export const Bio = {
  name: "Mags Engineering Limited",
  description:
    "Mags Engineering is a prominent Engineering, Procurement, and Construction (EPC) company specializing in delivering comprehensive solutions across various sectors, including oil and gas, power, and infrastructure. With a focus on innovation and sustainability, Mags Engineering is known for its expertise in managing complex projects from initial design through to execution and maintenance. The company emphasizes quality, safety, and efficiency, leveraging advanced technologies and skilled professionals to meet client needs and industry standards. Mags engineering is committed to fostering long-term partnerships and contributing to the development of sustainable infrastructure and growth.",
  
  linkedin: "https://www.linkedin.com/company/mags-engineering-limitedd/",
  twitter: "https://x.com/magseng_",
  // insta: "https://www.instagram.com/mags_engineering?igsh=b2VkaHMyZnNnMmc1",
  facebook: "https://web.facebook.com/profile.php?id=61575658900911",
  whatsapp: "https://wa.me/+2348156358138"
};

export const trainingSchedule = [
    { id: 1, title: "Process Modeling / Simulation using Aspen HYSYS", start: "16 Jan 2026", end: "24 Jan 2026", cost: "180,000", link: "https://magsengineeringlimited.com/courses/process-modelingsimulation-using-aspen-hysys" },
    { id: 2, title: "Control Valve Sizing and Selection", start: "26 Jan 2026", end: "29 Jan 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/control-valve-sizing-and-selection" },
    { id: 3, title: "Pump Sizing", start: "30 Jan 2026", end: "02 Feb 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/pump-sizing" },
    { id: 4, title: "Line Sizing (Liquid, Gas & Multiphase)", start: "03 Feb 2026", end: "07 Feb 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/line-sizing" },
    { id: 5, title: "Valves Piping and Pipelines", start: "09 Feb 2026", end: "13 Feb 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/valves-piping-and-pipelines" },
    { id: 6, title: "Pump Characteristics & Applications", start: "16 Feb 2026", end: "20 Feb 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/pump-characteristics-applications" },
    { id: 7, title: "Piping Systems & Piping Calculation", start: "23 Feb 2026", end: "28 Feb 2026", cost: "300,000", link: "https://magsengineeringlimited.com/courses/piping-systems-piping-calculation" },
    { id: 8, title: "Plant Layout & Spacing (GE GAP Guidelines)", start: "02 Mar 2026", end: "04 Mar 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/plant-layout-spacing-ge-gap-guidelines" },
    { id: 9, title: "Process Drafting Engineering (Microsoft Visio or AutoCAD)", start: "05 Mar 2026", end: "11 Mar 2026", cost: "100,000", link: "https://magsengineeringlimited.com/courses/process-drafting-engineering-microsoft-visio" },
    { id: 10, title: "Guidelines for Design, Construction and operation of Oil and Gas facilities In Nigeria", start: "12 Mar 2026", end: "16 Mar 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/guideline-for-design-construction-and-operations-of-oil-and-gas-production-facilities" },
    { id: 11, title: "Process Safety Management for Petroleum Refineries", start: "17 Mar 2026", end: "19 Mar 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/process-safety-management-for-petroleum-refineries" },
    { id: 12, title: "EPC Contract & Engineering Documents in EPC", start: "20 Mar 2026", end: "21 Mar 2026", cost: "80,000", link: "https://magsengineeringlimited.com/courses/epc-contract-engineering-documents-in-epc" },
    { id: 13, title: "Transfer & Stock Piling Operations in Crude Oil Refining", start: "23 Mar 2026", end: "26 Mar 2026", cost: "500,000", link: "https://magsengineeringlimited.com/courses/transfer-stock-piling-operations-in-the-crude-oil-refining-industry" },
    { id: 14, title: "Shell and Tube Heat Exchanger", start: "26 Mar 2026", end: "28 Mar 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/shell-and-tube-heat-exchanger" },
    { id: 15, title: "Heat Exchangers; Design, Operation, Maintenance & Enhancement", start: "30 Mar 2026", end: "02 Apr 2026", cost: "230,000", link: "https://magsengineeringlimited.com/courses/heat-exchangers-design-operation-maintenance-enhancement" },
    { id: 16, title: "Change Management Procedure", start: "02 Apr 2026", end: "04 Apr 2026", cost: "80,000", link: "https://magsengineeringlimited.com/courses/change-management-procedure" },
    { id: 17, title: "Oil and Gas Facility Project", start: "06 Apr 2026", end: "08 Apr 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/oil-and-gas-facility-project" },
    { id: 18, title: "Conceptual Stage of Design", start: "09 Apr 2026", end: "11 Apr 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/conceptual-stage-of-design-" },
    { id: 19, title: "Front End Engineering Design of Oil and Gas Projects", start: "14 Apr 2026", end: "15 Apr 2026", cost: "130,000", link: "https://magsengineeringlimited.com/courses/front-end-engineering-design-of-oil-and-gas-projects" },
    { id: 20, title: "Process Plant Layout", start: "16 Apr 2026", end: "21 Apr 2026", cost: "300,000", link: "https://magsengineeringlimited.com/courses/process-plant-layout" },
    { id: 21, title: "Standard Deliverable List for Conceptual Study", start: "22 Apr 2026", end: "25 Apr 2026", cost: "300,000", link: "https://magsengineeringlimited.com/courses/standard-deliverable-list-for-conceptual-study" },
    { id: 22, title: "Standard Deliverable List for Feasibility Study", start: "27 Apr 2026", end: "29 Apr 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/standard-deliverable-list-for-feasibility-study" },
    { id: 23, title: "Standard Deliverable List for FEED Design", start: "30 Apr 2026", end: "04 May 2026", cost: "400,000", link: "https://magsengineeringlimited.com/courses/standard-deliverable-list-for-feed-design" },
    { id: 24, title: "Standard Deliverable List for Detailed Design", start: "06 May 2026", end: "07 May 2026", cost: "500,000", link: "https://magsengineeringlimited.com/courses/standard-deliverable-list-for-detailed-design" },
    { id: 25, title: "Post Combustion CO₂ Capture (Hysys Software)", start: "11 May 2026", end: "11 May 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/post-combustion-co-capture-hysys-software" },
    { id: 26, title: "Advance Process Modeling / Simulation using Aspen HYSYS", start: "12 May 2026", end: "16 May 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/advance-process-modelingsimulation-using-aspen-hysys" },
    { id: 27, title: "Refinery Process Design", start: "18 May 2026", end: "20 May 2026", cost: "130,000", link: "https://magsengineeringlimited.com/courses/refinery-process-design" },
    { id: 28, title: "Pressure Safety Valve Sizing", start: "21 May 2026", end: "23 May 2026", cost: "180,000", link: "https://magsengineeringlimited.com/courses/pressure-safety-valve-sizing-stage-1-" },
    { id: 29, title: "Process Design of Flare and Blowdown", start: "25 May 2026", end: "27 May 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/process-design-of-flare-and-blowdown" },
    { id: 30, title: "Process Measurement", start: "28 May 2026", end: "29 May 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/process-measurement" },
    { id: 31, title: "Fundamentals of surface facilities in oil fields", start: "30 May 2026", end: "01 Jun 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/fundamentals-of-surface-facilities-in-oil-fields" },
    { id: 32, title: "Storage Facilities & Terminal", start: "02 Jun 2026", end: "03 Jun 2026", cost: "100,000", link: "https://magsengineeringlimited.com/courses/storage-facilities-terminal" },
    { id: 33, title: "Process Engineering Design Basis", start: "04 Jun 2026", end: "06 Jun 2026", cost: "100,000", link: "https://magsengineeringlimited.com/courses/process-engineering-design-basis" },
    { id: 34, title: "Process Plant Design and Simulation", start: "08 Jun 2026", end: "13 Jun 2026", cost: "500,000", link: "https://magsengineeringlimited.com/courses/process-plant-design-and-simulation" },
    { id: 35, title: "Advance Process Engineering and Design", start: "15 Jun 2026", end: "18 Jun 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/advance-process-engineering-and-design" },
    { id: 36, title: "Process Engineering (Introduction)", start: "19 Jun 2026", end: "20 Jun 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/process-engineering-introduction" },
    { id: 37, title: "Process Sizing Criteria", start: "22 Jun 2026", end: "25 Jun 2026", cost: "140,000", link: "https://magsengineeringlimited.com/courses/process-sizing-criteria-" },
    { id: 38, title: "Cryogenic Engineering", start: "26 Jun 2026", end: "29 Jun 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/cryogenic-engineering" },
    { id: 39, title: "Process Plant Corrosion Course", start: "30 Jun 2026", end: "02 Jul 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/process-plant-corrosion-course" },
    { id: 40, title: "Sizing of Strainers & Screen Openings", start: "03 Jul 2026", end: "05 Jul 2026", cost: "180,000", link: "https://magsengineeringlimited.com/courses/sizing-of-strainers-screen-openings-for-strainers" },
    { id: 41, title: "Design Engineering Safety Checklist", start: "06 Jul 2026", end: "06 Jul 2026", cost: "100,000", link: "https://magsengineeringlimited.com/courses/design-engineering-safety-checklist-" },
    { id: 42, title: "HAZID", start: "08 Jul 2026", end: "09 Jul 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/hazid" },
    { id: 43, title: "HAZOP", start: "10 Jul 2026", end: "11 Jul 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/hazop" },
    { id: 44, title: "Plumbing Engineering", start: "13 Jul 2026", end: "16 Jul 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/plumbing-engineering" },
    { id: 45, title: "Process P&ID", start: "17 Jul 2026", end: "18 Jul 2026", cost: "350,000", link: "https://magsengineeringlimited.com/courses/process-pid" },
    { id: 46, title: "P&ID Development Procedure", start: "20 Jul 2026", end: "24 Jul 2026", cost: "300,000", link: "https://magsengineeringlimited.com/courses/pid-development-procedure" },
    { id: 47, title: "Distillation Column Selection and Sizing", start: "25 Jul 2026", end: "27 Jul 2026", cost: "100,000", link: "https://magsengineeringlimited.com/courses/distillation-column-selection-and-sizing" },
    { id: 48, title: "Cause & Effect Diagram For Process Engineers", start: "28 Jul 2026", end: "29 Jul 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/cause-effect-diagram-for-process-engineers-" },
    { id: 49, title: "Pipeline Engineering", start: "30 Jul 2026", end: "01 Aug 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/pipeline-engineering" },
    { id: 50, title: "Pipeline Flow Pigging", start: "03 Aug 2026", end: "05 Aug 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/pipeline-flow-pigging" },
    { id: 51, title: "Fitness for Service and Integrity of Piping Vessels and Tanks", start: "06 Aug 2026", end: "08 Aug 2026", cost: "300,000", link: "https://magsengineeringlimited.com/courses/fitness-for-service-and-integrity-of-piping-vessels-and-tanks" },
    { id: 52, title: "Material Selection for Refinery & Associated Facilities", start: "10 Aug 2026", end: "12 Aug 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/material-selection-for-refinery-associated-facilities" },
    { id: 53, title: "Materials selection and corrosion control for O&G systems", start: "13 Aug 2026", end: "15 Aug 2026", cost: "180,000", link: "https://magsengineeringlimited.com/courses/materials-selection-and-corrosion-control-for-oil-and-gas-production-systems" },
    { id: 54, title: "Hydrogen Pipeline System: Design, Construction, and Operation", start: "17 Aug 2026", end: "19 Aug 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/hydrogen-pipeline-system-design-construction-and-operation" },
    { id: 55, title: "Refinery Valves and Accessories for Control and SIS", start: "20 Aug 2026", end: "22 Aug 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/refinery-valves-and-accessories-for-control-and-safety-instrumented-systems-course" },
    { id: 56, title: "Fabrication, Installation & Erection Procedure for Piping", start: "24 Aug 2026", end: "26 Aug 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/fabrication-installation-erection-procedure-for-piping" },
    { id: 57, title: "Piping Inspection Code: In-Service Inspection, Rating & Repair", start: "27 Aug 2026", end: "29 Aug 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/piping-inspection-code-in-service-inspection-rating-repair-and-alteration-of-piping-systems" },
    { id: 58, title: "Project Schedule", start: "31 Aug 2026", end: "01 Sep 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/project-schedule-" },
    { id: 59, title: "Principles of Water and Wastewater Treatment Processes", start: "02 Sep 2026", end: "04 Sep 2026", cost: "180,000", link: "https://magsengineeringlimited.com/courses/principles-of-water-and-wastewater-treatment-processes" },
    { id: 60, title: "Drains & Flares: Design, Operation, and Troubleshooting", start: "05 Sep 2026", end: "07 Sep 2026", cost: "100,000", link: "https://magsengineeringlimited.com/courses/drains-flares-design-operation-and-troubleshooting" },
    { id: 61, title: "Commissioning", start: "08 Sep 2026", end: "09 Sep 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/commissioning" },
    { id: 62, title: "Refinery Instrumentation and Control (Flow)", start: "10 Sep 2026", end: "10 Sep 2026", cost: "80,000", link: "https://magsengineeringlimited.com/courses/refinery-instrumentation-and-control-systems" },
    { id: 63, title: "Process Instrumentation and Control (Air Supply System)", start: "11 Sep 2026", end: "11 Sep 2026", cost: "60,000", link: "https://magsengineeringlimited.com/courses/process-instrumentation-and-control-air-supply-system" },
    { id: 64, title: "Process Instrumentation and Control (Control Valves)", start: "12 Sep 2026", end: "12 Sep 2026", cost: "80,000", link: "https://magsengineeringlimited.com/courses/process-instrumentation-and-control-control-valves-accessories" },
    { id: 65, title: "Process Design Package Sulphur Recovery Unit", start: "14 Sep 2026", end: "16 Sep 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/process-design-package-sulphur-recovery-unit" },
    { id: 66, title: "Construction Safety", start: "17 Sep 2026", end: "19 Sep 2026", cost: "180,000", link: "https://magsengineeringlimited.com/courses/construction-safety" },
    { id: 67, title: "Practical Lubrication for Industrial Facilities", start: "21 Sep 2026", end: "24 Sep 2026", cost: "350,000", link: "https://magsengineeringlimited.com/courses/practical-lubrication-for-industrial-facilities" },
    { id: 68, title: "Hazardous Area Classification (API 505)", start: "25 Sep 2026", end: "28 Sep 2026", cost: "200,000", link: "https://magsengineeringlimited.com/courses/hazardous-area-classification-api-505" },
    { id: 69, title: "Firefighting Design", start: "29 Sep 2026", end: "02 Oct 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/firefighting-design" },
    { id: 70, title: "Installation of Stationary Pumps for Fire Protection", start: "03 Oct 2026", end: "06 Oct 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/installation-of-stationary-pumps-for-fire-protection" },
    { id: 71, title: "Chemical Process Safety", start: "07 Oct 2026", end: "12 Oct 2026", cost: "450,000", link: "https://magsengineeringlimited.com/courses/chemical-process-safety-" },
    { id: 72, title: "Centrifugal Compressor for Petroleum & Chemical Service", start: "13 Oct 2026", end: "14 Oct 2026", cost: "60,000", link: "https://magsengineeringlimited.com/courses/centrifugal-compressor-for-petroleum-chemical-and-gas-service-industries" },
    { id: 73, title: "LPG SAFETY", start: "15 Oct 2026", end: "17 Oct 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/lpg-safety" },
    { id: 74, title: "Chemical and Process Plant Commissioning", start: "19 Oct 2026", end: "22 Oct 2026", cost: "500,000", link: "https://magsengineeringlimited.com/courses/chemical-and-process-plant-commissioning" },
    { id: 75, title: "Project Control Deliverables", start: "23 Oct 2026", end: "24 Oct 2026", cost: "250,000", link: "https://magsengineeringlimited.com/courses/project-control-deliverables" },
    { id: 76, title: "Quality Assurance / Quality Control Plan", start: "26 Oct 2026", end: "28 Oct 2026", cost: "120,000", link: "https://magsengineeringlimited.com/courses/quality-assurance-quality-control-plan" },
    { id: 77, title: "Work Sequence for Piping Planning Design", start: "29 Oct 2026", end: "31 Oct 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/work-sequence-for-piping-planning-design" },
    { id: 78, title: "Process Control for Operators", start: "02 Nov 2026", end: "06 Nov 2026", cost: "350,000", link: "https://magsengineeringlimited.com/courses/process-control-for-operators" },
    { id: 79, title: "Risk-Based Inspection", start: "07 Nov 2026", end: "10 Nov 2026", cost: "150,000", link: "https://magsengineeringlimited.com/courses/risk-based-inspection" },
    { id: 80, title: "Liquefied Natural Gas Industry", start: "11 Nov 2026", end: "17 Nov 2026", cost: "300,000", link: "https://magsengineeringlimited.com/courses/liquefied-natural-gas-industry" },
];

export const liveEvents = [
  // {
  //   id: 1,
  //   type: "Live Webinar",
  //   region: "Global",
  //   date: "April 23 - 25, 2026",
  //   time: "04:30 PM WAT",
  //   title: "Oil and Gas Project",
  //   description:
  //     "The development of oil and gas facilities requires the integration of multiple engineering disciplines, rigorous project planning, and adherence to safety, environmental, and operational requirements. From conceptual design to commissioning and revamping, facility projects must balance technical, economic, and regulatory considerations.",
  //   details:
  //   [
  //     "This course provides participants with a comprehensive understanding of how oil and gas facility projects are conceived, designed, executed, and managed. Covering project engineering, design basis, process engineering, equipment, layout, safety, civil, piping, instrumentation, electrical, offshore considerations, and project management, the program offers both technical and managerial perspectives. Participants will also explore the phases of project execution—including Basic, FEED, and Detailed Design—while understanding how to align engineering deliverables with project schedules, cost, and operational goals.",
  //     "By the end of this webinar, participants will be equipped to contribute effectively to facility projects in both onshore and offshore environments."
  //   ],
  //   image: "https://i.ibb.co/dwqPCLZ9/Oil-and-Gas-Facility-Project.png",
  //   link: "https://magsengineeringlimited.com/courses/conceptual-stage-of-design-",
  // },
  {
    id: 2,
    type: "Live Webinar",
    region: "Global",
    date: "April 25, 2026",
    time: "10:30 AM WAT",
    title: "Front End Engineering Design of Oil and Gas Projects: Critical Factors for Project Success",
    description:
      "Front End Engineering Design (FEED) is one of the most critical phases in the lifecycle of an oil and gas project. Decisions made during this stage determine the technical feasibility, safety, cost efficiency, and long-term operability of the facility. Poor engineering judgment or incomplete analysis at the FEED stage often leads to costly redesigns, construction delays, operational inefficiencies, or even complete project failure.",

    details:
    [
      "This webinar provides a structured understanding of the FEED process within the overall project framework, from project identification and feasibility studies to definition, construction planning, and quality assurance. Participants will explore the decision-making process in gated project systems, learn how to prepare and assess statements of requirements, and identify overarching technical, commercial, and regulatory considerations. Real-world case studies and lessons learned will highlight best practices and common pitfalls in FEED for oil and gas developments.",
      "This technical webinar is designed to examine key engineering challenges commonly encountered during the FEED phase of oil and gas projects. Using real industry considerations and practical engineering approaches, the session will analyze critical design decisions that significantly influence project success.",
      "Participants will gain insights into important topics such as determining appropriate pipe wall thickness for process safety and mechanical integrity, understanding the role and importance of piping isometric deliverables in detailed engineering and construction, and identifying the correct timing and criteria for compressor selection during project development. The webinar will also address iron sulfide formation in hydrocarbon systems, its potential impact on safety and operations, and how inadequate consideration during design can contribute to project risks. In addition, the session will discuss heat exchanger selection, focusing on the engineering parameters that influence performance, reliability, and cost.",
      "By exploring these real design challenges, the webinar will highlight how proper technical evaluation, multidisciplinary coordination, and sound engineering judgment during FEED can prevent major issues during later project phases.",
      "This webinar is ideal for process engineers, piping engineers, mechanical engineers, project engineers, design engineers, and professionals involved in oil and gas project development, particularly those working on concept development, FEED studies, and detailed engineering phases.",
      "Participants will leave with practical engineering knowledge that can be applied directly to real project design challenges, improving their ability to contribute to successful oil and gas project execution."

    ],
      image: "https://ik.imagekit.io/mags/courses/FEED-of-Oil-and-Gas-Project.png",
    completed: true,
    youtubeUrl: "https://youtu.be/n-ivMmEX3VY?si=GqG0UtB9d9yX-OnD", 
    // slidesUrl: "https://docs.google.com/presentation/d/13Q-aK4Xs4oFed4T8jgVvmEo1oWZ-ZdjRV6J_9YPEDeo/edit?usp=sharing", 
  },

];

export const skills = [
  {
    title: "Oil and Gas Projects",
    name: [
      "Obodo Flowstation Piping & Instrument Diagram Modification",
      "CAWC-2 Flowstation Surge Vessel Modification",
      "FSO YOHO Spools and Bunkertrax Skid Fabrication",
      "Piping Modification for Coriolis Meter Erha Diesel Oil System",
      "Piping Modification for Coriolis Meter Etim Diesel Oil System",
      "EFE Wellheads Hookup & Flowline Construction",
      "Feasibility study into Critical Review of Current Conversion Facilities and Research Output on Carbon Dioxide Utilization."


    ],
  },
  {
    title: "Oil and Gas Projects",
    name: [
      "ATALA HALKIN Piping & Instrument Diagram Design",
      "Design of Orifice Plate for OGAINGBIR Flow Station",
      "HAZOP of Production of Nitrobenzene",
      "HAZOP of Aniline",
      "Feasibility Studies of 1 MMTPA of Methanol and 2.5MMTPA of Urea Plant",
      "Simulation of Intercooler Heat Exchanger",
      "Preliminary design of 1st &2nd stage Intercooler Heat Exchanger"

    ],
  },
  {
    title: "Oil and Gas Projects",
    name: [
      "Bench study into economic analysis of the method of removing methanol from natural gas.",
      "Feasibilities studies of correlations for predicting water content in sweet natural gas.",
      "Development of Bio-surfactant material for wellbore clean-up (Mud filter cake)",
      "Revamping of Flare system to manage surge drum liquid entrainment.",
      "Design of a new 16” gas lift header to accommodate increase in production capacity.",
      "Design of Ammonia receiving import terminal (FEED)."

    ],
  },
  {
    title: "Oil and Gas Previous Trainings",
    name: [
      "Hydraulic Design of piping system; Liquid/Gas line	",		
      "Control value sizing",
      "Hazard & operability study (HAZOP)",
      "Development of Process flow diagram & Piping & Instrumentation Diagram",
      "Plant 3D modelling using Autodesk Plant 3D",
      "Basic Process equipment sizing", 		
      "Change management procedure" 

    ],
  },
  {
    title: "Oil and Gas Previous Trainings",
    name: [
      "Various process design stages; Conceptual, FEED & Detailed.",
      "Multiple pump & piping design", 
      "Drafting engineering for Mechanical Engineers",
      "Drafting engineering for Process Engineers",
      "Hydraulic Design of Pump system	",		
      "Pressure relief valve sizing", 	
      "Plant 3D modelling using Aveva PDMS (Plant Design Management System)"

    ],
  },
  {
    title: "Oil and Gas Previous Trainings",
    name: [
      "Rules of thumb for process engineers",
      "Pump characters & performance evaluation", 
      "Pump installation detailed procedures ",
      "Relief valve sizing for pump discharge", 
      "Principles of pump selection",
      "Inspection & repair of storage tanks (API 653-650)",
      "Thermal rating & hydraulic analysis shell & tube heat exchanger "

    ],
  },
  {
    title: "Oil and Gas Previous Trainings",
    name: [
      "Guideline for design solution for process equipment failures ",
      "Process control for engineers", 
      "Commissioning of oil & gas process plants", 
      "Process engineering management", 
      "Hydrogen system code, standards & guidelines", 
      "Refinery process design",
      "Instrumentation symbols & identification (ISA – 5.1-1984 (R1992)"

    ],
  },
  {
    title: "Oil and Gas Previous Trainings",
    name: [
      "Introduction of oil & gas operation safety", 
      "Vent Sizing", 
      "Process controls for operators",
      "Pipeline strainers",
      "Guideline for auditing process safety management systems", 
      "Pumps & pumps piping", 
      "Process safety" 

    ],
  },
  {
    title: "Oil and Gas Previous Trainings",
    name: [
      "Distillation technology & tower simulation",
      "Standard for the Installation of Stationary Pumps for Fire Protection (NFPA 20)",
      "Mechanical seal for pump heat exchanger maintenance & repairs",
      "EPC (engineering procurement & construction) contract", 
      "Design, types, installation & commissioning of LNG storage & regeneration system", 
      "Tank design & fundamental operation", 
      "LPG safety – guideline for good safety procure in the LPG industry" 
       
    ],
  },
  {
    title: "Oil and Gas Previous Trainings",
    name: [
      "Fabrication, installation & erection procedure for piping", 
      "A guide to corrosion under installation management", 
      "Compressor sizing", 
      "Flare system design", 
      "LNG regasification terminal for process engineer" 

    ],
  },
];

export const subtitles = [
    {
      title: 'Integrity',
      description: 'We conduct business with honesty and transparency and uphold ethical standards in all dealings and decisions.'
    },
    {
      title: 'Safety',
      description: 'We prioritize the health and safety of employees, clients, and the communities in which we operate.'
    },
    {
      title: 'Excellence',
      description: 'We strive for the highest quality in all projects and services.'
    },
    {
      title: 'Collaboration',
      description: 'We foster teamwork and open communication within the company and with clients and partners.'
    },
    {
      title: 'Innovation',
      description: 'We embrace creativity and cutting-edge technology to deliver forward-thinking engineering solutions.'
    },
    {
      title: 'Customer Focus',
      description: 'We put clients at the center of everything we do and build strong relationships through responsiveness and understanding their needs.'
    },
    {
      title: 'Accountability',
      description: 'We take responsibility for our actions and their outcomes and hold ourselves and each other to high standards of performance.'
    },
    {
      title: 'Respect',
      description: 'We treat everyone with dignity and respect, fostering a positive workplace culture and appreciate the contributions of all team members.'
    }
  ];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/D560BAQFDUKPSU8P0Lw/company-logo_200_200/0/1687947132305?e=1698278400&v=beta&t=cBF3SdszRLspmyvV-rHa1y4tdj_hjjivH7Xy0Z7kOD8",
    role: "Mechanical Engineering",
    desc: "Mags Engineering Limited mechanical engineering services encompass a broad range of activities and expertise provided by mechanical engineers to support the design, development, operation, and maintenance of mechanical systems and components across various industries. These services are critical for industries such as manufacturing, construction, energy, automotive, aerospace, and more. Below is the core Mags Engineering Limited mechanical engineering services provided across industries:",
    skills: [
      "Design and Development",
      "System Optimization; Energy Efficiency Optimization, Thermal Systems Design and Fluid and Gas Flow Systems.",
      "Fabrication",
      "Maintenance and Reliability; Preventive and Predictive Maintenance, Condition Monitoring, Root Cause Analysis (RCA) and Upgrades and Modifications.",
      "Project Management; Turnkey Projects, Budgeting and Cost Estimation, Feasibility Studies, Risk Analysis and Safety Assessments.",
      "HVAC Systems; Heating, Ventilation, and Air Conditioning (HVAC) Design.",
      "Piping and Pressure Systems; Piping Design and Layout, Pressure Vessel Design, ",
      "Consulting and Feasibility Studies; Technology Selection, Regulatory Compliance, Sustainability and Green Engineering "

      
    ],
   
  },

  {
    id: 1,
    role: "Piping Engineering",
    desc: "Mags Engineering Limited Piping engineering services encompass a wide range of activities related to the design, installation, operation, and maintenance of piping systems used in various industries, including oil and gas, power generation, chemical processing, water treatment, pharmaceuticals, and food production. These services ensure that the piping systems are safe, efficient, cost-effective, and compliant with industry standards. Below are the core Mags Engineering Limited Piping engineering services provided across industries:",
    skills: [
      "Piping Design and Layout, Conceptual Design, Detailed Piping Design, Pipe Sizing, Pipe Routing, Isometric Drawings, Supports and Bracketing.",
      "Piping Stress Analysis and Simulation; Stress Analysis, Thermal Expansion, Dynamic Analysis",
      "Piping Material Selection; Material Specification & Corrosion Prevention.",
      "Piping Fabrication and Installation; Fabrication, Piping Installation, Pressure Testing.",
      "Piping System Optimization; Flow Optimization, Leak Detection, Energy Efficiency.",
      "Piping Support Design; Support Structures, Vibration and Shock Isolation, Expansion Joints.",
      "Piping Codes and Standards Compliance; Industry Codes, Local Regulations, Inspection and Quality Assurance.",
      "Piping System Maintenance and Reliability; Preventive Maintenance Plans, Condition Monitoring, Leak Repair and Replacement.",
      "Piping Insulation and Heat Tracing; Thermal Insulation, Heat Tracing.",
      "3D Modeling and CAD Services",
      "Commissioning and Start-Up Services; System Commissioning & Start-Up Assistance.",
      "Consultation and Feasibility Studies"

      
    ],
   
  },

  {
    id: 2,
    role: "Plant Drafting & 3D Modelling ",
    desc: "Mags Engineering Limited Plant drafting and 3D modeling services are essential for the design, visualization, and optimization of industrial plants. Below is the core Mags Engineering Limited Plant drafting and 3D modeling services provided across industries:",
    skills: [
      "2D Drafting Services; Piping and Instrumentation Diagrams (P&IDs), Mechanical Layout Drawings, Electrical and Control Diagrams, Civil and Structural Drawings, As-Built Drawings.",
      "3D Modeling Services; 3D Plant Design, Piping 3D Models, Process Equipment Modeling, Collision Detection (Clash Detection), Structural Modeling, HVAC and Electrical Systems.",
      "Equipment Layout and Placement; Optimizing Equipment Placement, Space Utilization, Access and Safety.",
      "Detailed Design and Drafting; Detailed Structural Elements, Detailing of Piping Systems, ",
      "Material Take-Offs and Cost Estimation; Bill of Materials (BOM) & Cost Estimation.",
      "As-Built 3D Models; As-Built Documentation & Retrofit and Revamping."


      
    ],
   
  },
  
  {
    id: 3,
    role: "Process Engineering ",
    desc: "Mags Engineering Limited Process engineering services are critical for designing, optimizing, and improving industrial processes across various sectors, including chemical, petrochemical, pharmaceutical, food and beverage, power generation, and more. Process engineers focus on maximizing efficiency, safety, environmental sustainability, and product quality while minimizing operational costs. Below is the core Mags Engineering Limited process engineering services provided across industries:",
    skills: [
      "Process Design and Development; Feasibility Studies, Flow Diagrams and Schematics, Process Simulation and Modeling, Equipment Specification: Identifying and selecting the appropriate equipment for each stage of the process, including reactors, heat exchangers, separators, compressors, pumps, and storage tanks.",
      "Front End Engineering Design (FEED)",
      "Detailed Engineering Design",
      "Process Optimization; Energy Optimization, Process Efficiency Improvement, Waste Minimization, Yield Improvement.",
      "Scale-Up and Pilot Testing; Pilot Plant Design, Scale-Up from Laboratory to Production, Data Analysis and Interpretation.",

      "Safety and Risk Analysis; Hazard and Operability Study (HAZOP), 	Process Safety Management, Safety Instrumented Systems (SIS), Failure Mode and Effects Analysis (FMEA).",
      "Commissioning and Start-Up; Commissioning Support, Start-Up and Troubleshooting, Performance Testing, ",
      "Plant Optimization and Continuous Improvement; Continuous Improvement, Process Monitoring and Control, Root Cause Analysis (RCA). ",
      "Project Management and Consultation; Project Design and Planning, Feasibility and Risk Assessment, Supply Chain Management.",
      "Energy and Utilities Management; Utility Systems Design, Cogeneration Systems, Energy Audits and Analysis.",
      "Supply Chain Integration; Material Flow Optimization, Logistics and Transportation Planning.",
      "Product Quality and Process Monitoring; Quality Control & Batch Process Optimization"



      
    ],
   
  },

  {
    id: 4,
    role: "Feasibility Studies ",
    desc: "Mags Engineering Limited Feasibility studies are essential preliminary analyses conducted to determine the viability of a project or initiative before committing significant resources to its implementation. These studies help businesses, government agencies, and organizations evaluate the potential of a project, assess risks, and make informed decisions. Feasibility study services are applied in various industries, including construction, engineering, technology, energy, pharmaceuticals, and manufacturing. Below is the core Mags Engineering Limited Feasibility studies services provided across industries:",
    skills: [
      "Technical Feasibility; Technology and Process Evaluation, System Integration and Compatibility, Prototype Development, Innovation Assessment.",
      "Economic Feasibility; Cost-Benefit Analysis, Budgeting and Financial Planning: Return on Investment (ROI): Break-Even Analysis.",
      "Market Feasibility; Market Research and Demand Analysis, Market Entry Strategy, SWOT Analysis, Demand Forecasting.",
      "Operational Feasibility; Operational Planning, Supply Chain and Resource Availability, Workforce Analysis, Facility and Infrastructure Requirements, Process Design and Optimization.",
      "Risk Feasibility; Risk Identification and Assessment, Risk Mitigation Strategies, Contingency Planning.",
      "Scheduling and Time Feasibility; Timeline and Milestone Analysis, Critical Path Analysis, Project Delays and Contingency Plans."




      
    ],
   
  },

  {
    id: 5,
    role: "Project Management Consultancy ",
    desc: "Mags Engineering Limited Project Management Consultancy (PMC) services provide professional oversight, guidance, and management expertise throughout the lifecycle of a project, from initiation to completion. These services help ensure that projects are delivered on time, within budget, and to the required quality standards. Mags PMC professionals work closely with stakeholders to manage risks, resources, schedules, and costs, ensuring effective communication, project control, and successful outcomes. Mags PMC services are commonly used in complex projects such as construction, infrastructure development, and industrial plant design, and oil and gas projects, among others. Mags Engineering Limited Components of Project Management Consultancy (PMC) Services:",
    skills: [
      "Project Planning and Strategy; Project Definition and Scope Development, Feasibility Studies, Project Strategy Development, Risk Assessment and Management.",
      "Cost and Budget Management; Cost Estimation and Budgeting, Cost Control and Monitoring, Value Engineering, Cash Flow Management.",
      "Time and Schedule Management; Project Scheduling and Timeline Development, Resource Allocation and Optimization, Monitoring and Controlling Schedules, Critical Path Analysis.",
      "Procurement Management; Procurement Planning and Strategy, Tendering and Contract Management, Supplier and Contractor Management, Inventory and Logistics Management.",
      "Quality Management; Quality Assurance and Control (QA/QC), Standards and Regulations Compliance, Quality Audits and Inspections.",
      "Project Monitoring and Control; Progress Tracking and Reporting, Performance Metrics and KPIs, Corrective Actions and Adjustments.",
      "Change Management; Change Control Processes, Scope Management.",
      "Project Closeout and Handover; Project Completion and Handover, Final Inspections and Testing, Project Documentation, Lessons Learned and Post-Project Evaluation."




      
    ],
   
  },


  {
    id: 6,
    role: "Front End Engineering Design (FEED)",
    desc: [
      "Mags Engineering Limited's Front End Engineering Design (FEED) services provide the critical engineering foundation required before the execution of major industrial, oil & gas, petrochemical, power, and infrastructure projects.",
      "Mags Engineering Limited FEED services help clients define project scope, establish technical requirements, optimize design options, evaluate project feasibility, reduce project risks, and improve cost and schedule certainty. ",
      "Mags Engineering Limited Components of Front-End Engineering Design (FEED) Services:"
    ],
    sections: [
      {
        title: "Project Definition and Scope Development",
        items: [
          "Project Objectives and Basis of Design (BOD)",
          "Design Philosophy Development",
          "Process Design Criteria",
          "Scope Definition and Boundary Identification",
          "Project Execution Strategy"
        ]
      },
      {
        title: "Process Engineering Deliverables",
        items: [
          "Process Flow Diagrams (PFDs)",
          "Piping and Instrumentation Diagrams (P&IDs)",
          "Heat and Material Balance (HMB)",
          "Utility Consumption and Utility Balance",
          "Process Simulations (Aspen HYSYS, Aspen Plus, UniSim)",
          "Equipment Sizing and Process Datasheets"
        ]
      },
      {
        title: "Mechanical and Equipment Engineering",
        items: [
          "Equipment List Development",
          "Static and Rotating Equipment Specifications",
          "Compressor and Pump Selection",
          "Heat Exchanger Selection and Design Basis",
          "Pressure Vessel and Tank Design Inputs"
        ]
      },
      {
        title: "Piping and Layout Engineering",
        items: [
          "Plot Plan Development",
          "Equipment Layout and Spacing Studies",
          "Piping Philosophy and Design Basis",
          "Line Sizing and Hydraulic Analysis",
          "Piping Material Specifications",
          "Constructability Reviews"
        ]
      },
      {
        title: "Instrumentation, Control, and Safety Engineering",
        items: [
          "Control Philosophy Development",
          "Cause and Effect Diagrams",
          "Shutdown Philosophy",
          "Safety Instrumented System (SIS) Requirements",
          "Relief and Depressurization Studies",
          "Fire and Gas Detection Philosophy"
        ]
      },
      {
        title: "Safety and Risk Studies",
        items: [
          "HAZID (Hazard Identification)",
          "HAZOP (Hazard and Operability Study)",
          "SIL Assessment",
          "QRA (Quantitative Risk Assessment)",
          "FERA (Fire Explosion and Risk Analysis)",
          "Facility Siting and Layout Safety Reviews"
        ]
      },
      {
        title: "FEED Closeout and EPC Transition",
        items: [
          "FEED Package Development",
          "Tender Documentation Preparation",
          "Technical Bid Evaluation Support",
          "EPC Handover Documentation",
          "Lessons Learned and Project Readiness Review"
        ]
      }
    ],
  },
  {
    id: 7,
    role: "HAZOP / HAZID Study",
    desc: [
      "Mags Engineering Limited HAZOP (Hazard and Operability Study) and HAZID (Hazard Identification) services provide systematic and structured risk assessment solutions for oil & gas, petrochemical, power, energy, manufacturing, and industrial facilities.",
      "Mags Engineering Limited conducts HAZOP and HAZID studies during concept selection, FEED, detailed engineering, pre-startup, and operational phases to ensure facilities are designed, constructed, and operated safely and efficiently.",
      "Mags Engineering Limited Components of HAZOP / HAZID Study Services include:"
    ],
    sections: [
      {
        items: [
          "Hazard Identification (HAZID) Studies",
          "Hazard and Operability (HAZOP) Studies",
          "Process Safety Review",
          "Safety Instrumented Systems (SIS) Review",
          "Facility Siting and Layout Safety Review",
          "Mechanical Integrity and Operational Safety Review",
          "Pre-Startup and Operational Safety Support",
          "Final Reporting and Documentation"
        ]
      }
    ],
  },
 
  {
    id: 8,
    role: "Procurement & Construction",
    desc: [
      "Mags Engineering Limited's procurement & construction services provide end-to-end support for the successful execution of industrial, oil & gas, petrochemical, power, infrastructure, and manufacturing projects. These services ensure that materials, equipment, and construction activities are effectively planned, coordinated, and executed to meet project objectives for safety, quality, cost, and schedule.",
      "Mags Engineering Limited supports clients from procurement planning through site construction, installation, testing, commissioning support, and final project delivery. Our approach focuses on technical compliance, supply chain efficiency, contractor management, constructability, and strict adherence to project specifications and international standards.",
      "Mags Engineering Limited Components of Procurement & Construction Services include:",
    ],
    sections: [
      {
        items: [
          "Procurement Planning and Strategy",
          "Vendor and Supplier Management",
          "Tendering and Contract Management",
          "Material and Equipment Procurement",
          "Inspection and Quality Assurance",
          "Logistics and Supply Chain Management",
          "Construction Planning and Site Preparation",
          "Mechanical, Civil, and Structural Construction",
          "Electrical, Instrumentation, and Control Installation",
          "Construction Supervision and HSE Management",
          "Pre-Commissioning and Commissioning Support",
          "Final Handover and Project Closeout"
        ]
      }
    ],
  },
  {
    id: 9,
    role: "Pre-Commissioning & Commissioning",
    desc: [
      "Mags Engineering Limited's pre-commissioning and commissioning services provide structured support to ensure that industrial facilities, oil & gas plants, petrochemical units, power systems, utilities, and infrastructure projects are safely prepared, tested, verified, and transitioned from construction completion to full operational readiness.",
      "Mags Engineering Limited supports clients through mechanical completion verification, system testing, commissioning execution, startup readiness, performance validation, and final handover. Our focus is to minimize startup risks, prevent operational failures, ensure system reliability, and achieve safe and efficient plant operations from day one.",
      "Mags Engineering Limited Components of Pre-Commissioning & Commissioning Services:",
    ],
    sections: [
      {
        items: [
          "Mechanical Completion Verification",
          "Pre-Commissioning Activities",
          "Instrumentation and Control System Verification",
          "Static and Rotating Equipment Commissioning",
          "Utilities and Offsite Systems Commissioning",
          "Process Commissioning and Startup Support",
          "Performance Testing and Acceptance",
          "Documentation and Handover",
          "Shutdown, Restart, and Brownfield Support",
          "Post-Startup Optimization"
        ]
      }
    ],
  },
  {
    id: 10,
    role: "Research & Development",
    desc: [
      "Mags Engineering Limited Research & Development (R&D) services provide innovative, technical, and strategic solutions that support continuous improvement, technology advancement, and sustainable growth across oil & gas, petrochemical, energy, manufacturing, power, infrastructure, and industrial sectors.",
      "Mags Engineering Limited Components of Research & Development (R&D) Services:",
    ],
    sections: [
      {
        items: [
          "Applied Engineering Research",
          "Process Innovation and Optimization",
          "New Technology Evaluation",
          "Product and System Development",
          "Simulation and Modeling Studies",
          "Sustainability and Energy Studies",
          "Materials and Equipment Research",
          "Safety and Risk Improvement Studies",
          "Data Analytics and Performance Intelligence",
          "Academic and Industrial Collaboration",
          "Reporting and Commercialization Support"
        ]
      }
    ],
  },
  {
    id: 11,
    role: "Training",
    desc: [
      "Mags Engineering Limited Training services provide industry-focused technical and professional development programs designed to build competence, improve workforce capability, and enhance operational excellence across oil & gas, petrochemical, power, manufacturing, infrastructure, and industrial sectors. These training services are structured to bridge the gap between academic knowledge and real-world industry application, helping professionals, graduates, and organizations develop practical skills required for project execution, operations, maintenance, safety, and engineering excellence.",
      "Mags Engineering Limited supports individuals, corporate teams, institutions, and industry professionals through hands-on technical training, competency development, certification programs, industrial workshops, and specialized engineering courses. Our focus is to deliver practical knowledge, industry best practices, regulatory compliance awareness, and career advancement opportunities that improve both individual performance and organizational productivity.",
      "Mags Engineering Limited Components of Training Services:",
    ],
    sections: [
      {
        items: [
          "Process Engineering Training",
          "Mechanical Engineering Training",
          "Piping and Plant Design Training",
          "Instrumentation and Control Training",
          "Safety and Process Safety Training",
          "Project Engineering and FEED Training",
          "Oil and Gas Industry Compliance Training",
          "Software and Digital Engineering Training",
          "Leadership and Professional Development",
          "Academic and Institutional Training",
          "Certification and Competency Development"
        ]
      }
    ],
  },
  
];

export const privacypolicy = [
  {
    id: 0,
    subtitle: "Use of Services",
    items: [
      "You must be at least 18 years old or have parental consent to register for any of our training programs.",
      "You agree to provide accurate and up-to-date information during registration.",
      "Course content is for personal educational use only and may not be copied, distributed, or resold."       
    ],
   
  },
]

export const slugify = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')   // remove special characters
    .replace(/\s+/g, '-')           // replace spaces with dashes
    .replace(/-+/g, '-')            // remove multiple dashes
    .trim();

export const getServiceSlug = (service) => slugify(service?.role || '');


export const projects = [
   {
    id: 9,
    title: "Plant Commissioning and StartUp Procedures",
    date: "Sep 2023 - Oct 2023",
    description:
      "The Commissioning and Start-Up Course is designed to equip participants with essential knowledge and practical skills needed to effectively manage the commissioning and start-up phases of projects, particularly in engineering and industrial settings. This course covers the entire process from initial planning to final handover, ensuring that systems operate efficiently, safely, and in compliance with industry standards.",
    image:
      "https://i.ibb.co/n8nYTfbZ/COMMISIONING-efc4b6513b7435a130af.png",
    tags: ["Trainer: Engr. Lateef"
  ],
    duration: "2 Days",
    prerequisite: [
      "A bachelor's degree in engineering, technology, or a related field.",
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of commissioning and start-up principles and procedures."
    ],
    methodology: "Theoretical/Practical",
    category: "commissioning",
    objectives: [
          "Understand the principles and importance of commissioning and start-up.",
        	"Develop effective commissioning plans and strategies.",
        	"Learn about the verification and testing of systems and equipment.",
        	"Execute Pre-commissioning and Commissioning Activities",
        	"Manage Initial Start-up",
        	"Master safe and systematic start-up procedures.",
        	"Gain insights into operator training and documentation handover.",
        	"Troubleshoot and Resolve Issues",
        	"Enhance Team Coordination",
        	"Improve Project Outcomes",
        	"Analyze real-world case studies to identify best practices and common challenges."
        
    ],
    outline: [
        "Module 1:  Introduction to Commissioning and Start-Up",
        "Module 2:  Preparation and planning",
        "Module 3:  Mechanical Completion  and Integrity checking",
        "Module 4:  Pre-commissioning & Operational Testing",
        "Module 5:  Start Up & Initial Operation",
        "Module 6:  Performance and Acceptance testing", 
        "Module 7:  Post Commissioning",
        "Module 8:  Case Study"
        
    ],
    assessment: "	Online Written Exam ",
    cdf: [
      "Classroom-based training",
      "Online courses", 
      "In-house workshops"
    ],
    cost: "₦100,000 / $80",
    paymentLink: "",
    
  },

  
{
  id: 27,
  title: "LPG SAFETY",
  date: "Present",
  description:
  [
      "LPG (Liquefied Petroleum Gas) Safety is a crucial consideration in the use, storage, transportation, and handling of LPG due to its flammable and potentially hazardous nature. LPG is commonly used for heating, cooking, and as fuel in both residential and industrial applications. Given its flammable properties, any leakage or mishandling can pose serious risks, including fires, explosions, and health hazards.",
      "LPG is widely used in various industries and households, making safety a critical aspect of its handling, transportation, and usage. This course provides a comprehensive understanding of LPG safety measures, regulatory requirements, and risk management strategies. Participants will explore best practices in bulk storage, transportation, cylinder handling, and consumer installations. The course also covers emergency response planning and real-world case studies to enhance practical knowledge."
  ],
  image: "https://i.ibb.co/xqxD56Hz/LPG-Safety.jpg",
  tags: [
      'Trainer: Engr. Adeyemi',
  ],
  category: "hazop hazid",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "Basic knowledge of LPG properties and uses",
      "Familiarity with industrial safety protocols",
      "Understanding of regulatory compliance requirements"
  ],
  methodology: "Theoretical",
  objectives: [
      "Identify key responsibilities in LPG safety management",
      "Apply national and international LPG safety regulations",
      "Analyze safety hazards in trans-shipment terminals and inland transportation",
      "Implement best practices in bulk storage and handling",
      "Establish proper handling techniques for LPG cylinders",
      "Understand safety measures for bulk distribution and consumer installations",
      "Identify safety management techniques for LPG operations",
      "Implement safety monitoring and control measures",
      "Develop effective emergency response plans",
      "Apply real-world case study insights to improve safety practices"
  ],
  outline: [
      "Module 1: Key Responsibilities",
      "Module 2: Regulatory Framework",
      "Module 3: LPG Safety",
      "Module 4: LPG Distribution Chain",
      "Module 5: Trans-Shipment Terminal",
      "Module 6: Inland Transportation",
      "Module 7: Bulk Storage and Handling",
      "Module 8: Cylinder Filling and Handling",
      "Module 9: Distribution in Bulk",
      "Module 10: Consumer Installation and Usage",
      "Module 11: Managing Safety",
      "Module 12: Emergency Planning and Response",
      "Module 13: Case Studies and Real-World Examples"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦250,000 / $220",
  certification: "Certificate of Completion"
},

{
  id: 28,
  title: "MECHANICAL ENGINEERING",
  date: "Present",
  description:
  [
      "Mechanical Engineering is one of the broadest and oldest branches of engineering that involves the design, analysis, manufacturing, and maintenance of mechanical systems. It combines principles of physics, mathematics, material science, thermodynamics, fluid mechanics, and control theory to create or improve machines, devices, and systems.",
      "Mechanical engineering is a broad discipline that applies principles of physics, material science, and mathematics to design, analyze, manufacture, and maintain mechanical systems. This course provides an in-depth understanding of core mechanical engineering concepts, including thermodynamics, fluid mechanics, heat transfer, and machine design. Participants will also explore material science, manufacturing processes, and electromechanical devices, with practical applications in real-world case studies."
  ],
  image: "https://i.ibb.co/kVWwNqb0/Mechanical-Engineering.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "mechanical",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "4 Days",
  prerequisite: [
      "Basic knowledge of physics and mathematics",
      "Understanding of fundamental engineering principles",
      "Familiarity with mechanical systems and components"
  ],
  methodology: "Theoretical",
  objectives: [
      "Explain key concepts in thermodynamics, fluid mechanics, and heat transfer",
      "Apply mechanical engineering principles in system design and analysis",
      "Evaluate material properties and their impact on mechanical design",
      "Understand the role of heat exchangers, pumps, and electromechanical devices in various applications",
      "Explore different manufacturing processes and material selection techniques",
      "Assess mechanical failures and improve design for durability and efficiency",
      "Implement mechanical engineering concepts in practical applications",
      "Analyze case studies to understand challenges and solutions in mechanical engineering"
  ],
  outline: [
      "Module 1: Thermodynamics",
      "Module 2: Fluid Mechanics",
      "Module 3: Pumping Machinery",
      "Module 4: Heat Transfer",
      "Module 5: Heat Exchangers",
      "Module 6: Material Science",
      "Module 7: Manufacturing Processes",
      "Module 8: Machine Design",
      "Module 9: Electromechanical Devices",
      "Module 10: Case Studies and Real-World Examples"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦250,000 / $220",
  certification: "Certificate of Completion"
},

{
  id: 29,
  title: "Dye Penetrant Testing (DPT) Acceptance Criteria",
  date: "Present",
  description:
  [
      "Dye Penetrant Testing (DPT), also known as Liquid Penetrant Testing (LPT), is a widely used non-destructive testing (NDT) method to detect surface-breaking flaws in non-porous materials. Acceptance criteria for DPT are based on the evaluation of defects and their compliance with applicable standards or codes, depending on the type of material, application, and industry requirements.",
      "This course provides an in-depth understanding of Dye Penetrant Testing (DPT) Acceptance Criteria and its application across various industry standards. Participants will learn to interpret and apply acceptance criteria for surface-breaking defects in metallic materials, welds, castings, and critical components. The course covers prominent industry standards and codes, focusing on their role in ensuring safety, compliance, and quality in diverse engineering sectors, including pressure vessels, storage tanks, piping systems, structural welding, and shipbuilding. Practical case studies will enhance the participants' ability to apply theoretical knowledge to real-world scenarios."
  ],
  image: "https://i.ibb.co/qLLdMmFv/Dye-Penetrant-51a4a8ca3aa9b5b2e930.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "mechanical",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic knowledge of non-destructive testing (NDT) methods, especially Dye Penetrant Testing",
      "Familiarity with material properties, welding processes, and manufacturing techniques",
      "An understanding of common industrial applications (e.g., pressure vessels, piping, tanks)",
      "Knowledge of engineering drawings and technical documentation"
  ],
  methodology: "Theoretical",
  objectives: [
      "Understand the principles and processes of Dye Penetrant Testing (DPT)",
      "Explain the role of DPT in quality control, defect detection, and safety assurance",
      "Interpret and apply DPT acceptance criteria as per global standards such as: ASME, API, AWS, ISO, EN, and IACS standards",
      "Differentiate between various codes and standards for specific applications (e.g., pressure vessels, storage tanks, piping systems)",
      "Evaluate defects in components such as welds, castings, pipelines, and structures based on their intended application and standard requirements",
      "Recognize industry-specific challenges, including those in shipbuilding, power generation, and bridge construction",
      "Prepare accurate inspection reports detailing DPT findings and ensuring compliance with acceptance criteria",
      "Understand the importance of traceability and quality assurance in engineering projects",
      "Analyze real-world case studies to learn best practices, avoid common pitfalls, and implement effective inspection processes",
      "Enhance decision-making skills for defect evaluation and disposition, including repair and re-inspection"
  ],
  outline: [
      "Module 1: ASME BPVC for Pressure Vessel",
      "Module 2: API 650 for Oil Storage Tanks",
      "Module 3: API 620 for Low Pressure Storage Tanks",
      "Module 4: ASME B 31.3 for Process Piping",
      "Module 5: ASME B 31.1 for Power Piping",
      "Module 6: AWS D 1.1 for Steel Structural Welding Inspection",
      "Module 7: API 1104 for Welding of Pipelines and Related Facilities",
      "Module 8: American Bureau of Shipping (ABS) for Hull Inspection",
      "Module 9: ISO 23277 Metallic Materials Weld Inspection",
      "Module 10: ISO 17635",
      "Module 11: IACS for Shipbuilding Inspection",
      "Module 12: AWS D1.5 for Bridge Welding Inspection",
      "Module 13: BS EN ISO 10228-2 for Steel Casting Inspection",
      "Module 14: EN 10228-2 for Steel Casting Inspection",
      "Module 15: ISO 4987 for Steel Casting Inspection",
      "Module 16: GE Standard for GE Turbine and GE Accessories Inspection",
      "Module 17: Acceptance Criteria at Fluorescent Dye Penetrant Testing",
      "Module 18: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦250,000 / $220",
  certification: "Certificate of Completion"
},

{
  id: 30,
  title: "Motors and Generators",
  date: "Present",
  description:
  [
      "Motors and generators are both machines used to convert energy, but they work on opposite principles. Motors convert electrical energy into mechanical energy, while generators convert mechanical energy into electrical energy.",
      "Motors work based on electromagnetic induction. When current flows through a conductor (usually a coil), it creates a magnetic field. This magnetic field interacts with the magnetic field of a permanent magnet (or another electromagnet) to produce a mechanical force that turns the motor's shaft. A generator is a device that converts mechanical energy into electrical energy. It works on the principle of electromagnetic induction, where mechanical motion induces a current in a conductor moving through a magnetic field.",
      "This course provides a comprehensive understanding of electric machines, focusing on the principles, operation, and maintenance of motors and generators. Participants will learn about the generation of electric current, synchronous and asynchronous machines, alternator connections, protection mechanisms, and motor operations. The course will also cover generator synchronization, motor applications, and troubleshooting techniques, reinforced through real-world case studies."
  ],
  image: "https://i.ibb.co/ch5Szsqs/Motors-and-Generators.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "mechanical",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "Basic understanding of electricity and magnetism",
      "Familiarity with electrical circuits and components",
      "Knowledge of power systems"
  ],
  methodology: "Theoretical",
  objectives: [
      "Define key concepts related to motors and generators",
      "Explain the generation and transformation of electrical energy",
      "Understand alternator construction, connections, and protections",
      "Analyze alternator operation, control mechanisms, and maintenance practices",
      "Understand the importance of synchronizing generators in a power system",
      "Learn techniques for safe and effective generator paralleling",
      "Compare synchronous and asynchronous motors",
      "Examine the characteristics and uses of three-phase and other motor types",
      "Explore the working principles of asynchronous motors",
      "Learn about motor performance, efficiency, and load handling",
      "Recognize common faults in motors and generators",
      "Develop preventive maintenance strategies for reliable operation",
      "Analyze real-world scenarios of motor and generator applications",
      "Evaluate best practices for troubleshooting and optimization"
  ],
  outline: [
      "Module 1: Objectives",
      "Module 2: Introduction to Electric Machines",
      "Module 3: Generation of Electric Current",
      "Module 4: Synchronous Machines – Alternators",
      "Module 5: Alternator Connections and Protections",
      "Module 6: Alternator Operation and Control",
      "Module 7: Generator Paralleling and Synchronizing",
      "Module 8: Alternator Maintenance",
      "Module 9: Synchronous Motors",
      "Module 10: Three-phase Asynchronous Motor",
      "Module 11: Other Types of Motors",
      "Module 12: Operation of Asynchronous Motors",
      "Module 13: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦300,000 / $250",
  certification: "Certificate of Completion"
},

{
  id: 31,
  title: "Steam Boilers",
  date: "Present",
  description:
  [
      "A steam boiler is a device used to generate steam by applying heat energy to water. Boilers are essential components in many industrial processes, power plants, and heating systems. The basic principle behind a steam boiler is converting water into steam through the application of heat from a fuel source, which then can be used for various purposes, such as power generation, heating, or driving engines.",
      "This course provides an in-depth understanding of steam boiler systems, their applications, types, common operational challenges, and best practices for boiler water treatment. Participants will gain insights into optimizing boiler performance, preventing failures, and ensuring safe and efficient operations. Case studies will provide real-world examples to reinforce learning."
  ],
  image: "https://i.ibb.co/Pstkq2vc/Steam-Boilers.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "mechanical",
  duration: "1 Day",
  prerequisite: [
      "Basic knowledge of thermodynamics and heat transfer",
      "Understanding of industrial processes that require steam",
      "Familiarity with fluid mechanics"
  ],
  methodology: "Theoretical",
  objectives: [
      "Identify key applications of steam in industries such as power generation, refining, and manufacturing",
      "Explain the role of steam in heating, sterilization, and mechanical work",
      "Describe the working principles of fire-tube and water-tube boilers",
      "Understand the advantages and limitations of different boiler types",
      "Recognize common operational issues such as scaling, corrosion, and carryover",
      "Analyze the impact of poor water quality on boiler efficiency and lifespan",
      "Explain the importance of water treatment in preventing scaling and corrosion",
      "Explore chemical and mechanical treatment methods for maintaining boiler efficiency",
      "Review real-world boiler system failures and their causes",
      "Evaluate best practices for boiler maintenance and optimization"
  ],
  outline: [
      "Module 1: Uses for Steam",
      "Module 2: Types of Steam Boilers",
      "Module 3: Problem Areas",
      "Module 4: Principles of Boiler Water Treatment",
      "Module 5: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦90,000 / $70",
  certification: "Certificate of Completion"
},

{
  id: 32,
  title: "Oil & Gas Production",
  date: "Present",
  description:
  [
    "Oil and gas production involves the extraction of hydrocarbons from underground reservoirs and processing them into usable fuels.",
    "The Oil & Gas Production course provides a detailed understanding of the key processes involved in extracting, processing, and handling hydrocarbons. This course covers fundamental principles, from reservoir dynamics and wellhead operations to processing systems and utility requirements. Participants will gain insights into industry best practices, operational challenges, and case studies from real-world applications.",
    "Designed for engineers, technicians, and industry professionals, this course aims to bridge the gap between theoretical knowledge and practical field applications, equipping learners with the necessary skills to work effectively in oil and gas production operations."
  ],
  image: "https://i.ibb.co/qYJLcCDp/Oil-Gas-Production.jpg",
  tags: [
    'Trainer: Engr. Majid',
  ],
  category: "Petroleum",
  duration: "2 Days",
  prerequisite: [
    "A basic understanding of engineering principles",
    "Familiarity with oil & gas industry operations",
    "Knowledge of fluid mechanics and thermodynamics"
  ],
  methodology: "Theoretical",
  objectives: [
    "Explain the basic concepts, industry landscape, and key terminologies",
    "Describe the stages of oil and gas processing from extraction to final product handling",
    "Understand reservoir behavior, wellhead components, and their role in production efficiency",
    "Identify the separation, treatment, and processing methods used in production facilities",
    "Understand the role of power generation, water treatment, and gas compression in production operations",
    "Learn from real-world examples, challenges, and problem-solving strategies in oil and gas production"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Process Overview",
    "Module 3: Reservoir and Wellheads",
    "Module 4: The Oil and Gas Process",
    "Module 5: Utility Systems",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 33,
  title: "Commissioning",
  date: "Present",
  description:
  [
    "Commissioning is the structured process of planning, inspecting, testing, and validating systems and equipment to ensure they are installed correctly and operate according to design and safety standards before turning over to operations. It bridges the gap between construction completion and the start of commercial operations.",
    "The Commissioning Course provides a complete understanding of the commissioning phase in project execution, with an emphasis on systematic planning, documentation, team coordination, and safe execution. This course walks participants through the commissioning process from engineering preparation to final handover, including systemization, progress tracking, data management, HSE compliance, and startup operations.",
    "The course emphasizes practical tools and methodologies used across various industries (e.g., oil & gas, energy, infrastructure) to ensure systems are tested, verified, and transferred safely and efficiently from construction to operation."
  ],
  image: "https://i.ibb.co/tTH5KZP8/Commissioning-a99821d3465b9b91abc8.jpg",
  tags: [
    'Trainer: Engr. Majid',
  ],
  category: "commissioning",
  duration: "3 Days",
  prerequisite: [
    "A background in engineering, project management, or construction",
    "Basic understanding of industrial project execution phases",
    "Familiarity with technical documentation and system-based thinking"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand what commissioning is, its objectives, phases, and integration into the project lifecycle",
    "Analyze how commissioning fits within overall project frameworks and communicate its scope effectively",
    "Break down complex projects into manageable systems and subsystems for structured commissioning",
    "Develop and implement engineering procedures and readiness checklists for safe start-up",
    "Utilize commissioning databases and tools for punch list management, tagging, and record-keeping",
    "Monitor commissioning progress, understand KPIs, and apply status-reporting principles for control",
    "Structure commissioning teams and clarify roles within a robust organizational setup",
    "Manage handovers between construction, commissioning, and operations teams with clarity and documentation",
    "Interpret contract structures, milestones, and responsibilities related to commissioning deliverables",
    "Implement HSE Best Practices – Apply health, safety, and environmental measures throughout commissioning to ensure risk-free operations",
    "Coordinate final start-up procedures and ensure seamless transition into operational phase"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Project Presentation",
    "Module 3: System/Subsystem Methodology",
    "Module 4: Pre‐commissioning/Commissioning Engineering",
    "Module 5: Database",
    "Module 6: Progress and Status Principles",
    "Module 7: Organization",
    "Module 8: Technical Transfer of Responsibilities",
    "Module 9: Contract Structure",
    "Module 10: HSE During Commissioning Operations",
    "Module 11: Startup Operations"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 34,
  title: "Commissioning Standards Documents",
  date: "Present",
  description:
  [
    "The Commissioning Standards Documents Course is designed to provide professionals with a comprehensive understanding of the standardized documentation, frameworks, and best practices that guide the commissioning process across industries. The course emphasizes the importance of clear planning, consistent terminology, defined responsibilities, risk management, and continuous improvement through lessons learned.",
    "Participants will gain insights into the structured use of commissioning standards and documentation throughout all project phases—from engineering and manufacturing to construction completions, on-site testing, and system handover.",
    "This course prepares participants to implement documentation frameworks that support efficiency, traceability, and safety in commissioning projects."
  ],
  image: "https://i.ibb.co/9HgJvWdc/Commissioning-Standards-Documents-e0c937539b6ba0934934.jpg",
  tags: [
    'Trainer: Engr. Majid',
  ],
  category: "commissioning",
  duration: "3 Days",
  prerequisite: [
    "A background in engineering, project management, or commissioning",
    "Familiarity with basic commissioning and project execution principles",
    "Understanding of industrial systems or facilities"
  ],
  methodology: "Theoretical",
  objectives: [
    "Explain the role of standardized documentation in ensuring quality, consistency, and safety",
    "Distinguish between engineering, pre-commissioning, commissioning, and closeout phases",
    "Apply industry-approved commissioning terms to promote clear communication and reduce ambiguity",
    "Interpret documentation that outlines accountability and scope for all stakeholders in the commissioning team",
    "Design structured commissioning plans using standardized formats and planning tools",
    "Ensure alignment between design, fabrication, installation, and commissioning documentation",
    "Follow standardized protocols for field tests, function checks, and performance verification",
    "Complete and document the formal transfer of systems into operation, including punch list closure",
    "Incorporate HSE documentation into commissioning workflows to mitigate operational risks",
    "Document feedback, performance gaps, and improvements for ongoing standardization enhancement"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Phases of the Commissioning Process",
    "Module 3: Terminology",
    "Module 4: Roles & Responsibilities",
    "Module 5: Commissioning Strategy & Planning",
    "Module 6: Commissioning Engineering, Manufacturing, Construction Completions",
    "Module 7: On-Site Testing",
    "Module 8: Handover, In-Service, Closeout",
    "Module 9: Safety & Risk Management",
    "Module 10: Lessons Learned & Continuous Improvement"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 35,
  title: "Pipeline Engineering",
  date: "Present",
  description:
  [
    "Pipeline engineering involves the design, construction, operation, and maintenance of pipelines used to transport fluids such as oil, gas, water, and chemicals.",
    "The Pipeline Engineering course provides a comprehensive understanding of the principles, design, construction, operation, and maintenance of pipelines used in various industries such as oil & gas, water supply, and chemical transportation.",
    "The course covers essential engineering concepts, safety standards, and industry best practices to equip professionals with the skills needed to design, construct, and manage pipeline infrastructure efficiently.",
    "Participants will gain insights into risk assessment techniques, condition monitoring, and repair methods, ensuring pipelines operate safely and effectively throughout their lifecycle. The course also explores the latest industry developments and decommissioning strategies for aging pipelines."
  ],
  image: "https://i.ibb.co/0y937X2B/Pipeline-Engineering.jpg",
  tags: [
    'Trainer: Engr. Majid',
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "A background in engineering",
    "Basic knowledge of fluid mechanics and material science",
    "Familiarity with industry standards and regulations"
  ],
  methodology: "Theoretical",
  objectives: [
    "Explain the principles of pipeline design, material selection, and fluid dynamics considerations",
    "Implement industry-standard pipeline design approaches, including stress analysis and route selection",
    "Assess construction methods, risk mitigation techniques, and safety protocols",
    "Perform hydrostatic testing, leak detection, and commissioning procedures",
    "Understand operational challenges, flow assurance, and performance optimization",
    "Develop preventive and corrective maintenance plans to enhance pipeline longevity",
    "Apply condition monitoring tools and effective repair techniques",
    "Learn decommissioning processes and explore emerging industry innovations",
    "Gain insights from past pipeline projects, failures, and success stories to enhance decision-making"
  ],
  outline: [
    "Module 1: Principles of Pipeline Design",
    "Module 2: Design Approach",
    "Module 3: Pipeline Construction and Risk Assessment Techniques",
    "Module 4: Pressure Testing and Commissioning",
    "Module 5: Pipeline Operation",
    "Module 6: Pipeline Maintenance",
    "Module 7: Pipeline Condition Monitoring and Repair Methods",
    "Module 8: Pipeline Decommissioning and Industry Developments",
    "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦250,000 / $220",
  certification: "Certificate of Completion"
},

{
  id: 36,
  title: "Power Plant Commissioning",
  date: "Present",
  description:
  [
    "Power plant commissioning is the systematic process of ensuring that all systems and components of a power plant are designed, installed, tested, operated, and maintained according to the operational requirements. It marks the final phase before a plant becomes fully operational.",
    "The Power Plant Commissioning course is designed to provide a thorough understanding of the commissioning process for power generation facilities, with a strong focus on system readiness, performance validation, and safe integration of plant components.",
    "This course covers the commissioning of major systems such as boilers, turbines, generators, and electrical equipment, as well as the management systems required to ensure a successful, safe, and efficient start-up.",
    "Through this course, participants will gain practical and theoretical knowledge needed to manage, supervise, and execute the commissioning phases in thermal and combined-cycle power plants."
  ],
  image: "https://i.ibb.co/ymQDQhVY/Power-Plant-Commissioning.jpg",
  tags: [
    'Trainer: Engr. Majid',
  ],
  category: "commissioning",
  duration: "3 Days",
  prerequisite: [
    "A background in electrical, mechanical, or power engineering",
    "Basic knowledge of power plant operations and system components",
    "Familiarity with project execution phases"
  ],
  methodology: "Theoretical",
  objectives: [
    "Define commissioning, its objectives, and its role in the power plant lifecycle",
    "Apply structured procedures, checklists, and documentation tools for effective commissioning control",
    "Understand start-up and operational readiness testing for boilers, burners, feedwater systems, and related components",
    "Oversee functional checks and performance testing for steam or gas turbines, lube oil systems, and vibration monitoring",
    "Conduct commissioning activities for generators including insulation tests, synchronization, and excitation systems",
    "Ensure proper operation of switchgear, transformers, protection systems, cabling, and grounding systems"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Commissioning Management System",
    "Module 3: Boiler & Auxiliaries",
    "Module 4: Turbine & Auxiliaries",
    "Module 5: Generators & Auxiliaries",
    "Module 6: Electrical Equipment’s"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦200,000 / $180",
  certification: "Certificate of Completion"
},

{
  id: 37,
  title: "Process Measurement",
  date: "Present",
  description:
  [
    "Process measurement is the method of quantifying physical parameters in industrial processes—such as pressure, temperature, flow, and level—using sensors and instruments. Accurate measurement is essential for effective monitoring, control, and optimization of industrial operations.",
    "The Process Measurement course provides an in-depth exploration of the fundamental techniques and instruments used to measure key process variables in industrial operations. Accurate measurement of temperature, pressure, flow, and level is essential for effective process control, safety, efficiency, and product quality.",
    "This course introduces participants to the core concepts of process measurement and progresses through the practical selection, installation, and protection of measurement instruments.",
    "It also addresses critical environmental and operational considerations, including instrument heating and climate protection. Emphasis is placed on real-world application and industry standards to prepare participants for field or control room roles in various industries such as oil and gas, petrochemicals, power generation, and manufacturing."
  ],
  image: "https://i.ibb.co/2Yp0Lftb/process-measurement.png",
  tags: [
    'Trainer: Engr. Okechukwu',
  ],
  category: "PAI",
  duration: "4 Days",
  prerequisite: [
    "Basic understanding of industrial processes and control systems",
    "Familiarity with measurement principles (e.g., units, calibration, accuracy)",
    "A background in instrumentation, electrical, mechanical, or process engineering"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the significance of process measurement in achieving control, safety, and operational objectives",
    "Identify the basic principles and instruments used to measure temperature, pressure, flow, and level",
    "Select appropriate measurement devices based on process characteristics and application requirements",
    "Interpret specifications, datasheets, and installation guidelines for different measurement instruments",
    "Understand best practices for the installation of process instruments to ensure accuracy and reliability",
    "Apply methods to protect instruments from mechanical damage, corrosion, and environmental exposure",
    "Implement heating and climate protection techniques to maintain instrument performance in harsh conditions",
    "Troubleshoot common issues in process measurement and propose practical solutions",
    "Ensure compliance with industry regulations and safety standards during instrument selection and deployment",
    "Integrate measurement systems with control architectures and data acquisition systems for optimal plant performance"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: General",
    "Module 3: Temperature",
    "Module 4: Pressure",
    "Module 5: Flow",
    "Module 6: Level",
    "Module 7: Instrument Installation",
    "Module 8: Instrument Protection",
    "Module 9: Instrument Heating & Climate Protection"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 38,
  "title": "Process P&ID",
  "date": "Present",
  "description": [
    "The Process Piping and Instrumentation Diagram (P&ID) is one of the most critical engineering documents used in the design, construction, operation, and maintenance of oil, gas, and petrochemical facilities. It provides a detailed graphical representation of process equipment, piping systems, instrumentation, and control strategies required for safe and efficient plant operation.",
    "This course provides a comprehensive understanding of P&ID documentation standards, preparation procedures, review methodologies, and engineering responsibilities involved in developing high-quality P&IDs. Participants will learn how to interpret and develop P&IDs in accordance with industry practices and engineering standards.",
    "The program also includes a practical case study of a crude oil production facility, where participants will analyze and understand P&IDs for major process units such as separators, manifolds, produced water treatment systems, pumps, fuel gas systems, and flare systems. This hands-on approach ensures that participants gain practical skills applicable to real field operations and engineering design."
  ],
  image: "https://i.ibb.co/4wz94Scs/Process-P-ID-Course.png",
  tags: [
    'Trainer: Engr. Okechukwu',
  ],
  category: "process",
  "duration": "8 Days",
  "prerequisite": [
    " A basic understanding of process engineering principles\n Familiarity with process equipment and systems (e.g., pumps, vessels, valves)\n Some exposure to industrial or plant operations is beneficial but not mandatory\n Engineering background"
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the purpose, scope, terminology, and requirements associated with Process P&IDs.",
    "Identify the format, structure, and documentation criteria required for preparing standard P&IDs.",
    "Interpret process equipment, piping systems, instrumentation, and control loops represented in P&IDs.",
    "Understand the step-by-step procedure for developing P&IDs, including preparation, issue control, and revision management.",
    "Apply engineering review practices and checklists to verify the accuracy and completeness of P&IDs.",
    "Define the roles and responsibilities of engineers, designers, and project teams in P&ID development.",
    "Interpret P&IDs of a typical crude oil production facility, including:",
    "Manifold systems",
    "Separation systems (Test, HP, and LP separators)",
    "Oil handling and pumping systems",
    "Produced water treatment systems",
    "Fuel gas and flare systems",
    "Develop the ability to review and validate P&IDs for operational safety, maintainability, and process integrity."
  ],
  "outline": [
    "Module 1: Introduction (Purpose, Scope, References, Terms & Terminologies and Requirements)",
    "Module 2: P&ID Documentation Criterial (Format & Contents, Equipment, Piping & Instrumentation & Controls)",
    "Module 3: P&ID Development Procedure (P&ID Issue, P&ID Preparation, P&ID Reviews & Management of Change)",
    "Module 4: P&ID Responsibilities",
    "Module 5: Process P&ID Review Checklist",
    "Module 6: P&ID of a Crude Oil Production Facility",
    "Drawing Index Sheet",
    "Symbology and Legend",
    "Manifold",
    "Test Separator",
    "HP Separator",
    "LP Separator",
    "Interconnection Piping",
    "Electrostatic Heater",
    "LACT Unit",
    "Oil Pipeline Pumps",
    "Oil System",
    "Produced Water Skimmer",
    "Floatation Cell Tank",
    "SAVER Pit",
    "Fuel Gas System",
    "Flare KOD",
    "Flare System & Atmospheric Vent Stack"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},

{
  id: 39,
  title: "Refinery Valves and Accessories for Control and Safety Instrumented Systems Course",
  date: "Present",
  description:
  [
    "In a refinery, valves and their accessories play a critical role in both process control and safety. While control valves regulate process variables (flow, pressure, temperature), safety valves are part of Safety Instrumented Systems (SIS) designed to prevent hazards and ensure safe shutdown.",
    "This course provides a comprehensive insight into the selection, application, and maintenance of valves and related accessories used in control and safety instrumented systems (SIS) within refinery environments.",
    "With safety, reliability, and precision being paramount in refinery operations, this course focuses on the critical role valves play in both process control and emergency scenarios.",
    "Participants will explore various types of control and safety valves, including emergency block valves, SIS valves, vapor depressurizing valves, and hydraulic slide valve actuators. The course also covers specific selection criteria, installation best practices, and testing procedures to ensure compliance with industry standards and operational integrity."
  ],
  image: "https://i.ibb.co/HLwsYcgg/Refinery-Valves-and-Accessories.png",
  tags: [
    'Trainer: Engr. Majid',
  ],
  category: "PAI",
  duration: "4 Days",
  prerequisite: [
    "Basic foundational understanding of process instrumentation and control systems",
    "Familiarity with refinery operations and industrial process equipment",
    "Basic knowledge of valve types, functions, and instrumentation terminology"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the importance of valves and accessories in refinery control and safety instrumented systems",
    "Identify different types of control valves and their functions in process regulation",
    "Apply specific criteria for valve selection based on pressure, temperature, fluid characteristics, and process requirements",
    "Perform and oversee proper installation, inspection, and testing procedures to ensure safe and effective valve operation",
    "Analyze typical refinery applications of valves and understand their integration into process systems",
    "Describe the role of emergency block valves in isolating systems during abnormal or hazardous conditions",
    "Understand the function and criticality of SIS valves in maintaining process safety and meeting regulatory compliance",
    "Explain vapor depressurizing valve operations and their importance in overpressure protection and process safety",
    "Understand the function, configuration, and control of hydraulic slide valve actuators in refining applications",
    "Integrate valve systems effectively into safety and control architectures for reliable refinery operation"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Control Valves",
    "Module 3: Specific Criteria",
    "Module 4: Installation/Inspecting/Testing",
    "Module 5: Refinery Applications",
    "Module 6: Emergency Block Valves",
    "Module 7: Safety Instrumented Systems (SIS) Valves",
    "Module 8: Vapor Depressurizing Valves",
    "Module 9: Hydraulic Slide Valves Actuators"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦200,000 / $180",
  certification: "Certificate of Completion"
},

{
  id: 40,
  title: "Refinery Instrumentation and Control Systems",
  date: "Present",
  description:
  [
    "Installing refinery instruments and control systems is a crucial part of setting up and commissioning a refinery. It ensures that the process can be monitored, controlled, and optimized safely and efficiently.",
    "Process Instrumentation and Control (PIC) is the backbone of any industrial process, especially in refineries, chemical plants, power generation, and water treatment. It involves measuring, monitoring, and controlling process variables to ensure efficiency, safety, and product quality.",
    "The Process Instrumentation and Control course provides in-depth knowledge and practical insights into the measurement and control of process variables essential for safe, efficient, and automated plant operations.",
    "Participants will explore core instrumentation topics such as flow, level, temperature, and pressure measurements, as well as advanced topics including automatic control systems, control valves, transmission methods, and protective devices.",
    "The course integrates basic knowledge of industrial instrumentation systems, power supply arrangements, and control center configurations."
  ],
  image: "https://i.ibb.co/Kc3gXgmx/Installation-of-Refinery-Instruments-and-Control-Systems.png",
  tags: [
    'Trainer: Engr. Okechukwu',
  ],
  category: "PAI",
  duration: "1 Day",
  prerequisite: [
    "Engineering Background",
    "Understanding of process operations",
    "Knowledge of process systems and control theory",
    "Understanding of industrial automation and instrumentation"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the principles and methods of measuring key process variables — flow, level, temperature, and pressure",
    "Gain knowledge of automatic controls, control valves & accessories, transmission systems, seals, purges & winterizing, air supply system, hydraulic system, electrical power supply, and instrument panels"
  ],
  outline: [
    "Module 1: Flow",
    "Module 2: Level",
    "Module 3: Temperature",
    "Module 4: Pressure",
    "Module 5: Automatic Controls",
    "Module 6: Control Valves & Accessories",
    "Module 7: Transmission Systems",
    "Module 8: Seals, Purges & Winterizing",
    "Module 9: Air Supply System",
    "Module 10: Hydraulic System",
    "Module 11: Electrical Power Supply",
    "Module 12: Instruments Panels"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "FREE",
  certification: "Certificate of Completion"
},

{
  id: 41,
  title: "Process Instrumentation and Control (Air Supply System)",
  date: "Present",
  description: [
    "An air supply system in process instrumentation provides compressed air for operating pneumatic instruments, actuators, control valves, and tools. It is a backbone utility in industries for reliable and clean power where electrical systems are not ideal.",
    "This course offers a comprehensive introduction to the design, operation, and maintenance of instrument air supply systems, which are critical to the reliability of process instrumentation and automation.",
    "Instrument air systems ensure the delivery of clean, dry, and pressurized air to pneumatic instruments and control valves used in a wide variety of industrial processes.",
    "Participants will explore the fundamental components and considerations of air supply systems, including air compressors, drying and cleaning methods, distribution networks, and standby systems.",
    "The course is structured to provide both theoretical understanding and practical insight, enabling learners to support safe and efficient process operations."
  ],
  image: "https://i.ibb.co/dszkHbZf/Process-I-C-Air-Supply-System.png",
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of industrial instrumentation and control systems",
    "General knowledge of fluid mechanics and compressed air principles",
    "Technical or engineering background in instrumentation, mechanical, or process engineering (preferred)"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the importance and function of instrument air systems in process control and automation",
    "Describe the general structure and components of air supply systems used in industrial environments",
    "Evaluate the capacity requirements for instrument air based on system demands and process needs",
    "Explain various methods of air drying and cleaning to maintain air quality standards suitable for instrumentation",
    "Understand the design and layout principles of instrument air distribution systems",
    "Identify the role and configuration of instrument air standby systems in ensuring system reliability and availability",
    "Apply best practices in monitoring, maintaining, and troubleshooting air supply systems to prevent downtime and instrument failure"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: General",
    "Module 3: Capacity",
    "Module 4: Drying & Cleaning",
    "Module 5: Distribution Systems",
    "Module 6: Instrument Air Standby Systems"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦60,000 / $50",
  certification: "Certificate of Completion"
},

{
  id: 42,
  title: "Process Instrumentation and Control (Control Valves & Accessories)",
  date: "Present",
  description: [
    "Control valves regulate the flow, pressure, temperature, or level of fluids by varying the size of the flow passage. They are final control elements in a process loop and receive signals from controllers to maintain the desired set-point.",
    "This course offers a comprehensive study of control valves and their associated accessories, which are vital components in regulating process variables such as flow, pressure, temperature, and level.",
    "Control valves serve as the final control elements in an automation system, and their proper selection, installation, and maintenance directly impact process performance and efficiency.",
    "The course covers various types of control valves, their actuators, manifolds, and the associated piping and wiring practices.",
    "Participants will gain both theoretical knowledge and practical insights through case studies that reflect real-world industrial challenges and solutions.",
    "The course is ideal for professionals seeking to deepen their understanding of how control valves function within a broader control system."
  ],
  image: "https://i.ibb.co/Txgw1Rnm/Process-I-C-Control-Valves-Accessories.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of process control principles and instrumentation systems",
    "Familiarity with fluid dynamics and process operations",
    "Technical or Engineering background in instrumentation, mechanical, or process engineering"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role of control valves in process automation and their impact on system performance",
    "Identify and compare different types of control valves, including their construction, functionality, and typical applications",
    "Understand the function, types, and selection criteria of control valve actuators (pneumatic, electric, and hydraulic)",
    "Explain the role and configuration of control valve manifolds in maintaining and isolating valve assemblies",
    "Describe best practices for the piping and wiring of control valve actuators to ensure reliable and safe operation",
    "Analyze real-life case studies to apply theoretical knowledge in troubleshooting, optimizing, and maintaining control valve systems",
    "Select appropriate control valve and accessory configurations based on process requirements and environmental conditions"
  ],
  outline: [
    "Module 1: General",
    "Module 2: Control Valves Types",
    "Module 3: Control Valves Actuators",
    "Module 4: Control Valves Manifolds",
    "Module 5: Piping & Wiring to Control Valves Actuators",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},

{
  id: 43,
  title: "Process Instrumentation and Control (Flow)",
  date: "Present",
  description: [
    "Flow is the movement of a fluid (liquid, gas, or steam) through a pipe or channel. In industrial process control, accurate flow measurement ensures proper material balance, energy efficiency, product quality, and system safety.",
    "This course provides an in-depth understanding of flow measurement techniques and their application in industrial process control systems. Flow measurement is critical to monitoring and managing fluids in industries such as oil and gas, chemical processing, water treatment, and power generation.",
    "Participants will explore the principles, applications, and technologies related to flow instrumentation, with a strong focus on differential pressure devices, orifice plates, piping requirements, and advanced flow measurement techniques. By combining theoretical knowledge with practical insights, the course equips participants with the skills to design, select, install, and troubleshoot flow measurement systems in accordance with industry best practices and standards"
      ],
  image: "https://i.ibb.co/PsmmnCrk/Process-I-C-Flow.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of process instrumentation and control systems",
    "Foundational knowledge of fluid mechanics and flow behavior",
    "Engineering, technical, or operations background in instrumentation, chemical, mechanical, or process industries"
  ],
  methodology: "Theoretical",
  objectives: [
    "Explain the role and importance of flow measurement in process control systems.",
    "Differentiate between types of flow measurement devices and their applications.",
    "Identify the correct flow measurement techniques for various process conditions.",
    "Understand industry applications of differential pressure elements, area meters, and target flow transmitters.",
    "Perform orifice plate sizing calculations based on process conditions.",
    "Apply ISO 5167-2 standards in selecting orifice plates.",
    "Define installation requirements for orifice plates to ensure accuracy and reliability.",
    "Understand piping layouts, tapping methods, and pressure recovery considerations.",
    "Compare differential primary elements, area meters, and target flow transmitters.",
    "Assess advantages, limitations, and suitability for specific applications.",
    "Identify common issues in flow measurement systems.",
    "Recommend corrective actions and maintenance best practices.",
    "Apply theoretical knowledge to evaluate, select, and troubleshoot flow measurement systems in real-world scenarios."
      
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Application",
    "Module 3: Differential Primary Elements",
    "Module 4: Orifice Plates (Sizing)",
    "Module 5: Orifice Plates Installation requirements",
    "Module 6: Connecting Piping ",
    "Module 7: Area Meters",
    "Module 8: Target Flow Transmitters",
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},

{
  id: 44,
  title: "Process Instrumentation and Control (Electrical Power Supply)",
  date: "Present",
  description: [
    "The electrical power supply in process instrumentation and control systems is responsible for providing the necessary power to operate the field instruments, sensors, controllers, actuators, and other electronic devices involved in process control.",
    "A reliable and stable electrical power supply is essential for accurate measurements, control, and safety.",
    "This course provides a detailed understanding of electrical power supply systems used in industrial process instrumentation and control.",
    "The reliable supply of electrical power is crucial to the functioning of instrumentation systems, as it ensures the continuous operation of control devices, monitoring equipment, and other electrical loads.",
    "The course covers essential principles, configurations, and strategies involved in supplying electrical power to process systems, with a focus on handling power dips, interruptions, and ensuring emergency power availability.",
    "Participants will explore various aspects of electrical power supply, including circuit arrangements, load management, and solutions for maintaining power during interruptions.",
    "The course will also delve into emergency power systems, backup solutions, and combination drives designed to mitigate power dips, ensuring uninterrupted operation of instrumentation systems."
  ],
  image: "https://i.ibb.co/pBH4MgDq/Process-I-C-Electrical-Power-Supply.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of electrical systems and their role in industrial process control",
    "Familiarity with electrical circuits, load calculations, and power distribution",
    "Technical background in electrical engineering, instrumentation, or process control"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the importance of a reliable electrical power supply in industrial process control and instrumentation",
    "Identify the key components of an electrical power supply system and how they interact with process instrumentation",
    "Describe general electrical power supply principles, including voltage, current, and frequency management",
    "Explain various power supply circuit arrangements and how to design them for optimal performance and safety",
    "Learn how to manage power supply to loads in process systems, ensuring stability and reliability",
    "Understand how to provide power to critical loads from two different sources to ensure system redundancy and reliability",
    "Implement strategies to supply electricity during power dips and ensure continuous operation of instruments and equipment",
    "Design and implement emergency power systems to provide backup power to instrumentation and associated loads during power outages",
    "Explore combination drives that address both power dips and interruptions, ensuring minimal disruption in process control"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: General",
    "Module 3: Power Supply Circuit Arrangement",
    "Module 4: Power Supply to Loads",
    "Module 5: Load Supply From Two Sources",
    "Module 6: Supplying Electricity During Power Dips",
    "Module 7: Supplying Emergency Power to Instruments & Associated Load",
    "Module 8: Combination Drives for Power Dips & Interruption"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},

{
  id: 45,
  title: "Process Instrumentation and Control (Hydraulic System)",
  date: "Present",
  description: [
    "A hydraulic system uses pressurized fluid to perform work. In industrial applications, hydraulic systems are commonly used to control heavy machinery, automate processes, and move mechanical components with high force.",
    "Hydraulic systems in process instrumentation and control ensure that machines operate smoothly and efficiently, with precision in controlling force, speed, and movement.",
    "This course offers a comprehensive introduction to hydraulic systems used in industrial process instrumentation and control.",
    "Hydraulic systems play a vital role in controlling and transmitting power in various sectors, including manufacturing, oil & gas, and chemical processing.",
    "The course covers the essential components of hydraulic systems, their design principles, and how to integrate them with control systems to ensure efficient operation.",
    "Participants will explore key topics such as pumps, pressure regulation, safety mechanisms, alarms, fluid handling, and the importance of proper piping and strainers.",
    "Additionally, the course addresses how to design hydraulic systems that meet operational requirements and adhere to safety standards, as well as how to maintain and troubleshoot hydraulic systems effectively."
  ],
  image: "https://i.ibb.co/mVYnHWv5/Process-I-C-Hydraulic-System.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of process instrumentation and control principles",
    "General knowledge of fluid mechanics, pressure, and fluid dynamics",
    "A technical background in instrumentation, mechanical engineering, or process control"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role and function of hydraulic systems in process control and instrumentation",
    "Identify the fundamental design principles of hydraulic systems and the factors that influence system performance",
    "Describe the different types of hydraulic pumps, their operation, and how to select them based on system requirements",
    "Explain the purpose and functionality of hydraulic drums in the storage and management of hydraulic fluids",
    "Understand the principles of pressure control and how hydraulic pressure is managed within a system",
    "Recognize the function and importance of safety and relief valves in protecting hydraulic systems from overpressure",
    "Learn about level alarms used to monitor hydraulic fluid levels and ensure optimal system performance",
    "Understand pressure alarms and their role in monitoring system pressure to prevent damage and ensure safety",
    "Describe the types and functions of pressure gauges and gauge glasses for accurate pressure measurement in hydraulic systems",
    "Identify the role of pressure regulators in maintaining consistent system pressure and preventing pressure fluctuations",
    "Explain the operation and importance of strainers in filtering hydraulic fluid to protect components from contaminants",
    "Understand the role of piping in hydraulic systems and the best practices for ensuring leak-free, efficient fluid transmission",
    "Gain insights into hydraulic fluid types, characteristics, and maintenance practices to ensure long-term system reliability"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Basis of Design",
    "Module 3: Pumps",
    "Module 4: Drums",
    "Module 5: Pressure",
    "Module 6: Safety and Relief Valves",
    "Module 7: Level Alarms",
    "Module 8: Pressure Alarms",
    "Module 9: Pressure Gauges & Gauge Glasses",
    "Module 10: Pressure Regulators",
    "Module 11: Strainers",
    "Module 12: Piping",
    "Module 13: Fluid"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 46,
  title: "Process Instrumentation and Control (Instruments Panels)",
  date: "Present",
  description: [
    "Instrument panel is a central assembly housing instruments and control components that monitor and control industrial processes. It acts as the interface between operators and the process, enabling efficient monitoring, diagnostics, and control.",
    "Instrument panels may include various instruments, controllers, relays, switches, and indicators in a neatly organized and accessible format.",
    "This course is designed to provide a comprehensive understanding of the design, construction, and application of instrument panels in process control systems.",
    "Instrument panels serve as the interface between operators and the process, housing instruments, controllers, indicators, and other control devices in a structured and user-friendly layout.",
    "The course covers different types of panels including conventional, console-type control centers, and graphic panels.",
    "Participants will explore key elements such as structural design, painting and finishing, electrical installations, and panel piping.",
    "Participants will gain insight into how panels are configured, built, and maintained for both functionality and safety in industrial environments."
  ],
  image: "https://i.ibb.co/xtm6DZdc/Process-I-C-Instruments-Panels.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of process instrumentation and control principles",
    "Basic knowledge of control devices such as transmitters, indicators, switches, and controllers",
    "Technical or engineering background in instrumentation, electrical, or process systems"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role of instrument panels in process instrumentation and control systems",
    "Describe the general requirements, components, and layout considerations of instrument panels",
    "Differentiate between conventional panels, console-type control centers, and graphic panels based on design and application",
    "Apply best practices in structural design to ensure the durability and stability of instrument panels in various industrial settings",
    "Understand the importance of painting and surface treatment for corrosion resistance and aesthetic standards",
    "Plan and implement electrical installations within instrument panels, ensuring proper wiring, grounding, and safety",
    "Integrate piping into panel design for pneumatic or hydraulic signal transmission, considering layout and maintenance needs",
    "Interpret panel drawings and specifications to support fabrication, installation, and troubleshooting",
    "Collaborate with multidisciplinary teams (mechanical, electrical, instrumentation) during panel design and implementation phases"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: General",
    "Module 3: Conventional Panel",
    "Module 4: Console-Type Control Center",
    "Module 5: Graphic Panel",
    "Module 6: Structural",
    "Module 7: Painting",
    "Module 8: Electrical Installations",
    "Module 9: Piping"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $70",
  certification: "Certificate of Completion"
},

{
  id: 47,
  title: "Process Instrumentation and Control (Pressure)",
  date: "Present",
  description: [
    "In industrial processes, pressure is a key process variable that needs to be accurately measured and controlled to ensure safety, efficiency, and product quality.",
    "It is especially important in systems involving gases, liquids, steam, or chemical reactions.",
    "This course is designed to provide participants with the understanding of pressure measurement and control in industrial processes.",
    "Pressure is a key process variable, and its accurate measurement is critical to safety, efficiency, and quality control in various sectors such as oil & gas, chemical processing, pharmaceuticals, and manufacturing.",
    "The course introduces the principles and practices of pressure instrumentation, covering essential components such as purging and sealing systems, piping considerations, pressure gauges, transmitters, switches, and local control devices.",
    "Participants will also learn about best practices in installation, calibration, and maintenance to ensure optimal performance and reliability."
  ],
  image: require("./coursesImg/Process I & C(pressure).png"),
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of process control systems and instrumentation",
    "General knowledge of physics, especially pressure and fluid dynamics",
    "Background in engineering, industrial technology, or a related technical field is advantageous",
    "Familiarity with industrial environments or process systems is helpful but not mandatory"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role and significance of pressure measurement in process instrumentation and control",
    "Describe common purging and sealing techniques used to protect pressure instruments from contamination and damage",
    "Identify appropriate piping layouts and configurations that support accurate pressure measurement",
    "Explain the types, operation, and applications of pressure gauges in various industrial settings",
    "Understand the working principles, selection criteria, and calibration of pressure transmitters and switches",
    "Describe the functionality and application of locally mounted pressure controllers and recorders",
    "Apply knowledge of pressure instrumentation to improve process safety, efficiency, and reliability",
    "Recognize common challenges in pressure measurement and learn troubleshooting and maintenance techniques"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Purging & Sealing",
    "Module 3: Piping",
    "Module 4: Pressure Gauges",
    "Module 5: Pressure Transmitters, Switches, and Locally Mounted Controllers & Recorders"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦50,000 / $40",
  certification: "Certificate of Completion"
},

{
  id: 48,
  title: "Process Instrumentation and Control (Level)",
  date: "Present",
  description: [
    "Process Instrumentation and Control (Level), which is all about measuring and controlling the height of a fluid (liquid or sometimes solids like powders) in a vessel, tank, or column.",
    "This specialized course focuses on level measurement and control as one of the most critical aspects of process instrumentation.",
    "It provides a detailed exploration of the instruments, devices, and systems used to measure, indicate, transmit, control, and alarm process levels across various industrial applications.",
    "Participants will gain knowledge of locally and remotely mounted instruments, controllers, and transmitters, as well as the accessories and system components that ensure accurate and reliable level control.",
    "Through real-world case studies, the course also highlights best practices and troubleshooting techniques for effective level measurement in operational environments."
  ],
  image: "https://i.ibb.co/JjDnz4nV/Process-I-C-Level.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of instrumentation, process control, or operations",
    "Basic understanding of process systems and measurement principles",
    "Basic knowledge of level measurement",
    "Interpretation skills"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental concepts and importance of level measurement in process industries",
    "Identify various types of locally mounted indicating gauges and understand their applications",
    "Explain the working principles and selection criteria for level transmitters",
    "Distinguish between locally mounted and remote/board-mounted control and indication devices",
    "Understand how locally mounted controllers function and where they are typically applied",
    "Evaluate the role and configuration of remote receivers and board-level interfaces",
    "Design and implement effective level alarm systems to ensure process safety and operational continuity",
    "Recognize the significance of instrument accessories in enhancing accuracy and protecting equipment",
    "Apply knowledge to real-world scenarios through case studies, reinforcing correct selection, installation, and troubleshooting of level measurement systems"
  ],
  outline: [
    "Module 1: Content",
    "Module 2: General",
    "Module 3: Locally Mounted Indicating Gauges",
    "Module 4: Level Transmitters",
    "Module 5: Locally Mounted Controllers",
    "Module 6: Remote or Board Mounted Receivers",
    "Module 7: Level Alarms",
    "Module 8: Accessories",
    "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦60,000 / $50",
  certification: "Certificate of Completion"
},


{
  id: 49,
  title: "Process Instrumentation and Control (Seals, Purges & Wintering)",
  date: "Present",
  description: [
    "Seals, Purges & Wintering are protective and maintenance measures used in process plants to ensure instrumentation functions properly, especially in harsh environments, hazardous materials, or cold climates.",
    "This specialized course focuses on the critical practices of sealing, purging, and winterizing in process instrumentation systems.",
    "These practices are essential to ensure the protection, reliability, and accurate operation of field instruments exposed to harsh environments, corrosive media, or extreme weather conditions.",
    "Participants will gain an understanding of various seal systems used to isolate instruments from the process, purging techniques for maintaining clean and safe instrument environments, and winterization strategies to prevent freezing and operational issues in cold climates.",
    "The course bridges engineering principles with field-level application, enabling learners to apply these protective techniques in real-world industrial scenarios."
  ],
  image: "https://i.ibb.co/zWtQQHqW/Process-I-C-Seals-Purges-Wintering.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of process instrumentation and control systems",
    "Basic knowledge of field instrumentation components and their environmental considerations",
    "Technical background in instrumentation, mechanical, or process engineering"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the importance of seals, purges, and winterization in ensuring reliable instrument performance",
    "Identify different types of seals (e.g., diaphragm seals, chemical seals) and their applications in isolating instruments from process media",
    "Explain the purpose, setup, and best practices of purge systems for protecting measurement devices from contamination or hazardous gases",
    "Understand the methods and materials used for winterizing instrumentation systems to prevent freezing and ensure functionality in cold environments",
    "Evaluate instrumentation environments to determine the appropriate sealing, purging, or winterization strategies",
    "Apply inspection, maintenance, and troubleshooting techniques for seal and purge systems",
    "Implement winterization plans in accordance with safety and operational standards to reduce downtime and protect assets",
    "Integrate protective practices into the design and maintenance of instrumentation systems for enhanced process safety and reliability"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Seals",
    "Module 3: Purges",
    "Module 4: Winterizing"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦60,000 / $50",
  certification: "Certificate of Completion"
},

{
  id: 50,
  title: "Process Instrumentation and Control (Temperature)",
  date: "Present",
  description: [
    "Process Instrumentation and Control involves the use of various instruments and devices to measure, monitor, and control process variables such as temperature, pressure, flow, and level in industrial systems.",
    "Temperature control is one of the most critical aspects, especially in chemical, food, pharmaceutical, and energy industries.",
    "This course provides a comprehensive understanding of temperature measurement and control in industrial process instrumentation.",
    "It delves into the principles, construction, working mechanisms, and applications of various temperature sensing instruments and technologies.",
    "Starting with the basics, the course explores key devices such as thermocouples, resistance temperature detectors (RTDs), thermometers, and advanced optical pyrometers.",
    "It culminates with real-world case studies to reinforce learning and practical application.",
    "Whether you're new to instrumentation or looking to deepen your expertise, this course equips you with the knowledge to select, install, and interpret temperature measurement instruments effectively in process environments."
  ],
  image: "https://i.ibb.co/kVvZsHdc/Process-I-C-Temperature.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of general process control principles",
    "Basic knowledge of physics, particularly heat and temperature concepts",
    "Familiarity with industrial process systems (not mandatory)",
    "Engineering or technical background in instrumentation, electronics, or mechanical disciplines is beneficial"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role of temperature measurement in process instrumentation and control systems",
    "Explain the working principles, construction, and applications of thermowells",
    "Describe the operation, types, and advantages of thermocouples used in industrial settings",
    "Identify resistance-type temperature sensors such as RTDs and thermistors, and their appropriate usage",
    "Differentiate between various types of thermometers used for local temperature readings",
    "Explain the working and application of filled-system temperature instruments",
    "Understand the principles behind non-contact temperature measurement using radiation-type pyrometers",
    "Gain insights into optical pyrometers and their usage in high-temperature and specialized environments",
    "Analyze practical case studies to connect theoretical knowledge with real-world applications in process industries"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Thermowells",
    "Module 3: Thermocouple Temperature Measurement",
    "Module 4: Resistance-Type Temperature Measurement",
    "Module 5: Thermometers for Local Temperature Measurement",
    "Module 6: Filled-System Temperature Instrument",
    "Module 7: Radiation Type Pyrometers",
    "Module 8: Optical Pyrometers",
    "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦60,000 / $50",
  certification: "Certificate of Completion"
},

{
  id: 51,
  title: "Process Instrumentation and Control (Transmission Systems)",
  date: "Present",
  description: [
    "Transmission systems in process control are responsible for conveying measurement and control signals between field instruments (like sensors and actuators) and centralized control units (PLCs, DCS, or SCADA). Accurate and reliable transmission is essential for effective monitoring and control.",
    "This course provides a foundational and practical understanding of flow systems used in process instrumentation and control, with a specific focus on the transmission methods that drive industrial automation.",
    "It explores the essential components, configurations, and operational principles of pneumatic, electrical, and hydraulic systems used to measure, control, and transmit flow information across various industries.",
    "Participants will learn how these systems function individually and within integrated control loops, along with industry-standard practices for inspection, testing, and maintenance.",
    "The course aims to bridge theoretical concepts with field applications, preparing participants to evaluate, maintain, and troubleshoot flow control systems effectively."
  ],
  image: "https://i.ibb.co/NdtPcQYJ/Process-I-C-Transmission-Systems.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of process control and instrumentation fundamentals",
    "Familiarity with physical principles of flow and fluid mechanics",
    "Engineering or technical background in automation, instrumentation, mechanical, or electrical fields (preferred)"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role and significance of flow systems in process instrumentation and control.",
    "Identify general components and functions of flow control systems across various applications.",
    "Explain the working principles and configuration of pneumatic systems used in flow control and actuation.",
    "Understand electrical systems used in flow measurement and signal transmission, including wiring, sensors, and controllers.",
    "Describe the operation, advantages, and limitations of hydraulic transmission systems used in industrial control applications.",
    "Apply standard inspection and testing techniques to ensure performance, reliability, and safety of flow systems.",
    "Troubleshoot common problems in pneumatic, electrical, and hydraulic systems within flow control environments.",
    "Integrate knowledge of various transmission systems to support efficient and accurate process operations."
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: General",
    "Module 3: Pneumatic Systems",
    "Module 4: Electrical Systems",
    "Module 5: Hydraulic Transmission Systems for Control",
    "Module 6: Inspection & Test"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦60,000 / $50",
  certification: "Certificate of Completion"
},

{
  id: 52,
  title: "ASSESSMENT OF AND PLANNING FOR NATURAL HAZARDS",
  date: "Present",
  description: [
    "Assessment involves identifying, analyzing, and understanding the risks posed by natural hazards. The goal is to reduce vulnerability and prepare for effective response and recovery.",
    "This course provides a structured approach to assessing and planning for natural hazards with a focus on minimizing risks to infrastructure, equipment, and operations.",
    "It guides participants through the process of identifying potential hazards, collecting relevant data, evaluating the vulnerability of critical equipment, and comparing risks against design criteria.",
    "The course also covers planning for recovery and recommissioning activities after an event."
  ],
  image: "https://i.ibb.co/HLmhsV1s/ASSESSMENT-OF-AND-PLANNING-FOR-NATURAL-HAZARDS-43a85a97518d9c2e7ec1.png",
  tags: [
    "Trainer: Engr. Adeyemi"
  ],
  category: "hazop hazid",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of risk assessment or disaster management concepts",
    "Familiarity with fluid mechanics and heat exchanger operations.",
    "Knowledge of material science, especially related to thermal conductivity and corrosion.",
    "General knowledge of environmental and geotechnical factors"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the importance of natural hazard assessment in protecting assets and operations.",
    "Identify various types of natural hazards (e.g., earthquakes, floods, hurricanes) relevant to specific locations or facilities",
    "Collect and interpret hazard-related data for informed decision-making.",
    "Recognize critical equipment and systems that must be assessed for vulnerability",
    "Evaluate current designs and installations against hazard-resistant criteria or standards",
    "Design and evaluate the performance of shell-and-tube exchangers, incorporating baffles and tube bundles to improve efficiency.",
    "Plan for effective recovery and recommissioning following a natural hazard event",
    "Apply practical knowledge gained from case studies to improve facility preparedness and response."
  ],
  outline: [
    "Module 1:    Introduction",
    "Module 2:    Identifying Hazards",
    "Module 3:    Gather Data",
    "Module 4: Identify Equipment to be addressed In Natural Hazards Assessment",
    "Module 5:    Evaluate against Design Criteria",
    "Module 6:    Recovery",
    "Module 7:    Recommissioning",
    "Module 8:  Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},

{
  id: 52,
  title: "Bearings Failures, Causes & Remedies",
  date: "Present",
  description: [
    "Bearings are critical components in rotating machinery, designed to support loads and reduce friction between moving parts. When bearings fail, they can lead to equipment breakdowns, reduced efficiency, safety hazards, and costly downtime. Understanding why bearings fail and how to prevent it is essential for reliable machine operation.",
    "This course offers a comprehensive study of bearing systems, focusing on their construction, operation, and failure mechanisms.",
    "Participants will explore the types of loads bearings endure, the influence of material selection, clearances, and design considerations, as well as the most common causes of bearing failures.",
    "The course introduces diagnostic tools and techniques, including path pattern interpretation and TV-2 statistics.",
    "Real-world examples and practical demonstrations are included to reinforce root cause analysis and best practices for failure prevention and corrective action."
  ],
  image: "https://i.ibb.co/zTqjn8LS/Bearings-Failures-Causes-Remedies-05397a51ad4ecaa8cec6.png",
  tags: [
    "Trainer: Engr. Adeyemi"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of mechanical components and rotating machinery",
    "Familiarity with industrial maintenance practices.",
    "Understanding of friction, lubrication, and material behavior."
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Identify types of bearings and their working principles",
    "Understand key components and their mechanical roles",
    "Compare material properties and their impact on bearing performance",
    "Recognize how material selection influences durability and failure risk",
    "Understand how radial, axial, and combined loads affect bearing choice",
    "Match bearing types to specific machine requirements",
    "Learn how improper clearances contribute to wear and failure",
    "Understand the impact of thermal expansion and misalignment",
    "Explore issues such as lubrication problems, contamination, overloading, and fatigue",
    "Analyze how poor installation and improper maintenance lead to failures",
    "Study real-world failure examples and match symptoms to causes",
    "Use path pattern analysis to determine failure modes",
    "Learn how to apply statistical tools to assess bearing wear and reliability",
    "Perform practical assessments and demonstrations of faulty bearings",
    "Understand corrective actions and preventive maintenance measures",
    "Analyze case histories of bearing failures in various industries",
    "Apply lessons learned to improve reliability and reduce downtime"
  ],
  outline: [
    "Module 1:     Concept",
    "Module 2:     Construction",
    "Module 3:     Bearing Materials",
    "Module 4:     Types of Load and Bearings",
    "Module 5:     Bearing Clearances",
    "Module 6:     Why Bearing Fails",
    "Module 7:     Failures, Causes, and Remedies: Few Examples",
    "Module 8:     Path Pattern Interpretation",
    "Module 9:     Other Important Points",
    "Module 10:    TV-2 Statistic",
    "Module 11:    Practical Demonstration",
    "Module 12:    Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 53,
  title: "Boiler System Failure",
  date: "Present",
  description: [
    "A boiler system is a critical component in power plants, manufacturing industries, and heating systems. It works by heating water to produce steam, which is used for heating, power generation, or industrial processes.",
    "Boiler system failures can lead to operational downtime, safety hazards, and costly repairs. These failures aren't limited to just the boiler tubes but include all parts of the system — such as feedwater systems, pressure vessels, burners, control systems, and more.",
    "Understanding these failures is essential for maintaining efficiency, ensuring safety, and prolonging equipment life.",
    "This course offers an in-depth exploration of boiler system failures, examining the causes, mechanisms, and prevention strategies across various boiler components.",
    "Participants will gain knowledge about failure modes affecting economizers, deaerators, firetube and watertube boilers, steam and mud drums, and condensate systems.",
    "The course will also address corrosion, deposits, and mechanical stresses that contribute to component degradation.",
    "Through case studies, learners will analyze real-world failure incidents and apply corrective actions to enhance system reliability and performance."
  ],
  image: "https://i.ibb.co/KjvCP3rW/Boiler-System-Failure-125ed46c34cbe6329fe1.png",
  tags: [
    "Trainer: Engr. Adeyemi"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of boiler design and operation",
    "Familiarity with steam systems and water treatment processes.",
    "Knowledge of materials, corrosion, and thermal stress concepts."
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Identify the role of economizers, deaerators, drums, and tubes in steam generation",
    "Recognize how each component contributes to boiler performance and efficiency",
    "Learn the typical causes of failures in firetube and watertube boilers",
    "Analyze the impact of design, operation, and maintenance practices on failure risks",
    "Understand how corrosion, scaling, and deposits affect system integrity",
    "Examine failure patterns in steam lines, mud drums, and superheaters",
    "Identify symptoms of impending failure and conduct inspections",
    "Learn preventive strategies through proper operation and monitoring",
    "Analyze actual boiler failure events and root cause investigations",
    "Use case study insights to improve system performance and reduce downtime"
  ],
  outline: [
    "Module 1:     Economizers",
    "Module 2:     Deaerators",
    "Module 3:     Firetube Boilers",
    "Module 4:     Watertube Boilers",
    "Module 5:     Steam Line Deposits",
    "Module 6:     Mud Drum and Steam Drum Deposits",
    "Module 7:     Boiler Drums and Tubes",
    "Module 8:     Boiler Water Sight Glass Failure",
    "Module 9:     Superheater Tubes Failures",
    "Module 10:    Condensate Lines Corrosion",
    "Module 11:    Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},


{
  id: 54,
  title: "Boiler Tube Failure",
  date: "Present",
  description: [
    "Boiler tube failure is one of the most common and critical problems in steam-generating systems, particularly in power plants and heavy industries.",
    "The boiler tubes are essential components that carry water or steam at high pressure and temperature. If these tubes fail, it can lead to forced shutdowns, loss of efficiency, costly repairs, and in severe cases, dangerous accidents.",
    "Failures happen when the tube material can no longer withstand the mechanical stresses, temperatures, or corrosive environments inside the boiler.",
    "Understanding the causes and types of failures is crucial for improving reliability, safety, and performance.",
    "This course focuses on the causes, types, and prevention of boiler tube failures, which are one of the leading causes of forced outages in thermal power and industrial steam generation systems.",
    "Participants will gain foundational knowledge of boiler components and accessories, followed by an in-depth look at failure mechanisms, detection methods, and corrective actions.",
    "Real-world case studies will be used to demonstrate practical approaches to diagnosing and mitigating boiler tube failures in various industrial settings."
  ],
  image: "https://i.ibb.co/7dJCwzkN/Boiler-Tube-Failure-90a3e29406c9b91d7f92.png",
  tags: [
    "Trainer: Engr. Adeyemi"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of steam generation principles.",
    "Familiarity with industrial boiler systems and components.",
    "Knowledge of materials and corrosion concepts."
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Recognize the importance of maintaining proper operating conditions.",
    "Identify how accessory failures can contribute to tube damage.",
    "Understand mechanisms such as corrosion, erosion, fatigue, overheating, and mechanical wear.",
    "Detect early warning signs and use inspection techniques to assess tube condition.",
    "Learn strategies for improving water chemistry, operational procedures, and material selection.",
    "Plan maintenance and inspection routines to reduce failure frequency.",
    "Examine documented failure incidents and root cause analysis.",
    "Apply findings to improve the reliability and longevity of boiler systems."
  ],
  outline: [
    "Module 1:    Boiler",
    "Module 2:    Boiler Accessories",
    "Module 3:    Boiler Tube Failures",
    "Module 4:    Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},

{
  id: 55,
  title: "Fundamentals of Control Valve Engineering",
  date: "Present",
  description: [
    "A control valve is a critical component in process control systems. It regulates the flow of fluids (liquids, gases, or steam) by varying the size of the flow passage. This ensures that process variables like pressure, temperature, and fluid level are maintained within desired ranges.",
    "Control valves receive signals from controllers (like PLCs or DCS) and adjust their position accordingly to maintain process stability and efficiency.",
    "This course provides a foundational understanding of control valve engineering, focusing on the selection, operation, and specification of control valves and associated components.",
    "It covers essential topics such as actuators, positioners, severe service applications, treatment methods, industry standards, and documentation practices.",
    "Participants will gain insight into how control valves regulate process variables and contribute to system efficiency and stability.",
    "The course includes practical examples, sample specifications, and real-world case studies to enhance applied learning."
  ],
  image: "https://i.ibb.co/wFj1KgJR/Fundamentals-of-Control-Valve-Engineering-70877eb488ccea471af0.png",
  tags: [
    "Trainer: Engr. Adeyemi"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of fluid mechanics and process control systems",
    "Familiarity with instrumentation symbols and process flow diagrams",
    "Awareness of industrial control systems and loop operations."
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Identify different types of industrial furnaces and their applications",
    "Distinguish between batch, continuous, electric, fuel-fired, and other furnace types",
    "Learn to calculate thermal efficiency and assess heat losses",
    "Understand key parameters affecting furnace performance",
    "Identify opportunities for improving fuel usage and reducing energy losses",
    "Explore insulation, air-fuel ratio control, preheating, and automation techniques",
    "Review examples of successful furnace optimization projects",
    "Understand practical implementation challenges and solutions"
  ],
  outline: [
    "Module 1:     Control Valve",
    "Module 2:     Actuators",
    "Module 3:     Positioners",
    "Module 4:     Severe Service",
    "Module 5:     Severe Service Treatments",
    "Module 6:     Standards",
    "Module 7:     Sample Specification",
    "Module 8:     Sample Datasheet",
    "Module 9:     Case Study"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 56,
  title: "Gas Dehydration",
  date: "Present",
  description: [
    "Gas dehydration is the process of removing water vapor from natural gas to prevent problems such as hydrate formation, pipeline corrosion, and freezing. It’s a critical step in natural gas processing to ensure gas meets pipeline specifications and remains safe for transport and use.",
    "This course provides a detailed understanding of gas dehydration processes, which are essential for removing water vapor from natural gas to prevent hydrate formation, corrosion, and equipment damage.",
    "Participants will explore the behavior of water in hydrocarbon systems, various dehydration technologies, and hydrate inhibition techniques in both processing plants and pipelines.",
    "Special focus is given to glycol dehydration using liquid desiccants.",
    "The course concludes with real-world case studies to highlight practical challenges and solutions in gas dehydration operations."
  ],
  image: "https://i.ibb.co/GfR1Bgpm/Gas-Dehydration-4ab1e42d224e7d9a335e.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of natural gas composition and processing",
    "Familiarity with thermodynamics and phase behavior",
    "Understanding of gas plant operations and equipment."
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Recognize the need to remove water vapor from natural gas streams",
    "Understand the impact of water on gas quality, pipeline integrity, and downstream equipment",
    "Study the phase behavior of water in natural gas systems",
    "Evaluate the conditions leading to condensation and hydrate formation",
    "Identify various dehydration technologies and their operating principles",
    "Compare absorption, adsorption, and refrigeration-based methods",
    "Understand the use of triethylene glycol (TEG) and other desiccants",
    "Analyze key equipment and parameters in a typical glycol dehydration unit",
    "Explore chemical and mechanical methods to prevent hydrate formation",
    "Learn about methanol and glycol injection strategies",
    "Learn how to manage temperature and pressure to avoid hydrate risks",
    "Apply hydrate inhibition strategies during transport and shutdown conditions",
    "Analyze field examples of dehydration unit performance and failures",
    "Learn from troubleshooting techniques and operational improvements"
  ],
  outline: [
    "Module 1:     Overview",
    "Module 2:     Water Hydrocarbon System Behaviors",
    "Module 3:     Gas Dehydration Systems",
    "Module 4:     Absorption Using Liquid Desiccants (Glycol Dehydration)",
    "Module 5:     Hydrate Inhibition in Low Temperature Processing Plant",
    "Module 6:     Hydrate Inhibition in Gas Pipeline",
    "Module 7:     Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 57,
  title: "Furnaces",
  date: "Present",
  description: [
    "A furnace is an enclosed structure used to heat materials to high temperatures. In industries, furnaces are critical for processes such as metal melting, heat treatment, chemical reactions, and generating hot gases for boilers and other systems.",
    "The main function of a furnace is to provide controlled heating, which can be direct (material is exposed to flame/gases) or indirect (heating elements or external heat sources).",
    "This course offers a detailed understanding of industrial furnaces, focusing on their classification, performance evaluation, and fuel economy improvement techniques.",
    "Participants will explore different furnace types, learn how to assess furnace efficiency, and identify practical energy-saving measures.",
    "Real-world case studies will provide insight into best practices, common issues, and optimization strategies used across industries such as metallurgy, petrochemicals, ceramics, and manufacturing."
  ],
  image: "https://i.ibb.co/TGd6JWG/Furnaces-46c00bc0e4ebe04adfab.png",
  tags: [
    "Trainer: Engr. Adeyemi"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of thermodynamics and heat transfer",
    "Familiarity with combustion processes and industrial heating systems",
    "Awareness of energy efficiency principles."
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Identify different types of industrial furnaces and their applications",
    "Distinguish between batch, continuous, electric, fuel-fired, and other furnace types",
    "Learn to calculate thermal efficiency and assess heat losses",
    "Understand key parameters affecting furnace performance",
    "Identify opportunities for improving fuel usage and reducing energy losses",
    "Explore insulation, air-fuel ratio control, preheating, and automation techniques",
    "Review examples of successful furnace optimization projects",
    "Understand practical implementation challenges and solutions"
  ],
  outline: [
    "Module 1:     Types and Classification of Different Furnaces",
    "Module 2:     Performance Evaluation of a Typical Furnace",
    "Module 3:     General Fuel Economy Measures in Furnaces",
    "Module 4:     Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},


{
  id: 58,
  title: "Engineering Disciplines (Activities and Deliverables)",
  date: "Present",
  description: [
    "In industrial and infrastructure projects, engineering disciplines work in coordination to deliver safe, functional, and cost-effective systems. Each discipline contributes through distinct phases of design, analysis, and documentation. Their deliverables are essential for procurement, construction, commissioning, and operation.",
    "This course provides a structured understanding of the roles, responsibilities, and key deliverables of each major engineering discipline in an industrial project environment. It highlights the scope of work and interdependencies across process, mechanical, civil, piping, instrumentation, and electrical engineering, among others. The course is designed to give participants clarity on typical outputs, coordination challenges, and quality expectations from each discipline, with practical reinforcement through case studies."
],
  image: "https://i.ibb.co/sJ5hmGQb/Engineering-disciplines-Activities-and-Deliverables-60909887a190f08b1d90.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "project management",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of project execution in engineering or construction",
    "Familiarity with engineering disciplines",
    "Suitable for junior engineers, project coordinators, engineering managers, and technical documentation teams"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the specific roles and deliverables of each engineering discipline in a project",
    "Interpret and produce key documents such as P&IDs, layouts, datasheets, and analysis reports",
    "Recognize interdependencies and coordination requirements across disciplines",
    "Identify the documentation and inputs required at various project phases (FEED, EPC, commissioning)",
    "Apply quality control practices to engineering deliverables",
    "Evaluate case studies to identify best practices and common coordination issues",
    "Communicate more effectively across multidisciplinary engineering teams",
    "Track progress and ensure alignment with project execution plans",
    "Support design review processes such as 30%, 60%, and 90% model reviews",
    "Promote efficiency, safety, and compliance through accurate engineering documentation"
  ],
  outline: [
    "Module 1:     Process",
    "Module 2:     Plant Layout",
    "Module 3:     Equipment",
    "Module 4:     Safety & Environment",
    "Module 5:     Civil",
    "Module 6:     Piping",
    "Module 7:     Pipeline",
    "Module 8:     Instrumentation",
    "Module 9:     Electrical"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 59,
  title: "Heat Exchanger Inspection",
  date: "Present",
  description: [
    "Heat exchangers are critical components in industrial systems, used to transfer heat between two or more fluids without mixing them. Over time, due to harsh operating environments, they are prone to issues like fouling, corrosion, erosion, cracking, and leaks, which can reduce efficiency and lead to unplanned shutdowns or safety hazards.",
    "This course provides a comprehensive understanding of heat exchanger systems with a specific focus on inspection, testing, and maintenance practices. It explores the different types of heat exchangers, their functions, common deterioration mechanisms, and the importance of regular inspection to ensure safety, efficiency, and regulatory compliance. Participants will learn standard inspection procedures, testing methods, preservation practices during idle periods, and how to maintain accurate inspection documentation. The course includes real-world case studies to illustrate key learning points and industry practices. "
],
  image: require("./coursesImg/heat exchanger inspection.png"),
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of heat transfer and thermodynamics",
    "Familiarity with heat exchanger operations and process equipment",
    "Knowledge of industrial maintenance or inspection methods"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Recognize inspection’s role in maintaining performance, reliability, and safety",
    "Identify regulatory and operational drivers for periodic inspections",
    "Understand applications across industries and operating environments",
    "Compare designs such as shell-and-tube, plate, finned, and air-cooled exchangers",
    "Understand fouling, scaling, erosion, and stress-related damage",
    "Explain the necessity of inspection and monitoring",
    "Learn how inspection prevents failure, reduces downtime, and extends asset life",
    "Perform visual inspections, non-destructive testing (NDT), and operational checks",
    "Follow protocols for accessing, disassembling, and inspecting units",
    "Explore hydrostatic, dye penetrant, ultrasonic, eddy current, and radiographic testing",
    "Interpret test results and identify actionable outcomes",
    "Prevent internal damage and corrosion during shutdowns",
    "Apply proper cleaning, drying, and sealing techniques",
    "Document findings, test results, repairs, and preventive measures",
    "Review real-life inspection scenarios and outcomes",
    "Identify lessons learned and best practices for future inspections"
  ],
  outline: [
    "Module 1: Scope",
    "Module 2: Name and Functions of Heat Exchangers",
    "Module 3: Types of Heat Exchangers",
    "Module 4: Corrosion and Deterioration in Heat Exchangers",
    "Module 5: Necessity of Inspection",
    "Module 6: Inspection Procedures",
    "Module 7: Testing",
    "Module 8: Idle Time Preservation",
    "Module 9: Inspection Documentation",
    "Module 10: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 60,
  title: "Heat Exchanger Maintenance",
  date: "Present",
  description: [
    "Heat exchangers are critical pieces of equipment used to transfer heat between two fluids without mixing them. They’re widely used in industries like power generation, oil & gas, chemical processing, HVAC, and food production.",
    "Because they handle extreme temperatures, pressures, and sometimes corrosive materials, they need regular maintenance to ensure efficient and safe operation.",
    "This course offers practical and technical insights into the maintenance and repair of heat exchangers, which are critical components in process industries for energy transfer. It introduces participants to the basic structure and working of heat exchangers, explores various types and components, and provides step-by-step approaches for inspection, routine maintenance, and specialized repair methods. The course gives special attention to diaphragm-type heat exchangers and includes hands-on knowledge about re-tubing old bundles. Real-world case studies highlight common issues and effective solutions used in the field."

  ],
  image: "https://i.ibb.co/F4LdsGkw/heat-exchanger-maintenance.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of heat transfer principles",
    "Familiarity with mechanical maintenance practices and tools",
    "Knowledge of industrial process systems and components"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Identify key operating principles and heat transfer mechanisms",
    "Recognize the importance of maintenance for reliability and efficiency",
    "Understand structural and functional differences in shell-and-tube, plate, and diaphragm types",
    "Match exchanger types to their most suitable applications",
    "Learn about key components like tubes, shells, baffles, heads, and gaskets",
    "Understand construction materials and mechanical assembly details",
    "Perform cleaning, inspection, and preventive maintenance routines",
    "Detect fouling, corrosion, leaks, and mechanical wear",
    "Understand unique structural and operational considerations",
    "Learn specialized inspection and maintenance techniques",
    "Learn how to assess when re-tubing is necessary",
    "Gain knowledge of material compatibility and mechanical procedures",
    "Study real-world problems and repair approaches",
    "Apply learning to enhance reliability and operational uptime"
  ],
  outline: [
    "Module 1: What is a Heat Exchanger",
    "Module 2: Types of Heat Exchangers",
    "Module 3: Exchanger Components",
    "Module 4: Heat Exchanger Construction",
    "Module 5: Maintenance of Heat Exchanger",
    "Module 6: Diaphragm Type Heat Exchanger",
    "Module 7: Special Consideration in Diaphragm Type Heat Exchanger Maintenance",
    "Module 8: Old Bundle Re-Tubing",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 61,
  title: "HVAC Domestic and Industrial Ventilation Systems",
  date: "Present",
  description: [
    "HVAC stands for Heating, Ventilation, and Air Conditioning.",
    "Ventilation systems, a critical part of HVAC, are designed to move fresh air into spaces and remove stale air, controlling temperature, humidity, and air quality. Whether in homes (domestic) or factories (industrial), these systems ensure comfort, health, and safety. Both systems share basic principles but differ significantly in scale, complexity, and performance requirements.",
    "This course offers a comprehensive introduction to ventilation systems within the HVAC (Heating, Ventilation, and Air Conditioning) field, focusing on both domestic and industrial applications. Participants will explore the types of ventilation systems, methods for improving indoor air quality, and techniques for estimating ventilation rates. The course also covers design considerations specific to industrial environments, providing insight into the functional and regulatory requirements of ventilation systems. Real-world case studies will be used to reinforce theoretical knowledge and practical application."

],
  image: require("./coursesImg/HVAC Domestic and Industrial Ventilation Systems.png"),
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of thermodynamics and fluid flow",
    "Familiarity with HVAC system components and functions",
    "Awareness of indoor air quality principles"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Explain why ventilation is critical for comfort, safety, and air quality",
    "Differentiate between natural and mechanical ventilation",
    "Recognize systems such as exhaust, supply, balanced, and spot ventilation",
    "Match system types to appropriate applications in residential and industrial contexts",
    "Understand ventilation’s role in controlling pollutants, moisture, and odors",
    "Incorporate filtration, air exchange, and humidity control techniques",
    "Use standard formulas and guidelines (ASHRAE, CIBSE, etc.)",
    "Calculate air changes per hour (ACH) based on occupancy and space use",
    "Learn how to control airborne contaminants in workplaces",
    "Explore local exhaust ventilation (LEV), dilution ventilation, and capture systems",
    "Assess space constraints, noise, energy use, and ducting layouts",
    "Evaluate fan selection, air distribution, and integration with HVAC systems",
    "Review successful and problematic ventilation installations",
    "Identify key lessons and best practices for design and maintenance"
  ],
  outline: [
    "Module 1: General Purpose Ventilation",
    "Module 2: Types of Ventilation Systems",
    "Module 3: Ventilation Strategies for Indoor Air Quality",
    "Module 4: Estimating Ventilation Rates",
    "Module 5: Industrial Ventilation",
    "Module 6: General System Design Considerations",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 62,
  title: "Inspection of Pressure Vessels",
  date: "Present",
  description: [
    "ASME Section VIII Division 1 of the Boiler and Pressure Vessel Code (BPVC) governs the design, fabrication, testing, inspection, and certification of pressure vessels. Inspection is a crucial part of this process because pressure vessels operate under high pressure and hold potentially hazardous substances — so failures can be catastrophic.",
    "This course provides a comprehensive understanding of the inspection requirements for pressure vessels in accordance with ASME Section VIII Division 1. It covers the role of authorized inspection, relevant ASME code provisions, the scope and organization of Section VIII, and the responsibilities of both manufacturers and authorized inspectors. Through detailed exploration of code stamps, inspection processes, and real-world case studies, participants will gain practical knowledge to ensure compliance, safety, and reliability in pressure vessel fabrication and operation."

  ],
  image: "https://i.ibb.co/MK1mcYG/inspection-of-pressure-vessels.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of pressure vessel design and manufacturing",
    "Familiarity with general industrial codes and standards",
    "Knowledge of welding, NDE, and fabrication processes"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Define who an Authorized Inspector is and their role in code compliance",
    "Explain when and why authorized inspection is required under ASME",
    "Understand how the ASME Code is structured and applied across industries",
    "Navigate relevant sections with a focus on Section VIII Div. 1",
    "Identify the purpose of the 'U,' 'UM,' 'U2,' and other relevant stamps",
    "Understand stamping procedures and their implications on inspection",
    "Distinguish duties related to document review, witness testing, and final acceptance",
    "Coordinate effectively between involved parties during vessel fabrication",
    "Review key code sections on design, materials, fabrication, inspection, testing, and certification",
    "Understand how Division 1 differs from other Divisions in Section VIII",
    "Follow procedures for joint review, material traceability, pressure testing, and final inspection",
    "Engage in Q&A for clarification and knowledge reinforcement",
    "Address common questions related to inspection practices and code interpretation",
    "Learn from inspection successes and failures in various industries",
    "Identify best practices and preventive measures"
  ],
  outline: [
    "Module 1: What is Authorized Inspection?",
    "Module 2: Overview of ASME Code",
    "Module 3: Code Stamps",
    "Module 4: Inspection responsibilities: Manufacturer & Authorized Inspector",
    "Module 5: ASME Section Inspection VIII: Scope & Organization",
    "Module 6: Section VIII & Division 1 Inspection requirements",
    "Module 7: Questions & Answers",
    "Module 8: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 63,
  title: "Instrumentation Project Engineering Documents",
  date: "Present",
  description: [
    "Instrumentation projects involve specifying, selecting, installing, and integrating instruments and control systems in industrial plants (oil & gas, power, chemical, manufacturing, etc.).  ",
    "To manage this efficiently, a well-defined set of engineering documents is required. These documents ensure that all design requirements are met, the installation is done properly, and the system operates safely and reliably.",
    "This course provides an in-depth understanding of the key engineering documents used in instrumentation projects, particularly in process and industrial automation. These documents are essential for planning, designing, executing, and maintaining instrumentation systems in complex projects. Participants will explore the purpose, structure, interrelationships, and development sequence of documents such as P&IDs, datasheets, loop diagrams, hook-ups, and logic diagrams. Real-world case studies will illustrate the importance of accuracy and coordination in documentation to ensure safety, functionality, and compliance. "
],
  image: require("./coursesImg/Instrumentation Project Engineering Documents.png"),
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of instrumentation and control principles",
    "Familiarity with process systems and control loops",
    "Understanding of project execution phases in industrial settings"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Recognize how each document supports project planning, execution, and commissioning",
    "Ensure consistency and integration across multidisciplinary teams",
    "Understand how P&IDs define process flow, control logic, and instrument locations",
    "Use P&IDs as the basis for developing other instrumentation documents",
    "Translate process requirements into technical specifications for instruments",
    "Ensure datasheets meet design, procurement, and operational needs",
    "Organize instruments by tag number, service, and system",
    "Create and update I/O lists for integration with control systems",
    "Illustrate control loop connections from field to control room",
    "Design hook-ups for installation with accurate materials and termination",
    "Assign and document cable routing, termination, and control signals",
    "Understand how logic diagrams represent control system behavior",
    "Document safety and control logic in response to process deviations",
    "Apply to emergency shutdown (ESD) and interlock systems",
    "Learn from actual project documentation scenarios",
    "Identify common pitfalls and best practices for effective document management"
  ],
  outline: [
    "Module 1: Piping & Instrumentation Diagram or P&ID",
    "Module 2: Process Datasheet",
    "Module 3: Instrument Index",
    "Module 4: I/O List",
    "Module 5: Instrument Specification",
    "Module 6: Instrument Loop Diagrams",
    "Module 7: Instrument Hook-up Diagrams",
    "Module 8: Instrument Cable Schedule",
    "Module 9: Instrument Logic Diagrams",
    "Module 10: Cause & Effect Diagrams",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 64,
  title: "Instruments Symbols",
  date: "Present",
  description: [
    "Instrument symbols are a universal language used in engineering, especially in process industries like oil & gas, chemical plants, power plants, and manufacturing. They appear mainly in technical drawings called P&ID (Piping and Instrumentation Diagrams). These symbols help engineers, operators, and technicians understand how systems are measured, monitored, and controlled.",

    "The purpose of these symbols is to represent: What physical quantity is being measured (like flow, temperature, pressure, or level). The type of instrument or function it performs (like indicating, recording, transmitting, controlling). Its role in the process loop (such as measurement, control action, or alarm).",

    "This course provides a detailed understanding of instrumentation symbols as used in engineering drawings and control systems documentation. It focuses on standard symbol conventions, their application in various types of measurements (flow, pressure, temperature, level), and their use in control systems, control valves, calibration, and safety systems. Participants will become familiar with how to read, interpret, and use instrumentation symbols in process diagrams like P&IDs. The course also includes reference to international codes, standards, and real-world case studies to reinforce practical application."
],
  image: "https://i.ibb.co/MxGzBrCQ/instruments-symbols.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of process instrumentation and control systems",
    "Familiarity with industrial processes and equipment",
    "Understanding of process diagrams"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Recognize the role of symbols in engineering drawings and documentation",
    "Identify standard conventions for instrumentation symbols",
    "Understand how flow and pressure instruments are represented in P&IDs",
    "Distinguish between different types of sensors and transmitters",
    "Identify different types of control valves and their functions",
    "Recognize accessories like positioners, I/P converters, and actuators",
    "Learn how thermocouples, RTDs, and level sensors are represented in diagrams",
    "Differentiate between local, remote, and display instruments",
    "Analyze feedback and feedforward loop arrangements",
    "Understand the flow of information from field to control room",
    "Understand calibration notations and symbols on loop sheets",
    "Recognize how calibration documentation aligns with field instruments",
    "Learn relevant international standards (e.g., ISA, ISO) for symbol usage",
    "Understand their importance in engineering consistency and compliance",
    "Interpret symbols related to safety functions, shutdowns, and interlocks",
    "Understand SIS-specific documentation and notations",
    "Analyze real project documentation and troubleshoot errors",
    "Improve interpretation and accuracy in instrumentation design and reviews"
  ],
  outline: [
    "Module 1: Instrument Symbols",
    "Module 2: Flow / Pressure measurement",
    "Module 3: Control Valve",
    "Module 4: Control Valve Accessories",
    "Module 5: Temperature measurement",
    "Module 6: Level measurement",
    "Module 7: Control Loops",
    "Module 8: Instruments Calibration",
    "Module 9: Codes, standards & Specification",
    "Module 10: Safety Instrumented Systems",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},

{
  id: 65,
  title: "Introduction to Steam Turbines",
  date: "Present",
  description: [
    "A steam turbine is a mechanical device that converts thermal energy from high-pressure steam into rotational mechanical energy. This mechanical energy is often used to drive: Generators, Pumps, Compressors, or other rotating equipment in industrial processes. Steam turbines are critical components in power plants (thermal, nuclear), petrochemical industries, refineries, and marine propulsion.",
    "This course offers a foundational introduction to steam turbines, focusing on their role within power generation systems. Participants will learn about the arrangement and internal components of steam turbines, as well as the types of turbines used across various plant configurations. The course also explores the integration of steam turbines with pulverized coal-fired boilers and nuclear steam supply systems. Through real-world case studies, learners will gain practical insights into turbine operation, system efficiency, and reliability considerations in modern power plants." 
],
  image: "https://i.ibb.co/d0NDLyB6/introduction-to-steam-turbines.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of thermodynamics and mechanical systems",
    "General awareness of how power plants operate",
    "Familiarity with energy conversion principles"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Recognize the importance of steam turbines in thermal power generation",
    "Describe how turbines convert thermal energy into mechanical and electrical energy",
    "Learn the basic arrangement of steam turbines including casing, rotor, and blades",
    "Understand the flow of steam through various turbine stages",
    "Study the stationary and rotating elements of a steam path",
    "Understand how steam pressure and temperature affect turbine performance",
    "Compare impulse and reaction turbines",
    "Understand configurations such as condensing, extraction, and back-pressure turbines",
    "Learn how pulverized coal-fired boilers generate steam for turbine use",
    "Explore combustion and heat transfer processes relevant to turbine operation",
    "Understand the role of steam turbines in nuclear steam supply systems (NSSS)",
    "Identify differences in design and safety considerations compared to fossil plants",
    "Analyze real-world steam turbine applications",
    "Review operational challenges, failures, and performance optimization examples"
  ],
  outline: [
    "Module 1: Introduction to Power Plants",
    "Module 2: Steam Turbine Arrangement",
    "Module 3: Steam Path Parts",
    "Module 4: Types of Steam Turbines",
    "Module 5: Pulverized Coal-Fired Boilers",
    "Module 6: Nuclear Steam Supply System",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 66,
  title: "Pinch Technology",
  date: "Present",
  description: [
    "Pinch Technology is a process integration technique used to maximize energy efficiency in industrial systems by optimizing heat recovery between process streams. It helps identify the minimum energy requirement of a process and guides the design of heat exchanger networks (HEN) to recover waste heat and reduce utility consumption (steam, cooling water, fuel, etc.).",

    "Developed in the 1970s, pinch analysis is now widely applied in refineries, chemical plants, food processing, and energy-intensive industries for improving energy use, reducing emissions, and lowering operating costs.",

    "This course introduces the principles and practical applications of Pinch Technology — a powerful method for optimizing energy use in process industries. Participants will learn how to identify energy-saving opportunities, set energy targets, design heat exchanger networks, and evaluate capital-energy trade-offs. The course covers both theoretical fundamentals and practical tools for implementation, including exergy analysis and total site integration, supported by real-world case studies."
],
  image: "https://i.ibb.co/8D9SKkNq/pinch-technology.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of heat transfer and thermodynamics",
    "Familiarity with process design and energy systems",
    "Recommended for process engineers, energy analysts, and plant designers"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the core principles of pinch technology and its importance in energy optimization",
    "Extract relevant data from process flowsheets to apply pinch analysis",
    "Set realistic energy targets for heat recovery and utility usage",
    "Design efficient heat exchanger networks based on pinch principles",
    "Analyze energy systems using exergy for deeper insight into inefficiencies",
    "Balance capital investment with energy savings through trade-off analysis",
    "Apply pinch concepts to improve existing processes and reduce utility costs",
    "Integrate heat pumps and engines for enhanced process efficiency",
    "Expand analysis from unit operations to total site energy management",
    "Interpret and apply insights from real-world case studies to industrial processes"
  ],
  outline: [
    "Module 1: What this chapter contains",
    "Module 2: What is Pinch Technology",
    "Module 3: From Flowsheet to Pinch Data",
    "Module 4: Energy Targets",
    "Module 5: Targeting for Multiple Utilities",
    "Module 6: Exergy Analysis",
    "Module 7: Capital - Energy Trade-offs",
    "Module 8: Process Modifications",
    "Module 9: Placement of Heat Engines and Heat Pumps",
    "Module 10: Heat Exchanger Network Design",
    "Module 11: Data Extraction Principles",
    "Module 12: Total Site Improvement",
    "Module 13: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 67,
  title: "Pipeline Flow Pigging",
  date: "Present",
  description: [
    "Pigging is a process used in pipeline systems to clean, inspect, or separate different products within the line without stopping the flow. It involves inserting a device known as a “pig” into the pipeline, which travels with the fluid flow to perform various functions. Pigging is widely used in oil and gas, petrochemicals, food and beverage, and water treatment industries.",

    "Pigging improves pipeline efficiency, reduces contamination between products, and helps maintain flow by removing build-up, debris, or scale. It is also used for inline inspection, dewatering, and system commissioning or decommissioning.",

    "This course provides a complete understanding of pipeline pigging operations, covering both routine cleaning and advanced inline inspection techniques. Participants will explore the principles of pigging, design considerations, pig trap configuration, pig selection, and operational procedures for various pipeline systems. With detailed insights into new construction pigging and onstream pigging for different fluid types, the course also addresses maintenance and storage of pigging components, supported by real-world case studies."
],
  image: "https://i.ibb.co/BRwFfYm/pipeline-flow-pigging.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of pipeline systems and fluid mechanics",
    "Familiarity with oil, gas, or refined product transportation systems",
    "Ideal for pipeline engineers, integrity specialists, operations personnel, and maintenance teams"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the objectives and benefits of pigging in pipeline systems",
    "Identify and design critical components of piggable pipelines",
    "Operate and maintain pig launching and receiving stations safely",
    "Select the appropriate pig based on pipeline conditions and pigging goals",
    "Apply pigging techniques during pipeline construction and commissioning",
    "Conduct routine onstream pigging for various fluids, including crude oil and gas",
    "Utilize inline inspection tools for pipeline integrity evaluation",
    "Implement maintenance practices for pigs and associated hardware",
    "Interpret data from pigging operations to improve performance and reliability",
    "Analyze real-world case studies to strengthen operational decision-making"
  ],
  outline: [
    "Module 1: Purpose of Pigging",
    "Module 2: Pipeline Design Considerations",
    "Module 3: Pig Launching and Receiving Traps",
    "Module 4: Selecting the Right Pipeline Pig",
    "Module 5: Pigging New Construction",
    "Module 6: Onstream Pigging of Natural Gas Lines, Natural Gas Liquids and Refined Petroleum Products",
    "Module 7: Onstream Pigging of Crude Oil Lines",
    "Module 8: Inline Inspection Technology",
    "Module 9: Maintenance, Cleaning and Storage of Pigs and Components",
    "Module 10: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 68,
  title: "Post Combustion CO₂ Capture (Hysys Software)",
  date: "Present",
  description: [
    "This course offers a comprehensive exploration of post-combustion carbon dioxide (CO₂) capture technologies, focusing on the MEA-based absorption method and its implementation using Aspen HYSYS simulation software. Participants will gain a strong understanding of the thermodynamics, process flow, equipment design, and simulation practices related to CO₂ capture from flue gases. Economic evaluation and future considerations of Carbon Capture and Storage (CCS) systems are also discussed. This course integrates theoretical concepts with hands-on process simulation and real-life case studies to prepare participants for industry-relevant CCS applications."
    ],
  image: "https://i.ibb.co/zTsL7NjX/Post-Combustion-CO-Capture-Hysys-Software.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "A background in chemical/process engineering",
    "Basic knowledge of thermodynamics and mass transfer",
    "Prior exposure to Aspen HYSYS (basic level)"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Explain the principles and importance of post-combustion CO₂ capture within a CCS framework",
    "Understand and simulate the MEA-based CO₂ absorption-regeneration process in HYSYS",
    "Input and interpret real-world flue gas data for accurate simulation modeling",
    "Develop and troubleshoot process simulation models for CO₂ capture using HYSYS",
    "Evaluate the economic feasibility of CO₂ capture systems, considering energy usage and solvent recycling",
    "Identify trends, future directions, and policy implications related to CCS technologies",
    "Apply learned concepts to real case scenarios for practical insight into deployment and optimization"
  ],
  outline: [
    "Module 1: Introduction & CCS System Overview",
    "Module 2: Overview of MEA-CO₂ Capture Process",
    "Module 3: Flue Gas Process Specifications for Simulation Models",
    "Module 4: Process Simulation Models Development",
    "Module 5: Economics of CO₂ Capture System",
    "Module 6: CCS Future Outlook & Conclusion",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 69,
  title: "Pressure Vessel Design, Shell, Head, Nozzle and Basic Flange",
  date: "Present",
  description: [
    "This course provides an in-depth understanding of the design principles and code requirements for pressure vessels, focusing on the shell, head, nozzle, and basic flange design. Using the ASME Boiler and Pressure Vessel Code (BPVC) Section VIII, Division 1, participants will learn how to interpret and apply design rules to ensure safe and efficient vessel design. The course combines theoretical foundations with practical insights and case studies to equip engineers and inspectors with the skills needed for pressure vessel design and evaluation.",
    "A pressure vessel is a closed container designed to hold gases or liquids at a pressure significantly different (usually higher) from the surrounding atmosphere. Pressure vessels are critical in many industries such as Oil & Gas, Chemical Processing, Power Generation, Pharmaceuticals, Food and Beverage because they operate under pressure, even small failures can be catastrophic — that’s why design is highly regulated and must follow standards like ASME Section VIII, PED, etc."
],
  image: "https://i.ibb.co/YT2kNVt0/Pressure-Vessel-Design-Shell-Head-Nozzle-and-Basic-Flange.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "A basic understanding of mechanical or process engineering",
    "Familiarity with industrial equipment such as vessels, tanks, or piping systems",
    "Knowledge of engineering materials and stress analysis"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Understand the structure and application of ASME BPVC Section VIII Div. 1 for pressure vessel design",
    "Identify design conditions and select suitable materials based on operating parameters",
    "Apply joint efficiency principles and calculate minimum wall thickness for shells and heads",
    "Design common vessel components, including cylindrical shells, heads, nozzles, and conical transitions",
    "Analyze and implement code requirements for nozzle reinforcement",
    "Evaluate the impact of design codes on manufacturing and inspection processes",
    "Ensure pressure vessel integrity through compliance with recognized industry standards",
    "Interpret technical design problems using real-world case studies for practical application"
  ],
  outline: [
    "Module 1: Design Codes",
    "Module 2: ASME BPVC – Boiler and Pressure Vessel Code",
    "Module 3: ASME BPVC Section VIII, Div.1",
    "Module 4: Design Conditions",
    "Module 5: Material Selection",
    "Module 6: Joint Efficiency",
    "Module 7: Design of Parts under Internal Pressure",
    "Module 8: Conical Transitions under Internal Pressure",
    "Module 9: Nozzle",
    "Module 10: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 70,
  title: "Introduction to Process Control for Chemical Engineers",
  date: "Present",
  description: [
    "Process control is the science of keeping industrial processes running within desired conditions. It’s essential for safety, efficiency, quality, and productivity in any process industry like oil and gas, food processing, power plants, or chemical manufacturing.",
    "This course provides a solid foundation in process control principles, focusing on the essential components and functions that keep industrial processes stable, safe, and efficient. Learners will gain an understanding of how sensors, transmitters, controllers, and final control elements interact within feedback control loops. The course explores different control modes and system responses, equipping participants with the ability to interpret control loop behavior and apply best practices in monitoring and troubleshooting. It is designed for engineers, technicians, and technical personnel working in process industries."
],
  image: require("./coursesImg/Introduction to Process Control for Chemical Engineers.png"),
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "A basic understanding of industrial processes or plant operations",
    "Familiarity with general instrumentation concepts is helpful but not mandatory",
    "An Engineering, technical, or operator-level background in manufacturing or process industries"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Understand the fundamental purpose and components of process control systems",
    "Differentiate between open-loop and closed-loop control strategies",
    "Identify key components in a feedback control loop and explain their roles",
    "Select appropriate sensors and transmitters for different process applications",
    "Understand signal transmission methods and how they affect control accuracy",
    "Explain the function and tuning of controllers, particularly PID controllers",
    "Describe the role and types of final control elements in a process loop",
    "Analyze different control loop modes and their use in specific process conditions",
    "Apply theoretical knowledge to real-life problems using case studies",
    "Recognize the impact of control strategy on process safety, quality, and efficiency"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Control Concepts",
    "Module 3: Feedback Control Loops",
    "Module 4: Sensors",
    "Module 5: Signal Transmitters",
    "Module 6: Controllers",
    "Module 7: Final Control Elements",
    "Module 8: Control Loops Mode",
    "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $90",
  certification: "Certificate of Completion"
},

{
  id: 71,
  title: "PROCESS CONTROL FOR OPERATORS",
  date: "Present",
  description: [
    "Process control is all about keeping industrial processes running smoothly, safely, and efficiently. As an operator, you play a key role in monitoring and adjusting the process to maintain optimal performance.",
    "This course introduces plant operators and technical personnel to the fundamentals of process control systems used in industrial operations. It explains the principles, measurements, and control techniques necessary for maintaining stable, efficient, and safe operations. Topics include measurement of temperature, pressure, level, and flow, as well as analytical parameters and control system components like actuators and controllers. The course bridges theory and practice, empowering operators to understand and interact effectively with control systems in real-time environments. Case studies help contextualize learning with real-world examples. "

  ],
  image: "https://i.ibb.co/PzWFgSMZ/process-control-for-operators.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "7 Days",
  prerequisite: [
    "Basic knowledge of industrial processes",
    "A general understanding of plant equipment and operations",
    "Familiarity with standard operating procedures (SOPs) in industrial facilities"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Define process control and its impact on safety, product quality, and efficiency",
    "Recognize how control systems affect day-to-day operations",
    "Understand the principles behind temperature, pressure, level, and flow measurement",
    "Identify the appropriate instruments used for each measurement",
    "Learn about key chemical and physical parameters monitored in a process",
    "Recognize the importance of on-line analyzers and sensors",
    "Identify the roles of sensors, controllers, actuators, and final control elements",
    "Understand how these components work together in a feedback system",
    "Understand proportional, integral, and derivative (PID) control",
    "Explore different controller types and their practical uses",
    "Learn the basics of cascade, feedforward, and ratio control",
    "Recognize the challenges of interacting control loops in complex systems",
    "Understand lag, dead time, and process dynamics",
    "Anticipate process behavior and adjust control actions accordingly",
    "Monitor trends, alarms, and setpoints",
    "Make informed decisions to adjust or troubleshoot control elements",
    "Study real case examples of process instability, equipment response, or control failure",
    "Learn corrective and preventive strategies"
  ],
  outline: [
    "Module 1: Introduction to Process control",
    "Module 2: Temperature Measurement and control",
    "Module 3: Pressure Measurement",
    "Module 4: Level Measurement",
    "Module 5: Flow Measurement",
    "Module 6: Analytical Measurement",
    "Module 7: Final Control Elements",
    "Module 8: Process Characteristics",
    "Module 9: Types of Process Controllers",
    "Module 10: Multi-Loop Controllers",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦350,000 / $300",
  certification: "Certificate of Completion"
},

{
  id: 72,
  title: "Process Engineering (Introduction)",
  date: "Present",
  description: [
    "Process Engineering is a branch of engineering that focuses on designing, operating, controlling, and optimizing chemical, physical, and biological processes. It plays a crucial role in industries such as chemicals, oil and gas, pharmaceuticals, food and beverage, water treatment, and many more. At its core, process engineering is about transforming raw materials into valuable products efficiently, safely, and sustainably.",
    "This course provides a comprehensive introduction to Process Engineering, focusing on its role within industrial projects, particularly in the oil & gas sector. It covers the scope of process engineering across project phases from FEED (Front-End Engineering Design) to detailed design and EPC (Engineering, Procurement, and Construction) proposals. Through a structured module sequence, learners will explore essential design documents, calculations, equipment sizing, and simulation tools. The course combines theoretical knowledge with practical applications and real-world case studies to build a strong foundation for aspiring process engineers and related professionals."
],
  image: "https://i.ibb.co/TBsxtR9F/process-engineering-introduction.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of chemical or mechanical engineering principles",
    "Familiarity with physical and chemical processes",
    "Foundational knowledge of thermodynamics and fluid mechanics"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together.",
    "Define the scope and responsibilities of a process engineer",
    "Recognize the relevance of process engineering in industrial projects",
    "Distinguish between FEED, EPC, and detailed design phases",
    "Understand the process engineering deliverables for each stage",
    "Collaborate with other discipline engineers (mechanical, electrical, instrumentation)",
    "Manage technical coordination during different project stages",
    "Develop a robust basis of design document",
    "Select appropriate processes based on project requirements",
    "Utilize process simulation tools to analyze plant behavior",
    "Evaluate flow-related challenges in pipeline systems",
    "Read and create Process Flow Diagrams (PFDs) and Piping & Instrumentation Diagrams (P&IDs)",
    "Analyze Heat & Mass Balance (H&MB) sheets",
    "Perform line sizing, pump hydraulic calculations, and vessel sizing",
    "Design relief systems and flare networks",
    "Evaluate heat exchanger requirements and perform thermal design",
    "Size relief valves accurately",
    "Perform blowdown and depressurization analysis",
    "Review real engineering design challenges and solutions",
    "Reflect on best practices and common pitfalls in process engineering"
  ],
  outline: [
    "Module 1: Introduction to Process Engineering",
    "Module 2: Process Engineering Projects",
    "Module 3: Role of Process Engineer",
    "Module 4: Interface with Other Discipline Engineers",
    "Module 5: Oil & Gas Projects",
    "Module 6: Phases of Project",
    "Module 7: FEED – Process Engineering Scope",
    "Module 8: EPC Proposals – Process Engineering Scope",
    "Module 9: Detailed Design – Process Engineering Scope",
    "Module 10: Basis of Design",
    "Module 11: Process Selection",
    "Module 12: Process Simulation",
    "Module 13: Flow Assurance Evaluation",
    "Module 14: Process Flow Diagram (PFD) and Heat & Mass Balance (H&MB)",
    "Module 15: Piping and Instrumentation Diagram (P&ID)",
    "Module 16: Line Sizing",
    "Module 17: Pump Hydraulics Calculation",
    "Module 18: Vessel Sizing",
    "Module 19: Heat Exchanger Thermal Design",
    "Module 20: Relief Valve Sizing",
    "Module 21: Blowdown and Depressurization Study",
    "Module 22: Flare Design",
    "Module 23: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 73,
  title: "Process Loop Checking",
  date: "Present",
  description: [
    "Process loop checking is the final verification activity conducted before commissioning a control system. It ensures that all instruments, wiring, signals, and control logic from the field device to the control system and back operate correctly as designed. This critical step confirms the integrity and functionality of the entire control loop. The goal is to confirm that each control or monitoring loop—from sensor to controller to final control element—is properly installed, configured, calibrated, and ready for operational use. It reduces the risk of startup delays or process upsets.",
    "This course provides a comprehensive understanding of process loop checking — a critical activity in commissioning and startup phases of industrial automation and control systems. It covers the full loop verification process, from field instrument to control system, ensuring functionality, safety, and readiness for operation. Participants will also learn how to document loop checks, conduct factory acceptance tests, and benchmark system performance, with real-world examples for practical context."
],
  image: "https://i.ibb.co/xtjZCw2R/process-loop-checking.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of instrumentation and control systems",
    "Familiarity with process plant commissioning procedures",
    "Suitable for instrumentation technicians, commissioning engineers, control system engineers, and QA/QC personnel"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the purpose and process of loop checking in automation systems",
    "Identify different types of control and monitoring loops",
    "Conduct proper loop check procedures during FAT and site commissioning",
    "Collaborate effectively across disciplines during loop validation",
    "Use diagnostic tools and documentation to verify signal integrity and system function",
    "Analyze loop performance data and resolve discrepancies",
    "Develop and implement strategies for sustaining loop performance",
    "Maintain loop records for audits, maintenance, and continuous improvement",
    "Follow safety and QA/QC protocols during testing and operation",
    "Apply insights from case studies to improve reliability and commissioning success"
  ],
  outline: [
    "Module 1: Introduction to Loop Checking",
    "Module 2: The Factory Acceptance Test",
    "Module 3: Start-Up",
    "Module 4: Performance Benchmarking",
    "Module 5: Sustaining the Performance",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 74,
  title: "Process Safety Incident Case Studies",
  date: "Present",
  description: [
    "Studying real-world process safety incidents helps engineers and operators understand the root causes of failures and implement better safety systems. These case studies highlight the importance of proper design, hazard identification, operational discipline, and compliance with safety regulations. Most major incidents are preventable and often result from a combination of human error, design flaws, poor maintenance, or inadequate procedures.",
    "This course offers an in-depth examination of major industrial incidents across various sectors, focusing on process safety failures and lessons learned. Through real-world case studies from chemical plants, refineries, and manufacturing facilities, participants will explore root causes, contributing factors, and corrective actions. The course emphasizes proactive risk identification, safety management system improvement, and incident prevention strategies."
],
  image: "https://i.ibb.co/Hv3PZDF/process-safety-incident-case-studies.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "hazop hazid",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of process safety and industrial operations",
    "Familiarity with hazard identification and risk management principles",
    "Suitable for safety professionals, process engineers, operations personnel, and compliance managers"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the critical role of incident analysis in improving process safety",
    "Identify common root causes across various industrial accidents",
    "Evaluate deficiencies in safety management systems and controls",
    "Analyze the consequences of poor maintenance, communication, and emergency planning",
    "Apply lessons learned to prevent similar failures in their own operations",
    "Improve the implementation of hazard reviews, MOC, and inspection systems",
    "Enhance process safety culture through real-world examples",
    "Develop a systematic approach to reviewing and documenting incidents",
    "Promote cross-functional learning from high-impact failures",
    "Recommend corrective and preventive measures aligned with industry best practices"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Valero Meraux Refinery",
    "Module 3: LACC",
    "Module 4: Wacker Polysilicon",
    "Module 5: Formosa Plastics Corporation",
    "Module 6: Lubrizol Chemtool",
    "Module 7: ConocoPhillips",
    "Module 8: Rubicon",
    "Module 9: Home Market Foods",
    "Module 10: Suncor Energy",
    "Module 11: Tyson Foods",
    "Module 12: Dow St. Charles Operations",
    "Module 13: Phillips 66 Refinery",
    "Module 14: Georgia-Pacific",
    "Module 15: CITGO Petroleum Refinery",
    "Module 16: Kinder Morgan Gas Plant",
    "Module 17: Kinder Morgan Crude Oil Production Facility",
    "Module 18: Georgia-Pacific",
    "Module 19: Pemex Refinery",
    "Module 20: ConocoPhillips",
    "Module 21: Georgia-Pacific",
    "Module 22: Pemex Refinery",
    "Module 23: Domtar Paper Mill",
    "Module 24: Flint Hills Resources Refinery",
    "Module 25: Polycarbon Industries",
    "Module 26: Darling Ingredients",
    "Module 27: BASF TOTALEnergies",
    "Module 28: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦180,000 / $150",
  certification: "Certificate of Completion"
},

{
  id: 75,
  title: "Process Safety Management",
  date: "Present",
  description: [
    "Process Safety Management (PSM) is a systematic framework used to prevent the unintended release of hazardous chemicals, especially in industries dealing with high-risk processes such as oil & gas, chemical manufacturing, and petrochemicals. PSM focuses on managing the integrity of operating systems and processes handling dangerous substances through disciplined design, operation, and maintenance practices. ",
    "This course introduces the fundamental concepts and practical applications of Process Safety Management (PSM) for managing hazardous processes in industrial settings. It focuses on risk identification, hazard control, and fire/explosion prevention. By combining theoretical foundations with real-world examples, the course equips participants with tools to implement and sustain effective PSM systems in compliance with regulatory standards and best practices."
],
  image: require("./coursesImg/process safety management.png"),
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "hazop hazid",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of industrial processes and safety principles",
    "Familiarity with risk assessment and hazard identification techniques",
    "Suitable for safety engineers, operations managers, maintenance personnel, and regulatory compliance professionals"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the core principles of Process Safety Management and its importance",
    "Identify and evaluate process hazards and associated risks",
    "Implement control measures to manage risks effectively",
    "Apply industry standards and regulatory requirements for PSM",
    "Integrate process safety into design, operations, and maintenance activities",
    "Distinguish between fire and explosion hazards and apply protective measures",
    "Promote a safety culture through leadership, training, and accountability",
    "Analyze process incidents and apply findings to improve safety systems",
    "Use real-world case studies to inform better decision-making and risk management strategies",
    "Support ongoing improvement of PSM systems through audits and performance monitoring"
  ],
  outline: [
    "Module 1: Foreword",
    "Module 2: Management of process risk",
    "Module 3: Process safety hazard control",
    "Module 4: Fire and explosion protection",
    "Module 5: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 76,
  title: "Process Safety Management for Petroleum Refineries",
  date: "Present",
  description: [
    "Process Safety Management (PSM) is a disciplined framework for managing the integrity of operating systems and processes handling hazardous substances in petroleum refineries. Its primary goal is to prevent incidents such as fires, explosions, toxic releases, and environmental harm by systematically identifying, evaluating, and controlling process hazards.",
    "This course provides a practical and structured understanding of Process Safety Management (PSM) tailored specifically for petroleum refinery operations. Emphasizing both regulatory compliance and operational excellence, the course explores key elements such as process safety information, hazard analysis, operating procedures, mechanical integrity, and management of change. Learners will also examine the role of PSM in preventing catastrophic incidents through proactive system design and effective risk management. Case studies from real refinery operations will reinforce theoretical knowledge with real-world context."
],
  image: "https://i.ibb.co/L3nkdcT/Process-Safety-Management-for-Petroleum-Refineries.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "hazop hazid",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of chemical or process engineering concepts",
    "Familiarity with refinery operations or industrial plant systems",
    "Awareness of occupational health and safety practices"
  ],
  methodology: "Theoretical",
  objectives: [
    "Define the purpose and core elements of Process Safety Management",
    "Identify and evaluate hazards in petroleum refinery operations",
    "Interpret and utilize essential process safety documentation",
    "Develop and review effective operating procedures",
    "Apply mechanical integrity and management of change principles",
    "Understand regulatory standards relevant to PSM in the refinery sector",
    "Analyze case studies to reinforce best practices and lessons learned"
  ],
  outline: [
    "Module 1: Purpose",
    "Module 2: Process Safety Information",
    "Module 3: Process Hazards Analysis",
    "Module 4: Operating Procedures",
    "Module 5: Mechanical Integrity",
    "Module 6: Management of Change",
    "Module 7: Related Standards",
    "Module 8: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 77,
  title: "Project Control Deliverables",
  date: "Present",
  description: [
    "Project Control Deliverables are the critical outputs produced by the project controls team to plan, monitor, and manage project performance effectively. These deliverables ensure that the project is completed on time, within budget, and according to the required quality standards.",
    "In engineering and construction projects, especially in complex sectors like oil & gas, energy, and infrastructure, project controls serve as the backbone of project management. They provide the necessary tools and information for decision-making across all project phases — from feasibility studies to project close-out. These deliverables typically include a mix of planning documents, cost reports, progress tracking tools, risk assessments, and forecasting models, all of which enable proactive management and control of the project lifecycle.",
    "This course provides a comprehensive guide to the key documents, registers, procedures, and analytical tools required for effective project control in engineering and construction projects. Participants will gain practical knowledge of planning, scheduling, cost control, progress monitoring, and reporting systems that support project execution from initiation through completion. Emphasis is placed on aligning deliverables with best practices, ensuring timely execution, budget management, and risk mitigation. "
],
  image: "https://i.ibb.co/jPkpYSzr/project-control-deliverables.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of project management principles",
    "Familiarity with scheduling and cost estimation concepts",
    "Prior exposure to engineering or construction projects"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the structure and function of key project control deliverables",
    "Develop and interpret baseline and detailed schedules for all project phases",
    "Utilize registers such as EDDR, PSR, SSR, and MDR for tracking project progress",
    "Apply progress measurement techniques including S-curves and earned value methods",
    "Generate manpower and equipment deployment plans aligned with execution schedules",
    "Prepare, analyze, and report on project performance through structured procedures",
    "Conduct schedule risk analysis and develop appropriate recovery strategies",
    "Integrate cost estimating, invoicing, and forecasting into the project control framework",
    "Prepare and review standard project reports including progress, variation, and cost reports",
    "Understand and apply best practices through analysis of real-world case studies"
  ],
  outline: [
    "Module 1: Baseline Schedule",
    "Module 2: Detailed Schedules/Networks",
    "Module 3: Engineering Document Deliverables Register (EDDR)",
    "Module 4: Procurement Services Register (PSR)",
    "Module 5: Subcontracting Services Register (SSR)",
    "Module 6: Manufacturing & Delivery Register (MDR)",
    "Module 7: Detailed Construction Schedules",
    "Module 8: Detailed Shutdown/Tie-in Schedules",
    "Module 9: Planning & Scheduling Procedure",
    "Module 10: Detailed Pre-Commissioning/Commissioning Schedules",
    "Module 11: Progress S Curves",
    "Module 12: Manpower Deployment Schedules & Histograms",
    "Module 13: Equipment Deployment Schedules",
    "Module 14: Progress Measurement Procedure",
    "Module 15: Progress Reporting Procedure",
    "Module 16: Progress Review and Certification Procedure",
    "Module 17: Schedule Risk Analysis Procedure and Report",
    "Module 18: Recovery Plans",
    "Module 19: Weekly/Monthly Progress Reports and Other Exception Reports",
    "Module 20: Weekly Quantity-Based Construction Reports",
    "Module 21: Change Order and Variation Reports",
    "Module 22: Cost Estimating Procedure",
    "Module 23: Code of Accounts",
    "Module 24: Asset Register Procedure and Asset Register",
    "Module 25: Monthly Cost Reports",
    "Module 26: Invoicing Procedure and Invoices",
    "Module 27: Invoices Status Report",
    "Module 28: Cash Flow Forecasts",
    "Module 29: Project Execution Plan (PEP)",
    "Module 30: Contract Execution Plan (CEP)",
    "Module 31: Construction Manpower Deployment Schedule",
    "Module 32: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦250,000 / $230",
  certification: "Certificate of Completion"
},

{
  id: 78,
  title: "Project Execution Plan",
  date: "Present",
  description: [
    "The purpose of this Project Execution Plan (PEP) is to define the strategy, scope, and approach for successfully executing the project. It serves as the roadmap for all project phases from initiation and design to implementation and close-out ensuring alignment across all stakeholders, efficient resource utilization, and adherence to safety, quality, and schedule commitments. The PEP outlines how the project will be managed and delivered, providing clarity on roles, responsibilities, procedures, milestones, and deliverables.",
    "This course offers a comprehensive guide to developing and implementing a Project Execution Plan (PEP), a foundational document that outlines how a project will be delivered safely, efficiently, and within budget and schedule constraints. Through detailed modules, learners will understand how to structure a PEP to align with organizational goals and stakeholder expectations. The course integrates key topics such as project governance, risk management, stakeholder engagement, procurement, quality assurance, operations readiness, and technology deployment. Case studies will provide practical insights into how effective PEPs lead to project success. "
],
  image: "https://i.ibb.co/hJSXcfNt/project-execution-plan.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "project management",
  duration: "4 Days",
  prerequisite: [
    "A foundational understanding of project management principles",
    "Some exposure to engineering, construction, or operations projects",
    "Familiarity with project lifecycle stages (concept, FEED, execution, close-out)"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify major boiler components and how they function together",
    "Define the purpose, scope, and structure of a Project Execution Plan (PEP)",
    "Identify and describe the key elements required to develop a robust PEP",
    "Understand the governance and assurance processes that underpin successful project delivery",
    "Analyze project risks and describe how risk mitigation is integrated into the PEP",
    "Develop stakeholder and interface management strategies for large or complex projects",
    "Interpret how HSSE, quality, and regulatory requirements are embedded within project execution",
    "Coordinate engineering, procurement, and construction strategies within the PEP framework",
    "Apply information management techniques to enhance communication and data flow throughout a project",
    "Plan for operations readiness and long-term asset performance from the early stages of a project",
    "Examine real-world case studies to evaluate how well-crafted PEPs drive successful project outcomes"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Project Background",
    "Module 3: Premises",
    "Module 4: Development Concept & Scope",
    "Module 5: Governance",
    "Module 6: Project Assurance",
    "Module 7: Forms of Agreement",
    "Module 8: Financing & Insurance",
    "Module 9: Risk Management",
    "Module 10: Permits & Approvals",
    "Module 11: HSSE & Social Performance",
    "Module 12: Project Organization",
    "Module 13: Stakeholder Engagement",
    "Module 14: Interface Management",
    "Module 15: Project Controls",
    "Module 16: Quality Management",
    "Module 17: Technology",
    "Module 18: Engineering",
    "Module 19: Contracting & Procurement",
    "Module 20: Construction",
    "Module 21: Information Management & Technology",
    "Module 22: Subsurface",
    "Module 23: Operations Readiness",
    "Module 24: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦250,000 / $200",
  certification: "Certificate of Completion"
},

{
  id: 79,
  title: "Quality Control Plan of Construction Project",
  date: "Present",
  description: [
    "A Quality Control Plan (QCP) is an essential document that outlines the procedures, standards, responsibilities, and methods for ensuring that construction activities meet project specifications, codes, and client expectations. In construction projects, maintaining high quality is critical not only for safety and regulatory compliance but also for the longevity and performance of the finished structure. The QCP provides a systematic approach to control and verify the quality of materials, workmanship, and processes throughout the construction lifecycle.",
    "This course equips participants with the knowledge and practical tools to develop and implement an effective Quality Control Plan (QCP) for construction projects. It focuses on maintaining high standards of workmanship, complying with contract specifications, and managing documentation throughout the construction lifecycle. Participants will explore quality procedures, team responsibilities, handling of submittals and materials, and managing revisions to work through real-world case studies."
],
  image: "https://i.ibb.co/Gfp8wXwL/Quality-Control-Plan-of-Construction-Project.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "project management",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of construction project management",
    "Familiarity with site operations and contract documentation",
    "Suitable for engineers, site supervisors, QA/QC inspectors, and construction managers"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental principles and importance of a Quality Control Plan (QCP) in construction projects",
    "Identify the key elements and structure of a comprehensive QCP",
    "Examine the roles and responsibilities within the project organization for quality assurance",
    "Develop effective procedures for monitoring, verifying, and documenting construction quality",
    "Analyze the submittal process and manage material compliance efficiently",
    "Evaluate the impact of revisions and changes on project quality control",
    "Apply best practices for inspection, testing, and corrective action processes",
    "Learn from real-world case studies to improve the implementation and effectiveness of QCPs"

  ],
  outline: [
    "Module 1: Background Information of The Project",
    "Module 2: Quality Control Plan (QCP)",
    "Module 3: Project Organization",
    "Module 4: Quality Control Procedures",
    "Module 5: Submittals and Materials",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  
  certification: "Certificate of Completion"
},

{
  id: 80,
  title: "Relief Valve Sizing (Aspen HYSYS)",
  date: "Present",
  description: [
    "Relief valves (also known as pressure safety valves, PSVs) are critical safety devices in process plants. They protect equipment and pipelines from overpressure by safely venting excess pressure to flare systems or the atmosphere, preventing equipment failure or catastrophic accidents.",
    "Relief Valve Sizing is a precise engineering task. It involves calculating the required discharge area of the valve to ensure it can relieve excess pressure quickly and safely during different overpressure scenarios. Aspen HYSYS, a powerful process simulation software, provides tools to simulate process conditions and accurately size relief valves based on recognized engineering standards (e.g., API 520, API 521, ASME). Using Aspen HYSYS allows process engineers to model the worst-case scenarios, predict relief loads, and determine appropriate valve sizes efficiently and accurately.",
    "This course provides a comprehensive guide to relief valve sizing using Aspen HYSYS. Participants will learn to estimate relief loads, size relief valves and their associated piping, and develop proper datasheets for documentation. The course also covers integration with Aspen Flare System Analyzer for a complete safety system analysis. Through practical simulations and case studies, learners gain hands-on experience in ensuring the safe and compliant design of pressure relief systems in process plants."
],
  image: "https://i.ibb.co/W4HJjssp/Relief-valve-sizing-aspen-hysys.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of process safety and pressure systems",
    "Familiarity with fluid dynamics and thermodynamic principles",
    "Prior experience or exposure to Aspen HYSYS is recommended"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role and importance of pressure relief systems in process safety",
    "Identify different types of relief scenarios and determine appropriate relief loads",
    "Use Aspen HYSYS to calculate and size relief valves for various fluid conditions",
    "Properly size inlet and outlet piping to comply with API 520 and 521 standards",
    "Generate and interpret detailed relief valve datasheets",
    "Confidently transfer data from Aspen HYSYS to Aspen Flare System Analyzer",
    "Evaluate real-life industrial case studies to reinforce sizing practice",
    "Avoid common pitfalls and ensure safety and compliance in valve sizing",
    "Integrate relief valve design with the overall process safety management strategy",
    "Communicate effectively with safety teams and vendors regarding relief system specifications"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Relief load estimation",
    "Module 3: Relief valve sizing",
    "Module 4: Relief valve inlet and outlet line sizing",
    "Module 5: Relief valve datasheets",
    "Module 6: Transfer data to Aspen Flare System Analyzer",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 81,
  title: "Risk-Based Inspection",
  date: "Present",
  description: [
    "Risk-Based Inspection (RBI) is a proactive and systematic approach to inspection planning, aimed at optimizing inspection resources by focusing efforts on equipment that poses the highest risk.",
    "The methodology is guided by API Recommended Practice 580, which provides a framework for identifying, assessing, and managing risks associated with fixed equipment and piping in the refining, petrochemical, and process industries. Unlike traditional time-based inspections, RBI evaluates both the probability and consequence of failure to prioritize inspection activities. This ensures that high-risk equipment is inspected more frequently, while low-risk items are monitored at optimized intervals — improving plant safety, reliability, and cost-effectiveness.",
    "This course introduces participants to the principles and methodology of Risk-Based Inspection (RBI) as outlined in API Recommended Practice 580. It focuses on identifying, assessing, and managing risk through inspection planning and execution. Participants will gain the technical understanding needed to implement RBI in an industrial setting, especially within petrochemical and refinery operations, thereby ensuring asset integrity while optimizing inspection resources and reducing operational risks."
],
  image: "https://i.ibb.co/mC5VYn3d/risk-based-inspection-api-580.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of chemical or mechanical engineering principles",
    "Familiarity with physical and chemical processes",
    "Foundational knowledge of thermodynamics and fluid mechanics"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental principles of Risk-Based Inspection as per API 580",
    "Identify and analyze potential deterioration mechanisms and failure modes",
    "Collect and organize the necessary data to support an RBI program",
    "Assess the likelihood and consequences of failure for process equipment",
    "Evaluate overall risk and prioritize equipment for inspection",
    "Develop an inspection plan based on risk ranking and operational context",
    "Recommend additional mitigation actions beyond inspection",
    "Document RBI assessments and ensure traceability of decisions",
    "Recognize the importance of team roles, qualifications, and ongoing training",
    "Apply the RBI methodology to practical case studies and real-life scenarios"
  ],
  outline: [
    "Module 1: Purpose and Scope",
    "Module 2: References",
    "Module 3: Definitions and Acronyms",
    "Module 4: Basic Concepts",
    "Module 5: Introduction to Risk-Based Inspection",
    "Module 6: Screening and Boundary Identification",
    "Module 7: Data and Information Collection for RBI Assessment",
    "Module 8: Identifying Deterioration Mechanisms and Failure Modes",
    "Module 9: Assessing Likelihood of Failure",
    "Module 10: Assessing Consequences of Failure",
    "Module 11: Assessing Risk",
    "Module 12: Risk Management with Inspection Activities",
    "Module 13: Other Risk Mitigation Activities",
    "Module 14: Reassessment and Updating RBI Assessments",
    "Module 15: Roles, Responsibilities, Training and Qualifications",
    "Module 16: RBI Documentation and Record Keeping",
    "Module 17: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 82,
  title: "Well Testing",
  date: "Present",
  description: [
    "Well testing is a critical process in the oil and gas industry used to evaluate the performance and characteristics of a well. It involves the controlled flow of reservoir fluids (oil, gas, water) to the surface so that engineers can analyze production potential, reservoir properties, and overall well behavior.",
    "The data gathered from well testing helps determine reservoir capacity, fluid properties, pressure behavior, and production optimization strategies. It is an essential step during well commissioning, reservoir evaluation, and even during the life of a well for performance monitoring. Well testing provides insights for decision-making on field development, enhanced recovery methods, well interventions, and economic viability of the reservoir.",
    "This course provides a comprehensive introduction to well testing in oil and gas operations, covering both theoretical foundations and practical applications. It is designed to equip engineers and field professionals with the knowledge and tools to plan, execute, and interpret well tests effectively. The course explores the types of tests used to evaluate reservoir characteristics, production potential, and flow behavior, emphasizing surface and downhole equipment and data analysis methods."
],
  image: "https://i.ibb.co/8L9Sk71w/well-testing-36c825136b6b16850511.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of petroleum engineering principles",
    "Familiarity with drilling and production operations",
    "Ideal for reservoir engineers, production engineers, field operators, and geoscientists"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental purpose and benefits of well testing",
    "Identify various types of well tests and their appropriate applications",
    "Plan and execute well tests safely and efficiently",
    "Select and operate the required surface and downhole test equipment",
    "Acquire and validate high-quality test data in the field",
    "Analyze well test data to determine key reservoir parameters",
    "Interpret pressure and rate responses to assess well performance",
    "Apply industry-standard tools and techniques for test interpretation",
    "Understand how well testing supports reservoir modeling and development planning",
    "Evaluate real-world case studies to improve testing strategies"
  ],
  outline: [
    "Module 1: What is Well Testing",
    "Module 2: Practical Well Testing",
    "Module 3: Information Obtained from Well Testing",
    "Module 4: Types of Well Tests",
    "Module 5: Surface and Down Hole Equipment",
    "Module 6: Well Test Interpretation",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 83,
  title: "Well Logging (Part-1: Open Hole Logging)",
  date: "Present",
  description: [
    "Open hole logging is the process of recording physical, chemical, and structural properties of the subsurface formations in a wellbore before casing or completion. It involves lowering measurement tools into an uncased (open) borehole to gather continuous data, which helps characterize the reservoir and guide drilling, completion, and production decisions. ",
    "This course offers a thorough introduction to open hole well logging, a critical technique for evaluating subsurface formations during drilling operations. The curriculum covers conventional logging tools, advanced interpretation methods, procedural workflows at the wellsite, and the application of high-tech logs, especially in horizontal wells. Through detailed modules and real-world case studies, participants will gain the skills to interpret log data and make informed reservoir decisions."
],
  image: "https://i.ibb.co/1tjbxMrt/Well-Logging-Part-1-Open-Hole-Logging-144186eb90cfd1915b1d.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of petroleum geology and drilling operations",
    "Familiarity with reservoir engineering principles is helpful",
    "Ideal for logging engineers, geologists, drilling engineers, and subsurface analysts"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the purpose and scope of open hole well logging",
    "Identify and explain various types of conventional logging tools",
    "Interpret logs for lithology, porosity, and fluid saturation",
    "Execute logging operations safely and efficiently at the wellsite",
    "Evaluate the benefits of high-tech logging tools for detailed formation analysis",
    "Understand specific logging challenges in horizontal and deviated wells",
    "Differentiate between wireline and LWD logging methods",
    "Apply best practices in data quality control and depth correlation",
    "Integrate log data with core, test, and seismic information",
    "Use case studies to enhance interpretation accuracy and operational performance"
  ],
  outline: [
    "Module 1: Introduction to Conventional Open Hole Logging",
    "Module 2: Type of Conventional Open Hole Logging",
    "Module 3: Log Interpretation for Conventional Open Hole Logging",
    "Module 4: Logging Procedure in Well Site",
    "Module 5: High Technology Log",
    "Module 6: Well Logging in Horizontal Wells",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},


{
  id: 84,
  title: "Well Logging (Part-2: Cased Hole Logging)",
  date: "Present",
  description: [
    "Cased hole logging refers to logging operations conducted after the well has been completed and the casing has been installed and cemented in place. These logs provide valuable data for reservoir monitoring, production evaluation, well integrity assessment, and secondary recovery planning. Unlike open hole logging, cased hole logging tools are specifically designed to measure through steel casing and cement. ",
    "This course introduces the principles, tools, and applications of cased hole logging, a crucial method used to evaluate well integrity, production performance, and reservoir characteristics after casing has been installed. Participants will explore a wide range of cased hole tools including cement evaluation logs, casing inspection logs, and production logging tools. The course also covers advanced acoustic and nuclear tools and provides practical insights through case studies."
],
  image: "https://i.ibb.co/4RT7b4p2/Well-Logging-Part-2-Cased-Hole-Logging-214c3c7c0d07e9afde20.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of petroleum geology and drilling operations",
    "Familiarity with reservoir engineering principles is helpful",
    "Ideal for logging engineers, geologists, drilling engineers, and subsurface analysts"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the role of cased hole logging in well evaluation and diagnostics",
    "Select appropriate cement evaluation tools based on well conditions",
    "Interpret casing inspection logs to assess mechanical integrity",
    "Use spectral noise and production logging tools to locate flow anomalies",
    "Apply saturation logs to monitor reservoir fluid movement and support EOR",
    "Correlate cased hole log results with completion and production history",
    "Conduct effective cased hole log planning and data quality control",
    "Improve well performance and safety through log-based decisions",
    "Integrate multi-log data for comprehensive post-completion analysis",
    "Learn from real-world examples to enhance well intervention strategies"
  ],
  outline: [
    "Module 1: Introduction to Cased Hole Logging",
    "Module 2: Cement Logs (CBL, SBT, URS, RIB, RBT, CAST, USI, SCMT)",
    "Module 3: Casing Inspection Log (MIT, MFC)",
    "Module 4: Spectral Noise Tool (SNL) & Production Logging Tools (PLT)",
    "Module 5: Saturation Log",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 85,
  title: "Well Completion and Stimulation",
  date: "Present",
  description: [
    "Well completion is the process of making a drilled well ready for production (or injection). It involves installing the necessary equipment and systems inside the wellbore to ensure safe and efficient extraction of hydrocarbons. Completion design depends on reservoir characteristics, well type, production goals, and operational constraints. Well stimulation, on the other hand, involves techniques used to enhance well productivity by improving flow paths between the reservoir and the wellbore. Stimulation can be required when natural reservoir drive is insufficient, or when damage has restricted flow capacity.",
    "This course offers a detailed exploration of the techniques, equipment, and decisions involved in completing and stimulating oil and gas wells. It guides participants through each phase of the well completion process — from casing and tubing installation to stimulation methods such as perforating and fracturing. The course emphasizes practical knowledge for optimizing well performance and ensuring safe, efficient production operations."
],
  image: "https://i.ibb.co/DgKDCDTw/Well-Completion-and-Stimulation.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of drilling and reservoir engineering",
    "Familiarity with oil and gas well architecture",
    "Recommended for petroleum engineers, production engineers, well services personnel, and field operators"
  ],
  methodology: "Theoretical",
  objectives: [
    "Explain the fundamental concepts of well completion and stimulation",
    "Identify and describe the steps in the completion process",
    "Evaluate different types of completion systems and their applications",
    "Understand the role of tubing and surface equipment in production control",
    "Select appropriate completion fluids and design for formation compatibility",
    "Apply perforation techniques to achieve efficient reservoir contact",
    "Distinguish between various stimulation techniques and when to apply them",
    "Assess the impact of completion design on flow assurance and well performance",
    "Analyze real-world case studies for practical insights and improvement",
    "Make informed decisions for optimizing well productivity and longevity"
  ],
  outline: [
    "Module 1: What is Well Completion",
    "Module 2: Setting Production Casing",
    "Module 3: Installing the Tubing",
    "Module 4: Installing the Christmas Tree",
    "Module 5: Types of Well Completion",
    "Module 6: Factors Influencing Well Completion Selection",
    "Module 7: Type of Flow",
    "Module 8: Completion and Workover Fluids",
    "Module 9: Perforating",
    "Module 10: Well Stimulation",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 86,
  title: "Water Treatment",
  date: "Present",
  description: [
    "Water treatment is the process of improving the quality of water to make it suitable for a specific end-use, such as drinking, industrial processes, irrigation, or disposal into the environment. The goal is to remove or reduce contaminants and undesirable components from raw water sources — like rivers, lakes, groundwater, or industrial effluents. In both municipal and industrial settings, water treatment plays a vital role in protecting human health, ensuring equipment reliability, and meeting environmental regulations. ",
    "This course provides a comprehensive understanding of water treatment processes across industrial settings, covering the full cycle from raw water intake to wastewater discharge. Participants will explore the technologies, equipment, and chemical treatments involved in ensuring water quality for various plant operations, including cooling towers and boilers. Real-world case studies offer practical insights into system design, operation, and troubleshooting. "
],
  image: "https://i.ibb.co/BKzFC4Q9/water-treatment.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of chemistry and fluid mechanics",
    "Familiarity with industrial plant operations",
    "Ideal for chemical, process, and utility engineers, as well as plant operators and maintenance personnel"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify and classify different types of water sources and contaminants",
    "Describe the objectives and methods used in water pre-treatment",
    "Understand the chemistry and control of cooling tower water treatment",
    "Explain the requirements for effective boiler water conditioning",
    "Evaluate different wastewater treatment techniques and technologies",
    "Interpret water analysis data to troubleshoot common problems",
    "Apply operational best practices to improve treatment system reliability",
    "Ensure compliance with environmental and safety regulations",
    "Develop strategies for cost-effective and sustainable water treatment",
    "Analyze case studies to enhance problem-solving and design skills"
  ],
  outline: [
    "Module 1: Raw Water",
    "Module 2: Pre-treatment",
    "Module 3: Cooling Tower",
    "Module 4: Boiler Water",
    "Module 5: Wastewater Treatment",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 87,
  title: "Waste Heat Recovery",
  date: "Present",
  description: [
    "Waste Heat Recovery (WHR) is the process of capturing and reusing the heat that is generated in industrial processes but typically lost to the environment. This “waste” heat can be found in exhaust gases, cooling water, furnace flue gases, and other heat streams from processing operations.",
    "By recovering this energy, industrial plants can reduce fuel consumption, lower emissions, and improve overall energy efficiency. Waste heat can be reused in various forms — for preheating combustion air, generating steam, or even producing electricity through technologies like ORC (Organic Rankine Cycle) or thermoelectric generators. WHR is a key strategy in achieving sustainable industrial operations and is widely implemented in industries such as cement, steel, glass, petrochemicals, and power generation.",
    "This course explores the principles, technologies, and practices involved in recovering waste heat from industrial processes. Designed for engineers, energy managers, and plant operators, it emphasizes how to identify sources of heat loss and turn them into valuable energy savings. Participants will gain insights into feasibility assessment, technology selection, and implementation of waste heat recovery systems to improve energy efficiency and reduce operational costs."
],
  image: "https://i.ibb.co/vCBsDmNF/waste-heat-recovery.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of thermodynamics and heat transfer",
    "Familiarity with industrial processes and energy systems",
    "Recommended for process engineers, energy consultants, facility managers, and technical staff involved in energy optimization"
  ],
  methodology: "Theoretical",
  objectives: [
    "Define waste heat and its importance in industrial energy efficiency",
    "Identify common sources of waste heat in plant operations",
    "Understand the key factors influencing feasibility of recovery systems",
    "Evaluate and select appropriate waste heat recovery technologies",
    "Analyze energy flows to pinpoint loss points and savings potential",
    "Apply waste heat recovery practices to diverse industrial sectors",
    "Assess real-world case studies for lessons and benchmarking",
    "Explore current research trends and technological advancements",
    "Quantify the economic and environmental benefits of waste heat projects",
    "Develop strategies for implementing and optimizing recovery systems"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Factors Affecting Waste Heat Recovery Feasibility",
    "Module 3: Waste Heat Recovery Options and Technologies",
    "Module 4: Evaluating Selected Applications for Waste Heat Opportunities and Practices",
    "Module 5: Industrial Waste Heat Losses and Research Development, and Demonstration Needs",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 88,
  title: "Steam Tracing Systems for Industrial Plants",
  date: "Present",
  description: [
    "Steam Tracing Systems are essential auxiliary systems in industrial plants, designed to maintain or raise the temperature of process piping, equipment, or instruments by using steam as the heat source. These systems prevent freezing, maintain fluid viscosity, or ensure the continuity of process flow in critical pipelines and vessels, especially in colder environments or when handling temperature-sensitive materials.",
    "Steam tracing involves the installation of small-bore steam lines (tracers) alongside or around process lines. Heat from the steam is transferred by conduction through the pipe wall to the process fluid, preventing solidification or thermal degradation.",
    "In industries such as oil and gas, petrochemicals, refineries, food processing, and pharmaceuticals, steam tracing ensures operational reliability, safety, and process efficiency by mitigating risks associated with low temperatures — such as blockages, ruptures, or compromised product quality.",
    "This course provides a comprehensive guide to the design, operation, and optimization of steam tracing systems in industrial plants. Steam tracing is vital for maintaining temperature, preventing freezing, and ensuring fluidity in piping systems and equipment. Participants will explore the technical principles behind tracing design, understand different heating mediums, and gain practical knowledge in dimensioning, installation, and cost-effective system implementation."
  ],
  image: "https://i.ibb.co/ZphCW5dF/Steam-Tracing-Systems-for-Industrial-Plants.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of thermodynamics and heat transfer",
    "Familiarity with piping systems and process equipment",
    "Understanding of industrial plant utilities"
  ],
  objectives: [
    "Understand the purpose and benefits of steam tracing systems in industrial applications",
    "Identify areas of a plant that require steam heating and tracing",
    "Select appropriate steam pressures based on system requirements",
    "Perform basic calculations for heat loss, steam consumption, and tracer sizing",
    "Dimension both the steam distribution and condensate return systems effectively",
    "Plan and implement efficient layouts for steam tracing installations",
    "Compare steam tracing with alternative methods like electric or thermal fluid tracing",
    "Apply economic and energy-efficient design principles in steam tracing systems",
    "Analyze real-world case studies to extract practical lessons and best practices",
    "Integrate steam tracing into broader plant utility and maintenance strategies"
  ],
  outline: [
    "Module 1: Reason for Using Stream Tracing Systems",
    "Module 2: Explanation on Steam Heating of Various Part of a Plant",
    "Module 3: Selection of Steam Pressure",
    "Module 4: Calculation of the Tracing System",
    "Module 5: Dimensioning of the Steam Distribution System",
    "Module 6: Dimensioning of the Condensate Collecting System",
    "Module 7: Arrangement and Installation of Steam Tracing System",
    "Module 8: Example of Installation for a Steam Tracing System",
    "Module 9: Economic Design of Steam Tracing System",
    "Module 10: High-Pressure Hot Water and Thermal Fluid System",
    "Module 11: Steam or Electric Tracing Systems- a Comparison",
    "Module 12: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 89,
  title: "Turbine",
  date: "Present",
  description: [
    "A turbine is a rotary mechanical device that extracts energy from a fluid flow (liquid, steam, gas, or air) and converts it into mechanical work. This mechanical work is often used to drive generators for electricity production, compressors, or pumps in industrial applications. Turbines are essential components in power generation, aviation, oil & gas, and various process industries. The design and type of turbine used depend on the working fluid, energy input, and application requirements.",
    "This comprehensive course explores the principles, components, and operations of turbines, with a primary focus on steam turbines. It covers essential theoretical concepts, classification systems, design parameters, auxiliary systems, and turbine protection mechanisms. Participants will gain a deep understanding of turbine technology through theoretical discussions and real-world case studies to enhance their practical knowledge and troubleshooting abilities."
  ],
  image: "https://i.ibb.co/5gTCc1VP/turbine.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of thermodynamics and fluid mechanics",
    "Understanding of industrial power systems and process operations",
    "Suitable for mechanical, process, and maintenance engineers, plant operators, and energy professionals"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamentals of turbine operation and energy conversion",
    "Differentiate between impulse and reaction turbine mechanisms",
    "Classify turbines based on pressure, casing type, and application",
    "Analyze the operation of condensing vs non-condensing and reheat vs non-reheat systems",
    "Identify and describe key turbine components and auxiliary systems",
    "Explain the function and importance of turbine protection systems",
    "Interpret turbine instrumentation for performance and condition monitoring",
    "Describe the role of lubrication and sealing systems in reliable turbine operation",
    "Apply theoretical knowledge to analyze operational issues",
    "Learn from real-world case studies to improve troubleshooting and efficiency"
  ],
  outline: [
    "Module 1: Contents",
    "Module 2: Steam turbine",
    "Module 3: Basic turbine theory",
    "Module 4: Impulse and reaction balding",
    "Module 5: Turbine classification",
    "Module 6: Condensing VS non condensing",
    "Module 7: Single pressure VS Multi pressure",
    "Module 8: Reheat VS non reheat",
    "Module 9: Single casing VS compound casing",
    "Module 10: Exhaust flows",
    "Module 11: Inter stage sealing",
    "Module 12: Steam admission components",
    "Module 13: Turbine expansion",
    "Module 14: Turbine bearings",
    "Module 15: Lubrication",
    "Module 16: Turing gear",
    "Module 17: Rupture Diaphragm",
    "Module 18: Turbine Auxiliary systems",
    "Module 19: Lube oil system components",
    "Module 20: Gland Steam system",
    "Module 21: Turbine Electro-Hydraulic Control oil system",
    "Module 22: Turbine Supervisory Instruments",
    "Module 23: LP/PG Turbines",
    "Module 24: Turbine Protections",
    "Module 25: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦200,000 / $180",
  certification: "Certificate of Completion"
},

{
  id: 90,
  title: "Tank Design & Fundamental Operation",
  date: "Present",
  description: [
    "Storage tanks are essential components in various industries such as oil & gas, chemical processing, water treatment, food & beverage, and pharmaceuticals. They are used to store raw materials, intermediates, or final products, and may hold liquids, gases, or slurries under atmospheric or pressurized conditions.",
    "Proper tank design ensures safe operation, efficient storage, and compliance with industry codes (e.g., API 650, API 620, ASME). The design process considers the nature of the stored substance, environmental conditions, pressure/temperature, and operational requirements. The operation of storage tanks includes filling, holding, and emptying the tank, as well as monitoring and maintaining the integrity of the stored contents.",
    "This course provides a detailed foundation in the design, construction, operation, and maintenance of storage tanks used in industrial facilities. Participants will learn about the design codes, material selection, construction practices, operational requirements, and safety considerations critical to efficient tank operation. Through real-world case studies, learners will explore practical challenges and best practices in managing aboveground and underground storage systems."
  ],
  image: "https://i.ibb.co/v6WfdGZ3/Tank-Design-Fundamental-Operation.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of fluid mechanics and mechanical systems",
    "Familiarity with industrial plant processes",
    "Suitable for process, mechanical, and maintenance engineers, operators, and safety personnel"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify the different types and functions of industrial storage tanks",
    "Understand the design principles, standards, and material choices for tank construction",
    "Interpret tank drawings and specifications",
    "Explain the key steps involved in tank construction and quality control",
    "Operate storage tanks safely and efficiently under different process conditions",
    "Implement routine maintenance, inspection, and repair procedures",
    "Recognize potential safety hazards and apply appropriate mitigation techniques",
    "Analyze case studies to enhance practical knowledge and decision-making",
    "Comply with environmental and regulatory standards for tank operations",
    "Recommend design or operational improvements based on performance analysis"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Tank Design",
    "Module 3: Tank Construction",
    "Module 4: Tank Operations",
    "Module 5: Tank Maintenance",
    "Module 6: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 91,
  title: "Shell and Tube Heat Exchanger",
  date: "Present",
  description: [
    "The Shell and Tube Heat Exchanger is one of the most widely used types of heat exchangers in industrial applications, particularly in sectors such as oil & gas, petrochemicals, power generation, food processing, and HVAC systems. It is designed to efficiently transfer heat between two fluids — one flowing through a bundle of tubes and the other flowing over the tubes within an outer shell. The fluids can be either liquids or gases, and they can flow in the same or opposite directions (parallel flow or counterflow), depending on process requirements.",
    "This course offers a detailed exploration of Shell and Tube Heat Exchangers (STHEs), which are widely used in process industries for efficient thermal energy transfer. The course begins with basic concepts and working principles, progressing through TEMA classifications, component identification, stream allocation, thermal design, and operational challenges. It also introduces software tools such as HTRI for practical design and evaluation. By the end, learners will understand both theoretical principles and real-world applications of STHEs."
  ],
  image: "https://i.ibb.co/vCZXfP0W/shell-and-tube-heat-exchanger.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Fundamental knowledge of heat transfer and thermodynamics",
    "Basic understanding of fluid mechanics and process engineering",
    "Exposure to chemical or mechanical engineering principles"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental working principles and classifications of heat exchangers",
    "Identify the components and design standards used in shell and tube heat exchangers",
    "Differentiate between TEMA head and shell types and select appropriate configurations",
    "Allocate process streams correctly for optimal performance and longevity",
    "Recognize and address common operational issues such as fouling and vibration",
    "Apply thermal design principles using LMTD and effectiveness-NTU methods",
    "Interpret software-generated heat exchanger performance data (e.g., HTRI outputs)",
    "Evaluate various heat exchanger types and choose the right one for a specific application",
    "Perform basic thermal rating and sizing tasks for process needs",
    "Draw practical lessons from case studies and industrial use scenarios"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Working Principle/Governing Equation",
    "Module 3: Other Types of Heat Exchangers",
    "Module 4: Applications of Heat Exchangers",
    "Module 5: Different Parts of Heat Exchangers",
    "Module 6: Tema Front / Rear Head Types",
    "Module 7: Tema Shell Types",
    "Module 8: Allocation of Streams",
    "Module 9: Major Practical Problems in Heat Exchangers",
    "Module 10: Thermal Designing & Rating of Heat Exchangers",
    "Module 11: HTRI Output/Results Interpretation",
    "Module 12: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 92,
  title: "Rule of Thumb for Process Engineers",
  date: "Present",
  description: [
    "In the fast-paced and complex world of process engineering, precise calculations and simulations are crucial. However, experienced engineers often rely on Rules of Thumb as quick reference points for preliminary design, feasibility checks, and rapid decision-making during early project stages or troubleshooting.",
    "Rules of Thumb are simplified engineering guidelines derived from practical experience, empirical data, and industry best practices. While not a replacement for detailed engineering analysis, they are invaluable for: Initial equipment sizing, rough cost estimation, Preliminary heat and material balances, Rapid verification of simulation outputs, Field troubleshooting. Process engineers use these shortcuts to make timely, informed decisions — especially when immediate answers are needed, or data is incomplete.",
    "This course provides a practical collection of industry-validated rules of thumb that guide process engineers in day-to-day decision-making and quick estimations. It covers key areas such as separation processes, heat exchange, treating, fluid flow, fractionation, combustion, and more. These heuristics are invaluable for early design phases, troubleshooting, or when detailed data is not yet available. Through detailed modules and real-world case studies, participants will gain practical insight to complement theoretical knowledge and software tools."
  ],
  image: "https://i.ibb.co/g2t4QkZ/rule-of-thumb-for-process-engineers.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "Fundamental knowledge of heat transfer and thermodynamics",
    "Basic understanding of fluid mechanics and process engineering",
    "Exposure to chemical or mechanical engineering principles"
  ],
  methodology: "Theoretical",
  objectives: [
    "Apply common rules of thumb for rapid process evaluations and feasibility checks",
    "Make rough equipment sizing and performance estimates during early design stages",
    "Understand practical boundaries and limitations of heuristic methods",
    "Use thumb rules for separation, fluid flow, and heat transfer processes",
    "Estimate requirements for treating systems such as amine units or gas dehydration",
    "Quickly approximate utility loads and equipment capacities (e.g., pumps, compressors)",
    "Evaluate fractionation and combustion systems using simplified empirical methods",
    "Cross-check simulation results or detailed calculations against known industry heuristics",
    "Recognize when to use thumb rules versus when detailed design is necessary",
    "Analyze real-world case studies where thumb rules have enhanced or limited performance"
  ],
  outline: [
    "Module 1: Separation",
    "Module 2: Heat Transfer Shell & Tube Heat Exchangers",
    "Module 3: Treating",
    "Module 4: Fluid Flow",
    "Module 5: Fractionation",
    "Module 6: Combustion",
    "Module 7: Physical Properties",
    "Module 8: Compressors, Expanders & Pumps",
    "Module 9: Refrigeration",
    "Module 10: Miscellaneous",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦200,000 / $180",
  certification: "Certificate of Completion"
},

{
  id: 93,
  title: "Scaffold Safety",
  date: "Present",
  description: [
    "Scaffold Safety is a critical aspect of workplace safety in industries such as construction, oil & gas, petrochemicals, shipbuilding, and maintenance operations. Scaffolds provide temporary elevated platforms that allow workers to access hard-to-reach areas for construction, maintenance, inspection, or repair activities.",
    "While scaffolds improve accessibility and efficiency, they also introduce significant hazards, including falls from height, scaffold collapse, falling objects, and electrical risks. Therefore, proper design, erection, inspection, and use of scaffolding are essential to protect workers and comply with safety regulations. Effective scaffold safety programs involve planning, competent supervision, worker training, regular inspections, and adherence to safety standards (such as OSHA, EN, or local regulations). Safe practices ensure not only worker protection but also productivity and legal compliance.",
    "This course is designed to equip participants with the essential knowledge and skills to safely use, inspect, and maintain scaffolding systems in industrial and construction environments. The course emphasizes compliance with safety regulations, proper use of personal protective equipment (PPE), and hands-on understanding of scaffold components, inspection procedures, and tagging systems. Real-world case studies are included to reinforce key learning outcomes and promote a safety-first mindset on-site."
  ],
  image: "https://i.ibb.co/PZYJqFWb/scaffold-safety.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of workplace safety principles",
    "Familiarity with construction or industrial work environments",
    "Prior participation in general health and safety induction"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify the main components and types of scaffolding",
    "Demonstrate correct usage and inspection of fall protection equipment",
    "Conduct scaffold pre-use checks using a standardized user checklist",
    "Recognize the importance and implementation of scaffold tagging systems",
    "Apply key safety regulations and general requirements for scaffold use",
    "Understand the process and responsibilities around scaffold erection and dismantling",
    "Detect potential hazards associated with scaffolding and take corrective actions",
    "Analyze real incidents to reinforce safe practices and avoid common mistakes",
    "Enhance workplace communication related to scaffold safety concerns",
    "Promote a proactive safety culture in environments involving elevated work"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Scaffold Components",
    "Module 3: Harness/Lanyard Inspection & Use",
    "Module 4: Scaffold Inspection and Tagging",
    "Module 5: Scaffold User’s Checklist",
    "Module 6: Scaffold General Requirements"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 94,
  title: "Fired Heaters",
  date: "Present",
  description: [
    "Fired heaters are critical equipment in refineries, petrochemical plants, and gas processing facilities. They supply the necessary heat to process fluids through direct combustion of fuel, typically used in applications such as crude preheating, reforming, or thermal cracking.",
    "This course introduces the fundamental principles, design considerations, and operational practices of fired heaters used in industrial process systems—especially in refineries and petrochemical plants. Participants will explore different fired heater configurations, performance monitoring techniques, common operational challenges, and troubleshooting methods. The course includes practical case studies to connect theory with real-world applications."
  ],
  image: "https://i.ibb.co/xKmyq2dS/fired-heaters-874b32ba15aebbaffa40.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of thermodynamics and heat transfer",
    "Familiarity with process plant equipment and operations",
    "Ideal for process engineers, maintenance personnel, and plant operators"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify various types of fired heater designs and their applications",
    "Understand the heat transfer mechanisms within a fired heater",
    "Monitor key performance indicators and optimize heater efficiency",
    "Operate fired heaters safely under varying load conditions",
    "Analyze flue gas to assess combustion performance",
    "Troubleshoot common issues related to heater operation and performance",
    "Perform basic maintenance and inspection tasks for fired heaters",
    "Apply learning through case studies focused on real-world heater performance and failures"
  ],
  outline: [
    "Module 1: Fired Heater Designs",
    "Module 2: Performance Monitoring",
    "Module 3: Fired Heater Operation",
    "Module 4: Troubleshooting",
    "Module 5: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $70",
  certification: "Certificate of Completion"
},

{
  id: 95,
  title: "Field Instrumentation",
  date: "Present",
  description: [
    "Field instrumentation refers to the measurement and control devices installed in process plants and industrial facilities to monitor and regulate variables such as pressure, temperature, flow, level, and composition. These instruments are installed directly in the field (at or near process equipment) and are essential for safe, efficient, and automated operation of process systems.",
    "This course offers a practical and technical foundation in the core elements of field instrumentation used in industrial process control. It covers the fundamental principles, types of measurements, calibration techniques, control loop configurations, safety systems, and international standards. The course prepares participants to work effectively with instruments used in flow, pressure, temperature, and level control."
  ],
  image: "https://i.ibb.co/9kKgfcYW/field-instrumentation-310e86f5f88cac1a1803.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "PAI",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of process control principles",
    "Familiarity with industrial plant operations",
    "Knowledge of instrumentation terminology"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the purpose and interpretation of instrument symbols and documentation",
    "Identify and apply suitable instruments for flow, pressure, level, and temperature measurement",
    "Explain the working principles and configurations of control valves and their accessories",
    "Calibrate and maintain field instruments using industry-standard procedures",
    "Analyze and design basic and advanced control loops",
    "Comprehend relevant codes and standards used in instrumentation systems",
    "Evaluate and contribute to the development of safety instrumented systems",
    "Apply knowledge through case studies to troubleshoot and optimize instrumentation in real-world scenarios"
  ],
  outline: [
    "Module 1: Instrument Symbols",
    "Module 2: Flow / Pressure measurement",
    "Module 3: Control Valve",
    "Module 4: Control Valve Accessories",
    "Module 5: Temperature measurement",
    "Module 6: Level measurement",
    "Module 7: Control Loops",
    "Module 8: Instruments Calibration",
    "Module 9: Codes, standards & Specification",
    "Module 10: Safety Instrumented Systems",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $90",
  certification: "Certificate of Completion"
},

{
  id: 96,
  title: "Fire Protection Piping Systems",
  date: "Present",
  description: [
    "Fire protection piping systems are critical for safeguarding life, property, and equipment in industrial, commercial, and residential facilities. These systems are designed to quickly detect and suppress fires using water, foam, gas, or chemical agents distributed through a network of specialized piping, valves, and discharge devices.",
    "This course provides a comprehensive overview of fire protection piping systems used in industrial, commercial, and residential applications. It covers applicable codes and standards, types of piping systems, design methods, pressure loss calculations, material selection, and pump requirements. The course also focuses on sprinkler system configuration and performance, supported by real-world case studies to demonstrate best practices and lessons learned."
  ],
  image: "https://i.ibb.co/r2L7zJ1Y/fire-protection-piping-systems-7a63eee6920a74371519.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of fluid dynamics and piping systems",
    "Familiarity with building services or industrial facility layouts",
    "Suitable for fire protection engineers, piping designers, facility managers, and safety compliance officers"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand fire protection system requirements and relevant codes",
    "Identify various types of fire protection piping and their applications",
    "Design compliant piping layouts for effective fire suppression",
    "Calculate pressure drops and optimize flow using hydraulic principles",
    "Select appropriate materials based on fire system classification and building type",
    "Determine pump specifications for adequate fire flow delivery",
    "Configure sprinkler systems to meet coverage and hazard requirements",
    "Apply case study insights to avoid design errors and improve safety",
    "Integrate fire protection piping with building and utility systems",
    "Support testing, inspection, and maintenance practices for long-term reliability"
  ],
  outline: [
    "Module 1: Fire Protection Codes and Standards",
    "Module 2: Types of Fire Protection Piping",
    "Module 3: Design of Piping System",
    "Module 4: Pressure Drop Due to Friction",
    "Module 5: Pipe Materials",
    "Module 6: Pumps",
    "Module 7: Sprinkler System Design",
    "Module 8: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 97,
  title: "Cryogenic and Refrigeration Piping System",
  date: "Present",
  description: [
    "Cryogenic and refrigeration piping systems are designed to transport fluids at extremely low temperatures, typically below -100°C for cryogenics and between -50°C and +10°C for refrigeration. These systems are essential in industries such as liquefied natural gas (LNG), air separation, food processing, pharmaceuticals, and industrial gas handling.",
    "This course provides an essential foundation for designing and operating piping systems used in cryogenic and refrigeration applications. It covers industry codes and standards, fluid properties, material selection, and pressure drop considerations specific to low-temperature systems. The course is ideal for engineers involved in LNG, industrial gas, or refrigeration projects. Real-world case studies are included to illustrate design challenges, safety practices, and operational optimization."
  ],
  image: "https://i.ibb.co/DPwwXzKr/cryogenic-and-refrigeration-piping-systems-1de7d650d2d290b7cd94.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "1 Day",
  prerequisite: [
    "Basic knowledge of fluid mechanics and thermodynamics",
    "Familiarity with piping layouts and pressure systems",
    "Ideal for mechanical, process, and pipeline engineers as well as plant operators and maintenance professionals"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the unique requirements of cryogenic and refrigeration piping systems",
    "Apply industry codes and standards for safe and compliant system design",
    "Identify the properties and hazards associated with cryogenic fluids and refrigerants",
    "Perform accurate pressure drop and pipe sizing calculations for low-temperature systems",
    "Select appropriate piping materials that maintain integrity at cryogenic temperatures",
    "Design for thermal contraction, insulation, and flexibility in piping layout",
    "Recognize key challenges in operation, maintenance, and safety of cryogenic systems",
    "Analyze case studies to apply best practices and avoid common failures",
    "Integrate cryogenic piping with storage tanks, compressors, and heat exchangers",
    "Improve energy efficiency and reliability of refrigeration and cryogenic systems"
  ],
  outline: [
    "Module 1: Codes and Standards",
    "Module 2: Cryogenic Fluids and Refrigerants",
    "Module 3: Pressure Drop and Pipe Sizing",
    "Module 4: Piping Materials",
    "Module 5: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦80,000 / $90",
  certification: "Certificate of Completion"
},

{
  id: 98,
  title: "Compressed-Air Systems Piping",
  date: "Present",
  description: [
    "Piping systems form the backbone of any industrial facility, enabling the safe and efficient transport of fluids (liquids, gases, or slurries). Within these, compressed-air systems piping is a specialized sub-system used to deliver compressed air—a critical utility in manufacturing plants, workshops, oil & gas operations, power plants, and many automated systems. Compressed air is often referred to as the 'fourth utility' (after electricity, water, and gas) due to its vital role in instrumentation, pneumatic tools, valve actuators, packaging, and control systems.",
    "This course provides in-depth knowledge of compressed-air systems used in industrial piping networks. It covers the physical behavior of air, flow characteristics, and pressure drop considerations, along with equipment such as fans, blowers, and compressors. Participants will gain practical skills in designing efficient compressed-air piping layouts, calculating system losses, and optimizing air delivery through nozzles. Real-world case studies will reinforce learning and application."
  ],
  image: "https://i.ibb.co/N2s2GRWr/compressed-air-systems-piping-f4873e3f71ff94f59506.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of fluid mechanics and thermodynamics",
    "Familiarity with piping systems and industrial equipment",
    "Recommended for mechanical engineers, piping designers, and utility system specialists"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental principles behind fluid flow in piping systems",
    "Understand the physical properties of compressed air and how they affect system behavior",
    "Select appropriate equipment such as fans, blowers, and compressors based on system needs",
    "Analyze airflow dynamics within industrial piping systems",
    "Calculate pressure losses in compressed-air distribution networks",
    "Identify and quantify minor losses due to fittings and changes in flow direction",
    "Design efficient nozzle systems to control flow velocity and pressure",
    "Optimize system design for energy efficiency and operational reliability",
    "Evaluate real-world systems through case studies to identify best practices and improvement areas",
    "Apply relevant engineering principles for troubleshooting and system upgrades",
    "Support safe, efficient, and compliant compressed-air system operations"
  ],
  outline: [
    "Module 1: Properties of Air",
    "Module 2: Fans, Blowers, and Compressors",
    "Module 3: Flow of Compressed Air",
    "Module 4: Pressure Drop in Piping",
    "Module 5: Minor Losses",
    "Module 6: Flow of Air through Nozzles",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 99,
  title: "Equipment Absorption Column Design",
  date: "Present",
  description: [
    "An absorption column is a process equipment used to transfer a soluble component from a gas phase into a liquid phase through mass transfer. It is widely used in chemical, petrochemical, gas processing, and environmental applications such as removing CO₂, H₂S, or volatile organics from gas streams.",
    "This course provides a comprehensive understanding of the design and engineering principles behind absorption columns used in industrial gas-liquid separation processes. Participants will explore each stage of the design process—from gathering project data to the detailed mechanical design in compliance with ASME codes. The course includes the design of column internals, nozzles, supports, and flanged joints, supported by practical case studies."
  ],
  image: "https://i.ibb.co/bhQ0jG1/Equipment-Absorption-Column-Design-6f8d6a85951bd6e2ddf9.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "Basic knowledge of mass transfer and fluid mechanics",
    "Familiarity with process equipment design concepts",
    "Understanding of ASME Section VIII Division 1 & 2"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the operational purpose and structure of an absorption column",
    "Interpret process data to inform column design",
    "Apply a systematic design procedure for sizing and configuring absorption columns",
    "Design and evaluate column internals for efficient mass transfer",
    "Calculate nozzle diameters based on process and mechanical considerations",
    "Perform mechanical design in compliance with ASME Section VIII Div.1/2",
    "Design support structures to withstand operational and environmental loads",
    "Ensure reliable sealing through properly designed flanged joints",
    "Evaluate and reinforce nozzle designs for structural integrity",
    "Learn from real-world case studies to avoid common design pitfalls"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Project data",
    "Module 3: Design procedure",
    "Module 4: Designing of internals",
    "Module 5: Determination of Nozzles inside Diameters",
    "Module 6: Mechanical Design of Absorption Column as per ASME S8. Di1/Di2",
    "Module 7: Design of Support",
    "Module 8: Design of Flanged Joints",
    "Module 9: Design an Integral Radial Nozzle Centrally Located",
    "Module 10: Check the Design of a Radial Nozzle in a Cylindrical Shell",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 100,
  title: "API Crude Oil Characterization Measurement",
  date: "Present",
  description: [
    "Crude oil characterization is essential for understanding its physical and chemical properties, which influence refining processes, transportation, storage, and commercial value. One of the most commonly used parameters is the API gravity, defined by the American Petroleum Institute (API) to express the density of petroleum liquids.",
    

    "This course offers an in-depth exploration of methods used to characterize crude oil properties as outlined by the American Petroleum Institute (API). The program covers essential measurement techniques for distillation, vapor pressure, heat capacity, viscosity, thermal conductivity, and other physical and chemical characteristics necessary for crude oil evaluation and modeling in refining and upstream operations."
],
  image: "https://i.ibb.co/Z1Y36Rkp/API-Crude-Oil-Characterization-Measurement-45209e704584927852d1.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of petroleum refining and production processes",
    "Familiarity with chemical engineering or petroleum engineering principles",
    "Ideal for process engineers, lab technicians, and petroleum analysts"
  ],
  methodology: "Theoretical",
  objectives: [
    "Explain the role and importance of crude oil characterization in process design and operations",
    "Apply distillation and SimDist techniques to determine boiling range distributions",
    "Collect and interpret general physical and chemical property data",
    "Conduct vapor pressure measurements using ebulliometry",
    "Measure heat capacity and pseudo-critical properties for crude mixtures",
    "Analyze and apply thermal conductivity data for design calculations",
    "Accurately determine and use viscosity values for flow and transport calculations",
    "Understand the significance of gravity and molecular weight in refinery and reservoir engineering",
    "Utilize data in process simulators to model and optimize operations",
    "Evaluate real-world case studies and overcome common characterization challenges"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Distillation and Simulated Distillation",
    "Module 3: General Physical Property Characterization Data",
    "Module 4: Chemical Analysis Data",
    "Module 5: Ebulliometric Vapor Pressure Measurements",
    "Module 6: Two-Phase Heat Capacity and Pseudo-Critical Temperature Measurement",
    "Module 7: Thermal Conductivity",
    "Module 8: Viscosity",
    "Module 9: Gravity",
    "Module 10: Molecular Weight",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},


{
  id: 101,
  title: "Design & Operation of Hydrocarbon Turboexpanders",
  date: "Present",
  description: [
    "A turboexpander is a high-speed rotating device that extracts energy from a pressurized hydrocarbon gas stream by allowing it to expand and cool rapidly. It is commonly used in natural gas processing, NGL (natural gas liquids) recovery, and cryogenic separation processes.",
    "This course explores the design principles, operational characteristics, and supporting systems of hydrocarbon turboexpanders used in gas processing and cryogenic applications. Participants will gain insights into design fundamentals, auxiliary components, operation procedures, and reliability management. The course also introduces modern features such as magnetic bearings and noise control strategies, with real-world case studies for contextual understanding."
  ],
  image: "https://i.ibb.co/G4CsBTkG/Design-Operation-of-Hydrocarbon-Turboexpanders-15229129a4f4e7d3231f.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of thermodynamics and fluid mechanics",
    "Familiarity with gas processing or petrochemical plant operations",
    "Engineering background in mechanical, process, or instrumentation disciplines"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the function and importance of turboexpanders in hydrocarbon processes",
    "Identify and describe key design considerations for turboexpanders",
    "Explain the role of auxiliary systems in safe and efficient operation",
    "Operate and monitor turboexpanders according to best practices",
    "Conduct and interpret expander performance tests",
    "Recognize the application and benefits of magnetic bearing technology",
    "Integrate turboexpander/generator systems for energy recovery",
    "Apply noise control techniques in turboexpander system design",
    "Implement reliability-centered maintenance strategies",
    "Analyze real-world turboexpander projects to draw practical insights"
  ],
  outline: [
    "Module 1: Turboexpander General Information",
    "Module 2: Design Fundamentals",
    "Module 3: Auxiliaries",
    "Module 4: Turboexpander/Compressor Operation",
    "Module 5: Expander Testing",
    "Module 6: Magnetic Bearings",
    "Module 7: Turboexpander/Generator",
    "Module 8: Noise Control",
    "Module 9: Reliability / Maintenance",
    "Module 10: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 102,
  title: "Expansion Tank Design (Chilled Water)",
  date: "Present",
  description: [
    "An expansion tank in a chilled water system is designed to absorb the volume changes in the water due to temperature fluctuations. Though chilled water systems typically operate at lower temperatures, thermal expansion still occurs and must be accommodated to prevent pressure buildup, equipment stress, or system damage.",
    "This course provides a focused study on the principles and practices of designing expansion tanks for chilled water systems. Participants will learn about the function of expansion tanks in managing system pressure changes, the various types of expansion tanks, and how to properly size and select them for different HVAC applications. Practical examples and calculator usage are included to enhance applied understanding."
  ],
  image: "https://i.ibb.co/nsfY0XCV/Expansion-Tank-Design-Chilled-Water-dad8556c1e9a2b566a0e.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "process",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of HVAC or mechanical systems",
    "Familiarity with chilled water system components and operations",
    "Ideal for HVAC engineers, building services designers, and mechanical technicians"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify various types of fired heater designs and their applications",
    "Explain the function and importance of expansion tanks in chilled water systems",
    "Differentiate between the main types of expansion tanks and their use",
    "Apply design equations to correctly size an expansion tank",
    "Identify key factors affecting expansion tank selection and performance",
    "Utilize calculator tools to streamline the design process",
    "Recognize common design issues and how to prevent them",
    "Assess system impacts of poorly sized or maintained expansion tanks",
    "Apply case-based learning to real-world HVAC system designs"
  ],
  outline: [
    "Module 1: Introduction",
    "Module 2: Disclaimer",
    "Module 3: Expansion Tank Types",
    "Module 4: Sizing an Expansion Tank",
    "Module 5: Expansion Tank Design Issues",
    "Module 6: Expansion Tank Calculator",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $70",
  certification: "Certificate of Completion"
},

{
  id: 103,
  title: "Exploration & Production Equipment Piping",
  date: "Present",
  description: [
    "Piping systems in exploration and production (E&P) facilities are essential for transporting fluids—oil, gas, water, and drilling mud—between various pieces of equipment. These systems must be designed and installed to handle harsh environments, variable pressures, corrosive substances, and operational safety requirements.",
    "This course outlines the total procedure covering the design, fabrication, installation, inspection, and commissioning of piping for upstream E&P equipment such as wellheads, separators, pumps, compressors, and storage units.",
    "This course provides a comprehensive understanding of piping systems used in upstream oil and gas exploration and production operations. It covers functional roles, piping components, data representation, and operational practices. The course also addresses common troubleshooting techniques and real-world case studies to reinforce practical knowledge."
  ],
  image: "https://i.ibb.co/k2b0JH3n/Exploration-Production-Equipment-Piping-70d5347724311c5a4a41.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "Petroleum",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of oil and gas production systems",
    "Familiarity with mechanical or process engineering concepts",
    "Understanding of piping terminology and symbols is advantageous"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the functional role of piping systems in exploration and production",
    "Identify and describe essential piping components",
    "Interpret standard piping diagrams and documents",
    "Apply knowledge of piping operations in E&P environments",
    "Recognize and resolve common piping issues through troubleshooting",
    "Assess the impact of piping layout and design on system performance",
    "Understand the materials and standards used in piping design",
    "Apply lessons learned from real-world case studies to improve piping reliability"
  ],
  outline: [
    "Module 1: Objectives",
    "Module 2: The Functions of Piping",
    "Module 3: Piping Components",
    "Module 4: Representation and Data",
    "Module 5: Piping Operations",
    "Module 6: Troubleshooting",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 104,
  title: "Fuel Gas Distribution Piping System",
  date: "Present",
  description: [
    "A fuel gas distribution piping system is a specialized network within industrial and commercial facilities that safely transports combustible gases (like natural gas, LPG, or manufactured gases) from a central source (e.g., a gas manifold, bulk tank, or pipeline) to end-use equipment such as furnaces, turbines, boilers, burners, or engines. These systems are crucial for industries where reliable, safe, and regulated gas supply is essential for continuous operation and energy efficiency.",
    "This course delivers a comprehensive understanding of fuel gas distribution piping systems, focusing on the physical behavior of fuel gases, applicable codes and standards, system components, and sizing methodologies. It includes detailed modules on LPG systems—covering transportation, storage, and tank sizing. Through practical case studies, participants will develop the skills necessary to design, operate, and troubleshoot safe and efficient fuel gas piping systems across residential, commercial, and industrial applications."
],
  image: "https://i.ibb.co/5XvgRLHb/fuel-gas-distribution-piping-system-f48f6c649b55c249e5a5.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of fluid mechanics and thermodynamics",
    "Familiarity with piping layouts and pressure systems",
    "Ideal for mechanical, process, and pipeline engineers as well as plant operators and maintenance professionals"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand and apply relevant fuel gas piping codes and standards",
    "Differentiate between types of fuel gases and their properties",
    "Design safe and compliant fuel gas distribution systems",
    "Properly size pipes based on gas flow, system layout, and demand",
    "Select suitable materials for various pressure and environmental conditions",
    "Identify and use key components in fuel gas systems",
    "Perform pressure testing to ensure system integrity and safety",
    "Design and evaluate LPG transportation and storage systems",
    "Calculate appropriate LPG tank and pipe sizes for various applications",
    "Analyze real-world case studies to improve safety, reliability, and efficiency in gas systems"
  ],
  outline: [
    "Module 1: Codes and Standards",
    "Module 2: Types of Fuel Gas",
    "Module 3: Gas Properties",
    "Module 4: Fuel Gas System Pressures",
    "Module 5: Fuel Gas System Components",
    "Module 6: Fuel Gas Pipe Sizing",
    "Module 7: Pipe Materials",
    "Module 8: Pressure Testing",
    "Module 9: LPG Transportation",
    "Module 10: LPG Storage",
    "Module 11: LPG Tank and Pipe Sizing",
    "Module 12: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 105,
  title: "Gas Piping System",
  date: "Present",
  description: [
    "Piping systems are fundamental infrastructure in industrial, commercial, and residential facilities used to safely transport fluids — including liquids, gases, steam, and slurries. Within this broad category, the gas piping system is specifically designed to handle the transport and distribution of various gases such as natural gas, propane, hydrogen, oxygen, nitrogen, and process gases.",
    "Due to the volatile and pressurized nature of gases, gas piping systems require precise engineering, strict safety measures, and compliance with codes and standards to prevent leaks, explosions, or operational hazards.",
    "This course provides an in-depth understanding of gas transmission and distribution piping systems. It focuses on the physical properties of gases, pressure drop calculations, pipeline configurations, and the use of compressors to maintain flow and pressure. Participants will also gain insights into stress analysis and cost optimization strategies essential for safe, reliable, and economical gas pipeline operations. The course is reinforced with practical case studies from real industrial applications."
  ],
  image: "https://i.ibb.co/0yBw8817/gas-piping-system-e8abb3a11017a4e90abf.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of fluid mechanics and thermodynamics",
    "Familiarity with piping layouts and pressure systems",
    "Ideal for mechanical, process, and pipeline engineers as well as plant operators and maintenance professionals"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the behavior and properties of gases relevant to piping systems",
    "Calculate pressure drops and determine flow capacity for gas pipelines",
    "Apply line packing concepts for operational flexibility",
    "Analyze pipelines arranged in series and parallel to evaluate system performance",
    "Design and evaluate looping pipelines to increase capacity and redundancy",
    "Select appropriate compressors and integrate them into pipeline systems",
    "Conduct basic pipe stress analysis for safe and compliant designs",
    "Evaluate economic trade-offs in pipeline design and operation",
    "Identify key considerations in gas pipeline reliability and efficiency",
    "Learn from industry case studies to improve design, operation, and maintenance strategies"
  ],
  outline: [
    "Module 1: Gas Properties",
    "Module 2: Pressure Drop Due to Friction",
    "Module 3: Line Pack in Gas Pipeline",
    "Module 4: Pipes in Series",
    "Module 5: Pipes in Parallel",
    "Module 6: Looping Pipelines",
    "Module 7: Gas Compressors",
    "Module 8: Pipe Stress Analysis",
    "Module 9: Pipeline Economics",
    "Module 10: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},
{
  id: 106,
  title: "Oil Systems Piping",
  date: "Present",
  description: [
    "An oil piping system is a specialized segment of industrial piping infrastructure designed for the safe, reliable, and efficient transport of various oils—including crude oil, fuel oil, hydraulic oil, lubrication oil, and thermal oils. These systems are vital in petrochemical plants, refineries, offshore platforms, power plants, and industrial facilities.",
    "Due to the flammable, viscous, and sometimes corrosive nature of oils, their piping systems must adhere to strict design, material selection, and safety protocols.",
    "This course offers a complete guide to the design, analysis, and operation of oil piping systems, with an emphasis on the physical properties of oil, fluid dynamics, and hydraulic calculations. It addresses the key considerations for pressure drop, flow characteristics, pumping requirements, and mechanical integrity. Participants will also learn about valves, fittings, pipe stress, and economic evaluation through detailed theoretical insights and real-world case studies."
  ],
  image: "https://i.ibb.co/PGGB9D5x/oil-systems-piping.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of fluid mechanics and thermodynamics",
    "Familiarity with industrial piping layouts and components",
    "Ideal for piping engineers, mechanical engineers, process engineers, and plant operators"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental principles behind fluid flow in piping systems",
    "Understand the physical properties of compressed air and how they affect system behavior",
    "Select appropriate equipment such as fans, blowers, and compressors based on system needs",
    "Analyze airflow dynamics within industrial piping systems",
    "Calculate pressure losses in compressed-air distribution networks",
    "Identify and quantify minor losses due to fittings and changes in flow direction",
    "Design efficient nozzle systems to control flow velocity and pressure",
    "Optimize system design for energy efficiency and operational reliability",
    "Evaluate real-world systems through case studies to identify best practices and improvement areas",
    "Apply relevant engineering principles for troubleshooting and system upgrades",
    "Support safe, efficient, and compliant compressed-air system operations"
  ],
  outline: [
    "Module 1: Density, Specific Weight, and Specific Gravity",
    "Module 2: Specific Gravity of Blended Products",
    "Module 3: Viscosity",
    "Module 4: Viscosity of Blended Products",
    "Module 5: Bulk Modulus",
    "Module 6: Vapor Pressure",
    "Module 7: Pressure",
    "Module 8: Velocity",
    "Module 9: Reynolds Number",
    "Module 10: Types of Flow",
    "Module 11: Pressure Drop Due to Friction",
    "Module 12: Minor Losses",
    "Module 13: Complex Piping Systems",
    "Module 14: Total Pressure Required",
    "Module 15: Hydraulic Gradient",
    "Module 16: Pumping Horsepower",
    "Module 17: Pumps",
    "Module 18: Valves and Fittings",
    "Module 19: Pipe Stress Analysis",
    "Module 20: Pipeline Economics",
    "Module 21: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 107,
  title: "Piping Systems & Piping Calculation",
  date: "Present",
  description: [
    "Piping systems are critical to industrial facilities, serving as the circulatory system for transporting fluids (liquids, gases, slurries, or steam) between equipment such as pumps, tanks, compressors, reactors, and heat exchangers. These systems must be carefully designed, sized, and analyzed to ensure safety, efficiency, and compliance with relevant codes and standards. The Piping Calculation Manual provides a comprehensive reference for engineers, including equations, design methodologies, material selection, and layout principles necessary for reliable piping design and operation.",
    "This course provides a practical and comprehensive guide to the design and calculation of industrial piping systems across various applications. It covers fluid flow principles, pipe sizing, material selection, and system-specific requirements, including water, steam, gas, oil, and cryogenic services. Through detailed modules and case studies, participants will gain both theoretical understanding and applied skills in designing efficient, safe, and compliant piping systems."
  ],
  image: "https://i.ibb.co/t5SNsdV/piping-systems-piping-calculation.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "1 Day",
  prerequisite: [
    "Basic knowledge of fluid mechanics and thermodynamics",
    "Familiarity with engineering drawings and industrial plant operations",
    "Recommended for mechanical engineers, piping designers, and utility system specialists"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the fundamental principles behind fluid flow in piping systems",
    "Perform pipe sizing and pressure loss calculations for various system types",
    "Select appropriate materials for specific fluids and operating conditions",
    "Apply design standards and safety codes relevant to each piping system",
    "Design reliable systems for water, steam, air, gas, and oil services",
    "Account for expansion, contraction, insulation, and support in piping layouts",
    "Identify failure risks and apply strategies to improve system reliability",
    "Interpret piping system schematics and calculation manuals",
    "Analyze case studies to apply practical design and troubleshooting techniques"
  ],
  outline: [
    "Module 1: Water Systems Piping",
    "Module 2: Fire Protection Piping Systems",
    "Module 3: Waste Water and Storm Water Piping",
    "Module 4: Steam Systems Piping",
    "Module 5: Compressed-Air Systems Piping",
    "Module 6: Oil Systems Piping",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦300,000 / $250",
  certification: "Certificate of Completion"
},

{
  id: 108,
  title: "Slurry and Sludge Piping System",
  date: "Present",
  description: [
    "Slurry and sludge piping systems are designed to transport mixtures of solids suspended in liquids, often under challenging conditions such as high abrasion, variable viscosity, and intermittent flow. These systems are commonly used in mining, mineral processing, wastewater treatment, dredging, and heavy industry.",
    "This course covers the design and analysis of piping systems for transporting slurry and sludge, which are commonly found in mining, wastewater treatment, and process industries. It focuses on the physical behavior of complex fluids, including Newtonian and non-Newtonian characteristics, pressure loss calculations, and flow regimes. Participants will gain the technical knowledge needed to manage abrasive, viscous, and multiphase flow conditions effectively. Case studies illustrate practical design challenges and solutions."
],
  image: "https://i.ibb.co/SD7QfnGb/slurry-and-sludge-piping-system.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic knowledge of fluid mechanics and thermodynamics",
    "Familiarity with piping layouts and pressure systems",
    "Suitable for process, piping, and mechanical engineers working in heavy industry, mining, or wastewater sectors"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the physical properties of slurry and sludge and how they impact piping design",
    "Distinguish between Newtonian and non-Newtonian fluids and identify appropriate flow models",
    "Analyze the behavior of homogeneous and heterogeneous flows in piping systems",
    "Perform pressure drop calculations for both Newtonian and non-Newtonian flow conditions",
    "Evaluate the impact of flow regime on pipeline wear and maintenance needs",
    "Select suitable materials and pumps for slurry and sludge transport",
    "Design pipelines to minimize settling and ensure stable flow",
    "Apply best practices in layout and operation to reduce energy consumption and downtime",
    "Interpret real-world case studies for practical insights and design validation",
    "Ensure system compliance with safety and operational standards in difficult service environments"

  ],
  outline: [
    "Module 1: Physical Properties",
    "Module 2: Newtonian and Non-Newtonian Fluids",
    "Module 3: Flow of Newtonian Fluids",
    "Module 4: Flow of Non-Newtonian Fluids",
    "Module 5: Homogeneous and Heterogeneous Flow",
    "Module 6: Pressure Loss in Slurry Pipelines with Heterogeneous Flow",
    "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 109,
  title: "Wastewater & Stormwater Piping",
  date: "Present",
  description: [
    "Wastewater and stormwater piping systems are essential for collecting, transporting, and safely discharging used water and rainwater from industrial, commercial, and residential facilities. These systems help prevent flooding, protect public health, and ensure compliance with environmental regulations.",
    "This course provides a comprehensive study of piping systems used for transporting wastewater and stormwater in municipal, industrial, and commercial applications. Covering the hydraulic behavior of these fluids, system design principles, materials, and energy considerations, this course is ideal for engineers and technicians involved in designing, operating, or maintaining sewer infrastructure. Case studies reinforce practical application and real-world problem-solving."
  ],
  image: "https://i.ibb.co/5gpp2svf/waste-water-and-storm-water-piping.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of fluid mechanics and environmental engineering",
    "Familiarity with drainage or piping systems",
    "Ideal for civil engineers, public works personnel, piping designers, and utility planners"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the unique properties of wastewater and stormwater and how they affect system design",
    "Calculate flow velocity, pressure loss, and self-cleansing criteria for piping networks",
    "Design both gravity and pressure-based sewer systems using accepted engineering methods",
    "Evaluate and select suitable pipe materials for different site conditions",
    "Apply hydraulic principles to size pipes, slopes, and pumping systems",
    "Analyze the behavior of storm and sanitary flows under varying weather and loading conditions",
    "Design complex and branched piping networks with proper flow distribution",
    "Estimate energy needs and operational costs for pumping stations",
    "Ensure structural stability of buried sewer pipes through correct load assessment",
    "Learn from real-world projects to avoid common design and operational pitfalls"
  ],
  outline: [
    "Module 1: Properties of Wastewater and Stormwater",
    "Module 2: Pressure",
    "Module 3: Velocity",
    "Module 4: Reynolds Number",
    "Module 5: Types of Flow",
    "Module 6: Pressure Drop Due to Friction",
    "Module 7: Minor Losses",
    "Module 8: Sewer Piping Systems",
    "Module 9: Sanitary Sewer System Design",
    "Module 10: Self-Cleansing Velocity",
    "Module 11: Storm Sewer Design",
    "Module 12: Complex Piping Systems",
    "Module 13: Total Pressure Required",
    "Module 14: Hydraulic Gradient",
    "Module 15: Gravity Flow",
    "Module 16: Pumping Horsepower",
    "Module 17: Pumps",
    "Module 18: Pipe Materials",
    "Module 19: Loads on Sewer Pipe",
    "Module 20: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 110,
  title: "Water Piping System",
  date: "Present",
  description: [
    "Water piping systems are critical components in industrial, commercial, and residential infrastructure. These systems are designed to transport water for various purposes such as cooling, process operations, fire protection, potable supply, and wastewater disposal. A well-designed water piping system ensures reliable flow, adequate pressure, safety, and compliance with applicable codes.",
    "This course offers a comprehensive understanding of water piping systems used in industrial, municipal, and building service applications. Covering both fundamental fluid mechanics and practical piping design, it walks participants through system components, flow analysis, energy requirements, and economic considerations. The course also explores real-world applications and challenges through detailed case studies."
],
  image: "https://i.ibb.co/VcqLJNGz/water-piping-system.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of fluid mechanics and thermodynamics",
    "Familiarity with piping layouts or civil/industrial utility systems",
    "Suitable for mechanical engineers, civil engineers, piping designers, and utility planners"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the physical properties of water and their effect on system design",
    "Analyze fluid flow in piping networks using velocity, Reynolds number, and pressure loss equations",
    "Design water piping systems with consideration for both frictional and minor losses",
    "Evaluate pump selection and energy requirements using hydraulic principles",
    "Interpret and design systems using hydraulic gradient and gravity flow considerations",
    "Apply pipe stress analysis techniques to ensure mechanical integrity",
    "Choose and place valves and fittings effectively within a system",
    "Perform economic evaluation of piping systems based on material, pumping cost, and layout",
    "Troubleshoot issues in complex piping layouts and flow distributions",
    "Learn from real-world case studies to improve design efficiency and reliability"
  ],
  outline: [
    "Module 1: Properties of Water",
    "Module 2: Pressure",
    "Module 3: Velocity",
    "Module 4: Reynolds Number",
    "Module 5: Types of Flow",
    "Module 6: Pressure Drop Due to Friction",
    "Module 7: Minor Losses",
    "Module 8: Complex Piping System",
    "Module 9: Total Pressure Required",
    "Module 10: Hydraulic Gradient",
    "Module 11: Gravity Flow",
    "Module 12: Pumping Horsepower",
    "Module 13: Pumps",
    "Module 14: Flow Injections and Deliveries",
    "Module 15: Valves and Fittings",
    "Module 16: Pipe Stress Analysis",
    "Module 17: Pipeline Economics",
    "Module 18: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 111,
  title: "Steam Piping System",
  date: "Present",
  description: [
    "SSteam piping systems are designed to transport steam generated in boilers to various end-use points, such as turbines, heat exchangers, reboilers, or process equipment. These systems must be carefully engineered to handle high pressures, temperatures, and thermal expansion, ensuring efficient and safe operation.",
    "This course provides a comprehensive introduction to the design, operation, and maintenance of steam piping systems used in industrial and utility applications. Participants will learn the key principles governing steam behavior, pressure drop, sizing, and material selection. The course includes guidance on applicable codes and standards, component specification, and steam flow control—concluding with practical case studies from real installations."
],
  image: "https://i.ibb.co/0kXwpfg/steam-piping-system.png",
  tags: [
    "Trainer: Engr. Okechukwu"
  ],
  category: "mechanical",
  duration: "2 Days",
  prerequisite: [
    "Basic understanding of thermodynamics and fluid mechanics",
    "Familiarity with industrial piping or mechanical systems",
    "Suitable for piping engineers, plant designers, maintenance personnel, and energy managers"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand the properties of steam and their relevance to piping design",
    "Apply appropriate codes and standards to ensure safe and compliant systems",
    "Select suitable piping materials based on temperature and pressure conditions",
    "Calculate pressure drops and determine allowable velocity ranges",
    "Design and size steam piping systems for optimal flow and energy efficiency",
    "Specify pipe wall thickness based on operating pressure and system life",
    "Integrate nozzles, valves, and fittings effectively into the piping layout",
    "Identify operational risks such as water hammer, erosion, and heat loss",
    "Conduct troubleshooting and performance analysis using case studies",
    "Improve reliability and efficiency of existing steam piping networks"
  ],
  outline: [
    "Module 1: Codes and Standards",
    "Module 2: Types of Steam Systems Piping",
    "Module 3: Properties of Steam",
    "Module 4: Pipe Materials",
    "Module 5: Velocity of Steam Flow in Pipes",
    "Module 6: Pressure Drop",
    "Module 7: Nozzles and Orifices",
    "Module 8: Pipe Wall Thickness",
    "Module 9: Determining Pipe Size",
    "Module 10: Valves and Fittings",
    "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},
  
  {
    id: 0,
    title: "Basic Line Sizing",
    date: "Aug 2023 - Sep 2023",
    description:
      "A Basic Line Sizing course typically aims to equip students with the fundamental knowledge and skills required to determine the appropriate size of pipes or lines for fluid transportation systems.",
    image:
    "https://i.ibb.co/JwZmfkvB/Basic-line-85d1dc18a0677b69c28e.png",
    tags: ['Trainer: Engr. Okechukwu'],
    category: "process",

    duration: "1 Day",
    prerequisite: [
      "Fundamental Concepts of Fluid mechanics, Pipe friction, Reynolds number and Pressure drop.",
      "Knowledge of Pipe schedules and dimensions, Fluid properties, Design parameters, Calculation tools (Excel)"


    ],
    methodology: "Theoretical",
    objectives: [
          "Understand fluid flow principles.",
        	"Understand the basic Pipe and Fittings",
        	"Understand the basic the methods and formulas to calculate pipe diameter based on flow rate, fluid properties, and allowable pressure drop.",
          "Understand the importance of line sizing for particular industries (e.g., oil and gas, chemical, water supply).",
          "Understand line sizing for different fluids: Apply line sizing principles to liquids, gases, and multiphase flows.",
          "Understand the basic industry-accepted standards (e.g., ASME B31, API) for line sizing calculations and material selection."
                  
    ],
    outline: [
        "Module 1:  Introduction to Fluid Mechanics",
        "Module 2:  Pipe and Fittings",
        "Module 3:  Fluid Flow in Pipes",
        "Module 4:  Line Sizing Calculations",
        "Module 5:  Special Considerations",
        "Module 6:  Line Sizing Standards and Codes", 
    ],
    assessment: "	Online Written Exam  ",
    cdf: [
      "Virtual",
    ],
    cost: "FREE"
  },
  {
    id: 0,
    title: "Liquid Line Sizing",
    date: "Aug 2023 - Sep 2023",
    description:
      "A liquid line sizing course typically aims to equip participants with the knowledge and skills necessary to accurately determine the appropriate size for liquid lines in various industrial applications. Either API Rp 14e, IS0 13075 or P001 codes standard will be use for the sizing.",
      image:
      "https://ik.imagekit.io/mags/courses/liquid%20line%20sizing.png",
    tags: ['Trainer: Engr. Okechukwu'],
    category: "process",
    
    duration: "3 Days",
    prerequisite: [
      "Fundamental Concepts of Fluid mechanics, Pipe friction, Reynolds number and Pressure drop.",
      "Knowledge of Pipe schedules and dimensions, Fluid properties, Design parameters, Calculation tools (Excel)"



    ],
    methodology: "Theoretical",
    objectives: [
          "Understanding the essential parameters of fluid flow (flow rate, velocity, pressure drop, etc.)",
          "Understanding the flow velocity and pressure drop importance and calculation",
          "Surge the typical surge factors.",
          "Understanding the how to determine friction factor through a pipe.",
          "Understanding Sizing Criteria (Velocity & Pressure Drop) of a liquid pipeline ",
          "Understanding the velocity calculation ",
          "Understanding the pressure drop calculation along the pipe",
          "Understanding the how to perform line sizing using codes and standards.",
          "Understanding the how to perform line sizing via Aspen Hysys"

                  
    ],
    outline: [
        "Module 1:  Introduction to liquid line sizing parameters (flow rate, velocity, pressure drop, etc.)",
        "Module 2:  Surge Factor / Fluid Hammer",
        "Module 3:  Introduction to Line Sizing Calculations",
        "Module 4:  Liquid Line Sizing Standards and Codes",
        "Module 5:  Velocity & Pressure drop criterial for Liquid Line Sizing ",
        "Module 6:  Liquid Line Sizing with Excel",
        "Module 7:  Liquid Line Sizing with Aspen Hysys"
 
    ],
    assessment: "	Online Written Exam  ",
    cdf: [
      "Classroom, Face to Face or Virtual",
    ],
    cost: "₦70,000 / $60"
  },
  
  {
    id: 1,
    title: "Control Valve Sizing and Selection",
    date: "Aug 2023 - Sep 2023",
    description: [
      "Control valves are critical components in process industries, serving as the final control element in regulating flow, pressure, temperature, and level within a system. Accurate sizing and selection of control valves are essential to ensure efficient process control, reliability, and safety.",
      "This course, “Control Valve Sizing,” provides a comprehensive understanding of the principles, methodologies, and tools used to size and select control valves for various process applications. Participants will gain both theoretical knowledge and practical skills to evaluate valve performance under different operating conditions and fluid types.",
      "Through a combination of lectures, case studies, and simulation exercises, learners will explore key sizing parameters, flow characteristics, and standards that govern control valve design. ",
      "By the end of the course, participants will be able to interpret process data, perform sizing calculations for incompressible and compressible fluids, prepare accurate control valve datasheets in compliance with international standards, confidently perform sizing calculations for liquids, gases, and steam, evaluate control valve performance, and select suitable valve types and trims for stable process control.",
          
    ],
            
      image:
      "https://i.ibb.co/MDMVGWGH/CONTROL-VALVE-SIZING-9e913fc4d55572dd10a7.png",
    tags: ["Trainer: Engr. Magnus"],
    category: "process",
    github: "https://github.com/Joseffl/ai_summarizer",
    webapp: "https://bit.ly/3UbxnCV",

    duration: "3 Days",
    prerequisite: [
      "Fundamental Concepts of Fluid mechanics; flow rate, pressure, velocity, and head loss.",
      "Basic Mathematics",
      "Units and Conversions",
      "Knowledge of Calculation tools (Excel)",

    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the purpose and importance of control valves in process industries.",
          "Identify the major components and functions of control valve systems.",
          "Describe the working principle of a control valve and its main parts (body, trim, actuator, and positioner).",
          "Distinguish between different types of control valves such as globe, ball, butterfly, and plug valves.",
          "Explain inherent and installed flow characteristics (linear, equal percentage, quick opening).",
          "Determine the impact of valve characteristics on process dynamics.",
          "Select appropriate valve characteristics based on process requirements and control loop behavior.",
          "Identify control valve symbols and designations on P&IDs and PFDs.",
          "Interpret control valve tag numbers, instrumentation connections, and loop identifiers.",
          "Define key sizing parameters including flow coefficient (Cv), pressure drop (ΔP), specific gravity, and flow rate.",
          "Understand the effects of fluid properties (density, viscosity, vapor pressure) on valve sizing.",
          "Establish design and operating pressure conditions required for accurate valve selection.",
          "Apply standards and equations for sizing valves handling liquids.",
          "Calculate valve flow coefficient (Cv) for water or liquid service under various conditions.",
          "Identify and mitigate issues such as cavitation and flashing during valve selection.",
          "Apply appropriate sizing equations for gases and vapors considering pressure drop ratios and flow regimes.",
          "Determine choked and non-choked flow conditions in compressible service.",
          "Calculate valve Cv and required pressure drop for stable operation with gas streams.",
          "Utilize Aspen HYSYS software tools for control valve sizing and simulation.",
          "Input process data to estimate flow coefficients and verify valve performance under design conditions.",
          "Develop and complete control valve datasheets in accordance with industry standards (ISA 75.01, API 602).",
          "Review and verify datasheet accuracy for vendor submission and procurement documentation."
        
    ],
    outline: [
        "Module 1: Introduction",
        "Module 2: Control valve fundamentals",
        "Module 3: Control valve characteristics",
        "Module 4: Control Valve in process drawings",
        "Module 5: Control Valve sizing parameters",
        "Module 6: Sizing Control Valve for incompressible fluid",
        "Module 7: Sizing Control Valve for compressible fluid",
        "Module 8: Control Valve Sizing with Aspen Hysys",
        "Module 9: Control Valve Datasheet"


    ],
    assessment: "	Online Written Exam  ",
    cdf: [
      "Classroom, Face to Face or Virtual",
    ],
    cost: "₦150,000 / $120"
  },
  {
    id: 2,
    title: "Gas Line Sizing",
    date: "Oct 2022 - Present",
    description:
      "A gas line sizing course typically aims to equip participants with the knowledge and skills necessary to accurately determine the appropriate size for gas lines in various industrial applications. Either API Rp 14e, IS0 13075 or P001 codes standard will be use for the sizing.",
      image:
      "https://i.ibb.co/WTzqk80/gas-line-sizing-354b3c6b8f0ad972ada4.png",
      tags: [
      'Trainer: Engr. Okechukwu',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Fundamental Concepts of Fluid mechanics, Pipe friction, Reynolds number and Pressure drop.",
      "Knowledge of Pipe schedules and dimensions, Fluid properties, Design parameters, Calculation tools (Excel)"


    ],
    methodology: "Theoretical",
    objectives: [
          "Understanding the essential parameters of fluid flow (flow rate, velocity, pressure drop, etc.)",
          "Understanding the gas flow velocity and pressure drop importance and calculation",
          "Surge the typical surge factors.",
          "Understanding the GPSA engineering data book.",
          "Understanding the how to determine friction factor through a pipe.",
          "Understanding Sizing Criteria (Velocity & Pressure Drop) of a gas pipeline ",
          "Understanding the gas velocity calculation ",
          "Understanding the general and empirical pressure drop calculation along the pipe",
          "Understanding the how to perform gas line sizing via codes and standards.",
          "Understanding the how to perform  gas line sizing via Aspen Hysys"

                  
    ],
    outline: [
        "Module 1:  Introduction to gas line sizing parameters (flow rate, velocity, pressure drop, etc.)",
        "Module 2: Surge Factor / Fluid Hammer",
        "Module 3: Introduction to Line Sizing Calculations",
        "Module 4: GPSA engineering data book.",
        "Module 5:  Gas Line Sizing Standards and Codes",
        "Module 6:  Gas Velocity & Pressure drop criterial for  Gas Line Sizing", 
        "Module 7:   Gas Line Sizing with Excel",
        "Module 8:   Gas Line Sizing with Aspen Hysys"



    ],
    assessment: "	Online Written Exam  ",
    cdf: [
      "Classroom, Face to Face or Virtual",
    ],
    cost: "₦80,000 / $70"
  },
  

  {
    id: 3,
    title: "HAZID",
    date: "Oct 2022 - Present",
    description:
      "A Hazard Identification (HAZID) course is a comprehensive program designed to equip individuals with the essential knowledge and skills to proactively identify, assess, and manage potential hazards within their workplace or projects. This course is crucial for ensuring workplace safety, regulatory compliance, and minimizing the risk of accidents or incidents.",
      image:
      "https://i.ibb.co/Kz9mmz9S/hazid-07dad38530b00db64cf5.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "hazop hazid",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic Safety Concepts",
      "Process Understanding",
      "Team Collaboration Skills",
      "Technical Skills"

    ],
    methodology: "Theoretical/Practical",
    objectives: [
          "Understanding hazard identification techniques.",
          "Recognizing potential hazards.",
          "Evaluating the severity of hazards.",
          "Prioritizing hazards.",
          "Developing risk management strategies.",
          "Understanding regulatory requirements"

                  
    ],
    outline: [
        "Module 1:  Introduction to HAZID.",
        "Module 2:  Hazard Identification Techniques",
        "Module 3:  Hazard Assessment.",
        "Module 4:  HAZID Planning",
        "Module 5:  HAZID Team Roles and Responsibilities.",
        "Module 6:  HAZID Execution.",
        "Module 7:  HAZID Methodology",
        "Module 8:  HAZID Reporting and Documentation.",
        "Case Studies"
    ],
    assessment: "	Online Written Exam  ",
    cdf: [
      "Classroom-based training",
      "Online courses", 
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $100"
  },
{
    id: 4,
    title: "HAZOP",
    date: "Oct 2022 - Present",
    description: "HAZOP is a systematic and structured technique used to identify potential hazards and operational problems in a process or system. It's a widely used method in the process industry, particularly in areas like chemical engineering, pharmaceuticals, and oil and gas. This course aims to equip participants with the knowledge and skills necessary to accurately identify potential hazards and operational problems in a process or system.",
    image: "https://ik.imagekit.io/mags/courses/hazop.png",
    tags: [
      "Trainer: Engr. Lateef"
    ],
    category: "hazop hazid",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "2 Days",
    prerequisite: [
      "Basic understanding of process engineering.",
      "Process flow diagrams (PFDs)",
      "Piping and instrumentation diagrams (P&IDs)",
      "Plant Layout diagrams",
      "Material safety data sheets (MSDS)",
      "Provisional operating instructions",
      "Heat and material balances",
      "Equipment datasheets",
      "Start-up and emergency shut-down procedures",
      "Experience in the process industry.",
      "Problem-solving and critical thinking.",
      "Communication and teamwork"
    ],
    methodology: "Theoretical/Practical",
    objectives: [
      "Understand the principles and methodology of HAZOP.",
      "Identify potential hazards and operational problems in a process.",
      "Develop and implement effective hazard control measures.",
      "Enhance process safety and reliability.",
      "Analyze how the HAZOP technique can be applied at the different stages of a project’s lifecycle such as FEED, detailed design, revalidation and decommissioning",
      "Prepare for a HAZOP workshop, determine the skills and actions necessary to lead a HAZOP and how to generate a HAZOP report"
    ],
    outline: [
      "Module 1: Introduction to HAZOP",
      "Module 2: HAZOP Methodology & Procedure",
      "Phases of Hazop",
      "Module 3: HAZOP Case Studies",
      "Module 4: Hazard Identification and Evaluation",
      "Module 5: Hazard Control Measures",
      "Module 6: HAZOP Documentation and Follow-up / HAZOP worksheet"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $100"
  },

  {
    id: 10,
    title: "Change Management Procedure",
    date: "Oct 2022 - Present",
    description: "A Change Management Procedure course tailored for the oil and gas industry focuses on the unique challenges and complexities associated with change in this sector. This course equips participants with the knowledge and skills to effectively manage change in the oil and gas industry, ensuring that transitions are smooth, safe, and aligned with organizational goals. By focusing on industry-specific challenges and solutions, attendees will be better prepared to lead their teams through successful change initiatives.",
    image: "https://i.ibb.co/PvQJdY5m/change-management-773c716fc19181d78097.png",
    tags: [
      "Trainer: Engr. Magnus"
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Background of EPC (Engineering, Procurement, and Construction) projects"
    ],
    methodology: "Theoretical",
    objectives: [
      "Define the concept of change and change management.",
      "Understand key roles in the change management process.",
      "Determine the phases of change management.",
      "Learn to formulate an effective plan for the change process.",
      "Deeply understand the reasons for resistance to change.",
      "Find out about effective methods of preventing and eliminating resistance to change.",
      "Gain the ability to design fruitful communication related to the change process.",
      "Learn techniques for effective implementation of change.",
      "Develop skills associated with controlling the change process.",
      "Build proficiency in shaping a change-oriented organizational culture."
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: Scope",
      "Module 3: Procedure",
      "Module 4: Authorization",
      "Module 5: Cost of Trend Preparation",
      "Module 6: Cost Effects",
      "Module 7: Schedule Effects",
      "Module 8: Trend meetings",
      "Module 9: Contract Amendments",
      "Module 10: Final Settlement",
      "Module 11: Document Update",
      "Module 12: Roles and Responsibilities",
      "Module 13: Tools and Techniques",
      "Module 14: Communication Plan",
      "Module 15: Monitoring and Continuous Improvement",
      "Module 16: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦80,000 / $60"
  },

  {
    id: 11,
    title: "Material Selection for Process Units Piping",
    date: "Oct 2022 - Present",
    description: "The Material Selection for Process Units Piping Course is designed to provide participants with the necessary skills and knowledge to select appropriate materials for piping systems used in various process units across industries such as oil and gas, chemicals, and manufacturing. The course emphasizes the importance of material selection to ensure safety, reliability, and efficiency in process operations using the following material grades; A312 TP304L, A106 Gr. B/A672 Gr.B60, B165 N04400, A312 TP321H, & A312 TP304.",
    image: "https://ik.imagekit.io/mags/courses/material%20selection.png",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "1 Day",
    prerequisite: [
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of Process Units Piping."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the fundamentals of piping materials and their characteristics.",
      "Identify factors influencing material selection, including corrosion, pressure, temperature, and fluid type.",
      "Learn about industry standards and specifications related to piping chemical materials.",
      "Determine the corrosion rate."
    ],
    outline: [
      "Module 1: Introduction to Process Units Piping",
      "Module 2: Corrosion rate",
      "Module 3: Fuel Gas",
      "Module 4: Natural Gas",
      "Module 5: Methanol Mixtures",
      "Module 6: Process Oxygen",
      "Module 7: Process Condensate",
      "Module 8: Ammonia Water",
      "Module 9: Turbine Condensate",
      "Module 10: Hydrogen Gas",
      "Module 11: Syngas (H2+CO+CO2)",
      "Module 12: Reformed Gas (H2+CO+CO2)"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 12,
    title: "Material Selection for Utility Piping",
    date: "Oct 2022 - Present",
    description: "The Material Selection for Piping Utility Course focuses on the principles and practices of selecting appropriate materials for piping systems in various industries. Participants will learn how to evaluate materials based on their properties, applications, and performance in different environments using the following material grades; A106 Gr.B/A672 Gr.B60, A312 TP304 & A53 Gr. B/GALV",
    image: "https://ik.imagekit.io/mags/courses/material%20selection.png",
    tags: [
      "Trainer: Engr. Majid"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "1 Day",
    prerequisite: [
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of piping utility systems."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the fundamentals of piping materials and their characteristics.",
      "Identify factors influencing material selection, including corrosion, pressure, temperature, and fluid type.",
      "Learn about industry standards and specifications related to piping utility materials.",
      "Determine the corrosion rate."
    ],
    outline: [
      "Module 1: Introduction to Piping Utility Materials",
      "Module 2: Corrosion rate",
      "Module 3: Boiler Blow Down",
      "Module 4: Boiler Feed Water",
      "Module 5: Cooling Water",
      "Module 6: LPS/LPC",
      "Module 7: MPS/MPC",
      "Module 8: Nitrogen",
      "Module 9: Plant Air",
      "Module 10: Service Water",
      "Module 11: Fire Foam",
      "Module 12: Fire Water (AG)",
      "Module 13: Demineralized Water",
      "Module 14: Instrument Air",
      "Module 15: Fire Water (after filter)"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 13,
    title: "Material Selection for Separator & Tanks",
    date: "Oct 2022 - Present",
    description: "The Material Selection for Separators and Tanks Course focuses on the critical aspects of selecting materials for separators and storage tanks used in various industries, particularly in oil and gas, chemicals, and petrochemicals. Participants will gain insight into the unique challenges posed by these applications, including pressure, temperature, and corrosive environments using the material grades; carbon steel & Stainless Steel",
    image: "https://ik.imagekit.io/mags/courses/material%20selection.png",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "1 Day",
    prerequisite: [
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of Separator & Tanks systems."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the fundamentals of piping materials and their characteristics.",
      "Identify factors influencing material selection, including corrosion, pressure, temperature, and fluid type.",
      "Learn about industry standards and specifications related to Separators and Tanks materials.",
      "Determine the corrosion rate."
    ],
    outline: [
      "Module 1: Introduction to Piping Utility Materials",
      "Module 2: Corrosion rate",
      "Module 3: Natural Gas",
      "Module 4: Rich Methanol / Methanol Water",
      "Module 5: LPC/MPC/HPC/MPS",
      "Module 6: BFW+Steam",
      "Module 7: Reformed Gas/ Syngas (H2+CO+CO2)",
      "Module 8: Saturated Natural Gas",
      "Module 9: Ammonia"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 14,
    title: "Material Selection for Turbine & Compressors",
    date: "Oct 2022 - Present",
    description: "The Material Selection for Turbines and Compressors Course is designed to provide participants with a comprehensive understanding of the material selection process for turbines and compressors used in various industries, including power generation, aerospace, and oil and gas. Given the demanding operating conditions these components face, careful material selection is crucial for performance, safety, and longevity using the material grades; carbon steel & Stainless Steel (T>150).",
    image: "https://ik.imagekit.io/mags/courses/material%20selection.png",
    tags: [
      "Trainer: Engr. Majid"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "1 Day",
    prerequisite: [
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of Turbine & Compressors."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the operational principles of turbines and compressors and their material requirements.",
      "Identify the properties and characteristics of materials used in these applications.",
      "Learn about the factors influencing material selection, including temperature, pressure, and corrosive environments.",
      "Explore industry standards and specifications relevant to turbines and compressors.",
      "Develop strategies for assessing and mitigating material failure risks.",
      "Determine the corrosion rate."
    ],
    outline: [
      "Module 1: Introduction to Turbine & Compressors Materials",
      "Module 2: Corrosion rate",
      "Module 3: HPS/LPS",
      "Module 4: HHPS/LPS",
      "Module 5: Nitrogen",
      "Module 6: Syngas (H2+CO+CO2)"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 15,
    title: "Material Selection for Valves",
    date: "Oct 2022 - Present",
    description: "The Material Selection for Valves Course is designed to provide participants with the knowledge and skills necessary to select appropriate materials for valves used in various applications across industries such as oil and gas, chemicals, water treatment, and power generation. Given the critical role valves play in controlling flow and ensuring safety, effective material selection is essential for performance, durability, and reliability using the material grades; SA216 WCB, A351 CF8, SA217 WC6, A216 WCB, Monel.",
    image: "https://ik.imagekit.io/mags/courses/material%20selection.png",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "mechanical",
    duration: "1 Day",
    prerequisite: [
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of Valves."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the types and functions of valves in industrial applications.",
      "Identify the properties of materials commonly used in valve construction.",
      "Learn about the factors influencing material selection, including operating conditions and fluid characteristics.",
      "Explore industry standards and specifications relevant to valve materials.",
      "Develop strategies for assessing and mitigating risks associated with valve material failures.",
      "Determine the corrosion rate."
    ],
    outline: [
      "Module 1: Introduction to Valves",
      "Module 2: Material Properties and Performance",
      "Module 3: Corrosion and Wear Mechanisms",
      "Module 4: Corrosion rate",
      "Module 5: Natural Gas",
      "Module 6: Purge Gas",
      "Module 7: Syngas",
      "Module 8: Process Condensate",
      "Module 9: LPS, MPS, HPS",
      "Module 10: HHPS",
      "Module 11: LPC, MPC, HPC",
      "Module 12: Nitrogen",
      "Module 13: Crude Methanol",
      "Module 14: Flashed Methanol",
      "Module 15: Refined Methanol",
      "Module 16: Process Gas",
      "Module 17: Oxygen."
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦60,000 / $50"
  },

  {
    id: 16,
    title: "Material Selection for Heat Exchanger",
    date: "Oct 2022 - Present",
    description: "The Material Selection for Heat Exchangers Course is designed to provide participants with a thorough understanding of the criteria and processes involved in selecting materials for heat exchangers used in various industries, including oil and gas, chemicals, power generation, and HVAC. Given the critical role heat exchangers play in thermal management, appropriate material selection is essential for efficiency, safety, and durability using the material grades; carbon steel, SA-516 70N, SA-240 304L, SA-266 2N, SA-965 F304L/SA-182 F304 & Stainless Steel.",
    image: "https://ik.imagekit.io/mags/courses/material%20selection.png",
    tags: [
      "Trainer: Engr. Majid"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "1 Day",
    prerequisite: [
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of Heat Exchanger."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the function and types of heat exchangers.",
      "Identify the properties of materials commonly used in heat exchangers.",
      "Learn about the factors influencing material selection, including temperature, pressure, and fluid characteristics.",
      "Explore industry standards and regulations related to heat exchanger materials.",
      "Develop strategies for assessing and mitigating risks associated with material failure.",
      "Determine the corrosion rate."
    ],
    outline: [
      "Module 1: Introduction to Turbine & Compressors Materials",
      "Module 2: Corrosion rate",
      "Module 3: Component of Channel Side (Head, Shell, Channel Flange, Pass Partition, Nozzle, Flange).",
      "Module 4: Component of Heat Transfer (Tie Rod, Spacer, Baffle, Support Plate, Partition Plate, Impingement, Tubesheet, Hex Bolt, Hex Nut, Body Flange, Shell Side Shell, Tubes/U-Tubes, Sealing Strip)."
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 17,
    title: "Material Selection for Chemical Piping",
    date: "Oct 2022 - Present",
    description: "The Material Selection for Piping in Chemical Applications Course is designed to equip professionals with the knowledge and skills necessary to select appropriate materials for piping systems specifically used in the chemical industry. Given the unique challenges posed by corrosive environments, temperature extremes, and varying pressures, this course emphasizes the importance of careful material selection to ensure safety, performance, and longevity using the following material grades; A312 TP304L, A312 TP316L, CPVC & A312 TP304.",
    image: "https://ik.imagekit.io/mags/courses/material%20selection.png",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "1 Day",
    prerequisite: [
      "Several years of experience in the field of engineering, construction, or operations.",
      "A basic understanding of piping chemical systems."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the fundamentals of piping materials and their characteristics.",
      "Identify factors influencing material selection, including corrosion, pressure, temperature, and fluid type.",
      "Learn about industry standards and specifications related to piping chemical materials.",
      "Determine the corrosion rate."
    ],
    outline: [
      "Module 1: Introduction to Chemical Piping Materials",
      "Module 2: Corrosion rate",
      "Module 3: Oxygen Scavenger",
      "Module 4: NAOH Solution",
      "Module 5: Phosphate Solution",
      "Module 6: Crossion Inhibitor (AG)",
      "Module 7: H2SO4",
      "Module 8: HCL Solution (2~40%) (AG)",
      "Module 9: NaClO Solution (10%) (AG)",
      "Module 10: Lube Oil"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 18,
    title: "Multiphase Line Sizing",
    date: "Oct 2022 - Present",
    description: "A multiphase line sizing course typically aims to equip participants with the knowledge and skills necessary to accurately determine the appropriate size for multiphase lines (gas and liquid) in various industrial applications. Either API Rp 14e, IS0 13075 or P001 codes standard will be use for the sizing.",
    image: "https://ik.imagekit.io/mags/courses/multiphase%20line%20sizing.png",
    tags: [
      "Trainer: Engr. Okechukwu"
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Fundamental Concepts of Fluid mechanics, Pipe friction, Reynolds number and Pressure drop.",
      "Knowledge of Pipe schedules and dimensions, Fluid properties, Design parameters, Calculation tools (Excel)"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understanding the essential parameters of fluid flow (flow rate, velocity, pressure drop, etc.)",
      "Understanding the multiphase flow velocity and pressure drop importance and calculation",
      "Surge the typical surge factors.",
      "Understanding the GPSA engineering data book.",
      "Understanding the how to determine friction factor through a pipe.",
      "Understanding Sizing Criteria (Velocity & Pressure Drop) of a multiphase pipeline",
      "Understanding the Erosional and Minimum velocity calculation",
      "Understanding the general and empirical pressure drop calculation along the pipe",
      "Understanding the how to perform multiphase line sizing via codes and standards.",
      "Understanding the how to perform multiphase line sizing via Aspen Hysys"
    ],
    outline: [
      "Module 1: Introduction to gas line sizing parameters (flow rate, velocity, pressure drop, etc.)",
      "Module 2: Surge Factor / Fluid Hammer",
      "Module 3: Introduction to Line Sizing Calculations",
      "Module 4: GPSA engineering data book.",
      "Module 5: Multiphase Line Sizing Standards and Codes",
      "Module 6: Erosional & Minimum Velocity and Pressure drop criterial for Multiphase Line Sizing",
      "Module 7: Multiphase Line Sizing with Excel",
      "Module 8: Multiphase Line Sizing with Aspen Hysys"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom, Face to Face or Virtual"
    ],
    cost: "₦90,000 / $80"
  },

  {
    id: 19,
    title: "Pump Sizing",
    date: "Oct 2022 - Present",
    description: "Pump sizing involves determining the right dimensions and capacities of a pump for a specific application. The process includes identifying the pump’s flow rate, head pressure, pump speed, and other related factors. By properly sizing a pump, you can match its performance capabilities to your requirements, ensuring that the pump operates efficiently and reliably. Either API Rp 14e or IS0 13075 codes standard will be use for the sizing.",
    image: "https://ik.imagekit.io/mags/courses/PUMP%20SIZING.png",
    tags: [
      "Trainer: Engr. Magnus"
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Fundamental Concepts of Fluid mechanics.",
      "Basic Knowledge of Pumps and Their Applications",
      "Basic Mathematics",
      "Units and Conversions",
      "Knowledge of Calculation tools (Excel)"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understanding the pump piping",
      "Understanding the difference between Net Positive Suction Head Available (NPSHa) and Net Positive Suction Head Required (NPSHr)",
      "Understanding the Reciprocating, rotary and centrifugal pump suction and Discharge piping systems.",
      "Knowing the effect of cavitation in pump system.",
      "Understanding the various parameters for pump sizing calculation",
      "Learning how to perform pump sizing with Excel",
      "Learning how to perform pump sizing with hysys",
      "Understanding the pump datasheet"
    ],
    outline: [
      "Module 1: Introduction to pump and pump piping",
      "Module 2: Net Positive Suction Head Available (NPSHa) and Net Positive Suction Head Required (NPSHr)",
      "Module 3: Reciprocating, rotary and centrifugal pump suction and Discharge piping systems",
      "Module 4: Cavitation",
      "Module 5: Calculation Inputs, Pump Total Differential Head, Net Positive Suction Head Available, Pump Absorbed Power and Frictional Head Loss.",
      "Module 6: Pump Sizing with Excel",
      "Module 7: Pump Sizing with Aspen Hysys",
      "Module 8: Pump Datasheet"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom, Face to Face or Virtual"
    ],
    cost: "₦120,000 / $100"
  },

  {
    id: 20,
    title: "Oil and Gas Material Selection",
    date: "Oct 2022 - Present",
    description: "The Oil and Gas Material Selection Course is designed to provide participants with a comprehensive understanding of material selection processes specific to the oil and gas industry. The course covers the criteria for choosing materials that can withstand the harsh environments and operational challenges faced in upstream, midstream, and downstream applications.",
    image: "https://ik.imagekit.io/mags/courses/oil%20and%20gas%20selection.png",
    tags: [
      "Trainer: Engr. Majid"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "1 Day",
    prerequisite: [
      "Basic knowledge of the oil and gas industry, including its processes, equipment, and challenges, is beneficial.",
      "Familiarity with various materials used in oil and gas operations (e.g., metals, alloys, polymers, composites)."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the fundamentals of material properties and their relevance in oil and gas applications.",
      "Identify factors affecting material selection, including corrosion, temperature, pressure, and environmental conditions.",
      "Learn about industry standards and regulations governing material selection.",
      "Explore various materials commonly used in the industry, including metals, polymers, and composites."
    ],
    outline: [
      "Module 1: Introduction to Material Selection",
      "Module 2: Material Properties and Behavior",
      "Module 3: Corrosion Mechanisms",
      "Module 4: Material Standards and Specifications",
      "Module 5: Materials Used in Oil and Gas",
      "Module 6: Material selection for Piping Utility",
      "Module 7: Material selection for Piping Chemicals",
      "Module 8: Material selection for Piping Process Units",
      "Module 9: Material selection for separator & Tanks",
      "Module 10: Material selection for Turbine & Compressors",
      "Module 11: Material selection for Heat Exchangers",
      "Module 12: Material selection for Valves"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "0"
  },

  {
    id: 21,
    title: "Process Flow Diagram (PFD)",
    date: "Oct 2022 - Present",
    description: "A course on process flow diagrams (PFDs) typically aims to equip participants with the skills needed to create, interpret, and utilize PFDs effectively across various industries. Participants will gain practical experience in creating and analyzing PFDs, enhancing their ability to communicate processes clearly and drive improvements in their organizations. Participants will gain practical experience in creating and analyzing PFDs, enhancing their ability to communicate processes clearly and drive improvements in their organizations.",
    image: "https://ik.imagekit.io/mags/courses/PFD.png",
    tags: [
      "Trainer: Engr. Lateef"
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "2 Days",
    prerequisite: [
      "Core Engineering Concepts: Basic Thermodynamics, Fluid Mechanics and Unit Operations.",
      "Technical Skills: Computer-Aided Design (CAD): Proficiency in CAD software (e.g., AutoCAD) for creating process diagrams."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the purpose and importance of PFDs in process management.",
      "Learn the standard symbols and notation used in PFDs.",
      "Develop skills to design and analyze process flow diagrams.",
      "Apply PFDs for process improvement and communication."
    ],
    outline: [
      "Module 1: Introduction to Process Flow Diagrams",
      "Module 2: Fundamental Concepts",
      "Module 3: Standard Symbols and Notation",
      "Module 4: Designing a Process Flow Diagram",
      "Module 5: Analyzing and Interpreting PFDs",
      "Module 6: Case Studies and Applications",
      "Module 7: Process Improvement Techniques",
      "Module 8: Final Project"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦80,000 / $60"
  },
{
    id: 10,
    title: "Piping & Instrumentation Diagram (P&ID)",
    date: "Oct 2022 - Present",
    description: "A course on Piping and Instrumentation Diagrams (P&IDs) focuses on teaching participants how to create, interpret, and utilize these critical diagrams in engineering and industrial settings. P&IDs are essential for understanding the design, operation, and maintenance of process systems. Participants will gain a solid understanding of P&IDs, equipping them with the skills needed to create and analyze these diagrams effectively, enhancing their ability to contribute to project success and safety in their respective fields.",
    image: "https://ik.imagekit.io/mags/courses/p%20and%20id.png",
    tags: [
      "Trainer: Engr. Lateef"
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Core Engineering Concepts: Basic Thermodynamics, Fluid Mechanics and Unit Operations.",
      "Technical Skills: Computer-Aided Design (CAD): Proficiency in CAD software (e.g., AutoCAD) for creating process diagrams.",
      "Knowledge of PFD"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the purpose and importance of P&IDs in process design and safety.",
      "Learn the standard symbols and conventions used in P&IDs.",
      "Develop skills to create and analyze P&IDs effectively.",
      "Apply P&IDs in project documentation and process safety management."
    ],
    outline: [
      "Module 1: Introduction to Process Flow Diagrams",
      "Module 2: Importance of Reading P & IDs in Industry",
      "Module 3: P & ID Structure and Typical Information",
      "Module 4: Legend Sheet/Master Sheet – The Key for Reading P&IDs",
      "Module 5: Symbols and Meanings on a P&ID",
      "Module 6: Valves in Control Loops and Primary Flow Elements.",
      "Module 7: Line Designation, Equipment, Instrument & Fitting Tagging",
      "Module 8: Insights into How Process Operations are controlled",
      "Module 9: Reading and Interpretation of P&ID",
      "Module 10: Drafting of P&ID",
      "Module 11: Case Studies / Project Work"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦80,000 / $60"
  },
  // {
  //   id: 11,
  //   title: "Pressure Safety Valve Sizing",
  //   date: "Oct 2022 - Present",
  //   description: "Pressure Safety Valves (PSV) are utilized and engineered into designs to relieve pressure in emergency conditions. PSVs are used in numerous industries and can be designed in many different ways depending on the needs of the system. This course will get you accustomed to PSVs and show you how to size and select the appropriate one for your needs. Either ISA 75.01.01, IEC 60534-2-1, API 609, DEP.32.36.01.17-GEN, AWWA C504 codes standard will be use for the sizing.",
  //   image: "https://ik.imagekit.io/mags/courses/Pressure%20Safety%20Valve%20Sizing.png",
  //   tags: [
  //     "Trainer: Engr. Lateef"
  //   ],
  //   category: "process",
  //   github: "https://github.com/Joseffl/react-todo-app",
  //   webapp: "https://bit.ly/47GF1It",
  //   duration: "3 Days",
  //   prerequisite: [
  //     "Basic Engineering Principles; (Thermodynamics, Fluid Mechanics, Statics and Dynamics).",
  //     "Basic Mathematics",
  //     "Units and Conversions",
  //     "Process Safety Knowledge",
  //     "Knowledge of Calculation tools (Excel)"
  //   ],
  //   methodology: "Theoretical",
  //   objectives: [
  //     "Explain the various applications of Codes and standards for sizing a PSV.",
  //     "Understand the various types of PSVs and steps for sizing.",
  //     "Perform calculations for sizing and selection of pressure relief devices for gas, liquid and steam",
  //     "Explain how to apply the API RP 520 Part I, Sizing and Selection of Pressure Relieving Devices.",
  //     "Understand the different scenarios for PSV application",
  //     "Perform various PSV sizing with excel-sheet and hysys"
  //   ],
  //   outline: [
  //     "Module 1: Introduction and Overview of PSVs",
  //     "Module 2: Codes, Standards, & Components of a PSV System",
  //     "Module 3: Types of PSVs & Steps for Sizing",
  //     "Module 4: Different Relieving Scenarios",
  //     "Module 5: PSV Sizing",
  //     "Module 6: Sizing application on Gas, Liquid and steam.",
  //     "Module 7: PSV Sizing with Aspen Hysys",
  //     "Module 8: PSV Datasheet"
  //   ],
  //   assessment: "Online Written Exam",
  //   cdf: [
  //     "Classroom, Face to Face or Virtual"
  //   ],
  //   cost: "₦150,000 / $130"
  // },
  {
    id: 12,
    title: "Plant Layout & Spacing (GE GAP Guidelines)",
    date: "Oct 2022 - Present",
    description: "A plant layout course typically covers the design and arrangement of facilities, equipment, and resources in a manufacturing or service environment. Plant layouts have a major influence on the operation of a plant. An improper layout design can lead to hazardous situations, impractical maintenance or reduced plant efficiency. These can have a significant financial impact for the owner of the plant. So understanding the various considerations that come with determining a plant layout is important for designing a proper layout. In this course different considerations are discussed for different levels of layout design and applications. This will increase your understanding of what has to be taken into account when positioning your equipment’s during designing the plant layout. Topics include safety, proximity, maintenance, constructability, practicality and economic considerations. After this course participants will have the knowledge to design a basic plant layout. The following codes and standard are referred; API 500, API 2510, API RP 752, NFPA 30, NFPA 50A, NFPA 58, NFPA 59.",
    image: "https://ik.imagekit.io/mags/courses/PLANT%20LAYOUT.png?updatedAt=1767612734417",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "plant drafting",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Affinity with industrial plants"
    ],
    methodology: "Theoretical",
    objectives: [
      "Knowledge of process industry plants",
      "Understand the overview of the plant layout considerations",
      "Identify the potential hazards on a plant and incorporate them in your layout design",
      "Knowledge of GE GAP Guidelines and Industrial Risk Insurers (IRI) requirements",
      "Understand the spacing’s for various unit operations and equipment’s as per codes and standards & manufacturer recommendation.",
      "Perform an inter/intra unit operations/equipment’s spacing for oil, gas and chemical plants"
    ],
    outline: [
      "Module 1: Introduction to process industry plants",
      "Module 2: Identify different types of industrial plants.",
      "Module 3: GE GAP Guidelines",
      "Module 4: Industrial Risk Insurers (IRI) requirements",
      "Module 5: Layout Consideration",
      "Module 6: Plant Spacing",
      "Module 7: Process Equipment Spacing",
      "Module 8: Specific Facilities",
      "Module 9: Building siting in process plants",
      "Module 10: Process Units to Offplot Facility Spacing",
      "Module 11: Case Studies and Applications"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $100"
  },
  {
    id: 13,
    title: "Installation of Stationary Pumps for Fire Protection",
    date: "Oct 2022 - Present",
    description: "The installation of stationary pumps for fire protection is a critical aspect of ensuring that a facility or structure is adequately protected in the event of a fire. These pumps are designed to provide a reliable and sufficient supply of water to fire suppression systems such as sprinklers, hydrants, and other fire protection equipment. The scope of this training shall include liquid supplies; suction, discharge, and auxiliary equipment; power supplies, including power supply arrangements; electric drive and control; diesel engine drive and control; steam turbine drive and control; and acceptance tests and operation. Standards and regulations (NFPA 20, NFPA 13, NFPA 22, NFPA 24, NFPA 25, NFPA 37, NFPA 51B, NFPA 70, NFPA 70E, NFPA 72, NFPA 110, etc.) This course equips participants with solid understanding of the principles and practices for installing and maintaining stationary fire protection pumps, ensuring reliable and compliant systems that meet both safety standards and operational requirements.",
    image: "https://ik.imagekit.io/mags/courses/STANDARD%20FOR%20%20THE%20INSTALLATION%20OF%20STATIONARY%20PUMPS%20FOR%20FIRE%20PROTECTION.png?updatedAt=1767612759052",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Basic Understanding of Fire Protection Systems",
      "Basic Knowledge of Hydraulics and Fluid Mechanics",
      "Familiarity with Plumbing and Piping Systems",
      "Basic Knowledge of Pumping Equipment"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the role of fire protection systems and the importance of pumps in these systems.",
      "Familiarize participants with the different types of fire protection pumps.",
      "Learn about the key design principles and considerations when installing fire protection pumps",
      "Step-by-step process for the actual installation of fire protection pumps.",
      "Equip participants with the skills to maintain and troubleshoot fire protection pumps to ensure long-term reliability.",
      "Understand the testing and commissioning procedures to ensure that the pump system is functioning correctly.",
      "Learn about the necessary documentation and compliance requirements for fire protection pump systems.",
      "Review real-world examples and best practices for fire protection pump installation."
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: General Requirements.",
      "Module 3: Types of Fire Protection Pumps",
      "Module 4: Applications of the types of Fire Protection Pumps",
      "Module 5: Design Considerations for Fire Protection Pump Installation",
      "Module 6: Pump Installation Procedures",
      "Module 7: Acceptance testing, performance and Maintenance",
      "Module 8: Fire Protection Pump System Documentation and Compliance",
      "Module 9: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $100"
  },

  
  {
    id: 10,
    title: "Atmospheric and Low Pressure Storage Tank Venting",
    date: "Oct 2022 - Present",
    description:
    [
      "Atmospheric and Low Pressure Storage Tank Venting refers to the systems and practices used to manage the pressure and venting of gases from storage tanks, specifically for liquids such as crude oil, chemicals, and petroleum products, that are stored under atmospheric or low-pressure conditions.", 
      "Storage tanks are common in industries such as oil and gas, chemicals, and petrochemicals, where they are used to store liquids and gases. Proper venting is crucial to maintain the safety of these tanks and prevent hazardous conditions such as overpressure, vacuum, or the release of toxic vapors.",
      "This course is crucial for professionals in industries dealing with large-scale storage tanks. It provides the knowledge necessary to ensure safe and environmentally responsible operations, focusing on the importance of properly designed and maintained venting systems. By understanding the principles of venting, design calculations, safety protocols, and relevant codes, participants can help prevent tank damage, environmental hazards, and ensure compliance with regulatory standards."


    ],
      image:
      "https://i.ibb.co/3mg5pYxw/ATMOSPHERIC-AND-LOW-PRESSURE-STORAGE-TANK-VENTING-2c6bb4c7755892091651.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Engineering Knowledge",
      "Understanding of Storage Tanks and Tank Operations",
      "Basic Process Safety Management (PSM)",
      "Knowledge of Basic Venting Principles",
      "Familiarity with Codes and Standards",
      "API Standards: (API 2000 & NFPA 30)"



    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the basic principles and purpose of venting in atmospheric and low-pressure storage tanks.",
          "Design, size, and select appropriate venting systems to ensure tank safety, environmental compliance, and operational efficiency.",
          "Understand relevant industry standards (e.g., API 2000, NFPA) and apply them to their operations.",
          "Recognize and mitigate risks associated with overpressure, vacuum conditions, and emissions.",
          "Maintain and troubleshoot venting systems to ensure optimal and safe tank operation."






                  
    ],
    outline: [
        "Module 1:   Introduction to Storage Tanks",
        "Module 2:   Venting Systems Overview.",
        "Module 3:   Venting Design Considerations",
        "Module 4:   Safety and Environmental Considerations",
        "Module 5:   Venting Systems and Codes/Standards ",
        "Module 6:   Sizing and Selection of Venting Equipment",
        "Module 7:   Operational Procedures and Monitoring",
        "Module 8:   Maintenance of Venting Systems",
        "Module 9:   Case Studies "








    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦150,000 / $120"
  },
{
    id: 10,
    title: "Strainers",
    date: "Oct 2022 - Present",
    description: "Strainers Course typically focuses on the design, selection, installation, and maintenance of strainers used in industrial systems to filter debris, particulates, and contaminants from fluids (liquids or gases). This course will not only improve participant’s understanding of the technology behind strainers but also help them develop practical skills for maintaining reliable, efficient, and safe filtration systems. Whether you’re involved in industrial process design, maintenance, or operations, such training can improve system performance, reduce downtime, and ensure compliance with safety standards. The following codes and standards will be reference for this training; ASME, ASTM (A216, A351 & A312), API (614 & 610), ISO (9001 & 15156), MSS (SP-40, SP-45 & SP-82), NFPA (20 & 30), ANSI (B16.34 & B16.5), depending on the specific application of the strainer.",
    image: "https://ik.imagekit.io/mags/courses/STRAINERS.png",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Basic Engineering or Technical Background",
      "Understanding of Pipeline Systems",
      "Experience or Basic Knowledge of Strainers and Filtration Systems"
    ],
    methodology: "Theoretical",
    objectives: [
      "Identify different types of strainers and their appropriate applications in fluid systems.",
      "Select and size strainers correctly for various flow conditions, considering factors like pressure, flow rate, and filtration needs.",
      "Install and integrate strainers into systems following industry standards and best practices.",
      "Troubleshoot common issues related to strainer performance, such as clogging or pressure drop.",
      "Maintain and clean strainers, ensuring they operate at peak performance over time.",
      "Comply with safety and regulatory standards in strainer installation and operation."
    ],
    outline: [
      "Module 1: Introduction to Strainers",
      "Module 2: Strainer Design and Selection",
      "Module 3: Strainer Installation",
      "Module 4: Operation and Performance",
      "Module 5: Maintenance and Troubleshooting",
      "Module 6: Safety and Compliance",
      "Module 7: Strainer Testing and Commissioning",
      "Module 8: Specialized Strainer Applications",
      "Module 9: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },

  {
    id: 11,
    title: "Fired Heaters for General Refinery Service",
    date: "Oct 2022 - Present",
    description: " Fired Heater for General Refinery Service course typically covers the design, operation, maintenance, and safety aspects of fired heaters used in refinery processes. Fired heaters are essential pieces of equipment in refineries, used to provide heat to various processes, such as distillation, cracking, reforming, and hydroprocessing. A course on fired heaters for general refinery service would provide a comprehensive understanding of how these heaters work, the types of fired heaters used in refineries, and the key factors in ensuring their reliable and safe operation. The following codes and standards will be use; ANSI/API 560, ISO 13705.",
    image: "https://i.ibb.co/PvQJdY5m/fired-heaters.png",
    tags: [
      "Trainer: Engr. Majid"
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Basic Engineering Knowledge",
      "Refinery Operations Knowledge",
      "Fundamental Thermodynamics"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the role of fired heaters in refinery operations.",
      "Design, operate, and maintain fired heaters with a focus on safety, reliability, and efficiency.",
      "Troubleshoot common operational issues and understand key performance metrics.",
      "Implement best practices in emissions control and energy optimization.",
      "Safely manage startup, shutdown, and emergency situations related to fired heaters."
    ],
    outline: [
      "Module 1: Introduction to Fired Heaters",
      "Module 2: Design Considerations.",
      "Module 3: Fired Heater Components",
      "Module 4: Tubes & Tube supports.",
      "Module 5: Headers",
      "Module 6: Piping, terminals and manifolds",
      "Module 7: Refractories and insulation",
      "Module 8: Burners and auxiliary",
      "Module 9: Instrument and auxiliary connections",
      "Module 10: Shop fabrication and field erection",
      "Module 11: Fired Heater Operation",
      "Module 12: Inspection, examination and testing",
      "Module 13: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦130,000 / $100"
  },

  {
    id: 10,
    title: "Absorption & Stripping ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Absorption and stripping are important processes used in chemical engineering, particularly in the treatment of gases and liquids. These processes are applied to separate components of mixtures by utilizing differences in their physical properties, such as solubility or volatility",

      "Absorption and Stripping Course equips professionals with the knowledge and skills necessary to understand, design, and optimize these important processes in the chemical, petroleum, and environmental sectors. By focusing on the theoretical principles, practical design, and operational considerations, participants can improve the efficiency, safety, and sustainability of industrial operations involving absorption and stripping."



    ],
      image:
      "https://i.ibb.co/p6RjFsvF/ABSORPTION-AND-STRIPPING-dffcb2e377c4796877bd.png",
    tags: [
      'Trainer: Engr. Adeyemi',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "A strong foundation in chemical engineering principles, mass transfer concepts, and basic equipment design is key to fully understanding the complexities of absorption and stripping processes.",
      " 	Basic Chemical Engineering Principles ",
      "	  Mass Transfer Fundamentals ",
      " 	Chemical Process Equipment"






    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the basic principles and mechanisms of absorption and stripping processes.",
          "Design and optimize absorption and stripping systems for various industrial applications.",
          "Select appropriate solvents and process conditions based on system requirements.",
          "Troubleshoot common operational problems in absorption and stripping columns.",
          "Assess the energy efficiency and economic feasibility of absorption and stripping processes"









                  
    ],
    outline: [
        "Module 1:  Introduction to Absorption and Stripping",
        "Module 2:  Absorption Process.",
        "Module 3:  Stripping Process",
        "Module 4:  Mass Transfer in Absorption and Stripping",
        "Module 5:  Design of Absorption and Stripping Columns",
        "Module 6: Solvent Selection and Management",
        "Module 7:  Operational Consideration",
        "Module 8:  Case Studies and Real-World Applications"











    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦60,000 / $50"
  },


  {
    id: 10,
    title: "Basic Operation & Function of Control Valves ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Control valves are a critical component in industrial processes, regulating the flow of fluids (liquids, gases, or slurries) through a system. Their primary function is to adjust the flow rate based on input from a control system, which can be linked to various process parameters such as pressure, temperature, or level. Control valves are widely used in industries like oil and gas, chemical processing, water treatment, and power generation to ensure optimal process control, system efficiency, and safety.",
      "This Basic Operation & Function of Control Valves Course provides a strong foundation in control valve technology and its applications across various industries. It helps participants understand the critical role of control valves in maintaining operational efficiency and safety within industrial processes."



    ],
      image:
      "https://i.ibb.co/270mC6x5/BASIC-OPERATION-AND-FUNCTION-OF-CONTROL-VALVES-a325b8d8ebff3e414d30.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic Knowledge of Fluid Mechanics.",
      "Basic Understanding of Instrumentation and Control"







    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the terminology related to control valves and their applications across various industries.",
          "Gain knowledge of the basic designs of control valves and their suitability for different process conditions.",
          "Learn how to evaluate characterization and trim design for optimizing valve performance in various applications.",
          "Recognize and address technical considerations related to control valves, including material selection and installation requirements.",
          "Comprehend the force-balance principle and how it relates to actuator functionality and valve operation.",
          "Understand the basic designs of actuators and how they interact with control valves to regulate flow accurately.",
          "Explore the concept of control valve unit action and its impact on system response and flow regulation.",
          "Master the concept of actuator benchset range and its importance in valve calibration for optimal performance.",
          "Gain a solid understanding of the principles behind valve positioners, including how they influence valve control and accuracy.",
          "Learn the mechanics of control loop action, how it interacts with control valves, and its effect on process stability.",
          "Understand control valve packing designs, their role in preventing leaks, and how they maintain valve integrity.",
          "Gain insight into seat leakage considerations, and learn techniques for minimizing or preventing leakage in control valve systems."










                  
    ],
    outline: [
        "Module 1:   Terminology",
        "Module 2:   Control Valve Basic Designs ",
        "Module 3:   Characterization and Trim Design",
        "Module 4:   Control Valve Technical Considerations ",
        "Module 5:   Force-Balance Principle", 
        "Module 6:   Actuator Basic Designs",
        "Module 7:   Control Valve Unit Action ",
        "Module 8:   Actuator Benchset Range",
        "Module 9:   Valve Positioner Basics",
        "Module 10:  Control Loop Action ",
        "Module 11:  Control Valve Packing Designs ",
        "Module 12:  Seat Leakage",
        "Module 13:  Case Studies "












    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦60,000 / $50"
  },

  
  {
    id: 10,
    title: "Boiler Emergencies and Solution ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Boilers are critical components in various industrial systems, generating steam or hot water for processes such as heating, power generation, and manufacturing. However, due to their high-pressure, high-temperature environment, boilers can face several emergency situations that may lead to equipment damage, downtime, or safety hazards. Understanding these emergencies and the corresponding solutions is essential for maintaining safe and efficient boiler operations.", 

      "The course focuses on identifying common boiler emergencies, understanding their causes, and providing practical solutions and safety protocols to mitigate risks. It is tailored for plant operators, engineers, and maintenance personnel working with boiler systems, aiming to improve their emergency response skills and reduce downtime caused by boiler failures"


    ],
      image:
      "https://i.ibb.co/pjBmVWd8/BOILER-EMERGENCIES-6f5a6da598dc633b79a2.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Knowledge of Boiler Systems.",
      "General Safety Awareness"







    ],
    methodology: "Theoretical",
    objectives: [
          "To understand the basic components, types, and functions of a boiler, and to explain its role in industrial applications, focusing on heat transfer, combustion, and steam generation.",
          "To identify the causes and effects of low and low-low drum level conditions, and to learn the corrective actions and safety protocols to maintain optimal drum levels in a boiler.",
          "To recognize the risks associated with high and high-high drum level conditions and to develop skills in diagnosing, troubleshooting, and mitigating high drum level issues.",
          "To understand the causes and consequences of high and high-high furnace draft pressures, and to learn methods for controlling and stabilizing furnace draft for safe and efficient combustion.",
          "To identify the causes of high bed temperatures in a boiler system, and to learn corrective actions for managing and reducing excessive bed temperatures to ensure safe operation.",
          "To recognize the impact of low bed temperatures on combustion efficiency and boiler performance, and to develop strategies to maintain proper bed temperatures in the boiler system.",
          "To understand the function of water walls, screen tubes, and evaporator tubes, and to identify the causes, symptoms, and corrective actions for tube failures in these critical components.",
          "To understand the role of super heater tubes in steam generation, and to identify the causes and solutions for super heater tube failures, including troubleshooting and replacement procedures.",
          "To recognize the causes and risks of high super heater temperatures, and to learn the techniques for managing and reducing super heater temperature to prevent damage and ensure optimal steam quality.",
          "To identify the consequences of low super heater temperatures, and to understand the corrective actions required to restore the super heater to its optimal temperature range for efficient boiler operation.",
          "To understand the causes of flame failure in the combustion process, and to learn the procedures for diagnosing and resolving flame failure issues to maintain safe and efficient boiler operation.",
          "To learn the causes and safety risks of furnace explosions, and to develop the skills needed to prevent, detect, and respond effectively to furnace explosion incidents.",
          "To understand the causes and hazards of high boiler pressure, and to develop skills in monitoring, controlling, and safely managing high pressure situations in the boiler system.",
          "To identify the causes and symptoms of coal feeder failure, and to learn the troubleshooting techniques and corrective actions necessary to restore coal feeder functionality and maintain efficient combustion.",
          "To understand the role of PAH (Primary Air Heater) and SAH (Secondary Air Heater) tubes in boiler systems, and to identify the causes of tube failures, along with methods for detecting and addressing these issues.",
          "To recognize the importance of boiler feed pumps, understand the causes of feed pump failure, and to learn the steps for diagnosing and repairing feed pump issues to ensure proper water circulation.",
          "To understand the function of fans in maintaining airflow and combustion efficiency, and to learn the causes, symptoms, and corrective actions for fan failure to prevent operational disruptions."










                  
    ],
    outline: [
        "Module 1:   Introduction to Boilers and Their Function",
        "Module 2:   Drum level low and low-low.",
        "Module 3:   Drum level high and high high",
        "Module 4:   Furnace Draft high and high high",
        "Module 5:   Bed Temperature High ",
        "Module 6:   Bed Temperature Low",
        "Module 7:   Water wall / screen tube / evaporator tube failure",
        "Module 8:   Super heater tube failure",
        "Module 9:   High super heater temperature",
        "Module 10:  Low Super heater temperature",
        "Module 11:  Flame Failure",
        "Module 12:  Furnace Explosion",
        "Module 13:  Boiler pressure high",
        "Module 14:  Coal feeder failure",
        "Module 15:  PAH / SAH tube failure",
        "Module 16:  Boiler feed pump failure",
        "Module 17:  Fan Failure",
        "Module 18:  Case Studies"













    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦120,000 / $100"
  },


  {
    id: 10,
    title: "Auxiliary System of the Gas Turbine ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Gas turbines are widely used in power generation, aviation, and industrial applications due to their high efficiency and reliability. To ensure optimal performance, gas turbines rely on various auxiliary systems that support their operation. These systems handle everything from fuel supply and lubrication to cooling, control, and protection.", 
      "Auxiliary System of the Gas Turbine Course is designed to provide participants with an in-depth understanding of the auxiliary systems that support the operation and performance of gas turbines in various industries, such as power generation, aviation, and oil & gas. The auxiliary systems play a critical role in ensuring the safe, efficient, and reliable operation of gas turbines, which are key components in many industrial applications."


    ],
      image:
      "https://i.ibb.co/Kj5ntCD3/AUXILLARY-SYSTEM-OF-THE-GAS-TURBINE-66cd4fd713262cee18aa.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "To benefit from this course, participants should have: ",
      " 	Basic Engineering Knowledge.",
      "	  Mechanical/Electrical Experience.",
      "	  Safety Training."







    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the key auxiliary systems supporting the operation of gas turbines.",
          "Troubleshoot and maintain lubrication, fuel, air, cooling, and control systems.",
          "Optimize the performance and reliability of gas turbine systems by managing auxiliary systems effectively.",
          "Understand the role of emissions and exhaust systems in maintaining regulatory compliance.",
          "Apply best practices for maintenance and predictive analysis to ensure continuous and safe operation of gas turbines."









                  
    ],
    outline: [
        "Module 1:   Introduction to Gas Turbines and Auxiliary Systems",
        "Module 2:   Lubrication System.",
        "Module 3:   Fuel System",
        "Module 4:   Air and Cooling System",
        "Module 5:   Starting and Shutdown Systems ",
        "Module 6:   Control and Monitoring Systems",
        "Module 7:   Exhaust and Emissions Control",
        "Module 8:   Vibration and Monitoring Systems ",
        "Module 9:   Case Studies " 














    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦70,000 / $50"
  },


  {
    id: 10,
    title: "API Centrifugal Pump ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "API centrifugal pump is a type of centrifugal pump specifically designed and manufactured to meet the standards set by the American Petroleum Institute (API) for use in the petroleum, chemical, and natural gas industries. These pumps are widely used for handling liquids such as crude oil, refined products, chemicals, and other process fluids that require high efficiency, reliability, and safety in demanding industrial environments.", 
      "API Centrifugal Pump Course focuses on the design, operation, maintenance, and troubleshooting of centrifugal pumps used in industrial applications, particularly in the petroleum, chemical, and gas industries. The course typically aligns with the American Petroleum Institute (API) standards, which provide guidelines and best practices for pumps used in these sectors, ensuring reliability, safety, and efficiency."


    ],
      image:
      "https://i.ibb.co/hxxTLds8/api-centrifugal-pump.png",
    tags: [
      'Trainer: Engr. Adeyemi',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "To benefit from the course, participants should have: ",
      "•	Basic Engineering Knowledge.",
      "•	Familiarity with Pumps.",
      "•	Safety Awareness."








    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the design, operation, and selection of centrifugal pumps as per API 610 standards.",
          "Perform regular maintenance and troubleshoot common centrifugal pump issues.",
          "Apply performance monitoring techniques to ensure optimal pump operation.",
          "Implement safety protocols and ensure environmental compliance in pump operations.",
          "Design, select, and install pumps for specific applications within petroleum, chemical, and gas industries."









                  
    ],
    outline: [
        "Module 1:   API Pump Type Definitions.", 
        "Module 2:   Understanding API Standards.",
        "Module 3:   API Standards for Pumps",
        "Module 4:   Pump Design and Selection",
        "Module 5:   API  Pumps and applications",
        "Module 6:   Case Studies"















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦50,000 / $40"
  },



  {
    id: 10,
    title: "Carbon Steel ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Carbon steel is a type of steel that is primarily composed of iron and carbon, with small amounts of other elements like manganese, silicon, and copper. Carbon steel is one of the most widely used materials in the manufacturing and construction industries due to its strength, versatility, and cost-effectiveness.",
      "Carbon Steel Course provides critical knowledge of one of the most widely used materials in engineering and manufacturing. From understanding its properties and applications to mastering testing and maintenance procedures, this course is essential for professionals working with carbon steel across many industries."


    ],
      image:
      "https://i.ibb.co/Hp4VnGpN/CARBON-STEEL-a8c7516bd0d01687fb70.png",
    tags: [
      'Trainer: Engr. Adeyemi',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "	Educational Background",
      "	Basic Understanding of Materials Science",
      "	Basic understanding of industrial safety procedures when working with metals or machinery."










    ],
    methodology: "Theoretical",
    objectives: [
          "Demonstrate a comprehensive understanding of carbon steel, its properties, and applications.",
          "Apply standards, codes, and best practices related to carbon steel in industrial and commercial settings.",
          "Understand the critical aspects of carbon steel fabrication, testing, and corrosion resistance.",
          "Analyze real-world challenges in using carbon steel and propose solutions based on technical knowledge.",
          "Make informed decisions about the selection and use of carbon steel in various industries."










                  
    ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Technical Background.",
        "Module 3:  Standards and Codes.",
        "Module 4:  Metallurgy",
        "Module 5:  Properties",
        "Module 6:  Oxidation Resistance",
        "Module 7:  Fabrication",
        "Module 8:  Applications",
        "Module 9:  Corrosion and Protective Coatings",
        "Module 10: Testing and Inspection",
        "Module 11: Case Studies"


















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦50,000 / $40"
  },

  
  {
    id: 10,
    title: "Calibration - Technicians Guide ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Calibration is the process of adjusting and verifying the accuracy of measuring instruments to ensure that they provide accurate, consistent, and reliable readings. In many fields such as manufacturing, engineering, and process industries, calibration is crucial for quality control, safety, and compliance with regulatory standards.",
      "Calibration Technician's Guide course will equip you with the necessary skills and knowledge to handle and maintain precision instruments. By understanding the principles of calibration, troubleshooting techniques, and industry standards, technicians can help ensure that measurements are accurate and that equipment operates within specified tolerances."


    ],
      image:
      "https://i.ibb.co/nqB0hmX2/CALIBRATION-TECHNICIANS-GUIDE-ebe28aed563c8ad6c14f.png",
    tags: [
      'Trainer: Engr. Adeyemi',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "	Basic Knowledge of Instruments.",
      "	Mathematical and Analytical Skills.",
      "	Safety Awareness."











    ],
    methodology: "Theoretical",
    objectives: [
          "Apply principles and best practices of calibration across different types of instruments and devices.",
          "Understand the importance of maintaining accurate and up-to-date calibration documentation.",
          "Perform the calibration of a wide range of instrumentation, including temperature, pressure, level, flow, final control devices, and process analytical instruments.",
          "Troubleshoot and resolve common issues in calibration, ensuring reliable and accurate measurement in industrial processes."









                  
    ],
    outline: [
        "Module 1:  Calibration principles",
        "Module 2:  Documentation.",
        "Module 3:  Temperature instrumentation calibration",
        "Module 4:  Pressure  instrumentation calibration",
        "Module 5:  Level  instrumentation calibration",  
        "Module 6:  Flow  instrumentation calibration",
        "Module 7:  Final control devices  calibration",
        "Module 8:  Process analytical  instrumentation calibration", 
        "Module 9:  Case Studies "


















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦70,000 / $50"
  },


  {
    id: 10,
    title: "Causes of Delays in EPC, PM ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "EPC and project management delays are complex and often arise from multiple sources, including design errors, procurement issues, regulatory challenges, and poor project management practices. Effective planning, communication, risk management, and timely decision-making are critical in mitigating delays and ensuring projects are completed on schedule. Identifying potential causes early in the project and establishing contingency plans can significantly reduce the impact of these delays on overall project timelines and costs.",
      "Causes of Delays in EPC and Project Management Course provides essential insights into the challenges that project managers and teams face in large-scale projects. By identifying common causes of delays and learning effective mitigation strategies, participants can better manage time, resources, and risks, ensuring more successful project delivery."


    ],
      image:
      "https://i.ibb.co/Kpp1hQsR/CAUSES-OF-DELAYS-IN-EPC-PM-196c448bbedbd84a84c9.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "project management",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "The course is suitable for both beginners and experienced professionals. However, the following may be beneficial: ",
      " 	Basic Knowledge of Project Management.",
      " 	Familiarity with the EPC Industry.",
      " 	Experience with Construction or Engineering Projects."












    ],
    methodology: "Theoretical",
    objectives: [
          "Analyze real-world case studies of EPC projects that faced delays in various phases (engineering, procurement, construction, project management, and finance).",
          "Apply theoretical knowledge from earlier modules to assess the root causes of delays in these case studies.",
          "Identify key lessons learned from the case studies and how these can be applied to future projects to avoid similar delays.",
          "Gain practical insights into effective strategies and best practices for preventing delays and successfully managing EPC projects."









                  
    ],
    outline: [
        "Module 1:   Introduction to EPC and Project Management (PM)",
        "Module 2:   Delays in Engineering.",
        "Module 3:   Delays in Procurement",
        "Module 4:   Delays in Construction",
        "Module 5:   Delays in Project Management",
        "Module 6:   Delays in Finance",
        "Module 7:   Case Studies "



















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 10,
    title: "Compressor",
    date: "Oct 2022 - Present",
    description:
    [
          
      "This comprehensive training program is designed to provide in-depth knowledge on various types of compressors, focusing on centrifugal, reciprocating, and axial compressors. The modules aim to equip engineers, designers, and technicians with the necessary skills to understand the working principles, design considerations, performance characteristics, and practical aspects of compressor operation. Topics will cover both the theoretical and practical aspects of compressor technology, providing the participants with tools and methodologies to estimate, specify, control, and maintain compressors in different industrial applications."

    ],
      image:
      "https://i.ibb.co/0RQx3djW/COMPRESSOR-28d17c48f9d9c07a337b.png",
    tags: [
      'Trainer: Engr. Adeyemi',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic understanding of thermodynamics and fluid mechanics.",
      "Familiarity with mechanical engineering principles, of compressors.",
      "Fundamental knowledge of process engineering in industrial systems (such as chemical, power, and manufacturing plants).",
      "Basic understanding of control systems and instrumentation used in industrial equipment.",
      "Previous experience in compressor operation or design is helpful, though not required for beginners interested in gaining detailed knowledge."













    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the fundamental principles of compressor technology, including the different types of compressors and their applications.",
          "Estimate and select centrifugal compressors using power rating methods and sizing techniques.",
          "Specify and design compressors, including understanding power ratings, sizing considerations, and the importance of metallurgy, shaft seals, and balance pistons.",
          "Evaluate compressor performance characteristics, and develop approaches to optimize and control compressor performance.",
          "Understand and apply mechanical and process design principles for both centrifugal and reciprocating compressors.",
          "Identify and solve unique compressor problems, particularly related to performance and operational issues.",
          "Implement control and instrumentation systems for centrifugal compressors to ensure smooth operation and efficiency.",
          "Understand the design, performance, and maintenance of reciprocating compressors, and apply proper sizing and performance analysis techniques.",
          "Master the sizing techniques for axial compressors and understand their unique characteristics and applications."









                  
    ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Centrifugal Compressor Estimate.",
        "Module 3:  How to specify a compressor; Power rating method and sizing",
        "Module 4:  New Ideas on  Centrifugal Compressor; Metallurgy, design, shaft seals and balance pistons",
        "Module 5:  Approach to compressor performance ",
        "Module 6:  Important performance characteristics",
        "Module 7:  Process and mechanical design",
        "Module 8:  How to control Centrifugal Compressor",
        "Module 9:  How to instrument Centrifugal Compressor ", 
        "Module 10: Unique compressor problems",
        "Module 11: Piston compressor rating",
        "Module 12: Mechanical Design of  Reciprocating Compressor",
        "Module 13: Performance characteristics of  Reciprocating Compressor",
        "Module 14: Installation, operation and maintenance of  Reciprocating Compressor",
        "Module 15: How to size  Axial Compressor",
        "Module 16: Case Studies"




















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦100,000 / $80"
  },


  {
    id: 10,
    title: "Centrifugal Compressor for Petroleum, Chemical and Gas Service Industries",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Centrifugal compressor is a type of dynamic compressor commonly used in petroleum, chemical, and gas service industries due to its high efficiency, reliability, and ability to handle large volumes of gases. These industries rely on centrifugal compressors to boost the pressure of gases for various applications, including refining, natural gas transportation, and chemical processing.", 
      "Centrifugal Compressor for Petroleum, Chemical, and Gas Service Industries course typically focuses on the principles, design, operation, and maintenance of centrifugal compressors used in various industrial applications. These compressors are widely used in the petroleum, chemical, and gas industries for tasks such as gas compression, air handling, and refrigeration. Below is an outline of the key topics often covered in such a course: "

    ],
      image:
      "https://i.ibb.co/vCSNRQT3/Centrifugal-3797efb49e19a5863975.png",
    tags: [
      'Trainer: Engr. Adeyemi',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "The prerequisites typically focus on foundational knowledge in mechanical and chemical engineering principles, as well as an understanding of fluid mechanics, thermodynamics, and industrial systems."












    ],
    methodology: "Theoretical",
    objectives: [
          "In-depth understanding of centrifugal compressor technology and its applications.",
          "Knowledge of design, operation, and troubleshooting techniques for maintaining high-performance compressors.",
          "Ability to identify and resolve common issues related to compressor systems.",
          "Familiarity with safety, maintenance, and regulatory considerations specific to the petroleum, chemical, and gas industries"









                  
    ],
    outline: [
        "Module 1:   Introduction to Centrifugal Compressors",
        "Module 2:   Applications in Petroleum, Chemical, and Gas Industries.",
        "Module 3:   Basic Design",
        "Module 4:   Accessories",
        "Module 5:   Inspection, Testing And preparation for shipment ",
        "Module 6:   Vendors data",
        "Module 7:   Case Studies " 





















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦60,000 / $40"
  },

  {
    id: 10,
    title: "Storage tank inspection",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Storage tank inspection is a crucial part of maintaining the safety, integrity, and operational efficiency of tanks used across various industries, particularly those that store hazardous liquids or chemicals. Regular and thorough inspections help prevent leaks, minimize environmental risks, ensure regulatory compliance, and prolong the life of storage tanks. ",
      "Using advanced inspection methods like ultrasonic testing and magnetic flux leakage, combined with routine visual checks, can identify potential issues early, allowing for timely repairs and ensuring safe tank operation. Proper documentation and adherence to industry standards, such as API 653, ensure that tanks remain safe and compliant throughout their lifecycle.",
      "Storage Tank Inspection Course is designed to provide professionals with the knowledge and skills needed to inspect, evaluate, and maintain storage tanks used in various industries, particularly in the petroleum, chemical, and gas sectors. Storage tanks are essential for the safe storage of liquids, gases, chemicals, and other materials, and their inspection is crucial for ensuring safety, regulatory compliance, and operational efficiency."

    ],
      image:
      "https://i.ibb.co/XnfnwyZ/API-653-s-TORAGE-TANK-INSPECTION-fb1b69744ad3efbdf724.png",
    tags: [
      'Trainer: Engr. Okechuckwu',
    ],
    category: "procurement construction",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "4 Days",
    prerequisite: [
      "Basic Engineering Knowledge",
      "Safety Training",
      "Knowledge of Industry Standards and Codes",
      "Basic Inspection Techniques"












    ],
    methodology: "Theoretical",
    objectives: [
          "Understand and apply industry standards and regulations related to tank inspection.",
          "Effectively conduct visual inspections and non-destructive testing on tanks.",
          "Identify potential risks and failures associated with storage tanks.",
          "Document inspection findings and generate professional reports.",
          "Implement maintenance and repair solutions for common tank problems.",
          "Safely perform inspections, especially in confined spaces or hazardous environments."









                  
    ],
    outline: [
        "Module 1:  Introduction to Storage Tanks",
        "Module 2:  Regulatory and Industry Standards.",
        "Module 3:  Inspection Principles and Techniques",
        "Module 4:  Corrosion and Damage Mechanisms",
        "Module 5:  Risk-Based Inspection (RBI)", 
        "Module 6:  Tank Inspection Reports and Documentation",
        "Module 7:  Maintenance and Repair Procedures",
        "Module 8:  Tank Testing and Testing Procedures",
        "Module 9:  Emergency and Safety Procedures ",
        "Module 10: Case Studies "
 





















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦300,000 / $250"
  },

  {
    id: 10,
    title: "Distillation and Vapor Pressure Measurement in Petroleum Products",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Distillation and vapor pressure measurement are critical techniques in the analysis of petroleum products. These methods provide important information regarding the volatility, purity, and composition of petroleum products such as crude oil, gasoline, diesel, jet fuel, and lubricating oils. ",
      "This course provides in-depth knowledge of distillation and vapor pressure measurement techniques applied to various petroleum products. It covers both theoretical and practical aspects, focusing on the significance of distillation and vapor pressure in the characterization of petroleum and its derivatives. ",
      "The course explores different methods of distillation measurement (at atmospheric and reduced pressures), simulated distillation techniques, and vapor pressure measurements. Additionally, it covers the importance of these measurements for various petroleum products, including crude oil, spark-ignition fuels, diesel fuels, aviation fuels, solvents, and liquefied petroleum gas (LPG). Through case studies and real-world examples, participants will learn how to analyze distillation and vapor pressure data to meet industry standards and optimize production processes.",

    ],
      image:
      "https://i.ibb.co/PZFL72kZ/DISTILLATION-861790fb45f9b577826f.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Chemistry and Thermodynamics.",
      "Petroleum Refining Processes.",
      "Instrumentation and Measurement Techniques.",
      "Safety Standards."













    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the Principles of Distillation and Vapor Pressure",
          "Describe the techniques and equipment used for distillation at atmospheric pressure.",
          "Interpret data and understand the implications of distillation cuts for different petroleum products.",
          "Discuss the principles and methods used for distillation under reduced pressure conditions.",
          "Analyze the advantages and limitations of reduced pressure distillation in petroleum refining.",
          "Understand the process and applications of simulated distillation.",
          "Explain the differences between traditional distillation methods and simulated distillation, particularly for complex petroleum mixtures.",
          "Master the principles and techniques for measuring vapor pressure in petroleum products.",
          "Evaluate the significance of vapor pressure in the storage, handling, and transportation of petroleum products.",
          "Investigate the technology and methods for real-time, on-line measurement of distillation and vapor pressure.",
          "Discuss the benefits and challenges of implementing on-line measurement systems in industrial settings.",
          "Analyze distillation and vapor pressure data for different categories of petroleum products, including crude oil, spark-ignition fuels, diesel, aviation fuels, solvents, and LPG.",
          "Compare data sets to understand product characteristics and regulatory compliance."










                  
    ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Distillation Measurement at Atmospheric Pressure.",
        "Module 3:  Distillation Measurement at Reduced Pressure",
        "Module 4:  Simulated Distillation Measurement",
        "Module 5:  Vapor Pressure Measurement",
        "Module 6:  An Overview of On-Line Measurement for Distillation and Vapor Pressure",
        "Module 7:  Distillation and Vapor Pressure Data of Crude Oil",
        "Module 8:  Distillation and Vapor Pressure Data in Spark-Ignition Fuels",
        "Module 9:  Distillation and Vapor Pressure Data of Diesel Fuels",
        "Module 10: Distillation and Vapor Pressure in Aviation Fuels",
        "Module 11: Distillation and Vapor Pressure Data of Solvents",
        "Module 12: Distillation and Vapor Pressure Data in Liquefied Petroleum Gas.",
        "Module 13: Case Studies "

 





















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦100,000 / $80"
  },

  {
    id: 10,
    title: "Distillation Column Selection and Sizing",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Distillation Column Selection and Sizing is a crucial step in the design and operation of distillation processes, commonly used in the chemical, petrochemical, pharmaceutical, and food industries. The objective of this process is to efficiently separate mixtures of liquids based on their different volatilities.",
      "The Distillation Column Selection and Sizing course provides participants with essential knowledge and practical tools for selecting and sizing distillation columns used in chemical, petroleum, and petrochemical processes. This course covers the fundamental principles of distillation, the history and evolution of distillation technologies, various types of distillation processes, and detailed insights into distillation column internals and their role in effective separation. It further delves into the factors influencing column selection, general design considerations, and how to optimize the design of distillation columns for efficient operation. The course also includes real-world case studies to illustrate the application of these principles in industrial settings."

    ],
      image:
      "https://i.ibb.co/VcZMCt2k/distillation-column-cb1aa93f0c9b3dd7475d.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Participants are expected to have a basic understanding of the following concepts: ",
      "Basic Chemistry and Thermodynamics.",
      "Chemical Engineering Principles.",
      "Basic Process Design.",
      "Petroleum and Chemical Industries."














    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the Principles of Distillation: ",
          "Identify the Different Types of Distillation Processes",
          "Understand the History and Evolution of Distillation",
          "Comprehend the Different Modes of Distillation Operation",
          "Understand Distillation Column Internals",
          "Select Appropriate Column Internals for Specific Applications",
          "Explore the Design Considerations for Distillation Columns",
          "Understand the Process of Selecting the Right Type of Distillation Column",
          "Apply Knowledge to Real-World Case Studies"











                  
    ],
    outline: [
        "Module 1:   Introduction",
        "Module 2:   Scope.",
        "Module 3:   Distillation",
        "Module 4:   Distillation History",
        "Module 5:   Types of Distillation Processes",
        "Module 6:   Mode of Operation",
        "Module 7:   Column Internals",
        "Module 8:   Types of Distillation Column",
        "Module 9:   General Design Consideration",
        "Module 10:  The Selection of Column Internals",
        "Module 11:  Case Studies "


 





















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦100,000 / $80"
  },


{
    id: 10,
    title: "Mechanical Drafting (Equipment & Piping (AutoCAD)) Engineering",
    date: "Oct 2022 - Present",
    description: "Mechanical Drafting (Equipment & Piping) Engineering course is designed to teach students the fundamental skills of mechanical drafting with a focus on equipment and piping systems, using AutoCAD as the primary tool. The course typically emphasizes creating precise technical drawings for mechanical equipment and piping installations, which are crucial in industries like manufacturing, petrochemicals, power plants, and HVAC systems. This course is ideal for individuals pursuing a career in mechanical engineering, industrial design, or construction, where proficiency in drafting mechanical equipment and piping systems is essential.",
    image: "https://ik.imagekit.io/mags/courses/mechanical%20drafting.png",
    tags: [
      "Trainer: Engr. Adeyemi"
    ],
    category: "plant drafting",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "8 Days",
    prerequisite: [
      "Basic knowledge of AutoCAD.",
      "Basic understanding of mechanical engineering concepts.",
      "Basic mathematics and geometry skills.",
      "Familiarity with industrial equipment and piping systems."
    ],
    methodology: "Theoretical",
    objectives: [
      "Be proficient in AutoCAD for creating detailed mechanical equipment and piping system drawings.",
      "Understand the principles behind piping systems, equipment layouts, and mechanical system design.",
      "Be able to create both 2D technical drawings and isometric views for piping and equipment systems.",
      "Know how to apply drafting standards, symbols, and conventions in mechanical engineering.",
      "Develop the ability to integrate mechanical equipment with piping systems in real-world design projects.",
      "Understand the importance of quality control and accuracy in mechanical and piping drafting."
    ],
    outline: [
      "Module 1: Introduction to Mechanical Drafting & AutoCAD Basics",
      "Module 2: Basic Mechanical Equipment Drafting.",
      "Module 3: Introduction to Piping Systems",
      "Module 4: Piping Layout and Design",
      "Module 5: Advanced Equipment Drafting",
      "Module 6: Isometric Piping Drawings",
      "Module 7: Drafting Standards and Quality Control",
      "Module 8: Final Project – Equipment and Piping System Design",
      "Module 9: Final Review, Presentation & Exam"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $90"
  },

  {
    id: 11,
    title: "Introduction to Oil and Gas",
    date: "Oct 2022 - Present",
    description: " Oil and gas are two of the most significant sources of energy used globally, powering industries, transportation, and homes. They are both fossil fuels, formed over millions of years from the remains of ancient plants and animals buried and subjected to intense heat and pressure deep within the Earth. The Introduction to Oil and Gas course provides a comprehensive foundation for the world of oil and gas. It is designed to equip students with an understanding of the key components and operations of the industry, from exploration to production, transportation, refining, and distribution. Through a detailed exploration of the upstream, midstream, and downstream sectors, as well as safety systems, utilities, and future trends, this course offers a well-rounded introduction to the oil and gas industry. With a mix of theoretical content, real-world case studies, and a forward-looking perspective, this course prepares participants to understand the challenges and opportunities in the oil and gas industry, and to apply their knowledge to various practical scenarios.",
    image: "https://i.ibb.co/PvQJdY5m/intro-to-oil.png",
    tags: [
      "Trainer: Engr. Magnus"
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "2 Days",
    prerequisite: [
      "This course is designed for individuals with little to no prior knowledge of the oil and gas industry.",
      "Basic Understanding of Science.",
      "Interest or Background in Engineering or Energy."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the structure and operation of the oil and gas industry",
      "Explain the core activities in the upstream sector",
      "Analyze the midstream sector's role",
      "Understand the downstream sector",
      "Recognize the importance of associated, utility, and safety systems",
      "Assess future trends in the oil and gas industry.",
      "Apply case study analysis to real-world scenarios."
    ],
    outline: [
      "Module 1: Introduction to oil and gas industry",
      "Module 2: The Upstream Sector.",
      "Module 3: The Midstream Sector.",
      "Module 4: The Downstream Sector.",
      "Module 5: Associated, Utility & Safety Systems",
      "Module 6: Future Trends in the Oil and Gas Industry",
      "Module 7: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦60,000 / $40"
  },

  {
    id: 10,
    title: "Basic Drafting Engineering",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Basic Drafting Engineering course focuses on the foundational skills needed for technical drawing and design in engineering. Drafting is a critical part of the engineering and manufacturing processes, as it involves creating precise, standardized representations of structures, systems, and components. ",
      "Basic Drafting Engineering Course provides an introduction to the principles and practices of technical drawing, aimed at beginners or those seeking foundational skills in drafting. This type of course typically covers both manual and digital drafting techniques, focusing on the creation of accurate and clear drawings used in engineering, architecture, and manufacturing. ",
      "By the end of the course, students will have acquired the basic skills needed to pursue further study or entry-level roles in engineering design, drafting, or architecture. They may continue to explore specialized areas like mechanical drafting, civil engineering drafting, or advanced CAD design."

    ],
      image:
      "https://i.ibb.co/PsmNv0vb/basic-drafting-45b61c50e3368c7eeb03.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "plant drafting",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Basic Mathematics",
      "Basic Computer Skills",
      "Basic Problem-Solving Skills",
      "Interest or Curiosity in Design and Engineering"

















    ],
    methodology: "Theoretical",
    objectives: [
          "Define the concept of change and change management.",
          "Understand key roles in the change management process.",
          "Determine the phases of change management.",
          "Learn to formulate an effective plan for the change process.",
          "Deeply understand the reasons for resistance to change.",
          "Find out about effective methods of preventing and eliminating resistance to change.",
          "Gain the ability to design fruitful communication related to the change process.",
          "Learn techniques for effective implementation of change.",
          "Develop skills associated with controlling the change process.",
          "Build proficiency in shaping a change-oriented organizational culture."














                  
    ],
    outline: [
        "Module 1:   Introduction to Drafting",
        "Module 2:   Drawing Standards and Conventions.",
        "Module 3:   Basic Geometric Constructions",
        "Module 4:   Orthographic Projection (Plant General Arrangement)",
        "Module 5:   Isometric and Axonometric Drawing (Piping)",
        "Module 6:   Introduction to CAD (Computer-Aided Design)",
        "Module 7:   Assembly and Component Drawings",
        "Module 8:   Sectional and Detail Views",
        "Module 9:   Piping and Electrical Drawings (Basic)",
        "Module 10:  Drawing for Manufacturing and Fabrication",
        "Module 11:  Technical Report Writing (Basic)"





 





















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "FREE"
  },


  {
    id: 10,
    title: "Gas Processing Operation",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Gas processing operations involve a series of steps and technologies used to treat and refine natural gas, which is extracted from reservoirs, before it can be transported and used. Natural gas extracted from the ground often contains impurities, such as water, carbon dioxide (CO2), hydrogen sulfide (H2S), and natural gas liquids (NGLs), which need to be removed to meet the quality standards required for transportation and end use. The goal of gas processing is to separate valuable components, remove contaminants, and ensure the gas meets pipeline specifications",
      "This course is ideal for professionals, technicians, engineers, and students interested in pursuing careers or advancing their expertise in the natural gas sector. The focus is on the various processes used to remove impurities, separate natural gas liquids (NGLs), and make natural gas suitable for use in industries like power generation, residential heating, and transportation."

    ],
      image:
      "https://i.ibb.co/fG9PNsZk/gas-processing-f34fd991b24cd32874ad.png",
    tags: [
      'Trainer: Engr. Magnus',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic Science Knowledge.",
      "Basic Engineering Concepts.",
      "Introduction to Gas or Oil Industry"


















    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the composition of natural gas and the types of impurities that need to be removed.",
          "Learn about the key processes involved in natural gas treatment and purification, such as dehydration, sulfur removal, and CO2 removal.",
          "Explore the techniques for separating natural gas liquids (NGLs) and their uses.",
          "Gain practical knowledge of equipment used in gas processing plants (e.g., compressors, distillation columns, heat exchangers).",
          "Learn the safety and regulatory practices in the operation and maintenance of gas processing facilities.",
          "Understand the economic, environmental, and sustainability challenges in gas processing."















                  
    ],
    outline: [
        "Module 1:   Introduction to Gas Processing",
        "Module 2:   Composition and Properties of Natural Gas.",
        "Module 3:   Gas Treatment Processes",
        "Module 4:   Natural Gas Liquids (NGL) Recovery",
        "Module 5:   Gas Processing Equipment",
        "Module 6:   Gas Processing Plant Operations",
        "Module 7:   Safety and Environmental Considerations",
        "Module 8:   Economic and Sustainability Aspects",
        "Module 9:   Case Studies and Industry Trends"






 





















    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
,
    ],
    cost: "₦60,000 / $40"
  },

 {
    id: 10,
    title: "Structural Drafting Engineering",
    date: "Oct 2022 - Present",
    description: "Structural Drafting Engineering is a specialized area of engineering focused on creating detailed technical drawings for the design and construction of structures, such as buildings, bridges, and other infrastructure projects. Structural drafters and engineers use specialized tools and software to produce accurate, detailed, and standardized plans, including structural layouts, component specifications, and material details. These drawings are essential for contractors, fabricators, and construction teams to ensure that structures are built safely, efficiently, and according to design specifications. Structural Drafting Engineering (AutoCAD) course is designed to teach students how to create detailed and accurate structural drawings and designs using AutoCAD. These drawings are essential for the construction and fabrication of buildings, bridges, and other infrastructure projects. The course covers the principles of structural engineering and the application of AutoCAD for creating blueprints, layouts, foundation plans, and reinforcement details.",
    image: "https://i.ibb.co/YFXh30Gp/structural-drafting.png",
    tags: [
      "Trainer: Engr. Majid"
    ],
    category: "plant drafting",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Basic knowledge of civil or structural engineering principles.",
      "Basic proficiency in AutoCAD.",
      "Basic drafting knowledge"
    ],
    methodology: "Theoretical",
    objectives: [
      "Use AutoCAD effectively for creating structural drawings, including foundation plans, framing plans, and reinforcement details.",
      "Understand and apply structural engineering principles to create accurate and efficient drawings.",
      "Create detailed structural layouts for buildings, bridges, and other infrastructure projects.",
      "Develop construction details such as beam and column connections, foundation reinforcement, and structural steel detailing.",
      "Apply industry standards (e.g., AISC, BS, IS, Eurocodes) in the creation of structural drawings."
    ],
    outline: [
      "Module 1: Introduction to Structural Drafting and AutoCAD Basics",
      "Module 2: Structural Drafting Process",
      "Module 3: Structural Drafting Techniques",
      "Module 4: Standards and Codes in Structural Drafting",
      "Module 5: Structural Foundation and Floor Plans.",
      "Module 6: Framing Plans and Structural Components",
      "Module 7: Structural Detailing for Steel and Concrete",
      "Module 8: Beams, Columns, Panels, Stairs, Ladders layouts",
      "Module 9: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },
  {
    id: 10,
    title: "Electrical Drafting (Microsoft Visio) Engineering ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Electrical Drafting (Microsoft Visio) Engineering course focuses on teaching the fundamental skills of electrical drafting using Microsoft Visio as a tool for creating electrical diagrams, circuit layouts, and system schematics. Microsoft Visio is a versatile and widely-used tool for creating various technical diagrams, including electrical schematics, wiring diagrams, and system flowcharts.",
      "Electrical Drafting (Microsoft Visio) Engineering course is designed to teach individuals how to use Microsoft Visio for creating electrical schematics, wiring diagrams, circuit layouts, and other types of electrical drawings. This course is suitable for electrical engineers, designers, and technicians looking to develop skills in visualizing and documenting electrical systems using Visio."
    ],
      image:
      "https://i.ibb.co/4RCgpbdY/electrical-drafting-7aa412a803e5480784d4.png",
    tags: [
      'Trainer: Engr. Adeyemi',
    ],
    category: "plant drafting",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "5 Days",
    prerequisite: [
      "Basic knowledge of electrical systems and components (e.g., circuit breakers, transformers, switches, and conductors).",
      "Familiarity with basic principles of electricity (voltage, current, resistance, power).",
      "Basic understanding of Microsoft Visio."



    ],
    methodology: "Theoretical",
    objectives: [
          "Understand how to use Microsoft Visio as a tool for electrical drafting.",
          "Be able to design and draft electrical schematics, wiring diagrams, and panel layouts.",
          "Apply industry standards for electrical symbols and diagramming conventions.",
          "Create one-line diagrams and electrical circuit diagrams.",
          "Integrate control systems, power distribution, and wiring layouts in Visio.",
          "Prepare clear and accurate electrical documentation suitable for engineering projects and construction."

                  
    ],
    outline: [
        "Module 1:   Introduction to Electrical Drafting and Visio Basics",
        "Module 2:   Electrical Symbols and Diagramming Conventions.",
        "Module 3:   Creating Electrical Schematics",
        "Module 4:   Designing Wiring Diagrams and Panel Layouts",
        "Module 5:   Advanced Electrical Drafting in Visio",
        "Module 6:   Drafting Standards ",
        "Module 7:   Case Studies",
        "Module 8:   Final Project "


    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },

{
    id: 10,
    title: "Process Drafting Engineering (Microsoft Visio)",
    date: "Oct 2022 - Present",
    description: "Process Drafting Engineering (Microsoft Visio) course is designed to teach students how to create detailed process diagrams, equipment layouts, and schematics using Microsoft Visio, which is commonly used for visualizing, documenting, and analyzing process systems in industries like chemical, oil & gas, power generation, and manufacturing. This course focuses on process flow diagrams (PFDs), piping and instrumentation diagrams (P&IDs), equipment layouts, and other process-related drawings.",
    image: "https://i.ibb.co/7dRFZVJW/process-drafting-visio.png",
    tags: ["Trainer: Engr. Adeyemi"],
    category: "plant drafting",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "6 Days",
    prerequisite: [
      "Basic knowledge of process engineering.",
      "Familiarity with Microsoft Visio.",
      "Basic knowledge of drafting principles"
    ],
    methodology: "Theoretical",
    objectives: [
      "Use Microsoft Visio effectively to create process flow diagrams (PFDs), piping and instrumentation diagrams (P&IDs), and other process-related documentation.",
      "Understand and apply industry-standard symbols and conventions for process drafting.",
      "Design equipment layouts, piping systems, and control systems for industrial processes.",
      "Create dynamic and clear process diagrams that are useful for plant design, maintenance, and operations.",
      "Utilize Visio’s advanced features for shapes, templates, and data linking to generate accurate process documentation."
    ],
    outline: [
      "Module 1: Introduction to Process Drafting and Microsoft Visio Basics",
      "Module 2: Creating Process Flow Diagrams (PFDs) in Visio",
      "Module 3: Creating Piping and Instrumentation Diagrams (P&IDs)",
      "Module 4: Advanced Process Drafting Techniques",
      "Module 5: Drafting Standards, Documentation, and Reporting",
      "Module 6: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },
  {
    id: 11,
    title: "Process Drafting Engineering (Autocad)",
    date: "Oct 2022 - Present",
    description: "Process Drafting Engineering refers to the creation and design of technical drawings and diagrams used to represent industrial processes, systems, and equipment layouts. It is a vital discipline within industries such as chemical processing, oil and gas, power generation, and manufacturing. The purpose of process drafting is to ensure that all components of a process system are accurately depicted, well-coordinated, and compliant with industry standards, ensuring efficient operation, safety, and ease of maintenance. Process Drafting Engineering course is designed to teach students how to create technical drawings and schematics for process systems using AutoCAD, one of the most widely used software applications in the field of engineering drafting. This course typically focuses on creating detailed process flow diagrams (PFDs), piping and instrumentation diagrams (P&IDs), and other essential process-related documents, such as equipment layouts, piping systems, and safety drawings. AutoCAD offers precision and the ability to generate complex designs, which makes it invaluable in industries such as chemical, petroleum, power, and manufacturing.",
    image: "https://i.ibb.co/DDKYBqNZ/process-drafting.png",
    tags: ["Trainer: Engr. Majid"],
    category: "plant drafting",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "8 Days",
    prerequisite: [
      "Basic knowledge of process engineering.",
      "Familiarity with AutoCAD",
      "Basic knowledge of drafting principles"
    ],
    methodology: "Theoretical",
    objectives: [
      "Master the use of AutoCAD to design process flow diagrams (PFDs), piping and instrumentation diagrams (P&IDs), and equipment layouts.",
      "Understand the symbols and standards used in process engineering for drafting.",
      "Create detailed and professional process designs, including piping layouts, instrumentation, and control systems.",
      "Apply industry standards such as ISO, ANSI, and other relevant guidelines for process drafting.",
      "Create 3D models of process plants and integrate them into overall layouts.",
      "Develop process documentation for real-world industrial projects."
    ],
    outline: [
      "Module 1: Introduction to Process Drafting and AutoCAD Basics",
      "Module 2: Process Flow Diagrams (PFDs).",
      "Module 3: Piping and Instrumentation Diagrams (P&IDs)",
      "Module 4: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },
  {
    id: 12,
    title: "Process Design of Oil & Gas Separator and Scrubbers",
    date: "Oct 2022 - Present",
    description: " An oil and gas separator is a crucial piece of equipment in the oil and gas industry used to separate the mixed production fluids (oil, gas, water, and other solids) into their individual components. The separator typically works in the upstream segment of the industry, before the fluids undergo further processing or transportation. This course provides a comprehensive understanding of the process design principles for oil & gas separators and scrubbers. It covers theoretical concepts, design calculations, instrumentation integration, and real-world case studies. The course is designed for engineers and technical professionals involved in upstream oil and gas production. Participants will learn how to analyze multiphase flow, apply sizing methodologies, and integrate safety and instrumentation into the design process. Emphasis is placed on practical design tools, API 12J codes and standards.",
    image: "https://i.ibb.co/JWfjKbyh/Process-Design-of-Oil-Gas-Separator-and-Scrubbers.png",
    tags: ["Trainer: Engr. Majid"],
    category: "petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "4 Days",
    prerequisite: [
      "Basic Engineering Knowledge.",
      "Familiarity with Oil & Gas Processes.",
      "Basic understanding of process control and instrumentation.",
      "Fundamentals of Fluid Mechanics.",
      "Experience with Industry Standards."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the role of separators and scrubbers in upstream processing.",
      "Identify and apply key process and mechanical design parameters.",
      "Perform sizing calculations for 2-phase and 3-phase separators as per API 12J codes and standards",
      "Select appropriate instrumentation and control systems.",
      "Evaluate mechanical and structural requirements for vessel design.",
      "Interpret and apply design standards and codes (e.g., API, ASME).",
      "Analyze real-world scenarios and troubleshoot design inefficiencies."
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: Scope.",
      "Module 3: Design Parameters",
      "Module 4: Separator Sizing Specification",
      "Module 5: Instrumentation",
      "Module 6: Mechanical Design Consideration",
      "Module 7: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $120"
  },
  {
    id: 13,
    title: "Refinery Process Design",
    date: "Oct 2022 - Present",
    description: " Refinery Process Design refers to the structured and systematic approach to designing the processes and systems used in the operation of an oil refinery. The objective is to efficiently and safely convert crude oil into various valuable products such as gasoline, diesel, jet fuel, kerosene, liquefied petroleum gas (LPG), and petrochemicals. The design process involves a combination of chemical engineering, process engineering, mechanical engineering, and safety management. This course provides a comprehensive understanding of the key principles and techniques involved in refinery process design. It covers the essential areas of crude oil refining, from the estimation of stream properties and mass balances to the design of major refining units like the crude distillation column. By the end of this course, students will gain the technical knowledge needed to design and optimize refinery processes effectively, ensuring efficient operation and compliance with safety and environmental standards.",
    image: "https://i.ibb.co/VpC9qmVC/refinery-process.png",
    tags: ["Trainer: Engr. Magnus"],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "A basic understanding of chemical engineering principles, including mass and energy balances.",
      "Familiarity with fluid mechanics, thermodynamics, and process control.",
      "Basic knowledge of separation processes and distillation techniques.",
      "Experience using process simulation software.",
      "An introductory level understanding of oil refining processes and operations."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the Fundamentals of Refinery Process Design",
      "Estimate Stream Properties in Refining Systems",
      "Perform Mass Balances in Refinery Design",
      "Design a Crude Distillation Column"
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: Estimation of Refinery Stream Properties.",
      "Module 3: Refinery Mass Balances, Refinery Block diagram and Refinery modeling",
      "Module 4: Design of Crude Distillation Column"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦130,000 / $100"
  },
  {
    id: 14,
    title: "Oil and Gas Separation - Design & Sizing",
    date: "Oct 2022 - Present",
    description: "Hydrocarbon streams as produced at the wellhead are composed of a mixture of gas, liquid hydrocarbons, and sometimes free water. In most cases it is desirable to separate these phases as soon as possible after bringing them to the surface and handle or transport the two or three phases separately. This separation of the liquids from the gas phase is accomplished by passing the well-stream through an oil-gas or oil-gas-water separator. Different design criteria must be used in sizing and selecting a separator for a hydrocarbon stream based on the composition of the fluid mixture. The Oil and Gas Separation (Design & Sizing) course provides an in-depth understanding of the principles, designs, and operational aspects of oil and gas separators, with a focus on optimizing separation processes in oil and gas production facilities. The course covers the construction, types, and factors affecting separation, as well as the detailed design and sizing of separators. Participants will gain insights into various separation equipment, multi-stage systems, and specialized separators for different operational conditions.",
    image: "https://i.ibb.co/ds6jGDbX/oil-and-gas-separation.png",
    tags: ["Trainer: Engr. Magnus"],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "Petroleum engineering fundamentals, including exploration, production, and processing.",
      "Fluid Mechanics concepts, particularly related to gas and liquid flows.",
      "Thermodynamics in the context of separation and phase behavior.",
      "Process engineering principles, including design and operation of equipment in industrial settings."
    ],
    methodology: "Theoretical",
    objectives: [
      "Define the purpose of separation in oil and gas production.",
      "Explain the physical principles behind oil, gas, and water separation processes.",
      "Identify the various types of separators used in the industry.",
      "Understand the factors influencing the selection of separators based on operational conditions.",
      "Apply knowledge to design and size gas and liquid separators based on flow rates and operating conditions.",
      "Perform the calculations for separator capacity, including gas and liquid volume.",
      "Examine the factors such as pressure, temperature, fluid properties, and flow rate that affect the efficiency of separation.",
      "Use engineering principles to optimize separation performance.",
      "Understand the function and application of other equipment used in the separation process, such as filters and scrubbers.",
      "Develop Multi-Stage Separation Systems.",
      "Design and analyze two-stage separation systems for more efficient processing.",
      "Learn about low-temperature gas separation units and filter separators."
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: Construction of Separators.",
      "Module 3: Separator Types",
      "Module 4: Factors Affecting Separation",
      "Module 5: Separator Design - Introduction",
      "Module 6: Separator Design - Gas Capacity",
      "Module 7: Separator Design - Liquid Capacity",
      "Module 8: Other Types Separation Equipment",
      "Module 9: Two Stage Separation System",
      "Module 10: Filter Separators",
      "Module 11: Low Temperature Gas Separation Units",
      "Module 12: Vertical Gas Scrubber",
      "Module 13: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $120"
  },
  {
    id: 15,
    title: "Oil & Gas Separators",
    date: "Oct 2022 - Present",
    description: "The term “oil and gas separator” in oilfield terminology designates a pressure vessel used for separating well fluids produced from oil and gas wells into gaseous and liquid components. A separating vessel may be referred to in the following ways: Oil and gas separator, Separator, Stage separator, Trap, knockout drum, Flash chamber, Expansion separator, Scrubber, Filter. This course describes the design, use, functions, capacities, classifications, performance, operation, and maintenance of oil and gas separators. Vertical, horizontal and spherical separators in both two- and three-phase arrangements are discussed. Quality of effluent fluids is approximated. Equations for calculating the sizes and capacities of separators and capacity curves and tables for sizing oil and gas separators are provided. These capacity curves and tables can be used to estimate capacities of separators as well as to determine the size of separator required to handle given volumes of fluids. Sample calculations for sizing separators are included.",
    image: "https://i.ibb.co/S444NbBS/oil-and-gas-separators.png",
    tags: ["Trainer: Engr. Okechukwu"],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "5 Days",
    prerequisite: [
      "Basic Engineering Knowledge.",
      "Familiarity with Oil & Gas Processes.",
      "Fundamentals of Fluid Mechanics.",
      "Experience with Industry Standards"
    ],
    methodology: "Theoretical",
    objectives: [
      "Recognize the main functions of separators in oil and gas production, and the additional roles they play in ensuring process efficiency.",
      "Identify common challenges in oil and gas separation, including issues like emulsion formation, foaming, and gas-liquid separation.",
      "Understand various methods and technologies used to separate oil from gas and vice versa, ensuring optimal separation efficiency.",
      "Learn about the types and functions of mist extractors in separators, and how they help remove liquid droplets from gas streams.",
      "Gain skills in assessing the quality of separated fluids, ensuring that product specifications are met.",
      "Understand the different types of separators and their applications, including horizontal, vertical, and two-phase separators.",
      "Explore the role of centrifugal separators and gas scrubbers in enhancing separation efficiency.",
      "Learn how to estimate the size and capacity requirements for separators based on operational data and fluid characteristics.",
      "Gain practical knowledge of using computer software tools for sizing separators, streamlining the design process.",
      "Learn to read and apply capacity curves for both vertical and horizontal separators to optimize design and operational efficiency.",
      "Understand the real-world factors that influence separator sizing, including location, process conditions, and flow rates.",
      "Learn how stage separation is implemented to increase the efficiency of oil and gas separation in multi-phase flow systems.",
      "Gain expertise in selecting the appropriate separator or scrubber for specific applications, based on factors like fluid composition and flow rates.",
      "Learn about the codes and standards for constructing oil and gas separators, ensuring compliance with safety and regulatory requirements.",
      "Gain knowledge of the control systems, valves, and safety features that are crucial for the safe and efficient operation of separators.",
      "Learn best practices for the operation, maintenance, and troubleshooting of oil and gas separators to ensure consistent performance and longevity.",
      "Study real-world case studies to understand common challenges and solutions related to separator design, operation, and maintenance."
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: Primary Functions of Oil and Gas.",
      "Module 3: Secondary Functions of Oil and Gas",
      "Module 4: Special Problems in Oil and Gas Separation",
      "Module 5: Methods Used To Remove Oil From Gas in Separators",
      "Module 6: Mist Extractors Used in Oil and Gas Separators",
      "Module 7: Methods Used To Remove Gas From Oil In Separators",
      "Module 8: Estimated Quality of Separated Fluids",
      "Module 9: Classification of Oil and Gas Separators",
      "Module 10: Centrifugal Oil and Gas Separators and Gas Scrubbers",
      "Module 11: Estimating the Sizes and Capacities of Oil and Gas Separators",
      "Module 12: Computer Sizing of Oil and Gas Separators",
      "Module 13: Capacity Curves for Vertical and Horizontal Oil and Gas Separators",
      "Module 14: Practical Considerations in Sizing Oil and Gas Separators",
      "Module 15: Stage Separation of Oil and Gas",
      "Module 16: Selection and Application of Separators and Scrubbers",
      "Module 17: Construction Codes for Oil and Gas Separators",
      "Module 18: Controls, Valves, Accessories, and Safety Features for Oil and Gas Separators",
      "Module 19: Operation and Maintenance Considerations for Oil and Gas Separators",
      "Module 20: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦200,000 / $150"
  },
  {
    id: 16,
    title: "Process Fundamentals",
    date: "Oct 2022 - Present",
    description: "Process fundamentals generally refers to the basic concepts, principles, and components involved in the design, operation, and management of processes. A process can be understood as a series of steps or activities performed to achieve a specific objective, often in the context of business, engineering, or manufacturing. The Process Fundamentals course is designed to provide a foundational understanding of the essential principles and operations in industrial processing, particularly within the chemical and petroleum industries. This course covers key concepts in chemistry, physics, refining processes, separation techniques, and refinery operations. The modules are carefully structured to guide learners through the basic principles, practical applications, and operational aspects of crude oil refining, as well as the specific equipment and processes used in refineries. The course emphasizes both theoretical knowledge and practical skills, using case studies to encourage problem-solving and critical thinking.",
    image: "https://i.ibb.co/NztG34K/process-fundamentals.png",
    tags: ["Trainer: Engr. Lateef"],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "3 Days",
    prerequisite: [
      "This course is suitable for individuals with basic knowledge in science, particularly those with a background in:",
      "General Chemistry",
      "High school Physics or equivalent",
      "Introduction to Chemical Engineering",
      "Familiarity with industrial operations"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the core concepts of chemistry that form the basis for process operations, such as atomic structure, chemical bonding, and reaction mechanisms.",
      "Understand the physical properties of matter (density, viscosity, boiling points, etc.) and their influence on industrial operations, especially in relation to refinery processes.",
      "Understand the overall process of crude oil refining, including distillation, cracking, and conversion processes.",
      "Identify the different products derived from crude oil and their commercial uses.",
      "Learn the basic unit operations involved in process industries, including separation techniques like filtration, distillation, absorption, and membrane processes.",
      "Understand the significance of these operations in the context of refinery processes.",
      "Comprehend the different types and grades of crude oil, as well as their chemical and physical properties.",
      "Understand how these characteristics influence refining processes and the final products.",
      "Get acquainted with the first stages of refinery operations, including crude distillation, and separation of lighter and heavier fractions.",
      "Understand the role of heat exchangers, distillation columns, and other equipment in the refinery.",
      "Learn about secondary refinery operations such as cracking, reforming, and hydroprocessing.",
      "Understand the technology and principles behind these processes and their importance in converting crude oil into valuable products.",
      "Explore the expansion of lube oil production in refineries.",
      "Understand the chemical processes, technologies, and equipment involved in the production of lubricants from crude oil.",
      "Study advanced refinery processes such as alkylation, polymerization, and hydrocracking.",
      "Understand the significance of these processes in the production of high-quality fuels and petrochemicals.",
      "Understand the importance of sampling in process operations.",
      "Learn various sampling techniques for quality control, process monitoring, and testing in refinery settings.",
      "Familiarize with key industry-specific terminology and definitions related to process operations and refinery practices.",
      "Apply knowledge learned throughout the course to real-world case studies."
    ],
    outline: [
      "Module 1: Basic Chemistry",
      "Module 2: Basic Physics & Physical Properties of Matter.",
      "Module 3: Crude Oil Refining",
      "Module 4: Unit Operation/Separation Techniques",
      "Module 5: Characteristics of Crude Oil",
      "Module 6: Refinery I Operations",
      "Module 7: Refinery II Operations",
      "Module 8: Lube Expansion Block",
      "Module 9: Refinery III Operations",
      "Module 10: Sampling",
      "Module 11: Glossary Definitions",
      "Module 12: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦80,000 / $60"
  },


  {
    id: 10,
    title: "Well Servicing and Workover",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Well servicing and workover are essential operations in the life cycle of an oil or gas well. These activities are necessary to maintain well production, repair damaged equipment, or improve well performance. Though related, well servicing and workover operations are distinct in terms of their scope, complexity, and the type of interventions performed.",
      "The Well Servicing and Workover course is designed to provide a comprehensive understanding of the techniques, equipment, and procedures used in well maintenance, repair, and enhancement. Well servicing and workover operations are essential to ensure that oil and gas wells maintain optimal production rates throughout their lifespan. The course covers a range of operations, from light and heavy workovers on live wells to servicing killed wells. Participants will also explore special cases that require unique approaches, along with detailed case studies to highlight real-world challenges and solutions. This course equips participants with the knowledge and skills necessary to safely and efficiently manage well servicing and workover operations."
    ],
      image:
      "https://i.ibb.co/gF6JQVfr/Well-Servicing-and-Workover-a64598162d8161eac24c.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Before enrolling in this course, participants should have the following foundational knowledge:",
      "Basic understanding of petroleum engineering concepts, including well completion, reservoir management, and production techniques.",
      "Familiarity with well operation and wellbore integrity concepts.",
      "Basic knowledge of fluid mechanics, pressure management, and well control.",
      "Prior experience in the oil and gas industry or completion of introductory courses in well operations would be beneficial but is not mandatory."




    ],
    methodology: "Theoretical",
    objectives: [
          "Gain a clear understanding of the importance and role of well servicing and workover operations in maintaining well performance.",
          "Learn the key differences between well servicing and workover operations and when each is necessary.",
          "Understand the various types of operations performed on live wells, including light and heavy workovers, and the different equipment and techniques used.",
          "Learn how to identify the appropriate operation for specific well conditions.",
          "Learn the techniques and equipment used for light servicing operations, including simple repairs, maintenance, and optimization tasks on live wells.",
          "Understand the safety measures and procedures required for light operations on active wells.",
          "Explore the more complex procedures involved in heavy workovers on live wells, such as pulling tubing, replacing equipment, and handling higher risks associated with well control.",
          "Learn about the equipment and safety protocols used during high-risk workover operations.",
          "Learn how to handle operations on wells that have been killed (shut-in), including techniques for re-entry, wellbore cleaning, and re-pressurization.",
          "Understand the unique challenges involved in working with killed wells and how to safely reinitiate production.",
          "Learn about special well servicing and workover cases, including unconventional wells, deepwater operations, and complex reservoir conditions that require customized approaches.",
          "Understand how to approach challenges such as corrosion, scaling, equipment failure, and wellbore damage.",
          "Analyze real-world case studies that highlight various workover scenarios and challenges faced during well servicing.",
          "Explore how different operational strategies, equipment, and safety measures were applied in these cases to resolve issues and optimize well production."


                  
    ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Main types of operation.",
        "Module 3:  Light operations on live wells",
        "Module 4:  Heavy  operations on live wells",
        "Module 5:  Operations on killed wells",
        "Module 6:  Special Cases",
        "Module 7:  Case Studies"





    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 10,
    title: "Artificial Lift",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Artificial lift refers to a variety of techniques used to lift or boost the flow of hydrocarbons from the wellbore to the surface when the natural reservoir pressure is insufficient to bring the fluids (oil, gas, water) to the surface on their own. It is commonly employed in oil and gas fields after the natural reservoir pressure has declined to the point where the well can no longer flow naturally, or when the flow rate needs to be increased for economic reasons.",

      "Artificial lift systems are designed to increase the production rate and maintain the flow of fluids over time. These systems can be mechanical or non-mechanical, depending on the characteristics of the reservoir and the type of fluids being produced.",

      "The Artificial Lift course focuses on the various methods and technologies used to enhance the production of oil and gas from wells where natural reservoir pressure is insufficient to lift fluids to the surface. Artificial lift systems are essential for maintaining production rates and optimizing well performance over time. This course covers key artificial lift methods such as pumping systems and gas lift, providing participants with the knowledge to choose and apply the right artificial lift method based on well conditions and reservoir characteristics. Through practical case studies, participants will also learn how to evaluate, troubleshoot, and optimize artificial lift systems to ensure efficient and cost-effective operations."
    ],
      image:
      "https://i.ibb.co/Mkwh2hKp/Artificial-Lift-ff0b7d16ad0bd6dea0b0.png",
    tags: [
      'Trainer: Engr. Okechukwu',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Before enrolling in this course, participants should have:",
      "Basic understanding of petroleum engineering concepts, including drilling, well completion, and reservoir engineering.",
      "Familiarity with production systems and well performance evaluation.",
      "Basic knowledge of fluid mechanics and pressure management in oil and gas wells.",
      "Prior experience with well operations or an introductory course in well testing and production is beneficial but not mandatory."



    ],
    methodology: "Theoretical",
    objectives: [
          "Gain an understanding of the role of artificial lift in optimizing production from wells with insufficient natural pressure.",
          "Learn about the various types of artificial lift methods and their applications in different well conditions.",
          "Understand the operation of various pumping systems, such as beam pumps (rod pumps), progressive cavity pumps (PCP), and electric submersible pumps (ESP).",
          "Evaluate when to apply each pumping method based on well characteristics like depth, flow rate, and fluid properties.",
          "Learn about the gas lift method, which uses injected gas to reduce the density of fluids in the wellbore, allowing the oil or gas to flow more easily to the surface.",
          "Understand the design, operation, and advantages of gas lift systems, including how to manage injection pressures and gas flow.",
          "Learn how to evaluate well conditions, including reservoir pressure, production rates, and fluid types, to select the most appropriate artificial lift method.",
          "Consider factors such as cost, operational complexity, and maintenance requirements when choosing the right artificial lift system for a well.",
          "Analyze real-world case studies to understand the challenges and solutions involved in implementing artificial lift systems.",
          "Explore how artificial lift systems have been optimized and maintained in different reservoir conditions"

                  
    ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Pumping.",
        "Module 3:  Gas Lift",
        "Module 4:  Choosing an artificial lift process",
        "Module 5:  Case Studies"





    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 10,
    title: "The Equipment of Naturally Flowing Wells",
    date: "Oct 2022 - Present",
    description:
    [
          
      "A naturally flowing well is a well in which the hydrocarbon (oil, gas, or water) naturally rises to the surface due to the pressure differential between the reservoir and the surface. This occurs when the reservoir pressure is high enough to push the fluids to the surface without the need for artificial lift methods, such as pumps or gas injection. However, even though no external artificial lift is needed, there is still a set of equipment that ensures the well's functionality, safety, and efficiency.",

      "The Equipment of Naturally Flowing Wells course provides a comprehensive introduction to the equipment and components used in naturally flowing oil and gas wells. These types of wells, which rely on the natural pressure of the reservoir to drive the fluids to the surface, require specialized equipment to maintain safe, efficient, and long-term production. The course covers the general configuration of flowing well equipment, including the production wellhead, tubing, packers, and downhole safety devices. Participants will also learn about running procedures and how to optimize the operation of flowing wells. The course includes practical case studies to help participants apply theoretical knowledge to real-world situations."
    ],
      image:
      "https://ik.imagekit.io/mags/courses/The%20Equipment%20of%20Naturally%20Flowing%20Wells.png",
    tags: [
      'Trainer: Engr. Magnus',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Before enrolling in this course, participants should have the following foundational knowledge:",
      "Basic understanding of petroleum engineering concepts, including wellbore construction, reservoir engineering, and fluid dynamics.",
      "Familiarity with well completion processes and the basic equipment used in oil and gas production.",
      "Basic understanding of production systems and well testing would be beneficial but not mandatory.",
      "Prior experience with well operations is helpful but not required."


    ],
    methodology: "Theoretical",
    objectives: [
          "Gain a clear understanding of the function and configuration of key equipment used in naturally flowing wells.",
          "Understand how each component contributes to safe, efficient, and optimal production in a naturally flowing well.",
          "Learn about the general layout and setup of equipment that supports the production of hydrocarbons in naturally flowing wells, from the wellhead to the surface facilities.",
          "Explore how the wellhead, tubing, packers, and other components work together to ensure smooth flow.",
          "Understand the importance of the production wellhead in controlling the flow of fluids from the reservoir.",
          "Learn about the components of the wellhead, including the Christmas tree, valves, and other critical parts that control pressure, flow, and safety.",
          "Gain insight into the design and function of the production string or tubing, which transports fluids from the reservoir to the surface.",
          "Learn how tubing is selected and installed based on reservoir conditions and production needs.",
          "Understand the function of packers in sealing off certain zones of the wellbore, preventing unwanted fluid movement, and maintaining well integrity.",
          "Explore the different types of packers used in naturally flowing wells and their applications.",
          "Learn about the various downhole equipment used in naturally flowing wells, including pumps, valves, and other tools that assist in production and flow control.",
          "Understand the critical role subsurface safety valves (SSSV) play in protecting against blowouts and ensuring the safety of the well in emergency situations.",
          "Learn how SSSVs operate, their design, and how they are installed and maintained.",
          "Gain practical knowledge of the procedures involved in running production equipment into the well, including tubing, packers, and safety valves.",
          "Learn best practices for installation, testing, and troubleshooting during the running process.",
          "Review real-world case studies that illustrate challenges and solutions related to naturally flowing wells.",
          "Analyze how equipment is selected, installed, and operated in different reservoir conditions to optimize well performance and ensure safety."
                            
    ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  General configuration of flowing well equipment.",
        "Module 3:  The production wellhead",
        "Module 4:  The production string or tubing",
        "Module 5:  Packers ",
        "Module 6:  Downhole Equipment",
        "Module 7:  Subsurface safety valves",
        "Module 8:  Running Procedure",
        "Module 9:  Case Studies" 





    ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 10,
    title: "Introduction to Well Completion",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Well completion is a critical phase in the life cycle of an oil or gas well, following the drilling process and before the production phase. It involves preparing a well for production or injection by installing the necessary equipment and systems to ensure safe, efficient, and optimized flow of hydrocarbons from the reservoir to the surface. Well completion encompasses the installation of casings, tubing, packers, and other tools designed to enhance the well's performance, manage reservoir pressure, and protect the surrounding environment.",
      "The Introduction to Well Completion course provides a comprehensive understanding of the well completion process, which is crucial for enabling efficient and safe oil and gas production. This course will introduce participants to the core concepts, factors influencing completion design, and the different configurations of well completion systems. Through practical case studies and real-world applications, participants will gain insights into how well completion is designed and executed to ensure optimal flow capacity and operational efficiency. This course is designed for those looking to understand the essential aspects of well completion and its role in the overall production system."
    
    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/intro%20to%20well.png?updatedAt=1767612725294",
    tags: [
      'Trainer: Engr. Okechukwu',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Participants should have the following knowledge or experience before taking this course:",
      "Basic understanding of petroleum engineering principles, including drilling, reservoir engineering, and fluid mechanics.",
      "Familiarity with the oil and gas industry, particularly upstream processes and operations.",
      "Knowledge of basic wellbore construction and drilling techniques is beneficial, but not mandatory.",
      "No prior experience in well completion design is required, but a fundamental understanding of the production lifecycle is recommended."


    ],
    methodology: "Theoretical",
    objectives: [
          "Gain a solid foundation in well completion and its critical role in oil and gas production.",
          "Understand the basic steps and phases involved in completing a well, from drilling to the final production stage.",
          "Understand how factors such as reservoir characteristics, wellbore stability, fluid properties, and production goals influence completion decisions.",
          "Evaluate the impact of different formation types, pressure conditions, and well environments on the completion design process.",
          "Understand the concept of flow capacity and its significance in the overall design of well completion systems.",
          "Learn how to assess and optimize the flow of hydrocarbons from the reservoir to the surface to maximize production rates.",
          "Understand the different well completion types (e.g., open-hole, cased-hole, multilateral, and smart wells) and their applications.",
          "Identify the benefits and limitations of each completion configuration based on reservoir characteristics and production goals.",
          "Gain knowledge of the sequential steps in the completion process, from well design to equipment installation and testing.",
          "Understand the roles of casing, tubing, perforating, and other components in well completion and how each contributes to overall well performance.",
          "Analyze real-world case studies to understand how well completion challenges are overcome.",
          "Apply theoretical knowledge to practical scenarios, focusing on completion design, operational optimization, and troubleshooting."                  
              


        ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Main factors influencing completion design.",
        "Module 3:  Overall approach to a well’s flow capacity.",
        "Module 4:  Major types of completion configurations",
        "Module 5:  Main phases in completion ",
        "Module 6:  Case Studies "





    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦40,000 / $30"
  },

  {
    id: 10,
    title: "Connecting the Pay-zone and the Borehole",
    date: "Oct 2022 - Present",
    description:
    [
          
      "In oil and gas drilling, the pay-zone refers to the specific layer or formation within a reservoir that contains commercially recoverable quantities of hydrocarbons (oil or gas). The borehole is the hole that is drilled into the earth to access these hydrocarbon deposits. Connecting the pay-zone to the borehole effectively is crucial to allow the flow of oil, gas, or other fluids from the reservoir into the wellbore for production.",
      "This connection involves several steps during the well completion process, and the methods used depend on the nature of the reservoir and the well being drilled. The primary goal is to ensure that hydrocarbons can flow from the pay-zone into the borehole without leakage or contamination from surrounding formations.",

      "The Connecting the Pay-zone and the Borehole course focuses on the critical process of linking the reservoir (pay-zone) to the wellbore, a key aspect of well completion. This course delves into the various stages of well completion, from drilling and casing the pay-zone to perforating the well and restoring the cement job. Special emphasis is placed on treating the pay-zone to optimize production and understanding the challenges of completing horizontal wells. The course integrates theoretical knowledge with practical case studies, providing participants with a comprehensive understanding of how to connect the pay-zone to the borehole efficiently and effectively."

    
    
    ],
      image:
      "https://i.ibb.co/Kz50QJF1/connecting-the-payzone-e9e3e587c406fe6425da.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Before enrolling in this course, participants should have:",
      "Basic understanding of petroleum engineering principles, including drilling, reservoir engineering, and production techniques.",
      "Familiarity with wellbore construction and basic concepts of well completion.",
      "A foundational knowledge of fluid dynamics and well testing is helpful, though not mandatory.",
      "No prior experience with specific pay-zone connection techniques is necessary, though an understanding of general well operations and completions would be beneficial."


    ],
    methodology: "Theoretical",
    objectives: [
          "Gain a detailed understanding of the steps involved in connecting the reservoir to the wellbore, ensuring safe and efficient production from the pay-zone.",
          "Learn how to drill and case the pay-zone effectively to ensure wellbore integrity and zonal isolation.",
          "Understand the selection and installation of casing strings and the importance of proper drilling techniques in accessing the pay-zone.",
          "Understand the critical role of cementing in isolating the wellbore from surrounding formations.",
          "Learn how to evaluate cement jobs and restore cement integrity when necessary to maintain zonal isolation and prevent fluid migration.",
          "Understand the perforating process, including techniques for creating perforations in the casing to connect the pay-zone to the wellbore.",
          "Learn about perforating guns, charge designs, and best practices to optimize well performance.",
          "Learn the various methods of treating the pay-zone to enhance well production, including acidizing, fracturing, and other stimulation techniques.",
          "Understand how different treatments impact reservoir flow characteristics and optimize recovery rates.",
          "Gain insights into the unique challenges involved in completing horizontal wells, including drilling, casing, perforating, and treatment techniques.",
          "Learn how to design and complete horizontal wells to maximize productivity in complex reservoir conditions.",
          "Analyze real-world case studies to see how theory is applied in practice.",
          "Understand how different scenarios and challenges were addressed in well completion, particularly in terms of connecting the pay-zone to the borehole."
                      


        ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Drilling and casing the pay-zone.",
        "Module 3:  Evaluating and restoring the cement job",
        "Module 4:  Perforating",
        "Module 5:  Treating the Pay-zone", 
        "Module 6:  The special case of horizontal wells",
        "Module 7:   Case Studies"





        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦50,000 / $40"
  },

  {
    id: 53,
    title: "Process Modeling/Simulation using Aspen HYSYS",
    date: "Present",
    description: [
      "This course provides a practical and comprehensive introduction to Aspen HYSYS. It offers a structured and comprehensive approach to learning Aspen HYSYS, the industry-standard tool for process simulation. Through a structured series of modules, participants will gain hands-on experience in building, analyzing, and optimizing steady-state process models for oil and gas facilities, refineries, and chemical plants. The course bridges theoretical concepts with real-world applications through extensive case studies including crude oil and gas/chemical projects. Tailored for professionals and students in the oil & gas, refining, and chemical industries.",

      "Participants will gain practical skills through real-world case studies, including crude oil plant modeling and gas/chemical project design, enabling them to apply simulation results in feasibility studies, design optimization, and plant troubleshooting. The course also includes preparation for the Aspen HYSYS User Certification, ensuring participants are ready to demonstrate their simulation competence professionally."

    ],
    image: "https://ik.imagekit.io/mags/courses/intro%20to%20process%20model%20using%20aspen.png?updatedAt=1767612763998",
    tags: [
      "Trainer: Engr. Okechukwu"
    ],
    category: "process",
    duration: "8 Days",
    prerequisite: [
      "Basic understanding of chemical/process engineering concepts",
      "Familiarity with unit operations (e.g., pumps, compressors, heat exchangers, reactors)",
      "Introductory knowledge of thermodynamics and material/energy balances",
      "Experience or interest in the oil & gas or chemical process industries"
    ],
    methodology: "Theoretical",
    objectives: [
      "Describe key stages in oil and gas projects and explain how process simulation supports decision-making throughout project lifecycles.",
      "Identify real-world applications of Aspen HYSYS in engineering design, operational troubleshooting, and optimization.",
      "Navigate the Aspen HYSYS interface, simulation environment, and model pallets with confidence.",
      "Define and manage component lists and apply appropriate thermodynamic property packages based on process requirements.",
      "Characterize petroleum assays for crude oil simulation and integrate assay data into models.",
      "Configure and apply unit sets, and effectively use model palettes to build simulation cases.",
      "Design and simulate process equipment, including: (i) Pumps, compressors, expanders, Heat exchangers and flash separators (ii) Conversion and equilibrium reactors",
      "Model pipe segments and evaluate pressure drop and heat loss.",
      "Utilize logical operators and manipulators (e.g., adjusters, recyclers, spreadsheets) for process control and convergence.",
      "Simulate distillation/separation columns, such as De-Methanizer, De-Ethanizer, and De-Propanizer.",
      "Develop and analyze Heat and Material Balances (HMB), and generate clear simulation reports.",
      "Model full-scale process systems, such as a crude oil plant, including assay characterization and atmospheric distillation.",
      "Perform feasibility and conceptual design simulations for gas or chemical process plants.",
      "Prepare for the Aspen HYSYS User Certification through review of advanced features and case-based assessments."
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: Oil and Gas Project Stages",
      "Module 3: HYSYS Applications",
      "Module 4: Simulation Environment",
      "Module 5: Component List",
      "Module 6: Physical Property Package",
      "Module 7: Petroleum Assays",
      "Module 8: Unit Sets / Model Pallets",
      "Module 9: Equipment Design",
      "Module 10: Modeling/Simulation of Pump, Compressors, Expander, Heat Exchanger, Flash Separator",
      "Module 11: Modeling/Simulation of Conversion or Equilibrium Reactor",
      "Module 12: Pipe Segment",
      "Module 13: Logical Operators/Manipulators (Recycler, Set, Adjust & Spreadsheet)",
      "Module 14: Modeling/Simulation of Separation Columns (De-Methanizer, De-Ethanizer, & De-Propanizer)",
      "Module 15: Heat & Material Balance (Reporting)",
      "Case Studies – Crude Oil Project & Gas/Chemical Project",
      "Module 16: Simulation of a Crude Oil Plant (Characterization, Pre-Heat Train, Atmospheric Towers, Side Operation and Pump Around Operation)",
      "Module 17: Feasibility/Conceptual Design of a Gas/Chemical Project",
      "Module 18: Aspen HYSYS User Certification Preparation"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦180,000 / $150",
    certification: "Certificate of Completion"
  },
  
  {
    id: 54,
    title: "Advance Process Modeling/Simulation using Aspen HYSYS",
    date: "Present",
    description: [
      "Aspen HYSYS is a powerful process simulation software developed by Aspen Technology that is widely used in the chemical, oil and gas, and other process industries for designing and optimizing processes. It allows engineers to simulate, analyze, and optimize chemical processes with ease.",

      "This advanced-level course is designed to deepen participants’ expertise in Aspen HYSYS by focusing on specialized processes and utilities commonly encountered in gas processing and chemical industries. Building on core simulation skills, the course covers acid gas removal, gas dehydration, sulfur recovery (SULSIM integration), sour water stripping, hydraulic calculations, and line sizing utilities.",

      "Participants will explore column operations and develop a strong understanding of end-to-end process modeling for conceptual design, debottlenecking, and troubleshooting. Real-world case studies and a capstone project simulate the conceptual design of a gas/chemical plant. The course also includes a dedicated module to prepare learners for the Aspen HYSYS Expert Certification, validating their mastery of process simulation."

    ],
    image: "https://ik.imagekit.io/mags/courses/process%20model%20using%20aspen.png?updatedAt=1767612777395",
    tags: [
      "Trainer: Engr. Okechukwu"
    ],
    category: "process",
    duration: "10 Days",
    prerequisite: [
      "Introduction to Process Modeling/Simulation using Aspen HYSYS"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand and model acid gas processes, including amine sweetening and CO₂/H₂S removal workflows.",
      "Simulate gas dehydration systems using glycol contactors and regeneration units within Aspen HYSYS.",
      "Use Aspen HYSYS with the SULSIM add-on to model sulfur recovery units (Claus process) accurately.",
      "Model sour water stripping processes, understanding their integration within refining and gas processing facilities.",
      "Perform line sizing and pressure drop analysis using Aspen HYSYS line sizing utilities.",
      "Analyze hydraulic behavior of pipelines and process systems using Aspen HYSYS hydraulic models.",
      "Configure and troubleshoot column operations, including convergence strategies and optimization.",
      "Apply simulation tools to evaluate real-world gas/chemical projects, from feasibility through conceptual design.",
      "Generate accurate heat and material balances, utility reports, and dynamic analysis where applicable.",
      "Prepare for the Aspen HYSYS Expert Certification, focusing on best practices, case analysis, and simulation strategy."
    ],
    outline: [
      "Module 1: Introduction",
      "Module 2: Acid Gas Process Overview & Workflow",
      "Module 3: Gas Dehydration Process Overview & Workflow",
      "Module 4: Sulfur Recovery (SULSIM) Process Overview & Workflow",
      "Module 5: Sour Water Process Overview & Workflow",
      "Module 6: Line Sizing Utility",
      "Module 7: Hydraulics",
      "Module 8: Column Operations in Aspen HYSYS",
      "Case Studies –Gas/Chemical Project",
      "Module 9: Feasibility/Conceptual Design of a Gas/Chemical Project",
      "Module 10: Aspen HYSYS Expert Certification Preparation"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦250,000 / $200",
    certification: "Certificate of Completion or Aspen HYSYS Expert Certificate"
  },
  

  {
    id: 52,
    title: "Sizing of Strainers & Screen Openings For Strainers",
    date: "Present",
    description: [
      "Screen openings for strainers refer to the size of the holes or mesh openings in the strainer's screen or filter element. These openings are designed to separate solids from liquids or gases by allowing the fluid to pass through while retaining particles of a certain size. The selection of screen openings for strainers depends on the application and the type of material being filtered.",
      "Strainer sizing is an essential process in designing systems that require filtration to protect downstream equipment or processes from debris, solids, or contaminants. Proper strainer sizing ensures that the strainer effectively captures particles without restricting fluid flow too much, preventing clogging, reducing maintenance, and ensuring optimal performance.",
      "The Sizing of Strainers & Screen Openings course is designed to provide participants with the essential knowledge and skills required to select and size strainers and screens for various applications in industrial processes. The course covers key topics such as screen openings, mesh sizes, factors influencing screen selection, strainer types, and sizing calculations. Participants will also learn how to consider the effects of factors like viscosity, pressure drop, and burst pressure to ensure efficient operation and longevity of strainer systems in fluid handling systems.",
      "By the end of this course, students will be proficient in determining the appropriate screen and strainer sizes for their systems and performing necessary calculations to optimize the performance of strainers across different operating conditions."

    ],
    image: "https://ik.imagekit.io/mags/courses/sizing%20of%20strainers.png?updatedAt=1767612758246",
    tags: [
      "Trainer: Engr. Okechukwu"
    ],
    category: "process",
    duration: "3 Days",
    prerequisite: [
      "Basic understanding of fluid mechanics and industrial filtration systems.",
      "Knowledge of process engineering or a related field, including concepts such as flow rate, pressure drop, and material properties."
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the concept of screen openings and their role in the function of strainers.",
      "Identify different types of screen openings used in industrial straining applications.",
      "Learn how to determine the appropriate mesh size for different straining applications.",
      "Familiarize with the different mesh and opening sizes used in strainers, and how to select them based on application needs.",
      "Identify and understand the factors that influence the selection of screen openings, such as fluid type, flow rate, and particle size.",
      "Learn about the most commonly used screen opening sizes in various industries and applications.",
      "Understand when and why each size is chosen.",
      "Understand the types of materials used in making strainer screens (e.g., stainless steel, brass, plastic) and their suitability for various applications.",
      "Explore the various applications where specific screen openings are used, such as in oil, water, gas, and chemical processing.",
      "Learn about the different types of strainers (e.g., Y-strainers, basket strainers, temporary strainers) and their applications in various industrial systems.",
      "Understand the importance of strainer sizing and the effects of improper sizing on system performance.",
      "Learn about the key factors involved in sizing strainers, including flow rate, pressure, and type of fluid.",
      "Learn how to perform sizing calculations for different types of strainers, considering flow conditions and operational requirements.",
      "Apply the principles learned throughout the course to real-world case studies involving strainer and screen sizing, pressure drops, and burst pressure calculations."

    ],
    outline: [
      "Module 1: Screen Openings for Strainers",
      "Module 2: Opening Size (Mesh Size)",
      "Module 3: Strainer Mesh and Opening Sizes",
      "Module 4: Factors Influencing the Selection of Screen Openings",
      "Module 5: Common Screen Opening Sizes",
      "Module 6: Materials Used for Strainer Screens",
      "Module 7: Applications of Different Screen Openings",
      "Module 8: Common Strainer Types",
      "Module 9: Strainers Sizing",
      "Module 10: Key Factors in Strainer Sizing",
      "Module 11: Sizing Calculations for Strainers",
      "Module 12: Screen Correction Factor Chart",
      "Module 13: Viscosity And Density Correction Factor Chart",
      "Module 14: Correction Factors For Clogged Screens",
      "Module 15: Y-Strainer Pressure Drop - Liquids",
      "Module 16: Y-Strainer Pressure Drop - Saturated Steam",
      "Module 17: Y-Strainer Pressure Drop - Saturated Steam",
      "Module 18: Basket Strainer Pressure Drop - Liquids",
      "Module 19: Temporary Strainer Pressure Drop - Liquids",
      "Module 20: Fabricated Y & Tee Strainer Pressure Drop - Liquids",
      "Module 21:  Fabricated Basket & Duplex Strainer Pressure Drop - Liquids",
      "Module 22:  Y-Strainer Screen Burst Pressure",
      "Module 23:  Basket & Duplex Strainer Basket Burst Pressure",
      "Module 24:  Series TB Strainer Burst Pressure",
      "Module 25:  Series TC Strainer Burst Pressure",
      "Module 26:  Fabricated Y-Strainer Screen Burst Pressure",
      "Module 27:  Fabricated T-Strainer Screen Burst Pressure",
      "Module 28:  Y-Strainer Screen Effective Area",
      "Module 29:  Basket Strainer Effective Area",
      "Module 30:   Fabricated Strainer Screen Effective Area",
      "Module 31:   Case Studies"

    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦180,000 / $150",
    certification: "Certificate of Completion"
  },
  

  {
    id: 10,
    title: "P&ID Development Procedure Stage 1  ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Developing a Piping and Instrumentation Diagram (P&ID) is a critical step in designing and documenting a process system. A P&ID shows the layout of equipment, piping, instruments, and control systems, serving as an essential tool for engineers and operators to understand how a process works.",

      "The P&ID Development Procedure Beginner course provides a comprehensive introduction to the creation, interpretation, and management of Piping and Instrumentation Diagrams (P&IDs) in industrial and engineering environments. This course covers fundamental concepts, symbols, and conventions used in P&ID drawings, along with a detailed explanation of various equipment, pipelines, and instrumentation systems. The course is tailored for individuals new to the field, providing them with the essential tools and knowledge needed to understand and develop P&IDs for process systems.",

      "By the end of this course, participants will be able to develop, read, and interpret P&IDs, contributing effectively to engineering projects by ensuring proper identification, specification, and communication of system design elements."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/p%20and%20id%201.png?updatedAt=1767612737257",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic understanding of industrial processes, piping systems, and instrumentation.",
      "Familiarity with technical drawing concepts or engineering symbols."



    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the overall structure and purpose of P&IDs in the context of industrial systems.",
          "Identify and understand the various pipeline symbols used in P&ID diagrams.",
          "Understand how different symbols represent various types of pipelines and flow paths.",
          "Learn about other types of lines used in P&IDs, such as electrical lines, control lines, and instrumentation lines.",
          "Understand the conventions used for pipeline identification to maintain consistency across drawings.",
          "Understand how product designations are assigned to pipelines and equipment in P&IDs.",
          "Understand how these numbers help in organizing and identifying various subsystems within the P&ID.",
          "Understand the methodology and conventions behind numbering pipelines in P&IDs.",
          "Understand the significance of these specifications in the design and operation of process systems.",
          "Understand the role of insulation in process safety and energy efficiency.",
          "Understand the different types of pipe fittings (elbows, tees, reducers, etc.) used in P&IDs.",
          "Understand the role and symbols for various types of valves (e.g., globe, ball, and gate) in P&IDs.",
          "Study the specific valves used in on/off services, such as shut-off and isolation valves.",
          "Understand the symbol conventions for control valves in P&ID diagrams.",
          "Study the types of valves used for one-way service, such as check valves and their application in preventing backflow.",
          "Explore valves used for special duties such as safety valves, relief valves, and pressure-reducing valves.",
          "Understand the importance of correctly identifying and labeling these valves in P&ID diagrams.",
          "Understand how to depict valve actuators in P&IDs.",
          "Understand how to represent tanks and pressure vessels in P&IDs, including their function and safety features.",
          "Study the fittings and accessories (e.g., level gauges, manways) associated with tanks and pressure vessels.",
          "Understand their role in ensuring system cleanliness and efficiency.",
          "Study the symbols for pumps and compressors in P&IDs, including centrifugal and positive displacement types.",
          "Understand the role of metering devices, such as flow meters, pressure gauges, and temperature sensors.",
          "Understand how to represent these units in P&ID diagrams.",
          "Study additional equipment commonly found in P&IDs, such as dryers, mixers, and separators.",
          "Understand the importance of equipment identification and the standards used for labeling equipment in P&ID diagrams.",
          "Study the role of instrumentation in P&IDs, including sensors, transmitters, and controllers.",
          "Understand the workflow used by contractors in developing P&IDs, from design to review stages.",
          "Understand how to manage and organize the P&ID creation process effectively.",
          "Understand how to ensure the accuracy and quality of P&ID documents throughout the design process.",
          "Understand how to manage P&IDs during the construction and operational phases of a project."


                      


        ],
    outline: [
        "Module 1: Structure",
        "Module 2: Pipeline Symbols",
        "Module 3: Other Lines",
        "Module 4: Pipeline Numbering and Identification",
        "Module 5: Product Designations",
        "Module 6: System Numbering",
        "Module 7: Pipeline Numbering",
        "Module 8: Pipeline Specifications",
        "Module 9: Insulation",
        "Module 10: Pipe Fittings",
        "Module 11: Valves",
        "Module 12: Valves used for “On/Off” Service",
        "Module 13: Valves used for “Control” Service",
        "Module 14: Valves used for “One-Way” Service",
        "Module 15: Valves used for “Special” Duties",
        "Module 16: Valve Actuators",
        "Module 17: Tanks and Pressure Vessels",
        "Module 18: Tank and Vessel Fixtures and Fittings",
        "Module 19: Filters",
        "Module 20: Pumps and Compressors",
        "Module 21: Metering Devices",
        "Module 22: Heat Exchangers",
        "Module 23: Other items of Equipment",
        "Module 24: Equipment Identification",
        "Module 25: Instrument",
        "Module 26: Contractor Workflow Description ",
        "Module 27: Responsibilities and organization ",
        "Module 28: Control, verification and review documents ",
        "Module 29: On-site management of P&IDs"







        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦300,000 / $250"
  },


  {
    id: 10,
    title: "P&ID Development Procedure Stage 2  ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "The P&ID Development Procedure course provides in-depth knowledge of advanced procedures for creating, interpreting, and managing Piping and Instrumentation Diagrams (P&IDs) in complex industrial systems. This course focuses on specific components and arrangements that are essential for ensuring the efficient, safe, and operable design of process systems. Participants will gain an understanding of the design philosophy behind various equipment configurations, valve arrangements, piping layouts, and instrumentation used across various industrial sectors.",

      "The course covers topics like bypass and block valves for Pressure Safety Valves (PSVs), heat exchanger piping arrangements, sample connections, steam and nitrogen purge connections, and many others. These topics are critical for engineers, designers, and technicians who need to ensure that the P&ID diagrams align with operational, safety, and regulatory standards."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/p%20and%20id%202.png?updatedAt=1767612736758",
    tags: [
      'Trainer: Engr. Magnus',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "5 Days",
    prerequisite: [
      "Basic knowledge of P&ID symbols and their meanings.",
      "Familiarity with industrial piping and equipment, including valves, pumps, pressure vessels, and heat exchangers.",
      "Fundamental understanding of process systems, instrumentation, and control systems.",
      "Experience in industrial engineering or process design."



    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the purpose and importance of bypass and block valves for Pressure Safety Valves (PSVs).",
          "Learn how to properly represent these valves in P&ID diagrams.",
          "Understand the use of blind flanges and jack screw flanges in isolating sections of piping.",
          "Learn how to symbolize and depict these flanges in P&ID drawings.",
          "Study the proper piping arrangements for heat exchangers.",
          "Learn how to represent heat exchangers, their connections, and flow paths in P&IDs.",
          "Understand the importance of sample connections in process systems.",
          "Learn how to represent sample connections and the associated instrumentation in P&IDs.",
          "Study the use of steam-out and nitrogen purge connections for cleaning and purging systems.",
          "Learn how to illustrate these connections in P&IDs to ensure safety and operational clarity.",
          "Learn how to depict vessels, drains, vents, and pressure points in P&IDs.",
          "Understand the significance of these components for process control, safety, and maintenance.",
          "Understand the piping arrangements for pumps, including suction and discharge lines.",
          "Learn how to correctly represent pump configurations and associated flow paths in P&IDs.",
          "Study the concept of class break points in P&IDs.",
          "Learn how to identify and represent different process areas and equipment class divisions in P&IDs.",
          "Understand the principles of pipeline numbering, including conventions for identifying pipelines in process diagrams.",
          "Learn how to ensure consistency in pipeline numbering across P&IDs.",
          "Learn the importance of proper pipe slopes for ensuring free drainage.",
          "Understand how to represent the required slopes in P&ID diagrams for drainage systems.",
          "Study the depiction of drains and vents for level instrumentation devices, such as level gauges (LG), level transmitters (LT), and level switches (LS).",
          "Learn how to represent these components accurately in P&ID diagrams.",
          "Understand the concept of trim lines in process systems and their role in isolating and controlling flow paths.",
          "Learn how to represent trim lines in P&ID drawings.",
          "Study the role of thermowells in heat stack exchangers for temperature measurement.",
          "Learn how to represent thermowells and their connections in P&ID diagrams.",
          "Understand the application of thermowells in air cooler systems for temperature control.",
          "Learn how to depict thermowells in air cooler arrangements in P&IDs.",
          "Study the requirements for cooling water supply and return lines in pump systems.",
          "Learn how to represent these cooling lines in P&IDs for pump-related applications.",
          "Understand the representation of steam turbines in process systems.",
          "Learn how to depict the key components of steam turbines in P&IDs.",
          "Study the importance of battery limit block valve assemblies and associated instrumentation in isolating systems.",
          "Learn how to represent these assemblies in P&IDs for clear system isolation and control.",
          "Learn about the role of indication levels for monitoring process variables.",
          "Understand how to represent level indicators and their connections in P&IDs.",
          "Study the use of insulating joints and nozzles in P&IDs for safety and control.",
          "Learn how to indicate insulating joints (I.F.) and nozzles in P&ID diagrams.",
          "Understand the role of control valves in regulating process flow and pressure.",
          "Learn how to depict control valves and their associated control loops in P&IDs.",
          "Study the numbering and identification conventions for instrument air take-off valves in P&IDs.",
          "Understand the importance of consistent numbering for ease of operation and maintenance."


                      


        ],
    outline: [
        "Module 1: By-Pass and block valve for PSV",
        "Module 2: Blind / with jack screw flange ",
        "Module 3: Heat Exchanger (piping arrangement)",
        "Module 4: Sample connection ",
        "Module 5: Steam out connection / Nitrogen purge ",
        "Module 6: Vessel, drain, vent and pressure point ",
        "Module 7: Pumps piping arrangements ",
        "Module 8: Class break points philosophy",
        "Module 9: Pipeline Numbering",
        "Module 10: Free draining / slope ",
        "Module 11: Drain, vent for level instrumentation (LG/LT/LS) ",
        "Module 12: Trim line", 
        "Module 13: Thermowell for heat stack exchanger ",
        "Module 14: Thermowell for aircooler",
        "Module 15: Cooling water supply and return for pumps ",
        "Module 16: Description of steam turbine ",
        "Module 17: Battery limit block valve assembly and instrumentation ",
        "Module 18: Indication Levels ",
        "Module 19: Indication of insulating joint (I.F.), and number of nozzles ",
        "Module 20: Control valve ",
        "Module 21: Numbering for instrument air take off valve"







        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦180,000 / $150"
  },


  {
    id: 10,
    title: "P&ID Development Procedure Stage 3  ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "The P&ID Development Procedure course provides in-depth knowledge and practical guidance for developing Piping and Instrumentation Diagrams (P&IDs), focusing on process work flow, utility distribution, piping arrangements, and key equipment and instrumentation in complex industrial systems. This course aims to equip participants with a structured approach to designing and managing P&IDs that ensure efficient, safe, and compliant process operations.",

      "The curriculum covers essential aspects of P&ID development, such as equipment description, instrumentation tables, numbering procedures, utility distribution systems, tie-ins, block valve arrangements, and various piping components. Special topics, including typical arrangements for sea cooling water supply/return, purge connections, and fire water lines, provide further specialization for those working in process engineering and plant design.",

      "The course emphasizes practical application and standardization, ensuring that participants can effectively contribute to the development and interpretation of P&IDs used for design, construction, and operation in industrial facilities."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/p%20and%20id%203.png?updatedAt=1767612738454",
    tags: [
      'Trainer: Engr. Okechukwu',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "5 Days",
    prerequisite: [
      "Basic understanding of P&ID symbols and conventions.",
      "Familiarity with industrial processes, equipment, and instrumentation.",
      "General understanding of piping systems and process flow.",
      "Basic knowledge of process engineering and mechanical or instrumentation design"



    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the concept of process work flow in P&ID development.",
          "Learn how to represent process flow logically and efficiently in a P&ID diagram.",
          "Recognize and understand the typical labels and descriptions used for equipment in P&IDs.",
          "Learn how to assign and use consistent labeling conventions for process equipment.",
          "Understand the role of instrumentation tables in documenting control and instrumentation systems.",
          "Learn how to create and interpret instrumentation tables that correspond to P&ID drawings.",
          "Study the procedure for numbering tie-ins in P&IDs.",
          "Learn how to organize tie-ins for clarity and consistency in complex systems.",
          "Understand the specific valve arrangements required for low, medium, and high-pressure steam systems.",
          "Learn how to represent these arrangements, including hose connections, in P&ID diagrams.",
          "Study how to represent various utility systems (such as air, water, or gas) in P&IDs.",
          "Learn how to depict utility distribution systems and ensure proper integration into the overall process.",
          "Understand the necessity of purge systems for flare headers in P&IDs.",
          "Learn how to represent purge systems for flare gas handling and safety in P&IDs.",
          "Study how to indicate flange ratings for equipment in P&IDs.",
          "Learn the importance of accurately representing flange ratings for safe operation and maintenance.",
          "Address various other minor but important components that may appear in P&IDs, such as accessories, supports, and safety devices.",
          "Understand how to include miscellaneous items without cluttering the diagram.",
          "Learn about the use of bypass systems around Non-Return Valves (NRV) on pump discharge lines.",
          "Understand how to represent these bypass lines in P&ID diagrams.",
          "Study the representation of condensate systems in P&IDs, including collection, drainage, and disposal.",
          "Learn how to effectively represent condensate lines and equipment in the diagram.",
          "Understand the concept and role of drip pots in process systems, particularly in removing water or contaminants.",
          "Learn how to represent drip pots and associated piping in P&IDs.",
          "Study the layout and function of utility stations in P&IDs.",
          "Learn how to represent utility stations that manage multiple services in P&ID diagrams.",
          "Understand the purpose and representation of sulphur jacket lines in process systems.",
          "Learn how to depict sulphur jacket lines in P&ID diagrams for heat control and system safety.",
          "Study the sizing criteria for hose connections in P&ID diagrams.",
          "Learn how to represent hose connections correctly according to industry standards.",
          "Learn about the typical piping arrangements for sea cooling water systems, including four-way valve configurations.",
          "Understand how to accurately represent these systems in P&IDs.",
          "Study the standard piping arrangements for sea cooling water supply and return lines.",
          "Learn to depict these piping systems and connections in P&ID diagrams.",
          "Understand the standard arrangements for blowdown connections in process systems.",
          "Learn how to represent blowdown connections in P&ID diagrams to ensure system safety and operational integrity.",
          "Learn how to represent the distribution of utilities or process fluids to various users in P&IDs.",
          "Understand how to organize and identify distribution lines clearly in diagrams.",
          "Study the various piping components (e.g., valves, flanges, fittings) and their options for use in P&IDs.",
          "Learn how to select and represent appropriate piping components for different applications.",
          "Understand the system for numbering lines in P&IDs to ensure consistency and clarity.",
          "Learn how to apply standard numbering systems to different types of process and utility lines.",
          "Learn about the concept of process line battery limits and their importance in P&ID design.",
          "Understand how to depict battery limits in P&ID diagrams to clearly indicate system boundaries.",
          "Study the representation of fire water lines and their battery limits in P&IDs.",
          "Understand the safety and regulatory implications of fire water line layouts.",
          "Understand the process and representation of pit close drain purge systems in P&IDs.",
          "Learn how to depict these systems and their associated components for effective drainage.",
          "Learn how to properly document notes in P&IDs to clarify design elements, equipment specifications, and safety instructions.",
          "Understand the importance of including notes for clarity and communication in P&ID development"


                      


        ],
    outline: [
        "Module 1:  Process Work Flow",
        "Module 2:  Equipment Description Typical Labels",
        "Module 3:  Instrumentation Tables",
        "Module 4:  Tie-INS Numbering Procedure",
        "Module 5:  Block valve arrangement for steam (LPS/MPS/HPS) and hose connections ",
        "Module 6:  Utility distribution P&ID (Miscellaneous)", 
        "Module 7:  Purge on flare header ",
        "Module 8:  Flange rating indication for Equipment", 
        "Module 9:  Miscellaneous ",
        "Module 10:  By-Pass around NRV on pump discharge ",
        "Module 11:  Condensate ",
        "Module 12:  Drip poot ", 
        "Module 13:  Utility station",  
        "Module 14:  Sulphur jacket line", 
        "Module 15:  Sizing criteria for hose connection ",
        "Module 16:  Typical piping arrangement for sea cooling water supply/return with four way valve", 
        "Module 17:  Typical piping arrangement for sea cooling water supply/return ",
        "Module 18:  Typical arrangement for blow down connections", 
        "Module 19:  Distribution to users",
        "Module 20:  Piping Component Options",
        "Module 21:  Lines Number System",
        "Module 22:  Process Line Battery Limit",
        "Module 23:  Fire Water Lines Battery Limit",
        "Module 24:  Typical for pit close drain purge",
        "Module 25:  Notes"







        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦180,000 / $150"
  },


  {
    id: 10,
    title: "P&ID Development Procedure 4 - Process Control  ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Process control is essential in industries like chemical, oil and gas, pharmaceuticals, and manufacturing, where precise regulation of process parameters (such as temperature, pressure, and flow rate) is crucial.",

      "The P&ID Development Procedure - Process Control course focuses on the integration of process control systems within Piping and Instrumentation Diagrams (P&IDs). This course provides participants with the knowledge and skills to understand, design, and develop control systems within the context of P&IDs. It covers various types of process control strategies, loop systems, and control mechanisms used in industrial applications to ensure efficient and safe operations.",

      "This course explores core concepts such as feedback and feedforward control, cascade control, split-range control, and more. It also introduces participants to applicable industry standards for process control, terminology, and the role of process control systems in achieving optimal process performance. Through a hands-on case study, participants will apply their learning to real-world scenarios and enhance their ability to develop effective control systems in P&IDs.",

      "By the end of this course, participants will be able to design control loops, integrate them into P&IDs, and ensure proper functionality of process control systems in various industrial settings."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/p%20and%20id%204.png?updatedAt=1767612736581",
    tags: [
      'Trainer: Engr. Okechukwu',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic knowledge of P&IDs, including symbols, layout, and general interpretation.",
      "Fundamental understanding of process systems in industries such as chemical, oil & gas, or power generation.",
      "Basic knowledge of instrumentation and control systems such as sensors, actuators, controllers, and valves.",
      "Basic understanding of process engineering principles."



    ],
    methodology: "Theoretical",
    objectives: [
          "Be proficient in designing and integrating process control systems into P&IDs.",
          "Understand various process control strategies and their applications in industrial processes.",
          "Be able to interpret and implement feedback, feedforward, and combined control systems.",
          "Have the skills to develop control loops and ensure that they are represented clearly and accurately in P&IDs for safe, efficient, and effective process operation. "

                      


        ],
    outline: [
        "Module 1:  Introduction to Process Control",
        "Module 2:  Applicable Standards Summary",
        "Module 3:  Basic Loop",
        "Module 4:  Terms used in  Process Control",
        "Module 5:  Control Loop ",
        "Module 6:  Feedback Control", 
        "Module 7:  Feedforward Control",
        "Module 8:  Feedforward-plus-Feedback Control",
        "Module 9:  Ration Control ",
        "Module 10: Cascade Control ",
        "Module 11: Split Range Control", 
        "Module 12: Case Study"








        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $120"
  },


  {
    id: 10,
    title: "Conceptual Stage of Design  ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "The Conceptual Stage of Design in Process Engineering course provides participants with the knowledge and tools required to generate innovative, practical, and feasible process designs. The course emphasizes the importance of creativity, cross-disciplinary collaboration, and problem-solving during the conceptual phase. Participants will learn how to assess requirements, explore multiple design alternatives, use simulation tools, evaluate economic and environmental impacts, and transition the design into the FEED & detailed engineering phase.",
      "This course is designed for process engineers, project managers, and technical professionals who are involved in the early stages of process design for manufacturing, chemical plants, energy systems, and other industrial sectors."

    
    
    ],
      image:
      "https://i.ibb.co/KxdBgbh1/conceptual-stage-15a8249ee56c1e67ac22.png",
    tags: [
      'Trainer: Engr. Okechukwu',
    ],
    category: "process",

    duration: "3 Days",
    prerequisite: [
      "Fundamental Knowledge in Process Engineering.",
      "Research Skills",
      "Basic Project Management Skills.",
      "Familiarity with Problem-Solving and Analytical Skills."




    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the principles and importance of the conceptual design stage in process engineering.",
          "Be able to create preliminary process flow diagrams and carry out basic material and energy balances.",
          "Develop skills to conduct economic feasibility studies.",
          "Be introduced to process simulation tools and their role in optimizing conceptual designs.",
          "Understand how to evaluate and select process alternatives based on technical, economic, and environmental considerations."

                      


        ],
    outline: [
        "Module 1:   Introduction to the Conceptual Design Phase",
        "Module 2:   Understanding Process Requirements.",
        "Module 3:   Process Research",
        "Module 4:   Development of Block Flow Diagram",
        "Module 5:   Preliminary Process Flow Diagrams (PFD) from licensors",
        "Module 6:   Process Simulation and Modeling",
        "Module 7:   Feasibility Analysis and Preliminary Costing",
        "Module 8:   Reporting and Documentation",
        "Module 9:   Transitioning to Detailed Design and Engineering",
        "Module 10:  Case Studies "









        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $120"
  },

  {
    id: 10,
    title: "Contract Administration ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Contract administration refers to the process of managing and overseeing the performance of a contract throughout its lifecycle. It involves ensuring that all parties involved in the contract adhere to the agreed terms, conditions, and timelines. This process helps ensure that the contract's objectives are met efficiently and that any issues or disputes are resolved promptly.",

      "The course on Contract Administration is designed to equip participants with the knowledge and skills required to manage contracts effectively throughout their lifecycle, from initiation to closure. This course will cover key elements of contract administration, including the various activities involved in managing contracts, ensuring performance, handling disputes, and administering the terms of the contract. Participants will gain practical insights through case studies and discussions to enhance their understanding of real-world contract management issues."

    
    
    ],
      image:
      "https://i.ibb.co/PZ9HNCpf/contract-admin-a8367424bb0016d4e36e.png",
    tags: [
      'Trainer: Engr. Okechukwu',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic Understanding of Contract Law.",
      "Project Management Fundamentals.",
      "Experience in Engineering or Contract Administration."




    ],
    methodology: "Theoretical",
    objectives: [
          "Understand Contract Management Fundamentals: Comprehend the basic concepts and processes involved in managing contracts, including the structure and purpose of contracts.",
          "Identify Key Contract Management Activities: Understand the roles and responsibilities involved in contract initiation, execution, monitoring, and amendment.",
          "Ensure Contract Performance: Learn how to measure and ensure that contract obligations are met in terms of quality, time, and cost.",
          "Close Contracts Effectively: Acquire the knowledge to properly conclude contracts, including compliance and documentation requirements.",
          "Administer Contracts Efficiently: Understand the continuous role of contract administration in monitoring compliance, addressing issues, and managing variations.",
          "Grasp the Engineer's Role in Contract Management: Understand the specific duties and responsibilities of engineers within the contract framework.",
          "Handle Contract Termination: Learn how to manage contract terminations, including reasons for termination and the process involved.",
          "Apply Learnings Through Case Studies: Develop practical solutions to common issues in contract management by analyzing real-world case studies."

                      


        ],
    outline: [
        "Module 1:  Contract Management",
        "Module 2:  Contract Management Activities.",
        "Module 3:  Contract Performance",
        "Module 4:  Closure of a Contract",
        "Module 5:  Contract Administration",
        "Module 6:  Responsibilities Of The Engineer",
        "Module 7:  Termination of Contract",
        "Module 8:  Case Studies "










        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦60,000 / $40"
  },

  {
    id: 10,
    title: "Cost Estimating Guidance ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Cost estimating is a crucial skill for successful project management. It involves careful planning, data gathering, and the use of proven methodologies to create realistic estimates. A good cost estimate forms the foundation for budgeting and controlling costs throughout the project, ensuring that the project remains financially viable and meets its goals. By using structured methods, incorporating risks, and constantly reviewing and validating estimates, project managers can help mitigate the risk of cost overruns and deliver successful projects.",
      "The Cost Estimating course is designed to provide participants with a solid foundation in understanding and applying cost estimating techniques for projects in various industries. This course will cover the core principles and processes involved in creating accurate and reliable cost estimates, key best practices, and the roles and responsibilities of different stakeholders in the cost estimating process. Through case studies, participants will gain practical insights and learn to apply cost estimating methods to real-world scenarios."

    
    
    ],
      image:
      "https://i.ibb.co/P82kD35/cost-estimating-7fe6efbff445021b6384.png",
    tags: [
      'Trainer: Engr. Magnus',
    ],
    category: "project management",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic Understanding of Project Management",
      "Familiarity with Financial and Budgeting Terms.",
      "Experience in Project-Based Work.",
      "Analytical and Problem-Solving Skills."





    ],
    methodology: "Theoretical",
    objectives: [
          "Understand Cost Estimating Fundamentals: Comprehend the purpose and importance of cost estimating in project management, and the key principles that guide the estimating process.",
          "Master the Cost Estimating Process: Learn the steps involved in generating accurate cost estimates for different types of projects.",
          "Apply Best Practices in Cost Estimating: Identify and implement industry-recognized practices that lead to the creation of reliable cost estimates.",
          "Understand Roles and Responsibilities: Understand the roles of different stakeholders involved in the cost estimating process, and how their responsibilities impact the quality of estimates.",
          "Perform Detailed Cost Estimation: Gain the skills to develop cost estimates using various methodologies, including bottom-up, top-down, and parametric estimating techniques.",
          "Analyze Case Studies: Apply cost estimating concepts to real-world scenarios and learn how to address challenges encountered in the estimating process."

                      


        ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Overview of the cost estimating process.",
        "Module 3:  Principles for the best practice cost estimating",
        "Module 4:  Roles and responsibilities",
        "Module 5:  Cost Estimating Process ",
        "Module 6:  Case Studies "











        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ], 
    cost: "₦50,000 / $40"
  },

  {
    id: 10,
    title: "Design Engineering Safety Checklist ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Design Engineering Safety Checklist is a comprehensive tool used to identify, assess, and mitigate potential hazards during the design phase of a project or product. It ensures that safety is integrated into the design process and helps engineers comply with relevant safety standards, codes, and regulations. By identifying safety risks early in the design process, the checklist contributes to reducing accidents, improving product reliability, and ensuring compliance with industry standards.",
      "The Design Engineering Safety Checklist course is designed to provide engineers, safety professionals, and project managers with a comprehensive understanding of the safety considerations that must be addressed throughout the design phase of industrial projects. The course covers key areas of design, from plant layout and process design to equipment and instrumentation, ensuring safety is integrated into each aspect of the project. By focusing on critical safety factors, loss prevention, and regulatory compliance, this course helps professionals create safer and more efficient industrial environments. Participants will also learn to apply safety standards using case studies, allowing them to assess and address potential risks during the design process."

    
    
    ],
      image:
      "https://i.ibb.co/WjZtgGS/eng-safety-checklist-7ee72e015a7d9deb6c00.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "hazop hazid",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic Knowledge of Engineering and Industrial Design.",
      "Familiarity with Safety Standards and Regulations.",
      "Experience in Project Management or Plant Operations.",
      "Problem-Solving and Analytical Skills.",
      "Understanding of Engineering Drawings and CAD."






    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the Fundamentals of Design Engineering Safety: Grasp the importance of safety in industrial design and how it integrates with engineering best practices.",
          "Implement Safety in Plant Layout: Learn how to design plant layouts that prioritize safety, accessibility, and efficiency while minimizing risks.",
          "Design Safe Building Infrastructure: Understand the key safety considerations for designing industrial buildings, including structural integrity and hazard prevention.",
          "Analyze Safety in Process Design: Recognize the safety risks associated with industrial processes and how to mitigate these risks during the design phase.",
          "Ensure Safety in Piping Systems: Identify safety standards for piping systems, including the prevention of leaks, corrosion, and the proper handling of hazardous materials.",
          "Integrate Safe Equipment Design: Learn how to design and select equipment that is both efficient and meets safety requirements.",
          "Design Venting Systems for Safety: Understand the role of venting systems in preventing the buildup of hazardous gases and maintaining a safe working environment.",
          "Implement Instrumentation and Electrical Safety: Learn how to integrate safety protocols into instrumentation and electrical systems to prevent hazards related to automation and control.",
          "Apply Loss Prevention Strategies: Develop strategies to minimize risks, including chemical leaks, fires, and environmental damage, during the design phase.",
          "Ensure Safe Raw Materials Handling: Understand the safety protocols required for the storage, handling, and transportation of raw materials in industrial settings.",
          "Evaluate Safety Through Case Studies: Analyze real-world case studies to apply safety principles and checklists to actual design scenarios, identifying risks and recommending solutions."

                      


        ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Plant Layout.",
        "Module 3:  Building",
        "Module 4:  Process",
        "Module 5:  Piping ",
        "Module 6:  Equipment",
        "Module 7:  Venting",
        "Module 8:  Instrumentation and Electrical",
        "Module 9:  Loss Prevention",
        "Module 10: Raw Materials",
        "Module 11:  Case Studies "












        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },

  {
    id: 10,
    title: "Air Receiver Sizing ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Air Receiver Sizing is an essential aspect of designing a compressed air system to ensure efficient operation, avoid system fluctuations, and maintain consistent air pressure. The air receiver, often referred to as an air tank or air accumulator, serves as a buffer in a compressed air system, providing a reserve of compressed air to handle system surges, accommodate changes in air demand, and reduce the frequency of compressor cycling.",

      "The course will provide participants with a comprehensive understanding of how to properly size air receivers, considering factors such as system flow rate, pressure variations, compressor capacity, and specific operational needs. It is ideal for professionals in industries that rely on compressed air systems, including manufacturing, automotive, chemical, and food processing."

    
    
    ],
      image:
      "https://i.ibb.co/LD4nMQ4v/air-receiver-sizing-22424599ed97ff846349.png",
    tags: [
      'Trainer: Engr. Lateef',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "The prerequisites for an Air Receiver Sizing Course generally include foundational knowledge of compressed air systems, fluid dynamics, and basic mechanical and electrical engineering principles. To ensure that participants can fully grasp the course material and apply it effectively, it is recommended that they have the following background:",
      "Basic Knowledge of Compressed Air Systems",
      "Fluid Mechanics and Pneumatics Basics",
      "Engineering and Thermodynamics Fundamentals",
      "Basic Safety Knowledge"







    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the principles and guidelines for sizing air receivers.",
          "Properly size air receivers for various compressed air systems, taking into account flow rate, pressure, and demand characteristics.",
          "Comprehend the safety standards and codes associated with air receiver design and operation.",
          "Evaluate the impact of air receiver sizing on compressor performance and system efficiency.",
          "Perform routine maintenance and troubleshooting of air receivers.",
          "Optimize air receiver sizing to improve energy efficiency and reduce operational costs."

                      


        ],
    outline: [
        "Module 1:   Introduction to Compressed Air Systems",
        "Module 2:   Air Receiver Sizing Principles.",
        "Module 3:   Factors Influencing Air Receiver Size",
        "Module 4:   Safety Considerations and Codes",
        "Module 5:   Impact of Receiver Size on Compressor Performance",
        "Module 6:   Air receiver sizing (Template calculation)",
        "Module 7:   Air Receiver Design and Installation",
        "Module 8:   Case Studies and Practical Applications "













        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦70,000 / $60"
  },

  {
    id: 10,
    title: "Process Design Engineering ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Process Design Engineering is a branch of engineering focused on designing, analyzing, and optimizing processes in industries such as chemical, petrochemical, food processing, pharmaceutical, oil and gas, and more. It involves creating systems that efficiently convert raw materials into products or services while meeting safety, quality, cost, and environmental standards. The role of process design engineers is to ensure that these processes are not only functional but also cost-effective, sustainable, and scalable.",
      "This course provides an in-depth exploration of process design engineering, focusing on key aspects of the design, simulation, and optimization of industrial processes, particularly in the context of oil and gas industries. Participants will gain essential skills in process engineering, understanding of upstream oil and gas operations, insights into fluid phase behavior, and proficiency in using process simulation software. Through these modules, students will develop the ability to design and optimize processes that are efficient, safe, and cost-effective in industrial applications."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/process%20design%20eng.png?updatedAt=1767612739416",
    tags: [
      'Trainer: Engr. Magnus',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Before embarking on this course, students should have the following foundational knowledge:",
      "Basic Thermodynamics.",
      "Fluid Mechanics.",
      "Chemistry and Material Science.",
      "Engineering Fundamentals."







    ],
    methodology: "Theoretical",
    objectives: [
          "Upon successful completion of this course, students will be able to:",
          "Develop and design industrial processes considering safety, cost, and environmental factors.",
          "Analyze material and energy balances to optimize process flow and efficiency.",
          "Apply fundamental engineering principles to solve complex process engineering problems.",
          "Understand the key processes and technologies involved in upstream oil and gas operations.",
          "Evaluate exploration, drilling, production, and reservoir management.",
          "Gain insight into equipment and process design specific to oil and gas extraction.",
          "Understand the thermodynamic properties of fluids and the phases they undergo under varying pressure and temperature conditions.",
          "Analyze phase diagrams and apply phase behavior principles to oil and gas systems.",
          "Apply the knowledge of fluid behavior to optimize process designs in upstream oil and gas operations.",
          "Use process simulation software to model, simulate, and optimize chemical processes.",
          "Understand and apply different models for thermodynamic calculations, flow sheet simulation, and process optimization.",
          "Interpret and troubleshoot simulation results to improve process designs and performance."


                      


        ],
    outline: [
        "Module 1:  Process Engineering",
        "Module 2:  Upstream Oil & Gas Overview.",
        "Module 3:  Fluid Phase Behavior",
        "Module 4:  Process Simulations",
        "Module 5:  Case Studies"














        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦60,000 / $40"
  },

  {
    id: 10,
    title: "Material Specification ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "A Material Specification course typically focuses on the principles, practices, and standards involved in specifying materials for construction, manufacturing, or product design. This course will focus on the following codes and standards; ASTM, ASME, API 5L, API 6A, AISI, API 5CT, ISO, EN/ ES, CSA, AS, JIS."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/material%20spec.png?updatedAt=1767612725014",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Understanding of Materials Science",
      "Engineering or Technical Background"








    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the fundamentals of material selections in oil and gas applications.",
          "Develop the ability to choose the most suitable materials for specific applications as per codes and standards and mode of operations",
          "Understand and apply relevant standards and codes in material specification.",
          "Implement effective quality control measures to ensure material conformance.",
          "Select materials that enhance product performance and durability.",
          "Choose materials that meet safety standards and reduce the risk of failures."


                      


        ],
    outline: [
        "Module 1: Introduction to Materials",
        "Module 2: Material Properties and Selection Criteria",
        "Module 3: Standards, Codes and Regulations",
        "Module 4: American Society for Testing and Materials (ASTM)",
        "Module 5: The American Society of Mechanical Engineers (ASME) ",
        "Module 6: American Petroleum Institute (API) 5L",
        "Module 7: American Petroleum Institute (API) 6A",
        "Module 8: American Iron and Steel Institute (AISI)",
        "Module 9: American Petroleum Institute (API) 5CT",
        "Module 10: International Organization for Standardization (ISO)",
        "Module 11: European Norm (European Standard)",
        "Module 12: Canadian Standards Association (CSA)",
        "Module 13: Australian standards (AS)",
        "Module 14: Japanese Industrial Standards (JIS)",
        "Module 15: Material Testing and Evaluation",
        "Module 16: Case Studies and Applications"















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $100"
  },

  {
    id: 10,
    title: "Plumbing Components and Equipment ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Plumbing components and equipment are essential parts of a plumbing system that ensure the safe, efficient, and effective distribution of water and removal of wastewater in residential, commercial, and industrial buildings. These components and equipment vary depending on the type of plumbing system and the specific requirements of the building or installation.",

      "The Plumbing Components and Equipment course is designed to provide a thorough understanding of the various components and equipment used in modern plumbing systems. This course will delve into the key elements that make up plumbing infrastructure, including fixtures, pipes, valves, pumps, and insulation, as well as specialized systems like grease interceptors, water treatment, and cross-connection control. Participants will gain hands-on knowledge about plumbing system design, installation, maintenance, and best practices in materials selection. The course also covers environmentally-friendly solutions, such as green plumbing and bioremediation systems, which are increasingly relevant in today's sustainable construction and water conservation efforts."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/plumbing%20components.png?updatedAt=1767612737795",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Understanding of Plumbing Systems.",
      "Mechanical or Engineering Background.",
      "Basic Mathematics.",
      "Blueprint Reading."








    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of this course, participants will be able to:",
          "Identify and explain the various types of plumbing fixtures (e.g., toilets, sinks, showers) and their design, installation, and maintenance requirements.",
          "Gain knowledge of different types of pipes and piping systems, including materials, sizing, installation techniques, and pressure considerations.",
          "Learn about various valve types used in plumbing systems, their functions, and applications, including shut-off, pressure-regulating, and check valves.",
          "Gain an understanding of the role of pumps in plumbing systems, including selection criteria, installation, and maintenance procedures for various pump types.",
          "Learn how to properly insulate piping systems to prevent heat loss, protect against freezing, and increase energy efficiency.",
          "Understand the importance of hangers and supports in plumbing systems and learn how to design and install them to ensure system stability and longevity.",
          "Learn how to apply vibration isolation techniques in plumbing systems to reduce noise, protect pipes, and improve system efficiency.",
          "Understand the design, installation, and maintenance of grease interceptors for managing grease in commercial kitchens and other wastewater systems.",
          "Learn the importance of cross-connection control in plumbing systems, including backflow prevention and compliance with safety regulations.",
          "Understand the principles of water treatment and learn how to design and implement systems that ensure safe, clean water for residential, commercial, and industrial applications.",
          "Learn the causes and effects of thermal expansion in piping systems and how to design systems to mitigate its impact.",
          "Learn about the design and installation of potable water coolers, fountains, and centralized water systems in commercial or large-scale residential projects.",
          "Gain insight into the use of bioremediation systems in wastewater treatment, including their role in pretreatment and environmental sustainability.",
          "Learn about green plumbing principles and technologies aimed at reducing water and energy consumption, including sustainable materials and energy-efficient systems.",
          "Apply the principles learned throughout the course by analyzing real-world plumbing system designs and solutions to common problems."



                      


        ],
    outline: [
        "Module 1:   Plumbing Fixtures",
        "Module 2:   Piping System.",
        "Module 3:   Valves",
        "Module 4:   Pumps",
        "Module 5:   Piping Insulation",
        "Module 6:   Hangers and Supports",
        "Module 7:   Vibration Isolation",
        "Module 8:   Grease Interceptors",
        "Module 9:   Cross-Connection Control",
        "Module 10:  Water Treatment",
        "Module 11:  Thermal Expansion",
        "Module 12:  Potable Water Coolers and Central Water Systems",
        "Module 13:  Bioremediation Pretreatment Systems",
        "Module 14:  Green Plumbing",
        "Module 15:  Case Studies"
















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $130"
  },

  {
    id: 10,
    title: "Cause & Effect Diagram For Process Engineers ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "A Cause and Effect Diagram, also known as a Fishbone Diagram or Ishikawa Diagram, is a useful tool for process engineers to identify and analyze the root causes of problems in a system or process. It visually maps out the potential causes of a specific effect or problem, helping engineers systematically investigate various factors that could contribute to an issue.",

      "The Cause & Effect Diagram for Process Engineers course is designed to provide participants with an in-depth understanding of cause-and-effect analysis in process engineering. The course covers the development and application of Cause & Effect Diagrams (also known as Fishbone or Ishikawa diagrams) for identifying and solving complex issues in process plants. Emphasizing control, monitoring, and shutdown systems, the course will guide process engineers through practical steps for designing diagrams that help troubleshoot process inefficiencies, optimize systems, and ensure safety. Real-world examples and sample diagrams will help participants gain confidence in creating these diagrams for use in their own projects."

    
    
    ],
      image:
      "https://i.ibb.co/WvtPqBzj/cause-and-effect-c8968c8623f65c544f5c.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Knowledge of Process Engineering.",
      "Understanding of Process Control Systems.",
      "Problem-Solving Skills.",
      "Mathematics and Analytical Thinking."









    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of the course, participants will be able to:",
          "Recognize the role of Cause & Effect Diagrams in troubleshooting, process optimization, and safety within process plants.",
          "Gain practical knowledge of how to prepare a Cause & Effect Diagram specifically for process plant operations, identifying key factors that contribute to system malfunctions or inefficiencies.",
          "Learn how to break down a process plant into its key components (people, equipment, materials, environment, and methods) and use these components to build a comprehensive Cause & Effect Diagram.",
          "Learn how to apply Cause & Effect Diagrams to identify the root causes of problems and implement corrective actions in process plant operations.",
          "Develop and utilize Cause & Effect Diagrams to improve monitoring and control systems and facilitate effective shutdown procedures.",
          "Review and analyze sample Cause & Effect Diagrams to understand their application in real-world scenarios and improve decision-making in process plants."


                      


        ],
    outline: [
        "Module 1:   An Introduction to Control, Monitoring and Shutdown of the Process Plant",
        "Module 2:   How to Prepare Cause & Effect Diagram for Process Plant.",
        "Module 3:   Sample Cause & Effect Diagram"

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $100"
  },
  
  {
    id: 10,
    title: "Air Dryer Sizing ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Air Dryer Sizing is the process of selecting the correct air dryer to meet the requirements of a compressed air system. An appropriately sized air dryer ensures that the compressed air is dried to the desired level, preventing moisture from damaging equipment and products. Incorrect sizing can lead to inefficiency, higher operating costs, and potential system failure. ",

      "The Air Dryer Sizing course is designed for engineers and professionals involved in designing, operating, and maintaining compressed air systems. This course provides a detailed understanding of the calculations and considerations involved in selecting and sizing air dryers. Participants will learn about key sizing parameters, how to interpret process data, and how to apply industry standards to ensure the correct air dryer specification. The course covers essential calculations, including adsorbent bed volume, pressure drop, and adsorber vessel sizing, offering a comprehensive approach to achieving optimal system performance."

    
    
    ],
      image:
      "https://i.ibb.co/DHDXVvKL/Air-dryer-9a49b5690ccbe8dc8d08.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Knowledge of Compressed Air Systems.",
      "Basic Engineering Principles.",
      "Mathematics.",
      "Process Data Interpretation."










    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of the course, participants will be able to:",
          "Comprehend the importance of correct sizing in optimizing air dryer performance, system efficiency, and preventing equipment failure.",
          "Learn about critical sizing parameters such as airflow, inlet and outlet temperatures, relative humidity, and dew point requirements.",
          "Understand the various codes and standards that apply to air dryer systems, ensuring compliance and safe operation in industrial settings.",
          "Accurately interpret process data, such as flow rates, pressure, temperature, and humidity, and use this data to guide air dryer sizing decisions.",
          "Gain hands-on experience with the calculations required for air dryer sizing, including adsorbent bed volume, pressure drop, and adsorber vessel sizing.",
          "Learn how to calculate the required volume of adsorbent material for the air dryer, ensuring proper moisture removal and system performance.",
          "Learn how to calculate pressure drop across the air dryer system, ensuring minimal energy loss and optimizing system efficiency.",
          "Understand how to calculate the required volume of the adsorber vessel, ensuring adequate capacity and performance during the drying cycle.",
          "Learn how to analyze the results of the sizing calculations and how to adjust parameters to meet system requirements.",
          "Analyze case studies to better understand the application of air dryer sizing principles in real-world settings and learn from practical examples."

                                


        ],
    outline: [
        "Module 1:   Calculation Objective",
        "Module 2:   General Information.",
        "Module 3:   Codes & Standards",
        "Module 4:   Sizing Parameters",
        "Module 5:   Process Data",
        "Module 6:   Calculation",
        "Module 7:   Adsorbent Bed Volume Calculation",
        "Module 8:   Pressure Drop Calculation",
        "Module 9:   Adsorber Vessel Volume Sizing",
        "Module 10:  Results",
        "Module 11:  Case Studies"


















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },

  {
    id: 10,
    title: "Special Plumbing Systems ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Special plumbing systems refer to specialized systems designed for unique or specific functions beyond the typical water supply, drainage, and waste systems found in most buildings. These systems cater to unique needs in specific environments like hospitals, industrial facilities, laboratories, food production, and more. These systems are often designed to meet stringent requirements for safety, functionality, and compliance with codes.",

      "The Special Plumbing Systems course is designed for professionals seeking advanced knowledge and expertise in specialized plumbing systems. This course covers a wide range of unique plumbing applications that go beyond traditional systems, such as fire protection, healthcare facility design, industrial waste treatment, irrigation, and renewable energy solutions like solar energy. The course also addresses the design of complex systems like swimming pools, fountains, compressed air systems, and steam piping. Through theoretical lessons and case studies, participants will learn the unique requirements and considerations for each system, ensuring they are equipped to design, install, and maintain these specialized systems in various industries."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/special%20plumbing%20systems.png?updatedAt=1767612756322",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Fundamental Plumbing Knowledge.",
      "Engineering or Technical Background.",
      "Mathematics.",
      "Familiarity with Codes and Standards."











    ],
    methodology: "Theoretical",
    objectives: [
          "Upon successful completion of this course, participants will be able to:",
          "Understand the principles of fire protection plumbing systems, including the selection of materials, system layout, and compliance with fire safety codes and standards.",
          "Gain specialized knowledge in the design and installation of plumbing systems for healthcare facilities, ensuring compliance with health codes, infection control measures, and patient safety.",
          "Learn the processes involved in the treatment and disposal of industrial waste, including system design considerations for effective waste management.",
          "Understand how to design and implement irrigation systems for residential, commercial, and agricultural purposes, focusing on water efficiency and sustainability.",
          "Gain expertise in the design and maintenance of reflecting pools and fountains, including water circulation, filtration, and aesthetic considerations.",
          "Learn the unique plumbing requirements for public swimming pools, including filtration, water treatment, and sanitation standards.",
          "Understand the design and safety considerations for gasoline and diesel oil plumbing systems, focusing on containment, transfer, and storage systems.",
          "Learn the fundamentals of steam and condensate piping systems, including their applications in industrial settings, as well as safety and maintenance considerations.",
          "Understand how to design and implement compressed air systems, focusing on system efficiency, pressure regulation, and safety protocols.",
          "Learn how to incorporate solar energy into plumbing systems, particularly in domestic and commercial water heating applications, and understand the design, installation, and maintenance of solar thermal systems.",
          "Gain knowledge in designing comprehensive site utility systems, including the integration of plumbing systems for large-scale residential or commercial projects.",
          "Apply your knowledge to real-world case studies, addressing challenges and developing solutions for specialized plumbing systems in diverse settings."

                                


        ],
    outline: [
        "Module 1:   Introduction",
        "Module 2:   Fire Protection Systems.",
        "Module 3:   Plumbing Design for Healthcare Facilities",
        "Module 4:   Treatment of Industrial Waste",
        "Module 5:   Irrigation Systems",
        "Module 6:   Reflecting Pools and Fountains",
        "Module 7:   Public Swimming Pools",
        "Module 8:   Gasoline and Diesel Oil Systems",
        "Module 9:   Steam and Condensate Piping",
        "Module 10:  Compressed Air Systems",
        "Module 11:  Solar Energy",
        "Module 12:  Site Utility Systems",
        "Module 13:  Case Studies"



















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $130"
  },

  {
    id: 10,
    title: "Plumbing Systems ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Plumbing systems refer to the network of pipes, fixtures, and equipment used to deliver clean water, remove wastewater, and handle other fluid-based needs within buildings or infrastructure. These systems are essential for providing potable water, sanitation, and stormwater management. Plumbing systems are designed to ensure safety, efficiency, and sustainability, and they must comply with local building codes and regulations.",

      "The Plumbing Systems course offers an in-depth exploration of the various systems involved in the plumbing design and maintenance of residential, commercial, and industrial buildings. This course provides professionals with the knowledge and skills necessary to design, install, and maintain a range of plumbing systems, from sanitary and storm drainage to specialized systems like graywater, vacuum, and pure water systems. Participants will learn about the principles, components, and best practices for ensuring efficient, safe, and sustainable plumbing operations. The course also includes hands-on case studies that enable students to apply theoretical concepts to real-world plumbing scenarios."

    
    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/plumbing%20systems.png?updatedAt=1767612736638",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Knowledge of Plumbing: Understanding of basic plumbing concepts, including pipe systems, fixtures, and fittings.",
      "Engineering Fundamentals: Familiarity with basic mechanical or civil engineering principles will be beneficial.",
      "Mathematics: Basic understanding of algebra and geometry for system calculations.",
      "Blueprint Reading: Knowledge of interpreting plumbing schematics and construction drawings is advantageous."












    ],
    methodology: "Theoretical",
    objectives: [
          "Upon successful completion of the course, participants will be able to:",
          "Understand the principles behind designing effective sanitary drainage systems, ensuring proper waste disposal and system integrity.",
          "Learn about the collection, treatment, and reuse of graywater, and how to incorporate these systems into sustainable plumbing designs.",
          "Gain knowledge on the critical role of venting in plumbing systems, including the design and installation of vent pipes to ensure proper air circulation and prevent harmful gas buildup.",
          "Understand the importance of stormwater management, including how to design and install efficient storm drainage systems to prevent flooding and water damage.",
          "Learn how to design reliable cold water supply systems that ensure consistent water pressure and meet the demands of users.",
          "Master the principles behind domestic water heating systems, including the selection, installation, and maintenance of water heaters for both residential and commercial applications.",
          "Learn about private sewage disposal systems, including septic systems and alternatives, ensuring proper waste treatment for properties not connected to municipal systems.",
          "Explore the design and maintenance of private water supply systems, including wells and pumps, to ensure safe and reliable water access.",
          "Gain an understanding of vacuum plumbing systems and their unique design considerations for applications requiring low water usage and increased efficiency.",
          "Learn the principles of designing pure water systems for specialized applications, such as laboratories and medical facilities, where high purity water is essential.",
          "Understand the specific requirements for lab waste systems, including chemical waste disposal and the safe handling of hazardous materials in plumbing systems.",
          "Apply theoretical knowledge to real-world plumbing scenarios, studying case studies that highlight common challenges and innovative solutions in plumbing design and installation."

                                


        ],
    outline: [
        "Module 1:   Introduction",
        "Module 2:   Sanitary Drainage Systems",
        "Module 3:   Graywater Systems ",
        "Module 4:   Vents and Venting Systems",
        "Module 5:   Storm Drainage Systems",
        "Module 6:   Cold Water Systems",
        "Module 7:   Domestic Water Heating Systems",
        "Module 8:   Private Sewage Disposal Systems",
        "Module 9:   Private Water Systems",
        "Module 10:  Vacuum Systems",
        "Module 11:  Pure Water Systems",
        "Module 12:  Lab Waste Systems",
        "Module 13:  Case Studies"




















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $130"
  },

  {
    id: 10,
    title: "Fundamentals of Plumbing Engineering ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Fundamentals of plumbing engineering encompass the principles and knowledge that are essential for designing, installing, and maintaining plumbing systems in buildings, industrial facilities, and infrastructure. Plumbing engineering ensures the effective management of water distribution, waste management, and overall fluid handling within a building or facility. Below are the key fundamentals.",

      "The Fundamentals of Plumbing Engineering course provides a comprehensive understanding of plumbing systems and their integral role in building design, construction, and operation. This course is ideal for engineers, architects, and professionals who want to develop a solid foundation in plumbing engineering practices. Topics covered include plumbing formulas, system design standards, cost estimation, job preparation, and advanced concepts such as energy conservation, seismic protection, acoustics, and plumbing for people with disabilities. Additionally, this course emphasizes modern practices like Building Information Modeling (BIM) and value engineering, while exploring how to ensure high-quality plumbing installations through careful planning and execution."

    
    
    ],
      image:
      "https://i.ibb.co/JF8QCxjd/fundamentals-b8df2714f79ffbaebd6a.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Understanding of Engineering Principles.",
      "Construction Knowledge.",
      "Mathematics.",
      "Blueprint Reading.",











    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of the course, participants will be able to:",
          "Recognize and apply plumbing-specific terminology, symbols, and formulas essential for plumbing engineering and system design.",
          "Comprehend and utilize national and international standards for plumbing materials and equipment, ensuring systems meet regulatory and safety requirements.",
          "Learn how to write detailed plumbing specifications, including system components, installation procedures, and performance requirements.",
          "Develop plumbing cost estimation skills, including the assessment of material, labor, and overhead costs, to prepare accurate and competitive plumbing budgets.",
          "Understand how to prepare comprehensive plumbing drawings, site plans, and field reports for installation, maintenance, and inspection purposes.",
          "Gain expertise in designing plumbing systems that meet the needs of people with disabilities, ensuring compliance with accessibility standards.",
          "Learn how to incorporate energy-efficient and resource-conserving practices into plumbing systems, focusing on sustainability and cost savings.",
          "Learn about the causes and prevention of corrosion in plumbing systems, and how to choose materials that mitigate corrosion risks.",
          "Understand the considerations for plumbing systems in earthquake-prone areas and how to design for seismic protection.",
          "Gain an understanding of how plumbing systems affect building acoustics and how to minimize noise through proper design and material selection.",
          "Learn the basics of value engineering in plumbing design to optimize functionality while minimizing costs without compromising quality.",
          "Understand best practices for ensuring high-quality plumbing installations, from design to completion, and addressing common issues during installation.",
          "Learn how to approach plumbing projects in existing buildings, including system retrofits, upgrades, and maintenance considerations.",
          "Understand the role of BIM in plumbing design, construction, and maintenance, and how it improves collaboration, accuracy, and efficiency in project delivery.",
          "Review and discuss real-world plumbing case studies to reinforce learning and examine the application of plumbing engineering principles in practical scenarios."

                                          


        ],
    outline: [
        "Module 1:   Formulas, Symbols, and Terminology",
        "Module 2:   Standards for Plumbing Materials and Equipment.",
        "Module 3:   Specifications",
        "Module 4:   Plumbing Cost Estimation",
        "Module 5:   Job Preparation, Drawings, and Field Reports",
        "Module 6:   Plumbing for People with Disabilities",
        "Module 7:   Energy and Resource Conservation in Plumbing",
        "Module 8:   Corrosion",
        "Module 9:   Seismic Protection of Plumbing Systems",
        "Module 10:  Acoustics in Plumbing",
        "Module 11:  Basics of Value Engineering",
        "Module 12:  Ensuring High-Quality Plumbing Installations",
        "Module 13:  Existing Building Job Preparation",
        "Module 14:  Building Information Modeling",
        "Module 15:  Case Studies"





















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦120,000 / $100"
  },

  {
    id: 10,
    title: "Piping Material Specification (PMS) ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Piping Material Specification (PMS) is a critical document in the design and construction of piping systems, typically used in industries such as oil and gas, petrochemical, chemical plants, power plants, and other industrial facilities. The PMS provides a comprehensive list of all materials required for the piping system, ensuring that the materials used meet both technical and safety standards.",
      "The Piping Material Specification (PMS) course is designed to equip participants with in-depth knowledge of the materials, components, and standards that are critical to the design, construction, and maintenance of piping systems. This course covers all aspects of piping material selection, from understanding industry codes and standards to specifying appropriate materials for pipes, valves, fittings, flanges, gaskets, and other related components. Participants will also gain hands-on experience in applying these concepts to real-world scenarios through case studies, with a particular focus on ensuring the integrity, safety, and performance of piping systems across various industries such as oil and gas, power, and chemical processing."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/pms1.png?updatedAt=1767612740066",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "4 Days",
    prerequisite: [
      "Basic understanding of mechanical and civil engineering principles.",
      "Familiarity with pipeline design and construction practices.",
      "Knowledge of materials engineering and manufacturing processes (helpful but not essential).",
      "Introduction to engineering codes and standards."












    ],
    methodology: "Theoretical",
    objectives: [
          "Upon completion of this course, participants will be able to:",
          "Gain a comprehensive understanding of the role of piping material specifications (PMS) in ensuring the performance, safety, and longevity of piping systems.",
          "Learn how to identify and apply relevant codes and standards (such as ASME, ASTM, and API) to select the right materials and components for a piping system.",
          "Master the procedures for creating, reviewing, and managing material specifications and their implementation throughout the lifecycle of a piping system.",
          "Understand how to select appropriate materials for various pipeline components, including pipes, fittings, flanges, gaskets, and valves, based on operational and environmental conditions.",
          "Gain expertise in selecting and working with different pressure classes (PMS 150₦, 300₦, and 450₦) for various pipeline applications.",
          "Learn how to ensure quality control and safety standards through material specification, installation practices, and testing procedures.",
          "Apply theoretical knowledge to real-world scenarios through case studies that cover common challenges and solutions in piping material specification.",
          "Develop practical experience in choosing materials, designing components, and adhering to best practices for piping systems."

                                                    


        ],
    outline: [
        "Module 1:   Scope",
        "Module 2:   Codes & Standards.",
        "Module 3:   Procedure",
        "Module 4:   Material Specification",
        "Module 5:   Pipeline ",
        "Module 6:   Pipes",
        "Module 7:   Fittings",
        "Module 8:   Flanges",
        "Module 9:   Gaskets ",
        "Module 10:  Bolting & Threads",
        "Module 11:  Thread Sealant",
        "Module 12:  Valves",
        "Module 13:  Quick Opening End Closure",
        "Module 14:  Hydro-testing Vents & Drains",
        "Module 15:  Pipeline Security Items",
        "Module 16:  PMS 150₦ Class",
        "Module 14:  PMS 300₦ Class",
        "Module 15:  PMS 450₦ Class",
        "Module 16:  Case Studies"






















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦150,000 / $120"
  },

  {
    id: 10,
    title: "LNG Process Overview ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Liquefied Natural Gas (LNG) is natural gas (mostly methane) that has been cooled to a liquid state for storage or transport. The liquefaction process reduces the volume of natural gas by about 600 times, making it easier and more economical to transport over long distances, particularly when pipelines are not viable, such as for international shipping. LNG is transported in specialized cryogenic containers or ships, and it is re-gasified at the destination to be used as a fuel.",

      "The LNG Process Overview course provides a comprehensive introduction to the processes and technologies involved in the Liquefied Natural Gas (LNG) industry. This course covers key aspects such as LNG characteristics, the LNG value chain, and the various processes associated with LNG liquefaction and regasification. Participants will gain a thorough understanding of the technologies and licensors involved in LNG operations, as well as the relevant codes and standards that govern LNG production, transportation, and storage. The course also includes case studies that illustrate real-world applications of LNG processes, enabling participants to apply theoretical knowledge to practical scenarios."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/LNG.png?updatedAt=1767612723859",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic Knowledge of Natural Gas and Hydrocarbons.",
      "Fundamentals of Chemical Engineering.",
      "Engineering or Technical Background.",
      "Mathematics."













    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of the course, participants will be able to:",
          "Describe the physical properties and behavior of LNG, including its composition, temperature, pressure, and storage requirements.",
          "Identify the key stages in the LNG value chain, from natural gas extraction to liquefaction, transportation, regasification, and distribution.",
          "Understand the various codes and standards that regulate LNG production, safety, transportation, and storage, ensuring compliance with industry regulations.",
          "Gain an overview of the components and operations involved in an LNG plant, including the facilities for liquefaction, storage, and loading.",
          "Gain detailed knowledge of the LNG liquefaction process, including the different types of liquefaction technologies and the key parameters that influence the liquefaction process.",
          "Learn about the various licensors involved in LNG liquefaction technologies, their roles, and the differences between technologies used in LNG plants.",
          "Learn about the regasification process, including the different methods of converting LNG back to natural gas for use in power generation, transportation, and industrial applications.",
          "Understand the key licensors and technologies involved in LNG regasification and the considerations for selecting a regasification technology.",
          "Apply theoretical concepts to real-world LNG operations and projects, learning from case studies to address challenges and optimize processes"

                                                    


        ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  LNG Characteristics.",
        "Module 3:  LNG Value Chain",
        "Module 4:  Codes and Standards",
        "Module 5:  The LNG Plant ",
        "Module 6:  LNG Liquefaction process",
        "Module 7:  LNG Liquefaction process Licensors",
        "Module 8:  LNG Regasification process",
        "Module 9:  LNG Regasification process Licensors",
        "Module 10: Case Studies" 























        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },

  {
    id: 10,
    title: "Understanding & Development of Pump Datasheet ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "A pump datasheet is a detailed document that provides all necessary technical specifications, operational parameters, and performance characteristics of a pump. It is essential for the proper selection, operation, and maintenance of pumps in various industrial applications, such as chemical, oil and gas, water treatment, and power generation.",

      "The understanding and development of a pump datasheet require attention to detail, as this document is used to communicate key information between designers, engineers, and operators.",

      "The Understanding & Development of Pump Datasheet course is designed to provide participants with a comprehensive understanding of how to interpret and develop pump datasheets. This course is aimed at engineers, designers, and professionals involved in the selection, operation, and maintenance of pumps in various industries. Participants will learn the key aspects of pump datasheets, including operational conditions, performance data, mechanical details, environmental considerations, and relevant standards. The course includes practical examples and case studies to enhance learning, ensuring participants can confidently create and evaluate pump datasheets for diverse applications."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/pump%20datasheet.png?updatedAt=1767612751089",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Basic understanding of pump systems and operation.",
      "Familiarity with mechanical engineering concepts.",
      "Previous experience in industrial or process engineering is recommended but not mandatory.",
      "Knowledge of basic fluid dynamics and pump characteristics.",
      "Pump Sizing"














    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of this course, participants will be able to:",
          "Understand and interpret the critical information provided in a pump datasheet.",
          "Create a comprehensive and accurate pump datasheet based on system requirements.",
          "Assess the operational requirements of a pump, including flow rate, pressure, and temperature.",
          "Understand performance curves, efficiency, and power requirements to evaluate pump suitability for different applications.",
          "Identify key mechanical elements of pumps, such as impellers, bearings, seals, and shafts, and their role in pump operation.",
          "Consider the impact of environmental conditions, installation limitations, and maintenance requirements when developing a pump datasheet.",
          "Identify and apply industry standards and regulatory requirements related to pump design and operation.",
          "Gain knowledge of the testing and inspection procedures to ensure pumps meet required specifications.",
          "Learn about different pump accessories, features, and customization options to meet specific project needs.",
          "Analyze real-world case studies to understand the practical application of pump datasheets in various industries."
                                                


        ],
    outline: [
        "Module 1:  General Information",
        "Module 2:  Operating Conditions.",
        "Module 3:  Pump Details",
        "Module 4:  Performance Data",
        "Module 5:  Mechanical Details ",
        "Module 6:  Environmental & Installation",
        "Module 7:  Testing & Inspection",
        "Module 8:  Accessories & Special Features",
        "Module 9:  Compliance & Standards ",
        "Module 10: Additional Notes",
        "Module 11: Case Studies "
























        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦80,000 / $70"
  },

  {
    id: 10,
    title: "Safe Work Practice Simultaneous Operations (SIMOPS) ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "SIMOPs (Simultaneous Operations) refer to the management and coordination of multiple activities or operations that occur simultaneously within a facility or site, especially in complex or high-risk environments like oil and gas, petrochemical plants, construction sites, and offshore platforms. SIMOPs are crucial for ensuring safety, efficiency, and compliance when various activities intersect or overlap in a way that could potentially lead to safety hazards, operational conflicts, or accidents.",
      "Managing SIMOPs involves careful planning, communication, and coordination between different teams, ensuring that all operations are carried out safely and efficiently without interfering with one another. This is particularly critical in projects where multiple contractors, departments, or teams are working at the same time on a site, often with different operational goals.",

      "The SIMOPs (Simultaneous Operations) Management course is designed to provide participants with a thorough understanding of the principles, types, and importance of SIMOPs in high-risk, multi-disciplinary industrial environments, particularly in the oil and gas, construction, and offshore industries. The course covers the critical aspects of SIMOPs planning, coordination, and execution, emphasizing risk identification and mitigation strategies. Through practical case studies and real-world examples, participants will gain the skills necessary to successfully plan, manage, and execute SIMOPs to ensure safety, efficiency, and regulatory compliance."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/simops.png?updatedAt=1767612758596",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic understanding of industrial operations, especially in the oil, gas, or construction sectors.",
      "Familiarity with risk management and safety protocols in industrial settings.",
      "Experience working in multi-disciplinary environments is beneficial but not required."















    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of this course, participants will be able to:",
          "Define what SIMOPs are and why they are a critical part of operations in high-risk industrial settings.",
          "Recognize different types of SIMOPs and how they apply to various operational environments.",
          "Understand the inherent risks and challenges associated with conducting multiple operations simultaneously.",
          "Develop and implement effective SIMOPs planning and coordination strategies.",
          "Learn how to identify potential risks in SIMOPs and implement practical risk mitigation strategies.",
          "Understand the full cycle of SIMOPs, from planning through execution and post-operation review.",
          "Analyze real-world case studies to understand the practical challenges and lessons learned from SIMOPs in various industries."
                                              


        ],
    outline: [
        "Module 1:   What are SIMOPs",
        "Module 2:   Types of SIMOPs.",
        "Module 3:   Why are SIMOPs critical",
        "Module 4:   Why are SIMOPs Planning Important",
        "Module 5:   SIMOPs Planning and Coordination ",
        "Module 6:   Identify Risks and Mitigation Measures",
        "Module 7:   SIMPOs Cycle",
        "Module 8:   Case Studies "

























        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦100,000 / $80"
  },

  {
    id: 10,
    title: "Process Sizing Criteria ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Process sizing criteria are essential guidelines and calculations used to determine the appropriate size and dimensions of equipment and systems within a chemical, petrochemical, or industrial process. These criteria help ensure that the equipment functions efficiently, meets safety standards, and operates within the required specifications for the particular application.",

      "The Process Sizing Criteria course is designed to provide engineers, designers, and professionals involved in process engineering with the fundamental principles and criteria required to properly size and select equipment for industrial systems. This course will explore a variety of equipment, including pumps, compressors, vessels, heat exchangers, and more, offering participants a structured approach to the design and sizing process. Emphasis is placed on understanding design parameters such as pressure, temperature, and specific equipment factors. The course will also include practical guidance on how to apply these sizing criteria to achieve safe, efficient, and reliable system designs."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/process%20sizing%20crit.png?updatedAt=1767612749401",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic understanding of process engineering concepts and principles",
      "Familiarity with common industrial equipment such as pumps, compressors, and heat exchangers",
      "Knowledge of fluid dynamics and thermodynamics as they pertain to industrial applications",
      "Experience with process design tools, calculations, and design methods"















    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of this course, participants will be able to:",
          "Identify and apply the essential design parameters, including design pressure, temperature, and equipment-specific factors, in the sizing of process equipment.",
          "Understand the specific sizing criteria for pumps, compressors, vessels, glycol packages, heat exchangers, and other critical process equipment.",
          "Calculate the appropriate dimensions and specifications for vessels, equipment nozzles, and piping systems.",
          "Understand the principles behind the design and sizing of flare and cold vent systems for safe overpressure relief.",
          "Apply real-world case studies to develop practical insights into equipment sizing and system integration."
                                            


        ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Scope.",
        "Module 3:  Reference Documents",
        "Module 4:  Design Pressure",
        "Module 5:  Design Temperature ",
        "Module 6:  Design factors Pumps ", 
        "Module 7:  Design factors  Compressors",
        "Module 8:  Design factors  Glycol package unit",
        "Module 9:  Design factors  Other equipment",
        "Module 10: Design factors",
        "Module 11: Vessels sizing criteria",
        "Module 12: Diameter of vessels",
        "Module 13: Heat exchangers",
        "Module 14: Equipment nozzles",
        "Module 15: Elevation of equipment",
        "Module 16: Piping",
        "Module 17: Flare and cold vent systems",
        "Module 18: Case Studies"


























        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"
    ],
    cost: "₦140,000 / $120"
  },

  {
    id: 10,
    title: "Pressure Safety Valve Sizing Stage 1 ",
    date: "Oct 2022 - Present",
    description: [
      "Pressure Safety Valves (PSVs) are critical protection devices used in process industries to safeguard equipment, personnel, and the environment from the dangers of overpressure. They serve as the last line of defense by automatically relieving excess pressure when operating conditions exceed design limits. Proper understanding, sizing, and selection of PSVs are essential for maintaining plant safety, regulatory compliance, and operational reliability.",
      "This course provides a structured and practical foundation in Pressure Safety Valve engineering, covering the principles of pressure relief, applicable codes and standards, system components, design fundamentals, overpressure scenarios, and sizing methodologies for gas and vapor services. Participants will also gain hands-on exposure to PSV sizing with excel template, using simulation software and learn how to prepare and interpret PSV datasheets used in engineering projects.",
      "The training combines theoretical understanding with real industry applications, case studies, and practical engineering approaches aligned with standards such as API RP 520, API RP 521, API 526, ASME Section VIII, and other international best practices."
    ],
    image: "https://ik.imagekit.io/mags/courses/psv1.png?updatedAt=1767612744994",
    tags: [],
    category: "process",
    duration: "5 Days",
    trainingLanguage: "English",
    prerequisite: [
      "Basic Engineering Principles; (Thermodynamics, Fluid Mechanics, Statics and Dynamics).",
      "Basic Mathematics",
      "Units and Conversions",
      "Process Safety Knowledge",
      "Knowledge of Calculation tools (Excel)",
      "Aspen Hysys Knowledge"
    ],
    methodology: "Theoretical",
    objectives: [
      "Understand the role and importance of Pressure Safety Valves in process safety management and plant protection.",
      "Explain the fundamental principles of pressure relief and the operating philosophy of PSVs.",
      "Identify and correctly apply key PSV terminologies used in design, sizing, and operations.",
      "Interpret relevant international codes and standards governing PSV design, sizing, selection, and installation.",
      "Recognize the major components of a PSV system and understand their functions.",
      "Understand the design fundamentals and engineering basis for pressure relief systems.",
      "Differentiate between various types of PSVs and determine the appropriate selection criteria for different services.",
      "Identify common overpressure scenarios and evaluate relief requirements for each case.",
      "Perform PSV sizing calculations for gas and vapor service applications using standard engineering methods.",
      "Apply simulation software tools for PSV sizing and validation.",
      "Prepare, review, and interpret PSV datasheets used during FEED, detailed engineering, and procurement stages.",
      "Analyze real project case studies involving PSV sizing challenges, design errors, and operational failures to improve engineering decision-making."
    ],
    outline: [
      "Module 1: Introduction and Overview of PSVs",
      "Module 2: Terminologies",
      "Module 3: Codes and Standards",
      "Module 4: Components of a PSV System",
      "Module 5: Design Fundamentals",
      "Module 6: Types of PSVs & Steps for Sizing",
      "Module 7: Overpressure Scenarios",
      "Module 8: PSV Sizing for gas or vapor",
      "Module 9:  PSV Sizing with simulation software.",
      "Module 10: PSV Datasheet",
      "Module 11: Case Study"
    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom, Face to Face or Virtual"
    ],
    cost: "#180,000 / $150",
    certification: "Certificate of Completion"
  },

  {
    id: 10,
    title: "Pressure Safety Valve Sizing Stage 2",
    date: "Oct 2022 - Present",
    description: [
      "Pressure Safety Valve (PSV) sizing is one of the most critical aspects of process safety engineering, requiring accurate evaluation of relieving conditions, fluid behavior, and credible overpressure scenarios to ensure equipment integrity and plant safety. While Stage 1 establishes the foundational principles of PSV design and selection, Stage 2 focuses on advanced sizing methodologies for various real operating and emergency conditions commonly encountered in oil & gas, petrochemical, and process industries.",
      "This course provides an in-depth practical approach to PSV sizing for gas, vapor, steam, liquid, thermal relief, fire case, and blocked liquid discharge scenarios. Participants will learn how to distinguish between critical and subcritical flow conditions, apply the correct API and ASME sizing equations, determine relieving loads, and evaluate relief requirements for complex systems.",
      "Special emphasis is placed on engineering judgment, scenario selection, relieving rate determination, and accurate preparation of PSV datasheets for FEED and detailed engineering projects. Real project case studies and industry examples are used to demonstrate common design mistakes, troubleshooting methods, and best engineering practices in pressure relief system design.",
      "The training aligns with major international standards including API RP 520, API RP 521, API 526, ASME Section VIII, and practical plant design requirements."
    ],
    image: "https://ik.imagekit.io/mags/courses/psv2.png?updatedAt=1767612747836",
    tags: [],
    category: "process",
    duration: "10 Days",
    trainingLanguage: "English",
    prerequisite: [
      "Course on Pressure Safety Valve Sizing Stage 1"















    ],
    methodology: "Theoretical",
    objectives: [
      "Review and reinforce the key concepts, principles, and calculations covered in PSV Sizing Stage 1.",
      "Understand the difference between critical flow and subcritical flow conditions in gas and vapor PSV sizing.",
      "Perform PSV sizing calculations for gas and vapor services under critical flow conditions using standard API methodologies.",
      "Perform PSV sizing calculations for gas and vapor services under subcritical flow conditions and correctly determine backpressure effects.",
      "Size PSVs for steam relief applications and understand the specific requirements for steam systems.",
      "Perform PSV sizing calculations for liquid service applications considering incompressible flow behavior.",
      "Design and size Thermal Relief Valves (TRVs) for blocked-in liquid systems affected by thermal expansion.",
      "Evaluate and size PSVs for fire case scenarios using fire heat input calculations and wetted surface considerations.",
      "Perform PSV sizing for blocked liquid discharge scenarios in pumps and liquid transfer systems.",
      "Prepare, review, and validate PSV datasheets for engineering design, procurement, and plant operations.",
      "Apply simulation tools such as Aspen HYSYS to verify relieving loads and validate sizing assumptions where required.",
      "Analyze practical case studies involving PSV undersizing, oversizing, improper scenario selection, and operational failures to improve engineering decision-making and design reliability."
    ],
    outline: [
      "Module 1: Review on Pressure Safety Valve Sizing Stage 1",
      "Module 2: PSV Sizing for Gas or vapor for critical flow",
      "Module 3: PSV Sizing for Gas or vapor for subcritical flow",
      "Module 4:  PSV Sizing for Gas for Steam Relief.",
      "Module 5: PSV Sizing for Liquid",
      "Module 6:  PSV Sizing for Thermal Relief Valve",
      "Module 7:  PSV Sizing for fire",
      "Module 8:   PSV Sizing for Blocked Liquid Discharge.",
      "Module 9: PSV Datasheet",
      "Module 10: Case Study"




























    ],
    assessment: "Online Written Exam",
    cdf: [
      "Classroom, Face to Face or Virtual"
    ],
    cost: "#350,000 / $250",
    certification: "Certificate of Completion"
  },

  {
    id: 10,
    title: "Vertical Vapor-Liquid Separator Sizing ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Sizing a Vertical Vapor-Liquid Separator (VLS) involves determining the appropriate dimensions and design parameters for a vessel that efficiently separates vapor and liquid phases in a process stream. The design process includes considerations like fluid flow rates, phase characteristics, and separation efficiency.",

      "The Vertical Vapor-Liquid Separator Sizing course is designed to provide engineers and professionals in the process industries with the necessary knowledge and practical skills to perform the proper sizing and design calculations for vertical vapor-liquid separators. This course will cover the essential calculations, design considerations, and industry standards involved in separator sizing. Participants will gain a comprehensive understanding of the parameters, process data, and calculations required to select the appropriate separator dimensions and components for effective operation."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/vert.png?updatedAt=1767612764076",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic knowledge of fluid mechanics and thermodynamics",
      "Familiarity with process engineering concepts related to separators and phase separation",
      "Basic understanding of process data such as flow rates, pressure, temperature, and phase properties",
      "Experience with engineering design tools and formulas for equipment sizing",
      "Knowledge of codes and industry standards related to pressure vessels and separation technology"





    ],
    methodology: "Theoretical",
    objectives: [
          "By the end of this course, participants will be able to:",
          "Understand the basic principles behind vapor-liquid separation processes and the operational characteristics of vertical separators.",
          "Use relevant codes and standards to ensure compliance in separator design and sizing.",
          "Identify and calculate key sizing parameters, including vapor and liquid flow rates, separator vessel dimensions, and nozzle sizes.",
          "Apply process data to accurately size vertical separators for specific operating conditions.",
          "Perform step-by-step sizing calculations for separator diameter, height, inlet and outlet nozzle sizing, and head sizing.",
          "Evaluate the results of separator sizing calculations and apply them to real-world applications.",
          "Apply case study insights to practical separator design challenges in various industries."

                                


        ],
    outline: [
        "Module 1:   Calculation Objective",
        "Module 2:   General Information.",
        "Module 3:   Codes & Standards",
        "Module 4:   Sizing Parameters",
        "Module 5:   Process Data",
        "Module 6:   Calculation",
        "Module 7:   Inlet Nozzle Sizing ",
        "Module 8:   Separator Vessel Diameter Sizing",
        "Module 9:   Separator Vessel Height Sizing",
        "Module 10:  Vapor Outlet Nozzle Sizing ",
        "Module 11:  Liquid Outlet Nozzle Sizing ",
        "Module 12:  Separator Diameter Sizing ",
        "Module 13:  Separator Height and Top and Bottom Head Sizing",
        "Module 14:  Results",
        "Module 15:  Case Studies"






        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦140,000 / $120"
  },


  {
    id: 10,
    title: "Basic Production Technology in Oilfield ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Oilfield production technology is a complex and multi-disciplinary field that involves many processes and specialized technologies. From drilling and completion to transportation and environmental management, each step requires careful planning, technology, and expertise to ensure the efficient and sustainable extraction of hydrocarbons.",

      "This course provides an introduction to the fundamentals of production technology in the oilfield, focusing on the processes and equipment involved in the production and initial treatment of hydrocarbons. Participants will explore key systems and technologies used in oilfield operations, such as wellheads, separation processes, crude oil dehydration, storage, and gas processing. Real-world case studies will be used to demonstrate practical applications and common challenges faced in oilfield production. The course is designed to enhance the technical understanding of field operations, improving efficiency and safety."

    
    ],
      image:
      "https://i.ibb.co/zV8gVkpX/Basic-Production-9cf8098dbe2d52852f23.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "Petroleum",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "A basic understanding of oil and gas industry operations. ",
      "Technical or engineering background (helpful but not essential). "





    ],
    methodology: "Theoretical",
    objectives: [
          "Comprehend the role and function of wellheads, flow lines, and inlet manifolds in oilfield operations ",
          "Understand the fundamental processes involved in hydrocarbon production. ",
          "Explain the principles of gas-liquid separation and its importance in oilfield production. ",
          "Recognize the equipment used for separation and their operational considerations. ",
          "Understand the purpose and methods of crude oil dehydration. ",
          "Evaluate the technologies and equipment used to remove water and impurities from crude oil.", 
          "Describe the design and purpose of storage tanks in oilfield operations. ",
          "Learn about safe handling practices and compliance requirements for storage systems. ",
          "Gain insights into the initial stages of gas processing.", 
          "Understand the basics of gas conditioning and separation from associated hydrocarbons. ",
          "Analyze real-world scenarios and challenges through case studies.", 
          "Learn best practices and strategies to optimize oilfield production systems. "

                                


        ],
    outline: [
        "Module 1:    Wellhead, Flow Line and Inlet Manifold",
        "Module 2:    Gas Liquid Separation",
        "Module 3     Crude Oil Dehydration",
        "Module 4:    Storage Tanks",
        "Module 5:    Introduction to Gas Processing",
        "Module 6:    Case Studies "






        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100"
  },

  {
    id: 10,
    title: "Chemical Process Safety ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Chemical process safety is an essential discipline in process engineering focused on preventing and mitigating accidents involving hazardous chemicals or processes. It aims to ensure that chemical processes are safe for both workers and the surrounding environment, while also maintaining operational efficiency.",

      "The Chemical Process Safety course is designed to provide participants with a comprehensive understanding of the principles and practices necessary for maintaining safety in chemical process industries. The course explores critical topics related to hazards, safety measures, and regulatory standards that govern the safe design, operation, and maintenance of chemical processes. It provides a detailed examination of the theory and practical application of various safety concepts to prevent accidents, ensure worker health, and protect the environment.",

      "Through in-depth modules, the course covers a wide array of topics, including toxicology, industrial hygiene, fire and explosion prevention, chemical reactivity, hazard identification, risk assessment, and the design of safety procedures. This course aims to prepare participants to mitigate risks, respond effectively to hazardous events, and integrate safety into every aspect of chemical operations.",

      "Professionals in the field of process engineering, plant safety, risk management, and environmental health and safety will benefit from this course."

    
    ],
      image:
      "https://i.ibb.co/xSGFpP3r/Chemical-Process-0caa2c2fd711276f6ccd.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "hazop hazid",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "10 Days",
    prerequisite: [
      "Chemical Engineering Fundamentals.",
      "Chemistry and Physics.",
      "General Safety Concepts."





    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the Fundamentals of Process Safety:",
          "Gain a thorough understanding of chemical process safety principles, including hazard analysis, risk management, and the implementation of safety measures in the chemical industry.",
          "Identify and evaluate the toxicological hazards associated with chemicals used in industrial processes and understand their health impacts on workers and the surrounding environment.",
          "Understand the role of industrial hygiene in protecting workers and learn techniques to control exposure to hazardous chemicals.",
          "Develop the ability to model the potential sources of hazardous chemical releases and understand the methods for assessing their potential impact.",
          "Gain expertise in various toxic release and dispersion models used to predict the behavior of hazardous substances in the atmosphere.",
          "Study the principles behind the occurrence of fires and explosions in chemical processes and the strategies to prevent them.",
          "Learn the techniques and engineering solutions to prevent fires and explosions through proper process design, materials, and safety systems.",
          "Recognize and analyze the risks associated with chemical reactivity, including runaway reactions and their potential consequences.",
          "Understand the purpose and importance of pressure relief devices in chemical processes, and how they help prevent overpressure scenarios.",
          "Learn how to size relief devices appropriately based on the specific needs and hazards of a given process.",
          "Use hazard identification methods such as HAZOP, fault tree analysis, and failure mode effects analysis (FMEA) to recognize potential risks in chemical operations.",
          "Apply risk assessment techniques to evaluate the likelihood and impact of various hazards, and determine the risk levels associated with different chemical processes.",
          "Create and implement safety procedures, protocols, and safety design principles that protect both workers and the environment during chemical operations.",
          "Study past industrial accidents and understand the lessons learned to prevent similar occurrences in the future, with a focus on continuous improvement."

                                          


        ],
    outline: [
        "Module 1:  Introduction",
        "Module 2:  Toxicology.",
        "Module 3:  Industrial Hygiene",
        "Module 4:  Source Model",
        "Module 5:  Toxic releases and dispersion models ",
        "Module 6:  Fires and Explosion",
        "Module 7:  Concepts to prevent Fires and Explosion",
        "Module 8:  Chemical Reactivity",
        "Module 9:  Introduction to Reliefs ",
        "Module 10: Relief Sizing",
        "Module 11: Hazard Identification",
        "Module 12: Risk Assessment",
        "Module 13: Safety Procedures and Design",
        "Module 14: Case Histories and Lessons Learned"







        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦450,000 / $350"
  },


  {
    id: 10,
    title: "Decision Making & Problem-Solving Strategies ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Effective decision-making and problem-solving are key to success in both professional and personal environments. These strategies are designed to address challenges, optimize outcomes, and minimize risks. ",

      "In today's fast-paced and complex world, the ability to make effective decisions and solve problems creatively is critical for success in both personal and professional contexts. This course explores the psychological, strategic, and practical aspects of decision-making and problem-solving. Participants will gain insights into how their minds work during these processes, learn proven strategies for making effective decisions, and discover techniques for thinking creatively and collaboratively. Real-world case studies provide practical examples to help participants apply their newfound skills to everyday challenges."

    
    ],
      image:
      "https://i.ibb.co/9k81QV1N/Decision-Making-440e89025f1fb56ec9a0.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "project management",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "A basic understanding of teamwork and collaboration in professional settings. ",
      "An interest in developing critical thinking and creative problem-solving skills. ",
      "Experience in managing decisions or solving challenges in personal or professional life (preferred but not mandatory)."






    ],
    methodology: "Theoretical",
    objectives: [
          "Recognize how the mind works during decision-making and problem-solving. ",
          "Identify common cognitive biases and their impact on decisions. ",
          "Develop skills for making sound, timely, and well-informed decisions. ",
          "Understand the importance of emotional intelligence and intuition in decision-making. ",
          "Learn techniques for sharing decisions with others to ensure alignment and commitment.",
          "Build confidence in leading or contributing to group decision-making processes. ",
          "Master key problem-solving strategies to tackle challenges efficiently. ",
          "Apply logical frameworks and analytical tools for structured problem resolution. ",
          "Use techniques for generating creative ideas to solve complex problems. ",
          "Think outside the box to develop unique and innovative solutions. ",
          "Improve reasoning, analysis, and evaluative skills for better decision-making. ",
          "Cultivate habits that enhance independent and critical thinking. ",
          "Analyze case studies to understand the application of decision-making and problem-solving strategies in various scenarios.", 
          "Reflect on lessons learned to apply them effectively in personal and professional contexts."

                                          


        ],
    outline: [
        "Module 1:    Your mind at work.",
        "Module 2:    The art of effective decision making.",
        "Module 3:    Sharing decisions with others.",
        "Module 4:    Key problem-solving strategies.",
        "Module 5:    How to generate ideas.",
        "Module 6:    Thinking outside the box ", 
        "Module 7:    Developing your thinking skills ",
        "Module 8:    Case Studies "







        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦100,000 / $90"
  },


  {
    id: 10,
    title: "Depressuring Blowdown ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "The depressuring blowdown system is vital for safely and efficiently reducing the pressure in pipelines, vessels, or entire process units in various industries, such as oil, gas, and chemical processing. Proper management of blowdown systems is essential to prevent overpressure, protect equipment, and maintain safe operational conditions during both normal and emergency shutdowns.",

      "This course provides an in-depth understanding of depressuring and blowdown systems, focusing on their design, modeling, and operational significance in process safety. Depressuring is a critical safety mechanism employed in industrial plants to rapidly reduce pressure during emergencies, such as overpressure or fire exposure, to mitigate risks and prevent catastrophic failures. The course covers acceptance criteria, API guidelines, modeling techniques using Aspen HYSYS, and practical case studies, equipping participants with the knowledge and skills to design, evaluate, and troubleshoot blowdown systems effectively."

    
    ],
      image:
      "https://i.ibb.co/Ng0r6Gxv/Depressuring-Blowdown-8b3a1b3f54f8b77b10e4.png",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "process",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic understanding of process safety and pressure relief systems.", 
      "Familiarity with process design tools and standards, such as API codes. ",
      "Knowledge of thermodynamics, fluid dynamics, and heat transfer principles. ",
      "Experience with process simulation software (Hysys)"






    ],
    methodology: "Theoretical",
    objectives: [
          "Define depressuring and blowdown and explain their role in process safety ",
          "Identify situations requiring depressuring systems.",
          "Evaluate common depressuring scenarios, such as fire exposure, process upsets, or equipment failures.",
          "Perform case-based analysis to identify optimal depressuring strategies. ",
          "Understand the role of restriction orifices in controlling flow rates during blowdown.", 
          "Evaluate performance characteristics such as heat transfer efficiency and pressure loss.",
          "Interpret Piping and Instrumentation Diagrams (P&IDs) related to depressuring systems. ",
          "Apply simulation tools like Aspen HYSYS to model depressuring scenarios. ",
          "Analyze results to verify system compliance and optimize design. ",
          "Identify common challenges in depressuring systems and develop effective solutions. ",
          "Enhance system performance through best practices and lessons from case studies. "

                                          


        ],
    outline: [
        "Module 1:   Introduction and Objectives of Depressuring",
        "Module 2:   Acceptance and Design Criteria.",
        "Module 3:   Depressuring Criteria –API",
        "Module 4:   Developing Depressuring Criteria",
        "Module 5:   Depressuring Cases",
        "Module 6:   Restriction Orifice P&ID",
        "Module 7:   Depressuring Modeling Aspen Hysys",
        "Module 8:   Case Studies "








        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦150,000 / $120"
  },
  
  {
    id: 10,
    title: "Axial, Centrifugal and  Expander Compressors 1 (General Requirement)",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Axial Compressors, Centrifugal Compressors, and Expander-Compressors are all types of turbomachinery used in various industrial applications like gas compression, power generation, and refrigeration. Each type has distinct operating principles, advantages, and typical use cases.",

      "This course provides a comprehensive understanding of the design, operation, and maintenance of axial and centrifugal compressors and expander-compressors, focusing on general requirements, standards, and best practices. It delves into the principles of compressor functionality, material selection, design considerations, and key components. Participants will gain insights into statutory requirements, control systems, accessories, and vendor data management, with practical applications demonstrated through real-world case studies."

    
    ],
      image:
      "https://i.ibb.co/vxYxdGCs/Axial-7e96ac8423111d975ba0.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic knowledge of thermodynamics, fluid mechanics, and rotating equipment.",
      "Familiarity with industrial processes involving compressors (oil & gas, petrochemical, or chemical industries).",
      "Awareness of engineering drawings, symbols, and technical documentation.",
      "Prior experience with machinery design, operation, or maintenance is beneficial."







    ],
    methodology: "Theoretical",
    objectives: [
          "Define the scope, purpose, and normative references for axial and centrifugal compressors and expander-compressors.",
          "Interpret defined terms, industry standards, and best practices in compressor design and operation",
          "Learn the meaning of acronyms, abbreviations, and symbols commonly used in compressor systems.",
          "Understand standard dimensions and unit conversions applied in compressor design.",
          "Recognize unit responsibilities, including manufacturer, vendor, and operator roles.",
          "Define the requirements for the design, selection, and application of compressors in industrial environments.",
          "Analyze key design considerations for axial and centrifugal compressors and expander-compressors.",
          "Understand the impact of design parameters on performance, reliability, and efficiency.",
          "Identify essential compressor accessories and their functions.",
          "Understand lubrication, cooling, sealing, and auxiliary system requirements.",
          "Learn best practices for quality control, inspection, and testing of compressors before commissioning.",
          "Understand shipment preparation, including handling and preservation requirements.",
          "Assess vendor-supplied data, including technical specifications, maintenance requirements, and performance guarantees.",
          "Ensure compliance with industry regulations and project requirements.",
          "Examine industry case studies to identify challenges and solutions in compressor design, operation, and troubleshooting.",
          "Develop problem-solving approaches based on lessons learned from past projects."

                                          


        ],
    outline: [
        "Module 1:     Scope, Defined Terms, Normative Reference and Purpose",
        "Module 2:     Acronyms, Abbreviations, and Symbols",
        "Module 3      Dimensions and Units",
        "Module 4:     Requirements and Unit Responsibility",
        "Module 5:     Basic Design",
        "Module 6:     Accessories",
        "Module 7:     Inspection, Testing, and Preparation for Shipment",
        "Module 8:     Vendor’s Data",
        "Module 9:     Case Studies "









        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦100,000 / $90"
  },

  {
    id: 10,
    title: "Axial, Centrifugal and  Expander Compressors 2 (Nonintegrally Geared Centrifugal and Axial Compressors)",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Axial Compressors, Centrifugal Compressors, and Expander-Compressors are all types of turbomachinery used in various industrial applications like gas compression, power generation, and refrigeration. Each type has distinct operating principles, advantages, and typical use cases.",

      "This course provides a comprehensive understanding of the design, operation, and maintenance of axial and centrifugal compressors and expander-compressors, focusing on general requirements, standards, and best practices. It delves into the principles of compressor functionality, material selection, design considerations, and key components. Participants will gain insights into statutory requirements, control systems, accessories, and vendor data management, with practical applications demonstrated through real-world case studies."

    
    ],
      image:
      "https://i.ibb.co/vxYxdGCs/Axial-7e96ac8423111d975ba0.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic knowledge of thermodynamics, fluid mechanics, and rotating equipment.",
      "Familiarity with industrial processes involving compressors (oil & gas, petrochemical, or chemical industries).",
      "Awareness of engineering drawings, symbols, and technical documentation.",
      "Prior experience with machinery design, operation, or maintenance is beneficial."







    ],
    methodology: "Theoretical",
    objectives: [
          "Define the scope, purpose, and normative references for axial and centrifugal compressors and expander-compressors.",
          "Interpret defined terms, industry standards, and best practices in compressor design and operation",
          "Learn the meaning of acronyms, abbreviations, and symbols commonly used in compressor systems.",
          "Understand standard dimensions and unit conversions applied in compressor design.",
          "Recognize unit responsibilities, including manufacturer, vendor, and operator roles.",
          "Define the requirements for the design, selection, and application of compressors in industrial environments.",
          "Analyze key design considerations for axial and centrifugal compressors and expander-compressors.",
          "Understand the impact of design parameters on performance, reliability, and efficiency.",
          "Develop a deeper understanding of control systems and instrumentation for monitoring performance and ensuring operational safety.",
          "Utilize special tools for maintenance and troubleshooting of Nonintegrally geared compressors.",
          "Understand inspection, testing, and preparation procedures for shipment readiness",
          "Analyze real-world case studies to understand challenges and solutions specific to Nonintegrally geared compressors.",
          "Design and specifications of compressor casings",
          "Design and standards for inlet and outlet pressure connections",
          "Detailed analysis of blades, vanes, diffusers, and impellers.",
          "Study practical applications."

                                          


        ],
    outline: [
        "Module 1:     Scope, Defined Terms, Normative Reference and Purpose",
        "Module 2:     Acronyms, Abbreviations, and Symbols",
        "Module 3      Dimensions and Units",
        "Module 4:     Requirements and Unit Responsibility",
        "Module 5:     Basic Design",
        "Module 6:     Accessories",
        "Module 7:     Inspection, Testing, and Preparation for Shipment",
        "Module 8:     Vendor’s Data",
        "Module 9:     Case Studies "









        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100"
  },


  {
    id: 10,
    title: "Axial, Centrifugal and  Expander Compressors 3 (Integrally Geared Centrifugal Compressors)",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Axial Compressors, Centrifugal Compressors, and Expander-Compressors are all types of turbomachinery used in various industrial applications like gas compression, power generation, and refrigeration. Each type has distinct operating principles, advantages, and typical use cases.",

      "This course provides a comprehensive understanding of the design, operation, and maintenance of axial and centrifugal compressors and expander-compressors, focusing on general requirements, standards, and best practices. It delves into the principles of compressor functionality, material selection, design considerations, and key components. Participants will gain insights into statutory requirements, control systems, accessories, and vendor data management, with practical applications demonstrated through real-world case studies."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/Axial.jpg?updatedAt=1767612702638",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic knowledge of thermodynamics, fluid mechanics, and rotating equipment.",
      "Familiarity with industrial processes involving compressors (oil & gas, petrochemical, or chemical industries).",
      "Awareness of engineering drawings, symbols, and technical documentation.",
      "Prior experience with machinery design, operation, or maintenance is beneficial."








    ],
    methodology: "Theoretical",
    objectives: [
          "Define the key terms, acronyms, and symbols specific to Integrally geared centrifugal and axial compressors.",
          "Interpret dimensions, units, and nomenclature relevant to these systems.",
          "Understand the statutory requirements and responsibilities of manufacturers and operators.",
          "Apply basic and advanced design principles for Integrally geared compressors.",
          "Select suitable materials for casings, stationary components, and rotating elements to ensure reliability and durability.",
          "Identify and describe the functions of auxiliary systems such as lubrication, sealing systems, and mounting fixtures.",
          "Understand the role of couplings, guards, and gearing in compressor operations.",
          "Develop a deeper understanding of control systems and instrumentation for monitoring performance and ensuring operational safety.",
          "Utilize special tools for maintenance and troubleshooting of Integrally geared compressors.",
          "Understand inspection, testing, and preparation procedures for shipment readiness",
          "Analyze real-world case studies to understand challenges and solutions specific to Integrally geared compressors.",
          "Design and specifications of compressor casings",
          "Design and standards for inlet and outlet pressure connections",
          "Detailed analysis of blades, vanes, diffusers, and impellers.",
          "Review and management of supplier-provided data and documentation.",
          "Ensuring completeness and compliance with specifications.",
          "Study practical applications."


                                          


        ],
    outline: [
        "Module 1:     Scope, Defined Terms, Normative Reference and Purpose",
        "Module 2:     Acronyms, Abbreviations, and Symbols",
        "Module 3      Dimensions and Units",
        "Module 4:     Requirements and Unit Responsibility",
        "Module 5:     Basic Design",
        "Module 6:     Accessories",
        "Module 7:     Inspection, Testing, and Preparation for Shipment",
        "Module 8:     Supplier's Data",
        "Module 9:     Case Studies "









        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100"
  },

  {
    id: 10,
    title: "Axial, Centrifugal and  Expander Compressors 4 (Expander-compressors)",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Axial Compressors, Centrifugal Compressors, and Expander-Compressors are all types of turbomachinery used in various industrial applications like gas compression, power generation, and refrigeration. Each type has distinct operating principles, advantages, and typical use cases.",

      "This course provides a comprehensive understanding of the design, operation, and maintenance of axial and centrifugal compressors and expander-compressors, focusing on general requirements, standards, and best practices. It delves into the principles of compressor functionality, material selection, design considerations, and key components. Participants will gain insights into statutory requirements, control systems, accessories, and vendor data management, with practical applications demonstrated through real-world case studies."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/Axial.jpg?updatedAt=1767612702638",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic knowledge of thermodynamics, fluid mechanics, and rotating equipment.",
      "Familiarity with industrial processes involving compressors (oil & gas, petrochemical, or chemical industries).",
      "Awareness of engineering drawings, symbols, and technical documentation.",
      "Prior experience with machinery design, operation, or maintenance is beneficial."








    ],
    methodology: "Theoretical",
    objectives: [
          "Define the key terms, acronyms, and symbols specific to Integrally geared centrifugal and axial compressors.",
          "Interpret dimensions, units, and nomenclature relevant to these systems.",
          "Understand the statutory requirements and responsibilities of manufacturers and operators.",
          "Apply basic and advanced design principles for Integrally geared compressors.",
          "Select suitable materials for casings, stationary components, and rotating elements to ensure reliability and durability.",
          "Identify and describe the functions of auxiliary systems such as lubrication, sealing systems, and mounting fixtures.",
          "Understand the role of couplings, guards, and gearing in compressor operations.",
          "Develop a deeper understanding of control systems and instrumentation for monitoring performance and ensuring operational safety.",
          "Utilize special tools for maintenance and troubleshooting of Integrally geared compressors.",
          "Understand inspection, testing, and preparation procedures for shipment readiness",
          "Analyze real-world case studies to understand challenges and solutions specific to Integrally geared compressors.",
          "Design and specifications of compressor casings",
          "Design and standards for inlet and outlet pressure connections",
          "Detailed analysis of blades, vanes, diffusers, and impellers.",
          "Review and management of supplier-provided data and documentation.",
          "Ensuring completeness and compliance with specifications.",
          "Study practical applications."


                                          


        ],
    outline: [
        "Module 1:     Scope, Defined Terms, Normative Reference and Purpose",
        "Module 2:     Acronyms, Abbreviations, and Symbols",
        "Module 3      Dimensions and Units",
        "Module 4:     Requirements and Unit Responsibility",
        "Module 5:     Basic Design",
        "Module 6:     Accessories",
        "Module 7:     Inspection, Testing, and Preparation for Shipment",
        "Module 8:     Supplier's Data",
        "Module 9:     Case Studies "









        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100"
  },
  
  {
    id: 10,
    title: "EPC Contract & Engineering Documents in EPC",
    date: "Oct 2022 - Present",
    description:
    [
          
      "An EPC Contract is a form of project delivery system widely used in the engineering and construction industry, particularly for large-scale infrastructure, industrial, and energy projects. Under this contract model, the contractor is responsible for the engineering, procurement of materials and equipment, and construction of the project to deliver a fully operational facility to the client. Often referred to as a \"turnkey\" contract, it ensures the client receives a complete and functional facility upon project completion.", 

      "This course provides a comprehensive understanding of Engineering, Procurement, and Construction (EPC) contracts, along with the crucial role of engineering documents in EPC projects. It is designed to equip participants with the knowledge to effectively manage EPC contracts and engineering documentation to ensure project success. The course delves into the challenges, technical specifications, quality assurance, project timelines, and critical aspects of contract administration, supplemented by real-world case studies."

    
    ],
      image:
      "https://i.ibb.co/JwMJF2ts/EPC-contract-7458e17669f848bce020.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "project management",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic understanding of project management principles.",
      "Familiarity with contract law and construction processes.",
      "Awareness of engineering and design processes in large-scale projects.",
      "Experience in construction, procurement, or engineering (preferred but not mandatory)."









    ],
    methodology: "Theoretical",
    objectives: [
          "Define EPC contracts and recognize their role in delivering turnkey projects and identify common issues and challenges in EPC projects.",
          "Explain the scope of work and technical specifications involved in EPC contracts.",
          "Understand the roles of key stakeholders like the Design Director, Safety Consultant, and Proof Consultant.",
          "Analyze the Authority Engineer's responsibilities in EPC contracts.",
          "Learn how quality assurance is maintained and how variations or changes in scope are managed.", 
          "Evaluate the risks and responsibilities associated with assignment and sub-contracting.",
          "Understand clauses related to time, damages for delays, and bonuses for early completion.",
          "Examine insurance, price, price variation clauses, and payment structures in EPC contracts. ",
          "Assess the importance of proper financial planning and risk management.",
          "Understand the Defect Liability Period (DLP) and its role in ensuring project quality and compliance.",
          "Recognize the role of engineering documents in planning, design, execution, and commissioning.", 
          "Understand key engineering documents, including design drawings, specifications, and operational manuals.", 
          "Analyze case studies to understand best practices in EPC contract management and engineering documentation."



                                          


        ],
    outline: [
        "Module 1:    EPC contract, Issues and challenges",
        "Module 2:    Scope of works",
        "Module 3:    Technical Specs",
        "Module 4:    Design Director, Safety Consultant, Proof Consultant.",
        "Module 5:    Authority’s Engineer",
        "Module 6:    Quality assurance",
        "Module 7:    Variation/ Change in Scope.",
        "Module 8:    Assignment & Sub-contracting. ",
        "Module 9:    Time for project completion, levy of Damages Bonus for early completion.",
        "Module 10:   Insurance, Price, Price Variation clauses, Payment",
        "Module 11:   Defect Liability Period (DLP)",
        "Module 12:   Case Studies "










        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦80,000 / $60"
  },

  {
    id: 10,
    title: "Fabrication, Installation & Erection Procedure for Piping",
    date: "Oct 2022 - Present",
    description:
    [
          
      "The fabrication, installation, and erection of piping systems in industrial plants are critical processes that ensure the safe and efficient flow of fluids or gases within the system. These activities require adherence to strict standards and procedures to maintain the integrity, functionality, and safety of the piping system. The following is a typical procedure for fabricating, installing, and erecting piping systems, including the key steps and considerations at each stage. ",

      "The Fabrication, Installation & Erection Procedure for Piping course is designed to provide comprehensive training on the essential processes involved in the construction and installation of piping systems. It covers the entire workflow from the scope of the piping project to quality assurance, pressure testing, and final reinstatement. The course is intended for engineers, supervisors, and technicians working in the oil and gas, chemical, power generation, and construction industries, aiming to equip them with the necessary knowledge and skills to perform high-quality piping installation and erection.",

      "This course will cover key concepts including fabrication methods, welding, installation techniques, dimensional checking, and testing procedures. Additionally, it will delve into safety, environmental considerations, and the importance of maintaining high standards throughout the process."

    
    ],
      image:
      "https://i.ibb.co/4hswn5p/Fabrication-installation-c91b13b990b40e8f3554.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Familiarity with common piping materials, components, and their applications.",
      "Basic understanding of industries such as oil and gas, chemical, or power generation where piping systems are critical.",
      "Basic knowledge of construction or engineering principles related to mechanical systems, with some familiarity with the use of tools and equipment.",
      "Familiarity with basic safety practices in industrial work environments, including the use of personal protective equipment (PPE)."









    ],
    methodology: "Theoretical",
    objectives: [
          "Define the key objectives and deliverables in piping fabrication, installation, and erection processes.",
          "Gain insight into the terminology, standards, and references used in the industry for successful piping installation projects.",
          "Identify key stakeholders, their responsibilities, and the coordination required among different teams during the fabrication, installation, and erection stages.",
          "Master the step-by-step procedure for piping fabrication and installation, including pre-fabrication, welding, installation, and final testing.",
          "Understand the materials used in piping systems and how to select, inspect, and manage them effectively.",
          "Learn the techniques and processes involved in fabricating piping components before they are transported and assembled on-site.",
          "Gain hands-on knowledge on erecting and assembling piping systems in alignment with project specifications.",
          "Understand the unique considerations for installing underground piping, including trenching, support, and safety protocols.",
          "Learn the methods for checking the dimensions and alignment of installed piping systems to ensure compliance with project specifications.",
          "Understand the various welding techniques used in piping systems and how to ensure the integrity of welds through proper procedures.",
          "Learn the processes of protecting and maintaining piping systems through surface treatments like galvanizing, painting, and coating.",
          "Master the techniques for proper identification, labeling, and marking of pipes for easy reference and future maintenance.",
          "Learn how to implement QA/QC procedures to ensure the piping system meets all standards and regulations.",
          "Understand how to perform pressure testing to validate the strength and leak-free status of the piping system.",
          "Gain knowledge on the importance of system flushing to remove debris and contaminants before final commissioning.",
          "Learn how to return the piping system to full service after completion of testing and cleaning.",
          "Understand the necessary equipment, tools, and resources required for the safe and effective installation and erection of piping systems.",
          "Understand the health, safety, and environmental requirements for piping installation projects and how to implement them effectively."



                                          


        ],
    outline: [
        "Module 1:    Scope",
        "Module 2:    Definition and Reference.",
        "Module 3:    Responsibility",
        "Module 4:    Procedure",
        "Module 5:    Products and Materials",
        "Module 6:    Pre-fabrication",
        "Module 7:    Piping erection",
        "Module 8:    Installation of Underground Piping",
        "Module 9:    Dimensional Checking",
        "Module 10:   Welding",
        "Module 11:   Galvanizing Painting and Coating",
        "Module 12:   Identification and Marking",
        "Module 13:   Quality Assurance and Quality Control",
        "Module 14:   Pressure Testing",
        "Module 15:   Flushing",
        "Module 16:   Reinstatement",
        "Module 17:   Equipment and Resources ",
        "Module 18:   Health Safety and Environment ", 
        "Module 19:   Case Studies "











        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦150,000 / $120  "
  },


  {
    id: 10,
    title: "AIR-COOLED HEAT EXCHANGERS",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Air-Cooled Heat Exchangers (ACHEs) are a type of heat exchanger that uses air as the cooling medium to dissipate heat from a fluid (usually a liquid) passing through the system. Unlike water-cooled heat exchangers, which rely on water to absorb heat, air-cooled heat exchangers depend on ambient air to carry away heat from the fluid, making them particularly useful in environments where water availability is limited or where water usage needs to be minimized. ",

      "The AIR-COOLED HEAT EXCHANGERS course is designed to provide students with a comprehensive understanding of the principles, components, design, and operation of air-cooled heat exchangers (ACHE). This course focuses on the analysis of forced and induced draft systems, tube bundles, fan operation, as well as construction techniques and materials used in ACHE systems. Students will gain knowledge on advanced topics like air recirculation, evaporative cooling, and steam condensation, as well as the economic considerations involved in selecting and designing air-cooled heat exchangers.",

      "By the end of the course, students will be equipped to evaluate the performance of ACHE systems, apply design principles, and make informed decisions in real-world industrial applications. They will also learn from industry-specific case studies to better understand practical challenges and solutions in heat exchanger design and operation."

    
    ],
      image:
      "https://i.ibb.co/xt83xxFV/Air-cooled-560db2c1758e12c47f07.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "To fully benefit from this course, students should have foundational knowledge of:",
      "Thermodynamics – Basic understanding of heat transfer principles and thermodynamic cycles.",
      "Fluid Mechanics – Familiarity with fluid flow concepts, pressure drops, and fluid dynamics.",
      "Heat Transfer – Knowledge of conduction, convection, and radiation principles.",
      "Mechanical Engineering Basics – Understanding of mechanical systems and components, particularly those related to heat exchangers and cooling systems.",
      "Mathematical Concepts – Basic calculus and algebra to assist in the analysis of system designs and performance."









    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the basic principles of air-cooled heat exchangers (ACHE)",
          "Identify the various applications of ACHEs in different industries.",
          "Explain the operational differences between forced and induced draft systems.",
          "Compare the advantages and limitations of each system in practical applications.",
          "Identify the components of a tube bundle and understand how they impact heat exchanger efficiency.",
          "Discuss the types of tubing used and their materials, including the selection criteria based on heat transfer and fluid compatibility.",
          "Assess the role of fins in increasing surface area for enhanced heat exchange.",
          "Analyze the different types of fans used and understand their influence on airflow and system performance.",
          "Evaluate different fan driver mechanisms and their energy implications.",
          "Study how fan rings and plenums contribute to efficient airflow and cooling.",
          "Investigate the technologies used to regulate and optimize airflow for effective heat exchange.",
          "Identify the impact of air recirculation on system efficiency and methods to mitigate it.",
          "Study the role of trim coolers in enhancing system performance and efficiency.",
          "Analyze how humidification can improve the overall cooling process.",
          "Learn how evaporative cooling enhances performance under specific operational conditions.",
          "Study the role of steam condensers and their design considerations for effective heat transfer.",
          "Discuss the specialized requirements of air-cooled overhead condensers in ACHE systems.",
          "Assess how system design, materials, and operational factors influence the cost-effectiveness of air-cooled heat exchangers.",
          "Learn how to design ACHE systems based on operational requirements, environmental conditions, and system performance needs.",
          "Apply knowledge from real-world case studies to practical design, troubleshooting, and optimization of ACHE systems."



                                          


        ],
    outline: [
        "Module 1:   Introduction",
        "Module 2:   Forced and Induced Draft ",
        "Module 3:   Tube Bundle",
        "Module 4:   Tubing",
        "Module 5:   Finned-Tube Construction",
        "Module 6:   Fan",
        "Module 7:   Fan Drivers",
        "Module 8:   Fan Ring and Plenum Chambers",
        "Module 9:   Air-Flow Control",
        "Module 10:  Air Recirculation",
        "Module 11:  Trim Coolers",
        "Module 12:  Humidification Chambers",
        "Module 13:  Evaporative Cooling",
        "Module 14:  Steam Condensers",
        "Module 15:  Air Cooled Overhead Condensers",
        "Module 16:  Air Cooled Heat Exchanger Costs",
        "Module 17:  Design Considerations ",
        "Module 18:  Case Studies"












        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦80,000 / $60 "
  },


  {
    id: 10,
    title: "AIR CONDITIONING",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Air conditioning systems function as heat transfer equipment by moving heat from one area to another area to maintain a comfortable temperature. In this context, the primary mechanism by which air conditioning achieves cooling is heat exchange.",

      "This course provides an in-depth exploration of air conditioning systems, focusing on their role as heat transfer equipment in both comfort and industrial applications. The course covers the fundamental principles of air conditioning, including thermodynamic cycles, refrigerants, and heat exchangers. Participants will learn how air conditioning systems are designed, selected, and optimized for various environments, from residential and commercial comfort cooling to large-scale industrial applications. Additionally, the course delves into the critical aspects of load calculation, ventilation, and the operation of central and unitary refrigerant-based systems. Practical case studies will be used to provide real-world insight into the design, installation, and maintenance of air conditioning systems."

    
    ],
      image:
      "https://i.ibb.co/zV7HcDx4/Air-conditioning-67cfdf062a9e556b03f3.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "A basic understanding of thermodynamics and heat transfer principles (conduction, convection, and radiation).",
      "Familiarity with mechanical engineering concepts, particularly in refrigeration and HVAC (Heating, Ventilation, and Air Conditioning) systems).",
      "Knowledge of fluid dynamics and the operation of heat exchangers (e.g., evaporators, condensers)."









    ],
    methodology: "Theoretical",
    objectives: [
          "Gain a solid understanding of the thermodynamics and heat transfer principles behind air conditioning systems.",
          "Recognize the role of air conditioning as a heat transfer equipment in controlling temperature and humidity.",
          "Explore the importance of indoor air quality, temperature control, and energy efficiency in comfort air conditioning.",
          "Study the requirements for air conditioning in industrial settings, where factors like heat load, equipment cooling, and humidity control are critical.",
          "Learn to design systems that handle large-scale, high-capacity cooling needs.",
          "Understand the role of ventilation in maintaining air quality and temperature control.",
          "Learn how ventilation integrates with air conditioning systems to improve indoor air quality and comfort.",
          "Identify the key components of air conditioning systems, such as compressors, evaporators, condensers, and expansion valves.",
          "Understand the applications and advantages of these designs in space-constrained environments.",
          "Understand how these components interact to transfer heat and maintain desired conditions.",
          "Learn the design and operation of central air conditioning systems for large buildings or complexes.",
          "Understand the advantages and limitations of central systems, including ductwork design and system integration.",
          "Investigate unitary systems, which are typically used in smaller spaces or residential settings, and how they manage refrigerants and cooling loads.",
          "Study the selection and performance characteristics of unitary air conditioning systems.",
          "Learn the methods for calculating cooling loads based on factors like building size, insulation, external weather conditions, and internal heat generation.",
          "Apply load calculations to design air conditioning systems that meet the specific needs of a space.",
          "Analyze case studies to gain practical insights into the challenges and solutions in air conditioning system design and installation.",
          "Explore how air conditioning systems are applied across different industries, including commercial, residential, and industrial environments."



                                          


        ],
    outline: [
        "Module 1:    Introduction ",
        "Module 2:    Comfort Air Conditioning.",
        "Module 3:    Industrial Air Conditioning",
        "Module 4:    Ventilation",
        "Module 5:    Air-Conditioning Equipment",
        "Module 6:    Central Systems",
        "Module 7:    Unitary Refrigerant-Based Air-Conditioning Systems",
        "Module 8:    Load Calculation",
        "Module 9:    Case Studies "













        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦80,000 / $60 "
  },


  {
    id: 10,
    title: "COMPACT AND NONTUBULAR HEAT EXCHANGERS",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Compact and Non-tubular Heat Exchangers are a category of heat exchangers designed to offer efficient heat transfer in a compact form, often without the traditional tubular or shell-and-tube structure. These heat exchangers are especially useful in applications where space is limited, where high heat transfer efficiency is required, or where the traditional tubular designs would be too large or expensive to implement. ",

      "This course provides a comprehensive study of compact and non-tubular heat exchangers, focusing on a variety of advanced heat exchanger designs that offer space-saving solutions while maintaining high heat transfer performance. Unlike traditional shell-and-tube heat exchangers, compact and non-tubular designs are increasingly used in industries where constraints, high thermal efficiency, space and specialized material properties are important. The course covers several types of compact heat exchangers, including plate-and-frame, spiral-plate, plate-fin, and nonmetallic options such as graphite, ceramic, and Teflon heat exchangers, participants will be equipped with the knowledge to select, design, and troubleshoot compact and non-tubular heat exchangers based on application-specific needs."

    
    ],
      image:
      "https://i.ibb.co/TDqGPXZj/Compact-735a8d90115d7fd1f386.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "A foundational understanding of thermodynamics, heat transfer, and fluid dynamics.",
      "Basic knowledge of conventional heat exchangers (such as shell-and-tube) and their design principles.",
      "Familiarity with materials science, particularly in relation to heat transfer materials such as metals, ceramics, and polymers.",
      "Experience with mechanical or chemical engineering principles, including the use of design calculations to optimize heat exchangers."









    ],
    methodology: "Theoretical",
    objectives: [
          "Gain a strong understanding of the various types of compact heat exchangers and their design features.",
          "Recognize the advantages and limitations of compact heat exchangers compared to traditional shell-and-tube heat exchangers, particularly in terms of space, performance, and efficiency.",
          "Learn the design principles of plate-and-frame heat exchangers, including the function of gaskets and the flow arrangements that optimize heat transfer.",
          "Apply plate-and-frame exchangers to applications requiring high heat transfer performance and compact design.",
          "Understand the differences between gasketed and welded-plate heat exchangers, including their advantages, such as leak prevention in welded designs and flexibility in gasketed designs.",
          "Design and optimize these heat exchangers for specific thermal applications.",
          "Investigate the design and operation of spiral-plate heat exchangers, focusing on their compact structure and suitability for handling viscous fluids and high-temperature applications.",
          "Learn how brazed-plate-fin exchangers provide compact heat transfer solutions with high heat transfer efficiency by integrating plates and fins in a brazed design.",
          "Explore applications in industries such as refrigeration and cryogenics.",
          "Understand the design and performance of plate-fin tubular heat exchangers, focusing on their application in processes requiring compact heat exchangers with high heat transfer rates.",
          "Investigate the design features of spiral-tube exchangers, which offer a space-saving solution while maintaining good heat transfer and low pressure drop.",
          "Learn the characteristics of graphite heat exchangers, including their resistance to corrosion and high-temperature applications in chemical processes",
          "Analyze when to select graphite exchangers for applications involving aggressive chemicals or extreme temperatures.",
          "Understand the design of cascade coolers and their role in multi-stage cooling processes, particularly in cryogenics and specialized chemical processes.",
          "Study the unique bayonet-tube exchanger design, which is ideal for high-pressure applications and offers compactness and versatility.",
          "Explore the design considerations of atmospheric sections in heat exchangers, focusing on the use of non-pressurized zones for energy recovery or air cooling.",
          "Investigate the benefits and challenges of using nonmetallic materials (such as plastics and composites) in heat exchangers, particularly for handling aggressive or corrosive fluids.",
          "Learn about the unique properties of PVDF (Polyvinylidene Fluoride) heat exchangers, including their chemical resistance and applications in the semiconductor and pharmaceutical industries.",
          "Understand the role of ceramic heat exchangers, which offer high-temperature resistance and stability in high-performance applications, such as in energy and chemical industries.",
          "Study the use of Teflon-based heat exchangers, focusing on their chemical inertness, non-stick properties, and suitability for aggressive or reactive fluids.",
          "Use case studies to identify design challenges and solutions for optimizing heat exchanger performance based on specific process requirements."



                                          


        ],
    outline: [
        "Module 1:    Compact Heat Exchangers",
        "Module 2:    Plate-and-Frame Exchangers",
        "Module 3:    Gasketed-Plate Exchangers",
        "Module 4:    Welded- and Brazed-Plate Exchangers",
        "Module 5:    Spiral-Plate Exchangers ",
        "Module 6:    Brazed-Plate-Fin Exchangers",
        "Module 7:    Plate-Fin Tubular Exchangers (PFE) ",
        "Module 8:    Spiral-Tube Exchangers (STE) ",
        "Module 9:    Graphite Heat Exchangers",
        "Module 10:   Cascade Coolers",
        "Module 11:   Bayonet-Tube Exchangers",
        "Module 12:   Atmospheric Sections",
        "Module 13:   Nonmetallic Heat Exchangers",
        "Module 14:   PVDF Heat Exchangers",
        "Module 15:   Ceramic Heat Exchangers",
        "Module 16:   Teflon Heat Exchangers",
        "Module 17:   Case Studies" 














        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100  "
  },


  {
    id: 10,
    title: "CRYOGENIC PROCESSES",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Cryogenic processes refer to processes that occur at extremely low temperatures, typically below -150°C (-238°F), where gases become liquids, solids, or exhibit unique physical properties. These processes are often used for a variety of industrial, scientific, and engineering applications. Cryogenic temperatures are typically achieved using specialized refrigeration systems or cryogenic fluids such as liquid nitrogen (LN2), liquid oxygen (LOX), or liquid helium (LHE). ",

      "This course provides an in-depth understanding of cryogenic processes, which involve the study and application of extremely low temperatures, typically below -150°C (-238°F). The course covers the essential principles of cryogenics, including the properties of cryogenic fluids, refrigeration, liquefaction, process equipment, separation and purification systems, and safety considerations. The course is designed to equip students with both theoretical knowledge and practical applications of cryogenics in various industries such as aerospace, medical, food preservation, and industrial gas production.",

      "Throughout the course, Participants will explore the key components and technologies associated with cryogenic systems and gain insight into the safety protocols necessary when handling cryogenic materials. Case studies will provide real-world examples of how cryogenic processes are implemented across different sectors."

    
    ],
      image:
      "https://i.ibb.co/spzS8zBt/Cryogenic-processes-dde6b5f66e83d2a03675.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "A basic understanding of thermodynamics and heat transfer principles.",
      "Familiarity with Fluid mechanics and material properties ",
      "Basic chemistry (particularly gas laws and phase transitions)."









    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the fundamentals of cryogenic processes, including the principles of low-temperature thermodynamics and their practical applications.",
          "Identify and describe the properties of cryogenic fluids, including the characteristics that distinguish them from standard fluids at higher temperatures.",
          "Comprehend the properties and behaviors of materials at cryogenic temperatures, focusing on changes in solid-state properties and their implications for material selection.",
          "Analyze refrigeration and liquefaction processes used to produce and maintain cryogenic conditions in various systems.",
          "Describe the function and design of cryogenic process equipment, including compressors, heat exchangers, and expansion devices.",
          "Examine separation and purification systems employed in cryogenic applications, particularly in the production of pure gases and liquefied natural gas (LNG).",
          "Understand storage and transfer systems for cryogenic liquids and gases, including insulation, pressure control, and transfer mechanisms.",
          "Apply principles of cryogenic instrumentation in monitoring and controlling cryogenic processes, ensuring system efficiency and safety.",
          "Implement safety practices related to cryogenic systems, including handling cryogenic fluids and managing associated risks like asphyxiation and frostbite.",
          "Explore the use of heat exchangers in processes involving solids (e.g., solid-liquid and solid-gas heat transfer Critically evaluate real-world case studies, understanding the practical challenges and solutions applied in cryogenic industries such as space exploration, medicine, and food preservation."



                                          


        ],
    outline: [
        "Module 1:   Introduction",
        "Module 2:    Properties of Cryogenic Fluids.",
        "Module 3:    Properties of Solids",
        "Module 4:    Refrigeration and Liquefaction",
        "Module 5:    Process Equipment",
        "Module 6:    Separation and Purification Systems",
        "Module 7:    Storage and Transfer Systems",
        "Module 8:    Cryogenic Instrumentation",
        "Module 9:    Safety",
        "Module 10:   Case Studies "















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100  "
  },

  {
    id: 10,
    title: "HAIRPIN/DOUBLE-PIPE HEAT EXCHANGERS",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Hairpin (Double-Pipe) Heat Exchangers are a simple and compact type of heat exchanger commonly used for small-scale or specialized heat exchange applications. They consist of two concentric pipes, one carrying the hot fluid and the other carrying the cold fluid. Heat is transferred between the two fluids through the walls of the inner pipe.",

      "This course focuses on the design, operation, and application of hairpin and double-pipe heat exchangers, which are widely used in situations where compact heat transfer solutions are required, especially for smaller flow rates or where space constraints are critical. Hairpin and double-pipe heat exchangers are simple yet versatile designs, and this course provides an in-depth exploration of their construction principles, types, and applications in various industries. Students will learn how to optimize the design of these exchangers to meet specific thermal and mechanical requirements while addressing challenges such as heat transfer efficiency, pressure drop, and cost-effectiveness. Real-world case studies will also be examined to provide practical insights into the use of these heat exchangers in industry."

    
    ],
      image:
      "https://i.ibb.co/5gpwwXHK/Hairpin-664b51ce2d0ce5f9a213.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "Basic understanding of thermodynamics, heat transfer (conduction, convection, and radiation), and fluid dynamics.",
      "Familiarity with general heat exchanger types and their applications.",
      "Basic knowledge of mechanical engineering principles, especially related to fluid flow and thermal systems.",
      "Experience with design calculations and understanding of the importance of heat transfer coefficients and pressure drop in heat exchanger design."










    ],
    methodology: "Theoretical",
    objectives: [
          "Grasp the fundamental construction principles of hairpin and double-pipe heat exchangers, including their configuration and operational principles.",
          "Identify the key design elements of these heat exchangers that influence their heat transfer capabilities and overall performance.",
          "Learn how to incorporate finned double pipes to increase heat transfer efficiency, particularly in applications where space or flow rates are limited.",
          "Analyze the effect of fin geometry and material selection on heat transfer performance in double-pipe heat exchangers.",
          "Explore the design and construction of multitube hairpin heat exchangers, which use multiple parallel tubes in a coiled configuration to enhance heat transfer.",
          "Analyze the advantages and challenges of multitube hairpin exchangers, including flow arrangements and the impact on pressure drop and heat transfer. ",
          "Apply the knowledge gained to design hairpin and double-pipe heat exchangers for various industrial applications, considering factors such as thermal performance, space limitations, and fluid properties.",
          "Evaluate how these exchangers can be optimized for specific operational conditions, such as high temperatures, corrosive fluids, or viscous liquids.",
          "Use case studies to apply design principles to real-world challenges in heat exchanger applications.",
          "Develop practical solutions to improve the performance, efficiency, and reliability of hairpin and double-pipe heat exchangers in diverse industry settings, such as oil and gas, HVAC, and food processing."



                                          


        ],
    outline: [
        "Module 1:      Principles of Construction",
        "Module 2:      Finned Double Pipes", 
        "Module 3:      Multitube Hairpins",
        "Module 4:      Design Applications",
        "Module 5:      Case Studies "















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦70,000 / $60 "
  },

  {
    id: 10,
    title: "HEAT EXCHANGERS FOR SOLIDS",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Heat Exchangers for Solids are specialized devices used to transfer heat between solids and fluids (liquids or gases), or between solids of different temperatures. These heat exchangers play a crucial role in processes where solid materials need to be either heated or cooled, and they are common in industries like chemical processing, food production, metals processing, and materials handling.",
 
      "This course provides a comprehensive study of heat exchange systems tailored specifically for solid materials during processes like solidification, fusion, and thermal management for sheeted and divided solids. Unlike traditional heat exchangers for fluids, heat exchangers for solids must account for unique material properties and complex heat transfer mechanisms. The course covers the design, operation, and optimization of heat exchangers suited for solid processes in industries such as metallurgy, chemical processing, and food manufacturing. By the end of the course, participants will be equipped with the knowledge to select, design, and troubleshoot heat exchangers optimized for solid materials in various industrial applications."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/Heat%20Exchangers%20for%20Solids.jpg?updatedAt=1767612711379",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "1 Day",
    prerequisite: [
      "A foundational understanding of thermodynamics and heat transfer principles (conduction, convection, and radiation).",
      "Basic knowledge of mechanical engineering concepts and industrial processing).",
      "Familiarity with material science, particularly in relation to the behavior of solids during thermal processes."










    ],
    methodology: "Theoretical",
    objectives: [
          "Recognize the unique challenges of heat transfer in solid materials.",
          "Apply heat transfer mechanisms (e.g., conduction, radiation) to different types of solids (e.g., metals, powders, polymers).",
          "Identify the equipment and systems used in the solidification of molten materials.",
          "Evaluate different heat exchangers used in solidification, such as chillers and cooling towers, for efficiency and performance.",
          "Understand the heat exchange requirements for melting and fusion of solid materials.",
          "Design and optimize systems to maintain effective heat transfer in fusion processes, focusing on temperature control.",
          "Investigate equipment for handling heat transfer in large, flat solids (e.g., metal sheets, polymer films).",
          "Learn how to maximize heat transfer efficiency and overcome challenges related to large surface areas.",
          "Learn how to design heat exchangers for particulate materials (e.g., powders, granules).",
          "Explore the use of rotary kilns and fluidized bed reactors for heat transfer in granular solids.",
          "Analyze real-world case studies to identify heat exchanger design challenges and solutions.",
          "Apply theoretical knowledge to practical scenarios in various industries, including metallurgy, pharmaceuticals, and food processing.",
          "Understand materials, design approaches, and their impact on energy"



                                          


        ],
    outline: [
        "Module 1:   Equipment for Solidification",
        "Module 2:   Equipment for Fusion of Solids.",
        "Module 3:   Heat-Transfer Equipment for Sheeted Solids",
        "Module 4:   Heat-Transfer Equipment for Divided Solids",
        "Module 5:   Case Studies "
















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦70,000 / $60 "
  },

  {
    id: 10,
    title: "Heat Transfer Equipment",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Heat transfer equipment refers to devices used to transfer heat from one medium (such as a fluid or gas) to another in various industrial and engineering applications. These systems are essential in processes where heating or cooling is required, such as in HVAC systems, chemical processing, power generation, and refrigeration. ",

      "The Heat Transfer Equipment course provides an in-depth understanding of the design, operation, and application of various heat transfer devices used in industrial processes. This course covers essential equipment and technologies designed to efficiently transfer heat in diverse systems. The curriculum addresses both conventional and advanced heat exchangers, thermal insulation, air conditioning, refrigeration, and cryogenic processes, among other topics. It emphasizes both theoretical principles and practical applications, making it ideal for engineers, designers, and technicians working with heat transfer systems in chemical, mechanical, and energy sectors."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/Heat%20Transfer%20Equipment%20Course.jpg?updatedAt=1767612712859",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "4 Days",
    prerequisite: [
      "A basic understanding of thermodynamics and fluid mechanics.",
      "Familiarity with heat transfer principles (conduction, convection, radiation).",
      "Background knowledge in mechanical or chemical engineering principles."










    ],
    methodology: "Theoretical",
    objectives: [
          "Understand the principles and methods used to design heat transfer equipment.",
          "Analyze and design shell-and-tube heat exchangers based on the TEMA (Tubular Exchanger Manufacturers Association) standards.",
          "Calculate heat transfer rates and pressure drops in shell-and-tube exchangers.",
          "Understand the design and working principles of hairpin and double-pipe heat exchangers.",
          "Evaluate performance characteristics such as heat transfer efficiency and pressure loss.",
          "Learn about the design and application of air-cooled heat exchangers.",
          "Assess the advantages and limitations compared to water-cooled heat exchangers.",
          "Study the design principles of compact and non-tubular heat exchangers (e.g., plate, spiral, and finned tube exchangers).",
          "Understand the applications and advantages of these designs in space-constrained environments.",
          "Explore the use of heat exchangers in processes involving solids (e.g., solid-liquid and solid-gas heat transfer).",
          "Study practical applications like food processing and materials handling.",
          "Investigate the importance and methods of thermal insulation in preventing heat loss or gain.",
          "Understand materials, design approaches, and their impact on energy efficiency.",
          "Learn the fundamentals of air conditioning systems, including heat transfer mechanisms and system components.",
          "Understand the design and energy efficiency considerations for various air conditioning applications.",
          "Study refrigeration cycles, equipment, and their applications in industrial and domestic settings.",
          "Understand the role of heat exchangers in refrigeration systems.",
          "Gain knowledge about heat transfer in cryogenic processes, including low-temperature heat exchangers.",
          "Understand the challenges and technologies involved in handling materials at cryogenic temperatures.",
          "Learn the design and operation of evaporators used in various industries (e.g., food, chemical, and pharmaceutical).",
          "Understand heat transfer dynamics in evaporator systems and how to optimize their performance.",
          "Apply theoretical concepts to real-world situations through case studies.",
          "Analyze and propose solutions for practical challenges faced in heat transfer equipment design and operation."


                                          


        ],
    outline: [
        "Module 1:   Thermal Design Of Heat-Transfer Equipment",
        "Module 2:   Tema-Style Shell-And-Tube Heat Exchangers.",
        "Module 3:   Hairpin/Double-Pipe Heat Exchangers",
        "Module 4:   Air-Cooled Heat Exchangers",
        "Module 5:   Compact And Nontubular Heat Exchangers",
        "Module 6:   Heat Exchangers For Solids",
        "Module 7:   Thermal Insulation",
        "Module 8:   Air Conditioning",
        "Module 9:   Refrigeration",
        "Module 10:  Cryogenic Processes",
        "Module 11:  Evaporators",
        "Module 12:  Case Studies" 

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦150,000 / $120 "
  },

  
  {
    id: 10,
    title: "REFRIGERATION",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Refrigeration is essentially a process that uses heat transfer to cool a space or substance, and it works similarly to air conditioning in that it moves heat from one location to another. However, the purpose of refrigeration is typically to preserve food, cool liquids, or regulate the temperature of industrial processes rather than just to cool the air in a building. ",

      "The Refrigeration under Heat Transfer Equipment course is designed to provide a comprehensive understanding of refrigeration systems, focusing on their fundamental principles, design, operation, and industrial applications. It explores various refrigeration technologies, including vapor-compression systems and alternative refrigerant methods, with an emphasis on practical case studies to enhance learning. The course is suitable for professionals, engineers, and students aiming to deepen their knowledge in thermal management and heat transfer equipment used in modern industries."

    
    ],
      image:
      "https://ik.imagekit.io/mags/courses/refrigeration.jpg?updatedAt=1767612743986",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "A basic understanding of thermodynamics and heat transfer principles.",
      "Familiarity with engineering fundamentals and processes, especially related to fluid dynamics and energy systems ",
      "Background knowledge in mechanical or chemical engineering principles."










    ],
    methodology: "Theoretical",
    objectives: [
          "Explain the principles of refrigeration and its importance in industrial applications.",
          "Define key concepts such as heat transfer, energy efficiency, and thermodynamic cycles.",
          "Describe the components and working principles of vapor-compression refrigeration systems.",
          "Evaluate the performance of mechanical refrigeration systems using thermodynamic analysis.",
          "Identify and understand the roles of various refrigeration equipment, including compressors, condensers, evaporators, and expansion valves.",
          "Assess equipment selection criteria based on system requirements and operational conditions.",
          "Explore non-mechanical refrigeration methods such as absorption systems and cryogenics.",
          "Analyze the environmental and economic impacts of alternative refrigerants and systems.",
          "Review and analyze real-world applications of refrigeration systems in industries such as food processing, and HVAC.",
          "Solve practical engineering challenges and optimize system designs based on case study insights."


                                          


        ],
    outline: [
        "Module 1:    Introduction",
        "Module 2:    Mechanical Refrigeration (Vapor-Compression Systems).",
        "Module 3:    Equipments",
        "Module 4:    Other Refrigerant Systems Applied in the Industry",
        "Module 5:    Case Studies "
        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦100,000 / $80"
  },

  {
    id: 10,
    title: "THERMAL INSULATION",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Thermal insulation refers to the process or materials used to reduce the rate of heat transfer between objects or spaces that are at different temperatures. Its primary purpose is to prevent unwanted heat loss or gain, thereby enhancing energy efficiency and maintaining comfort within buildings, vehicles, or equipment. ",

      "This course provides a comprehensive study of thermal insulation materials, systems, and practices used to optimize energy efficiency in a variety of industrial applications. Focusing on the science behind thermal resistance, insulation materials, and their practical implementation, this course covers the principles of insulation, selection criteria for different systems, and the economic considerations in choosing insulation thickness. The course also delves into best practices for the installation of insulation and highlights real-world case studies to understand challenges and solutions. By the end of the course, participants will be well-equipped to design, select, install, and optimize thermal insulation systems to improve energy conservation, safety, and cost-effectiveness."

    
    ],
      image:
      require("./coursesImg/Thermal Insulation.jpg"),
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "A basic understanding of thermodynamics and heat transfer principles (conduction, convection, and radiation).",
      "Familiarity with mechanical or civil engineering concepts, particularly in relation to energy systems and industrial applications.",
      "Background knowledge in mechanical or chemical engineering principles Knowledge of basic material science, especially regarding thermal properties of materials.",
      "Experience in energy efficiency or sustainability practices in industrial settings."










    ],
    methodology: "Theoretical",
    objectives: [
          "Identify the key types of insulation materials used in various industries (e.g., fiberglass, mineral wool, foam, reflective coatings).",
          "Understand the thermal properties of these materials and their suitability for different applications.",
          "Evaluate and select the most effective insulation systems based on factors such as temperature range, environmental conditions, and application requirements.",
          "Understand how to integrate insulation into various systems (e.g., pipes, tanks, ducts, equipment).",
          "Calculate the optimal insulation thickness based on thermal resistance, energy savings, and cost.",
          "Understand the concept of economic thickness, balancing insulation cost with long-term energy savings and payback periods.",
          "Understand proper installation techniques to maximize insulation effectiveness and longevity.",
          "Learn about challenges in insulation installation, including thermal bridging, moisture control, and handling specific applications like high-temperature or hazardous environments.",
          "Analyze real-world examples of insulation system designs and installations.",
          "Identify common issues in insulation selection and installation, and explore effective solutions."


                                          


        ],
    outline: [
        "Module 1:    Insulation Materials",
        "Module 2:    System Selection",
        "Module 3:    Economic Thickness of Insulation",
        "Module 4:    Installation Practice",
        "Module 5:    Case Studies "

        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦80,000 / $60  "
  },

  {
    id: 10,
    title: "HAZOP Guidelines for Oil and Gas standards",
    date: "Oct 2022 - Present",
    description:
    [
          
      "HAZOP (Hazard and Operability Study) is a structured and systematic technique used to identify hazards and operational issues in processes, particularly in industries like oil and gas. The method is essential for assessing potential risks and ensuring safety, compliance, and reliability in operations. In the context of ARAMCO (Saudi Aramco), the largest oil company in the world, adhering to their specific guidelines and standards for HAZOP is critical for operational safety.",

      "This course provides a structured approach to Hazard and Operability (HAZOP) studies, focusing on ARAMCO standards and best practices. Participants will gain a deep understanding of risk assessment methodologies, process safety management, and compliance requirements within ARAMCO guidelines. The course covers HAZOP study execution, risk identification, hazard mitigation, and documentation requirements, ensuring participants are equipped to conduct effective safety assessments in industrial environments."

    
    ],
      image:
      require("./coursesImg/HAZOP Guidelines for ARAMCO standards.jpg"),
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "hazop hazid",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic understanding of process safety and risk management ",
      "Familiarity with industrial operations and process flow diagrams (PFDs) / piping & instrumentation diagrams (P&IDs). ",
      "Knowledge of ARAMCO safety standards and HAZOP methodology (preferred but not mandatory). "










    ],
    methodology: "Theoretical",
    objectives: [
          "Learn the fundamental principles of HAZOP studies and their significance in risk management.",
          "Identify key ARAMCO standards and compliance requirements for conducting HAZOP assessments. ",
          "Apply systematic risk identification techniques to assess hazards in industrial processes.", 
          "Utilize HAZOP guidewords to analyze process deviations and their consequences.",
          "Identify potential failure modes, operability issues, and hazard scenarios. ",
          "Develop risk mitigation strategies and safety recommendations.",
          "Learn best practices for HAZOP documentation and reporting as per ARAMCO guidelines.",
          "Improve communication skills for presenting HAZOP findings to stakeholders. ",
          "Analyze case studies to understand common industry challenges and solutions. ",
          "Gain practical experience in conducting HAZOP workshops and risk assessments."


                                          


        ],
    outline: [
        "Module 1:     Review of HAZOP Technique",
        "Module 2:     Procedure for Conducting a HAZOP Study",
        "Module 3      Programming HAZOP Studies",
        "Module 4:     HAZOP Studies in Saudi ARAMCO",
        "Module 5:     Examples of HAZOP Studies",
        "Module 6:     Case Studies"


        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100  "
  },


  {
    id: 10,
    title: "Guidance on Valves Type Selection",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Selecting the right valve for a specific application is a critical task in process engineering, as valves control the flow of fluids (liquids, gases, and slurries) and ensure the safe, efficient, and reliable operation of systems. The wrong valve can lead to process inefficiencies, safety hazards, or even equipment failure.",
      "This course provides a structured approach to selecting the appropriate valves for various industrial applications, ensuring reliability, efficiency, and compliance with operational requirements. Participants will learn the key factors that influence valve selection, including required function, service conditions, fluid properties, operational frequency, isolation needs, maintenance considerations, environmental impact, cost, and past operational experience. The course will cover decision-making strategies and real-world case studies to enhance practical understanding and application."

    
    ],
      image:
      "https://i.ibb.co/0VZXCJNC/Guidance-on-Valves-Selection-6cd0ef17db8a2f501ff1.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic knowledge of fluid mechanics and flow control principles",
      "Familiarity with different types of valves and their applications",
      "Understanding of piping and process system requirements"










    ],
    methodology: "Theoretical",
    objectives: [
          "Identify different types of valves and their roles in controlling, regulating, and isolating fluid flow.",
          "Evaluate valve performance based on operational needs.",
          "Consider factors such as pressure, temperature, and operating environment.",
          "Understand how external conditions impact valve performance and longevity.",
          "Assess how the physical and chemical properties of fluids influence valve selection.",
          "Determine compatibility with different materials and sealing mechanisms.",
          "Understand viscosity, density, and flow properties related to valve operation.",
          "Learn how abrasive, corrosive, and high-temperature fluids affect valve reliability.",
          "Determine the importance of actuation methods and response time.",
          "Learn about manual, automated, and control valve options.",
          "Identify applications where tight shutoff, leakage prevention, and emergency isolation are critical.",
          "Compare different valve types for effective flow isolation.",
          "Learn about maintenance-friendly valve designs and accessibility considerations.",
          "Understand the impact of valve material selection on maintenance cycles.",
          "Assess the impact of emissions, noise levels, and regulatory requirements",
          "Understand the role of valves in sustainable and eco-friendly designs.",
          "Apply lessons learned from previous applications to improve valve selection",
          "Analyze failure modes and reliability data for better decision-making",
          "Understand space limitations and structural support requirements",
          "Optimize valve selection based on design constraints and installation requirements.",
          "Compare initial investment, operational costs, and long-term value.",
          "Evaluate trade-offs between budget constraints and performance reliability.",
          "Review industry-specific examples of valve selection challenges and solutions.",
          "Identify best practices for selecting, installing, and maintaining valves in different applications."


                                          


        ],
    outline: [
        "Module 1:       Required function. ",
        "Module 2:       Service conditions.",
        "Module 3:       Fluid type and condition",
        "Module 4        Fluid characteristics",
        "Module 5:       Frequency of operation",
        "Module 6:       Isolation requirements",
        "Module 7:       Maintenance requirements",
        "Module 8:       Environmental considerations",
        "Module 9:       Past experience in comparable conditions",
        "Module 10:      Weight and size",
        "Module 11:      Cost",
        "Module 12:      Case Studies "



        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100  "
  },

  {
    id: 10,
    title: "THERMAL DESIGN OF HEAT-TRANSFER EQUIPMENT",
    date: "Oct 2022 - Present",
    description:
    [
          
      "The thermal design of heat-transfer equipment is critical for the efficient transfer of heat between two or more fluids, typically involving either the removal or absorption of heat. This design process encompasses a variety of principles and considerations to ensure that the equipment operates at optimal performance, efficiency, and safety.",

      "This course provides an in-depth study of thermal design principles and practices for various types of heat-transfer equipment, focusing on the effective and efficient thermal management of industrial processes. The course covers a wide range of topics, from fundamental heat-transfer concepts to detailed design methods for various heat exchangers, condensers, reboilers, evaporators, and batch operations. Emphasizing practical applications, the course also addresses issues such as fouling, corrosion, and the cost considerations of heat exchangers, preparing students to approach real-world thermal design challenges in chemical and mechanical engineering settings."

    
    ],
      image:
      require("./coursesImg/Thermal Design of Heat-Transfer Equipment.jpg"),
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic understanding of thermodynamics and heat transfer principles (conduction, convection, radiation).",
      "Familiarity with fluid mechanics and heat exchanger operations.",
      "Knowledge of material science, especially related to thermal conductivity and corrosion.",
      "Introductory understanding of chemical process operations and equipment design"










    ],
    methodology: "Theoretical",
    objectives: [
          "Grasp the fundamental principles of heat transfer and their application to industrial equipment.",
          "Analyze and solve thermal design problems related to different heat transfer processes.",
          "Develop thermal designs for single-phase heat transfer systems.",
          "Apply design principles to specific equipment such as condensers, reboilers, and evaporators.",
          "Design systems for heating and cooling vessels, including batch operations and tank coils.",
          "Analyze the effects of fouling and scaling on heat exchanger performance and propose solutions.",
          "Design and evaluate the performance of shell-and-tube exchangers, incorporating baffles and tube bundles to improve efficiency. ",
          "Apply design methods to specialized systems such as scraped-surface exchangers and solids processing.",
          "Investigate and mitigate the impacts of corrosion in heat exchangers.",
          "Evaluate design solutions from both a technical and economic perspective.",
          "Analyze case studies to assess the challenges and solutions in thermal design of heat-transfer equipment."


                                          


        ],
    outline: [
        "Module 1:    Introduction to Thermal Design",
        "Module 2:    Thermal Design for Single-Phase Heat Transfer",
        "Module 3:    Thermal Design of Condensers",
        "Module 4:    Thermal Design of Reboilers",
        "Module 5:    Thermal Design of Evaporators",
        "Module 6:    Batch Operations: Heating and Cooling of Vessels",
        "Module 7:    Thermal Design of Tank Coils ",
        "Module 8:    Heating and Cooling of Tanks",
        "Module 9:    Extended or Finned Surfaces",
        "Module 10:   Fouling and Scaling",
        "Module 11:   Thermal Design for Solids Processing and Typical Heat-Transfer Coefficients",
        "Module 12:   Scraped-Surface Exchangers",
        "Module 13:   Case Studies "




        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100 "
  },

  {
    id: 10,
    title: "Guidelines for Auditing Process Safety Management Systems ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "Auditing Process Safety Management (PSM) Systems is a critical task to ensure that a company is maintaining a safe working environment, particularly in high-risk industries such as chemicals, oil and gas, and manufacturing. The guidelines for auditing PSM systems aim to evaluate whether processes are managed and controlled in a way that minimizes the risk of accidents, injuries, and environmental harm.",
      "This course provides a structured approach to auditing Process Safety Management (PSM) systems, focusing on compliance, risk management, and operational integrity. Participants will gain in-depth knowledge of audit techniques, accountability, process safety knowledge, project safety reviews, and management of change (MOC). The course follows industry best practices and regulatory guidelines to ensure that PSM audits effectively identify gaps, mitigate risks, and enhance overall safety performance. Real-world case studies will reinforce the practical application of audit strategies and methodologies."

    
    ],
      image:
      "https://i.ibb.co/tM766rD8/guidelines-for-auditing-a842ec00054a4b770255.jpg",
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "hazop hazid",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "3 Days",
    prerequisite: [
      "Basic understanding of Process Safety Management (PSM) principles.",
      "Familiarity with regulatory requirements (OSHA PSM, CCPS, API RP 750, or equivalent). ",
      "Experience in industrial risk assessment, compliance auditing, or safety reviews"










    ],
    methodology: "Theoretical",
    objectives: [
          "Define the purpose and objectives of PSM system audits. ",
          "Recognize the role of audits in ensuring regulatory compliance and risk mitigation. ",
          "Learn systematic audit methodologies, planning, and execution strategies. ",
          "Apply data collection techniques, interview methods, and documentation reviews in process safety audits.", 
          "Define roles and responsibilities in the audit process.", 
          "Ensure alignment between corporate policies and safety regulations. ",
          "Evaluate hazard identification, risk assessment, and process safety documentation. ",
          "Understand the role of safety culture and human factors in PSM effectiveness.",
          "Assess safety review processes during project development and execution.", 
          "Identify process hazards and mitigation strategies at various project stages. ",
          "Understand Management of Change (MOC) requirements in process safety.",
          "Identify common MOC failures and audit best practices.",
          "Analyze real-world PSM audit findings and lessons learned. "


                                          


        ],
    outline: [
        "Module 1:     Management of Process Safety Management Systems Audits",
        "Module 2:     Audit Techniques ",
        "Module 3:     Accountability and Responsibility",
        "Module 4       Process Safety Knowledge",
        "Module 5:      Project Safety Reviews",
        "Module 6:      Management of Change",
        "Module 7:      Process Equipment Integrity",
        "Module 8:      Process Risk Management",
        "Module 9:      Incident Investigation",
        "Module 10:    Human Factors",
        "Module 11:    Training and Performance",
        "Module 12:    Emergency Response Planning",
        "Module 13:    Case Studies "





        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦130,000 / $110 "
  },


  {
    id: 10,
    title: "TEMA-STYLE SHELL-AND-TUBE HEAT EXCHANGERS ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "TEMA (Tubular Exchanger Manufacturers Association) is an organization that provides standardized designs and guidelines for shell-and-tube heat exchangers, which are widely used in industries such as chemical processing, oil refining, power generation, and HVAC. The TEMA standards ensure consistent, reliable, and efficient designs of shell-and-tube heat exchangers. These standards help optimize heat transfer performance, ensure safety, and reduce operational issues.",

      "This course focuses on the design, construction, and application of TEMA-style shell-and-tube heat exchangers, which are among the most widely used heat transfer devices in industrial applications. Shell-and-tube exchangers are integral to processes in the chemical, petrochemical, and energy sectors, and this course provides a thorough understanding of their design, from the selection of materials to the arrangement of tubes and baffles. Students will learn the key principles governing the construction and operation of these systems, as well as practical considerations related to corrosion, cost, and case-specific challenges. By the end of the course, participants will be equipped with the knowledge to effectively design, troubleshoot, and optimize shell-and-tube heat exchangers for a variety of industrial application."

    
    ],
      image:
      require("./coursesImg/tema.jpg"),
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "mechanical",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "A foundational understanding of thermodynamics, heat transfer, and fluid mechanics Familiarity with fluid mechanics and heat exchanger operations.",
      "Basic knowledge of process equipment, especially heat exchangers.",
      "Familiarity with material properties relevant to thermal and mechanical design such as thermal conductivity, strength, and corrosion resistance."











    ],
    methodology: "Theoretical",
    objectives: [
          "Learn about the different types of TEMA-style shell-and-tube heat exchangers, including their key definitions and distinctions.",
          "Understand the application of various TEMA configurations (e.g., fixed tube sheet, U-tube, floating head) in different industrial contexts.",
          "Gain an understanding of the general design factors that influence the selection and configuration of shell-and-tube exchangers, including flow arrangements, heat transfer efficiency, and pressure drop.",
          "Analyze the thermal, mechanical, and fluid dynamic considerations that must be addressed during the design phase.",
          "Learn about the various construction methods used in shell-and-tube heat exchangers and their impact on performance, reliability, and maintenance.",
          "Explore the design features of the shell-side, including the selection of shell diameter, shell length, and the arrangement of inlet and outlet nozzles.",
          "Address considerations related to flow distribution, pressure drop, and heat transfer performance.", 
          "Learn the role of baffles in shell-and-tube heat exchangers, focusing on their design to enhance heat transfer and reduce fluid bypass.",
          "Understand the function of tube bundles in maximizing surface area and improving flow conditions.",
          "Analyze the causes and impacts of corrosion in shell-and-tube exchangers, particularly on materials in contact with corrosive fluids.",
          "Discuss methods of mitigating corrosion, including material selection and protective coating.",
          "Understand the various cost components involved in the design, fabrication, and maintenance of shell-and-tube heat exchangers",
          "Evaluate cost-performance trade-offs when selecting materials and construction method."



                                          


        ],
    outline: [
        "Module 1:    Types and Definitions",
        "Module 2:    General Design Considerations",
        "Module 3:    Principal Types of Construction",
        "Module 4:    Tube-Side Construction",
        "Module 5:    Shell-Side Construction",
        "Module 6:    Baffles and Tube Bundles",
        "Module 7:    Corrosion in Heat Exchangers",
        "Module 8:    Shell-and-Tube Exchanger Costs",
        "Module 9:    Case Studies "






        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦100,000 / $80 "
  },


  {
    id: 10,
    title: "Project Schedule ",
    date: "Oct 2022 - Present",
    description:
    [
          
      "A project schedule is a detailed plan that outlines the timeline for completing a project. It includes the list of tasks and activities, the order in which they need to be completed, their duration, and the resources required. A project schedule is an essential tool for managing time effectively, ensuring that the project is completed on time, within scope, and within budget.",
      "This course provides a structured approach to developing, managing, and optimizing project schedules. Participants will gain an in-depth understanding of scheduling principles, including activity sequencing, resource allocation, duration estimation, critical path analysis, and schedule risk assessment. The course will also cover techniques for updating and maintaining schedules to ensure project success. Real-world case studies will be used to reinforce key concepts and best practices."

    
    ],
      image:
      require("./coursesImg/Project Schedule.jpg"),
    tags: [
      'Trainer: Engr. Majid',
    ],
    category: "project management",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",

    duration: "2 Days",
    prerequisite: [
      "Basic understanding of project management principles ",
      "Familiarity with scheduling tools such as Primavera P6 or Microsoft Project ",
      "Knowledge of work breakdown structure (WBS) and resource planning"











    ],
    methodology: "Theoretical",
    objectives: [
          "Capture all activities required for project execution",
          "Define task dependencies and logical sequencing ",
          "Allocate labor, materials, and equipment to activities", 
          "Balance resource availability with project constraints ",
          "Establish realistic timeframes based on scope and resource availability ",
          "Use historical data and industry benchmarks for estimation", 
          "Ensure horizontal and vertical traceability in the schedule",
          "Confirm that the critical path accurately reflects project constraints ",
          "Conduct a schedule risk analysis to identify potential delays ",
          "Develop mitigation strategies for high-risk activities", 
          "Track progress against planned activities ",
          "Adjust schedules based on actual performance and project changes", 
          "Establish a reference schedule for tracking deviations ",
          "Use baseline comparisons to assess project efficiency ",
          "Analyze past scheduling successes and failures ",
          "Develop strategies for continuous improvement in project scheduling "



                                          


        ],
    outline: [
        "Module 1:        Capturing All Activities",
        "Module 2:        Sequencing All Activities",
        "Module 3:        Assigning Resources to All Activities ",
        "Module 4         Establishing the Duration of All Activities",
        "Module 5:        Verifying That the Schedule Can Be Traced Horizontally and Vertically ",
        "Module 6:        Confirming That the Critical Path Is Valid",
        "Module 7;        Ensuring Reasonable Total Float",
        "Module 8:        Conducting a Schedule Risk Analysis",
        "Module 9:        Updating the Schedule Using Actual Progress and Logic",
        "Module 10:       Maintaining a Baseline Schedule",
        "Module 11:       Case Studies "







        

















        ],
    assessment: "	Online Written  Exam",
    cdf: [
      "Classroom-based training",
      "Online courses ",
      "In-house workshops",
      "On-the-job training"

    ],
    cost: "₦120,000 / $100 "
  },

  
  {
    id: 11,
    title: "Quality Assurance / Quality Control Plan",
    date: "Present",
    description:
    [
        "A Quality Assurance (QA) / Quality Control (QC) Plan is a comprehensive framework used to ensure that products or services meet defined quality standards and requirements throughout the production or service delivery process. QA focuses on preventing defects by improving processes, systematizing operations, and ensuring consistency in performance. QC involves detecting defects and inconsistencies by inspecting and testing the final product or service to ensure it meets the specified requirements.",
        "This course provides a comprehensive understanding of QA and QC principles, focusing on the development, implementation, and maintenance of a QA/QC plan. Participants will learn about quality management systems, documentation processes, inspection protocols, and reporting procedures. Real-world case studies will be used to illustrate best practices and common challenges in quality management across various industries."
    ],
    image: require("./coursesImg/Quality assurance.jpg"),
    tags: [
        'Trainer: Engr. Majid',
    ],
    category: "project management",
    github: "https://github.com/Joseffl/react-todo-app",
    webapp: "https://bit.ly/47GF1It",
    duration: "2 Days",
    prerequisite: [
        "Basic understanding of quality assurance and quality control concepts",
        "Familiarity with industry standards and regulatory requirements for quality management",
        "Experience in project execution and documentation processes"
    ],
    methodology: "Theoretical",
    objectives: [
        "Learn about the key principles of quality management",
        "Understand the role of QMS in ensuring product and service consistency",
        "Learn how to structure and document a QAP",
        "Understand the responsibilities of QA teams in project execution",
        "Identify key roles and responsibilities within a QA/QC team",
        "Understand how organizational structure impacts quality assurance",
        "Understand the importance of NCRs in identifying quality issues",
        "Develop effective corrective and preventive action plans",
        "Learn how to document and approve materials for project use",
        "Learn how to prepare and submit material inspection requests",
        "Ensure compliance with project specifications and standards",
        "Understand inspection protocols and approval procedures",
        "Understand how to document and request installation inspections",
        "Develop skills for conducting quality checks on installed components",
        "Learn how to request and document quality control inspections",
        "Ensure adherence to QA/QC procedures in project execution",
        "Understand the role of checklists in standardizing quality control",
        "Develop checklists for different stages of quality management",
        "Analyze past QA/QC successes and failures",
        "Develop strategies for continuous quality improvement"
    ],
    outline: [
        "Module 1: Quality Management System",
        "Module 2: Quality Assurance Plan",
        "Module 3: Organizational Chart",
        "Module 4: Non-Conformance Report Form",
        "Module 5: Material Submittal Form",
        "Module 6: Request for Material Inspection Form",
        "Module 7: Request for Installation Inspection Form",
        "Module 8: Quality Control Inspection Request Form",
        "Module 9: Check List",
        "Module 10: Case Studies"
    ],
    assessment: "Online Written Exam",
    cdf: [
        "Classroom-based training",
        "Online courses",
        "In-house workshops",
        "On-the-job training"
    ],
    cost: "₦120,000 / $100",
    certification: "Certificate of Completion"
},


{
  id: 12,
  title: "Lean Project Management",
  date: "Present",
  description:
  [
      "Lean Project Management is a project management methodology derived from Lean Manufacturing principles, focusing on maximizing value while minimizing waste. The goal is to deliver projects more efficiently by optimizing processes, reducing non-value-adding activities, and ensuring that resources are used effectively. Lean principles are often associated with continuous improvement and creating value for the customer.",
      "This course provides a comprehensive understanding of Lean Project Management principles, tools, and techniques that enhance efficiency and streamline processes. Participants will explore how Lean practices are applied across industries, from manufacturing to IT and construction, and gain insights into measuring project success. Real-world case studies will be examined to demonstrate successful Lean implementations."
  ],
  image: require("./coursesImg/lean.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "project management",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic understanding of project management concepts",
      "Familiarity with process improvement methodologies",
      "Interest in optimizing workflows and increasing efficiency"
  ],
  methodology: "Theoretical",
  objectives: [
      "Define Lean principles and their application to project management",
      "Recognize the benefits of Lean methodologies in project execution",
      "Identify and eliminate sources of waste in project workflows",
      "Utilize Lean tools such as Kanban, Value Stream Mapping, and 5S",
      "Adapt Lean Project Management techniques to different sectors",
      "Understand industry-specific challenges and best practices",
      "Establish key performance indicators (KPIs) for Lean projects",
      "Assess project outcomes through data-driven decision-making",
      "Analyze successful Lean Project Management implementations",
      "Apply lessons learned to improve efficiency in future projects"
  ],
  outline: [
      "Module 1: Introduction to Lean Project Management",
      "Module 2: Core Principles of Lean Project Management",
      "Module 3: Planning Your Lean Project",
      "Module 4: Tools and Techniques in Lean Project Management",
      "Module 5: Implementing Lean Project Management",
      "Module 6: Lean Project Management in Various Industries",
      "Module 7: Measuring Success in Lean Projects",
      "Module 8: Advanced Topics in Lean Project Management",
      "Module 9: Case Studies and Real-World Examples"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 13,
  title: "Liquid–Gas and Solid–Gas Separators",
  date: "Present",
  description:
  [
      "Liquid–Gas and Solid–Gas Separators are devices used in various industrial processes to separate different phases of matter (liquids or solids) from a gas stream. These separators are essential in a wide range of applications, including air pollution control, chemical processing, oil and gas production, and HVAC systems.",
      "This course provides a comprehensive understanding of various techniques and equipment used in separating liquid, gas, and solid phases from one another in industrial applications. Participants will explore different separation methods, including magnetic field separation, electrofilters, gas separators, flash drums, venturis, cyclones, and decanters. By examining the operational principles, applications, and performance characteristics of these separators, learners will gain the expertise needed to select, design, and optimize separation processes in different industries such as chemical engineering, environmental engineering, and manufacturing."
  ],
  image: require("./coursesImg/liquid gas.jpg"),
  tags: [
      'Trainer: Engr. Adeyemi',
  ],
  category: "Petroleum",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Fundamentals of Fluid Mechanics",
      "Thermodynamics and Heat Transfer",
      "Mathematical and Computational Skills",
      "Introduction to Process Engineering"
  ],
  methodology: "Theoretical",
  objectives: [
      "Gain insight into how separation is achieved through different physical principles such as magnetic fields, electrostatic forces, and mechanical movement",
      "Develop the skills to choose the most effective separator for a specific liquid-gas or solid-gas separation challenge based on factors like efficiency, cost, and application",
      "Assess the performance characteristics of separators (such as efficiency, pressure drop, and maintenance requirements) through practical calculations and simulations",
      "Use knowledge gained in the course to design and optimize liquid-gas and solid-gas separation systems in industrial settings",
      "Solve complex separator-related problems, including pressure, flow rates, and operational efficiencies, with a focus on practical applications",
      "Use computational tools to simulate separator behavior in real-world conditions, optimizing for variables like velocity, pressure, and phase distribution",
      "Develop the ability to select the most suitable separator (e.g., venturi, cyclone, or scrubber) for specific applications based on operational requirements"
  ],
  outline: [
      "Module 1: Separation in a magnetic field",
      "Module 2: Electrofilters",
      "Module 3: Gas separators and flash drums",
      "Module 4: Separator vats",
      "Module 5: The venturi",
      "Module 6: Simulation of a venturi",
      "Module 7: Pulverization columns",
      "Module 8: Various points",
      "Module 9: Choice of an air scrubber",
      "Module 10: Varied calculations",
      "Module 11: The cyclone",
      "Module 12: The disk decanter",
      "Module 13: Tubular decanter",
      "Module 14: Screw mud separator"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 14,
  title: "Effluent Treatment Plant",
  date: "Present",
  description:
  [
      "An Effluent Treatment Plant (ETP) involves a series of physical, chemical, and biological processes to treat wastewater generated from industrial activities, including manufacturing, chemical processing, food production, and more. The effluent may contain a wide variety of pollutants such as organic compounds, suspended solids, oils, heavy metals, and other harmful substances. The treatment process helps to purify the effluent and make it safe for discharge or reuse.",
      "This course provides a comprehensive understanding of Effluent Treatment Plants (ETPs), essential for professionals working in industries that deal with wastewater treatment. It covers the fundamental concepts, necessity, design, operational aspects, and mechanisms involved in ETPs. By exploring real-world case studies, participants will gain insights into practical challenges and solutions in wastewater management. The course emphasizes the importance of sustainable practices, compliance with environmental regulations, and advanced treatment technologies to ensure the effective handling of industrial effluents."
  ],
  image: "https://i.ibb.co/bghKDCQx/effluent-treatment-1550837d1d2a03323c9f.jpg",
  tags: [
      'Trainer: Engr. Adeyemi',
  ],
  category: "Petroleum",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "A basic understanding of environmental science and chemistry",
      "Familiarity with industrial processes that generate wastewater",
      "Knowledge of water quality parameters and their significance",
      "Experience in engineering or process operations"
  ],
  methodology: "Theoretical",
  objectives: [
      "Define what an Effluent Treatment Plant is and its role in industrial wastewater management",
      "Identify industries where ETPs are critical",
      "Explain the environmental, legal, and operational reasons for setting up ETPs",
      "Understand the impact of untreated effluents on ecosystems and communities",
      "Outline the key considerations in designing an ETP",
      "Understand the importance of site-specific design tailored to the nature of effluents",
      "Learn about primary, secondary, and tertiary treatment processes",
      "Understand the working principles of key mechanisms such as aeration and sedimentation",
      "Gain practical knowledge of operating ETPs efficiently and safely",
      "Address challenges such as equipment maintenance and unexpected effluent variations",
      "Understand the functions of key ETP units, including screening, aeration, sedimentation tanks, and sludge thickening units",
      "Evaluate the benefits of sludge recycling to aeration tanks in enhancing treatment efficiency",
      "Apply theoretical knowledge to real-world problems through case studies",
      "Learn from successful ETP implementations and identify common pitfalls to avoid",
      "Highlight the importance of recycling treated effluents and resource recovery",
      "Encourage environmentally sustainable practices in industrial operations"
  ],
  outline: [
      "Module 1: ETP (Effluent Treatment Plant)",
      "Module 2: Need of ETP",
      "Module 3: Design of ETP",
      "Module 4: Treatment Levels & Mechanisms of ETP",
      "Module 5: Case Study 1",
      "Module 6: ETP Plant Operation",
      "Module 7: Screening",
      "Module 8: Aeration",
      "Module 9: Sedimentation Tank",
      "Module 10: Sludge Thickening Unit",
      "Module 11: Advantage of Recycle Sludge to Aeration Tank",
      "Module 12: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦80,000 / $70",
  certification: "Certificate of Completion"
},

{
  id: 15,
  title: "Pressure Control During Oil Well Drilling",
  date: "Present",
  description:
  [
      "Pressure control during oil well drilling is crucial to maintaining safety, efficiency, and the integrity of the well. During the drilling process, pressure from the underground formations can sometimes exceed the pressure exerted by the drilling fluid (mud), which can lead to dangerous situations like blowouts, uncontrolled releases of oil or gas, or equipment failure. Proper pressure control is essential to prevent such hazards.",
      "This course provides an in-depth understanding of pressure control techniques during oil well drilling, focusing on maintaining wellbore stability, preventing blowouts, and ensuring safe drilling operations. Participants will explore sediment pressure, well control equipment, standard and modified well-killing methods, realistic gas behavior, offshore safety considerations, and gas migration through cement. Real-world case studies will reinforce the application of these concepts in oilfield operations."
  ],
  image: require("./coursesImg/pressure control oil.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "Petroleum",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic knowledge of drilling operations and well construction",
      "Understanding of pressure fundamentals and fluid dynamics in oil and gas wells",
      "Familiarity with well control principles and safety regulations"
  ],
  methodology: "Theoretical",
  objectives: [
      "Learn about formation pressure, overburden pressure, and hydrostatic pressure",
      "Recognize the importance of maintaining wellbore stability",
      "Identify pressure zones and their impact on drilling operations",
      "Assess risks associated with abnormal pressure formations",
      "Understand the components of a well control system, including blowout preventers (BOPs)",
      "Explore how pressure control devices help prevent kicks and blowouts",
      "Learn about methods such as the driller’s method and the wait-and-weight method",
      "Understand how to manage kicks safely and restore well control",
      "Identify situations where adaptations to traditional methods are necessary",
      "Assess alternative approaches for improving well control efficiency",
      "Analyze how gas expands and migrates under different pressure and temperature conditions",
      "Learn to predict and mitigate the risks associated with gas influx",
      "Identify unique challenges related to offshore well control operations",
      "Learn about offshore regulations, emergency response, and safety measures",
      "Understand how gas migration affects casing integrity and well stability",
      "Explore methods to mitigate gas flow through cemented sections",
      "Analyze past well control incidents and their causes",
      "Develop strategies for improving pressure management based on industry experience"
  ],
  outline: [
      "Module 1: Introduction",
      "Module 2: Pressure in the sediments",
      "Module 3: Well Control Equipment",
      "Module 4: Standard killing methods",
      "Module 5: Modification of the standard killing method",
      "Module 6: More realistic gas behavior",
      "Module 7: Special offshore safety issues",
      "Module 8: Gas migration through cement",
      "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 16,
  title: "Natural Gas Processing Technology",
  date: "Present",
  description:
  [
      "Natural Gas Processing refers to the treatment and purification of raw natural gas extracted from underground reserves to remove impurities, separate different hydrocarbons, and produce natural gas that is safe and ready for commercial use. The technology involved in natural gas processing is essential to ensure that the gas meets the quality standards for transportation and end-user consumption.",
      "This course provides an in-depth understanding of natural gas processing, from its origin and production to advanced treatment and recovery processes. Participants will learn about oil and gas separation, condensate stabilization, gas dehydration, sweetening, sulfur recovery, refrigeration, and LNG/LPG processing. The course integrates real-world case studies to reinforce theoretical knowledge and practical applications."
  ],
  image: require("./coursesImg/Natural Gas.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "Petroleum",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic knowledge of petroleum geology and reservoir engineering",
      "Understanding of fluid mechanics and thermodynamics",
      "Familiarity with oil and gas production processes"
  ],
  methodology: "Theoretical",
  objectives: [
      "Explain the origin, accumulation, and extraction of natural gas",
      "Identify key production methods and industry standards",
      "Describe phase separation techniques",
      "Understand the role of separators in gas processing",
      "Explain the need for stabilizing condensates",
      "Explore different stabilization techniques",
      "Discuss the effects of moisture in gas streams",
      "Compare different dehydration technologies",
      "Identify common contaminants in natural gas",
      "Explain sweetening methods such as amine treatment and Claus process for sulfur recovery",
      "Explain the role of refrigeration in natural gas processing",
      "Compare different refrigeration technologies",
      "Understand the processes involved in liquefied petroleum and natural gas production",
      "Identify key considerations in storage, transportation, and safety",
      "Analyze real-world gas processing scenarios",
      "Evaluate solutions for optimizing gas processing operations"
  ],
  outline: [
      "Module 1: Natural gas Origin, Accumulation and production",
      "Module 2: Oil and Gas Separation",
      "Module 3: Condensate Stabilization",
      "Module 4: Gas Dehydration",
      "Module 5: Sweetening processes and sulfur recovery",
      "Module 6: Refrigeration",
      "Module 7: LPG/LNG",
      "Module 8: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 17,
  title: "CATALYST",
  date: "Present",
  description:
  [
      "A catalyst is a substance that increases the rate of a chemical reaction without being consumed or altered in the process. Catalysts provide an alternative reaction pathway with a lower activation energy, making it easier for reactions to occur at a given temperature.",
      "This course provides an in-depth exploration of catalysts used in various industrial processes, including hydrotreating, desulfurization, reforming, shift conversion, and methanation. Participants will gain an understanding of catalyst properties, thermodynamics, design principles, and operational best practices. The course also covers troubleshooting strategies and case studies, enabling learners to apply theoretical knowledge to real-world challenges in catalytic processes."
  ],
  image: "https://i.ibb.co/XxxhBSJ8/CATALYST-b25428ac25deb21303f8.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic knowledge of chemical engineering principles, including thermodynamics and reaction kinetics",
      "Familiarity with industrial processes such as ammonia synthesis and steam reforming",
      "Understanding of process diagrams and calculations related to heat and material balances"
  ],
  methodology: "Theoretical",
  objectives: [
      "Learn the basic principles and role of catalysts in refining and petrochemical industries",
      "Analyze the thermodynamics of inorganic substances in relation to reduction processes",
      "Identify and understand the functions of hydrotreating, desulfurization, reforming, shift conversion, and methanation catalysts",
      "Compare different catalyst types and their industrial applications",
      "Study the properties, chemical compositions, and activity of catalysts such as C20-6, C20-7, C49-1, C7-2, C8-6, C125, C11-2, and others",
      "Examine the effects of process conditions on catalyst performance",
      "Understand the design and operational factors affecting catalyst efficiency",
      "Implement best practices to extend catalyst life and maximize yield",
      "Identify common catalyst deactivation mechanisms",
      "Develop troubleshooting strategies for shift conversion, reforming, and methanation processes",
      "Use case studies to analyze industry challenges and solutions",
      "Gain practical insights into improving process efficiency and catalyst longevity"
  ],
  outline: [
      "Module 1: Introduction",
      "Module 2: Thermodynamics of Inorganic Substances relating to Reduction",
      "Module 3: Hydrotreating Catalysts",
      "Module 4: Desulfurization Catalysts",
      "Module 5: Primary Reforming Catalysts",
      "Module 6: Secondary Reforming Catalysts",
      "Module 7: C12 High Temperature Shift Conversion Catalysts",
      "Module 8: C18 Low Temperature Shift Conversion Catalysts",
      "Module 9: Methanation Catalysts",
      "Module 10: Ammonia Synthesis Catalysts",
      "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 18,
  title: "DWSIM - Process Simulation, Modeling and Optimization",
  date: "Present",
  description:
  [
      "DWSIM is an open-source process simulator designed for the modeling, simulation, and optimization of chemical processes. It is a powerful tool that allows engineers to create flow sheets, simulate chemical processes, perform calculations, and optimize the design of systems.",
      "This course provides a hands-on introduction to DWSIM, a powerful open-source process simulation software used for modeling, simulation, and optimization in chemical and process engineering. Participants will learn to build and configure process simulations, perform sensitivity analyses, optimize process flowsheets, and model chemical reactions. The course also covers advanced features, including handling hypothetical components, characterizing petroleum fractions, and utilizing component databases. Through interactive case studies, participants will gain practical experience in applying DWSIM to solve real-world engineering challenges."
  ],
  image: "https://i.ibb.co/q3y8XgSf/DWSIM-53e0b30819d8026fdc1d.jpg",
  tags: [
      'Trainer: Engr. Adeyemi',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "8 Days",
  prerequisite: [
      "A basic understanding of chemical engineering principles",
      "Familiarity with process design and flowsheeting concepts",
      "Knowledge of thermodynamics, heat and mass balance, and chemical reaction engineering"
  ],
  methodology: "Theoretical",
  objectives: [
      "Understand the DWSIM interface, welcome screen, and configuration options",
      "Understand the fundamental processes involved in hydrocarbon production",
      "Set up and customize the user environment for effective process simulation",
      "Create and execute process simulations using DWSIM",
      "Model basic and complex process flowsheets with real-world applications",
      "Perform sensitivity analyses to evaluate the impact of variable changes on system performance",
      "Apply optimization techniques to improve process efficiency and reduce costs",
      "Define and simulate chemical reactions within DWSIM",
      "Evaluate reaction kinetics, equilibrium, and their influence on overall processes",
      "Characterize petroleum fractions and create hypothetical components for simulations",
      "Use built-in tools to calculate physical and thermodynamic properties",
      "Leverage DWSIM's extensive component databases for accurate simulation inputs",
      "Integrate user-defined components for specialized processes",
      "Utilize utilities within DWSIM to perform additional calculations such as energy integration",
      "Apply advanced functionalities for specific industry scenarios",
      "Analyze real-world scenarios using DWSIM to build, simulate, and optimize process flowsheets"
  ],
  outline: [
      "Module 1: Introduction and Welcome Screen",
      "Module 2: Simulation",
      "Module 3: User Interface and Configuration",
      "Module 4: Process modeling (Flowsheeting)",
      "Module 5: Sensitivity Analysis",
      "Module 6: Flowsheet Optimization",
      "Module 7: Utilities",
      "Module 8: Chemical Reactions",
      "Module 9: Hypothetical Components and Characterization of Petroleum Fractions",
      "Module 10: Component Databases",
      "Module 11: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦180,000 / $150",
  certification: "Certificate of Completion"
},

{
  id: 19,
  title: "Firefighting Design",
  date: "Present",
  description:
  [
      "Firefighting Design refers to the systematic approach and engineering design principles used to implement fire safety systems in various facilities or industrial plants. Proper firefighting design ensures that potential fire hazards are controlled, and in case of a fire emergency, effective systems are in place to suppress or contain the fire, minimize damage, and protect lives and property.",
      "This course provides a comprehensive understanding of firefighting system design, focusing on NFPA standards applicable to sprinkler systems, fire hydrants, fire pumps, standpipes, foam systems, and smoke control. Participants will gain insights into the principles of fire protection engineering, system layout, flow requirements, and performance criteria essential for designing effective fire suppression and smoke control systems. The course also includes real-world case studies to help learners apply NFPA standards to practical fire safety scenarios."
  ],
  image: "https://i.ibb.co/XxXWqHBh/Firefighting-149d85c251ba4a2fc6ca.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "5 Days",
  prerequisite: [
      "Basic knowledge of fire dynamics and fire suppression principles",
      "Familiarity with firefighting systems and NFPA codes (preferred but not mandatory)",
      "Understanding of hydraulics and fluid flow calculations for firefighting applications"
  ],
  methodology: "Theoretical",
  objectives: [
      "Interpret key NFPA standards related to fire protection system design",
      "Apply NFPA 13, 14, 20, 11, and 92 to firefighting system layouts and requirements",
      "Learn layout principles, water demand calculations, and coverage areas for sprinkler systems",
      "Understand the selection of sprinkler heads, pipe networks, and water supply requirements",
      "Analyze fire hydrant spacing, flow rates, and pressure requirements for effective firefighting",
      "Design hydrant networks to ensure compliance with NFPA guidelines",
      "Understand fire pump selection, pressure requirements, and performance calculations",
      "Ensure fire pump reliability and compliance with NFPA regulations",
      "Define types of standpipe systems, pipe sizing, and pressure requirements",
      "Determine the integration of standpipes with other fire protection systems",
      "Explore foam system applications, foam concentrate types, and expansion ratios",
      "Design fire suppression solutions for hazardous and high-risk facilities",
      "Learn principles of smoke movement, exhaust ventilation, and pressurization techniques",
      "Ensure compliance with life safety requirements in buildings",
      "Analyze fire protection system failures and successes through case studies",
      "Improve decision-making and troubleshooting skills for fire safety engineering"
  ],
  outline: [
      "Module 1: Sprinkler System Design (NFPA 13)",
      "Module 2: Fire Hydrant Flow Requirements (NFPA 14)",
      "Module 3: Fire Pump Sizing (NFPA 20)",
      "Module 4: Standpipe System Design (NFPA 14)",
      "Module 5: Foam System Design (NFPA 11)",
      "Module 6: Smoke Control Systems (NFPA 92)",
      "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦250,000 / $200",
  certification: "Certificate of Completion"
},

{
  id: 20,
  title: "Flowmeters",
  date: "Present",
  description:
  [
      "Flowmeters are devices used to measure the flow rate or quantity of a gas or liquid moving through a pipe or duct. Accurate flow measurement is critical in many industries, such as oil and gas, water treatment, chemical processing, and HVAC systems, as it helps ensure proper system functioning, efficiency, and safety.",
      "This course provides a comprehensive understanding of flow measurement technologies, focusing on different types of flowmeters and their applications in industrial processes. Participants will learn about volumetric flowmeters, direct force measurement techniques, frequency-based and mass flowmeters, as well as other specialized types. The course will cover selection criteria, industry-specific applications, and troubleshooting common flow measurement challenges. Real-world case studies will offer practical insights into choosing and optimizing flowmeters for various operating conditions."
  ],
  image: "https://i.ibb.co/fd82pn98/Flowmeters-75ef4fa33868bf3d1c63.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "Basic knowledge of fluid mechanics and flow measurement principles",
      "Familiarity with process control and instrumentation systems",
      "Understanding of units and conversion factors related to flow measurement"
  ],
  methodology: "Theoretical",
  objectives: [
      "Learn the basic working mechanisms of different types of flowmeters",
      "Identify the advantages and limitations of each measurement technique",
      "Study the design and functionality of flowmeters that measure volumetric flow rates",
      "Understand their use in various industrial and commercial processes",
      "Learn how force-based flowmeters operate and their role in flow measurement",
      "Evaluate their accuracy, sensitivity, and industrial relevance",
      "Understand how frequency-based flowmeters determine flow rates",
      "Study mass flowmeters, their working principles, and their application",
      "Review specialized flowmeter designs and their niche applications",
      "Compare performance characteristics for various industrial settings",
      "Understand key selection criteria such as fluid properties, accuracy, pressure drop, and installation constraints",
      "Evaluate common challenges and troubleshooting techniques for flow measurement systems",
      "Review industry examples of flowmeter selection and implementation",
      "Identify best practices for optimizing flow measurement accuracy and efficiency"
  ],
  outline: [
      "Module 1: Introduction",
      "Module 2: Volumetric flowmeters",
      "Module 3: Direct Force",
      "Module 4: Frequency, Mass flowmeters",
      "Module 5: Other types",
      "Module 6: Selection Criteria and Common flow application",
      "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦60,000 / $50",
  certification: "Certificate of Completion"
},

{
  id: 21,
  title: "Drawings and Symbols Principles of Presentation at Project Definition Phase",
  date: "Present",
  description:
  [
      "The Project Definition Phase in engineering and design projects is the stage where the groundwork for the project is laid out. During this phase, a significant portion of the project's planning, scope, and design is defined, and drawings and symbols play an essential role in communicating technical information. They are used to represent concepts, systems, equipment, and infrastructure in a standardized, clear, and accurate manner.",
      "This course provides a structured understanding of drawings, symbols, and presentation principles used in the project definition phase of engineering and industrial projects. Participants will gain insights into standards, graphical representations, CAD software applications, and system settings to ensure consistency and clarity in technical documentation. The course also covers equipment visualization, deliverables, and case studies to provide real-world examples of best practices in technical drawing and symbol usage."
  ],
  image: "https://i.ibb.co/67qCJvJ0/Drawings-and-symbols-f55e96a5d8c0956c3839.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "Basic understanding of engineering drawings and drafting techniques",
      "Familiarity with industry standards for graphical symbols and notations",
      "Experience with CAD software for technical drawings"
  ],
  methodology: "Theoretical",
  objectives: [
      "Identify key standards and guidelines used in the project definition phase",
      "Apply best practices for maintaining consistency in engineering documentation",
      "Recognize commonly used symbols across different engineering disciplines",
      "Ensure compliance with industry and regulatory symbol standards",
      "Learn how to enhance clarity through effective use of line types, annotations, and scaling",
      "Apply visualization techniques for better communication of design intent",
      "Gain an understanding of CAD tools used for project documentation",
      "Learn essential commands and functions to create professional drawings",
      "Set up templates, layers, and line styles for standardization",
      "Understand the importance of file management and version control in CAD systems",
      "Learn the key components of a complete project drawing package",
      "Understand the documentation workflow from project initiation to completion",
      "Learn best practices for depicting mechanical, electrical, and piping equipment in drawings",
      "Use standard conventions for layout and dimensioning",
      "Analyze examples of well-executed and poorly executed project drawing",
      "Learn from past projects to improve accuracy and effectiveness in drawing presentations"
  ],
  outline: [
      "Module 1: Scope and Reference Documents",
      "Module 2: Definitions",
      "Module 3: Symbols",
      "Module 4: Graphics and Visuals",
      "Module 5: CAD Software",
      "Module 6: CAD System Settings",
      "Module 7: Deliverables",
      "Module 8: Equipment and Other Things",
      "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦70,000 / $50",
  certification: "Certificate of Completion"
},

{
  id: 22,
  title: "Guidelines for Design Solutions for Process Equipment Failures (Part 1)",
  date: "Present",
  description:
  [
      "Designing solutions for process equipment failures is a critical task in ensuring the safety, reliability, and efficiency of industrial operations. Failures in equipment can lead to accidents, unplanned downtime, and increased operational costs. Proper design solutions should mitigate the risks associated with such failures and enhance the system's overall resilience.",
      "This course provides a detailed understanding of the design solutions required to prevent and mitigate process equipment failures. Participants will learn techniques for selecting design bases for process safety systems, along with design considerations for vessels, reactors, mass transfer equipment, and heat transfer equipment. The course also includes real-world case studies to illustrate common failure mechanisms and effective engineering solutions for ensuring safe and reliable operations in industrial settings."
  ],
  image: "https://i.ibb.co/LDPggcX4/guidelines-1-4ee6fe35622bedcbcffb.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic understanding of process equipment and safety systems",
      "Familiarity with failure mechanisms in industrial equipment",
      "Knowledge of thermodynamics, heat transfer, and mass transfer principles"
  ],
  methodology: "Theoretical",
  objectives: [
      "Identify common failure mechanisms such as material fatigue, corrosion, overpressure, and thermal stress",
      "Assess the impact of failures on process safety and operational efficiency",
      "Develop appropriate design criteria to prevent equipment failures",
      "Ensure compliance with industry safety standards and best practices",
      "Understand the structural and material requirements for pressure vessels",
      "Evaluate failure risks related to mechanical integrity, overpressure, and thermal expansion",
      "Assess design improvements to enhance reactor safety and reliability",
      "Identify potential failure points in reaction systems and develop mitigation strategies",
      "Analyze common failures in distillation columns, absorbers, and scrubbers",
      "Implement design modifications to improve efficiency and longevity of mass transfer equipment",
      "Identify failure causes in heat exchangers, boilers, and condensers",
      "Apply corrective design measures to enhance heat transfer efficiency and safety",
      "Review industry case studies to understand failure root causes and corrective actions",
      "Develop strategies for improving equipment reliability and reducing downtime"
  ],
  outline: [
      "Module 1: Introduction",
      "Module 2: Technique for Selecting the Design Bases for Process Safety Systems",
      "Module 3: Vessels",
      "Module 4: Reactors",
      "Module 5: Mass Transfer Equipment",
      "Module 6: Heat Transfer Equipment",
      "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦110,000 / $90",
  certification: "Certificate of Completion"
},

{
  id: 23,
  title: "Guidelines for Design Solutions for Process Equipment Failures (Part 2)",
  date: "Present",
  description:
  [
      "Designing solutions for process equipment failures is a critical task in ensuring the safety, reliability, and efficiency of industrial operations. Failures in equipment can lead to accidents, unplanned downtime, and increased operational costs. Proper design solutions should mitigate the risks associated with such failures and enhance the system's overall resilience.",
      "This course provides a structured approach to understanding design solutions for process equipment failures, focusing on preventing operational disruptions, ensuring process safety, and optimizing equipment reliability. Participants will explore failure mechanisms, root causes, and design improvements for various types of process equipment, including dryers, fluid transfer equipment, solid-fluid separators, solids handling equipment, fired equipment, and piping systems. Real-world case studies will be analyzed to demonstrate best practices for mitigating failures and improving equipment performance."
  ],
  image: "https://i.ibb.co/M5hdpKBn/guidelines-2-09e069a6240095322ed7.jpg",
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic understanding of process equipment and safety systems",
      "Familiarity with failure mechanisms in industrial equipment",
      "Knowledge of thermodynamics, heat transfer, and mass transfer principles"
  ],
  methodology: "Theoretical",
  objectives: [
      "Identify causes of failures such as fatigue, corrosion, thermal stress, and material degradation",
      "Assess the impact of failures on process safety and plant operations",
      "Apply engineering principles to enhance equipment reliability and performance",
      "Ensure compliance with industry safety standards and best practices",
      "Select appropriate materials and design modifications to extend equipment lifespan",
      "Identify common issues in industrial dryers, including overheating, material buildup, and mechanical wear",
      "Develop design solutions to improve drying efficiency and reliability",
      "Understand potential failures in pumps, compressors, and pipelines",
      "Apply corrective design measures to reduce downtime and enhance operational efficiency",
      "Identify failure points in filters, centrifuges, and separators",
      "Improve separation efficiency and prevent operational disruptions",
      "Address issues related to material flow, mechanical wear, and equipment clogging",
      "Optimize design for improved material handling and process efficiency",
      "Identify causes of burner malfunction, heat exchanger tube failures, and thermal stress",
      "Implement design improvements for safe and efficient fired equipment operation",
      "Understand common piping failures such as corrosion, vibration, and pressure surges",
      "Apply best practices for material selection, support design, and stress analysis"
  ],
  outline: [
      "Module 1: Dryers",
      "Module 2: Fluid Transfer Equipment",
      "Module 3: Solid-Fluid Separators",
      "Module 4: Solids Handling and Processing Equipment",
      "Module 5: Fired Equipment",
      "Module 6: Piping and Piping Components",
      "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 24,
  title: "INSTRUMENTATION EQUIPMENT",
  date: "Present",
  description:
  [
      "Instrumentation equipment refers to tools, devices, and systems used to measure, control, and monitor various variables in industrial, laboratory, or commercial processes. These instruments are essential for ensuring that processes run smoothly, efficiently, and safely. Instrumentation equipment is critical in a wide range of applications, from manufacturing to research, to ensure that systems are functioning within their required parameters.",
      "This course provides a comprehensive introduction to industrial instrumentation equipment, covering essential measurement devices and control components used in process industries. Participants will learn about key instrumentation principles, the role of ISA symbols in process diagrams, and the operation of pressure, level, flow, and temperature instruments. The course also explores control valves and accessories, with practical case studies to enhance understanding."
  ],
  image: require("./coursesImg/Instrumentation Equipment.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "PAI",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic knowledge of physics and engineering principles",
      "Familiarity with industrial processes and control systems",
      "Understanding of measurement concepts"
  ],
  methodology: "Theoretical",
  objectives: [
      "Explain the role of instrumentation in process control and automation",
      "Identify different types of instrumentation equipment and their applications",
      "Understand the significance of ISA symbols in piping and instrumentation diagrams (P&IDs)",
      "Use symbols to interpret instrumentation schematics",
      "Pressure instrumentation: working principles, types, and applications",
      "Level instrumentation: measurement techniques and selection criteria",
      "Flow instrumentation: types of flowmeters and selection guidelines",
      "Temperature instrumentation: thermocouples, RTDs, and other devices",
      "Describe different types of control valves and their applications",
      "Explain the function of valve actuators, positioners, and accessories in process control",
      "Analyze practical instrumentation challenges and solutions",
      "Evaluate instrumentation failures and improvement strategies"
  ],
  outline: [
      "Module 1: Introduction to Instrumentation Equipment",
      "Module 2: ISA Symbols",
      "Module 3: Pressure Instrumentation",
      "Module 4: Level Instrumentation",
      "Module 5: Flow Instrumentation",
      "Module 6: Temperature Instrumentation",
      "Module 7: Control Valves and Accessories",
      "Module 8: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦120,000 / $100",
  certification: "Certificate of Completion"
},

{
  id: 25,
  title: "LIQUID PIPELINE HYDRAULICS",
  date: "Present",
  description:
  [
      "Liquid Pipeline Hydraulics refers to the study of the flow and pressure dynamics of liquids within pipelines. It involves understanding how liquids behave under different conditions, and applying principles from fluid mechanics to design, operate, and maintain pipelines effectively. Liquid pipeline hydraulics is crucial in industries such as oil and gas, water supply, chemical transport, and any system that relies on the transportation of liquids through pipes.",
      "Liquid Pipeline Hydraulics is a fundamental course designed to provide an in-depth understanding of the principles governing the flow of liquids through pipelines. This course covers key hydraulic concepts, including liquid properties, pressure loss due to friction, pump station design, and thermal hydraulics. Participants will learn to analyze pipeline performance, optimize flow efficiency, and evaluate economic considerations for pipeline operations. Real-world case studies will illustrate the practical applications of hydraulic principles in liquid transportation systems."
  ],
  image: require("./coursesImg/Liquid Pipeline Hydraulics.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic knowledge of fluid mechanics and hydraulics",
      "Familiarity with pipeline systems and equipment",
      "Understanding of pressure and flow measurement principles"
  ],
  methodology: "Theoretical",
  objectives: [
      "Define key properties of liquids and their impact on pipeline performance",
      "Explain pressure drop due to friction and other hydraulic losses",
      "Perform pipe flow analysis and evaluate pressure and horsepower needs",
      "Assess multi-pump station operations for optimal performance",
      "Conduct pump analysis and understand selection criteria",
      "Design efficient pump stations for liquid transportation systems",
      "Understand the effects of temperature on pipeline flow",
      "Utilize appropriate flow measurement methods for pipeline monitoring",
      "Analyze transient flow conditions and their impact on pipeline integrity",
      "Evaluate cost considerations in pipeline design and operation",
      "Study successful applications of liquid pipeline hydraulics",
      "Apply best practices to improve pipeline efficiency and reliability"
  ],
  outline: [
      "Module 1: Introduction",
      "Module 2: Properties of Liquids",
      "Module 3: Pressure Drop due to Friction",
      "Module 4: Pipe Analysis",
      "Module 5: Pressure and Horsepower Required",
      "Module 6: Multi-Pump Station Pipelines",
      "Module 7: Pump Analysis",
      "Module 8: Pump Station Design",
      "Module 9: Thermal Hydraulics",
      "Module 10: Flow Measurement",
      "Module 11: Unsteady Flow in Pipeline",
      "Module 12: Pipeline Economics",
      "Module 13: Case Studies and Real-World Examples"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦200,000 / $170",
  certification: "Certificate of Completion"
},

{
  id: 26,
  title: "TEMPERATURE INSTRUMENT",
  date: "Present",
  description:
  [
      "A temperature instrument is a device used to measure the temperature of a substance or environment. There are several types of temperature instruments, each suited to different applications.",
      "This course provides a structured understanding of temperature instruments, their design considerations, and applications in industrial projects during the project definition phase. Participants will explore various types of temperature measurement instruments, thermowell design, wake frequency effects, thermistors, and bimetallic thermometers. The course also covers temperature measurement units and real-world case studies to reinforce learning and practical applications."
  ],
  image: require("./coursesImg/Temperature Measurement.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "PAI",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "1 Day",
  prerequisite: [
      "Basic understanding of temperature measurement principles",
      "Familiarity with industrial instrumentation and process control",
      "Knowledge of material selection and sensor applications"
  ],
  methodology: "Theoretical",
  objectives: [
      "Learn about thermocouples, resistance temperature detectors (RTDs), thermistors, and bimetallic thermometers",
      "Identify suitable temperature instruments for specific applications",
      "Understand temperature scales such as Celsius, Fahrenheit, Kelvin, and Rankine",
      "Convert between different temperature units for industrial applications",
      "Explore the role of thermowells in protecting temperature sensors",
      "Analyze factors affecting thermowell material selection and mechanical strength",
      "Learn about fluid-induced vibration and its impact on thermowell integrity",
      "Apply best practices to avoid thermowell failures due to resonance",
      "Understand the temperature-dependent resistance characteristics of thermistors",
      "Explore applications in precision temperature measurement and control systems",
      "Learn how bimetallic strips respond to temperature variations",
      "Evaluate advantages and limitations of bimetallic thermometers in different environments",
      "Review industry applications of temperature instruments and thermowell failures",
      "Identify common challenges and solutions in temperature measurement projects"
  ],
  outline: [
      "Module 1: Types of Temperature Instrument",
      "Module 2: Various Units of Temperature Measurement",
      "Module 3: Thermowell Design & Material",
      "Module 4: Wake Frequency",
      "Module 5: Thermistors",
      "Module 6: Bimetallic Thermometers",
      "Module 7: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},


// {
//   id: 27,
//   title: "Centrifugal Compressor for Petroleum, Chemical and Gas Service Industries",
//   date: "Present",
//   description:
//   [
//       "Centrifugal compressor is a type of dynamic compressor commonly used in petroleum, chemical, and gas service industries due to its high efficiency, reliability, and ability to handle large volumes of gases. These industries rely on centrifugal compressors to boost the pressure of gases for various applications, including refining, natural gas transportation, and chemical processing.",
//       "Centrifugal Compressor for Petroleum, Chemical, and Gas Service Industries course typically focuses on the principles, design, operation, and maintenance of centrifugal compressors used in various industrial applications. These compressors are widely used in the petroleum, chemical, and gas industries for tasks such as gas compression, air handling, and refrigeration. Below is an outline of the key topics often covered in such a course:"
//   ],
//   image: require("./coursesImg/Centrifugal Compressor for Petroleum, Chemical and Gas Service Industries.jpg"),
//   tags: [
//       'Trainer: Engr. Majid',
//   ],
//   category: "process",
//   github: "https://github.com/Joseffl/react-todo-app",
//   webapp: "https://bit.ly/47GF1It",
//   duration: "2 Days",
//   prerequisite: [
//       "The prerequisites typically focus on foundational knowledge in mechanical and chemical engineering principles, as well as an understanding of fluid mechanics, thermodynamics, and industrial systems."
//   ],
//   methodology: "Theoretical",
//   objectives: [
//       "In-depth understanding of centrifugal compressor technology and its applications.",
//       "Knowledge of design, operation, and troubleshooting techniques for maintaining high-performance compressors.",
//       "Ability to identify and resolve common issues related to compressor systems.",
//       "Familiarity with safety, maintenance, and regulatory considerations specific to the petroleum, chemical, and gas industries"
//   ],
//   outline: [
//       "Module 1: Introduction to Centrifugal Compressors",
//       "Module 2: Applications in Petroleum, Chemical, and Gas Industries.",
//       "Module 3: Basic Design",
//       "Module 4: Accessories",
//       "Module 5: inspection. Testing. And preparation for shipment",
//       "Module 6: Vendors data",
//       "Module 7: Case Studies"
//   ],
//   assessment: "Online Written Exam",
//   cdf: [
//       "Classroom-based training",
//       "Online courses",
//       "In-house workshops",
//       "On-the-job training"
//   ],
//   cost: "₦100,000 / $80",
//   certification: "Certificate of Completion"
// },

{
  id: 28,
  title: "Centrifugal Compressor Surge",
  date: "Present",
  description:
  [
      "Compressor surge is a dynamic instability phenomenon that occurs in centrifugal compressors when the flow through the compressor drops below a critical limit. This condition causes flow reversal, pressure oscillations, and severe mechanical vibrations, potentially leading to equipment damage and process interruptions. It is one of the most serious operational issues in centrifugal compressors and must be properly understood and prevented.",
      "This course provides a systematic approach to identifying, assessing, and planning for natural hazards that can impact critical infrastructure, equipment, and operations. It covers hazard recognition, data gathering, risk evaluation, and the development of mitigation, recovery, and recommissioning plans. Through case studies, participants will explore real-world applications of best practices in natural hazard preparedness and response."
  ],
  image: require("./coursesImg/Centrifugal Compressor Surge.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "Basic understanding of thermodynamics and fluid dynamics",
      "Familiarity with compressor operation and process equipment",
      "Prior exposure to process control or rotating machinery"
  ],
  methodology: "Theoretical",
  objectives: [
      "By the end of the course, participants will be able to:",
      "Explain the concept of surge and its implications on centrifugal compressor operations",
      "Develop and apply theoretical models to predict surge in compression systems",
      "Evaluate the dynamic interaction between compressors and connected piping",
      "Analyze system stability and recognize early indicators of surge",
      "Design effective surge control systems tailored to specific applications",
      "Implement real-time monitoring techniques to enhance surge detection",
      "Understand recommissioning steps for compressors after a shutdown or incident",
      "Apply lessons from case studies to prevent surge and improve equipment reliability"
  ],
  outline: [
      "Module 1: Introduction",
      "Module 2: Theoretical modeling of centrifugal compression systems",
      "Module 3: Centrifugal Compression System Model",
      "Module 4: Dynamic Compressor Model Including Piping Acoustics",
      "Module 5: Analysis of Compressor Dynamics",
      "Module 6: Stability Parameter Identification",
      "Module 7: Surge Control Design and Evaluation",
      "Module 8: Recommissioning",
      "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

// {
//   id: 32,
//   title: "Process Engineering Design Basis",
//   date: "Present",
//   description:
//   [
//       "A Change Management Procedure course tailored for the oil and gas industry focuses on the unique challenges and complexities associated with change in this sector.",
//       "This course equips participants with the knowledge and skills to effectively manage change in the oil and gas industry, ensuring that transitions are smooth, safe, and aligned with organizational goals. By focusing on industry-specific challenges and solutions, attendees will be better prepared to lead their teams through successful change initiatives."
//   ],
//   image: require("./coursesImg/Process Engineering Design Basis.jpg"),
//   tags: [
//       'Trainer: Engr. Majid',
//   ],
//   category: "process",
//   github: "https://github.com/Joseffl/react-todo-app",
//   webapp: "https://bit.ly/47GF1It",
//   duration: "3 Days",
//   prerequisite: [
//       "Background of EPC (Engineering, Procurement, and Construction) projects"
//   ],
//   methodology: "Theoretical",
//   objectives: [
//       "Define the concept of change and change management.",
//       "Understand key roles in the change management process.",
//       "Determine the phases of change management.",
//       "Learn to formulate an effective plan for the change process.",
//       "Deeply understand the reasons for resistance to change.",
//       "Find out about effective methods of preventing and eliminating resistance to change.",
//       "Gain the ability to design fruitful communication related to the change process.",
//       "Learn techniques for effective implementation of change.",
//       "Develop skills associated with controlling the change process.",
//       "Build proficiency in shaping a change-oriented organizational culture."
//   ],
//   outline: [
//       "Module 1: Introduction",
//       "Module 2: Scope.",
//       "Module 3: Procedure",
//       "Module 4: Authorization",
//       "Module 5: Cost of Trend Preparation",
//       "Module 6: Cost Effects",
//       "Module 7: Schedule Effects",
//       "Module 8: Trend meetings",
//       "Module 9: Contract Amendments",
//       "Module 10: Final Settlement",
//       "Module 11: Document Update",
//       "Module 12: Roles and Responsibilities",
//       "Module 13: Tools and Techniques",
//       "Module 14: Communication Plan",
//       "Module 15: Monitoring and Continuous Improvement",
//       "Module 16: Case Studies"
//   ],
//   assessment: "Online Written Exam",
//   cdf: [
//       "Classroom-based training",
//       "Online courses",
//       "In-house workshops",
//       "On-the-job training"
//   ],
//   cost: "₦100,000 / $80",
//   certification: "Certificate of Completion"
// },

{
  id: 33,
  title: "Process Piping Fundamentals, Codes and Standards",
  date: "Present",
  description:
  [
      "Process piping refers to the system of pipes, valves, fittings, and related components used to transport fluids (gases, liquids, slurries, and vapors) in industrial facilities such as refineries, chemical plants, power stations, and manufacturing plants. It is distinct from utility piping or plumbing, as it is directly involved in core process operations.",
      "Understanding the fundamentals of process piping and the associated codes and standards is essential for designing, constructing, and maintaining safe, efficient, and compliant piping systems.",
      "This course introduces the foundational principles of process piping systems, with a focus on design codes, standards, terminology, and compliance. It explains how various codes govern design, fabrication, inspection, and maintenance of piping systems in industries such as oil & gas, power, and chemical processing. The course also covers the roles of international standards organizations and helps participants distinguish between codes and standards. Real-world case studies reinforce application and best practices."
  ],
  image: require("./coursesImg/Process Piping Fundamentals, Codes and Standards.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "Basic knowledge of mechanical or process engineering",
      "Familiarity with industrial piping or plant systems",
      "Suitable for piping designers, mechanical engineers, QA/QC inspectors, and project engineers"
  ],
  methodology: "Theoretical",
  objectives: [
      "By the end of the course, participants will be able to:",
      "Understand the purpose and structure of industrial piping systems",
      "Define and apply essential terminology and symbols in piping design",
      "Identify key codes and standards relevant to process piping",
      "Distinguish between design codes, material standards, and recommended practices",
      "Navigate the structure and content of piping codes such as ASME B31.3",
      "Recognize the role of major organizations in setting global piping standards",
      "Apply code-compliant design principles to real-world projects",
      "Interpret material specifications and ensure proper documentation",
      "Align piping system development with industry best practices",
      "Analyze case studies to avoid common compliance and safety issues"
  ],
  outline: [
      "Module 1: The Basics of Piping System",
      "Module 2: Definitions, Terminology and Essential Vocabulary",
      "Module 3: Design Codes and Standards",
      "Module 4: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦80,000 / $60",
  certification: "Certificate of Completion"
},

{
  id: 34,
  title: "Process Control Fundamentals",
  date: "Present",
  description:
  [
      "Process control is the science of keeping industrial processes running within desired conditions. It’s essential for safety, efficiency, quality, and productivity in any process industry like oil and gas, food processing, power plants, or chemical manufacturing.",
      "This course provides a solid foundation in process control principles, focusing on the essential components and functions that keep industrial processes stable, safe, and efficient. Learners will gain an understanding of how sensors, transmitters, controllers, and final control elements interact within feedback control loops. The course explores different control modes and system responses, equipping participants with the ability to interpret control loop behavior and apply best practices in monitoring and troubleshooting. It is designed for engineers, technicians, and technical personnel working in process industries."
  ],
  image: require("./coursesImg/Process Control Fundamentals.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "PAI",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "2 Days",
  prerequisite: [
      "A basic understanding of industrial processes or plant operations",
      "Familiarity with general instrumentation concepts is helpful but not mandatory",
      "An Engineering, technical, or operator-level background in manufacturing or process industries"
  ],
  methodology: "Theoretical",
  objectives: [
      "By the end of the course, participants will be able to:",
      "Identify major boiler components and how they function together.",
      "Understand the fundamental purpose and components of process control systems",
      "Differentiate between open-loop and closed-loop control strategies",
      "Identify key components in a feedback control loop and explain their roles",
      "Select appropriate sensors and transmitters for different process applications",
      "Understand signal transmission methods and how they affect control accuracy",
      "Explain the function and tuning of controllers, particularly PID controllers",
      "Describe the role and types of final control elements in a process loop",
      "Analyze different control loop modes and their use in specific process conditions",
      "Apply theoretical knowledge to real-life problems using case studies",
      "Recognize the impact of control strategy on process safety, quality, and efficiency"
  ],
  outline: [
      "Module 1: Introduction",
      "Module 2: Control Concepts",
      "Module 3: Feedback Control Loops",
      "Module 4: Sensors",
      "Module 5: Signal Transmitters",
      "Module 6: Controllers",
      "Module 7: Final Control Elements",
      "Module 8: Control Loops Mode",
      "Module 9: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 35,
  title: "Process Engineering Design Basis",
  date: "Present",
  description:
  [
      "The Design Basis is a critical document (or set of guidelines) that defines the foundation for developing any engineering process design.",
      "It answers the essential question: What are we designing, and under what conditions? Before any detailed design, simulations, or equipment selection happens, the design basis ensures that everyone — engineers, operators, clients, and contractors are aligned.",
      "This course provides in-depth knowledge of the core philosophies, assumptions, and technical foundations that govern process engineering design. It focuses on developing a well-structured Design Basis Document (DBD), a critical component of any engineering project. Through real-world scenarios and design philosophies, learners will explore the standards and rationale behind decisions such as P&ID development, equipment sizing, pressure relief, sparing, utility design, and safety provisions. This course is essential for engineers involved in FEED (Front-End Engineering Design), detailed design, or process engineering documentation."
  ],
  image: require("./coursesImg/Process Engineering Design Basis.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "A foundational understanding of process engineering or plant operations",
      "Familiarity with P&ID and general process design documents",
      "Experience in EPC, FEED, or plant engineering projects"
  ],
  methodology: "Theoretical",
  objectives: [
      "By the end of the course, participants will be able to:",
      "Identify major boiler components and how they function together.",
      "Understand the structure and content of a Process Design Basis document",
      "Apply sound engineering philosophies in P&ID development",
      "Define equipment and utility requirements based on process needs",
      "Implement appropriate sparing, duty margins, and isolation strategies",
      "Establish safe and effective pressure relief and insulation philosophies",
      "Specify instrumentation connections in line with industry practices",
      "Incorporate regulatory and safety compliance such as IBR and corrosion allowances",
      "Recognize the rationale behind noise control, aromatic handling, and utility condition definition",
      "Develop a coherent design basis that supports project execution from FEED to commissioning",
      "Analyze real-world case studies to reinforce theoretical understanding and practical application"
  ],
  outline: [
      "Module 1: P&ID Engineering and Philosophy",
      "Module 2: Utility Battery Limit and Utility Header & Block Valves",
      "Module 3: Connection for Instruments",
      "Module 4: Equipment Sparing Philosophy",
      "Module 5: Equipment Duty Margin",
      "Module 6: Pressure Relief Philosophy",
      "Module 7: Insulation and Tracing Philosophy",
      "Module 8: Process Block Valves Philosophy",
      "Module 9: Utility Station Location Philosophy",
      "Module 10: Isolation Blinds / Spading Philosophy",
      "Module 11: Tank Fittings and Accessories Philosophy",
      "Module 12: Equipment Design Philosophy",
      "Module 13: Minimum Liquid Surge Requirement",
      "Module 14: Utility Conditions",
      "Module 15: Noise Control",
      "Module 16: Aromatics Handling",
      "Module 17: Corrosion Allowance",
      "Module 18: IBR requirements",
      "Module 19: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 36,
  title: "Piping Inspection Code: In-service Inspection, Rating, Repair, and Alteration of Piping Systems",
  date: "Present",
  description:
  [
      "ASME Section VIII Division 1 of the Boiler and Pressure Vessel Code (BPVC) governs the design, fabrication, testing, inspection, and certification of pressure vessels. Inspection is a crucial part of this process because pressure vessels operate under high pressure and hold potentially hazardous substances — so failures can be catastrophic.",
      "This course provides comprehensive training on the principles and practices outlined in the Piping Inspection Code, typically referencing API 570. It focuses on in-service inspection, evaluation, repair, alteration, and rerating of process piping systems. Participants will gain practical insights into organizing inspection programs, conducting examinations, and ensuring regulatory and safety compliance. The course also covers buried piping inspection and includes case studies to connect theory with field practices."
  ],
  image: require("./coursesImg/Piping Inspection Code_ In-service Inspection, Rating, Repair, and Alteration of Piping Systems.jpg"),
  tags: [
      'Trainer: Engr. Majid',
  ],
  category: "mechanical",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
      "Basic understanding of piping systems and industrial processes",
      "Familiarity with materials, corrosion mechanisms, and inspection techniques",
      "Awareness of relevant industry codes and standards (e.g., ASME B31.3, API 570)"
  ],
  methodology: "Theoretical",
  objectives: [
      "By the end of the course, participants will be able to:",
      "Identify major boiler components and how they function together.",
      "Recognize what systems, materials, and services fall under the code’s jurisdiction",
      "Apply inspection requirements to various process environments",
      "Understand how API, ASME, and other standards complement one another",
      "Use cross-referenced documents to enhance code compliance",
      "Ensure clear communication and documentation",
      "Apply proper terminology in inspection reports and procedures",
      "Establish roles, responsibilities, and qualifications for inspection personnel",
      "Apply inspection, examination, and pressure testing practices",
      "Implement visual, ultrasonic, radiographic, and pressure testing procedures",
      "Determine inspection intervals and extent of examination",
      "Calculate recommended inspection frequencies based on service history and risk",
      "Evaluate inspection data and record findings appropriately",
      "Analyze wall thickness, corrosion rates, and fitness-for-service data",
      "Maintain inspection records in compliance with documentation standards",
      "Understand requirements for code-compliant modifications",
      "Apply rules for weld repairs, temporary repairs, and pressure rerating",
      "Apply suitable techniques such as excavation, external corrosion assessment, and NDT",
      "Identify signs of degradation in underground lines",
      "Review real-world piping integrity challenges and resolutions",
      "Improve decision-making through lessons learned from field experience"
  ],
  outline: [
      "Module 1: Scope",
      "Module 2: Normative References",
      "Module 3: Terms, Definitions, Acronyms, and Abbreviations",
      "Module 4: Owner-Operator Inspection Organization",
      "Module 5: Inspection, Examination, and Pressure Testing Practices",
      "Module 6: Interval/Frequency and Extent of Inspection",
      "Module 7: Inspection Data Evaluation, Analysis, and Recording",
      "Module 8: Repairs, Alterations, and Rerating of Piping Systems",
      "Module 9: Inspection of Buried Piping",
      "Module 10: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
  ],
  cost: "₦100,000 / $80",
  certification: "Certificate of Completion"
},

{
  id: 37,
  title: "Hydrogen System Code, Standards and Guidelines",
  date: "Present",
  description: [
    "Hydrogen systems involve the production, storage, distribution, and use of hydrogen in various forms (gaseous or liquid), often under high pressure and/or cryogenic conditions. Due to its flammability, diffusivity, and potential for explosive mixtures, hydrogen requires strict adherence to established codes, standards, and safety practices. These frameworks ensure safe system design, material compatibility, and proper operation in industrial, commercial, and energy applications.",
    "This course provides a comprehensive guide to international codes, standards, and best practices for hydrogen systems. With increasing global interest in hydrogen as a clean energy carrier, understanding the regulatory and safety framework is crucial. Participants will explore ISO and EIGA documents covering hydrogen production, storage, distribution, and mechanical integrity requirements for various systems and installations."
  ],
  image: require("./coursesImg/Hydrogen System Code, Standards and Guidelines.jpg"),
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of chemical and process engineering principles",
    "Familiarity with hydrogen technologies and fuel systems",
    "General knowledge of piping systems and pressure equipment"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify and apply international standards relevant to hydrogen systems",
    "Understand design, safety, and testing requirements for hydrogen generators",
    "Evaluate piping systems for hydrogen transport in accordance with ISO 15649",
    "Interpret electrolysis system guidelines for various scale applications",
    "Assess installation and safety needs for gaseous hydrogen systems",
    "Ensure mechanical integrity of hydrogen PSA units using EIGA DOC 210",
    "Compare hydrogen production technologies and associated regulatory frameworks",
    "Apply lessons from case studies to ensure compliance and optimize safety in hydrogen projects",
    "Review successful and problematic ventilation installations"
  ],
  outline: [
    "Module 1: Hydrogen generators using fuel processing technologies (ISO 16110)",
    "Module 2: Petroleum and natural gas industries — Piping (ISO 15649)",
    "Module 3: Hydrogen generators using water electrolysis — Industrial, commercial, and residential applications (ISO 22734)",
    "Module 4: Gaseous Hydrogen Installations (EIGA DOC 15)",
    "Module 5: Hydrogen Pressure Swing Adsorber (PSA) Mechanical Integrity Requirements (EIGA DOC 210)",
    "Module 6: Overview of Hydrogen Production Methods (EIGA DOC 251)",
    "Module 7: Hydrogen Vent Systems for Customer Applications (EIGA DOC 211)",
    "Module 8: Safe Start Up and Shutdown Practices for Steam Reformers (EIGA DOC 185)",
    "Module 9: Guideline for Small Scale Hydrogen Production (EIGA DOC 246)",
    "Module 10: Best Available Techniques for Hydrogen Production by Steam Methane Reforming (EIGA DOC 155)",
    "Module 11: Combustion Safety for Steam Reformer Operation (CGA H-10)"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 38,
  title: "Hydrogen System Code, Standards and Guidelines (COURSE 2)",
  date: "Present",
  description: [
    "Hydrogen systems involve the production, storage, distribution, and use of hydrogen in various forms (gaseous or liquid), often under high pressure and/or cryogenic conditions. Due to its flammability, diffusivity, and potential for explosive mixtures, hydrogen requires strict adherence to established codes, standards, and safety practices. These frameworks ensure safe system design, material compatibility, and proper operation in industrial, commercial, and energy applications.",
    "This course presents a detailed guide to the codes, standards, and best practices surrounding hydrogen infrastructure across its value chain—storage, distribution, and utilization. Participants will explore key EIGA documents and ISO standards governing welded storage vessels, underground hydrogen storage, pipeline systems, land vehicle fuel containers, cylinder design, and compatibility. The course is critical for engineers, safety professionals, and project developers working in hydrogen-based energy systems."
  ],
  image: require("./coursesImg/Hydrogen System Code, Standards and Guidelines.jpg"),
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of hydrogen properties and industrial gas systems",
    "Familiarity with pressure vessels, pipeline systems, and fluid mechanics",
    "Prior knowledge of safety and quality standards in process industries"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand and apply EIGA and ISO standards to hydrogen storage and distribution systems",
    "Evaluate design requirements for hydrogen-compatible pressure vessels and pipelines",
    "Identify key safety considerations in hydrogen compression and filling systems",
    "Assess material compatibility with hydrogen for safe long-term usage",
    "Design compliant hydrogen transport and fueling systems for land vehicles",
    "Conduct safety audits and apply integrity management practices to hydrogen infrastructure",
    "Understand underground hydrogen storage requirements and associated risks",
    "Interpret and apply lessons from real-world hydrogen project case studies"
  ],
  outline: [
    "Module 1: Hydrogen Overview - Distribution-Storage-Applications (EIGA DOC 247)",
    "Module 2: Welded Gaseous Storage Vessels and Hydrogen Compatibility (EIGA TB 42)",
    "Module 3: Industrial Gas Pipeline Integrity Management (EIGA DOC 235)",
    "Module 4: Safety Audit / Assessment Tool – Hydrogen Compression, Purification and Cylinder Filling (EIGA DOC 10207)",
    "Module 5: Storage of Hydrogen in Systems Located Underground (EIGA DOC 171)",
    "Module 6: Hydrogen Pipeline Systems (EIGA Doc 121)",
    "Module 7: Hydrogen Cylinders and Transport Vessels (EIGA DOC 100)",
    "Module 8: Gas cylinders — Design, construction and testing of refillable seamless steel gas cylinders and tubes (ISO 9809)",
    "Module 9: Gaseous hydrogen — Land vehicle fuel containers (ISO 19881)",
    "Module 10: Liquid hydrogen — Land vehicle fuel tanks (ISO 13985)",
    "Module 11: Gas cylinders — Compatibility of cylinder and valve materials with gas contents (ISO 11114)",
    "Module 12: Case Studies"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 39,
  title: "Hydrogen System Code, Standards and Guidelines (COURSE 3)",
  date: "Present",
  description: [
    "Hydrogen systems involve the production, storage, distribution, and use of hydrogen in various forms (gaseous or liquid), often under high pressure and/or cryogenic conditions. Due to its flammability, diffusivity, and potential for explosive mixtures, hydrogen requires strict adherence to established codes, standards, and safety practices. These frameworks ensure safe system design, material compatibility, and proper operation in industrial, commercial, and energy applications.",
    "This course provides comprehensive training on the key international standards, codes, and practices guiding the safe design, fabrication, installation, and operation of hydrogen systems. Covering ISO, ASME, and CGA standards, it equips professionals with the necessary knowledge to manage high-pressure hydrogen systems, pressure vessels, piping, and storage technologies including metal hydrides and cryogenics. It is ideal for engineers, project designers, and safety managers working in hydrogen infrastructure and energy systems."
  ],
  image: require("./coursesImg/Hydrogen System Code, Standards and Guidelines.jpg"),
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
    "Fundamental understanding of mechanical or chemical engineering principles",
    "Basic knowledge of hydrogen technologies or industrial gas systems",
    "Prior exposure to pressure vessel and piping codes is beneficial"
  ],
  methodology: "Theoretical",
  objectives: [
    "Apply relevant ISO, ASME, and CGA codes in hydrogen infrastructure projects",
    "Design safe and compliant hydrogen piping and vessel systems",
    "Differentiate between metallic, composite, and cryogenic storage system requirements",
    "Evaluate mechanical integrity procedures for PSA and reformer operations",
    "Select appropriate materials and stress allowances for hydrogen system components",
    "Interpret and apply startup/shutdown safety practices from CGA H-13",
    "Conduct safety checks, audits, and design evaluations against established standards",
    "Leverage real-world case studies to identify risks and best practices in hydrogen deployment"
  ],
  outline: [
    "Module 1: Gas cylinders — Refillable seamless aluminium alloy gas cylinders — Design, construction and testing (ISO 7866)",
    "Module 2: Transportable gas storage devices — Hydrogen absorbed in reversible metal hydride (ISO 16111)",
    "Module 3: Gas cylinders — Design, construction and testing of refillable composite gas cylinders and tubes (ISO 11119)",
    "Module 4: ASME Section VIII Division 3, Article KD-10 (ASME)",
    "Module 5: Hydrogen Piping and Pipeline (ASME B31.12)",
    "Module 6: Process Piping (ASME B31.3)",
    "Module 7: Rules for Construction of Pressure Vessels (ASME Section VIII)",
    "Module 8: Safe Startup and Shutdown Practices for Steam Reformers Hydrogen Pressure Swing Adsorber (PSA) Mechanical Integrity Requirements (CGA H-13)",
    "Module 9: Design Factor Guidelines for High-Pressure Composite Hydrogen Tanks (ASME STP-PT-005-2006)",
    "Module 10: Hydrogen System Requirements (CGA G-5 series)",
    "Module 11: Cryogenic Hydrogen Storage (CGA H-3)"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 40,
  title: "Hydrogen System Code, Standards and Guidelines (COURSE 4)",
  date: "Present",
  description: [
    "Hydrogen systems involve the production, storage, distribution, and use of hydrogen in various forms (gaseous or liquid), often under high pressure and/or cryogenic conditions. Due to its flammability, diffusivity, and potential for explosive mixtures, hydrogen requires strict adherence to established codes, standards, and safety practices. These frameworks ensure safe system design, material compatibility, and proper operation in industrial, commercial, and energy applications.",
    "This course delivers a focused exploration of the codes, standards, and practices relevant to hydrogen system safety and compliance. It provides insights into the safe design, installation, operation, and inspection of hydrogen storage systems, bulk supply networks, compressors, and associated components. Covering CGA and API guidelines, the course is essential for engineers, project managers, and safety officers working in hydrogen production, storage, and distribution."
  ],
  image: require("./coursesImg/Hydrogen System Code, Standards and Guidelines.jpg"),
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
    "Foundational knowledge of industrial hydrogen systems or gas engineering",
    "Familiarity with gas compression, piping, or storage systems",
    "Basic understanding of safety and regulatory frameworks for hazardous gases"
  ],
  methodology: "Theoretical",
  objectives: [
    "Apply CGA and API standards to design safe hydrogen systems",
    "Implement standard procedures for hydrogen storage and delivery",
    "Identify proper installation techniques for both above-ground and buried systems",
    "Assess compressor selection and sealing technologies for hydrogen applications",
    "Understand the classification and labeling of metal hydride systems",
    "Inspect and evaluate gas cylinders for integrity and compliance",
    "Ensure compatibility and separation when storing hydrogen with other gases",
    "Evaluate lessons learned from past hydrogen system failures and best practices"
  ],
  outline: [
    "Module 1: Safe Design, Installation, and Use of Bulk Hydrogen Supply Systems (CGA H-5)",
    "Module 2: Position Statement On The Direct Burial Of Gaseous Hydrogen Storage Tanks (CGA PS-20)",
    "Module 3: Standard Procedures for Hydrogen Supply Systems (CGA H-7)",
    "Module 4: Position Statement on Adjacent Storage of Compressed Hydrogen and Other Flammable Gases (CGA PS-21)",
    "Module 5: Design, Qualification and Testing for Pressure Vessels for Portable, Reversible Metal Hydride Systems (CGA C-21)",
    "Module 6: Service Conditions for Portable, Reversible Metal Hydride Systems (CGA H-1)",
    "Module 7: Guidelines for the Classification and Labeling of Hydrogen Storage Systems with Hydrogen Absorbed in Reversible Metal Hydrides (CGA H-2)",
    "Module 8: Publication Series Guides the Inspection of Compressed Gas Cylinders for Safe Filling, Transport, and End Use (CGA’s C-6)",
    "Module 9: Dry Gas Sealing Systems for Axial, Centrifugal, and Rotary Screw Compressors and Expanders (API STD 692)",
    "Module 10: Reciprocating Compressors for Petroleum, Chemical, and Gas Industry Services (API STD 618)",
    "Module 11: Axial and Centrifugal Compressors and Expander-compressors (API Standard 617)"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},


{
  id: 41,
  title: "Hydrogen System Code, Standards and Guidelines (COURSE 5)",
  date: "Present",
  description: [
    "Hydrogen systems involve the production, storage, distribution, and use of hydrogen in various forms (gaseous or liquid), often under high pressure and/or cryogenic conditions. Due to its flammability, diffusivity, and potential for explosive mixtures, hydrogen requires strict adherence to established codes, standards, and safety practices. These frameworks ensure safe system design, material compatibility, and proper operation in industrial, commercial, and energy applications.",
    "This course focuses on the international standards and best practices governing hydrogen fueling systems, hydrogen-powered vehicles, and associated infrastructure. It emphasizes critical technical regulations for hydrogen purity, pump design, storage interface, and fueling protocols. Ideal for professionals in hydrogen mobility, fuel cell technologies, and energy infrastructure."
  ],
  image: require("./coursesImg/Hydrogen System Code, Standards and Guidelines.jpg"),
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of hydrogen properties and applications",
    "Familiarity with fuel systems or alternative energy vehicles",
    "Engineering background in mechanical, chemical, or energy systems is recommended"
  ],
  methodology: "Theoretical",
  objectives: [
    "Interpret and apply key ISO, EIGA, IEC, and UN regulations for hydrogen vehicle systems",
    "Identify safety and design requirements for gaseous and liquid hydrogen fueling stations",
    "Ensure compliance with fuel purity standards for hydrogen applications",
    "Understand connection standards and prevent misfuelling at dispensers",
    "Evaluate component specifications for hydrogen vehicle integration",
    "Recognize the certification and type-approval process for hydrogen-powered vehicles",
    "Design and install compliant stationary hydrogen fuel cell systems",
    "Learn from industry case studies to enhance safe and efficient system implementation"
  ],
  outline: [
    "Module 1: Reciprocating Cryogenic Pumps and Pump Installations for Hydrogen and Liquified Natural Gas (EIGA DOC 244)",
    "Module 2: Road vehicles — Compressed gaseous hydrogen (CGH2) and hydrogen/natural gas blends fuel system components (ISO 12619)",
    "Module 3: Hydrogen fuel quality — Product specification (ISO 14687)",
    "Module 4: Fuel cell road vehicles — Energy consumption measurement — Vehicles fuelled with compressed hydrogen (ISO 23828)",
    "Module 5: Gaseous hydrogen — Fuelling stations (ISO 19880 series)",
    "Module 6: Liquid hydrogen — Land vehicle fuelling system interface (ISO 13984)",
    "Module 7: Gaseous hydrogen land vehicle refuelling connection devices (ISO 17268)",
    "Module 8: Secondary Identification of H2 Vehicle at Dispenser (EIGA TB 43)",
    "Module 9: Hydrogen-powered vehicles. type-approval of hydrogen-powered motor vehicles (REGULATION (EC) No 79)",
    "Module 10: Hydrogen and Fuel Cell Vehicles (UN Technical Regulation No. 13)",
    "Module 11: Fuel cell technologies - Part 3-300: Stationary fuel cell power systems - Installation (IEC 62282-3-300)"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 42,
  title: "Hydrogen System Code, Standards and Guidelines (COURSE 6)",
  date: "Present",
  description: [
    "Hydrogen systems involve the production, storage, distribution, and use of hydrogen in various forms (gaseous or liquid), often under high pressure and/or cryogenic conditions. Due to its flammability, diffusivity, and potential for explosive mixtures, hydrogen requires strict adherence to established codes, standards, and safety practices. These frameworks ensure safe system design, material compatibility, and proper operation in industrial, commercial, and energy applications.",
    "This course provides a comprehensive look into the global codes, standards, and best practices governing hydrogen systems for refueling infrastructure and vehicle integration. Covering both technical and safety aspects, it equips engineers, regulators, and designers with the knowledge needed to implement hydrogen fueling systems that meet rigorous international and national standards."
  ],
  image: require("./coursesImg/Hydrogen System Code, Standards and Guidelines.jpg"),
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "process",
  github: "https://github.com/Joseffl/react-todo-app",
  webapp: "https://bit.ly/47GF1It",
  duration: "3 Days",
  prerequisite: [
    "Understanding of basic hydrogen properties and applications",
    "Familiarity with fuel cells, energy systems, or gas distribution infrastructure",
    "Technical background in mechanical, chemical, or electrical engineering is beneficial"
  ],
  methodology: "Theoretical",
  objectives: [
    "Identify and apply international standards governing hydrogen fuel quality and delivery",
    "Evaluate safety protocols for hydrogen storage, dispensing, and transportation",
    "Understand design and performance requirements for hydrogen vehicle refueling connections",
    "Implement fueling protocols that ensure efficiency and safety",
    "Analyze and interpret quality assurance procedures for hydrogen used in PEM fuel cells",
    "Assess facility electrical and hazard zoning requirements per NFPA codes",
    "Determine compliance paths for vehicle certification and station installation",
    "Learn from case studies to understand real-world applications and pitfalls"
  ],
  outline: [
    "Module 1: Fuel cell technologies - Part 3-100: Stationary fuel cell power systems - Safety (IEC 62282-3-100)",
    "Module 2: Hydrogen fuel - Product specification and quality assurance for hydrogen refueling points dispensing gaseous hydrogen - PEM fuel cell applications (DIN EN 17124)",
    "Module 3: Gaseous Hydrogen Land Vehicle Refueling Connection Devices (DIN EN 17268)",
    "Module 4: Hydrogen Fuel Quality for Fuel Cell Vehicles (SAE J2719)",
    "Module 5: Fueling Protocols for Light Duty Gaseous Hydrogen Surface Vehicles (SAE J2601)",
    "Module 6: Standard for Fittings for Use in Compressed Gaseous Hydrogen Fueling Stations (CSA/ANSI HGV 4.10)",
    "Module 7: Safety in Storage, Handling and Distribution of Liquid Hydrogen (EIGA DOC 06)",
    "Module 8: National Electrical Code® (NFPA 70)",
    "Module 9: Hydrogen Technologies Code (NFPA 2)",
    "Module 10: Compressed Gases and Cryogenic Fluids Code (NFPA 55)",
    "Module 11: UN ECE R134: Safety-related performance of hydrogen-fueled vehicles"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  id: 43,
  title: "Hydrogen System Code, Standards and Guidelines (COURSE 7)",
  date: "Present",
  description: [
    "Hydrogen systems involve the production, storage, distribution, and use of hydrogen in various forms (gaseous or liquid), often under high pressure and/or cryogenic conditions. Due to its flammability, diffusivity, and potential for explosive mixtures, hydrogen requires strict adherence to established codes, standards, and safety practices. These frameworks ensure safe system design, material compatibility, and proper operation in industrial, commercial, and energy applications.",
    "This course explores critical international and regional codes, standards, and best practices for hydrogen safety across detection, separation, purification, and vehicular applications. Participants will gain deep insights into system classification, occupational safety requirements, hazard zone designations, and explosive atmosphere control measures applicable to hydrogen facilities and transport systems."
  ],
  image: require("./coursesImg/Hydrogen System Code, Standards and Guidelines.jpg"),
  tags: [
    "Trainer: Engr. Majid"
  ],
  category: "process",
  duration: "3 Days",
  prerequisite: [
    "Basic understanding of hydrogen properties and fuel cell systems",
    "Background in chemical or mechanical engineering is beneficial",
    "Familiarity with gas safety systems, industrial health standards, or explosive atmosphere classification is advantageous"
  ],
  methodology: "Theoretical",
  objectives: [
    "Understand hydrogen detection technologies and deployment standards",
    "Apply international safety regulations to hydrogen storage and separation systems",
    "Classify explosive atmospheres and identify appropriate zone protections",
    "Ensure hydrogen systems meet the occupational safety standards of OSHA and IEC",
    "Evaluate the structural and procedural safety measures in hydrogen-powered vehicles",
    "Implement purification systems compliant with ISO safety requirements",
    "Analyze and respond to real-world incidents through safety-focused case studies",
    "Navigate and integrate standards from ISO, OSHA, CGA, OISD, and IEC into hydrogen project designs"
  ],
  outline: [
    "Module 1: Hydrogen detection apparatus — Stationary applications (ISO 26142)",
    "Module 2: Safety of pressure swing adsorption systems for hydrogen separation and purification (ISO 19883)",
    "Module 3: Basic considerations for the safety of hydrogen systems (ISO/TR 15916)",
    "Module 4: Fuel cell road vehicles — Safety specifications (ISO 23273)",
    "Module 5: Hydrogen, Occupational Safety and Health Administration (OSHA 1910.103)",
    "Module 6: Explosive atmospheres - Classification of areas - Explosive gas atmospheres (IEC 60079-10-1)",
    "Module 7: Hydrogen Safety (OISD-STD-241)",
    "Module 8: Commodity Specification for Hydrogen (CGA G-5.3)"
  ],
  assessment: "Online Written Exam",
  cdf: [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  cost: "₦150,000 / $120",
  certification: "Certificate of Completion"
},

{
  "id": 44,
  "title": "API 660 vs TEMA for Shell and Tube Heat Exchanger",
  "date": "Present",
  "description": [
    "Shell-and-tube heat exchangers are essential components in industrial thermal systems. Their design and operation are governed by well-established standards to ensure safety, reliability, and performance. Two of the most widely used standards are API 660, tailored for the petroleum and chemical industries, and TEMA, which provides a broader framework for various industrial applications.",
    "This course offers a comparative study of API 660 and TEMA, helping engineers, designers, and maintenance professionals understand how each standard approaches design philosophy, mechanical integrity, and operational efficiency. Through technical analysis, case studies, and practical examples, participants will gain the knowledge needed to make informed decisions in selecting and managing heat exchangers."
  ],
  "image": 'https://i.ibb.co/4n3fGLVW/API-660-vs-TEMA-for-Shell-and-Tube-Heat-Exchanger.png',
  "tags": [],
  "category": "mechanical",
  "duration": "1 Day",
  "prerequisite": [
    "A basic understanding of heat exchanger principles and thermal systems.",
    "Familiarity with industrial codes and standards (e.g., ASME, API).",
    "Experience in equipment design, specification, procurement, or maintenance in industries such as oil & gas, petrochemical, or power generation.",
    "Ability to interpret engineering drawings and technical documentation."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope, structure, and application of API 660 and TEMA standards.",
    "Identify key differences in design, fabrication, inspection, and maintenance requirements.",
    "Evaluate the implications of selecting either standard for specific industrial applications.",
    "Apply best practices for specifying, maintaining, and troubleshooting shell-and-tube heat exchangers using both standards."
  ],
  "outline": [
    "Module 1: Overview of Heat Exchanger Standards",
    "Module 2: Design Philosophy and Requirements",
    "Module 3: Fabrication and Construction",
    "Module 4: Inspection, Testing, and Quality Control",
    "Module 5: Maintenance and Troubleshooting",
    "Module 6: Specification and Procurement",
    "Module 7: Comparative Analysis and Decision-Making"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦40,000 / $50",
  "certification": "Certificate of Completion"
},

{
  "id": 45,
  "title": "Flange And Pipes",
  "date": "Present",
  "description": [
    "Flanges and pipes are essential components in piping systems, enabling secure, leak-tight connections for fluid and gas transportation across various industries, including oil & gas, petrochemical, power generation, and water treatment.",
    "This course provides a detailed understanding of the role, design, classification, standards, and materials used for flanges and pipes. Participants will explore the functions and applications of different flange types, understand industry-standard dimensions and ratings, and review material selection criteria based on service conditions. Real-world case studies will illustrate common issues and best practices, ensuring participants gain both theoretical knowledge and practical insights for effective flange and pipe system design, installation, and maintenance."
  ],
  "image": "https://i.ibb.co/674Smhzf/Flange-And-Pipes.png",
  "tags": [],
  "category": "mechanical",
  "duration": "2 Days",
  "prerequisite": [
    "Basic knowledge of mechanical engineering or piping systems.",
    "Exposure to plant operations, fabrication, or maintenance is beneficial but not mandatory.",
    "Ability to read basic technical drawings (e.g., P&IDs, piping layout diagrams)."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain why flanges are used and their advantages in assembly, maintenance, and repair.",
    "Select appropriate materials based on operating temperature, pressure, and media.",
    "Recognize weld neck, slip-on, socket weld, lap joint, threaded, and blind flanges, and describe their specific applications.",
    "Apply ASME, ANSI, DIN, and other relevant standards to ensure correct flange sizing and pressure class selection.",
    "Choose suitable materials for pipes and flanges based on service requirements and corrosion resistance.",
    "Categorize flanges based on pressure class, facing type, and manufacturing method.",
    "Interpret and apply relevant codes and standards for flanges and piping in design and procurement.",
    "Evaluate flange and pipe failures, identify root causes, and propose preventive measures."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Functions of Flanges",
    "Module 3: Common Materials Used for Flange",
    "Module 4: Types of Flanges & Their Use",
    "Module 5: Standard Dimensions & Ratings",
    "Module 6: Materials of Construction (MOC)",
    "Module 7: Classifications",
    "Module 8: Standards",
    "Module 9: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦80,000 / $60",
  "certification": "Certificate of Completion"
},

{
  "id": 46,
  "title": "Heat Exchangers; Design, Operation, Maintenance & Enhancement",
  "date": "Present",
  "description": [
    "Heat exchangers are vital components in oil, gas, petrochemical, and power generation facilities, enabling efficient heat transfer between process fluids. Proper design, operation, and maintenance are essential to ensure their performance, safety, and longevity.",
    "This course provides a comprehensive understanding of heat exchangers — from classification and design standards to troubleshooting and performance enhancement. Participants will learn how to apply industry codes, perform thermal design calculations, prepare and interpret specification sheets, and manage the complete lifecycle of heat exchangers, including storage, installation, operation, and maintenance. Special focus is given to practical challenges such as tube side repair/replacement, fouling, vibration, and unresolved design issues.",
    "Combining theoretical knowledge with case-based examples, the course equips engineers, operators, and maintenance personnel with the skills to optimize heat exchanger performance and reliability in demanding industrial environments."
  ],
  "image": "https://i.ibb.co/C5wvMVp9/Heat-Exchangers-Design-Operation-Maintenance-Enhancement.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "Degree/diploma in mechanical, chemical, process, or petroleum engineering (or equivalent industrial experience).",
    "Basic understanding of thermodynamics, fluid mechanics, and process equipment operation.",
    "Ability to read P&IDs, equipment datasheets, and mechanical drawings."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe the role, function, and applications of heat exchangers in industrial facilities.",
    "Identify different configurations and their suitability for various process duties.",
    "Interpret relevant design codes (e.g., TEMA, ASME) and their application in manufacturing and inspection.",
    "Use fundamental heat transfer equations to size and evaluate heat exchangers.",
    "Document and review key design parameters for procurement and installation.",
    "Apply best practices to prevent damage and ensure long-term operational reliability.",
    "Decide between tube repair and replacement based on condition assessment.",
    "Diagnose common operational problems such as fouling, leakage, and vibration, and recommend corrective actions.",
    "Understand limitations in current heat exchanger technology and explore potential performance enhancement strategies.",
    "Apply design, operation, and maintenance principles to improve safety, efficiency, and lifecycle costs of heat exchangers."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Classification of heat exchangers",
    "Module 3: Code and standards",
    "Module 4: Basic Design Equations of Heat Exchangers",
    "Module 5: Thermal Design",
    "Module 6: Specification sheet",
    "Module 7: Storage, Installation, Operation and Maintenance",
    "Module 8: Heat exchanger tube side maintenance (Repair vs replacement)",
    "Module 9: Troubleshooting",
    "Module 10: Unresolved problems in the heat exchangers design"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦230,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 47,
  "title": "Industrial Rotating Equipment Classification, Operations & Applications",
  "date": "Present",
  "description": [
    "Rotating equipment forms the backbone of industrial operations in oil & gas, power generation, petrochemicals, and manufacturing sectors. From pumps, compressors, and turbines to gearboxes and couplings, these machines enable continuous production and safe plant operation.",
    "This course introduces participants to the fundamentals of industrial rotating equipment, their classifications, prime movers (with a focus on steam turbines), and associated connectors. Emphasis is placed on operational principles, selection criteria, and practical applications. Participants will gain insight into performance optimization, reliability improvement, and maintenance considerations essential for minimizing downtime and enhancing efficiency.",
    "Through structured modules, the program blends theory with case examples, preparing engineers and technicians to effectively specify, operate, and troubleshoot rotating equipment in diverse industrial environments."
  ],
  "image": "https://i.ibb.co/R4SGwx9P/Industrail-Rotating-Equipment-Classification-Operations-Applications-Course.png",
  "tags": [],
  "category": "mechanical",
  "duration": "2 Days",
  "prerequisite": [
    "Degree or diploma in mechanical, process, petroleum, or electrical engineering (or equivalent technical field).",
    "Basic understanding of thermodynamics, fluid mechanics, and mechanical systems."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the significance of rotating machinery in industrial operations and process continuity.",
    "Differentiate between pumps, compressors, turbines, and auxiliary rotating equipment.",
    "Understand design features, operating principles, and applications of steam turbines as prime movers.",
    "Assess performance characteristics, energy conversion efficiency, and reliability aspects.",
    "Describe the function of couplings, gearboxes, and shaft alignments in ensuring safe power transmission.",
    "Match equipment type to process requirements and operating conditions.",
    "Recognize key factors affecting longevity and common failure mechanisms of rotating machinery.",
    "Relate theoretical knowledge to real industrial applications through case studies and examples."
  ],
  "outline": [
    "Module 1: Overview of rotating equipment",
    "Module 2: Prime Movers – Steam Turbines",
    "Module 3: Rotating Equipment",
    "Module 4: Connectors"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦60,000 / $50",
  "certification": "Certificate of Completion"
},

{
  "id": 48,
  "title": "Pipe Rack & Pipe Rack Piping",
  "date": "Present",
  "description": [
    "Pipe racks are the backbone of industrial plants, providing structural support and safe routing for process, utility, and service pipelines. This course provides a comprehensive understanding of pipe rack design, layout, and piping considerations, covering both structural and piping engineering aspects. Participants will gain knowledge of industry standards, design criteria, spatial requirements, load distribution, and effective pipe routing strategies. Emphasis will also be placed on practical considerations such as thermal expansion, segregation of hot and cold lines, clearances, anchor bays, and provisions for future expansion.",
    "By the end of the course, participants will be equipped with the skills to design, evaluate, and optimize pipe racks and associated piping systems for safe, efficient, and cost-effective plant operation."
  ],
  "image": "https://i.ibb.co/pvkKpfsZ/Pipe-Rack-Pipe-Rack-Piping.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of piping design and layout.",
    "Familiarity with process plant drawings (PFDs, P&IDs, and plot plans).",
    "Understanding of mechanical, structural, or civil engineering principles.",
    "Awareness of piping codes and standards (ASME B31.3, API, or equivalent) is helpful but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define the purpose and function of pipe racks in process facilities.",
    "Interpret design criteria and industry standards for pipe rack development.",
    "Apply correct shapes, widths, and clearances in pipe rack design.",
    "Allocate space for current and future piping requirements.",
    "Identify loading considerations and structural constraints.",
    "Differentiate between routing of process and utility lines.",
    "Apply segregation principles for hot and cold lines.",
    "Determine optimal routing for larger-sized lines and spacing requirements.",
    "Design and position anchor bays to control thermal expansion.",
    "Incorporate expansion loops and flexibility analysis in piping systems.",
    "Plan pipe routes across unit battery limits.",
    "Ensure effective use of trays for multilayer pipe arrangements.",
    "Balance safety, accessibility, and maintainability in layout decisions.",
    "Integrate provisions for future tie-ins and expansions.",
    "Apply best practices for pipe rack maintenance and safety"
  ],
  "outline": [
    "Module 1: Pipe Rack design Criteria",
    "Module 2: Shapes",
    "Module 3: Future Space",
    "Module 4: Width of Pipe Rack",
    "Module 5: Clearance",
    "Module 6: Pipe Rack Loading",
    "Module 7: Positions of Lines (Process & Utilities)",
    "Module 8: Hot Lines & Cold Lines",
    "Module 9: Bigger Size Lines",
    "Module 10: Pipe Spacing",
    "Module 11: Anchor Bay",
    "Module 12: Unit Battery Limit",
    "Module 13: Expansion Loops",
    "Module 14: Pipe Route",
    "Module 15: Trays"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 49,
  "title": "PIPING & PIPE HANGER DESIGN & ENGINEERING",
  "date": "Present",
  "description": [
    "This course provides an in-depth understanding of the principles, practices, and standards associated with the design and engineering of piping systems and pipe hangers. The training is designed to equip engineers and professionals with the technical knowledge needed to design, calculate, and select the appropriate support systems for piping under various operational conditions — including thermal expansion, seismic activity, and nuclear applications.",
    "Participants will gain practical knowledge through theoretical modules, detailed calculation methods, specification guidance, and real-world application examples. The course also explores advanced considerations like seismic supports, nuclear piping requirements, and grooved piping systems."
  ],
  "image": "https://i.ibb.co/LXSVWMzR/Piping-and-pipe-hanger-design-and-engineering.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "A basic understanding of piping systems and components.",
    "Fundamental knowledge of mechanical or civil engineering principles.",
    "Familiarity with stress analysis, thermal expansion, and structural loads is advantageous.",
    "Experience with industrial piping projects is helpful but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the design principles and standards for pipe hangers and supports.",
    "Determine optimal hanger locations for various piping layouts.",
    "Perform load calculations for hangers under static and dynamic conditions.",
    "Evaluate and calculate thermal movements affecting piping systems.",
    "Select proper hangers based on load, displacement, and environmental conditions.",
    "Interpret and apply typical pipe support specifications used in industry.",
    "Gain insight into nuclear pipe hanger design standards and practices.",
    "Design seismic support systems in compliance with relevant codes.",
    "Understand the design considerations for grooved piping systems.",
    "Apply the learned principles through real-world case studies and examples.",
    "Accurately use piping material weight data for support design.",
    "Utilize charts and tables for efficient and standardized design processes."
  ],
  "outline": [
    "Module 1: Design of Pipe Hangers",
    "Module 2: Determination of Hanger Locations",
    "Module 3: Hanger Load Calculations",
    "Module 4: Thermal Movement Calculations",
    "Module 5: Selection of the Proper Hangers",
    "Module 6: Typical Pipe Support Specification",
    "Module 7: Nuclear pipe Hangers",
    "Module 8: Seismic Supports",
    "Module 9: Supports for Grooved Piping",
    "Module 10: Application Examples",
    "Module 11: Weights of Piping Materials",
    "Module 12: Charts and Tables"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 50,
  "title": "Pump",
  "date": "Present",
  "description": [
    "This course provides a comprehensive study of pumps and their applications in industrial facilities, particularly in oil & gas, petrochemical, and power plants. It covers the classification of pumps, fundamentals of centrifugal and positive displacement pumps, pump performance, corrosion challenges, piping design considerations, sealing systems, and couplings.",
    "In addition, the course emphasizes operation, maintenance, and troubleshooting techniques to improve pump reliability, efficiency, and lifecycle management. Participants will gain both theoretical knowledge and practical insights needed for effective pump selection, system integration, and problem-solving in real-world applications."
  ],
  "image": "https://i.ibb.co/HL6Qs8by/Pump.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of fluid mechanics and hydraulics.",
    "Familiarity with process equipment in industrial facilities.",
    "Understanding of piping and process flow diagrams (PFDs/P&IDs).",
    "Some experience in plant operations or mechanical maintenance is beneficial but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Differentiate between centrifugal, positive displacement, and other pump types.",
    "Select pumps based on process requirements and fluid characteristics.",
    "Understand principles of operation, head, flow, NPSH, and efficiency.",
    "Interpret pump curves and evaluate pump performance.",
    "Analyze performance parameters (flow, head, efficiency, power).",
    "Assess system curves and pump operating points.",
    "Identify common corrosion issues in pumps.",
    "Select appropriate materials and coatings to enhance pump life.",
    "Understand piping layout considerations for pump operation.",
    "Manage suction/discharge piping and minimize hydraulic losses.",
    "Learn about mechanical seals, packing, and sealing technologies.",
    "Evaluate different coupling types and their applications.",
    "Understand design, operation, and applications of reciprocating and rotary pumps.",
    "Compare positive displacement vs. centrifugal pumps.",
    "Detect common pump failures (cavitation, seal leakage, misalignment, and vibration).",
    "Apply corrective and preventive maintenance techniques.",
    "Implement condition monitoring for improved reliability."
  ],
  "outline": [
    "Module 1: Classifications Of Pumps",
    "Module 2: Centrifugal Pump Fundamentals",
    "Module 3: Pump Performance",
    "Module 4: Corrosion",
    "Module 5: Piping Design",
    "Module 6: Sealing",
    "Module 7: Coupling",
    "Module 8: Positive Displacement Pumps",
    "Module 9: Maintenance & Troubleshooting"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 51,
  "title": "Pump Repairs (API RP 697)",
  "date": "Present",
  "description": [
    "This course provides in-depth knowledge and practical guidance on repairing and refurbishing pumps in compliance with API Recommended Practice 697. It covers the end-to-end repair process, starting from inspection of installed pumps, field repair activities, and shipment handling to detailed shop repair procedures such as disassembly, inspection, re-rates, rotor balancing, reassembly, and documentation.",
    "The course emphasizes industry best practices, quality assurance, and safety standards to ensure pumps are restored to reliable operating conditions. Participants will learn how to properly manage pump repairs both in the field and in specialized repair shops, with a strong focus on compliance with API standards, equipment longevity, and operational safety."
  ],
  "image": "https://i.ibb.co/CZxNcX6/Pump-Repairs-API-RP-697.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "Basic knowledge of pump design and operation.",
    "Familiarity with rotating equipment maintenance.",
    "Understanding of plant safety standards and equipment handling.",
    "Experience in mechanical maintenance, reliability, or rotating equipment is recommended but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define the scope and purpose of pump repair standards.",
    "Recognize key terms, definitions, and compliance requirements.",
    "Conduct thorough inspections of installed pumps.",
    "Apply safe methods for pump removal from baseplates.",
    "Identify repairable conditions versus cases requiring shop repair.",
    "Safely prepare and transport pumps or components to/from repair shops.",
    "Ensure proper documentation and handling procedures.",
    "Perform disassembly, cleaning, and inspection of pump components.",
    "Apply repair techniques for casings, rotors, seals, and bearings.",
    "Conduct modifications and re-rates as per process requirements.",
    "Understand welding, machining, and replacement component manufacturing.",
    "Ensure compliance with material and dimensional tolerances.",
    "Conduct rotor assembly and dynamic balancing.",
    "Assemble pumps in shop conditions with alignment and clearances verified.",
    "Prepare inspection and repair documentation in line with API RP 697.",
    "Review and verify shop reports before shipment.",
    "Ensure proper handover and receipt of repaired equipment by the owner."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Terms and Definitions",
    "Module 3: Inspection of Installed Pump and Removal from Baseplate",
    "Module 4: Field Inspections (After the Pump Has Been Removed from Its Base)",
    "Module 5: Field Repair",
    "Module 6: Shipment of Equipment or Components to or from Repair Shop",
    "Module 7: Receipt of Pump and Components by Repair Shop or Owner",
    "Module 8: Disassembly and Cleaning of the Pump (in Repair Shop)",
    "Module 9: Shop Inspection of Disassembled Pump, Components and Casing",
    "Module 10: Pump Modifications and Re-Rates",
    "Module 11: Repair Processes and New Component Manufacture",
    "Module 12: Rotor Assembly and Balancing",
    "Module 13: Shop Assembly of Pump",
    "Module 14: Shipment of Equipment or Components from Repair Shop",
    "Module 15: Documentation",
    "Module 16: Receipt of Repaired Pump by Owner"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 52,
  "title": "Safe Furnace & Boiler Firing",
  "date": "Present",
  "description": [
    "Furnaces and boilers are critical pieces of equipment in the oil & gas, petrochemical, and power industries, but they also present significant safety risks if not properly operated. This course provides a comprehensive understanding of safe furnace and boiler firing practices, emphasizing operational safety, fuel system integrity, burner management, and proper lighting and shutdown procedures. Participants will learn how fired heaters work, the hazards associated with explosions, and the steps necessary to prevent accidents through safe operating procedures and correct maintenance practices.",
    "By combining theory with practical safety principles, this course equips engineers, operators, and technicians with the skills required to ensure safe, efficient, and reliable operation of fired heaters and boilers."
  ],
  "image": "https://i.ibb.co/ZzZNH18c/Safe-Furnance-Boiler-Firing.png",
  "tags": [],
  "category": "mechanical",
  "duration": "4 Days",
  "prerequisite": [
    "A basic understanding of process plant operations or utility systems.",
    "Familiarity with combustion processes and fuel handling.",
    "Some prior experience with boilers, furnaces, or fired equipment is preferred for better comprehension."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain how furnaces and boilers operate in industrial settings.",
    "Identify major components and their functions.",
    "Understand the causes and consequences of furnace and boiler explosions.",
    "Learn preventive measures and safe operational practices.",
    "Understand different fuel systems (gas, oil, dual-fuel).",
    "Identify fuel safety requirements and safeguards against leaks or malfunctions.",
    "Describe types of burners and their role in safe and efficient firing.",
    "Apply correct maintenance and inspection techniques.",
    "Carry out step-by-step safe furnace lighting practices.",
    "Perform controlled and safe shutdown to prevent incidents.",
    "Apply best practices in line with industry standards and regulatory requirements.",
    "Promote operator awareness and adherence to furnace/boiler safety procedures."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: How fired heaters work",
    "Module 3: Explosions",
    "Module 4: Fuel systems",
    "Module 5: Burners",
    "Module 6: Furnace lighting and shutdown"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 53,
  "title": "Common Process Safety Issues Identified During HAZOP Revalidation",
  "date": "Present",
  "description": [
    "Hazard and Operability (HAZOP) studies are a cornerstone of process safety management, but their true value lies in periodic revalidation to capture changes in plant configuration, operation, and risk profile. This course focuses on the recurring and critical process safety issues often identified during HAZOP revalidation in oil, gas, and chemical facilities.",
    "Participants will learn how to recognize and address risks associated with bypasses, plant modifications, changes in operating conditions, missing safety information, and inadequate isolation practices. Through real-world examples and case studies, the course equips attendees with practical strategies to close safety gaps, comply with regulatory requirements, and enhance operational integrity."
  ],
  "image": "https://i.ibb.co/prKyCkLx/Common-process-safety-issues-identified-during-HAZOP-revalidation-operational-stage.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "2 Days",
  "prerequisite": [
    "Basic understanding of process engineering, operations, or safety management.",
    "Exposure to plant operations, maintenance, or safety reviews is beneficial.",
    "Ability to read and interpret P&IDs, process flow diagrams, and safety documentation."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain why periodic HAZOP revalidation is essential for ongoing process safety.",
    "Identify the regulatory and industry standards driving revalidation requirements.",
    "Identify risks associated with temporary and permanent bypasses of safety-critical equipment.",
    "Apply best practices for bypass authorization, tracking, and removal.",
    "Detect hazards introduced by equipment changes, process alterations, or layout modifications.",
    "Apply Management of Change (MOC) principles to mitigate these risks.",
    "Recognize how deviations in temperature, pressure, flow, or composition can introduce new hazards.",
    "Recommend safeguards to control these risks.",
    "Understand the importance of complete and up-to-date process safety data.",
    "Develop strategies to close documentation and knowledge gaps.",
    "Identify hazards arising from incomplete or ineffective isolation of equipment.",
    "Recommend isolation methods that meet recognized safety standards.",
    "Translate HAZOP revalidation findings into actionable recommendations.",
    "Support continuous improvement in process safety culture and performance."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Bypass management",
    "Module 3: Identification risk arises from modifications",
    "Module 4: Identification risk arises from changes in operating conditions",
    "Module 5: Missing process safety information and knowledge",
    "Module 6: Less than adequate long-term isolation"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦80,000 / $60",
  "certification": "Certificate of Completion"
},

{
  "id": 54,
  "title": "Fire and Explosion Guidance",
  "date": "Present",
  "description": [
    "Fire and explosion hazards represent some of the most critical safety challenges in oil and gas facilities, both onshore and offshore. Effective prevention, mitigation, and response strategies are essential to protect life, assets, and the environment.",
    "This course provides a structured understanding of fire and explosion hazard management in oil and gas operations. Participants will learn the underlying hazard management philosophy, methods for deriving fire and explosion loads, and the principles of risk-based assessment. Practical sessions cover incident response strategies, integration of hazard management into facility design, and alignment with international standards and best practices. Case-based discussions will reinforce the importance of proactive hazard identification and robust engineering controls."
  ],
  "image": "https://i.ibb.co/HLChnFnh/Fire-Explosion-Guidance.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "4 Days",
  "prerequisite": [
    "Basic knowledge of engineering, safety management, or oil and gas operations (preferred).",
    "Experience in HSE, process safety, or facility design is advantageous.",
    "Ability to interpret technical drawings (PFDs, P&IDs) and safety documentation."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe typical oil and gas facility layouts and operations in the context of fire and explosion risks.",
    "Explain the hierarchy of prevention, detection, control, and mitigation strategies.",
    "Calculate fire loads for different hydrocarbon scenarios.",
    "Understand heat transfer principles and their relevance to fire exposure.",
    "Identify sources of flammable gas clouds and overpressure events.",
    "Apply methodologies for estimating explosion loadings.",
    "Integrate quantitative and qualitative risk assessment methods into hazard management.",
    "Prioritize hazards based on frequency and consequence analysis.",
    "Describe fire suppression, containment, and evacuation procedures.",
    "Evaluate the use of active and passive fire protection systems.",
    "Outline immediate and follow-up actions to mitigate explosion consequences.",
    "Incorporate fire and explosion safety principles into engineering and layout decisions.",
    "Ensure compliance with international codes and industry standards."
  ],
  "outline": [
    "Module 1: Introduction to Oil and Gas Facilities",
    "Module 2: Fire and explosion hazard management philosophy",
    "Module 3: Derivation of fire loadings and heat transfer",
    "Module 4: Derivation of explosion load",
    "Module 5: Risk based assessment",
    "Module 6: Response to fires",
    "Module 7: Response to explosions",
    "Module 8: Fire and explosion hazard management in design"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 55,
  "title": "Hazardous Area Classification (API 505)",
  "date": "Present",
  "description": [
    "Hazardous Area Classification (HAC) is a critical process for identifying and managing locations where flammable gases, vapors, or liquids may be present, creating a risk of fire or explosion. The API 505 standard provides guidelines for classifying such areas using the Zone system, ensuring proper design, installation, and operation of electrical and mechanical equipment in oil, gas, and petrochemical environments.",
    "This course equips participants with the knowledge and skills to apply API 505 recommendations across various facilities — including petroleum refineries, drilling rigs, LNG plants, offshore units, and pipeline stations. It covers key principles such as ignition conditions, classification criteria, extent of classified areas, and facility-specific application examples. By combining theoretical fundamentals with practical case scenarios, participants will gain the competence to perform and review hazardous area classification effectively and in compliance with industry best practices."
  ],
  "image": "https://i.ibb.co/qLNJk495/Hazardous-Area-Classification-API-505.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "4 Days",
  "prerequisite": [
    "Basic knowledge of oil & gas processing, mechanical/electrical engineering, or safety engineering.",
    "Understanding of process equipment and layouts in petroleum facilities is beneficial.",
    "Familiarity with fire/explosion safety principles and ability to read facility layouts, PFDs, and P&IDs."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of API 505 in managing fire and explosion risks in oil & gas facilities.",
    "Interpret the terms, definitions, and acronyms used in hazardous area classification according to API 505.",
    "Recognize the basic conditions required for ignition and the properties of flammable/combustible liquids, gases, and vapors.",
    "Apply zone-based classification principles to define the type and extent of hazardous areas.",
    "Implement API 505 recommendations for various petroleum and gas installations, including:",
    "Refineries",
    "Onshore drilling rigs and production facilities",
    "Offshore fixed platforms",
    "Mobile Offshore Drilling Units (MODUs)",
    "Floating Production Units",
    "LNG facilities",
    "Petroleum pipeline transformation facilities",
    "Determine hazard boundaries using API 505 guidelines for common applications and complex layouts.",
    "Understand how hazardous area classification impacts equipment selection, maintenance, and safety compliance.",
    "Analyze and discuss example classifications from actual petroleum facilities to enhance application skills."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Terms, Definition & Acronym",
    "Module 3: Basic conditions for a fire or explosion",
    "Module 4: Flammable and Combustible liquids, gases and vapors",
    "Module 5: Classification Criteria",
    "Module 6: Extent of a classified location",
    "Module 7: Recommendations for determining degree and Extent of a classified location – common applications",
    "Module 8: Recommendations for determining degree and Extent of a classified location in petroleum refineries",
    "Module 9: Recommendations for determining degree and Extent of a classified location at drilling rig and production facilities on land and on marine fixed platforms.",
    "Module 10: Recommendations for determining degree and Extent of a classified location on mobile offshore drilling units (MODUs).",
    "Module 11: Recommendations for determining degree and Extent of a classified location at drilling rig and production facilities on floating production units.",
    "Module 12: Recommendations for determining degree and Extent of a classified location at petroleum pipeline transformation facilities.",
    "Module 13: Recommendations for determining degree and Extent of a classified location at LNG facilities."
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 56,
  "title": "PHA & WHAT-IF CHECKLIST QUESTIONS",
  "date": "Present",
  "description": [
    "This course introduces participants to the systematic application of Process Hazard Analysis (PHA) methods with a focus on the What-If/Checklist technique. It equips participants with the knowledge and practical skills to identify, analyze, and mitigate potential hazards in oil, gas, petrochemical, and power facilities. Covering critical process equipment (piping, vessels, pumps, compressors, reactors, tanks, etc.) and human/organizational factors, the course provides a practical framework for conducting structured What-If studies to improve operational safety and regulatory compliance.",
    "By the end, participants will be able to conduct What-If/Checklist sessions, document findings, and recommend safeguards to ensure safer facility operations."
  ],
  "image": "https://i.ibb.co/TqL9D31N/PHA-What-if-Checklist-Questions.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of process engineering, mechanical equipment, or plant operations.",
    "Familiarity with P&IDs, process flow diagrams (PFDs), and equipment datasheets.",
    "General awareness of safety regulations (e.g., OSHA PSM, API, IEC 61511, or equivalent standards).",
    "Prior exposure to hazard identification methods (HAZOP, risk assessment, or safety case studies) is beneficial but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the purpose, regulatory requirements, and methodologies of PHA.",
    "Differentiate between What-If, Checklist, HAZOP, and other PHA techniques.",
    "Develop and structure What-If questions relevant to major process systems and equipment.",
    "Use checklists to ensure thorough hazard coverage during analysis.",
    "Apply systematic What-If questions to piping, valves, vessels, tanks, pumps, compressors, heat exchangers, and other critical equipment.",
    "Consider potential deviations, failures, and human errors.",
    "Evaluate the effectiveness of existing safety systems and controls.",
    "Recommend additional safeguards or corrective actions.",
    "Recognize human error modes, procedural gaps, and ergonomics in hazard identification.",
    "Incorporate lessons learned from global industrial incidents into PHA sessions.",
    "Facilitate or participate effectively in a What-If/Checklist PHA workshop.",
    "Prepare structured documentation to support regulatory audits and safety cases."
  ],
  "outline": [
    "Module 1: Piping",
    "Module 2: Valves",
    "Module 3: Vessels",
    "Module 4: Tanks",
    "Module 5: Pumps",
    "Module 6: Compressors",
    "Module 7: Heat Exchangers",
    "Module 8: Reactors",
    "Module 9: Columns (Towers)",
    "Module 10: Flares",
    "Module 11: Electrical Equipment",
    "Module 12: Cooling Tower",
    "Module 13: Utility Systems",
    "Module 14: Human Factors",
    "Module 15: Global Events"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 57,
  "title": "PROCEDURE FOR PERMIT TO WORK",
  "date": "Present",
  "description": [
    "The Permit to Work (PTW) system is a formalized safety management tool used in industrial environments to ensure that hazardous and high-risk tasks are carried out safely. This course provides participants with a detailed understanding of the PTW system, including its scope, application, roles, responsibilities, and procedural requirements.",
    "It emphasizes how PTW helps prevent accidents by controlling work activities such as hot work, confined space entry, electrical isolation, working at height, and maintenance operations. The training also covers the auditing and training requirements that ensure ongoing compliance with company and industry standards.",
    "This program equips participants with the skills needed to apply, issue, monitor, and close permits effectively, ensuring safe operations and regulatory compliance in industries such as oil & gas, power, chemical, and manufacturing."
  ],
  "image": "https://i.ibb.co/KzNhS1G8/Procedure-for-Permit-to-Work.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of industrial operations and workplace safety practices.",
    "Familiarity with health, safety, and environmental (HSE) standards is beneficial.",
    "Prior experience in operations, maintenance, or supervisory roles.",
    "No prior PTW-specific training is required."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain when and why PTW is required in various industrial settings.",
    "Identify tasks that require mandatory permits.",
    "Interpret PTW terminology and definitions to ensure clarity in implementation.",
    "Distinguish between different types of permits (e.g., hot work, confined space, electrical, excavation).",
    "Describe the responsibilities of issuers, receivers, supervisors, and safety officers.",
    "Promote accountability and communication within the PTW system.",
    "Demonstrate the steps in preparing, issuing, monitoring, and closing permits.",
    "Apply isolation and lockout/tagout (LOTO) practices.",
    "Recognize common errors and implement corrective actions.",
    "Identify training requirements for personnel involved in PTW.",
    "Understand the role of audits in ensuring PTW compliance and continuous improvement."
  ],
  "outline": [
    "Module 1: Scope and Application",
    "Module 2: Definitions",
    "Module 3: Responsibilities",
    "Module 4: Procedure",
    "Module 5: Training and Audit Requirements"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 58,
  "title": "Dehydration Considerations",
  "date": "Present",
  "description": [
    "This course provides an in-depth exploration of natural gas dehydration processes and considerations. It covers key dehydration technologies, system design, and operational factors influencing dehydration efficiency. The course also discusses special considerations such as mercury impacts, different glycol systems, pump options, and the physical properties of common glycols used in dehydration."
  ],
  "image": "https://i.ibb.co/H61qQYN/Dehydration-Considerations.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "2 Days",
  "prerequisite": [
    "Fundamental understanding of natural gas processing, phase behavior",
    "Basic chemical engineering principles.",
    "Familiarity with fluid systems and process equipment."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "To understand the principles of adsorption and absorption in gas dehydration.",
    "To explore glycol dehydration methods and system design considerations.",
    "To analyze the impact of mercury and other contaminants on dehydration systems.",
    "To evaluate different dehydration system configurations, including glycol-gas powered and electric-driven pumps.",
    "To understand the characteristics and physical properties of common glycols used in dehydration processes.",
    "To identify special glycol dehydration systems and nonregenerable dehydrators for specific applications."
  ],
  "outline": [
    "Module 1: Overview",
    "Module 2: Adsorption",
    "Module 3: Absorption",
    "Module 4: Glycol Dehydration",
    "Module 5: System Design",
    "Module 6: Mercury Considerations",
    "Module 7: Special Glycol Dehydration Systems",
    "Module 8: Systems Utilizing Glycol-Gas Powered Pumps",
    "Module 9: Systems Utilizing Electric Driven Pumps",
    "Module 10: Nonregenerable Dehydrator",
    "Module 11: Physical Properties Of Common Glycols"
  ],
  "assessment": "Online Written Exam / AutoCAD Design Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦80,000 / $60",
  "certification": "Certificate of Completion"
},

{
  "id": 59,
  "title": "Hydrate Prediction & Prevention",
  "date": "Present",
  "description": [
    "This course offers a comprehensive understanding of hydrates in natural gas production and transportation. It covers the properties of water in gas systems, the formation and risks of gas hydrates, and effective prediction and prevention strategies.",
    "Participants will learn to identify hydrate formation conditions and apply various correlations and methods to mitigate hydrate-related flow assurance issues."
  ],
  "image": "https://i.ibb.co/0Vqbj40X/Hydrate-Prediction-Prevention.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "2 Days",
  "prerequisite": [
    "Fundamental understanding of petroleum engineering",
    "Thermodynamics, fluid mechanics, and natural gas processing.",
    "Prior knowledge of phase behavior, flow assurance, and basic chemistry will enhance the learning experience."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "To understand the water content in gas systems and its role in hydrate formation.",
    "To explain the nature and formation of gas hydrates.",
    "To develop skills for predicting hydrate formation conditions using temperature and pressure data.",
    "To learn how to calculate temperature drops during flow and their impact on hydrate stability.",
    "To explore various hydrate prediction correlations and their applications.",
    "To identify and evaluate effective hydrate prevention and inhibition techniques.",
    "To apply best practices for flow assurance in natural gas systems to minimize hydrate risks."
  ],
  "outline": [
    "Module 1: Overview",
    "Module 2: Water content of gas",
    "Module 3: Gas hydrates",
    "Module 4: Prediction of operating temperature and pressure",
    "Module 5: Temperature drop determination",
    "Module 6: Hydrate prediction correlations",
    "Module 7: Hydrate prevention",
    "Module 8: Hydrate inhibition"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦50,000 / $40",
  "certification": "Certificate of Completion"
},

{
  "id": 60,
  "title": "Glycol Maintenance, Care & Troubleshooting",
  "date": "Present",
  "description": [
    "Glycol-based systems are widely used in industrial and commercial applications for cooling, heating, and process control. Maintaining these systems is critical to ensuring operational efficiency, safety, and longevity. This course provides a comprehensive approach to glycol system care, focusing on proactive maintenance, problem-solving, filtration optimization, and advanced purification techniques.",
    "Participants will explore real-world scenarios, learn diagnostic and corrective procedures, and gain hands-on insights into maintaining system integrity. Whether you're a technician, engineer, or facility manager, this course equips you with the knowledge and tools to keep glycol systems running smoothly and sustainably."
  ],
  "image": "https://i.ibb.co/4RcDh9DD/Glycol-Maintenance-Care-Troubleshooting.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "1 Day",
  "prerequisite": [
    "Basic understanding of HVAC or industrial fluid systems.",
    "Familiarity with mechanical system components (pumps, filters, heat exchangers).",
    "Experience with routine maintenance procedures or technical operations."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Perform preventative maintenance on glycol systems to extend lifespan and efficiency.",
    "Identify and eliminate common operating problems in glycol systems.",
    "Optimize glycol filtration processes to reduce contamination and improve performance.",
    "Understand and apply carbon purification techniques for glycol system longevity."
  ],
  "outline": [
    "Module 1: Preventative maintenance",
    "Module 2: Eliminating Operating Problems",
    "Module 3: Improving Glycol Filtration",
    "Module 4: Use of Carbon Purification"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦50,000 / $40",
  "certification": "Certificate of Completion"
},

{
  "id": 61,
  "title": "Basics of Corrosion in Oil & Gas Industry",
  "date": "Present",
  "description": [
    "The oil and gas industry operates in some of the most challenging and corrosive environments, where equipment integrity is critical for safety, environmental protection, and profitability.",
    "This course provides participants with a solid understanding of corrosion principles, types, and impacts in oil and gas operations. Through structured modules, the course covers the fundamentals of corrosion science, environmental influences, material selection, corrosion control techniques, inspection, and monitoring practices.",
    "By the end, participants will be equipped with the knowledge to recognize corrosion threats, apply prevention strategies, and contribute to effective asset integrity management."
  ],
  "image": "https://i.ibb.co/B5gSzRc8/Basics-of-Corrosion-in-Oil-and-Gas-Industry.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of science or engineering principles.",
    "Some exposure to oil & gas operations, maintenance, or engineering is beneficial.",
    "Ability to understand technical concepts and interpret basic technical drawings or specifications."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define corrosion and explain it’s economic and safety impacts in oil & gas operations.",
    "Describe the electrochemical principles governing corrosion.",
    "Identify how operational and environmental conditions affect corrosion rates.",
    "Understand the role of water chemistry, gases, temperature, and pressure.",
    "Recognize common engineering materials used in oil & gas.",
    "Assess material suitability based on corrosion resistance.",
    "Distinguish between uniform, localized, and environment-specific corrosion mechanisms.",
    "Explain coating systems, cathodic protection, inhibitors, and process control measures.",
    "Interpret common inspection techniques for detecting corrosion and associated failures.",
    "Apply monitoring methods such as probes, coupons, and inline inspection tools to track corrosion activity.",
    "Contribute to corrosion management plans that enhance asset reliability and safety."
  ],
  "outline": [
    "Module 1: Corrosion Definition and cost",
    "Module 2: Fundamentals of Electricity and Electrochemistry",
    "Module 3: Environment",
    "Module 4: Engineering Materials",
    "Module 5: Forms of Corrosion",
    "Module 6: Methods of corrosion control",
    "Module 7: Corrosion and failure inspection",
    "Module 8: Corrosion monitoring"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 62,
  "title": "Catalytic Reforming",
  "date": "Present",
  "description": [
    "Catalytic reforming is a critical refining process used to upgrade low-octane naphtha into high-octane reformate, a key blending component for gasoline, and to produce valuable hydrogen for refinery operations. This course provides a comprehensive understanding of catalytic reforming principles, process chemistry, catalyst technology, operating parameters, and design considerations.",
    "Participants will gain insight into the chemical reactions, thermodynamics, and process conditions that drive reformer performance. The course also addresses hazard assessment, plant design, and optimization strategies to ensure safety, efficiency, and profitability. Real-world industry examples and case studies are used to connect theory with practical application."
  ],
  "image": "https://i.ibb.co/vxcqN4dF/Catalytic-Reforming.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "2 Days",
  "prerequisite": [
    "Basic knowledge of chemical or petroleum engineering principles (preferred).",
    "Prior exposure to refinery processes or petrochemical operations is beneficial.",
    "Ability to interpret process flow diagrams (PFDs) and basic process calculations."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the basic principles of catalytic reforming and its role in refinery operations.",
    "Identify the feedstock characteristics and desired product properties.",
    "Outline process configurations such as continuous regeneration, semi-regenerative, and cyclic reformers.",
    "Understand key reforming reactions, including dehydrogenation, isomerization, dehydrocyclization, and hydrocracking.",
    "Apply thermodynamic principles to predict reaction direction and yield.",
    "Identify catalyst compositions, functions, and preparation methods.",
    "Explain catalyst deactivation mechanisms and regeneration methods.",
    "Analyze the effect of temperature, pressure, hydrogen-to-hydrocarbon ratio, and space velocity on reformer performance.",
    "Identify operational hazards related to high temperature, high pressure, and flammable gases.",
    "Apply safety protocols and hazard mitigation strategies.",
    "Recognize design factors for reactor configuration, heat integration, and catalyst loading.",
    "Understand process control strategies to optimize operation.",
    "Apply learned concepts to enhance yield, selectivity, and catalyst life while maintaining safety and compliance."
  ],
  "outline": [
    "Module 1: Basic Principles",
    "Module 2: The Catalytic Reforming Process",
    "Module 3: Process Chemical Reactions and Thermodynamics",
    "Module 4: Catalytic Reforming Catalyst",
    "Module 5: Catalyst Reforming Parameters",
    "Module 6: Hazard Assessment",
    "Module 7: Plant Design",
    "Module 8: Design"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 63,
  "title": "Fundamentals of surface facilities in oil fields",
  "date": "Present",
  "description": [
    "Surface facilities in oil fields play a critical role in the processing, handling, and transportation of hydrocarbons from the wellhead to downstream facilities. This course provides participants with a comprehensive introduction to the equipment, systems, and processes involved in oil field surface operations.",
    "Covering essential components such as valves, piping, tanks, separators, pumps, compressors, heat exchangers, flares, and distillation units, the course explains their functions, operating principles, and interrelationships. Participants will gain a practical understanding of how these facilities are integrated to ensure safe, efficient, and environmentally compliant oil field operations. Real-world examples and process flow discussions will link theory to field applications, making the course relevant for both technical and operations staff."
  ],
  "image": "https://i.ibb.co/JjD3dLVG/Fundamentals-of-surface-facilities-in-oil-fields.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of oil & gas production processes or mechanical/chemical engineering concepts.",
    "Some exposure to upstream oil & gas facilities is beneficial but not mandatory.",
    "Ability to understand simple process flow diagrams (PFDs) and piping & instrumentation diagrams (P&IDs) is advantageous."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and role of valves, pipes, tanks, separators, heaters, exchangers, and related components.",
    "Explain how equipment such as separators, pumps, compressors, and distillation units operate within oil field processing systems.",
    "Recognize how individual components work together to process, treat, and transport crude oil and associated gas.",
    "Apply basic sizing, rating, and selection criteria for common oil field surface facility components.",
    "Understand the impact of pressure, temperature, flow rate, and crude composition on equipment choice.",
    "Identify safety features, flare systems, and environmental controls used in surface facilities.",
    "Review practical case studies to understand typical operational challenges and solutions in oil field surface facilities.",
    "Trace the flow of crude oil and gas through key surface facility stages, from separation to final treatment."
  ],
  "outline": [
    "Module 1: Valves",
    "Module 2: Pipes",
    "Module 3: Tanks",
    "Module 4: Separator, Dehydrator, Desalter",
    "Module 5: Pumps & compressors",
    "Module 6: Furnaces, Heaters, Heat Exchangers",
    "Module 7: Flares",
    "Module 8: Flow Meter",
    "Module 9: Distillation Column",
    "Module 10: Cooler",
    "Module 11: Condenser",
    "Module 12: Reboiler",
    "Module 13: Absorber",
    "Module 14: Crude Distillation Unit"
  ],
  "assessment": "Online Written Exam / AutoCAD Design Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},


{
  "id": 64,
  "title": "Boiler Control System Engineering",
  "date": "Present",
  "description": [
    "Boilers are critical components in power generation and industrial processes, and their efficient, safe, and reliable operation depends heavily on effective control systems. This course provides an in-depth understanding of boiler operation fundamentals and the principles of control engineering applied to steam generation systems.",
    "Participants will learn about furnace draft, feedwater systems, fuel-air ratio control, steam temperature regulation, burner management systems, and environmental considerations. The course also covers control valve sizing principles to ensure precise and stable operation. Real-world examples and best practices from power plants and industrial facilities will be incorporated to bridge theory and practical application."
  ],
  "image": "https://i.ibb.co/NgwgGHCC/Boiler-Control-System-Engineering.png",
  "tags": [],
  "category": "PAI",
  "duration": "5 Days",
  "prerequisite": [
    "Basic knowledge of mechanical, electrical, or control engineering.",
    "Exposure to boiler operations, power plant systems, or industrial process control is advantageous.",
    "Ability to interpret P&IDs and familiarity with basic instrumentation concepts.",
    "No advanced boiler control experience required"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the working principles, types, and major components of boilers.",
    "Recognize boiler operating parameters and their importance to plant performance.",
    "Describe common boiler control strategies and their impact on safety, efficiency, and reliability.",
    "Explain furnace draft requirements and the control methods for maintaining optimal combustion conditions.",
    "Understand feedwater flow regulation, level control, and the role of economizers.",
    "Identify control challenges specific to coal-fired units and strategies to optimize performance.",
    "Apply fuel-air ratio control for efficient combustion and reduced emissions.",
    "Describe methods for superheat and reheat temperature control.",
    "Understand BMS safety logic, interlocks, and startup/shutdown sequences.",
    "Identify emissions control strategies and environmental compliance measures.",
    "Apply valve sizing principles to ensure stable, accurate control of steam, feedwater, and fuel flows."
  ],
  "outline": [
    "Module 1: Boiler Fundamentals",
    "Module 2: Control of Boilers",
    "Module 3: Furnace Draft",
    "Module 4: Feedwater",
    "Module 5: Coal Fired Boilers",
    "Module 6: Fuel and Air Controls",
    "Module 7: Steam Temperatures",
    "Module 8: Burner Management System",
    "Module 9: Environment",
    "Module 10: Control Valve Sizing"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 65,
  "title": "INSTRUMENTATION AND CONTROL SYSTEMS",
  "date": "Present",
  "description": [
    "Instrumentation and control systems are the backbone of modern industrial operations, ensuring safe, reliable, and efficient processes in oil & gas, petrochemicals, power generation, manufacturing, and other industries. This course provides a comprehensive introduction to measurement systems, instrumentation elements, and control principles, progressing toward advanced topics such as transfer functions, system modeling, frequency response, and Nyquist diagrams.",
    "Participants will gain both theoretical knowledge and practical insights into how instruments measure process variables, how controllers maintain desired conditions, and how automated systems such as PLCs integrate into plant operations. The course also includes real-world case studies to bridge the gap between theory and industrial application."
  ],
  "image": "https://i.ibb.co/ZzgHFHp8/INSTRUMENTATION-AND-CONTROL-SYSTEM.png",
  "tags": [],
  "category": "PAI",
  "duration": "8 Days",
  "prerequisite": [
    "Diploma or degree in engineering (electrical, electronics, mechanical, chemical, or process) or a related technical discipline.",
    "Basic understanding of physics (mechanics, thermodynamics) and mathematics (algebra, calculus, Laplace transforms recommended).",
    "Some exposure to industrial plant systems or process operations is beneficial but not mandatory."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Describe the role and function of measurement systems in process industries.",
    "Differentiate between types of sensors, transducers, and measurement methods.",
    "Explain the function of primary elements, signal transmission, and final control elements.",
    "Apply measurement and control concepts to real industrial problems and evaluate solutions.",
    "Explain open-loop vs. closed-loop control and their relevance in industrial automation.",
    "Understand the principles of PID controllers and their applications in maintaining process stability.",
    "Explain how actuators, valves, and other final elements correct process deviations.",
    "Understand PLC hardware, programming basics, and integration into control systems.",
    "Use mathematical modeling techniques to represent dynamic process systems.",
    "Derive and use transfer functions for control system analysis.",
    "Evaluate time-domain responses such as transient and steady-state behavior.",
    "Understand Bode plots and frequency domain analysis for system stability.",
    "Use Nyquist stability criterion to evaluate control system performance.",
    "Combine measurement, instrumentation, modeling, and control strategies to design effective industrial control systems."
  ],
  "outline": [
    "Module 1: Measurement Systems",
    "Module 2: Instrumentation System Elements",
    "Module 3: Measurement Case Studies",
    "Module 4: Control Systems",
    "Module 5: Process Controllers",
    "Module 6: Correction Elements",
    "Module 7: PLC Systems",
    "Module 8: System Models",
    "Module 9: Transfer Function",
    "Module 10: System Response",
    "Module 11: Frequency Response",
    "Module 12: Nyquist Diagrams",
    "Module 13: Control Systems"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦500,000 / $450",
  "certification": "Certificate of Completion"
},

{
  "id": 66,
  "title": "Instruments Training & Calibration Procedures",
  "date": "Present",
  "description": [
    "Accurate measurement and reliable control are vital to the safe and efficient operation of power plants. Instruments such as pressure, flow, temperature, and level sensors, along with analyzers and transmitters, require proper installation, calibration, and maintenance to ensure plant performance and compliance with industry standards.",
    "This course provides participants with a comprehensive understanding of various instruments used in power plants, the calibration instruments required, step-by-step calibration procedures for different field devices, and the integration of calibrated instruments within plant control systems. Combining theoretical knowledge with practical procedures, the program equips engineers and technicians with the skills needed to enhance accuracy, reliability, and safety in instrumentation."
  ],
  "image": "https://i.ibb.co/qF4NKzLt/Instruments-Training-Clibration-Training.png",
  "tags": [],
  "category": "PAI",
  "duration": "4 Days",
  "prerequisite": [
    "Diploma or degree in instrumentation, electrical, electronics, mechanical, or process engineering.",
    "Basic understanding of measurement principles (pressure, flow, level, and temperature).",
    "Some exposure to industrial instrumentation, control systems, or power plant operations is beneficial but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Recognize the function of different field instruments (pressure, flow, temperature, level, and analyzers).",
    "Understand their role in power plant monitoring and control.",
    "Identify calibration equipment (deadweight testers, decade boxes, calibrators, simulators, etc.) used in power plants.",
    "Match calibration tools to the type of instrument being tested.",
    "Execute standard calibration procedures for various instruments (pressure transmitters, flow meters, temperature sensors, level transmitters, etc.).",
    "Apply best practices for ensuring accuracy, repeatability, and compliance with international standards (e.g., ISA, ISO).",
    "Record calibration data, tolerances, and adjustments in line with industry documentation practices.",
    "Maintain calibration logs for regulatory compliance and plant audits.",
    "Understand how calibrated instruments interact with Distributed Control Systems (DCS), Programmable Logic Controllers (PLC), and Safety Instrumented Systems (SIS).",
    "Troubleshoot discrepancies between field instruments and control system readings.",
    "Apply safety measures while calibrating instruments in a live plant environment.",
    "Contribute to reliable and efficient plant operations through precise measurement and control."
  ],
  "outline": [
    "Module 1: Different type of instruments in power plant",
    "Module 2: Calibration Instruments Required In Power Plant",
    "Module 3: Calibration Procedure For Different Type Of Field Instruments",
    "Module 4: Femilization Of Control Systems"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 67,
  "title": "Basics of PSV Sizing & Selection",
  "date": "Present",
  "description": [
    "Pressure Safety Valves (PSVs) are critical protective devices in the oil, gas, and process industries, ensuring equipment safety and compliance with international codes. Incorrect sizing or selection can lead to equipment damage, unplanned shutdowns, or catastrophic failures.",
    "This course provides participants with a foundational understanding of PSV functions, selection criteria, and sizing methodologies. It covers relief system fundamentals, overpressure causes, PSV types, operational challenges, and step-by-step sizing procedures according to recognized standards. Through practical examples, participants will gain the skills to ensure reliable, code-compliant PSV installations that safeguard both personnel and assets."
  ],
  "image": "https://i.ibb.co/d0yJL3jZ/Basics-of-PSV-Sizing-Selection.png",
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "Basic understanding of process engineering, mechanical engineering, or plant operations.",
    "Experience in oil, gas, petrochemical, or industrial plant operations is advantageous.",
    "Comfort with basic engineering calculations and reading P&IDs.",
    "No prior PSV sizing experience required"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe the role and function of relief systems in protecting process equipment.",
    "Explain the importance of compliance with codes and standards (API, ASME).",
    "Identify common PSV designs and their appropriate service conditions.",
    "Understand typical causes of overpressure and their impact on system design.",
    "Recognize common PSV problems such as chattering, leakage, and excessive inlet pressure drop.",
    "Follow step-by-step sizing procedures for liquid and vapor service.",
    "Perform inlet and outlet pressure drop checks.",
    "Distinguish between critical and subcritical flow and apply appropriate sizing equations.",
    "Apply API/ASME sizing equations to determine required PSV orifice areas.",
    "Select suitable PSV type, material, and set pressure for given process conditions."
  ],
  "outline": [
    "Module 1: Relief System Overview",
    "Module 2: Pressure Management in Vessel Systems",
    "Module 3: Common types of PSVs",
    "Module 4: Overpressure scenarios",
    "Module 5: Problems in PSVs operation",
    "Module 6: Addressing excessive inlet ΔP",
    "Module 7: Steps for sizing",
    "Module 8: Check for vapor flow regime",
    "Module 9: Sizing Equations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦50,000 / $40",
  "certification": "Certificate of Completion"
},

{
  "id": 68,
  "title": "Boiler Sizing",
  "date": "Present",
  "description": [
    "Boiler sizing is a critical engineering task to ensure safe, efficient, and reliable steam generation for industrial and power applications. This course provides a comprehensive, step-by-step approach to determining key boiler design and operational parameters, from fuel consumption to steam piping and insulation requirements.",
    "Participants will learn practical calculation methods for coal and water consumption, flue gas generation, chimney dimensions, fan capacities, feedwater pump requirements, safety valve sizing, blowdown rates, and steam distribution systems. The course incorporates relevant standards such as IS 6533, IBR, and ASME to ensure compliance and industry best practices. By the end, participants will be equipped to perform accurate boiler sizing calculations for new installations or performance optimization of existing systems."
  ],
  "image": "https://i.ibb.co/R80x9Vn/Boiler-Sizing.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of thermodynamics, heat transfer, and fluid mechanics.",
    "Exposure to boiler operation, steam systems, or power plant engineering is beneficial.",
    "Ability to perform engineering calculations and interpret technical drawings.",
    "No prior boiler sizing experience required"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Determine coal consumption based on boiler load and efficiency.",
    "Estimate water consumption for steam generation processes.",
    "Calculate flue gas generation rates.",
    "Determine chimney height and diameter as per IS 6533 Part 2.",
    "Size outlet (flue gas) ducts for optimal flow.",
    "Calculate bag filter capacity for particulate control.",
    "Calculate ID (Induced Draft) and FD (Forced Draft) fan capacities to maintain proper combustion air and flue gas flow.",
    "Calculate feedwater pump capacity requirements.",
    "Size safety valves as per IBR and ASME requirements for safe operation.",
    "Determine blowdown rates to control dissolved solids and prevent scaling.",
    "Calculate steam pipe sizes, pressure drops, and select suitable insulation types and thicknesses.",
    "Apply relevant engineering codes and standards to ensure safety, efficiency, and compliance."
  ],
  "outline": [
    "Module 1: Coal Consumption Calculation",
    "Module 2: Water Consumption",
    "Module 3: Flue Gas Generation",
    "Module 4: Chimney Height Calculation (As Per IS 6533 Part 2)",
    "Module 5: Chimney Diameter Calculation",
    "Module 6: Outlet Duct Size (Flue Gas Duct)",
    "Module 7: Bag Filter Capacity",
    "Module 8: ID Fan Capacity",
    "Module 9: FD Fan Capacity",
    "Module 10: Feed Water Pump Capacity Calculation",
    "Module 11: Safety Valve Sizing (As Per IBR / ASME)",
    "Module 12: Boiler Blowdown",
    "Module 13: Calculate Steam Pipe Size",
    "Module 14: Estimate Pressure Drop in Pipe",
    "Module 15: Steam Pipe Insulation Type Selection And Thickness Calculation"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 69,
  "title": "Front End Engineering Design of Oil and Gas Projects",
  "date": "Present",
  "description": [
    "Front End Engineering Design (FEED) is a critical phase in the oil and gas project lifecycle, bridging the gap between conceptual development and detailed engineering. High-quality FEED ensures accurate cost estimation, reduced execution risks, and alignment with project objectives.",
    "This course provides a structured understanding of the FEED process within the overall project framework, from project identification and feasibility studies to definition, construction planning, and quality assurance. Participants will explore the decision-making process in gated project systems, learn how to prepare and assess statements of requirements, and identify overarching technical, commercial, and regulatory considerations. Real-world case studies and lessons learned will highlight best practices and common pitfalls in FEED for oil and gas developments."
  ],
  "image": "https://i.ibb.co/YTYrPTp2/FEED-of-Oil-and-Gas-Project.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic understanding of engineering principles, preferably in petroleum, mechanical, civil, or chemical engineering.",
    "Experience in oil and gas operations, project management, or engineering design is beneficial.",
    "Ability to interpret technical documentation such as PFDs, P&IDs, and project specifications."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe the stages of oil and gas project development from concept to decommissioning.",
    "Explain the role of gated decision processes in risk and cost control.",
    "Outline methods for project identification and initial screening.",
    "Recognize the importance of early stakeholder engagement.",
    "Develop and evaluate feasibility reports.",
    "Translate business needs into clear technical requirements for FEED.",
    "Explain the scope, deliverables, and activities involved in FEED.",
    "Ensure FEED aligns with budget, schedule, and quality expectations.",
    "Integrate construction considerations into FEED deliverables.",
    "Understand interfaces between FEED and detailed engineering/construction teams.",
    "Apply criteria and metrics to assess FEED completeness and accuracy.",
    "Recognize the impact of FEED quality on EPC execution and cost certainty.",
    "Identify cross-cutting concerns such as HSE, regulatory compliance, project risk, and technology selection.",
    "Analyze real-world oil and gas FEED projects to identify success factors and avoid common pitfalls."
  ],
  "outline": [
    "Module 1: Project Framework: Lifecycle and Gate system",
    "Module 2: Identification",
    "Module 3: Feasibility and Statement of requirement",
    "Module 4: Project Definition / Front End Engineering Design",
    "Module 5: Construction",
    "Module 6: Quality of FEED",
    "Module 7: Overarching Issues",
    "Module 8: Case Studies and Lessons"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦130,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 70,
  "title": "How to Prepare a Process Design Basis",
  "date": "Present",
  "description": [
    "A Process Design Basis (PDB) is the foundational document that defines the technical, operational, environmental, and commercial requirements for a process plant. It sets the framework for all subsequent design, procurement, and construction activities, ensuring alignment between the owner, engineering team, and contractors.",
    "This course offers a comprehensive guide to developing a robust Process Design Basis, covering every key element from defining the plant’s objectives and feed/product specifications to environmental, safety, and operational philosophies. Participants will learn how to integrate process technology selection, control strategies, project execution expectations, and communication protocols into a single cohesive document.",
    "Through real-world case studies, attendees will gain insight into managing stakeholder expectations, coordinating multidisciplinary inputs, and ensuring the design basis meets both regulatory and business objectives. By the end, participants will have the skills to create a PDB that minimizes design changes, reduces project risk, and supports efficient project execution."
  ],
  "image": "https://i.ibb.co/4qgkn2L/How-to-Prepare-a-Process-Design-Basis.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Degree or diploma in chemical, mechanical, process, or petroleum engineering (or relevant industrial experience).",
    "Familiarity with basic process engineering concepts, plant operations, and project execution phases.",
    "Ability to read PFDs, P&IDs, and basic engineering documentation.",
    "Prior experience in FEED or EPC projects is an advantage but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain how a PDB fits into the overall project lifecycle and why it is critical to project success.",
    "Accurately describe plant purpose, feedstock characteristics, and product specifications.",
    "Identify process options and justify the chosen technology based on technical, economic, and operational factors.",
    "Develop a process control philosophy that aligns with plant safety, reliability, and efficiency goals.",
    "Translate project management strategies and contractual obligations into design requirements.",
    "Identify all documents, drawings, and reports that must be produced during the design phase.",
    "Establish protocols for data sharing, approvals, and coordination between parties.",
    "Integrate client/vendor preferences while ensuring technical compliance.",
    "Assess environmental conditions, infrastructure availability, and brownfield compatibility.",
    "Incorporate industry codes, permits, and standards into the PDB.",
    "Define the long-term plant operation and maintenance philosophy.",
    "Document working capital considerations, economic criteria, and project execution expectations.",
    "Include systems for physical security, cybersecurity, and plant-wide communication.",
    "Analyze real project examples to identify best practices and avoid common pitfalls."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Overall plant objective",
    "Module 3: Plant Feed & Products",
    "Module 4: Process technology",
    "Module 5: Process control philosophy",
    "Module 6: Management of the project",
    "Module 7: Project contract",
    "Module 8: Process design deliverables",
    "Module 9: How information will flow between the parties during the project",
    "Module 10: Preferred vendors",
    "Module 11: Conduct of the process design engineers",
    "Module 12: Nature of the plantsite",
    "Module 13: Economic criteria",
    "Module 14: Offsite facilities and infrastructure requirements",
    "Module 15: Brownfield-site compatibility",
    "Module 16: Environmental, safety and vessel and structural-design standards, permits and requirements",
    "Module 17: Plant operation and maintenance philosophy",
    "Module 18: Owner’s wishes regarding working capital",
    "Module 19: Communication system for the completed plant",
    "Module 20: Security of the project, and of the completed plant",
    "Module 21: Project execution expectations",
    "Module 22: Case Studies"
  ],
  "assessment": "Online Written Exam / AutoCAD Design Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 71,
  "title": "Hydrogen Pipeline System: Design, Construction, and Operation",
  "date": "Present",
  "description": [
    "Hydrogen is increasingly recognized as a clean energy carrier for the future, but its unique physical and chemical properties demand specialized considerations for safe and efficient transport through pipelines. This course provides a comprehensive understanding of the design, construction, operation, and maintenance of hydrogen pipeline systems in industrial and energy applications.",
    "Covering key elements from design philosophy and material selection to cleaning, construction, and operational safety measures, the course addresses the challenges of hydrogen embrittlement, leakage prevention, and high-purity requirements. Participants will explore applicable codes, standards, and best practices, along with lessons learned from real-world projects.",
    "By the end of the program, attendees will be equipped with the knowledge to plan, specify, and manage hydrogen pipeline projects that meet both technical and safety requirements while optimizing long-term reliability."
  ],
  "image": "https://i.ibb.co/3yLbg3tX/Hydrogen-Pipeline-System.png",
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "Degree or diploma in mechanical, chemical, process, petroleum, or pipeline engineering.",
    "Familiarity with pipeline design principles, material selection, and basic fluid mechanics.",
    "Ability to interpret P&IDs, pipeline alignment sheets, and engineering specifications.",
    "Prior exposure to gas transmission/distribution projects is beneficial but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain hydrogen’s properties, risks, and implications for pipeline transportation.",
    "Establish technical, operational, and safety objectives at the planning stage.",
    "Interpret industry terminology, applicable codes, and compliance requirements.",
    "Integrate safety, reliability, operability, and maintainability into hydrogen pipeline design.",
    "Choose components resistant to hydrogen embrittlement, leakage, and corrosion.",
    "Ensure purity and readiness for hydrogen service using best-practice cleaning methods.",
    "Apply safe construction practices for welding, coating, and laying hydrogen pipelines.",
    "Specify requirements for compressor stations, metering stations, and valve stations.",
    "Implement inspection, monitoring, and leak detection systems for ongoing safety.",
    "Incorporate cathodic protection, overpressure protection, and emergency shutdown systems."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Scope and purpose",
    "Module 3: Definitions",
    "Module 4: Design philosophy",
    "Module 5: Piping, valves and equipment.",
    "Module 6: Cleaning",
    "Module 7: Construction",
    "Module 8: Design and construction of stations",
    "Module 9: Operation and monitoring",
    "Module 10: General protective measures"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 72,
  "title": "Oil and Gas Facility Project",
  "date": "Present",
  "description": [
    "The development of oil and gas facilities requires the integration of multiple engineering disciplines, rigorous project planning, and adherence to safety, environmental, and operational requirements. From conceptual design to commissioning and revamping, facility projects must balance technical, economic, and regulatory considerations.",
    "This course provides participants with a comprehensive understanding of how oil and gas facility projects are conceived, designed, executed, and managed. Covering project engineering, design basis, process engineering, equipment, layout, safety, civil, piping, instrumentation, electrical, offshore considerations, and project management, the program offers both technical and managerial perspectives. Participants will also explore the phases of project execution—including Basic, FEED, and Detailed Design—while understanding how to align engineering deliverables with project schedules, cost, and operational goals.",
    "By the end of this course, participants will be equipped to contribute effectively to facility projects in both onshore and offshore environments."
  ],
  "image": "https://i.ibb.co/dwqPCLZ9/Oil-and-Gas-Facility-Project.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "Degree or diploma in mechanical, chemical, petroleum, civil, electrical, instrumentation, or related engineering disciplines.",
    "Prior exposure to oil and gas industry operations, projects, or engineering practices is beneficial but not mandatory.",
    "Basic understanding of process plant equipment, safety principles, and project execution methodologies."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of project engineering in oil and gas facility development.",
    "Describe the importance of design basis and its impact on project success.",
    "Demonstrate knowledge of process, mechanical, civil, piping, electrical, instrumentation, and offshore engineering considerations in facility design.",
    "Recognize the role of plant layout, materials, and corrosion protection in ensuring safe and efficient operations.",
    "Identify environmental and safety factors that influence project design and execution.",
    "Apply best practices for hazard mitigation, regulatory compliance, and sustainable facility design.",
    "Differentiate between Basic Engineering, FEED, and Detailed Design phases.",
    "Align engineering deliverables with project schedules and milestones.",
    "Understand the application of plant modeling in optimizing design and construction.",
    "Apply digital workflows for efficient multidisciplinary collaboration.",
    "Apply principles of engineering management and field engineering.",
    "Manage changes, revamping projects, and brownfield modifications.",
    "Balance scope, cost, schedule, and quality in facility projects.",
    "Understand the overall work process in facility project execution.",
    "Improve communication and integration among engineering teams, contractors, and stakeholders."
  ],
  "outline": [
    "Module 1: Project Engineering",
    "Module 2: The design basis",
    "Module 3: Process",
    "Module 4: Equipment/Mechanical",
    "Module 5: Plant Layout",
    "Module 6: Safety & Environment",
    "Module 7: Civil Engineering",
    "Module 8: Materials & Corrosion",
    "Module 9: Piping",
    "Module 10: Plant model",
    "Module 11: Instrumentation & Control",
    "Module 12: Electrical",
    "Module 13: Offshore",
    "Module 14: The overall work process",
    "Module 15: BASIC, FEED and Detail Design",
    "Module 16: Matching the Project Schedule",
    "Module 17: Engineering Management",
    "Module 18: Field Engineering",
    "Module 19: Revamping"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 73,
  "title": "Principles of Water and Wastewater Treatment Processes",
  "date": "Present",
  "description": [
    "The sustainable management of water resources is one of the most pressing challenges faced by industries and municipalities today. This course provides participants with a comprehensive understanding of the fundamental principles, technologies, and applications involved in modern water and wastewater treatment.",
    "The program covers water quality fundamentals, flowsheeting techniques, and the major treatment processes, including physical, chemical, sorption, biological, and membrane-based systems. It also addresses sludge treatment, odor management, and resource recovery—critical elements for achieving regulatory compliance, environmental protection, and sustainable operations.",
    "By combining theory with practical engineering applications, participants will gain the skills required to design, evaluate, and optimize treatment systems for industrial, municipal, and utility-scale water and wastewater facilities."
  ],
  "image": "https://i.ibb.co/Hf2LNNK7/Principles-of-Water-and-Wastewater-Treatment-Processes.png",
  "tags": [],
  "category": "process",
  "duration": "4 Days",
  "prerequisite": [
    "Basic knowledge of chemistry, biology, and physics.",
    "Familiarity with engineering processes or environmental systems.",
    "Background in civil, chemical, mechanical, or environmental engineering is beneficial.",
    "No prior specialized training in water treatment is required."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain key water quality parameters and their significance for treatment design.",
    "Interpret regulatory frameworks and compliance requirements.",
    "Develop and analyze flowsheets for water and wastewater treatment systems.",
    "Identify optimal process sequences for specific applications.",
    "Physical: Sedimentation, screening, filtration, aeration.",
    "Chemical: Coagulation, disinfection, advanced oxidation processes.",
    "Sorption: Activated carbon and ion-exchange applications.",
    "Biological: Aerobic and anaerobic processes, activated sludge, biofilm systems.",
    "Membrane: Reverse osmosis, ultrafiltration, nanofiltration, membrane bioreactors.",
    "Analyze sludge treatment methods and resource utilization options.",
    "Explore energy recovery and biosolids applications.",
    "Identify common odor sources and apply mitigation strategies.",
    "Integrate odor management into overall plant operation.",
    "Select suitable processes based on influent characteristics and effluent standards.",
    "Troubleshoot operational challenges and improve treatment performance.",
    "Incorporate sustainability and circular economy principles into water and wastewater projects."
  ],
  "outline": [
    "Module 1: Water Quality",
    "Module 2: Flowsheeting",
    "Module 3: Physical Processes",
    "Module 4: Chemical Processes",
    "Module 5: Sorption Processes",
    "Module 6: Biological Processes",
    "Module 7: Membrane Processes",
    "Module 8: Sludge Treatment & Utilization",
    "Module 9: Odour management"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 74,
  "title": "PROCESS DESIGN OF HEAT TRACING AND WINTERIZING",
  "date": "Present",
  "description": [
    "Heat tracing and winterization are essential design practices in oil & gas, petrochemical, power, and process industries to ensure the reliability, safety, and efficiency of piping systems, instruments, and equipment exposed to low-temperature environments. This course provides a comprehensive understanding of the principles, applications, and design methods of heat tracing systems (electric and steam) and winterization strategies.",
    "Through practical examples, participants will learn where and why heat tracing is required, conditions that necessitate winterization, applicable codes and standards, and design considerations for ensuring continuous operations in cold climates. The course builds competency in selecting the appropriate method, sizing, installation requirements, and integrating heat tracing into overall process design."
  ],
  "image": "https://i.ibb.co/wNM1fGsz/PROJECT-STANDARDS-AND-SPECIFICATIONS-FOR-HEAT-TRACING-AND-WINTERIZING-SYSTEMS.png",
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "A basic understanding of process engineering and plant operations.",
    "Familiarity with piping and instrumentation (P&IDs, line lists, etc.).",
    "General knowledge of heat transfer and fluid properties is beneficial but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define heat tracing, winterization, and their role in process safety and operability.",
    "Differentiate between electric, steam, and other heat tracing methods.",
    "Determine equipment, piping, and instruments that require heat tracing.",
    "Select suitable methods based on process conditions, cost, and safety considerations.",
    "Analyze plant areas and process streams vulnerable to freezing or viscosity increase.",
    "Apply design strategies to mitigate risks in cold environments.",
    "Interpret industry codes, standards, and company specifications for heat tracing.",
    "Define operational, maintenance, and reliability requirements.",
    "Develop a step-by-step approach for heat tracing and winterization design.",
    "Perform design calculations (heat loss, line sizing, and energy requirements).",
    "Integrate heat tracing systems into plant layout, instrumentation, and utilities."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Application & Methods",
    "Module 3: Conditions Requiring Winterization",
    "Module 4: Requirements",
    "Module 5: Design"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦80,000 / $60",
  "certification": "Certificate of Completion"
},

{
  "id": 75,
  "title": "Process Simulation of Multistage Compressor Process and Separator Sizing and Overpressure Study in Oil and Gas",
  "date": "Present",
  "description": [
    "This course provides a practical and technical understanding of how to simulate, analyze, and design critical equipment and safety systems in oil & gas facilities. It focuses on the process simulation of multistage compressors, generation of heat and material balances (HMB), separator sizing, and overpressure protection studies through pressure safety valve (PSV) sizing.",
    "Participants will gain hands-on experience in simulating multistage compressor processes, developing reliable HMBs for design and optimization, applying sizing methodologies for gas-liquid separators, and conducting overpressure protection studies for both blocked outlet and fire scenarios.",
    "The course equips engineers with the skills needed to ensure process safety, equipment reliability, and compliance with international design standards in oil & gas projects."
  ],
  "image": "https://i.ibb.co/ksCj268n/Process-Simulation-of-multistage-compressor-process-Separator-Sizing-Overpressure-Study-in-Oil-Gas.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of thermodynamics, fluid mechanics, and heat transfer.",
    "Familiarity with process design documents (PFDs, P&IDs, line lists).",
    "Working knowledge of oil & gas process operations (compression, separation, and safety systems).",
    "Prior exposure to process simulation software (e.g., Aspen HYSYS, DWSIM, PRO/II)."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the fundamentals of gas compression and intercooling.",
    "Perform multistage compressor simulations using process simulation tools.",
    "Analyze compressor performance parameters (power, efficiency, discharge temperatures, etc.).",
    "Develop reliable HMBs for compressor and separation systems.",
    "Use HMBs as a basis for equipment design and plant optimization.",
    "Validate HMB data against process simulation outputs.",
    "Apply design principles for gas-liquid separation.",
    "Size horizontal and vertical separators based on process requirements.",
    "Evaluate performance under normal and upset conditions.",
    "Identify overpressure scenarios (blocked outlet, fire, and thermal expansion).",
    "Perform PSV sizing calculations in compliance with API 520/521 standards.",
    "Ensure adequate relief system design for safe plant operations."
  ],
  "outline": [
    "Module 1: Process Simulation of multistage compressor process",
    "Module 2: Generate HMB",
    "Module 3: Separator Sizing",
    "Module 4: PSV Sizing (Blocked outlet and Fire Scenario)"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 76,
  "title": "Reading Schematics and Symbols",
  "date": "Present",
  "description": [
    "This course provides participants with the essential knowledge and skills to read, interpret, and apply engineering schematics and symbols used in piping systems. The training covers the fundamentals of piping design, fittings, flanges, valves, welding, and isometric piping drawings. Special emphasis is placed on understanding piping and welding symbols, enabling participants to correctly interpret technical drawings, communicate effectively with engineers and fabricators, and ensure proper installation and maintenance of piping systems.",
    "By completing this course, participants will gain confidence in reading drawings, identifying components, and applying international standards in oil & gas, power, and process industries."
  ],
  "image": "https://i.ibb.co/gZsvHFHQ/Reading-Schematics-and-Symbols.png",
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "Basic knowledge of engineering principles (mechanical or process).",
    "Familiarity with piping systems and plant operations (advantageous but not mandatory).",
    "No prior drafting experience is required, but participants should have an interest in technical drawings and symbols."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Recognize basic piping layouts, materials, and flow paths.",
    "Identify different types of pipe fittings, flanges, and valves.",
    "Read and apply standard piping symbols on engineering drawings.",
    "Understand welding symbols, their meanings, and application in fabrication.",
    "Develop skills to read orthographic and isometric piping drawings.",
    "Translate drawings into physical piping layouts.",
    "Differentiate between schematic and fabrication drawings.",
    "Use company, national, and international standards for schematics and symbols.",
    "Ensure correct interpretation for safe and efficient installation.",
    "Improve collaboration with engineers, fabricators, and construction teams through accurate interpretation of drawings.",
    "Reduce errors caused by misinterpretation of schematics and symbols."
  ],
  "outline": [
    "Module 1: Piping Fundamental",
    "Module 2: Pipe Fittings",
    "Module 3: Flanges",
    "Module 4: Valves",
    "Module 5: Piping symbols",
    "Module 6: Isometric Piping",
    "Module 7: Welding symbols",
    "Module 8: Drawings basics"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦60,000 / $50",
  "certification": "Certificate of Completion"
},

{
  "id": 77,
  "title": "Sulfur Recovery Unit - Claus Process with 2 Reactors",
  "date": "Present",
  "description": [
    "Sulfur recovery is a critical process in the oil and gas, petrochemical, and refinery industries for both environmental compliance and resource utilization. The Claus process is the most widely used technology for converting hydrogen sulfide (H₂S)-rich gases into elemental sulfur, thereby minimizing SO₂ emissions and ensuring regulatory compliance.",
    "This course provides participants with in-depth knowledge of the Claus Process with 2 catalytic reactors and practical training on how to simulate, analyze, and optimize the process using Aspen HYSYS. Learners will develop skills in process modeling, reactor configuration, material balance, and performance evaluation to ensure efficient sulfur recovery."
  ],
  "image": "https://i.ibb.co/SwvsWjBd/Simulation-of-Sulfur-Recovery-Unit-with-Tail-Gas-Treatment-using-Sulsim.png",
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "Basic knowledge of chemical/process engineering principles.",
    "Familiarity with process simulation software (preferably Aspen HYSYS).",
    "Understanding of refinery operations, particularly gas treating and acid gas removal (recommended).",
    "Fundamental knowledge of chemical reactions, mass balance, and thermodynamics."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of SRU in oil & gas operations – explain why sulfur recovery is critical for environmental compliance and process economics.",
    "Describe Claus process chemistry and reactor stages – differentiate between thermal and catalytic stages, and their functions.",
    "Identify major SRU equipment – explain the function of furnaces, reactors, condensers, and tail gas treatment units.",
    "Simulate Claus process in Aspen HYSYS – set up a process model with 2 reactors and generate heat & material balances.",
    "Evaluate process efficiency – calculate sulfur recovery percentage and identify bottlenecks.",
    "Optimize operating conditions – use HYSYS sensitivity analysis to improve SRU performance.",
    "Apply troubleshooting techniques – recognize deviations in sulfur recovery and recommend corrective measures."
  ],
  "outline": [
    "Module 1: Introduction to Sulfur Recovery",
    "Module 2: Claus Process Fundamentals",
    "Module 3: Process Flow and Equipment",
    "Module 4: Simulation Setup in Aspen HYSYS",
    "Module 5: Modeling Claus Process with 2 Reactors",
    "Module 6: Generating Heat & Material Balance (HMB)",
    "Module 7: Optimization & Sensitivity Analysis",
    "Module 8: Case Study & Hands-On Simulation"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 78,
  "title": "Sustainable Process Engineering Part A",
  "date": "Present",
  "description": [
    "This course introduces the foundational principles and practical approaches of Sustainable Process Engineering, focusing on integrating sustainability into process industries. It is designed to help engineers and professionals in the chemical, energy, manufacturing, and related sectors understand how to assess, design, and implement processes that are environmentally responsible, economically viable, and socially beneficial.",
    "Through a step-by-step exploration of core concepts, sustainability strategies, evaluation tools, and implementation practices, the course provides a structured pathway toward achieving sustainable development goals (SDGs) within engineering operations."
  ],
  "image": "https://i.ibb.co/F48ddHCj/Sustainable-Process-Engineering-Part-A.png",
  "tags": [],
  "category": "process",
  "duration": "1 Day",
  "prerequisite": [
    "A basic understanding of process engineering, chemical engineering, or industrial systems.",
    "Familiarity with engineering design principles and process analysis tools.",
    "Awareness of environmental and energy issues in industrial contexts is beneficial but not mandatory.",
    "Open to professionals, graduate students, and technical personnel involved in process design, operations, or sustainability planning."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define the key concepts and principles of sustainable process engineering.",
    "Understand the drivers of sustainability and how they apply to process industries.",
    "Identify and apply strategies for reducing environmental impact, enhancing efficiency, and promoting circular economy models.",
    "Use various evaluation techniques (e.g., life cycle assessment, carbon footprinting, and sustainability indicators) to assess process sustainability.",
    "Develop approaches for the implementation of sustainable practices in real-world industrial settings.",
    "Lay the groundwork for advanced study or application in Part B of the Sustainable Process Engineering series."
  ],
  "outline": [
    "Module 1: Concepts",
    "Module 2: Strategies",
    "Module 3: Evaluation",
    "Module 4: Implementation"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "FREE",
  "certification": "Certificate of Completion"
},

{
  "id": 79,
  "title": "Sustainable Process Engineering Part B (Concepts)",
  "date": "Present",
  "description": [
    "Building on the foundational knowledge established in Part A, Sustainable Process Engineering – Part B explores advanced topics in sustainable development within the context of engineering and industrial processes. This course focuses on three critical pillars: sustainability concepts, cleaner production, and industrial ecology, offering participants practical tools and frameworks to drive sustainable innovation across the value chain.",
    "Emphasizing systems thinking, resource optimization, and environmental integration, this course equips professionals to reimagine processes, minimize waste, and close material loops — ultimately contributing to resilient, low-impact industrial operations."
  ],
  "image": "https://i.ibb.co/V0tK20KX/Sustainable-Process-Engineering-Part-B.png",
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "Completed Sustainable Process Engineering – Part A, or possess equivalent foundational knowledge.",
    "A working understanding of process engineering, environmental impact, or sustainability in industry."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Deepen their understanding of advanced sustainability concepts and their application in complex engineering systems.",
    "Apply the principles of cleaner production to identify and implement waste reduction, energy efficiency, and pollution prevention strategies.",
    "Understand and utilize the framework of industrial ecology to develop closed-loop systems that mimic natural ecosystems.",
    "Integrate systems-level thinking into the design and management of sustainable processes and supply chains.",
    "Evaluate the long-term environmental and economic impacts of engineering decisions within the broader context of sustainable development.",
    "Support organizations in transitioning to more sustainable and circular industrial models."
  ],
  "outline": [
    "Module 1: Sustainability Concepts",
    "Module 2: Cleaner Production",
    "Module 3: Industrial Ecology"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦60,000 / $50",
  "certification": "Certificate of Completion"
},

{
  "id": 80,
  "title": "Sustainable Process Engineering Part C (Strategies)",
  "date": "Present",
  "description": [
    "Sustainable Process Engineering – Part C: Strategies focuses on the practical application of sustainability principles in process industries, with a strong emphasis on waste minimization and resource efficiency. This course addresses how to systematically identify, reduce, and recover waste and energy losses across various stages of chemical and industrial operations — including reactors, separation units, utility systems, and overall plant operations.",
    "Participants will explore engineering strategies to optimize material use, conserve energy, and enhance circularity, all while improving environmental performance and operational economics. The course is ideal for professionals seeking actionable methods to implement sustainability in their day-to-day processes and plant operations."
  ],
  "image": "https://i.ibb.co/vxbZMHKH/Sustainable-Process-Engineering-Part-C.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Completed Sustainable Process Engineering – Part A and Part B, or have a working knowledge of sustainable engineering concepts.",
    "A solid background in chemical/process engineering, including basic knowledge of reactors, separation processes, and utility systems.",
    "Familiarity with process operations, mass/energy balances, and general plant systems is recommended."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand and apply strategies for waste minimization in chemical reactors, including process optimization and reaction efficiency improvements.",
    "Identify sources of waste in separation processes (e.g., distillation, extraction) and implement strategies to reduce material and energy losses.",
    "Analyze utility systems to pinpoint inefficiencies and recommend improvements in water, steam, compressed air, and other services.",
    "Develop and implement energy conservation techniques across various process units to reduce environmental footprint and cost.",
    "Explore methods for materials recycling and reuse, promoting circular economy practices within process plants.",
    "Apply a systematic approach to waste minimization in operations, integrating sustainability into standard operating procedures and decision-making."
  ],
  "outline": [
    "Module 1: Waste Minimization in Reactors",
    "Module 2: Waste Minimization in Separation Processes",
    "Module 3: Identification of Waste in Utility Systems",
    "Module 4: Energy Conservation",
    "Module 5: Materials Recycling",
    "Module 6: Waste Minimization in Operations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 81,
  "title": "Sustainable Process Engineering Part D (Evaluation)",
  "date": "Present",
  "description": [
    "Sustainable Process Engineering – Part D: Evaluation provides participants with the essential tools and methodologies to quantitatively and qualitatively evaluate the sustainability of engineering processes. This course focuses on the assessment phase of sustainable design and operation, teaching participants how to conduct Life Cycle Assessments (LCA), safety evaluations, and economic and environmental assessments.",
    "Through a mix of theoretical grounding and practical case studies, learners will be equipped to make informed decisions that balance environmental impact, safety, and cost-efficiency. This course is critical for professionals aiming to integrate robust sustainability evaluation frameworks into process design, optimization, and operational strategies."
  ],
  "image": "https://i.ibb.co/1YSbKQ4R/Sustainable-Process-Engineering-Part-D.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Completed Sustainable Process Engineering – Parts A, B, and C, or have equivalent knowledge of sustainable design strategies and process operations.",
    "A sound understanding of process engineering principles, including material/energy balances and plant operations.",
    "Familiarity with basic sustainability concepts, cost analysis, and safety considerations in industrial systems."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles and methodology of Life Cycle Assessment (LCA) and how it applies to process engineering.",
    "Interpret and analyze LCA case studies to evaluate real-world applications and outcomes.",
    "Perform safety evaluations within the sustainability context, integrating risk assessment and prevention strategies.",
    "Conduct economic assessments to evaluate the cost-effectiveness and financial feasibility of sustainable process alternatives.",
    "Apply holistic sustainability assessment frameworks to guide decision-making in design, investment, and operational planning.",
    "Integrate environmental, safety, and economic evaluation tools to support sustainable innovation in industrial processes."
  ],
  "outline": [
    "Module 1: Life Cycle Assessment",
    "Module 2: Life Cycle Assessment Case Studies",
    "Module 3: Safety Evaluation",
    "Module 4: Assessment of Costs and Economics",
    "Module 5: Sustainability Assessment"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 82,
  "title": "Sustainable Process Engineering Part E (Implementation)",
  "date": "Present",
  "description": [
    "Sustainable Process Engineering – Part E: Implementation is the final part of the Sustainable Process Engineering series, focusing on the practical implementation of sustainability strategies within industrial settings. This course bridges the gap between theory and execution by addressing how to plan, design, and manage operations to embed sustainability into the core of process industries.",
    "Participants will learn how to integrate sustainability principles into process planning, project development, and operational management, enabling them to drive organizational change and support long-term sustainable performance. Emphasis is placed on aligning engineering decisions with business strategy, regulatory compliance, and sustainability targets."
  ],
  "image": "https://i.ibb.co/qMdj807w/Sustainable-Process-Engineering-Part-E.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Completed Sustainable Process Engineering – Parts A through D, or possess a comprehensive understanding of sustainability principles, evaluation tools, and process engineering.",
    "Background knowledge in process design, project management, and industrial operations.",
    "Experience or familiarity with engineering projects or operations is advantageous."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Develop strategic plans for implementing sustainability within process industries, considering organizational goals and environmental regulations.",
    "Integrate sustainability into process design and project development, from concept to execution, using structured methodologies and best practices.",
    "Apply operations management principles to ensure ongoing sustainable performance, including monitoring, continuous improvement, and stakeholder engagement.",
    "Align technical solutions with corporate sustainability goals, including carbon reduction, resource efficiency, and circular economy practices.",
    "Lead or contribute to multidisciplinary teams working on sustainable engineering initiatives and industrial transformation projects.",
    "Translate sustainability assessments and strategies into real-world actions and measurable results."
  ],
  "outline": [
    "Module 1: Planning for Sustainable Process Industries",
    "Module 2: Process Design and Project Development",
    "Module 3: Operations Management"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 83,
  "title": "Piping Joints",
  "date": "Present",
  "description": [
    "Piping joints are critical to the integrity, safety, and efficiency of any industrial piping system. This course provides participants with a comprehensive understanding of the different types of piping joints, their standards, design considerations, and practical applications in oil & gas, petrochemical, power, and process industries.",
    "The program covers flanges, gaskets, bolting, screwed connections, compression fittings, and elastomeric O-ring seals, as well as specialized practices like compound flanged joints and spading/blanking. Emphasis will be placed on company and national standards, ensuring compliance with industry codes while balancing reliability, safety, and cost-effectiveness.",
    "Through case-based examples, learners will gain the skills required to select, assemble, and maintain piping joints to minimize leaks, improve performance, and extend the operational life of piping systems."
  ],
  "image": "https://i.ibb.co/vCHY7YF1/Piping-Joints.jpg",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of piping systems and components (pipes, valves, fittings).",
    "Familiarity with engineering drawings such as P&IDs and isometrics.",
    "Awareness of materials of construction (MOC) and corrosion principles is helpful.",
    "No prior specialized piping joint training is required (course is beginner-to-intermediate level)."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Interpret company-specific and national standards governing piping joints.",
    "Apply best practices to ensure regulatory and safety compliance.",
    "Describe different flange types, their applications, and limitations.",
    "Select appropriate gaskets based on pressure, temperature, and fluid properties.",
    "Explain compound flanged joints and their industrial applications.",
    "Apply correct bolting practices for flanges and covers to ensure leak-free joints.",
    "Understand torque, preload, and tightening sequence requirements.",
    "Perform spading and blanking of flanges safely during isolation or maintenance.",
    "Identify proper use of screwed piping joints and compression fittings.",
    "Evaluate the suitability of elastomeric O-ring seals for specific applications.",
    "Select jointing methods based on process conditions (pressure, temperature, corrosive service).",
    "Diagnose common joint failures (leakage, gasket blowout, bolt loosening) and recommend solutions.",
    "Incorporate lessons learned into safe and reliable piping joint design."
  ],
  "outline": [
    "Module 1: Company & National Standards",
    "Module 2: Flanges",
    "Module 3: Gasket",
    "Module 4: Compound Flanged Joints",
    "Module 5: Bolting for Flanges and Covers",
    "Module 6: Spading and Blanking of Flanges",
    "Module 7: Screwed Piping Joints",
    "Module 8: Compression Fittings",
    "Module 9: Elastomeric O-Ring Seals"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 84,
  "title": "Badger Cumene Technology Course",
  "date": "Present",
  "description": [
    "Cumene (isopropylbenzene) is a critical intermediate in the petrochemical industry, primarily used for the production of phenol and acetone. The Badger Cumene Technology is a leading industrial process recognized for its efficiency, reliability, and use of modern zeolite catalysts.",
    "This course provides participants with a comprehensive understanding of the cumene process, from fundamental chemistry to industrial-scale applications. It covers physical properties, process chemistry, catalyst technology, and process design, with a strong focus on simulation and performance evaluation using leading software tools such as HYSYS, DWSIM, ProMax, and Honeywell UniSim.",
    "Participants will develop the skills required to understand process flow, troubleshoot operations, optimize performance, and evaluate catalyst life and contamination issues. By the end of the course, learners will gain a solid foundation in both the theoretical and practical aspects of Badger Cumene Technology."
  ],
  "image": require("./coursesImg/Badger cumene technology.jpg"),
  "tags": [],
  "category": "PC",
  "duration": "3 Days",
  "prerequisite": [
    "This course is intended for:\n· Process, chemical, and petrochemical engineers.\n· Plant operation and technical service engineers working in cumene, phenol, or acetone plants.\n· Researchers and students specializing in petrochemicals and industrial catalysis.\nParticipants should have:\n· A background in organic chemistry, reaction engineering, and process design.\n· Basic knowledge of simulation tools (HYSYS, DWSIM, ProMax, or UniSim) is recommended but not mandatory."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the role of cumene in the petrochemical value chain and its industrial applications.",
    "Recall and apply the physical and chemical properties of cumene in process design and operation.",
    "Explain the reaction chemistry and mechanism underlying cumene synthesis.",
    "Analyze the performance of zeolite catalysts, including activity, selectivity, and sensitivity to contaminants.",
    "Interpret the process flow description of the Badger Cumene Technology, including feed preparation, reactor design, and product recovery.",
    "Simulate the cumene process using software tools (HYSYS, DWSIM, ProMax, UniSim), enabling design, optimization, and sensitivity studies.",
    "Assess performance indicators such as yield, selectivity, conversion, and energy efficiency.",
    "Identify and address common operational challenges related to catalyst contamination, process integration, and system performance.",
    "Apply best practices in process monitoring and troubleshooting for improved reliability and efficiency of cumene plants."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Cumene Uses and Industry.",
    "Module 3: Physical Properties",
    "Module 4: Process Chemistry",
    "Module 5: Catalyst Performance and Contaminations",
    "Module 6: Process Description",
    "Module 7: Process Simulation (Hysys/DWSIM/Promax/Honeywell Unisim, Plus etc)",
    "Module 8: Performance"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 85,
  "title": "Badger Ethylbenzene Technology",
  "date": "Present",
  "description": [
    "Ethylbenzene (EB) is the key raw material for styrene monomer production, which is used in plastics, resins, and synthetic rubbers. The Badger Ethylbenzene Technology, particularly in collaboration with ExxonMobil’s EBMax catalyst, is an industry-leading process known for its high efficiency, low energy consumption, and superior catalyst performance.",
    "This course provides participants with a comprehensive understanding of ethylbenzene production, including feedstock preparation, process chemistry, catalyst behavior, process design, simulation, and optimization techniques. Special emphasis is given to EBMax catalyst performance, process integration, and modern design using chemical-grade ethylene feedstocks.",
    "Through theory and simulation exercises (HYSYS, DWSIM, ProMax, Honeywell UniSim, etc.), participants will gain the technical and practical expertise to design, operate, and optimize Badger Ethylbenzene plants while ensuring high product quality and cost efficiency."
  ],
  "image": require("./coursesImg/Badger ethylbenzene technology.jpg"),
  "tags": [],
  "category": "PC",
  "duration": "3 Days",
  "prerequisite": [
    "This course is designed for:\n· Process and chemical engineers in petrochemical, refining, and styrene industries.\n· Plant operations, technical service, and R&D staff working on ethylbenzene or styrene production.\n· Engineering students or researchers interested in industrial catalysis and petrochemical process design.\nParticipants should have:\n· A solid background in organic chemistry, catalysis, and reaction engineering.\n· Familiarity with heat and mass transfer principles.\n· Basic knowledge of simulation tools (HYSYS, DWSIM, ProMax, UniSim) is beneficial but not mandatory."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the role of ethylbenzene in the petrochemical industry, especially as a precursor to styrene.",
    "Identify suitable feedstocks for ethylbenzene production and their preparation.",
    "Explain the chemistry of ethylbenzene production and the function of the ExxonMobil EBMax catalyst.",
    "Evaluate EBMax catalyst performance, including activity, selectivity, and longevity.",
    "Describe the Badger ethylbenzene process flow, including reactor system, separation units, and energy integration.",
    "Simulate the ethylbenzene process using software tools (HYSYS, DWSIM, ProMax, UniSim) for design and performance analysis.",
    "Apply process design optimization techniques to reduce energy consumption and maximize yield.",
    "Understand the design approach for EBMax plants using chemical-grade ethylene feedstocks.",
    "Assess ethylbenzene product quality parameters and their impact on downstream styrene production.",
    "Estimate raw material, utility, and catalyst requirements for economic evaluations.",
    "Integrate process design, catalyst performance, and operational strategies in EBMax plant design.Learn techniques for effective implementation of change."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Feedstocks for Ethylbenzene Production",
    "Module 3: ExxonMobil EBMax Catalyst",
    "Module 4: Process Chemistry and EBMax Catalyst Performance",
    "Module 5: Process Description",
    "Module 6: Process Simulation Hysys/DWSIM/Promax/Honeywell Unisim, Plus etc)",
    "Module 7: Process Design Optimization",
    "Module 8: EBMax Design Using Chemical-Grade Ethylene Feedstocks",
    "Module 9: Ethylbenzene Product Quality",
    "Module 10: Raw Materials, Utilities and Catalyst Requirements",
    "Module 11: EBMax Plant Design"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 86,
  "title": "Isomalk-3 (n-Butane Isomerization)",
  "date": "Present",
  "description": [
    "The Isomalk-3 technology is a highly advanced process for the isomerization of normal butane (n-butane) into isobutane, a critical feedstock for alkylation units in modern refineries. Isomalk-3 offers exceptional catalyst stability, high activity, and minimal environmental footprint, making it one of the most competitive technologies in paraffin isomerization.",
    "This course provides participants with a detailed understanding of process flow schemes, reaction mechanisms, catalyst regeneration, operating variables, and simulation approaches. Emphasis is given to the impact of contaminants, makeup gas quality, and nitrogen quality on catalyst performance.",
    "The course also highlights the unique advantages of the Isomalk-3 catalyst over conventional isomerization technologies and provides practical insights into the design and operation of Isomalk-3 reactors. Participants will be equipped with both theoretical knowledge and hands-on process simulation skills, enabling them to optimize, troubleshoot, and sustain efficient Isomalk-3 operations."
  ],
  "image": require("./coursesImg/Isomalk-3  (n-Butane isomerization).jpg"),
  "tags": [],
  "category": "PC",
  "duration": "3 Days",
  "prerequisite": [
    "This course is designed for:\n· Process, chemical, and refinery engineers.\n· Plant operations and technical service engineers working in isomerization, alkylation, or catalytic processes.\n· R&D professionals and graduate students specializing in refining and petrochemicals.\nRecommended background:\n· Knowledge of organic chemistry, particularly hydrocarbon reactions.\n· Understanding of catalysis and reaction engineering principles.\n· Familiarity with refinery operations and process simulation tools (Aspen HYSYS, DWSIM, ProMax, Honeywell UniSim)."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Explain the importance of n-butane isomerization and its role in modern refining.",
    "Interpret the process flow scheme of the Isomalk-3 technology.",
    "Describe the reverse isomerization phenomenon and its implications.",
    "Understand the reaction mechanism of the Isomalk-3 process.",
    "Apply knowledge of catalyst regeneration techniques to extend catalyst life and maintain efficiency.",
    "Analyze process variables and simulate isomerization reactions using process modeling tools.",
    "Identify catalyst contaminants and evaluate their effect on Isomalk-3 performance.",
    "Assess the impact of makeup gas quality and nitrogen purity on process reliability.",
    "Compare the advantages of Isomalk-3 catalyst over conventional alternatives.",
    "Understand the design and operation principles of Isomalk-3 reactors.",
    "Apply best practices for process optimization, troubleshooting, and long-term reliability of Isomalk-3 units."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Process Flow Scheme.",
    "Module 3: Reverse Isomerization",
    "Module 4: Reaction Mechanism",
    "Module 5: Catalyst Regeneration",
    "Module 6: Process Variables and Simulation (Hysys/DWSIM/Promax/Honeywell Unisim, Plus etc)",
    "Module 7: Isomalk-3 Catalyst Contaminants Variables",
    "Module 8: Makeup Gas Quality",
    "Module 9: Nitrogen Quality",
    "Module 10: Advantages of Isomalk-3 Catalyst",
    "Module 11: Isomalk-3 Reactors"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 87,
  "title": "Modern Crystallization Technology for Para-Xylene Production",
  "date": "Present",
  "description": [
    "Para-xylene (p-xylene) is a critical petrochemical used in the production of terephthalic acid (PTA) and dimethyl terephthalate (DMT), essential building blocks for polyester fibers, films, and resins. Achieving ultra-high purity para-xylene is crucial for efficient downstream processing and product quality.",
    "This course introduces participants to modern crystallization technologies, focusing on the CrystPX process, a state-of-the-art method for producing high-purity para-xylene. It covers process chemistry, thermodynamics, detailed process description, simulation approaches, product and by-product specifications, and process economics.",
    "By combining theoretical foundations with practical simulation exercises using Aspen HYSYS, DWSIM, ProMax, Honeywell UniSim, and other tools, the course equips participants with the knowledge and skills to design, simulate, optimize, and evaluate crystallization-based para-xylene production processes."
  ],
  "image": require("./coursesImg/Modern crystallization technology for para-xylene production.jpg"),
  "tags": [],
  "category": "PC",
  "duration": "3 Days",
  "prerequisite": [
    "This course is designed for:\n· Process and chemical engineers working in aromatic complexes and petrochemical industries.\n· Plant operations and technical staff involved in aromatics recovery, crystallization, or separation processes.\n· R&D professionals and graduate students focusing on crystallization technology or process design.\nRecommended background:\n· Solid knowledge of organic chemistry and separation processes.\n· Understanding of phase equilibria, heat & mass transfer, and thermodynamics.\n· Familiarity with process simulation software (HYSYS, DWSIM, ProMax, UniSim) is beneficial."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the importance of para-xylene and purity requirements in the petrochemical value chain.",
    "Explain the fundamentals of modern crystallization technology for para-xylene production.",
    "Describe the CrystPX process and its role in achieving high-purity para-xylene.",
    "Apply process chemistry and thermodynamic principles to crystallization design and optimization.",
    "Interpret the detailed process description, including unit operations and crystallizer design.",
    "Simulate crystallization processes using software tools (HYSYS, DWSIM, ProMax, UniSim) for design and performance analysis.",
    "Evaluate product and by-product specifications and their impact on downstream processes.",
    "Analyze process economics, including capital, operating costs, and energy requirements.",
    "Identify opportunities for optimization, energy efficiency, and environmental sustainability in para-xylene crystallization."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: CrystPX for High Purity Para-Xylene Production.",
    "Module 3: Process Chemistry and Thermodynamics",
    "Module 4: Detailed Process Description",
    "Module 5: Process Simulation (Hysys/DWSIM/Promax/Honeywell Unisim, Plus etc)",
    "Module 6: Product and By-Product Specifications",
    "Module 7: Process Economics"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 88,
  "title": "Para-Xylene Process",
  "date": "Present",
  "description": [
    "Para-xylene (p-xylene) is one of the most important aromatic chemicals, primarily used as a feedstock for the production of terephthalic acid (PTA) and dimethyl terephthalate (DMT), which are critical precursors for polyester fibers, films, and plastics. This course provides a comprehensive overview of para-xylene production and recovery in an aromatic complex.",
    "The program introduces participants to aromatic separation processes, crystallization development, and process fundamentals. Emphasis is placed on simulation and optimization techniques using process simulators such as Aspen HYSYS, DWSIM, ProMax, and Honeywell UniSim, enabling participants to model, analyze, and optimize para-xylene recovery processes.",
    "The course also addresses environmental considerations, highlighting best practices for energy efficiency, emissions reduction, and sustainable operation in para-xylene production facilities."
  ],
  "image": require("./coursesImg/para-xylene process.jpg"),
  "tags": [],
  "category": "PC",
  "duration": "3 Days",
  "prerequisite": [
    "This course is designed for:\n· Process, chemical, and petrochemical engineers.\n· Plant operations and technical service staff working in aromatic complexes or polyester value chains.\n· R&D engineers and students specializing in chemical process design, aromatics, or crystallization technologies.\nParticipants should have:\n· A strong foundation in organic chemistry, reaction engineering, and separation processes.\n· Knowledge of heat & mass transfer principles.\n· Basic familiarity with process simulation tools (HYSYS, DWSIM, ProMax, UniSim)."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the importance of para-xylene in the petrochemical and polyester industry value chain.",
    "Describe the process of para-xylene recovery within an aromatic complex.",
    "Explain the development and application of crystallization processes in para-xylene production.",
    "Apply the fundamental principles of para-xylene process design, including phase equilibrium, separation efficiency, and purity requirements.",
    "Simulate para-xylene processes using process simulation software (HYSYS, DWSIM, ProMax, UniSim) for analysis and optimization.",
    "Evaluate process performance and economics in para-xylene production.",
    "Participate in technical discussions regarding process alternatives, recovery schemes, and plant optimization strategies.",
    "Assess the environmental impact of para-xylene processes, including emissions, waste streams, and energy use.",
    "Apply best practices for sustainable operation and compliance with environmental regulations."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Para-Xylene Process Recovery in an Aromatic Complex",
    "Module 3: Development of Crystallization Process",
    "Module 4: Process Fundamentals",
    "Module 5: Process Simulation (Hysys/DWSIM/Promax/Honeywell Unisim, Plus etc)",
    "Module 6: Process Discussion",
    "Module 7: Environmental Impact"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 89,
  "title": "Aspen Plus Methanol Synthesis Model",
  "date": "Present",
  "description": [
    "The Aspen Plus Methanol Synthesis Model course is designed to equip participants with practical skills in simulating methanol production processes using Aspen Plus. The course introduces the fundamentals of methanol synthesis, including process components, physical properties, and reaction modeling.",
    "It provides hands-on experience in building and analyzing methanol production models, with specific focus on two major industrial processes: the ICI Synetix (Johnson Matthey) Methanol Process and the Lurgi Two-Stage Methanol Synthesis Process. Participants will learn how to define system components, configure physical property methods, model reactions, and evaluate process performance.",
    "By the end of the course, learners will gain the ability to model, analyze, and compare different methanol synthesis routes, applying Aspen Plus for process design, optimization, and decision-making."
  ],
  "image": require("./coursesImg/aspen plus methanol synthesis model.jpg"),
  "tags": [],
  "category": "PC",
  "duration": "4 Days",
  "prerequisite": [
    "· Students and professionals in chemical, process, or energy engineering.\n· Participants with a basic understanding of chemical process operations (reaction, separation, heat integration).\n· Familiarity with thermodynamics and reaction engineering concepts.\n· Prior exposure to Aspen Plus or similar simulation tools is beneficial, but not required."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Explain the fundamentals of methanol synthesis and its industrial importance.",
    "Define and configure key components (syngas, methanol, by-products) in Aspen Plus.",
    "Select and apply appropriate physical property methods for methanol process modeling.",
    "Build and analyze reaction models for methanol synthesis.",
    "Simulate the ICI Synetix (Johnson Matthey) Methanol Process, understanding its process flow and reactor modeling.",
    "Simulate the Lurgi Two-Stage Methanol Synthesis Process, capturing its unique features and advantages.",
    "Compare different process configurations, highlighting trade-offs in efficiency, yield, and design complexity.",
    "Summarize findings and apply Aspen Plus modeling techniques to optimize methanol production processes."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Components.",
    "Module 3: Physical Properties",
    "Module 4: Reaction Model",
    "Module 5: ICI Synetix (Johnson Matthey) Methanol Process Model",
    "Module 6: Lurgi Two-Stage Methanol Synthesis Process Model",
    "Module 7: Summary"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 90,
  "title": "Practical Lubrication for Industrial Facilities",
  "date": "Present",
  "description": [
    "This course provides participants with a practical and in-depth understanding of lubrication principles, lubricant types, and their applications in industrial facilities. It covers a wide spectrum of lubrication topics, including oils, greases, and synthetic lubricants, specialized lubricants for turbines, compressors, and paper machines, as well as environmentally friendly alternatives. Participants will gain knowledge of lubrication system design, contamination control, oil analysis, and best practices in storage and handling. The course emphasizes improving equipment reliability, extending asset life, and reducing downtime through effective lubrication strategies."
  ],
  "image": require("./coursesImg/Practical Lubrication for Industrial Facilities.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic knowledge of industrial equipment and rotating machinery.\n· Familiarity with maintenance practices in industrial plants.\n· Some background in mechanical engineering or plant operations."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles of lubrication and friction control in industrial systems.",
    "Identify different lubricant categories, properties, and performance characteristics.",
    "Apply lubricant testing methods to evaluate oil and grease quality.",
    "Select suitable lubricants for different equipment, including bearings, gears, turbines, compressors, and gas engines.",
    "Differentiate between mineral, synthetic, food-grade, and environmentally friendly lubricants.",
    "Implement centralized and oil mist lubrication systems effectively.",
    "Apply lubrication strategies tailored for specific applications such as paper machines, electric motors, and forest product industries.",
    "Manage lube oil contamination and apply on-stream oil purification methods.",
    "Establish best practices for lubricant storage, handling, and safety.",
    "Conduct successful oil analysis programs to monitor equipment health and predict failures.",
    "Develop cost-effective lubrication strategies to improve plant reliability and reduce maintenance downtime."
  ],
  "outline": [
    "Module 1: Principles of Lubrication",
    "Module 2: Lubricant Categories",
    "Module 3: Lubricant Testing",
    "Module 4: General Purpose R&O Oils",
    "Module 5: Hydraulic Fluids",
    "Module 6: Food Grade & Environmental Friendly Lubricant",
    "Module 7: Synthetic Lubricant",
    "Module 8: Lubricant for Forest Product & Paper Machines",
    "Module 9: Lubricating Greases",
    "Module 10: Pastes, Waxes & Tribosystems",
    "Module 11: Centralized & Oil Mist Lubrication Systems",
    "Module 12: Bearings & Other Machine Elements",
    "Module 13: Lubrication Strategies for Electric Motor Bearings",
    "Module 14: Gear Lubrication",
    "Module 15: Compressors & Gas Engines",
    "Module 16: Steam & Gas Turbines",
    "Module 17: Lube Oil Contamination & On-Stream Oil Purification",
    "Module 18: Storage Methods and Lubricant Handling",
    "Module 19: Successful Oil Analysis Practices in the Industrial Plant"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 91,
  "title": "Pump Characteristics & Applications",
  "date": "Present",
  "description": [
    "Pumps are fundamental components of process industries, enabling the safe and efficient transfer of fluids in oil & gas, petrochemical, water treatment, and power generation facilities. Understanding pump characteristics, performance curves, selection criteria, and applications is essential for engineers and operators to ensure reliable plant operations.",
    "This course provides a comprehensive study of pump principles, types, applications, and performance considerations. Participants will explore centrifugal pump hydraulics, sealing systems, energy efficiency, installation practices, and troubleshooting methods. Case studies will illustrate real-world challenges and solutions in pump operation and selection.",
    "By the end of this training, participants will be equipped with the knowledge and skills to select, operate, and maintain pumps effectively, minimizing downtime and optimizing energy usage."
  ],
  "image": require("./coursesImg/Pump Characteristics & Applications.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "Participants should have:\n· Basic knowledge of fluid mechanics and hydraulics.\n· Familiarity with process equipment used in industrial plants.\n· Awareness of piping systems and process operations.\n· Engineering background (mechanical, chemical, or process)"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the basic principles and functions of pumps in process industries.",
    "Interpret pump performance curves and apply them in pump selection.",
    "Evaluate special hydraulic considerations such as NPSH, cavitation, and system resistance.",
    "Differentiate among centrifugal pump types and their industrial applications.",
    "Understand sealing systems, sealless pumps, and mechanical seal applications.",
    "Analyze pump systems for energy conservation, reliability, and life-cycle cost optimization.",
    "Apply best practices in installation, operation, maintenance, and repair of pumps.",
    "Troubleshoot common pump operational issues (vibration, leakage, overheating, etc.).",
    "Study case-based applications to connect theoretical knowledge with real industry challenges.",
    "Make informed decisions in pump specification, selection, and system integration."
  ],
  "outline": [
    "Module 1: Introduction to Pumps",
    "Module 2: Hydraulics, Selection, and Curves",
    "Module 3: Special Hydraulic Considerations",
    "Module 4: Centrifugal Pump Types and Applications",
    "Module 5: Sealing Systems and Sealless Pumps",
    "Module 6: Energy Conservation and Life-Cycle Costs",
    "Module 7: Special Pump-Related Topics",
    "Module 8: Installation, Operation, Maintenance, and Repair",
    "Module 9: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 92,
  "title": "Reciprocating Compressor",
  "date": "Present",
  "description": [
    "This course introduces participants to the fundamentals of reciprocating compressors, widely used in oil, gas, petrochemical, and process industries for compressing gases. It covers the types of reciprocating compressors, their components and auxiliaries, and explores operational challenges with practical solutions. Emphasis is placed on understanding design, functionality, maintenance practices, and troubleshooting methods to ensure safe, reliable, and efficient operation."
  ],
  "image": require("./coursesImg/Reciprocating Compressor.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "2 Days",
  "prerequisite": [
    "· Basic knowledge of thermodynamics and fluid mechanics.\n· Familiarity with rotating equipment in industrial applications.\n· Understanding of general industrial safety practices."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the working principles of reciprocating compressors.",
    "Identify and differentiate between various types of reciprocating compressors.",
    "Recognize major components and auxiliary systems used in reciprocating compressors.",
    "Understand operational challenges such as vibration, leakage, lubrication, and wear.",
    "Apply practical solutions and maintenance practices to overcome operational issues.",
    "Enhance efficiency, reliability, and safety of reciprocating compressor operations."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Types",
    "Module 3: Component and Auxiliaries in Reciprocating Compressor",
    "Module 4: Challenges and Solutions"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦60,000 / $50",
  "certification": "Certificate of Completion"
},

{
  "id": 93,
  "title": "Tank Gauging",
  "date": "Present",
  "description": [
    "This course provides an in-depth understanding of tank gauging systems and associated measurement technologies used in the storage and handling of liquids, including petroleum products and liquefied gases. Participants will learn about different gauging technologies, system architecture, and critical factors affecting measurement accuracy, such as temperature variations and density changes. The course also covers engineering standards, regulatory approvals, overfill prevention, and the integration of additional sensors for operational reliability. By the end of the course, learners will be able to evaluate, design, and manage tank gauging systems to ensure safe, accurate, and compliant operations."
  ],
  "image": require("./coursesImg/Tank Gauging.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic knowledge of process instrumentation and control systems.\n· Familiarity with storage tank operations and fluid handling.\n· Understanding of measurement units and industrial standards."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the principles and applications of tank gauging systems.",
    "Compare different tank gauging technologies and select appropriate methods for specific applications.",
    "Apply relevant engineering standards and approvals to tank gauging installations.",
    "Accurately calculate volume and mass of stored products, considering density and temperature effects.",
    "Assess measurement accuracies and uncertainties in tank gauging systems.",
    "Understand temperature measurement techniques and their impact on volume calculations.",
    "Apply gauging principles to liquefied gases and other specialized storage scenarios.",
    "Integrate additional sensors and monitoring systems for enhanced tank management.",
    "Design or evaluate tank gauging system architecture for operational reliability and data integration.",
    "Implement overfill prevention strategies to ensure safety and regulatory compliance."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Tank Gauging Technologies.",
    "Module 3: Engineering Standards and approvals",
    "Module 4: Volume and Mass Assessment",
    "Module 5: Accuracies and Uncertainties",
    "Module 6: Temperature Measurement",
    "Module 7: Liquefied Gases",
    "Module 8: Additional Sensors",
    "Module 9: System Architecture",
    "Module 10: Overfill Prevention"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 94,
  "title": "Aspen Plus Biodiesel Model",
  "date": "Present",
  "description": [
    "The Aspen Plus Biodiesel Model course provides participants with the knowledge and practical skills to model biodiesel production processes using Aspen Plus, a leading process simulation software. The course covers the complete workflow of biodiesel simulation, from defining process components and physical properties to modeling chemical reactions, setting up simulation approaches, and analyzing results.",
    "Participants will gain hands-on experience in simulating transesterification and related biodiesel production steps, developing a deeper understanding of both the biodiesel process and Aspen Plus simulation techniques. Real-life case studies are integrated to reinforce learning and provide insight into industrial applications, optimization, and process evaluation."
  ],
  "image": require("./coursesImg/Aspen Plus Biodiesel Model.jpg"),
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "· Engineering students and professionals in chemical, process, or energy engineering fields.\n· Individuals with basic knowledge of chemical process operations (reactors, separators, distillation, etc.).\n· Familiarity with thermodynamics and chemical reaction principles.\n· Basic understanding of Aspen Plus or other process simulation software."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the fundamentals of biodiesel production and the role of simulation in process design.",
    "Define and configure biodiesel components (feedstocks, alcohols, esters, glycerol, etc.) within Aspen Plus.",
    "Apply physical property methods relevant to biodiesel modeling.",
    "Describe the process flow and unit operations in biodiesel production.",
    "Model and simulate transesterification and side reactions accurately.",
    "Develop a step-by-step simulation approach for biodiesel production using Aspen Plus.",
    "Analyze simulation results for material balance, energy requirements, and yield.",
    "Interpret case studies to evaluate process performance, optimization strategies, and sensitivity analysis in biodiesel production."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Components",
    "Module 3: Process Description",
    "Module 4: Physical Properties",
    "Module 5: Reactions",
    "Module 6: Simulation Approach",
    "Module 7: Simulation Results",
    "Module 8: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 95,
  "title": "Chemical Process Equipment Design",
  "date": "Present",
  "description": [
    "The Chemical Process Equipment Design course provides participants with the principles, methods, and practical approaches required to design and analyze key process equipment used in the chemical and process industries. The course covers essential aspects of fluid mechanics, heat transfer, separation processes, and chemical reaction engineering, while also introducing auxiliary equipment used to support plant operations.",
    "Through a combination of theory, design methods, and case-based learning, participants will learn to select, size, and evaluate process equipment for safety, efficiency, and reliability. The course is intended to bridge the gap between process design concepts and actual equipment design practices used in industry."
  ],
  "image": require("./coursesImg/Chemical Process Equipment Design.jpg"),
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "· Undergraduate and graduate students in Chemical, Process, or Mechanical Engineering.\n· Process engineers and designers seeking to strengthen equipment design skills.\n· Professionals with a basic understanding of thermodynamics, transport phenomena, and chemical reaction engineering."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Apply fluid flow principles to the design of pipelines, pumps, compressors, and fittings.",
    "Calculate pressure drops, flow regimes, and energy requirements for process fluids.",
    "Analyze heat transfer modes relevant to chemical processes.",
    "Design and evaluate heat exchangers, condensers, reboilers, and cooling equipment.",
    "Understand the principles of distillation, absorption, extraction, and filtration.",
    "Design key separation equipment such as distillation columns, absorbers, and membrane systems.",
    "Apply reaction kinetics and thermodynamics to reactor design.",
    "Design different types of reactors (batch, CSTR, PFR) for various chemical processes.",
    "Gain familiarity with auxiliary equipment such as dryers, evaporators, furnaces, and storage tanks.",
    "Incorporate safety, operability, and maintainability considerations into design.",
    "Integrate process fundamentals with engineering design practices.",
    "Perform preliminary equipment sizing and selection based on process data.",
    "Apply design standards and codes for safe and efficient equipment design."
  ],
  "outline": [
    "Module 1: Process Fluid Mechanics",
    "Module 2: Process Heat Transfer",
    "Module 3: Separation Equipment",
    "Module 4: Reactors",
    "Module 5: Other Equipment’s"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 96,
  "title": "Cooling Tower Design",
  "date": "Present",
  "description": [
    "The Cooling Tower Design course provides participants with in-depth knowledge of the principles, design considerations, and performance evaluation of cooling towers in process industries. The course begins with an introduction to cooling tower types and components before moving into advanced topics such as psychrometric concepts, heat and mass transfer fundamentals, NTU (Number of Transfer Units) analysis, KaV/L correlations, and performance calculations.",
    "Participants will also learn practical aspects such as water treatment, drift loss control, pressure drop estimation, airflow arrangements, pumping head determination, and motor power sizing, enabling them to design, analyze, and optimize cooling towers for safe and efficient operation. Realistic examples and calculations reinforce the theoretical concepts, bridging the gap between classroom knowledge and industrial practice."
  ],
  "image": require("./coursesImg/Cooling Tower Design.jpg"),
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "· Students and professionals in Chemical, Mechanical, Process, or Power Engineering.\n· Engineers involved in plant design, utilities, operations, or energy optimization.\n· Participants with a basic understanding of thermodynamics, fluid mechanics, and heat & mass transfer.\n· Familiarity with process utilities and cooling systems is beneficial but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose, working principles, and types of cooling towers.",
    "Identify key components and configurations of industrial cooling towers.",
    "Apply psychrometric concepts to analyze cooling tower performance.",
    "Evaluate key properties such as wet-bulb temperature, humidity, and enthalpy in cooling tower design.",
    "Assess cooling tower performance using parameters like approach, range, and efficiency.",
    "Analyze factors influencing cooling capacity such as water-to-air ratio, air flow arrangements, and drift losses.",
    "Apply fundamental principles of heat and mass transfer in cooling tower design.",
    "Perform NTU (Number of Transfer Units) calculations and determine KaV/L values for tower sizing.",
    "Estimate cold water temperature, evaporation losses, pumping head, and motor power requirements.",
    "Evaluate the effect of bypass water, pressure drops, and system hydraulics on tower operation.",
    "Select the most appropriate cooling tower type for specific industrial applications.",
    "Incorporate cooling water treatment practices to minimize fouling, scaling, and biological growth.",
    "Perform basic design, rating, and optimization calculations for industrial cooling towers."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Cooling Tower Types",
    "Module 3: Components of Cooling Towers",
    "Module 4: Psychrometrics Concepts",
    "Module 5: Main Properties of Psychrometrics",
    "Module 6: Cooling Tower Performance",
    "Module 7: Factors Affecting Cooling Tower Performance Capacity",
    "Module 8: Approach and Flow",
    "Module 9: Choosing a Cooling Tower",
    "Module 10: Cooling Water Treatment",
    "Module 11: Drift Loss in the Cooling Towers",
    "Module 12: Basic Transfer Rate",
    "Module 13: Heat & Mass Transfer Fundamental",
    "Module 14: NTU (Number of Transfer Unit) Calculation",
    "Module 15: Tower Demand & Tower Characteristic – KaV/L",
    "Module 16: Consideration of By-Pass Wall Water",
    "Module 17: Pressure Drops in Cooling Towers",
    "Module 18: Air Flow Arrangements",
    "Module 19: Motor Power Sizing",
    "Module 20: Evaporation",
    "Module 21: Estimation of Actual Cold Water Temperature",
    "Module 22: Determination of L/G",
    "Module 23: Determination of Pumping Head"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 97,
  "title": "Distillation",
  "date": "Present",
  "description": [
    "Distillation is one of the most widely used separation techniques in the chemical and process industries, applied in refining, petrochemicals, gas processing, and pharmaceuticals. This course provides participants with both theoretical and practical knowledge of distillation principles, process operations, equipment, and industrial applications. It covers different types of distillation, auxiliary equipment, key operating parameters, and advanced technologies. Special emphasis is placed on operating procedures, troubleshooting, and optimization of distillation columns to ensure safe, reliable, and efficient plant operations."
  ],
  "image": require("./coursesImg/Distillation.jpg"),
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "· A basic understanding of chemical engineering principles.\n· Knowledge of thermodynamics and phase equilibria.\n· Familiarity with process equipment and unit operations."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Explain the fundamental principles of distillation and its role in process industries.",
    "Identify different types of distillation processes (simple, fractional, azeotropic, extractive, steam distillation).",
    "Describe the design and function of distillation columns and associated auxiliary equipment.",
    "Understand the concepts of stripping and fractionation and their applications.",
    "Recognize key operating parameters that affect column performance (reflux ratio, pressure, temperature profiles, flooding, weeping, and entrainment).",
    "Apply best practices for operating a distillation column safely and efficiently.",
    "Perform step-by-step distillation processes in lab or pilot plant setups.",
    "Troubleshoot common distillation problems such as flooding, foaming, entrainment, and maldistribution.",
    "Evaluate different distillation technologies and select appropriate methods for given process requirements.",
    "Integrate process knowledge to optimize separation efficiency, energy use, and product quality."
  ],
  "outline": [
    "Module 1: Objectives",
    "Module 2: Introduction to Distillation Principles.",
    "Module 3: Distillation Process",
    "Module 4: Types Distillations",
    "Module 5: Stripping",
    "Module 6: Fractionation",
    "Module 7: Distillation Technologies",
    "Module 8: Auxiliary Equipment",
    "Module 9: Operating Parameters",
    "Module 10: Operating a Distillation Column",
    "Module 11: Performing Distillation",
    "Module 12: Troubleshooting"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 98,
  "title": "Drains & Flares: Design, Operation, and Troubleshooting",
  "date": "Present",
  "description": [
    "Flares and drain systems are essential safety devices in oil, gas, and petrochemical facilities, providing controlled disposal of excess hydrocarbons and process fluids. This course gives participants a comprehensive understanding of the functions, design, operation, and troubleshooting of flare and drain systems.",
    "Starting with the objectives and fundamental functions of flares, the course progresses to how flares work, types of flare systems, and the representation of flare data in process documentation. It also examines the relationship between flares and process systems, operating parameters, and best practices for operation. Special focus is given to troubleshooting techniques and ensuring compliance with environmental and safety standards.",
    "By the end of the program, participants will be equipped with both theoretical knowledge and practical insight to ensure safe, reliable, and efficient operation of flare and drain systems in process facilities."
  ],
  "image": require("./coursesImg/Drains & Flares_ Design, Operation, and Troubleshooting.jpg"),
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "· Process, mechanical, and instrumentation engineers.\n· Operations and maintenance personnel working in oil, gas, refining, and petrochemical plants.\n· HSE and safety engineers involved in flare and relief system design.\n· Participants with a basic understanding of process engineering principles, thermodynamics, and process safety.\n· Familiarity with PFDs and P&IDs is beneficial but not mandatory."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the purpose and objectives of flare and drain systems in process facilities.",
    "Explain the functions of flares and their role in plant safety and environmental compliance.",
    "Describe how flare systems work, including combustion, smokeless operation, and thermal radiation control.",
    "Identify the different types of flare systems (e.g., elevated, ground, enclosed, marine).",
    "Differentiate between types of flare stacks and their applications.",
    "Interpret flare representation and data in process documentation and engineering deliverables.",
    "Recognize the interaction between flares and process systems during normal operation, upset, and emergency conditions.",
    "Analyze key operating parameters such as pressure, flow, purge gas, steam/air assist, and flame stability.",
    "Apply best practices for the operation of flare and drain systems.",
    "Troubleshoot common flare issues such as smoking, flame instability, excessive noise, liquid carryover, and radiation concerns."
  ],
  "outline": [
    "Module 1: Objectives",
    "Module 2: The Functions of Flares.",
    "Module 3: How Flares Work",
    "Module 4: The Different Types Of Flare Systems",
    "Module 5: Different types of flare stacks",
    "Module 6: Flare Representation and Data",
    "Module 7: Flares & Processes",
    "Module 8: Operating Parameters",
    "Module 9: Operation",
    "Module 10: Troubleshooting"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 99,
  "title": "LNG Pumps Technologies",
  "date": "Present",
  "description": [
    "This course provides a detailed introduction to LNG (Liquefied Natural Gas) pumps, focusing on their design, selection, technologies, and leading manufacturers. Participants will explore the critical role of LNG pumps in cryogenic handling, storage, and transfer operations, including loading, unloading, and regasification processes. The course emphasizes the technical considerations in selecting the right pump equipment, the principles behind different LNG pump technologies, and an overview of major global manufacturers. Through case studies and practical insights, learners will gain the knowledge to evaluate, operate, and maintain LNG pump systems safely and efficiently."
  ],
  "image": require("./coursesImg/LNG Pumps Technologies.jpg"),
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "· Basic knowledge of LNG value chain (liquefaction, shipping, storage, and regasification).\n· Familiarity with cryogenic fluids and their handling.\n· Understanding of pump fundamentals and fluid mechanics."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Describe the role and importance of pumps in LNG handling and transfer operations.",
    "Identify key types of LNG pumps and their operating principles.",
    "Apply equipment selection criteria based on operational, safety, and efficiency requirements.",
    "Compare different LNG pump technologies (submerged, in-tank, inline, transfer pumps, etc.).",
    "Recognize major LNG pump manufacturers and understand their technological offerings.",
    "Evaluate the performance, reliability, and maintenance considerations of LNG pumps.",
    "Incorporate safety and best practices into LNG pump operations and selection."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: LNG Pump Equipment Selection",
    "Module 3: LNG Pump Technologies",
    "Module 4: LNG Pump Manufacturers"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 100,
  "title": "Packed Tower Design & Applications",
  "date": "Present",
  "description": [
    "Packed towers are widely used in the chemical, petrochemical, refining, and environmental industries for mass transfer operations such as absorption, stripping, distillation, and extraction. This course provides a comprehensive understanding of packed tower design principles, packing selection, and process applications across various operating conditions.",
    "Participants will learn the differences between random dumped packings and structured packings, and how to apply them for efficient gas–liquid and liquid–liquid operations. The course emphasizes practical design considerations, column internals, hydraulics, and operational challenges, along with real-world applications in pollution control, heat transfer, and industrial separation processes (e.g., atmospheric, vacuum, and pressure distillation).",
    "By combining theoretical principles with case-based applications, the course equips participants with the tools to design, optimize, and troubleshoot packed tower systems."
  ],
  "image": require("./coursesImg/Packed Tower Design & Applications.jpg"),
  "tags": [],
  "category": "process",
  "duration": "4 Days",
  "prerequisite": [
    "· Background in fluid mechanics, heat & mass transfer, and basic separation processes.\n· Familiarity with PFDs and P&IDs."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the fundamentals of packed tower operation and their role in process industries.",
    "Differentiate between random dumped packings and structured packings, and determine the criteria for selection.",
    "Apply packed tower design principles for gas absorption and liquid stripping operations.",
    "Explain the application of packed towers in pollution control systems (e.g., scrubbers).",
    "Understand the role of packing in heat transfer enhancement within columns.",
    "Analyze the use of packed towers in atmospheric, vacuum, and pressure distillation processes.",
    "Identify and design column internals such as distributors, redistributors, and demisters to ensure uniform flow and efficiency.",
    "Explore the role of packed towers in liquid–liquid extraction processes.",
    "Evaluate hydraulic limitations such as flooding, weeping, entrainment, and pressure drop.",
    "Apply best practices in design, operation, and troubleshooting of packed tower systems for optimized performance."
  ],
  "outline": [
    "Module 1: Random Dumped Packings",
    "Module 2: Structured Packings",
    "Module 3: Gas Absorption",
    "Module 4: Liquid Stripping",
    "Module 5: Pollution Control",
    "Module 6: Heat Transfer",
    "Module 7: Atmospheric Distillation",
    "Module 8: Vacuum Distillation",
    "Module 9: Pressure Distillation",
    "Module 10: Column Internals",
    "Module 11: Liquid-Liquid Extraction"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

  {
    "id": 101,
    "title": "Process Design Package Sulphur Recovery Unit",
    "date": "Present",
    "description": [
      "The Sulphur Recovery Unit (SRU) is a critical component of gas processing and refining facilities, designed to recover elemental sulfur from hydrogen sulfide (H₂S)–rich streams using the Claus process and tail gas treating technologies. A properly developed Process Design Package (PDP) ensures safe, reliable, and efficient SRU operation, covering process description, equipment specifications, control systems, safety, and operational guidelines.",
      "This course provides a comprehensive framework for understanding, designing, and operating an SRU based on a process design package. Participants will gain in-depth knowledge of process flow, instrumentation and control, equipment, safety measures, catalyst handling, startup and shutdown procedures, special operations (Aquisulf sulfur degassing), process analysis methods, and supporting engineering documents.",
      "The training bridges theory, design principles, and real-world operation, equipping participants with the expertise to evaluate SRU design packages, ensure compliance with environmental standards, and support plant commissioning and operations."
    ],
    "image": require("./coursesImg/Process Design Package Sulphur Recovery Unit.jpg"),
    "tags": [],
    "category": "process",
    "duration": "5 Days",
    "prerequisite": [
      "This course is designed for professionals in refining, gas processing, and EPC industries, including:\n· Process, design, and operations engineers involved in SRU or acid gas treatment.\n· Instrumentation and control engineers responsible for SRU automation and safety.\n· Commissioning and operations personnel working on sulfur recovery or tail gas treating.\n· EPC contractors and licensors developing SRU design documentation.\nRecommended knowledge:\n· Fundamentals of chemical process design and equipment selection.\n· Basic understanding of Claus process chemistry and gas treating operations.\n· Familiarity with P&IDs, control systems, and HAZOP methodology.\n· Prior exposure to process simulation tools (HYSYS, ProMax, UniSim, etc.)."
    ],
    "methodology": "Theoretical/Practical",
    "objectives": [
      "Explain the role and importance of the SRU in refinery and gas plant operations.",
      "Interpret a Process Design Package (PDP) for SRU, including process flow diagrams, equipment specifications, and supporting documents.",
      "Understand the process design description and chemical reactions of the Claus process.",
      "Describe the instrumentation and control strategies applied in SRU for safe and reliable operation.",
      "Identify key safety considerations, including H₂S handling, sulfur hazards, and emergency procedures.",
      "Recognize the function of major SRU equipment such as reactors, condensers, reheaters, incinerators, and degassing units.",
      "Apply knowledge of operation preparation, catalyst unloading/loading, and startup checklists.",
      "Distinguish between normal startup, shutdown, and special operating procedures for SRU.",
      "Operate and monitor critical process parameters to ensure stable and efficient sulfur recovery.",
      "Describe the Aquisulf process for liquid sulfur degassing, including startup, operation, and shutdown procedures.",
      "Perform hydrocarbon and sulfur recovery analysis methods for process monitoring and compliance.",
      "Utilize drawings and references (PFDs, P&IDs, datasheets) as part of SRU design documentation.",
      "Evaluate the overall process performance and suggest design or operational improvements."
    ],
    "outline": [
      "Module 1: Introduction",
      "Module 2: Process Design Description.",
      "Module 3: Instrumentation and Control System",
      "Module 4: Safety Information",
      "Module 5: Equipment’s",
      "Module 6: Preparation of Operation",
      "Module 7: Catalyst Unloading",
      "Module 8: Preparation and Checklist for Startup",
      "Module 9: Normal Startup for the Unit",
      "Module 10: Special Operating Procedures",
      "Module 11: Operation and Process Parameters",
      "Module 12: Shutdown of the Unit",
      "Module 13: Aquisulf Startup (Liquid Sulfur Degassing)",
      "Module 14: Operation and Process Parameters of Aquisulf",
      "Module 15: Shutdown of the Aquisulf",
      "Module 16: Hydrocarbon Analysis in Acid Gas",
      "Module 17: Sulfur Recovery Analysis Method",
      "Module 18: References",
      "Module 19: Drawing"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦250,000 / $200",
    "certification": "Certificate of Completion"
  },
  {
    "id": 102,
    "title": "Process Plant Layout – General Principles",
    "date": "Present",
    "description": [
      "Process plant layout is a critical phase in the design and development of chemical, petrochemical, and refinery facilities. It involves the systematic arrangement of equipment, piping, utilities, and supporting facilities to ensure safe, efficient, and economical operations. Good plant layout improves operability, maintainability, safety, and compliance with regulations, while minimizing capital and operating costs.",
      "This course introduces the principles, methodologies, and practices of process plant layout, guiding participants through site and plot layout, planning activities, development methods, and hazard assessment techniques. Using real-world case studies and industry standards, the course equips participants with the ability to interpret and apply layout concepts to practical engineering projects."
    ],
    "image": require("./coursesImg/Process Plant Layout – General Principles.jpg"),
    "tags": [],
    "category": "process",
    "duration": "3 Days",
    "prerequisite": [
      "This course is designed for engineers, designers, and project professionals involved in plant engineering and design. Recommended background includes:\n· Basic understanding of chemical or process engineering principles.\n· Familiarity with process flow diagrams (PFDs) and piping & instrumentation diagrams (P&IDs).\n· General knowledge of safety, hazard analysis, and project design workflow.\n· Experience with engineering design tools (AutoCAD, AVEVA E3D, Plant 3D, SmartPlant, etc.)."
    ],
    "methodology": "Theoretical/Practical",
    "objectives": [
      "Explain the importance of plant layout in process industries.",
      "Define the discipline of process plant layout and its role in EPC project execution.",
      "Apply site layout principles to determine plant location, orientation, and integration with infrastructure.",
      "Apply plot layout principles for arranging process units, utility systems, offsites, and safety zones.",
      "Plan layout activities systematically, from conceptual design to detailed engineering.",
      "Use different methods for layout conception and development, including analogues, modular design, and best practice case studies.",
      "Employ layout analogues and visual aids (3D models, block diagrams, sketches) for communication and decision-making.",
      "Conduct hazard assessments of plant layouts, integrating safety distances, fire protection, and regulatory requirements.",
      "Balance operability, safety, and cost considerations in layout decision-making.",
      "Critically review and evaluate layout deliverables as part of multidisciplinary engineering teams."
    ],
    "outline": [
      "Module 1: Introduction",
      "Module 2: Discipline of Process Plant Layout.",
      "Module 3: Site Layout Principles",
      "Module 4: Plot Layout Principles",
      "Module 5: Planning of Layout Activities",
      "Module 6: Methods for Layout, Conception, and Development",
      "Module 7: Layout Analogues and Visual Aids",
      "Module 8: Hazard Assessment of Plant Layout"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦150,000 / $120",
    "certification": "Certificate of Completion"
  },

  {
    "id": 103,
    "title": "Process Plant Layout - Detailed Site and Plot Layout",
    "date": "Present",
    "description": [
      "Detailed site and plot layout is a crucial phase in the engineering of process plants. It involves defining the precise arrangement of facilities, equipment, and infrastructure to achieve an optimum balance of safety, operability, constructability, maintainability, and environmental compliance.",
      "This course builds on general layout principles and dives deeper into detailed considerations such as storage facilities, utility systems, pollution control, transportation logistics, and in-building arrangements. It emphasizes industry standards, safety guidelines, and real-world best practices used in oil & gas, petrochemical, refinery, and power plants.",
      "Through case studies and design exercises, participants will gain practical knowledge of how to plan, evaluate, and optimize detailed layouts to meet both technical and regulatory requirements."
    ],
    "image": require("./coursesImg/Process Plant Layout - Detailed Site and Plot Layout.jpg"),
    "tags": [],
    "category": "process",
    "duration": "3 Days",
    "prerequisite": [
      "Participants are expected to have:\n· Basic knowledge of chemical or process engineering principles.\n· Familiarity with plant layout fundamentals (general site and plot design concepts).\n· Understanding of process documentation (PFDs, P&IDs, equipment datasheets).\n· Awareness of safety and environmental regulations applicable to industrial facilities.\n· Prior exposure to engineering design tools (AutoCAD, SmartPlant, AVEVA E3D, or Plant 3D) is helpful but not mandatory."
    ],
    "methodology": "Theoretical/Practical",
    "objectives": [
      "Understand the detailed aspects of process plant site and plot layout beyond general principles.",
      "Design and optimize transportation systems within process plants for efficiency and safety.",
      "Apply engineering and safety guidelines for bulk fluid storage (tanks, spheres, bullets).",
      "Develop layouts for bulk solid storage considering handling, dust control, and environmental issues.",
      "Plan warehouse storage areas for spare parts, consumables, and maintenance tools.",
      "Integrate pollution control facilities into site layouts in line with regulatory and environmental requirements.",
      "Analyze and design utility systems, including general utilities and specialized services (water, steam, power).",
      "Plan and optimize central services such as control rooms, substations, laboratories, and maintenance shops.",
      "Evaluate constructability aspects and translate them into layout design for efficient construction and installation.",
      "Prepare detailed plot layouts including spacing, safety distances, and accessibility for operations and maintenance.",
      "Develop effective layouts within buildings, ensuring functionality, safety, and compliance with building codes.",
      "Balance safety, operability, and cost considerations in site and plot layout decision-making.",
      "Critically assess detailed layout drawings and propose improvements to optimize plant design."
    ],
    "outline": [
      "Module 1: Transportation",
      "Module 2: Bulk Fluid Storage",
      "Module 3: Bulk Solid Storage",
      "Module 4: Warehouse Storage",
      "Module 5: Pollution Control",
      "Module 6: Utilities I: General",
      "Module 7: Utilities II: Water and Steam",
      "Module 8: Central Services",
      "Module 9: Construction and Layout",
      "Module 10: Details of Plot Layout",
      "Module 11: Layout Within Buildings"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦150,000 / $120",
    "certification": "Certificate of Completion"
  },
  {
    "id": 104,
    "title": "Process Plant Layout - Detailed Layout of Equipment",
    "date": "Present",
    "description": [
      "The layout of process equipment is one of the most critical stages in the design of industrial plants. The arrangement of tanks, reactors, heat exchangers, furnaces, and other key equipment directly impacts safety, operability, maintainability, energy efficiency, and cost-effectiveness.",
      "This course provides a comprehensive guide to the detailed layout of major process equipment, addressing both technical design considerations and practical engineering requirements. It covers spacing rules, safety distances, access requirements, maintenance provisions, and integration of auxiliary systems.",
      "By studying real-world examples and applying layout guidelines, participants will gain the knowledge to develop efficient, safe, and compliant plant layouts that meet both engineering and regulatory standards."
    ],
    "image": require("./coursesImg/Process Plant Layout - Detailed Layout of Equipment.jpg"),
    "tags": [],
    "category": "process",
    "duration": "3 Days",
    "prerequisite": [
      "Participants are expected to have:\n· Basic understanding of process engineering and equipment design.\n· Familiarity with PFDs (Process Flow Diagrams) and P&IDs (Piping & Instrumentation Diagrams).\n· Prior exposure to general plant layout principles.\n· Awareness of safety and regulatory standards related to process industries.\n· Knowledge of 3D plant design tools (SmartPlant, AVEVA E3D, AutoCAD Plant 3D, etc.)."
    ],
    "methodology": "Theoretical/Practical",
    "objectives": [
      "Understand the principles of equipment arrangement in process plant layouts.",
      "Apply spacing, safety, and operability guidelines for tanks, drums, and storage vessels.",
      "Design layouts for furnaces and fired equipment with due consideration for radiation, safety clearances, and fuel systems.",
      "Optimize the placement of distillation columns and towers, ensuring accessibility and structural support.",
      "Plan layouts of heat exchangers for maintainability and piping integration.",
      "Integrate reactors into plant layouts with focus on process efficiency, safety, and catalyst handling.",
      "Design appropriate layouts for mixers, filters, and centrifuges, considering solids handling and maintenance needs.",
      "Address layout challenges in solids handling plants, including conveyors, bins, and hoppers.",
      "Plan dryer installations with ventilation, energy efficiency, and environmental controls.",
      "Develop layouts for filling and packaging facilities, integrating logistics, safety, and product handling requirements.",
      "Evaluate detailed layout drawings for compliance with international codes and standards (API, ASME, NFPA, OSHA, etc.).",
      "Balance trade-offs between space utilization, cost, operability, and safety in equipment arrangement.",
      "Apply best practices to ensure constructability and maintainability in plant equipment layout."
    ],
    "outline": [
      "Module 1: Tanks and Drums",
      "Module 2: Furnaces and Fired Equipment",
      "Module 3: Distillation Columns and Towers",
      "Module 4: Heat Exchangers",
      "Module 5: Reactors",
      "Module 6: Mixers",
      "Module 7: Filters",
      "Module 8: Centrifuges",
      "Module 9: Solids Handling Plant",
      "Module 10: Dryers",
      "Module 11: Filling and Packaging"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦150,000 / $120",
    "certification": "Certificate of Completion"
  },
  {
    "id": 105,
    "title": "Process Plant Layout - Detailed Layout Materials",
    "date": "Present",
    "description": [
      "The effective layout of materials-handling systems, mechanical equipment, piping networks, and instrumentation is central to ensuring safe, reliable, and cost-effective operations in a process plant. Poor arrangement can lead to excessive pressure drops, vibration issues, maintenance difficulties, and even safety hazards.",
      "This course focuses on the detailed layout of pumps, compressors, conveyors, piping systems, and instrumentation within process facilities. Special attention is given to pipe stress analysis, ensuring that piping systems can withstand thermal expansion, vibration, and mechanical loads.",
      "Participants will learn how to integrate mechanical, piping, and instrumentation considerations into a cohesive plant layout that supports operability, maintainability, constructability, and compliance with international standards."
    ],
    "image": require("./coursesImg/Process Plant Layout - Detailed Layout Materials.jpg"),
    "tags": [],
    "category": "process",
    "duration": "3 Days",
    "prerequisite": [
      "· A basic understanding of process engineering and equipment operation.\n· Familiarity with plant layout fundamentals and general engineering drawings.\n· Prior exposure to pumps, compressors, and piping systems in industrial facilities.\n· Awareness of codes and standards such as ASME, API, and ISA.\n· Experience with 3D plant design tools (e.g., AVEVA E3D, SmartPlant, AutoCAD Plant 3D)."
    ],
    "methodology": "Theoretical",
    "objectives": [
      "Understand the layout principles for pumps, including suction piping design, NPSH considerations, accessibility, and alignment.",
      "Apply best practices for the placement and layout of compressors, addressing vibration, noise, cooling, and safety spacing.",
      "Design and optimize conveyor layouts for solids handling plants, ensuring efficiency, safety, and maintenance access.",
      "Develop piping layouts that balance cost, safety, operability, and constructability.",
      "Perform pipe stress analysis basics, including thermal expansion, support placement, and load considerations.",
      "Integrate instrumentation systems into the layout, ensuring visibility, accessibility, and compliance with ISA guidelines.",
      "Identify interdisciplinary interactions between mechanical, piping, and instrumentation layouts to avoid conflicts.",
      "Evaluate layout drawings against safety, operability, and maintainability requirements.",
      "Apply industry standards and regulatory requirements in equipment and piping arrangement.",
      "Optimize layouts to reduce pressure drop, vibration risk, and maintenance downtime."
    ],
    "outline": [
      "Module 1: Pumps",
      "Module 2: Compressors.",
      "Module 3: Conveyors",
      "Module 4: Piping",
      "Module 5: Pipe Stress Analysis",
      "Module 6: Instrumentation"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦150,000 / $120",
    "certification": "Certificate of Completion"
  },

  {
  "id": 106,
  "title": "Regulators",
  "date": "Present",
  "description": [
    "This course provides a comprehensive understanding of pressure regulators and associated safety devices used in the oil, gas, and process industries. Participants will explore the components, operating principles, and design considerations of direct-operated and pilot-operated regulators, as well as relief valves and vacuum control systems. The course also covers advanced topics such as series and monitor regulations, valve sizing calculations, chemical compatibility of materials, and considerations for extreme temperatures and corrosive environments. By the end of the course, participants will be able to select, size, and maintain regulators effectively, ensuring safe and efficient system operation."
  ],
  "image": require("./coursesImg/Regulators.jpg"),
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic knowledge of process instrumentation and control systems.\n· Understanding of fluid mechanics and pressure control concepts.\n· Familiarity with general safety standards in industrial operations."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe the fundamental principles and applications of pressure regulators.",
    "Identify and explain the functions of regulator components.",
    "Understand the operation of direct-operated and pilot-operated regulators.",
    "Select and size reducing regulators for various applications.",
    "Apply overpressure protection methods and relief valve principles.",
    "Explain series regulations, monitor regulations, and their applications.",
    "Perform valve sizing calculations for accurate system design.",
    "Understand vacuum control and freezing considerations in regulator operations.",
    "Evaluate chemical compatibility of elastomers and metals used in regulators.",
    "Apply knowledge of sulfide stress cracking and cold temperature effects on regulator performance."
  ],
  "outline": [
    "Module 1: Introduction to Regulators",
    "Module 2: Regulators Components",
    "Module 3: Principles of Direct-Operated Regulators",
    "Module 4: Principles of Pilot-Operated Regulators",
    "Module 5: Selecting and Sizing of Reducing Regulators",
    "Module 6: Overpressure Protection Methods",
    "Module 7: Principles of Relief Valves",
    "Module 8: Principles of Series Regulations and Monitor Regulations",
    "Module 9: Valve Sizing Calculations",
    "Module 10: Vacuum Control",
    "Module 11: Freezing",
    "Module 12: Chemical Compatibility of Elastomers and Metals",
    "Module 13: Sulfide Stress Cracking",
    "Module 14: Cold Temperature Considerations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},


  {
    "id": 107,
    "title": "Project Management Methodology",
    "date": "Present",
    "description": [
      "This course provides participants with a structured approach to managing projects across industries using a proven project management methodology. It guides learners through all phases of the project lifecycle—from initiation to closing—while emphasizing planning, execution, monitoring, and controlling. Participants will also gain hands-on knowledge of essential project documentation, such as project charters, communication plans, status reports, and lessons learned. By the end of the course, learners will be equipped with practical tools and best practices to deliver projects successfully, within scope, schedule, and budget, while managing risks and stakeholder expectations."
    ],
    "image": require("./coursesImg/Project Management Methodology.jpg"),
    "tags": [],
    "category": "project management",
    "duration": "4 Days",
    "prerequisite": [
      "· Basic knowledge of organizational operations and business processes.\n· Familiarity with general project concepts.\n· Prior exposure to project work in their domain."
    ],
    "methodology": "Theoretical",
    "objectives": [
      "Explain the phases of the project management lifecycle and their interrelationships.",
      "Initiate projects effectively by defining objectives, scope, and key stakeholders.",
      "Develop comprehensive project plans covering schedule, resources, cost, risks, and communication.",
      "Apply execution, monitoring, and controlling practices to ensure projects remain on track.",
      "Use project documentation tools such as charters, agreements, communication plans, and status reports.",
      "Manage project changes systematically through structured change request processes.",
      "Close projects effectively, capturing agreements, completion reports, and lessons learned.",
      "Apply methodology best practices to improve consistency, efficiency, and project success rates."
    ],
    "outline": [
      "Module 1: Overview",
      "Module 2: Initiation",
      "Module 3: Planning",
      "Module 4: Execution, Controlling and Monitoring",
      "Module 5: Additional Information on Controlling / Monitoring",
      "Module 6: Closing",
      "Module 7: Project Request Form",
      "Module 8: Project Charter",
      "Module 9: Project Agreement",
      "Module 10: Project Communication Plan",
      "Module 11: Project Status Report",
      "Module 12: Project Change Request Form",
      "Module 13: Project Completion Agreement",
      "Module 14: Project Completion Lessons Learned"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦150,000 / $120",
    "certification": "Certificate of Completion"
  },
  {
    "id": 108,
    "title": "Guide to Differential pressure (DP) Flow Measurement",
    "date": "Present",
    "description": [
      "Differential pressure (DP) flow measurement is one of the most widely used technologies in process industries due to its reliability, versatility, and compatibility with various fluids. This course provides participants with a comprehensive guide to DP flow measurement principles, technologies, and applications across gas, liquid, and steam systems.",
      "The course introduces the fundamentals of fluid flow, the theory behind DP flow measurement, and key applications in process systems. Participants will explore different primary element technologies (such as orifice plates, venturi tubes, and flow nozzles), transmitter technologies, and the integration of Rosemount primary elements and flow meters. Special emphasis is given to installation practices, calibration, troubleshooting, and engineering reference data to ensure accurate and reliable flow measurement in real-world applications.",
      "By the end of this training, participants will gain both theoretical knowledge and practical skills to optimize the use of DP flow meters in their respective industries."
    ],
    "image": require("./coursesImg/Guide to Differential pressure (DP) Flow Measurement.jpg"),
    "tags": [],
    "category": "PAI",
    "duration": "3 Days",
    "prerequisite": [
      "· Flow instrumentation.\n· Basic understanding of fluid mechanics, pressure measurement, and instrumentation systems.\n· Familiarity with P&IDs and basic control loops is beneficial but not mandatory."
    ],
    "methodology": "Theoretical",
    "objectives": [
      "Understand the principles and operation of differential pressure flow meters.",
      "Define and apply basic fluid and flow concepts relevant to DP measurement.",
      "Explain the theory of DP flow measurement, including Bernoulli’s principle and continuity equations.",
      "Identify the applications of DP flow measurement for gas, liquid, and steam systems.",
      "Differentiate between primary element technologies (orifice plates, venturi tubes, flow nozzles, pitot tubes, wedge meters, etc.).",
      "Understand transmitter technologies and their role in DP flow measurement accuracy.",
      "Explore the features and benefits of Rosemount primary elements and flow meters.",
      "Apply best practices for DP flow meter installation to avoid measurement errors.",
      "Perform calibration, maintenance, and troubleshooting of DP flow measurement systems.",
      "Use engineering data, pipe data, conversions, and equivalents in flow measurement calculations and reporting."
    ],
    "outline": [
      "Module 1: Differential pressure Flow Meter",
      "Module 2: Fluids and Flow Basic Terms and Concepts.",
      "Module 3: Theory of Differential pressure Flow",
      "Module 4: Gas, Liquid, and Steam Applications",
      "Module 5: Primary Element Technologies",
      "Module 6: Transmitter Technology",
      "Module 7: Rosemount Primary Elements and Flow Meters",
      "Module 8: Differential pressure Flow Meter Installation",
      "Module 9: Calibration, Maintenance and Troubleshooting",
      "Module 10: Engineering Data, Pipe Data, and Conversions and Equivalents"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦200,000 / $180",
    "certification": "Certificate of Completion"
  },
  {
    "id": 109,
    "title": "Storage Facilities & Terminal",
    "date": "Present",
    "description": [
      "This course provides a comprehensive understanding of storage facilities and oil terminal operations. Participants will gain insights into the critical functions of oil terminals, including storage management, shipment processes, and metering systems. The course emphasizes operational efficiency, safety, and regulatory compliance within oil and gas storage and terminal environments. Practical examples and case studies will enhance learners’ ability to apply concepts to real-world scenarios in petroleum storage and handling."
    ],
    "image": require("./coursesImg/Storage Facilities & Terminal.jpg"),
    "tags": [],
    "category": "Petroleum",
    "duration": "3 Days",
    "prerequisite": [
      "Participants are expected to have:\n· Basic knowledge of petroleum industry operations.\n· Understanding of oil and gas logistics and transportation.\n· Familiarity with safety protocols and industrial standards."
    ],
    "methodology": "Theoretical",
    "objectives": [
      "Describe the fundamental structure and functions of oil storage facilities and terminals.",
      "Explain the roles and responsibilities involved in terminal operations.",
      "Understand storage principles, tank types, and inventory management practices.",
      "Analyze shipment processes, including loading, unloading, and transportation logistics.",
      "Interpret metering techniques, instrumentation, and flow measurement for operational accuracy.",
      "Apply industry best practices for safety, environmental compliance, and operational efficiency."
    ],
    "outline": [
      "Module 1: Introduction",
      "Module 2: Functions of an Oil Terminal",
      "Module 3: Storage",
      "Module 4: Shipment",
      "Module 5: Metering"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦100,000 / $80",
    "certification": "Certificate of Completion"
  },
  {
    "id": 110,
    "title": "Transfer & Stock Piling Operations in the Crude Oil Refining Industry",
    "date": "Present",
    "description": [
      "This course provides a comprehensive understanding of transfer and stockpiling operations within crude oil refineries, focusing on the safe, efficient, and compliant management of crude, refined products, and liquefied gases. Participants will explore the operational, safety, and asset integrity aspects of storage, blending, and transfer processes. The course also addresses interfaces with middle-stream companies, flaring systems management, metering, billing, and the integration of process safety management (PSM) practices. Through case studies and practical examples, learners will develop the ability to optimize stockpiling operations while maintaining safety, regulatory compliance, and operational efficiency."
    ],
    "image": require("./coursesImg/Transfer & Stock Piling Operations in the Crude Oil Refining Industry.jpg"),
    "tags": [],
    "category": "Petroleum",
    "duration": "7 Days",
    "prerequisite": [
      "· Basic knowledge of crude oil refining processes and refinery operations.\n· Familiarity with industrial safety practices and process control.\n· Understanding of storage and handling principles for hydrocarbons."
    ],
    "methodology": "Theoretical",
    "objectives": [
      "Describe the current context and trends in the downstream oil industry.",
      "Understand crude oil refining processes and their relationship to stockpiling operations.",
      "Explain the role and importance of transfer and stockpiling operations in a refinery.",
      "Classify storage tanks and understand their selection criteria and operational considerations.",
      "Apply blending techniques for crude oil and refined products, including LPG, gasoline, fuel oil, and diesel.",
      "Manage flaring systems safely and in compliance with environmental regulations.",
      "Implement process safety management practices in transfer and stockpiling operations.",
      "Coordinate transfer and stockpiling operations with maintenance activities to enhance safety and efficiency.",
      "Apply asset integrity management principles to ensure reliable and safe operations.",
      "Manage the interface between refinery stockpiling operations and middle-stream companies effectively.",
      "Ensure safety and asset management in LPG and liquefied gas storage facilities.",
      "Oversee accurate metering and billing operations for refined products and crude."
    ],
    "outline": [
      "Module 1: Current Context of the Downstream Industry",
      "Module 2: Overview of Crude Oil Refining Processes",
      "Module 3: The Role of Transfer and Stockpiling Operations in a Crude Oil Refinery",
      "Module 4: Types and Classification of Storage Tanks",
      "Module 5: Blending Operations (Crude Oil, LPG, Gasoline, Fuel Oil, and Diesel)",
      "Module 6: Flaring Systems and How to Manage these Systems Adequately",
      "Module 7: Process Safety Management in Transfer and Stockpiling Operations",
      "Module 8: Calling the Attention to Transfer and Stockpiling Area – The Relation with Maintenance",
      "Module 9: Asset Integrity Management in Transfer and Stockpiling Sector",
      "Module 10: Managing the Interface between Refinery Stockpiling Operations and Middle Stream Companies",
      "Module 11: Process Safety and Asset Management in LPG and Liquefied Gas Storage Farm",
      "Module 12: Management of Metering and Billing Operations"
    ],
    "assessment": "Online Written Exam",
    "cdf": [
      "Classroom-based training",
      "Online courses",
      "In-house workshops",
      "On-the-job training"
    ],
    "cost": "₦500,000 / $450",
    "certification": "Certificate of Completion"
  },

  {
  "id": 111,
  "title": "Safety Devices for Protection Against Excessive Pressure (ISO 4126) Bursting Discs and Applications Course",
  "date": "Present",
  "description": [
    "This course provides a comprehensive study of safety devices designed to protect pressure equipment from excessive pressure, in line with the requirements of ISO 4126. Emphasis is placed on bursting disc safety devices, their materials, types, and associated components such as holders, supports, and seals. The course also explores specified bursting pressure requirements, inspection, testing, certification, and product designation as mandated by ISO standards.",
    "By the end of the program, participants will have the knowledge and skills to evaluate, select, and apply bursting disc devices in industrial systems, ensuring compliance with international safety and quality standards."
  ],
  "image": require("./coursesImg/Safety Devices for Protection Against Excessive Pressure (ISO 4126) Bursting Discs and Applications Course.jpg"),
  "tags": [],
  "category": "hazop hazid",
  "duration": "3 Days",
  "prerequisite": [
    "· A general understanding of process equipment (pressure vessels, piping, relief systems).\n· Basic knowledge of fluid mechanics and thermodynamics.\n· Familiarity with industrial safety standards (API, ASME, PED, or equivalent) is advantageous.\n· Engineering, operations, or maintenance background in oil & gas, petrochemical, chemical, or power sectors"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role and importance of safety devices in preventing overpressure hazards.",
    "Understand the scope and applications of bursting disc safety devices as defined by ISO 4126.",
    "Identify suitable materials for bursting discs, considering chemical compatibility, corrosion resistance, and temperature limits.",
    "Differentiate between types of bursting discs (forward-acting, reverse-acting, composite, etc.) and their operating principles.",
    "Describe the design and function of bursting disc holders, back pressure supports, temperature shields, and stiffening rings.",
    "Recognize the role of gaskets and seals in maintaining integrity of bursting disc assemblies.",
    "Apply correct assembly and installation practices to ensure safety and reliability.",
    "Interpret specified bursting pressure requirements and compliance criteria in ISO 4126.",
    "Understand manufacturer inspection requirements and quality assurance procedures.",
    "Explain test procedures (burst testing, proof testing, and other acceptance tests).",
    "Identify certification requirements for bursting disc devices under ISO 4126.",
    "Correctly interpret product designation and markings for compliance and traceability.",
    "Apply course knowledge to case studies and real-world scenarios in industrial safety systems."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Scope",
    "Module 3: Materials",
    "Module 4: Types of Bursting Discs",
    "Module 5: Bursting Disc Holders",
    "Module 6: Back Pressure Supports",
    "Module 7: Temperature Shields",
    "Module 8: Stiffening Rings",
    "Module 9: Gaskets/Seals",
    "Module 10: Assembly of Bursting Disc Safety Devices",
    "Module 11: Specified Bursting Pressure Requirements",
    "Module 12: Inspection by the Manufacturer",
    "Module 13: Test Procedures",
    "Module 14: Certification",
    "Module 15: Product Designation",
    "Module 16: Marking",
    "Module 17: Packaging and Storage"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 112,
  "title": "Advance Process Engineering and Design",
  "date": "Present",
  "description": [
    "The Advanced Process Engineering and Design course provides a comprehensive and practical foundation for engineers involved in the conceptual, basic, and detailed design of chemical and process plants. The program integrates core engineering principles with industry-relevant methodologies for designing major equipment, evaluating process alternatives, and developing efficient and safe process systems.",
    "Participants will learn how to analyze chemical processes, perform essential calculations, interpret process diagrams, and apply design correlations for heat exchangers, reactors, separation units, and utility systems. Through case studies and engineering examples, the course bridges theoretical concepts with real-world applications used in refineries, petrochemical plants, gas processing facilities, and pharmaceutical industries."
  ],
  "image": require("./coursesImg/Advance Process Engineering and Design Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "· Understanding of chemical engineering principles.\n· Knowledge of material and energy balances.\n· Familiarity with thermodynamics, fluid mechanics, and heat transfer.\n· Ability to interpret basic engineering drawings (PFDs and P&IDs).\n· Introduction to Process Engineering Course."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Apply advanced stoichiometric and process engineering principles to real industrial systems.",
    "Interpret and create process flow diagrams (PFDs) and piping and instrumentation diagrams (P&IDs).",
    "Design key process equipment including heat exchangers, distillation columns, extractors, reactors, absorbers, and piping systems.",
    "Evaluate fluid flow, pressure drop, and pumping system requirements.",
    "Perform equipment sizing and selection based on process data and industry standards.",
    "Develop utility system requirements for heating, cooling, steam, and compressed air systems.",
    "Conduct process troubleshooting and optimization using engineering correlations and best practices.",
    "Apply design principles to real-life case studies, improving decision-making, technical accuracy, and safety."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Stoichiometry",
    "Module 3: Process Engineering",
    "Module 4: Importance of process diagrams in Process Engineering",
    "Module 5: Process Design of Piping, fluid moving devices & Flow Meters",
    "Module 6: Process Design of Heat Exchangers",
    "Module 7: Process Design of Liquid-Liquid Extractors",
    "Module 8: Process Design of Distillation Columns",
    "Module 9: Process Design of Absorbers",
    "Module 10: Process Design of Rectors",
    "Module 11: Process Design of Utility Systems",
    "Module 12: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 113,
  "title": "Codes & Standards Course",
  "date": "Present",
  "description": [
    "The Codes & Standards Course provides a comprehensive introduction to the essential engineering codes, standards, guidelines, and recommended practices that govern the design, fabrication, inspection, and maintenance of process equipment and piping systems in the oil & gas, petrochemical, power, and industrial sectors.",
    "This course explains the structure, purpose, and application of major ASME and API codes, including pressure piping systems, boilers and pressure vessels, storage tanks, pressure-relief devices, heat exchangers, fired heaters, and risk-based inspection. Participants will learn how to interpret code requirements, understand compliance obligations, and apply standardized engineering practices to ensure safety, reliability, and regulatory conformity in projects and operations."
  ],
  "image": require("./coursesImg/CODES AND STANDARDS Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of engineering principles (mechanical, process, or chemical).\n· Familiarity with industrial equipment such as piping, vessels, and tanks.\n· Ability to read technical drawings (P&IDs, isometrics, datasheets).\nThis course is suitable for engineers, inspectors, designers, operators, maintenance personnel, and project professionals."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose, structure, and hierarchy of engineering codes, standards, regulations, specifications, and recommended practices.",
    "Recognize why codes and standards are essential for engineering safety, reliability, and compliance.",
    "Interpret ASME and API code requirements for pressure piping, pressure vessels, tanks, heaters, and relief systems.",
    "Apply key dimensional, design, and material requirements from ASME B31, B36, and B16 standards.",
    "Understand the design, fabrication, inspection, and testing requirements in the ASME Boiler and Pressure Vessel Code (BPVC).",
    "Describe API standards for equipment design: vessels, piping, heat exchangers, fired heaters, storage tanks, and pressure relief systems.",
    "Apply API inspection practices including Risk-Based Inspection (RBI), corrosion management, and material selection.",
    "Use codes and standards to ensure safe, efficient, and compliant engineering decisions."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Regulations Specifications Recommended Practice.",
    "Module 3: Why Codes And Standards Required",
    "Module 4: ASME B31 : Pressure Piping Codes",
    "Module 5: ASME B36 : Pipe Dimensions",
    "Module 6: ASME B16 : 4groupes",
    "Module 7: ASME BPVC : Boiler Pressure Vessel Codes",
    "Module 8: API : Pressure Vessels",
    "Module 9: API : Piping Systems",
    "Module 10: API : Fired Heaters",
    "Module 11: API : Heat Exchanger",
    "Module 12: API : Storage Tanks",
    "Module 13: API : Pressure Relief Devices",
    "Module 14: API : Risk Based Inspection",
    "Module 15: API : Corrosion And Material"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},
{
  "id": 114,
  "title": "Cryogenic Engineering",
  "date": "Present",
  "description": [
    "The Cryogenic Engineering Course provides a comprehensive foundation in the principles, technologies, and applications of extremely low-temperature systems. Participants will gain a thorough understanding of cryogenic fluids, refrigeration and liquefaction cycles, insulation strategies, measurement instrumentation, and the design and analysis of cryogenic systems. The course also emphasizes safety considerations, operational challenges, and applications of cryogenics in natural gas processing and LNG (Liquefied Natural Gas) facilities.",
    "This program is ideal for professionals working in oil & gas, LNG plants, petrochemical industries, hydrogen facilities, aerospace, and any sector where cryogenic operations and equipment are used."
  ],
  "image": require("./coursesImg/Cryogenic Engineering Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "· A basic understanding of thermodynamics, fluid mechanics, and heat transfer.\n· Familiarity with chemical or process engineering fundamentals.\n· Prior exposure to process plant operations or equipment design.\n· Ability to interpret P&IDs, process flow diagrams, and basic engineering documentation.\n· Basic mathematical and engineering calculation skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Perform key cryogenic calculations such as heat load estimation, thermal losses, and energy balances.",
    "Calculate thermophysical properties and predict phase behavior of cryogenic fluids.",
    "Explain the foundational concepts of cryogenics including low-temperature thermodynamics, Joule-Thomson effect, and gas liquefaction fundamentals.",
    "Understand temperature scales, cryogenic temperature ranges, and material behavior at low temperatures.",
    "Identify and describe the properties of major cryogenic fluids (LN2, LOX, LNG, LH2, helium, etc.).",
    "Evaluate thermodynamic characteristics and handling requirements of cryogenic substances.",
    "Understand refrigeration cycles used in cryogenic applications (Claude, Linde, Brayton, Mixed-Refrigerant Cycles).",
    "Analyze the principles of gas liquefaction and apply them to natural gas and industrial gases.",
    "Explain the importance of insulation in cryogenic systems and evaluate various insulation techniques (vacuum insulation, perlite, MLI, foam systems).",
    "Estimate heat ingress and understand the impact of insulation on system performance.",
    "Identify instrumentation used in cryogenic service including level measurement, pressure sensors, flow meters, and temperature devices.",
    "Understand selection criteria for materials and instrument types suited for ultra-low-temperature applications.",
    "Analyze cryogenic systems from an engineering perspective, including storage tanks, pipelines, vaporizers, and transfer systems.",
    "Perform system-level assessments for reliability, operability, and efficiency.",
    "Evaluate mechanical and thermal stresses associated with cryogenic operation.",
    "Understand the cryogenic processes involved in NG and LNG treatment, liquefaction, storage, and transport.",
    "Interpret process flow and equipment used in LNG trains, loading terminals, and regasification units.",
    "Identify hazards associated with cryogenic systems including thermal burns, oxygen deficiency, rapid phase transitions, material brittleness, BLEVE, and static electricity.",
    "Apply safety principles, PPE requirements, and industry best practices for cryogenic operations.",
    "Understand emergency shutdown (ESD) considerations and best practices for handling cryogenic releases."
  ],
  "outline": [
    "Module 1: Cryogenic Engineering Calculations",
    "Module 2: Basic Principles.",
    "Module 3: Cryogenic Fluids",
    "Module 4: Refrigeration and Liquefaction",
    "Module 5: Insulation",
    "Module 6: Cryogenic Instruments",
    "Module 7: Cryogenic Engineering and Cryogenic System Analysis",
    "Module 8: Natural Gas and Liquefied Natural Gas",
    "Module 9: Safety with Cryogenic System"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},
{
  "id": 115,
  "title": "Distillation Control & optimization",
  "date": "Present",
  "description": [
    "The Distillation Control & Optimization course provides a comprehensive understanding of how to effectively monitor, stabilize, and optimize distillation column operations in refineries, gas plants, petrochemical facilities, and chemical process industries. Participants will learn the principles of process dynamics, composition control, and pressure regulation, feed management, reflux handling>//, and advanced column control strategies that maximize separation efficiency and product quality.",
    "The course integrates fundamental distillation concepts with modern control techniques, enabling engineers and operators to diagnose performance issues, predict column behavior, and implement optimization strategies that reduce energy consumption, improve product yield, and enhance reliability. Participants will gain practical knowledge through real-world examples, industry best practices, and optimization workflows used in advanced plants.."
  ],
  "image": require("./coursesImg/Distillation Control & optimization Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of chemical engineering principles including heat and mass transfer.\n· Familiarity with distillation fundamentals (tray and packed columns).\n· Basic knowledge of process control (PID control, process variables).\n· Ability to read PFDs and P&IDs.\n\nThis course is suitable for operators, control room technicians, process engineers, optimization specialists, and operations supervisors."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe the operation, dynamics, and behavior of distillation columns.",
    "Understand the impact of pressure, reflux, feed conditions, and energy balance on separation.",
    "Apply various instrumentation and control strategies to stabilize column operation.",
    "Implement composition control using temperature, inferential, or analyzer-based systems.",
    "Analyze feed disturbances and their effect on product specifications and column stability.",
    "Apply pressure control methods to ensure safe and energy-efficient operations.",
    "Design effective reflux and reboiler control loops for improved separation.",
    "Understand column-wide control and interactions between top, bottom, and side-draw variables.",
    "Optimize distillation systems for minimum energy use while maintaining product quality.",
    "Apply optimization strategies to multi-product and complex distillation systems."
  ],
  "outline": [
    "Module 1: The process",
    "Module 2: Composition Control.",
    "Module 3: Pressure Control",
    "Module 4: Feed Control",
    "Module 5: Reflux Control",
    "Module 6: Column Control",
    "Module 7: Constant Separation",
    "Module 8: Multiple Product Distillation",
    "Module 9: Total Optimization"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 116,
  "title": "Flare KO Drum Sizing",
  "date": "Present",
  "description": [
    "The Flare Knockout (KO) Drum Sizing Course provides participants with a technical, practical, and code-aligned understanding of how to properly design and size flare knockout drums for oil & gas, refineries, petrochemical plants, and chemical processing facilities.",
    "Flare KO drums are essential safety components designed to remove liquids and condensable from relief and flare gas streams, protecting the flare header, flare stack, and overall plant safety system. This course covers design parameters, sizing fundamentals, liquid–vapor separation mechanisms, residence time calculations, disengagement velocities, and applicable standards.",
    "Participants will learn how to use sizing equations, perform sample calculations, and develop spreadsheet-based tools for field, engineering, and design office applications. The program concludes with real-world case studies to reinforce engineering judgment and troubleshooting skills."
  ],
  "image": require("./coursesImg/Flare KO Drum Sizing Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    "· Basic understanding of process engineering, thermodynamics, and fluid mechanics.\n· Familiarity with flare systems, relief load calculations, or process safety.\n· Ability to read PFDs, P&IDs, and equipment datasheets.\n· Basic experience with Excel or engineering calculation tools.\n\nSuitable for: Process engineers, safety engineers, design engineers, mechanical engineers, reliability/operations personnel, flare specialists, and anyone involved in flare system design or verification."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and function of flare KO drums in safety systems.",
    "Identify the types of KO drums (horizontal, vertical) and their typical applications.",
    "Describe how KO drums integrate within the flare header and relief network.",
    "Define key design inputs: relief loads, vapor properties, liquid properties, operating pressures and temperatures.",
    "Understand liquid disengagement, residence time, settling velocity, and droplet size considerations.",
    "Apply relevant standards for KO drum design requirements.",
    "Use the Souders–Brown equation for vapor–liquid separation.",
    "Determine disengagement velocity, allowable vapor velocity, and drum diameter/height.",
    "Evaluate minimum residence time requirements for liquid removal.",
    "Understand liquid surge volume, foam considerations, and inlet momentum limits.",
    "Perform step-by-step sizing of a vertical or horizontal KO drum.",
    "Use actual design inputs to determine vessel diameter, tangent-to-tangent length, and liquid levels.",
    "Prepare a summary datasheet for engineering documentation.",
    "Build a structured Excel spreadsheet for KO drum sizing.",
    "Automate vapor velocity, residence time, and vessel dimension calculations.",
    "Validate spreadsheet outputs against engineering standards.",
    "Analyze real plant scenarios with high relief loads, multiphase inputs, foaming fluids, or transient hydrodynamics.",
    "Evaluate common design and operational issues such as carryover, improper sizing, and inadequate surge volume.",
    "Apply engineering judgment to optimize existing KO drums or verify vendor designs."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Design Parameters.",
    "Module 3: Sizing Bases and Equations",
    "Module 4: Sample Calculation",
    "Module 5: Spreadsheet",
    "Module 6: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},
{
  "id": 117,
  "title": "Flare System Design",
  "date": "Present",
  "description": [
    "The Flare System Design Course provides a comprehensive and practical understanding of flare system engineering for oil & gas facilities, refineries, petrochemical plants, and chemical processing units. Flare systems are critical safety components that safely dispose of emergency relief gases, protect equipment integrity, and prevent catastrophic overpressure incidents.",
    "This course covers all major aspects of flare system design, including system components, vapor load determination, flare header design, knock-out drums, and flare stack sizing, radiation and noise considerations, and operational best practices. Participants will learn to apply API standards, conduct engineering calculations, evaluate flare capacity, and design flaring systems that meet safety, environmental, and regulatory requirements.",
    "The course integrates theory, design methodologies, and real engineering applications—ideal for both new and experienced engineers."
  ],
  "image": require("./coursesImg/Flare System Design Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of thermodynamics, fluid mechanics, and process engineering fundamentals.\n· Familiarity with relief systems, PFDs, and P&IDs.\n· Basic knowledge of units, process equipment, and engineering calculations.\n· Experience in plant operations, design engineering, or safety engineering.\n\nSuitable for: Process engineers, safety engineers, mechanical engineers, design engineers, flare specialists, reliability engineers, and operations personnel involved in relief and flare systems."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and importance of flare systems in process safety.",
    "Describe different types of flares (elevated, ground, enclosed, sonic, assisted).",
    "Understand how flare systems integrate with relief valves, headers, and disposal equipment.",
    "Identify major flare system components: Relief valves, Flare headers, KO drums, Seal drums, Flare stack, Pilots & ignition systems, Molecular seals, Steam/air/assist systems",
    "Understand the function and design role of each component.",
    "Determine relief loads from equipment using API 520/521.",
    "Calculate individual and combined loads for fire, blocked outlet, control failure, utility failures, and power outage scenarios.",
    "Analyze flare load during contingency vs. normal flaring.",
    "Identify multiphase relief conditions.",
    "Design flare headers and sub-headers for steady-state and dynamic conditions.",
    "Estimate line pressure drop, backpressure, and momentum limits.",
    "Understand hydrodynamic effects like slugs, two-phase flow, and erosion.",
    "Apply line sizing rules to meet API limits.",
    "Size flare stacks using API 537 and radiation models.",
    "Evaluate tip design, flame height, noise, smokeless capacity, and thermal radiation.",
    "Determine minimum separation distances using radiation modeling.",
    "Design and specify pilots, ignition systems, molecular seals, and steam/air assist systems.",
    "Understand wind loading and structural considerations.",
    "Evaluate environmental and regulatory requirements for flaring.",
    "Consider purge gas requirements, flare gas recovery systems, and smokeless operation.",
    "Assess dispersion modeling, noise levels, and flare flame stability.",
    "Review start-up, shutdown, and emergency considerations.",
    "Understand flare performance monitoring, troubleshooting, and maintenance.",
    "Identify common operational issues such as: Flameout, Pilot failure, Flashback, Carryover from KO drum, Excessive radiation or smoke",
    "Apply safe operating procedures and best practices."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Components of the Flare.",
    "Module 3: Determining Vapor Loads to be Flared",
    "Module 4: Design of Collection",
    "Module 5: Designing Flare Stack & Accessories",
    "Module 6: Other Design Considerations",
    "Module 7: Flare Operations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},
{
  "id": 118,
  "title": "PIPING AND INSTRUMENTATION DIAGRAM FOR PARAXYLENE RECOVERY UNIT",
  "date": "Present",
  "description": [
    "The Piping and Instrumentation Diagram for Paraxylene (PX) Recovery Unit Course provides a comprehensive, step-by-step understanding of how to read, interpret, and analyze P&IDs associated with a full paraxylene crystallization and separation plant. The course covers every major subsystem—from feed preparation and crystallization stages to centrifuges, filtration systems, refrigeration packages, nitrogen seal systems, and aromatics handling.",
    "Participants will learn how equipment, piping, control loops, safety systems, interconnections, and utilities are represented on P&IDs for a PX Recovery Unit. The course emphasizes functional understanding of process flow, instrumentation logic, isolation philosophy, pressure relief schemes, interlocks, nitrogen purging, hazardous area considerations, and operational sequences.",
    "This course is designed to strengthen competence in P&ID interpretation for engineers involved in PX plants, condensate splitters, aromatics complexes, and petrochemical production facilities where benzene–toluene–xylene (BTX) recovery plays a major role."
  ],
  "image": require("./coursesImg/PIPING AND INSTRUMENTATION DIAGRAM FOR PARAXYLENE RECOVERY UNIT Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "10 Days",
  "prerequisite": [
    "· Basic understanding of process engineering and petrochemical plant operations.\n· Familiarity with PFDs, P&IDs, symbols, and instrumentation tags.\n\nSuitable for: process engineers, operations personnel, piping engineers, instrumentation/control engineers, DCS engineers, and technical supervisors."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the objective, scope, and typical configuration of a PX Recovery Unit P&ID package.",
    "Identify key equipment groups: crystallizers, centrifuges, filtration, and refrigeration.",
    "Interpret drum internals, level control loops, vent/flare handling, and pump-out connections.",
    "Read heat exchanger arrangements, bypass lines, temperature control valves (TCVs), and safety devices.",
    "Understand clay reactor instrumentation, inlet/outlet piping, pressure control, and regeneration scheme.",
    "Analyze fractional distillation P&IDs, reflux system, reboiler heating loop, and tower control.",
    "Read drum control instrumentation, level control, vapor–liquid separation, and side-draw handling.",
    "Understand heater pass arrangements, firing controls (if applicable), inlet/outlet flow control, and interlocks.",
    "Interpret exchanger piping, dual service configurations, block valves, and temperature control.",
    "Identify air cooler / water cooler arrangements, fan controls, bypass options, and cooling medium connections.",
    "Understand crystallizer refrigeration circuits, jacket control, temperature loops, purge systems, and slurry withdrawal lines.",
    "Interpret centrifuge feed piping, speed control instrumentation, discharge handling, and safety systems.",
    "Understand nitrogen blanketing, seal pressure control, venting, and safety considerations.",
    "Learn pump arrangement, filters, coolers, instrumentation, and minimum flow requirements.",
    "Read slurry drum P&ID symbols, heater configurations, and level/temperature control.",
    "Interpret filtrate drum operation, pump-out system, venting, and nitrogen purging.",
    "Understand melt circulation, heat tracing, temperature control loops, and nitrogen seal.",
    "Learn separation philosophy and instrumentation associated with effluent collection.",
    "Read product separation P&IDs, control features, and safety devices.",
    "Interpret melt handling, heating loops, and discharge control.",
    "Understand second-stage filtrate separation and return stream management.",
    "Follow temperature control logic, slurry formation, and warm crystallization sequences.",
    "Identify piping connections, nitrogen systems, interlocks, and filtrate routing.",
    "Interpret three-stage filtrate separation and drum control.",
    "Understand handling of aromatic vapors, vent routing, odor control, and relief scenarios.",
    "Read vent gas cooling, nitrogen dilution, desuperheating systems, and flare routing.",
    "Understand refrigerant distribution, pressure control, relief links, and nitrogen purge interface.",
    "Analyze P&IDs for ethylene compressors, exchangers, separators, pumps, and instrumentation.",
    "Interpret propane cycle components: condensers, evaporators, controls, and safety systems.",
    "Read full lube oil skid instrumentation, filters, pressure control, and redundancy.",
    "Understand dry gas seal system, supply pressures, venting, and seal monitoring instrumentation.",
    "Interpret transfer pump systems, safety valves, refrigeration makeup, and isolation schemes."
  ],
  "outline": [
    "Module 1: introduction",
    "Module 2: feed surge drum.",
    "Module 3: c8+ feed preheating system",
    "Module 4: xylene clay tower",
    "Module 5: xylene splitter",
    "Module 6: xylene splitter receiver & sidecut Drum",
    "Module 7: xylene splitter reboiler heater",
    "Module 8: feed / filterate exchanger",
    "Module 9: feed cooler",
    "Module 10: first cold stage crystallizer - Line 1,2,3 & 4",
    "Module 11: first stage centrifuges",
    "Module 12: first stage centrifuges -nitrogen seal system",
    "Module 13: first stage centrifuges -lube oil system",
    "Module 14: slurry drum & slurry drum heater",
    "Module 15: first stage centrifuges and first filtrate drum",
    "Module 16: intermediate melt drum",
    "Module 17: screen effluent drum",
    "Module 18: second stage  product centrifuges",
    "Module 19: melt drum",
    "Module 20: second filtrate drum",
    "Module 21: warm stage crystallizer - line 1",
    "Module 22: second stage recovery centrifuges",
    "Module 23: third filtrate drums",
    "Module 24: aromatic sump / vent",
    "Module 25: cold aromatic sump / vent & desuperheating station",
    "Module 26: refrigeration system & low pressure nitrogen header",
    "Module 27: refrigeration package -ethylene refrigeration unit",
    "Module 28: refrigeration package -propane refrigeration unit",
    "Module 29: refrigeration package -lube oil system",
    "Module 30: refrigeration package – gas seal module",
    "Module 31: refrigeration package -transfer unit"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦800,000 / $700",
  "certification": "Certificate of Completion"
},
{
  "id": 119,
  "title": "Process Analysis and Simulation in Chemical",
  "date": "Present",
  "description": [
    "This course provides a comprehensive foundation in the principles and applications of process modeling, simulation, and analysis as used in modern chemical engineering. Participants will learn how to apply simulation tools to design, evaluate, and optimize chemical processes.",
    "The course covers key areas including thermodynamic modeling, equipment sizing, separation processes, heat integration, reactor modeling, and dynamic simulation. Through case studies and practical examples, learners will build the skills needed to analyze process performance, troubleshoot operating problems, and improve process efficiency and safety.",
    "This training prepares engineers and students to confidently use process simulators in industry projects, R&D activities, and plant operational support."
  ],
  "image": require("./coursesImg/Process Analysis and Simulation in Chemical Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "10 Days",
  "prerequisite": [
    "· Basic understanding of chemical engineering principles.\n· Introductory knowledge of thermodynamics and transport phenomena.\n· Familiarity with unit operations (heat exchangers, pumps, reactors, distillation, etc.).\n· Basic computer literacy and comfort with engineering software tools.\n\nThe course starts from foundational concepts, so motivated beginners can follow as well."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define process simulation and explain its importance in chemical plant design, optimization, and troubleshooting.",
    "Identify the capabilities and limitations of commercial simulation software.",
    "Select appropriate thermodynamic models for vapor–liquid, liquid–liquid, and gas–solid systems.",
    "Understand the impact of property methods on accuracy of simulation results.",
    "Analyze phase behavior and perform property estimation.",
    "Simulate pumps, compressors, blowers, valves, and piping networks.",
    "Analyze energy requirements, pressure drops, and fluid flow behavior.",
    "Understand equipment performance curves and their integration into simulations.",
    "Model shell-and-tube exchangers, heaters, coolers, and condensers.",
    "Perform energy analysis and evaluate heat recovery opportunities.",
    "Apply heat integration strategies to reduce energy consumption.",
    "Model common reactor types: CSTR, PFR, batch reactors, and catalytic reactors.",
    "Apply reaction kinetics and thermodynamics to predict reactor performance.",
    "Perform sensitivity studies on conversion, selectivity, and yield.",
    "Simulate distillation columns, absorption towers, flash drums, and scrubbers.",
    "Understand tray and packing performance models.",
    "Optimize separation efficiency and energy usage.",
    "Identify process bottlenecks using sensitivity analysis.",
    "Apply optimization tools to minimize energy use, maximize throughput, or improve product purity.",
    "Understand the trade-offs between cost, safety, and environmental impact.",
    "Build dynamic models for startup, shutdown, and transient behavior.",
    "Evaluate control strategies and identify system instabilities.",
    "Simulate plant responses to disturbances and equipment malfunctions.",
    "Simulate solid–liquid separation, filtration, drying, crystallization, and particle transport.",
    "Apply models for slurry systems and solid-phase thermodynamics.",
    "Solve real-world industrial problems using process simulators.",
    "Interpret simulation outputs to support decision-making in design and operations.",
    "Present integrated analyses with optimized process solutions."
  ],
  "outline": [
    "Module 1: Process Simulation in Chemical Engineering",
    "Module 2: Thermodynamic and Property Models.",
    "Module 3: Fluid Handling Equipment",
    "Module 4: Heat Exchange Equipment and Heat Integration",
    "Module 5: Chemical Reactors",
    "Module 6: Gas–Liquid Separation Operations.",
    "Module 7: Process Optimization in Chemical Engineering",
    "Module 8: Dynamic Process Analysis",
    "Module 9: Solids Operations in Process Simulators",
    "Module 10: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦400,000 / $350",
  "certification": "Certificate of Completion"
},
{
  "id": 120,
  "title": "Process Design of Flare and Blowdown",
  "date": "Present",
  "description": [
    "This course provides a detailed and practical understanding of the design, analysis, and operation of flare and blowdown systems in oil, gas, petrochemical, and refinery facilities. Participants will learn how to design safe and efficient blowdown networks capable of handling emergency depressurization, overpressure protection, and safe disposal of hydrocarbons.",
    "The course covers the fundamentals of flare system configuration, blowdown system selection, flare load estimation, header sizing, knockout drum design, liquid level determination, and flare stack sizing. It also integrates industry standards and relevant ASME codes.",
    "Engineers will gain the knowledge needed to evaluate existing facilities, troubleshoot operational issues, and design new flare and blowdown systems that meet safety, environmental, and regulatory requirements.."
  ],
  "image": require("./coursesImg/Process Design of Flare and Blowdown Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic knowledge of chemical or process engineering principles.\n· Understanding of pressure relief devices (PSVs, PRVs) and overpressure scenarios.\n· Familiarity with fluid flow, phase behavior, and thermodynamics.\n· Basic knowledge of equipment such as vessels, separators, compressors, and piping.\n· Prior exposure to process simulation tools.\n\nThe course is structured to accommodate intermediate-level learners but accessible to motivated beginners."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Explain the purpose and function of flare and blowdown systems in process plants.",
    "Identify typical flare system configurations and components.",
    "Understand regulatory requirements and safety considerations.",
    "Distinguish between various types of blowdown systems (cold blowdown, hot blowdown, staged blowdown).",
    "Determine the best blowdown strategy based on process conditions and fluid properties.",
    "Evaluate risks, disposal loads, and equipment constraints during system selection.",
    "Identify and design key flare system components such as: Flare stack, Seal drum, Knockout drum, Liquid seal, Flare tip",
    "Understand design margins, safety factors, and performance requirements.",
    "Evaluate combustion efficiency and radiation limits.",
    "Calculate flare load contributions from individual process units.",
    "Apply pressure drop calculations for flare headers and sub-headers.",
    "Address two-phase flow challenges and dynamic blowdown effects.",
    "Ensure system capacity under emergency relief conditions.",
    "Determine the required liquid handling capacity.",
    "Apply design criteria for vertical and horizontal knockout drums.",
    "Understand separation efficiency, droplet size requirements, and residence time.",
    "Evaluate internal configurations for optimal performance.",
    "Perform accurate liquid level calculations during blowdown events.",
    "Understand vessel geometry, holdup volume, and disengagement height.",
    "Prevent liquid carryover by correct estimation of surge levels.",
    "Apply API 521 guidelines for vessel sizing and level determination.",
    "Estimate required flare tip diameter based on flow rate and molecular weight.",
    "Calculate flame height, radiation contours, momentum limits, and noise levels.",
    "Design flare stacks for both smokeless and non-smokeless operation.",
    "Perform step-by-step sizing calculations as part of a final design example."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Selection of Blowdown Systems.",
    "Module 3: Design of Disposal System Components",
    "Module 4: Vapor Relief Header Sizing",
    "Module 5: Sizing a Knockout Drum",
    "Module 6: Determination of Liquid level in a Horizontal Vessel",
    "Module 7: Sample Calculation for Sizing a Flare Stack"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 121,
  "title": "Process Plant Design and Simulation",
  "date": "Present",
  "description": [
    "The Process Plant Design and Simulation Course provides a comprehensive, hands-on introduction to the principles, methodologies, and tools used in modern process engineering design, with a strong focus on simulation software such as Aspen HYSYS and Aspen EDR. This course bridges engineering theory with practical, real-world plant design workflows covering fluid flow, heat transfer, equipment sizing, dynamic modeling, and optimization.",
    "Participants will learn how to evaluate design conditions, generate key process deliverables, perform equipment and line sizing, and simulate complex operations such as distillation, heat exchange, and relief systems. The course progresses from foundational design concepts to advanced simulation tasks including dynamic modeling and process optimization using the Aspen suite.",
    "Ideal for process engineers, operations engineers, project engineers, and technical professionals involved in process design, optimization, and plant engineering."
  ],
  "image": require("./coursesImg/Process Plant Design and Simulation Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "12 Days",
  "prerequisite": [
    "· A fundamental understanding of chemical engineering principles (mass & energy balance, thermodynamics, fluid mechanics).\n· Basic familiarity with process equipment (pumps, valves, heat exchangers, separators, columns).\n· Basic exposure to Aspen HYSYS or other simulation tools.\n· Computer literacy and ability to work with engineering software.\n\nSuitable for early-career process engineers, senior students, plant engineers, and professionals involved in design or operations."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define process design stages and deliverables.",
    "Evaluate design basis, operating envelopes, and boundary conditions.",
    "Understand codes, standards, and typical engineering workflows.",
    "Navigate Aspen HYSYS and Aspen EDR environments confidently.",
    "Select appropriate thermodynamic packages for various systems.",
    "Build steady-state and dynamic simulation models.",
    "Perform Engineering Calculations Using Aspen HYSYS",
    "Size process lines based on simulation results (Module 5).",
    "Calculate pump head, NPSH, and pump selection using Aspen tools (Module 6).",
    "Size control valves using the control valve sizing environment (Module 7).",
    "Perform orifice plate sizing for flow measurement (Module 8).",
    "Size separators based on droplet settling and residence time criteria (Module 9).",
    "Size heat exchangers using Aspen EDR with mechanical and thermal design considerations (Module 10).",
    "Design and rate distillation columns with tray/packing design (Module 11).",
    "Size pressure safety valves (PSVs) in compliance with design scenarios (Module 13).",
    "Create process plant design models integrating equipment, utilities, and process streams (Module 14).",
    "Use simulation for debottlenecking, troubleshooting, and performance evaluation.",
    "Identify key process variables and constraints.",
    "Perform sensitivity analysis and parameter optimization.",
    "Improve energy efficiency, throughput, or operational stability (Module 12).",
    "Understand dynamics, control loops, and transient behavior.",
    "Develop simple dynamic models (Module 15).",
    "Execute a full dynamic study for a project-level problem (Module 16), including:\n· Startup and shutdown modeling\n· Control loop testing\n· Scenario analysis and safety evaluation",
    "Produce process calculations and reports directly from simulations.",
    "Develop PFD-level design documentation.",
    "Interpret and validate simulation results for engineering decisions."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Design condition evaluation.",
    "Module 3: Process deliverables",
    "Module 4: Process simulation software",
    "Module 5: Line sizing using Aspen HYSYS",
    "Module 6: Pump sizing using Aspen HYSYS",
    "Module 7: Control valve sizing using Aspen HYSYS",
    "Module 8: Orifice sizing using aspen HYSYS",
    "Module 9: Separator sizing using Aspen HYSYS",
    "Module 10: Heat exchanger sizing using Aspen EDR",
    "Module 11: Distillation column sizing using Aspen HYSYS",
    "Module 12: Optimizer in Aspen HYSYS",
    "Module 13: PSV sizing using Aspen HYSYS",
    "Module 14: Process plant design using Aspen HYSYS",
    "Module 15: Aspen HYSYS Dynamics – Simple problem",
    "Module 16: Aspen HYSYS Dynamics – Project Problem"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦500,000 / $450",
  "certification": "Certificate of Completion"
},
{
  "id": 122,
  "title": "SULPHUR RECOVERY UNIT (SRU)",
  "date": "Present",
  "description": [
    "The Sulphur Recovery Unit (SRU) course provides comprehensive technical knowledge of the Claus process and related tail gas treatment systems used in refineries, gas plants, and petrochemical facilities. The course covers SRU fundamentals, process flow, operating principles, equipment functionality, process control philosophy, safeguarding systems, and operational best practices aimed at achieving safe, efficient, and environmentally compliant Sulphur recovery.",
    "Participants will develop a strong understanding of reaction chemistry, thermal and catalytic stages, incineration, emissions management, and troubleshooting methods. Emphasis is placed on safety systems, fire & gas detection, HSE requirements, and cause-and-effect analysis critical for reliable SRU operation. The course also introduces relevant codes, standards, and reference documents that guide SRU design and operation."
  ],
  "image": require("./coursesImg/SULPHUR RECOVERY UNIT (SRU) Course.jpg"),
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic knowledge of chemical or process engineering.\n· Familiarity with refinery or gas plant operations.\n· Understanding of process instruments, PFDs, and P&IDs.\n· Awareness of safety systems such as ESD, F&G, and permit-to-work processes.\n\nThis course is suitable for process engineers, operators, control room personnel, technologists, HSE professionals, and maintenance engineers involved in Sulphur recovery operations."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the fundamental concepts and purpose of Sulphur Recovery Units in oil and gas facilities.",
    "Describe the main steps and chemical reactions in the Claus process.",
    "Interpret SRU process flow diagrams and identify major equipment.",
    "Understand the control philosophy of key SRU components (burner control, air/fuel ratio control, temperature control, reactor control, etc.).",
    "Explain safeguarding devices, shutdown systems, and protective instrumentation.",
    "Recognize the purpose and functioning of fire & gas detection systems in SRU.",
    "Apply quality control measures to ensure proper sulphur purity and emissions compliance.",
    "Analyze cause-and-effect matrices and understand how SRU responds to abnormal conditions.",
    "Apply safe operating practices and troubleshooting procedures for SRU units.",
    "Understand HSE requirements including hazardous areas, toxic gas management (H₂S/SO₂), emergency response, and safe maintenance practices.",
    "Use reference documents and standards related to SRU operation and maintenance."
  ],
  "outline": [
    "Module 1: General Description",
    "Module 2: Process Flow Description.",
    "Module 3: Process control",
    "Module 4: Safeguarding devices",
    "Module 5: Fire & Gas Systems",
    "Module 6: Quality control",
    "Module 7: Causes and effect",
    "Module 8: Operating practices",
    "Module 9: HSE",
    "Module 10: Reference documents index"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $220",
  "certification": "Certificate of Completion"
},
{
  "id": 123,
  "title": "Chemical and Process Plant Commissioning Phase 1 (Prepare)",
  "date": "Present",
  "description": [
    "The Chemical and Process Plant Commissioning Phase 1 (Prepare) course provides a structured foundation for planning, organizing, and preparing the essential activities required before on-site commissioning begins. This phase focuses on the administrative, technical, contractual, and organizational elements necessary to ensure safe, efficient, and successful commissioning execution.",
    "Participants will learn how to define commissioning scope, develop documentation, create commissioning plans, establish team structures, prepare training materials and SOPs, determine systemization priorities, and set up administrative frameworks including tagging systems, handover procedures, and scheduling.",
    "This course is designed to build competency for engineers, supervisors, and commissioning team members responsible for transforming a constructed plant into a fully operational facility through systematic preparation."
  ],
  "image": require("./coursesImg/Chemical and Process Plant Commissioning Phase 1.jpg"),
  "tags": [],
  "category": "commissioning",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic understanding of process engineering, plant operations, or project engineering.\n· Familiarity with P&IDs, process flow diagrams, and equipment functions.\n· Awareness of project execution phases (design, construction, pre-commissioning, commissioning).\n· Knowledge of basic HSE requirements in industrial environments.\n· Experience in plant operations, EPC projects, or commissioning is helpful but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the importance of appointing a Commissioning Manager and outline the associated responsibilities.",
    "Define commissioning scopes, interfaces, and contractual boundaries with EPC, OEMs, and subcontractors.",
    "Establish team composition, roles, responsibilities, and an organizational structure for commissioning.",
    "Develop a high-level commissioning plan or philosophy aligned with project execution timelines.",
    "Understand budgeting principles for commissioning activities, manpower, logistics, and consumables.",
    "Create a prioritized asset systemization strategy to ensure structured and safe commissioning sequencing.",
    "Identify documentation requirements for mechanical, electrical, instrument, and control commissioning.",
    "Build and manage a commissioning documentation library including electronic filing systems.",
    "Develop system files, checklists, forms, and standard operating documents essential.",
    "Interpret design documents to identify commissioning support requirements such as utilities, temporary systems, and equipment readiness.",
    "Prepare assignment details, site office needs, manpower plans, and procurement lists for commissioning chemicals & consumables.",
    "Create clear and structured Standard Operating Procedures (SOPs) for plant operation and commissioning activities.",
    "Develop training materials to support onboarding of operators, technicians, and commissioning staff.",
    "Produce a consistent table of contents and document descriptions for commissioning manuals.",
    "Build a detailed commissioning schedule that integrates with project timelines and system completions.",
    "Design a commissioning tagging system for tracking equipment status, punch lists, and readiness.",
    "Formulate a clear and systematic handover procedure between construction, commissioning, and operations.."
  ],
  "outline": [
    "Module 1: Appointing the Commissioning Manager",
    "Module 2: Commissioning Scope and Contracts.",
    "Module 3: Contracts",
    "Module 4: Budget Estimation",
    "Module 5: Prioritized Asset Systemization",
    "Module 6: Support Design",
    "Module 7: Develop an Initial Commissioning Plan or Philosophy",
    "Module 8: Appointment, Composition of the Commissioning Team, Roles, Responsibilities and Organization Chart",
    "Module 9: Documentation and Sign-Off Requirements, the Library andElectronic Filing",
    "Module 10: Devise Assignment Details, Site and Office Requirements, Consumables and Procure Commissioning Chemicals",
    "Module 11: Create Commissioning Documents and the System File",
    "Module 12: Control, Instrument, Electrical Commissioning DocumentPreparation",
    "Module 13: Mechanical Commissioning Document Preparation",
    "Module 14: Develop Training Materials",
    "Module 15: Develop Standard Operating Procedures (SOPs)",
    "Module 16: Table of Contents Descriptions",
    "Module 17: Develop Commissioning Schedule",
    "Module 18: Devise Handover Procedure.",
    "Module 19: Devise Commissioning Tagging System"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},
{
  "id": 124,
  "title": "Chemical and Process Plant Commissioning Phase 2 (Implement)",
  "date": "Present",
  "description": [
    "The Chemical and Process Plant Commissioning – Phase 2 (Implement) course focuses on the practical execution of commissioning activities following the planning and preparation completed in Phase 1. This phase involves hands-on implementation, verification of equipment integrity, adherence to safety requirements, and readiness for safe initial start-up.",
    "Participants will learn how to conduct Factory Acceptance Tests (FAT), verify construction completion, manage system status tracking, perform cleaning and pre-commissioning activities, complete instrument and electrical testing, implement punchlist management, and execute mechanical completion handover. The course also covers leak testing, safe introduction of chemicals, and initial start-up procedures leading to formal handover to operations.",
    "This program equips engineers, technicians, supervisors, and commissioning teams with the technical and operational competencies required to safely transition a newly built plant to operational readiness."
  ],
  "image": require("./coursesImg/Chemical and Process Plant Commissioning Phase 2.jpg"),
  "tags": [],
  "category": "commissioning",
  "duration": "5 Days",
  "prerequisite": [
    "· Completion of Chemical & Process Plant Commissioning – Phase 1 (Prepare) or equivalent industry experience.\n· Solid understanding of process equipment, instrumentation, electrical systems, and P&IDs.\n· Knowledge of construction quality checks and mechanical completion requirements.\n· Familiarity with industry safety standards, including lockout/tagout (LOTO), permit-to-work (PTW), and hazard analysis.\n· Experience in plant operations, EPC projects, maintenance, or testing is an advantage."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Conduct Factory Acceptance Testing (FAT) for mechanical, electrical, and control equipment.",
    "Verify construction quality, installation integrity, and adherence to project specifications.",
    "Complete vessel check sheets, equipment inspection forms, and system verification checklists.",
    "Track progress using system status reports, punchlists, and mechanical completion certificates.",
    "Identify, categorize, and clear commissioning punchlist items.",
    "Ensure smooth transition from construction to commissioning through formal handover requirements.",
    "Apply industry-standard cleaning methods such as air blowing, steam blowing, chemical cleaning, and drying procedures.",
    "Implement pre-commissioning procedures for piping systems, equipment, and utilities.",
    "Conduct engineering checks to ensure system readiness for commissioning.",
    "Perform instrument loop checks, function tests, and calibration activities.",
    "Carry out electrical testing on motors, MCCs, transformers, and power distribution systems.",
    "Validate control system logic, interlocks, alarms, and operator interface functionality.",
    "Conduct Pre-Commissioning HAZOP or Pre-Start-Up Safety Reviews (PSSR).",
    "Apply safe practices for the introduction of chemicals, utilities, and process fluids.",
    "Prepare safety documentation, checklists, and risk mitigation actions.",
    "Conduct pressure testing, nitrogen leak testing, and tightness checks.",
    "Follow commissioning and initial start-up procedures including warm-up, circulation, flushing, and system activation.",
    "Troubleshoot common issues encountered during start-up.",
    "Prepare final documentation, commissioning dossiers, and turnover packages.",
    "Coordinate with operations for functional testing, operator training, and process handover.",
    "Ensure all systems meet performance criteria before final acceptance."
  ],
  "outline": [
    "Module 1: Factory Acceptance Testing",
    "Module 2: Check Construction and Quality of Build.",
    "Module 3: Tracking Progress and System Status",
    "Module 4: Cleaning Procedures and Drying",
    "Module 5: Pre-Commissioning Procedures",
    "Module 6: Vessel Check Sheets",
    "Module 7: Instrument Loop, Electrical and Control System Testing",
    "Module 8: Commissioning Punchlisting",
    "Module 9: Handover from Construction to Commissioning",
    "Module 10: Introduction of Safe Chemicals",
    "Module 11: Pre-Commissioning HAZOP Studies or Pre-Start-Up Safety",
    "Module 12: Commissioning Leak Testing",
    "Module 13: Commissioning and Initial Start-Up Plus Procedures",
    "Module 14: Handover to Operations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $250",
  "certification": "Certificate of Completion"
},

{
  "id": 125,
  "title": "Chemical and Process Plant Commissioning Phase 3 (Close Out)",
  "date": "Present",
  "description": [
    "The Chemical and Process Plant Commissioning – Phase 3 (Close-Out) course focuses on completing all activities required after successful commissioning and initial start-up of a process plant. This phase ensures that all outstanding technical issues are resolved, documentation is finalized, operating procedures are updated, and knowledge is fully transferred to the operations team.",
    "Participants will gain expertise in closing technical reservations, preparing the final commissioning dossier, validating “as commissioned” documentation, supporting early operational troubleshooting, conducting close-out safety reviews, and formally disbanding the commissioning team. The course also covers the creation and organization of a comprehensive Commissioning System File, containing standardized and blank commissioning documents for future reference.",
    "This program is essential for commissioning engineers, operations teams, supervisors, and project personnel involved in ensuring a smooth transition from commissioning to long-term, stable plant operation."
  ],
  "image": require("./coursesImg/Chemical and Process Plant Commissioning Phase 3.jpg"),
  "tags": [],
  "category": "commissioning",
  "duration": "5 Days",
  "prerequisite": [
    "· Completion of Phase 1 (Prepare) and Phase 2 (Implement) of commissioning, or equivalent field experience.\n· Solid understanding of commissioning processes, start-up procedures, and mechanical completion.\n· Ability to interpret P&IDs, cause-and-effect charts, and operating instructions.\n· Basic familiarity with operational troubleshooting and plant optimization.\n· Experience in process, mechanical, or instrumentation engineering is highly beneficial."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Identify all open reservations, outstanding punch items, overrides, and temporary modifications.",
    "Document, track, and close each reservation to ensure full technical compliance.",
    "Confirm that systems meet design and operational performance requirements.",
    "Compile all commissioning records, test results, certificates, and checklists.",
    "Prepare a complete commissioning dossier in compliance with project and regulatory standards.",
    "Organize documentation into accessible, structured electronic and physical formats.",
    "Revise training modules, manuals, and competency documents to reflect the actual commissioned state.",
    "Update cause-and-effect logic, system descriptions, and commissioning logs.",
    "Ensure that operators and technical staff receive updated, accurate training.",
    "Modify SOPs, emergency procedures, and working instructions using actual commissioning outcomes.",
    "Document lessons learned and integrate them into final operational procedures.",
    "Ensure alignment between operations documentation and the plant’s final configuration.",
    "Assist operations during early production to resolve process issues and stabilize performance.",
    "Identify bottlenecks and inefficiencies and provide improvement recommendations.",
    "Use commissioning experience to improve plant reliability, throughput, and safety.",
    "Formally release commissioning personnel, finalize contracts, and reassign roles.",
    "Complete team debriefing, generate lessons learned, and perform final review meetings.",
    "Transfer responsibilities fully to the operations and maintenance teams.",
    "Perform a Post-Commissioning HAZOP, PSSR, or operational hazard review.",
    "Verify safety-critical systems (SIS, alarms, interlocks) operate correctly under actual conditions.",
    "Identify ongoing safety recommendations for long-term follow-up.",
    "Compile a full catalogue of blank commissioning documents including templates, forms, checklists, test sheets, and procedures.",
    "Ensure future commissioning teams have standardized documents for modifications or new systems.",
    "Create an indexed and searchable commissioning system file for long-term use."
  ],
  "outline": [
    "Module 1: Close Out Reservations",
    "Module 2: Complete Commissioning Documentation.",
    "Module 3: Complete Training and Update Documents to “As Commissioned”",
    "Module 4: Update Operating Procedures to “As Commissioned”.",
    "Module 5: Assist Continued Operation, Troubleshooting and/or De-bottlenecking Projects",
    "Module 6: Close Down the Commissioning Team",
    "Module 7: Complete Close-Out Hazard Study",
    "Module 8: Commissioning System File, a Full Catalogue of Blank Commissioning Documents"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦280,000 / $250",
  "certification": "Certificate of Completion"
},
{
  "id": 126,
  "title": "Duct Systems Design",
  "date": "Present",
  "description": [
    "The Duct Systems Design Course provides a comprehensive understanding of air distribution system design for HVAC applications in industrial, commercial, and residential buildings. The course covers fundamental airflow principles, duct design methodologies, material selection, acoustics, and the interaction between fans and ductwork to ensure efficient, safe, and reliable system performance.",
    "Participants will learn how to apply industry-standard duct design methods, analyze system pressure losses, and specify appropriate construction materials based on environmental and performance requirements. By the end of the course, learners will be equipped with practical skills to design, optimize, and troubleshoot duct systems across a wide range of engineering applications."
  ],
  "image": require("./coursesImg/Duct Systems Design Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "· A basic understanding of HVAC principles or thermal-fluid sciences.\n· Familiarity with airflow, pressure, and heat transfer fundamentals.\n· Ability to read mechanical drawings, duct layouts, and building blueprints.\n· Engineering mathematics skills for performing duct sizing and pressure drop calculations."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose of air distribution systems within HVAC.",
    "Identify the types of duct systems and their applications in different building environments.",
    "Explain key concepts such as airflow, pressure, friction losses, velocity, and duct sizing principles.",
    "Apply basic fluid mechanics principles to duct design.",
    "Recognize factors affecting duct system performance including space constraints, comfort requirements, energy efficiency, and noise levels.",
    "Select appropriate duct configurations and layout strategies.",
    "Apply the equal friction method to size duct networks.",
    "Determine friction rate, pressure losses, and duct dimensions using standard charts and formulas.",
    "Understand the static regain approach for balancing large or complex duct systems.",
    "Use static regain principles to reduce fan energy and improve system uniformity.",
    "Apply the constant velocity method for areas requiring predictable velocities.",
    "Identify situations where this method is more effective (e.g., exhaust, high-contaminant environments).",
    "Analyze how fans interact with ductwork, including system resistance curves and fan performance curves.",
    "Evaluate the impact of duct design on fan efficiency, noise, and energy use.",
    "Identify materials commonly used for duct construction such as galvanized steel, aluminum, fiberglass, and flexible ducts.",
    "Understand the selection criteria based on temperature, pressure, environment, and cost.",
    "Review construction standards, leakage classes, and SMACNA guidelines.",
    "Understand sources of noise in duct systems and how design impacts acoustics.",
    "Apply noise control strategies including duct lining, silencers, velocity limitations, and proper layout."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Duct Design Fundamentals.",
    "Module 3: Duct Design Considerations",
    "Module 4: Equal Friction Method",
    "Module 5: Static Regain Method",
    "Module 6: Constant Velocity Method",
    "Module 7: Fan-Duct System Interaction",
    "Module 8: Duct System Materials And Construction",
    "Module 9: Duct System Acoustics"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},
{
  "id": 127,
  "title": "Fitness for Service and Integrity of Piping Vessels and Tanks",
  "date": "Present",
  "description": [
    "The Fitness for Service (FFS) and Integrity of Piping, Vessels, and Tanks Course provides an in-depth understanding of the assessment techniques, design principles, degradation mechanisms, and inspection strategies used to ensure the safe and reliable operation of pressurized equipment in oil & gas, refineries, petrochemicals, power plants, and storage terminals.",
    "This course focuses on the methodologies in API 579/ASME FFS-1, API 510, API 570, API 653, ASME Section VIII, and related integrity codes to evaluate the continued suitability of equipment affected by degradation such as corrosion, thinning, cracking, creep, geometric distortion, dents, buckling, and overload.",
    "Participants will gain practical skills to analyze inspection data, perform FFS evaluations, determine risk, recommend repairs, and support integrity management programs. The course blends theoretical knowledge with real field case studies, enabling engineers and inspectors to make informed decisions about equipment safety and operability."
  ],
  "image": require("./coursesImg/Fitness for service and integrity of piping vessels and tanks Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "Basic understanding of pressure vessels, piping systems, and storage tanks.\n· Familiarity with mechanical integrity principles, inspection practices, or maintenance engineering.\n· Ability to interpret engineering drawings, inspection reports, and NDT results.\n· Background in mechanical engineering, materials engineering, or process engineering.\n· Awareness of industry codes such as API, ASME, and NACE.\nSuitable for: Inspection engineers, integrity engineers, reliability engineers, maintenance personnel, plant engineers, QA/QC inspectors, and anyone involved in asset integrity or mechanical integrity programs."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the fundamentals of Fitness for Service (FFS) assessments.",
    "Explain Level 1, 2, and 3 evaluations as defined in API 579.",
    "Describe the overall integrity management lifecycle.",
    "Identify material properties relevant to pressure equipment integrity.",
    "Understand how temperature, loading, and metallurgy influence material behavior.",
    "Recognize material degradation responses under various service conditions.",
    "Interpret design requirements from ASME Section VIII and piping/tank standards.",
    "Understand stress analysis, failure margins, and pressure–temperature limitations.",
    "Evaluate the impact of design assumptions on long-term integrity.",
    "Describe fabrication processes such as welding, forming, heat treatment, and machining.",
    "Identify fabrication-related defects and their effect on equipment integrity.",
    "Understand quality control and documentation requirements.",
    "Recognize different degradation mechanisms, including corrosion, SCC, erosion, fatigue, embrittlement, and oxidation.",
    "Match degradation modes with corresponding FFS assessment procedures.",
    "Understand the principles of inspection planning, NDT methods, and inspection intervals.",
    "Interpret inspection data for FFS assessments.",
    "Apply RBI (Risk-Based Inspection) concepts to prioritize inspection activities.",
    "Evaluate uniform and local metal loss using API 579 Part 4 and Part 5.",
    "Calculate required remaining thickness and remaining life.",
    "Assess the impact of corrosion rates and predict future condition.",
    "Assess dents, gouges, bulges, misalignment, out-of-roundness, local deformations, and other geometric distortions.",
    "Apply geometric tolerances and design acceptance limits.",
    "Understand crack mechanisms such as fatigue, SCC, thermal cracking, and hydrogen-induced cracking.",
    "Perform FFS evaluations for planar flaws using fracture mechanics principles.",
    "Evaluate high-temperature creep behavior in piping and vessels.",
    "Identify creep indicators and quantify creep damage progression.",
    "Perform FFS assessments based on API 579 creep procedures.",
    "Analyze overload events such as overpressure, mechanical impacts, excessive vibration, or thermal shocks.",
    "Determine the structural impact and define safe operating limits after an event.",
    "Perform root cause analysis (RCA) for mechanical failures.",
    "Understand failure modes, fracture characteristics, and metallographic evaluation.",
    "Recommend corrective and preventive actions based on findings.",
    "Select appropriate repair techniques for degraded equipment based on API 510/570/653 and ASME PCC-2.",
    "Understand temporary vs. permanent repairs.",
    "Verify suitability of weld repairs, mechanical clamps, composite wraps, and alteration procedures."
  ],
  "outline": [
    "Module 1: Principles",
    "Module 2: Materials.",
    "Module 3: Design",
    "Module 4: Fabrication",
    "Module 5: Degradation",
    "Module 6: Inspection",
    "Module 7: Thinning",
    "Module 8: Geometric Defects",
    "Module 9: Cracks",
    "Module 10: Creep Damage",
    "Module 11: Overload",
    "Module 12: Failure Analysis",
    "Module 13: Repairs"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $250",
  "certification": "Certificate of Completion"
},
{
  "id": 128,
  "title": "HVAC Design",
  "date": "Present",
  "description": [
    "The HVAC Design Course provides a comprehensive foundation in the principles, methods, and practical applications required to design heating, ventilation, and air-conditioning systems for residential, commercial, industrial, and specialized facilities.",
    "The course covers the complete design workflow—from load calculations to equipment selection, piping and ductwork design, central plant configuration, terminal units, temperature controls, and construction drawings.",
    "Participants will gain a strong understanding of modern HVAC technologies, energy-efficiency considerations, design best practices, and industry standards. By integrating theoretical concepts with real-world examples, the course equips engineers and designers with the skills required to design safe, efficient, reliable, and code-compliant HVAC systems."
  ],
  "image": require("./coursesImg/HVAC Design Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic knowledge of thermodynamics, fluid mechanics, and heat transfer.\n· Familiarity with building services, mechanical systems, or construction engineering.\n· Ability to read engineering drawings, floor plans, and schematics.\n· Basic understanding of HVAC components.\n\nSuitable for: Mechanical engineers, HVAC engineers, designers, technicians, facility engineers, project engineers, construction professionals, and anyone involved in building mechanical systems."
  ],
  "methodology": "Theoretical/practical",
  "objectives": [
    "Understand the role and purpose of HVAC systems in building environments.",
    "Identify types of HVAC systems (centralized, decentralized, VRF, chilled water, DX).",
    "Recognize comfort, air quality, and ventilation requirements.",
    "Describe the standard engineering workflow in HVAC design.",
    "Perform load calculations (cooling/heating loads).",
    "Understand code requirements, design criteria, and system selection steps.",
    "Prepare preliminary and detailed design documentation.",
    "Understand chilled water, hot water, and condenser water piping configurations.",
    "Select valves, fittings, strainers, separators, air vents, and other specialties.",
    "Calculate pressure drops and size HVAC piping systems.",
    "Describe central cooling and heating plant configurations (chillers, boilers, cooling towers).",
    "Understand plant operation, sequencing, efficiency, and redundancy.",
    "Evaluate pumps, heat exchangers, and plant control strategies.",
    "Understand air handling systems including AHUs, FAHUs, MAUs, FCUs, and package units.",
    "Apply psychrometric principles in HVAC air system design.",
    "Evaluate air distribution methods and ventilation requirements.",
    "Design duct systems using equal friction, static regain, and constant velocity methods.",
    "Evaluate pressure losses, fan selection, and airflow balancing.",
    "Integrate piping and duct routing within architectural and structural constraints.",
    "Select and apply terminal units such as VAV boxes, diffusers, grilles, chilled beams, radiators, and fan coil units.",
    "Evaluate performance characteristics and comfort implications.",
    "Understand control logic associated with terminal units.",
    "Identify sources of HVAC noise and vibration.",
    "Apply mitigation strategies including duct lining, silencers, isolation mounts, and low-noise design.",
    "Follow acoustic guidelines to meet occupant comfort requirements.",
    "Understand control fundamentals: thermostats, sensors, actuators, and controllers.",
    "Describe Building Management Systems (BMS) and their integration with HVAC.",
    "Develop control sequences for equipment, zones, and central plants.",
    "Interpret mechanical plans, sections, schedules, and detail drawings.",
    "Prepare HVAC layout drawings showing routing, sizing, and labeling.",
    "Coordinate HVAC drawings with architectural, structural, and electrical disciplines."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Design Process.",
    "Module 3: Piping, Valves & Specialties",
    "Module 4: Central Plant",
    "Module 5: Air Systems",
    "Module 6: Piping and Ductwork Distribution System",
    "Module 7: Terminal Equipment",
    "Module 8: Noise and Vibration Control",
    "Module 9: Automatic Temperature Controls",
    "Module 10: Construction Drawings"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},
{
  "id": 129,
  "title": "Material Selection for Refinery & Associated Facilities",
  "date": "Present",
  "description": [
    "This course provides a comprehensive understanding of material selection for refinery units and associated facilities, focusing on corrosion mechanisms, service conditions, metallurgical behavior, and applicable industry standards. Participants will explore how different process environments influence material degradation and how to select appropriate alloys, coatings, linings, and fabrication practices for long-term reliability.",
    "Covering crude distillation, conversion units, hydrogen and petrochemical plants, ammonia and methanol systems, utilities, and underground piping infrastructure, the course equips engineers with the technical knowledge to make cost-effective and safe material decisions throughout the asset lifecycle. Case studies and real-world scenarios enable learners to apply material selection principles to minimize corrosion failures, ensure mechanical integrity, and enhance operational safety in refinery and petrochemical environments."
  ],
  "image": require("./coursesImg/Material Selection for Refinery and Associated Facilities Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "· A basic understanding of refinery processes and equipment (distillation, cracking, hydrotreating, etc.).\n· Foundational knowledge of metallurgy, corrosion, and materials engineering.\n· Familiarity with P&IDs, process conditions, and design codes."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of material selection in refinery design, operation, and mechanical integrity.",
    "Identify key industry codes, standards, and material classification systems used in refinery applications.",
    "Describe corrosion mechanisms in distillation units, crude preheat trains, desalters, and utility systems.",
    "Select suitable materials for overhead condensers, heaters, desalters, and utility piping considering chloride, H₂S, and naphthenic acid corrosion.",
    "Evaluate operating conditions to predict corrosion risk.",
    "Identify corrosion threats in FCC, delayed coker, and thermal cracking units.",
    "Recommend appropriate alloys for alkylation units (HF and sulfuric acid services).",
    "Select corrosion-resistant materials for sulfur recovery, TGTUs, and sour water stripper systems.",
    "Understand high-temperature hydrogen attack (HTHA), sulfidation, carburization, and metal dusting phenomena.",
    "Select suitable materials for reactors, separators, air preheaters, and piping in hydrotreating, reforming, and hydrocracking units.",
    "Evaluate protective lining, cladding, and welding requirements for high-pressure hydrogen service.",
    "Describe corrosion mechanisms in hydrogen, ammonia, methanol, and gas treating plants.",
    "Select materials resistant to amine corrosion, stress corrosion cracking, and high-temperature oxidation.",
    "Understand the unique material challenges in polymerization, phenol processing, and solvent-treating systems.",
    "Learn material requirements for buried pipelines, cathodic protection systems, and coatings.",
    "Evaluate suitable materials for storage tanks, including crude, petroleum products, and chemical storage.",
    "Identify degradation mechanisms in production equipment and tankage (pitting, MIC, soil corrosion, etc.)."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Petroleum and Refinery Process Corrosion, Crude Oil Fractionation Units and Utilities.",
    "Module 3: Fluid Cooking & Cracking, Delayed Cooking, Alkylation Sulfur Plant  and Sour Water Strippers",
    "Module 4: Hydrosulfurizers, Catalytic Reformers, Hydrocrackers and Flue Gas",
    "Module 5: Hydrogen, Ammonia, Methanol, Gas Treating, Hydrodealkylation, Polymerization, Phenol, & Solvent Treating",
    "Module 6: Underground Piping Production Equipment and Tankage"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},
{
  "id": 130,
  "title": "Materials selection and corrosion control for oil and gas production systems",
  "date": "Present",
  "description": [
    "This course provides a comprehensive foundation for selecting appropriate materials and implementing effective corrosion control strategies across oil and gas production systems—including upstream, midstream, and early downstream facilities. Participants will learn how various process conditions, contaminants, fluids, and operational parameters affect material degradation. The course also covers the development of materials selection reports, application-specific guidelines, corrosion mitigation methods, and industry standards.",
    "By combining theoretical fundamentals with real-world case studies, the course equips engineers, inspectors, and technical professionals with the skills needed to evaluate corrosion risks, select cost-effective materials, ensure asset reliability, and comply with design and safety regulations in oil and gas environments."
  ],
  "image": require("./coursesImg/Materials selection and corrosion control for oil and gas production systems.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic understanding of oil and gas production processes (upstream flowlines, separators, pipelines, wells, etc.).\n· Foundational knowledge of metallurgy and material properties.\n· Awareness of common corrosion mechanisms affecting oil and gas systems.\n· Familiarity with standards."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the importance of material selection and corrosion control in oil and gas production systems.",
    "Identify critical factors influencing the integrity and reliability of production facilities.",
    "Review industry codes, recommended practices, and regulatory requirements.",
    "Learn how to gather and interpret process data, fluid compositions, and temperature, pressure, and flow conditions.",
    "Understand how production chemistry, reservoir characteristics, and operating limits influence materials selection.",
    "Develop the ability to identify design constraints and service conditions affecting material performance.",
    "Understand the structure, purpose, and scope of a Material Selection Report (MSR).",
    "Learn to document material recommendations for piping, valves, vessels, wells, subsea equipment, and pipelines.",
    "Identify best practices for justification, traceability, and compliance within MSRs.",
    "Apply corrosion prediction tools, methodologies, and models for oil and gas systems.",
    "Assess major corrosion mechanisms such as CO₂ corrosion, H₂S corrosion/sulfide stress cracking, MIC, erosion–corrosion, and oxygen contamination.",
    "Understand how to formulate materials selection criteria, including corrosion allowance, CRA selection, and coating systems.",
    "Select appropriate materials for:\n· Flowlines, pipelines, and gathering systems\n· Wellheads, downhole tubing, and completions\n· Separators, dehydrators, desalters, and treaters\n· Gas processing, water injection, and produced water handling\n· Subsea systems and offshore topside facilities",
    "Understand material challenges in high-pressure/high-temperature (HPHT) and sour service conditions.",
    "Identify and analyze the primary corrosion mechanisms associated with oil and gas production.",
    "Evaluate corrosion mitigation techniques including inhibitors, cathodic protection, coatings, linings, and chemical treatment.",
    "Learn monitoring and inspection techniques for early detection and control of corrosion in service.",
    "Review real-world corrosion failures, root-cause analyses, material selection mistakes, and best practices.",
    "Practice applying course principles to solve practical material selection and corrosion challenges.",
    "Develop decision-making skills to balance safety, reliability, and cost when selecting materials."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Design information for materials selection.",
    "Module 3: Material Selection Report",
    "Module 4: General Guidelines for corrosion evaluation & materials selection",
    "Module 5: Material selection for specific application & system",
    "Module 6: Corrosion",
    "Module 7: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 131,
  "title": "Piping Engineering",
  "date": "Present",
  "description": [
    "The Piping Engineering Course provides a comprehensive and practical foundation for the design, construction, inspection, and maintenance of industrial piping systems used in oil & gas, petrochemicals, refineries, power plants, water treatment facilities, and chemical processing industries. The course covers piping materials, corrosion mechanisms, design principles, piping components, welding, fabrication, project execution, heat tracing, coatings, insulation, non-metallic piping, and specialized systems such as lined and jacketed piping.",
    "Participants will learn how to apply engineering standards, select piping materials, interpret piping specifications, perform piping layout and design calculations, and ensure compliance with ASME, API, ISO, and international industry requirements. This program integrates theoretical knowledge with field practices to equip engineers, designers, inspectors, and technicians with the skills required for safe, efficient, and reliable piping system development and operation."
  ],
  "image": require("./coursesImg/Piping Engineering Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic understanding of process engineering or mechanical engineering.\n· Familiarity with P&IDs, layouts, and industrial equipment (recommended).\n· Knowledge of fluid mechanics and thermodynamics (beneficial but not mandatory).\n\nSuitable for: piping engineers, designers, inspectors (API/CSWIP/NDT), project engineers, maintenance personnel, mechanical engineers, and operations technical staff."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the fundamentals, scope, and importance of piping engineering.",
    "Select appropriate piping materials based on service conditions and industry standards.",
    "Identify corrosion mechanisms and apply mitigation strategies.",
    "Interpret and apply piping codes, standards, and design requirements.",
    "Understand piping components (fittings, flanges, valves, gaskets, supports) and their applications.",
    "Perform basic piping design, stress considerations, routing, and layout.",
    "Understand piping project workflows, documentation, and deliverables.",
    "Interpret welding procedures, requirements, inspection, and testing methods.",
    "Describe heat tracing, insulation, coating, painting, coating/wrapping, and cathodic protection methods.",
    "Understand lined, jacketed, and non-metallic piping systems, including their applications and limitations.",
    "Ensure integrity, reliability, and compliance of piping systems throughout design, installation, and operation."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Piping Materials.",
    "Module 3: Corrosion of Piping Metal",
    "Module 4: Piping Design",
    "Module 5: Piping Components",
    "Module 6: Piping Project Management",
    "Module 7: Piping Assembly",
    "Module 8: Piping Welding",
    "Module 9: Piping Inspection",
    "Module 10: Piping Heat Tracing",
    "Module 11: Lined Piping",
    "Module 12: Jacketed Piping",
    "Module 13: Piping Painting",
    "Module 14: Piping Coating & Wrapping",
    "Module 15: Cathode Protection",
    "Module 16: Piping Insulation",
    "Module 17: Non-Metallic Piping"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦400,000 / $350",
  "certification": "Certificate of Completion"
},
{
  "id": 132,
  "title": "Pressure Vessel",
  "date": "Present",
  "description": [
    "This course provides a complete and practical understanding of the design, fabrication, inspection, testing, and maintenance of pressure vessels used across the oil & gas, petrochemical, chemical, and power industries. It equips participants with the knowledge required to interpret design codes, understand stress analysis, evaluate fabrication processes, and ensure operational safety and integrity.",
    "The course covers pressure vessel geometry, materials, fabrication methods, inspection techniques, and structural considerations such as wind and seismic loading. It also addresses revamp strategies for aging vessels and provides a strong foundation in ASME Section VIII and other relevant international codes.",
    "Designed for engineers, technicians, and inspectors, this training ensures participants gain both theoretical and practical competence in pressure vessel engineering."
  ],
  "image": require("./coursesImg/Pressure Vessel Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of mechanical engineering principles (forces, stress, materials).\n· Familiarity with process equipment in refineries or chemical plants.\n· Basic knowledge of piping and process flow diagrams (PFD/P&ID) is beneficial.\n· Ability to read engineering drawings and technical documents.\n\nNote: The course starts from fundamental concepts, so motivated beginners can also follow."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define what pressure vessels are and identify their roles in process industries.",
    "Recognize common vessel types, configurations, and components.",
    "Understand the role of process engineers in specifying design conditions, safety requirements, and mechanical design parameters.",
    "Interpret process data sheets and define key operating parameters.",
    "Identify various head types (ellipsoidal, hemispherical, torispherical) and their applications.",
    "Understand the impact of geometry on design, fabrication, and cost.",
    "Navigate ASME Section VIII Division 1 & 2, API standards, and other relevant codes.",
    "Apply design rules, allowable stresses, and code compliance requirements.",
    "Understand nondestructive examination techniques (RT, UT, MPI, PT, VT).",
    "Select appropriate NDE methods based on vessel lifecycle and damage mechanisms.",
    "Describe welding techniques (SMAW, GTAW, SAW) and weld qualification requirements.",
    "Identify fabrication steps such as forming, rolling, post-weld heat treatment, and inspection.",
    "Apply requirements for hydrostatic testing, pneumatic testing, and leak testing.",
    "Understand safety precautions and acceptance criteria.",
    "Describe skirt, saddle, and leg supports and their design philosophy.",
    "Understand load transfer and stability considerations.",
    "Evaluate existing vessels for continued service, rerating, or modification.",
    "Understand remaining life assessment and common repair methods.",
    "Understand basic mechanical stress concepts: hoop stress, longitudinal stress, and thermal stress.",
    "Apply concepts to real-world vessel loading scenarios.",
    "Follow ASME code rules for thickness calculations, reinforcement requirements, and nozzle design.",
    "Perform simplified design checks for pressure, temperature, and external loads.",
    "Understand environmental loading conditions and their effect on vessel integrity.",
    "Apply design considerations for tall vertical vessels and horizontal vessels."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Process Engineer Responsibilities.",
    "Module 3: Pressure Vessel Geometry and Heads",
    "Module 4: Codes and Standards",
    "Module 5: Evaluation Methods (nondestructive examination)",
    "Module 6: Fabrication and Welding",
    "Module 7: Testing",
    "Module 8: Support",
    "Module 9: Revamps",
    "Module 10: Stress and Strain",
    "Module 11: Stress Analysis and Code Rules",
    "Module 12: Wind and Seismic Loading"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},
{
  "id": 133,
  "title": "Process Plant Corrosion Course",
  "date": "Present",
  "description": [
    "The Process Plant Corrosion Course provides engineers and technical personnel with a comprehensive understanding of corrosion mechanisms, damage modes, monitoring techniques, and mitigation strategies across major refinery process units. Because corrosion is one of the leading causes of equipment failure, unplanned shutdowns, and safety incidents, this course focuses on practical, real-world corrosion challenges encountered in crude units, conversion units, treating units, and sulfur recovery systems.",
    "The course covers corrosion fundamentals followed by detailed, unit-specific corrosion phenomena—such as naphthenic acid corrosion in the crude unit, catalyst fines erosion in FCCU, chloride stress corrosion cracking in reforming, amine stress corrosion cracking in treating units, and corrosion risks in sour environments common to hydroprocessing and sulfur recovery units. Participants will also learn how to select and apply corrosion monitoring techniques suitable for refinery operations.",
    "This course is ideal for engineers involved in process design, reliability engineering, inspection, materials selection, operations, and asset integrity."
  ],
  "image": require("./coursesImg/Process Plant Corrossion Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic understanding of chemical process operations and equipment.\n· Foundational knowledge in materials, metallurgy, and corrosion science.\n· Familiarity with piping, vessels, heat exchangers, and refinery process flows.\n\nThe course is structured for engineers, inspectors, process operators, and technical personnel at beginner to intermediate levels."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand Corrosion Fundamentals and Refinery Corrosion Challenges",
    "Analyze Corrosion Issues in the Crude Distillation Unit (CDU)",
    "Evaluate Corrosion Mechanisms in the Fluid Catalytic Cracking Unit (FCCU)",
    "Study Corrosion in Catalytic Light Ends Recovery Units",
    "Understand Corrosion Behavior in Catalytic Reforming Units",
    "Assess Corrosion Mechanisms in Hydroprocessing Units",
    "Examine Corrosion in the Alkylation Unit",
    "Evaluate Corrosion Issues in Amine Treating Units",
    "Understand Corrosion Mechanisms in Merox Treating Units",
    "Analyze Corrosion in Sour Water Treating Units",
    "Assess Corrosion in Sulfur Recovery Units (SRU)",
    "Select Appropriate Corrosion Monitoring Methods for Refinery Applications",
    "Match the correct monitoring method to each process unit.",
    "Develop corrosion monitoring plans for refinery-wide asset integrity."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Crude Unit.",
    "Module 3: Fluid Catalytic Cracking Unit",
    "Module 4: Catalytic Light Ends Recovery Unit",
    "Module 5: Catalytic Reforming Unit",
    "Module 6: Hydroprocessing Unit",
    "Module 7: Alkylation Unit",
    "Module 8: Amine Treating Unit",
    "Module 9: Merox Treating Unit",
    "Module 10: Sour water Treating Unit",
    "Module 11: Sulfur Recovery Unit",
    "Module 12: Selection of Corrosion Monitoring Methods for Refinery Application"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},
{
  "id": 134,
  "title": "Valves",
  "date": "Present",
  "description": [
    "The Valves Course provides in-depth technical knowledge on the selection, operation, application, and maintenance of industrial valves used across oil & gas, petrochemicals, power generation, refineries, water systems, and nuclear facilities. The course covers forged and cast steel valves, special-purpose valves, nuclear-grade valves, actuators, accessories, technical specifications, and maintenance practices.",
    "Participants will gain a strong understanding of valve construction, materials, performance characteristics, pressure–temperature ratings, design codes, testing requirements, and troubleshooting techniques. The program integrates theoretical concepts with practical field experience, equipping engineers, technicians, and operators with the skills required for reliable and safe valve operation in industrial environments."
  ],
  "image": require("./coursesImg/Valves Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of piping systems and fluid mechanics.\n· Familiarity with industrial process equipment.\n· Ability to interpret engineering drawings (P&IDs) and datasheets.\n\nSuitable for: technicians, maintenance personnel, process engineers, mechanical engineers, inspectors, and project engineers."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the types, functions, and classifications of industrial valves.",
    "Identify differences between forged steel, cast steel, and special application valves.",
    "Describe valve standards, pressure–temperature ratings, and material selection.",
    "Interpret valve datasheets, tables, charts, and sizing criteria.",
    "Understand actuators, accessories, and how they integrate with control and safety systems.",
    "Apply correct valve selection for different process conditions and media.",
    "Recognize the unique requirements for nuclear application valves.",
    "Conduct basic valve inspection, testing, troubleshooting, and maintenance.",
    "Apply best practices to ensure valve reliability, safety, and longevity in critical services."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Forged Steel Valves.",
    "Module 3: Cast Steel Valves",
    "Module 4: Special Application Valves",
    "Module 5: Nuclear Application Valves",
    "Module 6: Accessories/Actuators",
    "Module 7: Technical",
    "Module 8: Tables & Charts",
    "Module 9: Maintenance"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},
{
  "id": 135,
  "title": "Instrumentation Compressor",
  "date": "Present",
  "description": [
    "The Instrumentation Compressor Course provides an in-depth understanding of compressor control philosophy, associated instrumentation, and process applications across refinery and petrochemical units. The course covers centrifugal and reciprocating compressor controls, surge prevention, capacity control, alarms, trip logic, and integration with Distributed Control Systems (DCS) and Emergency Shutdown Systems (ESD).",
    "Participants will also study instrumentation and control strategies for compressors used in specific refinery and petrochemical units, including Atmospheric Tower Off-Gas Compressors, HDS Make-Up and Recycle Gas Compressors, Light Ends Recovery Compressors, Regeneration Air Compressors, and Propane Refrigeration Compressors.",
    "The course blends theory with practical field experience, equipping engineers and technicians with the knowledge to safely monitor, troubleshoot, and optimize compressor instrumentation and control systems."
  ],
  "image": require("./coursesImg/Instrumentation Compressor Course.jpg"),
  "tags": [],
  "category": "PAI",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of compressor fundamentals (centrifugal, reciprocating).\n· Familiarity with instrumentation principles and control loop basics.\n· Ability to interpret P&IDs, control narratives, and equipment datasheets.\n\nSuitable for: Instrumentation engineers, control engineers, mechanical engineers, process engineers, operations personnel, and maintenance technicians."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of compressors in process plants and refinery operations.",
    "Identify compressor types, applications, and critical control challenges.",
    "Recognize key instrumentation associated with compressor operation.",
    "Explain the operation of anti-surge valves, recycle lines, and blow-off valves.",
    "Interpret compressor performance curves and control logic.",
    "Recognize vibration, temperature, and pressure monitoring requirements.",
    "Describe control strategies for suction pressure, discharge pressure, and capacity modulation.",
    "Explain vibration and mechanical integrity monitoring.",
    "Identify sensors, transmitters, switches, and control valves used in compressor systems.",
    "Understand control loop architecture: DCS, ESD, PLC-based systems.",
    "Interpret cause-and-effect charts, shutdown logic, and permissive interlocks.",
    "Evaluate compressor instrumentation for safety, reliability, and performance.",
    "Describe instrumentation and control for off-gas compression.",
    "Evaluate protection against entrained liquids, fouling, and surge events.",
    "Understand temperature and pressure monitoring for catalyst protection.",
    "Evaluate compressor control strategies for maintaining hydrogen partial pressure.",
    "Understand the role of compressors in light hydrocarbons separation units.",
    "Identify instrumentation requirements for high vapor-throughput applications.",
    "Examine control strategies to maintain product recovery efficiency.",
    "Understand integrated control loops for dual-function compressors.",
    "Evaluate pressure control, flow balancing, and surge prevention.",
    "Understand air compression requirements for catalyst regeneration.",
    "Understand refrigeration cycle compressor roles."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Centrifugal Compressor Controls.",
    "Module 3: Reciprocating Compressor Controls",
    "Module 4: Instrumentation",
    "Module 5: Atmospheric Tower Off-Gas Compressor",
    "Module 6: HDS Unit Make-Up Gas Compressor",
    "Module 7: HDS Unit Recycle Gas Compressor",
    "Module 8: Light Ends Recovery Gas Compressor",
    "Module 9: Combined Recycle Gas/Make-up Compressor",
    "Module 10: Regeneration Air for CAT Cracking Unit",
    "Module 11: Propane Refrigeration Compressor"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},
{
  "id": 136,
  "title": "Construction Safety",
  "date": "Present",
  "description": [
    "The Construction Safety course is designed to equip workers, supervisors, engineers, and contractors with essential knowledge and practical skills needed to ensure safe practices across construction sites. The course covers the administrative, technical, and operational requirements necessary to maintain compliance with safety regulations, reduce workplace hazards, and promote a culture of safety.",
    "Through a combination of foundational principles, practical guidelines, and industry best practices, the course supports compliance with international standards such as OSHA, ISO 45001, and company-specific contractor safety programs."
  ],
  "image": require("./coursesImg/Construction Safety Course.jpg"),
  "tags": [],
  "category": "hazop hazid",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of construction site activities.\n· Ability to understand simple technical instructions and safety procedures.\n· Experience in civil, mechanical, electrical, or field operations (recommended but not mandatory).\n· Familiarity with personal protective equipment (PPE) and basic site rules.\nThe course is suitable for entry-level staff, technicians, contractors, supervisors, and safety officers."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the fundamentals of construction safety and its importance in preventing incidents.",
    "Interpret and apply contractor safety administrative requirements.",
    "Identify hazards associated with construction works and implement appropriate control measures.",
    "Apply safe work procedures for excavation, lifting, scaffolding, confined space, and other common activities.",
    "Demonstrate knowledge of civil, mechanical, and electrical safety protocols.",
    "Follow operational safety guidelines including permit-to-work systems, traffic management, and emergency response.",
    "Promote a strong safety culture and ensure compliance with regulatory and organizational safety standards."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Contractor Safety Administrative Requirements.",
    "Module 3: Work Site Safety",
    "Module 4: General Safety",
    "Module 5: Civil",
    "Module 6: Mechanical & Electrical",
    "Module 7: Operations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 137,
  "title": "Sampling, Analysis and Evaluation of Crude Oil",
  "date": "Present",
  "description": [
    "The Sampling, Analysis and Evaluation of Crude Oil Course provides a comprehensive foundation on the methods, standards, and laboratory practices used to characterize crude oil for refining, trading, production, and quality control purposes. The course covers crude oil sampling techniques, inspection assays, full crude assays, fractionation behavior, compatibility testing, and evaluation of crude oil for fuel applications.",
    "Participants will learn how to collect representative crude oil samples, conduct key laboratory analyses, interpret assay data, verify quality assurance requirements, and assess crude compatibility for blending and processing. The course prepares engineers, laboratory professionals, and refinery personnel to evaluate crude oils for operational efficiency, refinery optimization, and economic decision-making."
  ],
  "image": require("./coursesImg/Sampling, Analysis and Evaluation of Crude Oil Course.jpg"),
  "tags": [],
  "category": "Petroleum",
  "duration": "3 Days",
  "prerequisite": [
    "· Basic understanding of petroleum composition, hydrocarbon chemistry, and refinery processes.\n\nSuitable for refinery engineers, laboratory analysts, crude traders, process engineers, inspectors, terminal operators, and quality assurance personnel."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Explain crude oil composition, variability, and key characterization parameters.",
    "Understand the purpose and importance of accurate and representative sampling.",
    "Identify applicable standards governing crude sampling and testing.",
    "Select appropriate sampling techniques for tanks, pipelines, ships, and terminals.",
    "Perform composite, spot, automatic, and running samples based on operating conditions.",
    "Manage safety considerations and prevent sample contamination and degradation.",
    "Perform key tests such as API gravity, viscosity, sulfur content, pour point, flash point, and distillation curves.",
    "Understand the significance of inspection assays in refinery planning and crude oil classification.",
    "Evaluate crude quality for transport, storage, and process compatibility.",
    "Execute TBP (True Boiling Point) and ASTM D86 distillation analyses.",
    "Evaluate naphtha, kerosene, diesel, gas oil, and residue fractions.",
    "Assess distillation performance, fraction yields, and processability.",
    "Generate fraction evaluation reports used in refinery LP (linear programming) models.",
    "Apply QA/QC procedures to ensure reliable testing and reporting.",
    "Validate instrument calibration, laboratory practices, and documentation.",
    "Understand chain-of-custody requirements for custody transfer and commercial transactions.",
    "Identify factors affecting crude oil incompatibility such as asphaltene precipitation.",
    "Predict blend stability using laboratory testing and empirical methods.",
    "Assess risks during blending, transportation, and refinery operations.",
    "Evaluate crude oil fuel properties such as combustion characteristics, contaminants, and emissions.",
    "Understand treatment requirements for using crude oil directly in boilers and industrial furnaces.",
    "Assess environmental, safety, and operational concerns.",
    "Understand advancements in analytical techniques such as GC×GC, NMR, SIMDIS, and molecular-level analysis.",
    "Explore the role of digitalization, predictive analytics, and crude assay databases.",
    "Identify evolving industry needs driven by new refinery technologies and energy transition demands."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Sampling.",
    "Module 3: Inspection Assays",
    "Module 4: Comprehensive Assays and Fraction Evaluations.",
    "Module 5: Quality Assurance",
    "Module 6: Crude Oil Compatibility and Stability",
    "Module 7: Crude Oil as Fuel",
    "Module 8: Future Needs in Crude Oil Characterization"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},
{
  "id": 138,
  "title": "Work Sequence for Piping Planning Design",
  "date": "Present",
  "description": [
    "The Work Sequence for Piping Planning & Design Course provides a complete understanding of how piping systems are conceptualized, planned, and designed in process plants. This course walks participants through the logical workflow—from plant layout development to piping system design, routing, equipment connectivity, and support design.",
    "Participants will learn how to translate process requirements into practical and safe piping layouts by applying industry standards, design methodologies, spacing guidelines, and maintenance considerations. The course emphasizes real-world engineering practices used in refineries, petrochemical plants, power plants, and other industrial facilities.",
    "Through a combination of theory, workflow analysis, engineering drawings, and case studies, participants will gain the skills needed to perform piping layout work efficiently and to collaborate effectively with multidisciplinary engineering teams."
  ],
  "image": require("./coursesImg/Work Sequence for Piping Planning Design Course.jpg"),
  "tags": [],
  "category": "project management",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic understanding of process engineering or mechanical engineering principles.\n· Familiarity with P&IDs (Piping and Instrumentation Diagrams) and basic engineering drawings.\n· Foundational knowledge of fluid flow, pressure, and mechanical systems.\n· No prior piping layout design experience is required, but exposure to industrial plant environments is an advantage."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe the overall workflow used in piping design from basic engineering to detailed design.",
    "Recognize the roles of interdisciplinary teams and how information flows between them.",
    "Understand plant layout concepts including zoning, equipment grouping, and process flow patterns.",
    "Interpret plot plans and apply spatial planning principles.",
    "Understand safety, operability, and maintainability considerations in plant layout development.",
    "Apply international guidelines for equipment spacing, fire protection, and access requirements.",
    "Translate conceptual layouts into detailed piping arrangements.",
    "Apply best practices for operator access, insulation clearance, maintenance envelopes, and safety areas.",
    "Identify maintenance needs for rotating and static equipment.",
    "Ensure adequate space and access for lifting, replacement, and inspection.",
    "Apply routing rules based on process fluid, pressure, temperature, and equipment interface.",
    "Optimize routing for minimal pressure drop, safety, and ease of construction.",
    "Recognize routing constraints such as clashes, pipe racks, nozzles, and structural elements.",
    "Understand piping classes, line sizing, stress considerations, material selection, and code requirements.",
    "Interpret and apply P&IDs, equipment datasheets, plot plans, and 3D models in piping design.",
    "Apply best practices for piping connections to pumps, compressors, heat exchangers, vessels, and towers.",
    "Understand suction/discharge piping rules, nozzle loads, and thermal expansion considerations.",
    "Identify types of pipe supports and their functions (anchors, guides, shoes, springs, hangers).",
    "Understand how supports control thermal movement, vibration, and stress.",
    "Integrate support requirements into routing and layout development."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: General Work Sequence for Piping Planning & Design.",
    "Module 3: Overall Plant Layout",
    "Module 4: Plant Layout Considerations",
    "Module 5: Plant and Equipment Spacing",
    "Module 6: Detail Plant Layout",
    "Module 7: Maintenance Consideration",
    "Module 8: Pipe Routing",
    "Module 9: Piping Systems Design",
    "Module 10: Equipment Piping Design",
    "Module 11: Pipe Support Design"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},
{
  "id": 139,
  "title": "Valves Piping and Pipelines",
  "date": "Present",
  "description": [
    "The Valves, Piping, and Pipelines Course provides a comprehensive understanding of the components, design principles, performance criteria, and operational considerations that govern piping systems in process industries. Participants will gain in-depth knowledge of valve types, their construction, sizing, and applications; piping and pipeline materials and specifications; and how these systems integrate to support safe, reliable, and efficient plant operations.",
    "The course blends theoretical fundamentals with practical engineering analysis, offering exposure to real-world scenarios, industry standards, troubleshooting techniques, and performance calculations. It is designed for engineers, technicians, and industry professionals involved in design, operations, maintenance, and integrity management of process piping systems."
  ],
  "image": require("./coursesImg/Valves Piping and Pipelines Course.jpg"),
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "· A basic understanding of process engineering or mechanical engineering principles.\n· Foundational knowledge of fluid mechanics (flow, pressure, velocity, friction losses).\n· Familiarity with process equipment such as pumps, compressors, and pressure vessels.\n· Basic understanding of P&IDs and piping drawings.\n· No prior specialized experience in valves or pipeline design is required."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Explain the basic principles governing valve operation, pipe flow behavior, and pipeline design.",
    "Identify the roles of valves, piping, and pipelines in process systems.",
    "Differentiate among major valve types (gate, globe, ball, plug, check, control valves, etc.).",
    "Explain valve internals, materials of construction, trim design, and sealing mechanisms.",
    "Select appropriate valves based on service conditions and process requirements.",
    "Understand pressure classes, temperature–pressure ratings, and applicable design codes.",
    "Evaluate valve suitability for various service conditions including corrosive, erosive, high-temperature, cryogenic, and hazardous environments.",
    "Understand actuator types (pneumatic, hydraulic, electric) and their applications.",
    "Explain control valve characteristics, signal conversion, and automation interfaces.",
    "Interpret valve symbol representation on instrumentation and piping diagrams.",
    "Identify pipe materials, schedules, dimensions, and mechanical properties.",
    "Understand pipe fitting types, joining methods, pipe thickness calculations, and relevant codes.",
    "Understand pipeline design considerations: routing, supports, stress, flexibility, and protection.",
    "Explain pipeline operation, pigging, corrosion mitigation, and integrity management practices.",
    "Conduct flow calculations including Cv/Kv, pressure drop, flow capacity, and velocity limits.",
    "Perform pipeline hydraulic analysis using friction factors, head loss equations, and line sizing methods.",
    "Apply sizing principles for valves, pipes, and pipelines based on process conditions.",
    "Recognize valve and pipeline requirements in duties such as isolation, regulation, relief, and emergency shutdown.",
    "Evaluate system performance requirements across industries such as oil & gas, petrochemicals, water distribution, and energy."
  ],
  "outline": [
    "Module 1: Fundamentals",
    "Module 2: Valve Types Design and Construction.",
    "Module 3: Pressure Valves and Services",
    "Module 4: Control and Automation",
    "Module 5: Pipes",
    "Module 6: Pipelines/Pipework",
    "Module 7: Performance and Calculations",
    "Module 8: Duties and Services"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},
{
  "id": 140,
  "title": "Standard Deliverable List for Conceptual Study",
  "date": "Present",
  "description": [
    "The Standard Deliverable List for Conceptual Study Course provides engineers and project professionals with a comprehensive understanding of the required deliverables during the Conceptual Design Phase of oil & gas, refining, petrochemical, and energy projects.",
    "The conceptual study phase defines the high-level technical solutions, evaluates multiple development options, and establishes the basis for selecting the most feasible concept. At this stage, engineering deliverables must be sufficiently detailed to support screening, cost estimates risk assessment, and the decision-making process leading to FEED.",
    "This course highlights the essential documents produced by each engineering discipline—Process, Mechanical, Piping, E&I, Civil, Safety, Pipelines, and HVAC—and explains their objectives, content, and interdependencies. Participants gain the ability to identify, review, and prepare conceptual-level engineering deliverables that meet international standards and reflect industry best practices."
  ],
  "image": require("./coursesImg/Standard Deliverable List for Conceptual Study Course.jpg"),
  "tags": [],
  "category": "project management",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic understanding of engineering disciplines in oil & gas or industrial projects.\n· Fundamental knowledge of PFDs, P&IDs, and general industrial documentation.\n· Awareness of project development stages from Concept → Feasibility → FEED → EPC."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define the objectives and scope of conceptual studies in project development.",
    "Recognize the difference between conceptual and feasibility deliverables.",
    "Identify the decision gates and level of definition required at the conceptual stage.",
    "Understand what deliverables each engineering discipline produces during conceptual design.",
    "Learn the structure, content, and purpose of each document.",
    "Recognize discipline interfaces and how conceptual data flows into later phases.",
    "Develop preliminary engineering documents such as: Conceptual PFDs, Option screening documents, Plot plans, Utility summaries, Concept selection reports",
    "Review deliverables for completeness, clarity, and alignment with project objectives.",
    "Ensure conceptual deliverables meet international codes, engineering standards, and client requirements.",
    "Understand the level of engineering details required for cost estimation.",
    "Use conceptual deliverables to compare alternatives.",
    "Understand how technical, economic, operability, and safety considerations influence concept selection.",
    "Understand how Process, Mechanical, Piping, E&I, Civil, Pipelines, and Safety teams interface.",
    "Recognize dependencies such as utility loads, equipment sizing, layout constraints, and safety spacing.",
    "Analyze actual conceptual study examples.",
    "Understand challenges, assumptions, simplifications, and lessons learned.",
    "Learn how conceptual deliverables evolve into feasibility and FEED deliverables."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Project Engineering.",
    "Module 3: Process Engineering",
    "Module 4: Piping Engineering / Layouts",
    "Module 5: Control, Instrumentation & Telecoms",
    "Module 6: Safety",
    "Module 7: Mechanical",
    "Module 8: Civil / Structural - Onshore",
    "Module 9: Structural - Offshore",
    "Module 10: Materials",
    "Module 11: Pipelines",
    "Module 12: Electrical",
    "Module 13: HVAC",
    "Module 14: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $270",
  "certification": "Certificate of Completion"
},
{
  "id": 141,
  "title": "Standard Deliverable List for Feasibility Study",
  "date": "Present",
  "description": [
    "The Standard Deliverable List for Feasibility Study Course provides a structured understanding of the essential engineering documents, assessments, and analyses required during the Feasibility Phase of oil & gas, petrochemical, and industrial projects.",
    "A feasibility study determines whether a project is technically, economically, environmentally, and operationally viable. This course guides participants through the deliverables produced by each discipline; Process, Mechanical, Piping, Electrical, Civil, Safety, Materials, and more ensuring alignment with industry best practices, international standards, and project development workflows.",
    "Participants will learn the scope, content, and purpose of each deliverable, how the disciplines interface, and how these documents support investment decisions and the transition to Conceptual and Front-End Engineering Design (FEED). Real-life case studies reinforce learning and demonstrate typical feasibility-stage outputs."
  ],
  "image": require("./coursesImg/Standard Deliverable List for Feasibility Study Course.jpg"),
  "tags": [],
  "category": "project management",
  "duration": "5 Days",
  "prerequisite": [
    "· A basic understanding of engineering principles and project execution phases.\n· Familiarity with industrial or energy projects (oil & gas, power, petrochemicals).\n· Basic Knowledge of PFDs, P&IDs, and general engineering documentation."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the purpose, scope, and key decisions made at the feasibility stage.",
    "Identify how feasibility deliverables guide economic evaluation and project go/no-go decisions.",
    "Understand the required documents, studies, and analyses across all major engineering disciplines.",
    "Recognize how each deliverable contributes to technical definition and project viability.",
    "Understand how engineering teams collaborate to produce an integrated feasibility package.",
    "Manage data flow between Process, Mechanical, Electrical, Piping, Civil, and Safety disciplines.",
    "Align deliverables with international standards, client specifications, and regulatory requirements.",
    "Ensure completeness, clarity, and consistency across feasibility documentation.",
    "Understand preliminary calculations, conceptual layouts, equipment sizing, cost estimation, and risk identification.",
    "Assess uncertainties, assumptions, and limitations inherent to early-phase engineering.",
    "Prepare a deliverable register for projects.",
    "Identify dependencies, critical path items, and engineering priorities.",
    "Review completed feasibility studies and understand typical deliverable quality, depth, and structure.",
    "Learn how real projects evaluate concepts, select options, and justify investments."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Project Engineering.",
    "Module 3: Process Engineering",
    "Module 4: Piping Engineering / Layouts",
    "Module 5: Control, Instrumentation & Telecoms",
    "Module 6: Safety",
    "Module 7: Mechanical",
    "Module 8: Civil / Structural - Onshore",
    "Module 9: Structural - Offshore",
    "Module 10: Materials",
    "Module 11: Pipelines",
    "Module 12: Electrical",
    "Module 13: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},
{
  "id": 142,
  "title": "Standard Deliverable List for FEED Design",
  "date": "Present",
  "description": [
    "The Front-End Engineering Design (FEED) phase is one of the most critical stages in the lifecycle of oil & gas, petrochemical, refinery, and energy projects. FEED develops the technical definition, scope, cost, and schedule to a level of detail sufficient for investment approval and preparation of EPC tender packages.",
    "This course provides a comprehensive understanding of the standard deliverables produced during a FEED study across all major engineering disciplines. It equips participants with the knowledge required to prepare, review, and manage FEED deliverables according to industry standards, ensuring accuracy, consistency, and alignment with project objectives.",
    "Participants will gain insight into how FEED deliverables form the basis for EPC execution, vendor engagement, construction planning, and project cost estimation (typically Class 3 estimates). The course also explains multidisciplinary interfaces, data maturity levels, and how FEED deliverables evolve from conceptual design inputs."
  ],
  "image": require("./coursesImg/Standard Deliverable List for FEED Design Course.jpg"),
  "tags": [],
  "category": "project management",
  "duration": "7 Days",
  "prerequisite": [
    "· Basic engineering knowledge in oil & gas, petrochemical, or energy projects.\n· Familiarity with project development stages (Concept → FEED → EPC).\n· Understanding of basic engineering documents such as PFDs, P&IDs, equipment lists, SLDs, and plot plans.\n· Conceptual design experience is an advantage but not mandatory."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the purpose, scope, and importance of FEED in the project lifecycle.",
    "Identify major FEED deliverables and how they support EPC tendering.",
    "Understand technical maturity requirements for Class 3 cost estimates.",
    "Recognize what is expected from Process, Mechanical, Piping, Electrical, Safety, and other disciplines during FEED.",
    "Understand the structure, content, and review requirements of each deliverable.",
    "Learn how FEED data is integrated across disciplines.",
    "Review FEED deliverables for completeness, accuracy, and compliance.",
    "Understand FEED deliverable workflows, revision control, and interfaces.",
    "Identify gaps or inconsistencies that can impact EPC execution.",
    "Ensure all FEED deliverables comply with relevant international codes (ASME, API, IEC, ISO, NFPA, etc.).",
    "Understand client-specific standards and project execution requirements.",
    "Learn how FEED deliverables translate into EPC bid packages.",
    "Understand requirements for Material Requisitions (MRs), Technical Bid Evaluations, and vendor documents.",
    "Recognize the impact of FEED completeness on CAPEX/OPEX outcomes.",
    "Understand interdependencies among disciplines (e.g., process data for piping design).",
    "Identify required input/output deliverables per discipline.",
    "Learn to manage battery limits, tie-ins, and interface points.",
    "Study real-world FEED deliverable examples.",
    "Understand challenges, risks, and lessons learned from actual projects.",
    "Compare FEED vs. Conceptual/Feasibility deliverables."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Project Engineering.",
    "Module 3: Process Engineering",
    "Module 4: Piping Engineering / Layouts",
    "Module 5: Control, Instrumentation & Telecoms",
    "Module 6: Safety",
    "Module 7: Mechanical",
    "Module 8: Civil / Structural - Onshore",
    "Module 9: Structural - Offshore",
    "Module 10: Materials",
    "Module 11: Pipelines",
    "Module 12: Electrical",
    "Module 14: Procurement",
    "Module 15: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦400,000 / $350",
  "certification": "Certificate of Completion"
},

{
  "id": 143,
  "title": "Standard Deliverable List for Detailed Design",
  "date": "Present",
  "description": [
    "The Standard Deliverable List for Detailed Design course provides a comprehensive understanding of the engineering documents, drawings, calculations, and specifications required during the Detailed Design phase of oil & gas, petrochemical, power, and industrial projects. This stage transforms FEED-level information into fully engineered, ready-for-construction (RFC) deliverables with exact dimensions, material specifications, procurement details, construction instructions, and interdisciplinary coordination.",
    "Participants will learn how each engineering discipline—Project Engineering, Process, Piping, Mechanical, Civil/Structural, Instrumentation, Electrical, and others—contributes to the deliverable set necessary for construction contractors, procurement teams, and regulators. The course emphasizes quality assurance, regulatory compliance, constructability, operability, and seamless integration across all engineering modules."
  ],
  "image": require("./coursesImg/Standard Deliverable List for Detailed Design Course.jpg"),
  "tags": [],
  "category": "project management",
  "duration": "8 Days",
  "prerequisite": [
    "· Basic understanding of engineering project phases (Feasibility, Conceptual, FEED Design).\n· Familiarity with plant engineering disciplines such as process, mechanical, piping, electrical, and instrumentation.\n· Knowledge of reading and interpreting engineering drawings (PFDs, P&IDs, GA drawings).\n· Experience in EPC projects or exposure to engineering documentation workflows."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the overall purpose and stages of Detailed Design.",
    "Distinguish between FEED and Detailed Design deliverables.",
    "Learn document numbering, revision protocols, and QA/QC processes.",
    "Identify key project coordination deliverables (project execution plan, schedule, reporting).",
    "Understand interdisciplinary coordination matrices, interface registers, and responsibility assignment.",
    "Learn how technical queries (TQs), deviations, and change management are handled.",
    "Understand typical process deliverables: PFDs, P&IDs, line lists, cause-and-effect charts, heat & material balances.",
    "Learn how to generate datasheets for major equipment and instruments.",
    "Identify process safety deliverables (relief load summaries, flare load calculations).",
    "Learn key piping deliverables: plot plans, equipment layouts, isometrics, tie-in schedules.",
    "Understand piping MTOs, piping specs, 3D model development, and stress analysis reports.",
    "Recognize routing rules, accessibility needs, and construction constraints.",
    "Understand deliverables such as I/O lists, instrument index, loop drawings, logic diagrams, hookup drawings.",
    "Learn control system architecture documents and telecom network drawings.",
    "Evaluate instrument installation details and field wiring design.",
    "Understand safety deliverables including HAZOP actions, SIL/LOPA reports, fire & gas layouts, escape route plans.",
    "Learn fire protection drawings, hazard area classification, and safety equipment layouts.",
    "Review equipment datasheets, 3D mechanical models, general arrangement drawings, nozzle orientation drawings.",
    "Understand rotating and static equipment calculations.",
    "Learn vendor package integration and equipment installation requirements.",
    "Identify deliverables such as foundation drawings, structural framing plans, rebar schedules, concrete specifications.",
    "Learn geotechnical input, road layouts, drainage design, and building structural details.",
    "Understand offshore-specific deliverables: deck load analysis, topside structural drawings, sea fastening, lifting studies.",
    "Learn offshore codes (API RP 2A), fatigue analysis reports, and welded joint specifications.",
    "Learn materials engineering deliverables such as material selection diagrams (MSDs), corrosion control documents.",
    "Understand MTOs, data sheets, welding procedures, coatings, insulation specifications.",
    "Review pipeline route selection, alignment sheets, welding maps, pipeline stress analysis.",
    "Understand deliverables for block valve stations, pig launcher/receiver, pipeline construction drawings.",
    "Identify electrical deliverables: SLDs, cable schedules, load lists, lighting layouts, grounding & earthing drawings.",
    "Understand hazardous area considerations, power system studies, and equipment data sheets.",
    "Understand the interface between Detailed Design and procurement.",
    "Learn how deliverables such as material requisitions, TBE (Technical Bid Evaluation), and vendor documents are prepared and reviewed.",
    "Recognize the role of detailed design in vendor drawing approval cycles.",
    "Evaluate real-life detailed design packages from oil & gas, petrochemical, power, or water projects.",
    "Analyze issues related to coordination, constructability, and design quality.",
    "Apply knowledge to interpret and assess complete discipline deliverables."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Project Engineering.",
    "Module 3: Process Engineering",
    "Module 4: Piping Engineering / Layouts",
    "Module 5: Control, Instrumentation & Telecoms",
    "Module 6: Safety",
    "Module 7: Mechanical",
    "Module 8: Civil / Structural - Onshore",
    "Module 9: Structural - Offshore",
    "Module 10: Materials",
    "Module 11: Pipelines",
    "Module 12: Electrical",
    "Module 14: Procurement",
    "Module 15: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦500,000 / $450",
  "certification": "Certificate of Completion"
},

{
  "id": 144,
  "title": "Offsite & Utilities Conceptual Design",
  "date": "Present",
  "description": [
    "The Offsites & Utilities Conceptual Design Course provides a comprehensive understanding of the design, configuration, and integration of utility systems required to support process plants, refineries, petrochemical complexes, and LNG facilities. Offsites and utilities form the backbone of plant operations—ensuring the supply of air, water, steam, inert gases, fuels, and storage systems necessary for safe and reliable production.",
    "This course equips participants with the knowledge required to evaluate utility loads, size major equipment, understand system interactions, and develop conceptual designs that align with project requirements, operational philosophy, and industry standards. The program integrates engineering fundamentals, design methodologies, and practical examples, enabling participants to produce optimized and efficient utility system designs from concept through early FEED.",
    "This training is ideal for process engineers, project engineers, designers, and technical professionals involved in refinery, gas plant, and chemical plant development."
  ],
  "image": require("./coursesImg/Offsites & Utilities Conceptual Design Course.jpg"),
  "tags": [],
  "category": "utilities offsite design",
  "duration": "5 Days",
  "prerequisite": [
    "· Basic understanding of chemical/process engineering principles.\n· Familiarity with key unit operations and plant configurations.\n· Basic knowledge of fluid mechanics, thermodynamics, and heat transfer."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and requirements of instrument air and plant air systems.",
    "Learn the design basis, system configuration, compressors, dryers, receivers, and distribution networks.",
    "Identify air quality standards, reliability criteria, redundancy, and safety considerations.",
    "Learn the production, storage, and distribution of nitrogen, oxygen, and hydrogen utilities.",
    "Understand purity requirements and applications across process plants.",
    "Develop skills to size supply systems, evaluate consumption loads, and integrate utility headers into plant design.",
    "Understand cooling water demand estimation and system design philosophy.",
    "Learn about cooling towers, pumps, metallurgy, chemical treatment, and heat exchanger integration.",
    "Evaluate hydraulic design, approach temperature, cycles of concentration, and thermal performance.",
    "Understand water sourcing, treatment requirements, and classifications.",
    "Learn conceptual design of raw water intake, filtration, softening, and demineralization systems.",
    "Develop knowledge on potable water quality standards, distribution systems, and storage requirements.",
    "Understand steam system hierarchy—low, medium, and high-pressure steam.",
    "Learn boiler feedwater treatment, deaeration, and boiler conceptual design.",
    "Develop design capabilities for steam distribution, condensate recovery, and system balancing.",
    "Learn the types and sources of wastewater generated in process industries.",
    "Understand treatment approaches—API separators, dissolved air flotation, biological treatment, and tertiary systems.",
    "Identify discharge standards, environmental requirements, and design considerations for effluent systems.",
    "Understand conceptual design of product storage tanks, bullet tanks, spheres, and terminals.",
    "Learn loading/unloading facility design for trucks, rail, pipelines, and marine terminals.",
    "Understand safety distances, material compatibility, evaporation losses, and API/ASME guidelines."
  ],
  "outline": [
    "Module 1: Instrument / Plant Air System",
    "Module 2: Nitrogen / Oxygen / Hydrogen.",
    "Module 3: Cooling Water System",
    "Module 4: Raw / Demineralized / Potable Water System",
    "Module 5: Steam / BFW / Condensate System",
    "Module 6: Waste Water",
    "Module 7: Storage, Loading and Unloading"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 63,
  "title": "Line Sizing",
  "date": "Present",
  "description": [
    "A comprehensive professional training program covering gas, liquid, and multiphase pipeline sizing for oil, gas, chemical, and petrochemical facilities.",
    "This course equips engineers with the practical knowledge and skills required to accurately size gas, liquid, and multiphase pipelines using internationally recognized codes and standards. Participants will gain hands-on exposure to manual calculations and simulation-based approaches using Excel and Aspen HYSYS.",
    "Codes & Standards Covered: API RP 14E, ISO 13703, Norsok P-001, and Company/project piping standards (Shell, Chevron, Exxon Mobil)."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Line%20sizing(Int).png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "Basic understanding of fluid mechanics, Pipe friction, Reynolds number and Pressure drop.",
    "Familiarity with engineering units and fundamental equations (e.g., pressure, flow rate).",
    "Basic knowledge of process or piping systems (not mandatory).",
    "Knowledge of Pipe schedules and dimensions, Fluid properties, Design parameters, Calculation tools (Excel), Hysys",
    "Basic knowledge of Excel"
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the fundamentals of fluid flow in pipes.",
    "Apply Bernoulli's and Darcy-Weisbach equations to calculate flow characteristics.",
    "Identify and apply physical fluid properties in line sizing.",
    "Understand surge factors/surge expectation in flow system",
    "Understanding the (liquid, gas, multiphase phase) flow velocity and pressure drop criteria",
    "Understanding the how to determine friction factor through a pipe.",
    "Utilize industry codes and standards relevant to piping and line sizing.",
    "Apply line sizing criteria for different flow types (liquid, gas, multiphase phase).",
    "Perform line sizing using Aspen HYSYS.",
    "Understand pipe grade selection and wall thickness calculation.",
    "Interpret and use line sizing templates for common design scenarios."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Nature of flow in pipes",
    "Module 3: General Energy Equation (Bernoulli's Theorem)",
    "Module 4: General Equation for flow in pipes (Darcy's Formula)",
    "Module 5: Physical Properties of fluid",
    "Module 6: Pipe Grade",
    "Module 7: Codes & Standard for line sizing",
    "Module 8: Sizing Criteria",
    "Module 9: Line sizing with Aspen Hysys",
    "Module 10: Liquid Line Sizing (Template)",
    "Module 11: Single Phase Gas Line Sizing (Template)",
    "Module 12: Gas/Liquid Two Phase Line Sizing (Template)",
    "Module 13: Pipe wall thickness",
    "Module 14: Project"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom",
    "Face to Face",
    "Virtual"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 64,
  "title": "Plumbing Engineering",
  "date": "Present",
  "description": [
    "Fundamentals of plumbing engineering encompass the principles and knowledge that are essential for designing, installing, and maintaining plumbing systems in buildings, industrial facilities, and infrastructure. This course covers the network of pipes, fixtures, and equipment used to deliver clean water and remove wastewater while ensuring safety, efficiency, and compliance with local building codes.",
    "The program explores specialized systems beyond typical water supply and drainage, including healthcare facility plumbing, fire protection, and industrial waste treatment. Participants will also learn about environmentally-friendly solutions, such as green plumbing and bioremediation systems, which are increasingly relevant in sustainable construction."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Plumbing%20engineering.png",
  "tags": [],
  "category": "Construction/Petroleum",
  "duration": "4 Days",
  "prerequisite": [
    "Basic Understanding of Engineering Principles",
    "Construction Knowledge",
    "Mathematics",
    "Blueprint Reading"
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Recognize and apply plumbing-specific terminology, symbols, and formulas essential for plumbing engineering and system design.",
    "Comprehend and utilize national and international standards for plumbing materials and equipment.",
    "Learn how to write detailed plumbing specifications, including system components and performance requirements.",
    "Learn the basics of value engineering in plumbing design to optimize functionality while minimizing costs.",
    "Understand the principles behind designing effective sanitary drainage systems and cold water supply systems.",
    "Master the principles behind domestic water heating systems, including selection and maintenance.",
    "Explore private sewage disposal and private water supply systems (wells and pumps).",
    "Understand fire protection plumbing systems and compliance with fire safety codes.",
    "Gain specialized knowledge in plumbing systems for healthcare facilities and industrial waste treatment.",
    "Understand the design and safety considerations for gasoline, diesel oil, steam, condensate, and compressed air piping systems."
  ],
  "outline": [
    "Module 1: Formulas, Symbols, and Terminology",
    "Module 2: Standards for Plumbing Materials and Equipment",
    "Module 3: Specifications",
    "Module 4: Basics of Value Engineering",
    "Module 5: Sanitary Drainage Systems",
    "Module 6: Cold Water Systems",
    "Module 7: Domestic Water Heating Systems",
    "Module 8: Private Sewage Disposal Systems",
    "Module 9: Fire Protection Systems",
    "Module 10: Plumbing Design for Healthcare Facilities",
    "Module 11: Treatment of Industrial Waste",
    "Module 12: Irrigation Systems",
    "Module 13: Gasoline and Diesel Oil Systems",
    "Module 14: Steam and Condensate Piping",
    "Module 15: Compressed Air Systems"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 65,
  "title": "P&ID Development Procedure",
  "date": "Present",
  "description": [
    "Developing a Piping and Instrumentation Diagram (P&ID) is a critical step in designing and documenting a process system. A P&ID shows the layout of equipment, piping, instruments, and control systems, serving as an essential tool for engineers and operators to understand how a process works.",
    "This beginner course provides a comprehensive introduction to the creation, interpretation, and management of P&IDs in industrial environments. It covers fundamental concepts, symbols, and conventions, as well as the identification and specification of equipment, pipelines, and instrumentation systems. Participants will learn the essential workflow used by contractors to ensure accuracy and quality throughout the design process."
  ],
  "image": "https://ik.imagekit.io/mags/courses/P%20&%20ID%20development%20procedure.png",
  "tags": [],
  "category": "Petroleum/Engineering",
  "duration": "5 Days",
  "prerequisite": [
    "Basic understanding of industrial processes, piping systems, and instrumentation.",
    "Familiarity with technical drawing concepts or engineering symbols is helpful but not required."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the overall structure and purpose of P&IDs in the context of industrial systems.",
    "Identify and understand pipeline symbols, flow paths, and auxiliary lines (electrical, control, instrumentation).",
    "Apply conventions for pipeline identification, numbering, and product designations.",
    "Analyze pipeline specifications, insulation roles, and the use of various pipe fittings.",
    "Identify symbols and functions for various valves, including on/off, control, one-way, and special duty valves.",
    "Represent tanks, pressure vessels, pumps, compressors, and heat exchangers accurately in diagrams.",
    "Understand the role of instrumentation, including sensors, transmitters, and controllers.",
    "Learn the contractor workflow for developing, reviewing, and managing P&IDs from design to on-site operations."
  ],
  "outline": [
    "Module 1: Structure",
    "Module 2: Pipeline Symbols",
    "Module 3: Other Lines",
    "Module 4: Pipeline Numbering and Identification",
    "Module 5: Product Designations",
    "Module 6: System Numbering",
    "Module 7: Pipeline Numbering",
    "Module 8: Pipeline Specifications",
    "Module 9: Insulation",
    "Module 10: Pipe Fittings",
    "Module 11: Valves",
    "Module 12: Valves used for 'On/Off' Service",
    "Module 13: Valves used for 'Control' Service",
    "Module 14: Valves used for 'One-Way' Service",
    "Module 15: Valves used for 'Special' Duties",
    "Module 16: Valve Actuators",
    "Module 17: Tanks and Pressure Vessels",
    "Module 18: Tank and Vessel Fixtures and Fittings",
    "Module 19: Filters",
    "Module 20: Pumps and Compressors",
    "Module 21: Metering Devices",
    "Module 22: Heat Exchangers",
    "Module 23: Other items of Equipment",
    "Module 24: Equipment Identification",
    "Module 25: Instrument",
    "Module 26: Contractor Workflow Description",
    "Module 27: Responsibilities and organization",
    "Module 28: Control, verification and review documents",
    "Module 29: On-site management of P&IDs"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $250",
  "certification": "Certificate of Completion"
},

{
  "id": 66,
  "title": "Chemical and Process Plant Commissioning",
  "date": "Present",
  "description": [
    "The Chemical and Process Plant Commissioning course provides a structured foundation for planning, organizing, and preparing the essential activities required before on-site commissioning begins. This phase focuses on the administrative, technical, contractual, and organizational elements necessary to ensure safe, efficient, and successful commissioning execution.",
    "The program also emphasizes the practical execution of commissioning activities, involving hands-on implementation, verification of equipment integrity, adherence to safety requirements, and readiness for safe initial start-up. Participants will learn to transition a newly built plant to operational readiness through rigorous testing and systematic handover procedures."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Chemical%20and%20Process%20Plant%20Commissioning.png",
  "tags": [],
  "category": "Petroleum/Engineering",
  "duration": "4 Days",
  "prerequisite": [
    "Completion of Chemical & Process Plant Commissioning – Phase 1 (Prepare) or equivalent industry experience.",
    "Solid understanding of process equipment, instrumentation, electrical systems, and P&IDs.",
    "Knowledge of construction quality checks and mechanical completion requirements.",
    "Familiarity with industry safety standards (LOTO, PTW, and hazard analysis).",
    "Experience in plant operations, EPC projects, maintenance, or testing is an advantage."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the importance of appointing a Commissioning Manager and outline associated responsibilities.",
    "Define commissioning scopes, interfaces, and contractual boundaries with EPC, OEMs, and subcontractors.",
    "Establish team composition, roles, and organizational structures for commissioning.",
    "Develop high-level commissioning plans, system files, checklists, and Standard Operating Procedures (SOPs).",
    "Identify commissioning support requirements including utilities, temporary systems, and manpower plans.",
    "Design a commissioning tagging system for tracking equipment status and punch lists.",
    "Conduct Factory Acceptance Testing (FAT) and Pre-Start-Up Safety Reviews (PSSR).",
    "Implement pre-commissioning procedures for piping, instruments, and electrical systems.",
    "Execute leak testing, initial start-up procedures, and troubleshooting during activation.",
    "Coordinate final documentation, commissioning dossiers, and formal handover to operations."
  ],
  "outline": [
    "Module 1: Appointing the Commissioning Manager",
    "Module 2: Commissioning Scope and Contracts",
    "Module 3: Develop an Initial Commissioning Plan or Philosophy",
    "Module 4: Appointment, Composition of the Commissioning Team, Roles, Responsibilities and Organization Chart",
    "Module 5: Develop Training Materials",
    "Module 6: Develop Standard Operating Procedures (SOPs)",
    "Module 7: Devise Handover Procedure",
    "Module 8: Devise Commissioning Tagging System",
    "Module 9: Factory Acceptance Testing",
    "Module 10: Pre-Commissioning Procedures",
    "Module 11: Instrument Loop, Electrical and Control System Testing",
    "Module 12: Commissioning Punchlisting",
    "Module 13: Handover from Construction to Commissioning",
    "Module 14: Pre-Commissioning HAZOP Studies or Pre-Start-Up Safety",
    "Module 15: Commissioning and Initial Start-Up Plus Procedures",
    "Module 16: Handover to Operations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦500,000 / $400",
  "certification": "Certificate of Completion"
},

{
  "id": 67,
  "title": "Production Of Phosphoric Acid",
  "date": "Present",
  "description": [
    "The Production of Phosphoric Acid course provides a comprehensive understanding of the industrial production processes, equipment, environmental considerations, and safety aspects associated with phosphoric acid manufacturing. Phosphoric acid is a key intermediate in the fertilizer and chemical industries, and its production involves corrosive chemicals, high-temperature reactions, and significant environmental and occupational hazards.",
    "This course covers process technologies, material handling, storage and transfer systems, emission sources, environmental monitoring, and hazard management. Emphasis is placed on safe, efficient, and environmentally responsible operation, supported by real-world case studies and lessons learned from operating plants."
  ],
  "image": "https://ik.imagekit.io/mags/courses/PRODUCTION%20OF%20PHOSPHORIC%20ACID%20Course.png",
  "tags": [],
  "category": "PC",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of chemical engineering or industrial process operations",
    "Familiarity with process flow diagrams (PFDs) and P&IDs",
    "General awareness of health, safety, and environmental (HSE) principles"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand phosphoric acid production technologies and their key process steps.",
    "Identify equipment and materials of construction suitable for corrosive service.",
    "Recognize environmental impacts and emission sources associated with phosphoric acid plants.",
    "Apply emission monitoring and environmental compliance practices.",
    "Identify major process and occupational hazards and appropriate control measures.",
    "Promote safe, efficient, and environmentally responsible operation of phosphoric acid production facilities."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Description of Production Processes",
    "Module 3: Description of Storage and Transfer Equipment",
    "Module 4: Environmental Data",
    "Module 5: Emission Monitoring",
    "Module 6: Major Hazards",
    "Module 7: Occupational Health & Safety",
    "Module 8: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 68,
  "title": "Distillation Operation",
  "date": "Present",
  "description": [
    "The Distillation Operation course provides an in-depth, operations-focused understanding of tray and packed distillation columns, covering mechanical internals, operating principles, control philosophies, commissioning, startup, shutdown, and troubleshooting. The course bridges the gap between design intent and real-world operation, enabling participants to diagnose and resolve common and complex distillation problems.",
    "Emphasis is placed on hydraulic behavior, mass transfer efficiency, operability limitations, pressure relief, and process control, with extensive discussion on field-based issues such as flooding, foaming, weeping, entrainment, and maldistribution. The course also covers reboilers, condensers, and column control strategies, making it highly practical for operations, process, and troubleshooting engineers."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Distillation%20Operation%20Course.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "7 Days",
  "prerequisite": [
    "Basic understanding of process engineering principles",
    "Familiarity with mass and energy balances",
    "Fundamental knowledge of phase equilibrium and vapor–liquid behavior"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the operational behavior of tray and packed distillation columns.",
    "Identify and troubleshoot common and complex distillation problems such as flooding, foaming, weeping, and efficiency loss.",
    "Evaluate the impact of internals, feed distribution, and reflux arrangements on column performance.",
    "Operate and troubleshoot reboilers and condensers in coordination with column operation.",
    "Apply effective startup, shutdown, and commissioning practices to ensure safe and reliable operation.",
    "Implement appropriate pressure, temperature, and composition control strategies for stable separation.",
    "Assess overpressure risks and protection philosophy for distillation systems.",
    "Translate field test data into actionable operational improvements."
  ],
  "outline": [
    "Module 1: Distillation Troubleshooting",
    "Module 2: Reflux and Intermediate Feed Inlets for Tray Columns",
    "Module 3: Reflux and Intermediate Feed Distribution and Liquid Redistribution in Packed Towers",
    "Module 4: Bottom Section and Column Outlets",
    "Module 5: Gravity Lines and Instruments and Access Connections",
    "Module 6: Tray and Downcomer Layout",
    "Module 7: Mechanical Requirements for Trays",
    "Module 8: Internal Unique to Packed Towers",
    "Module 9: Distillation Overpressure Relief",
    "Module 10: Column Assembly and Preparation for Commissioning",
    "Module 11: Column Commissioning",
    "Module 12: Column Startup and Shutdown",
    "Module 13: Operation Difficulties",
    "Module 14: Column Field Testing; Flooding, Foaming, Efficiency and Troubleshooting",
    "Module 15: Reboilers and Condensers Operation and Troubleshooting",
    "Module 16: Basic Distillation Control Philosophy",
    "Module 17: Reboiler, Condensers and Pressure Control",
    "Module 18: Temperature and Composition Control",
    "Module 19: Miscellaneous Column Controls"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦400,000 / $350",
  "certification": "Certificate of Completion"
},

{
  "id": 69,
  "title": "Liquefied Natural Gas Industry",
  "date": "Present",
  "description": [
    "The Liquefied Natural Gas (LNG) Industry course provides an integrated understanding of the technical, commercial, and project-driven nature of the global LNG business. It covers the complete LNG value chain from upstream natural gas supply and liquefaction to shipping, import terminals, and end-use markets—while also addressing the commercial structures, contracts, economics, and regulatory frameworks that underpin LNG projects.",
    "The course emphasizes the project-based nature of LNG developments, the evolution of LNG business models, and the interplay between engineering, shipping, finance, and commercial agreements. Participants will gain practical insight into how LNG projects are structured, financed, built, operated, and marketed in a rapidly evolving global energy landscape."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Liquefied%20Natural%20Gas%20Industry.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "5 Days",
  "prerequisite": [
    "Basic understanding of oil and gas or energy industry fundamentals",
    "General knowledge of engineering, economics, or commercial principles",
    "Familiarity with project-based developments"
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the complete LNG value chain, from upstream gas to end markets.",
    "Explain the project-driven nature of LNG developments and their associated risks.",
    "Evaluate LNG project economics and commercial structures, including SPAs and shipping contracts.",
    "Understand the technical fundamentals of LNG liquefaction, shipping, and regasification.",
    "Navigate regulatory, contractual, and market considerations affecting LNG projects.",
    "Assess future trends and challenges facing the LNG industry, including energy transition impacts."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: The Project Nature of the LNG Business",
    "Module 3: Evolution of the LNG Business Model",
    "Module 4: LNG Projects",
    "Module 5: LNG Shipping",
    "Module 6: The Economics of an LNG Project",
    "Module 7: Upstream Natural Gas",
    "Module 8: The Liquefaction Plant",
    "Module 9: LNG Tankers",
    "Module 10: LNG Import Terminals",
    "Module 11: LNG Project Formation",
    "Module 12: Upstream Gas Supply Agreements",
    "Module 13: LNG Sale and Purchase Agreements",
    "Module 14: LNG Tanker Contracts",
    "Module 15: Shipping Conventions and Regulations",
    "Module 16: LNG Terminal Siting and Regulatory Issues",
    "Module 17: LNG Import Terminal Use Agreements",
    "Module 18: The Future of LNG"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $250",
  "certification": "Certificate of Completion"
},

{
  "id": 70,
  "title": "Production, Storage, and Handling of Liquefied Natural Gas (LNG)",
  "date": "Present",
  "description": [
    "The Production, Storage, and Handling of Liquefied Natural Gas (LNG) course provides a comprehensive understanding of the technical, safety, and operational aspects of LNG facilities across the value chain. The course focuses on liquefaction processes, cryogenic storage, vaporization, transfer systems, and facility design, with strong emphasis on plant siting, layout, risk management, and fire protection.",
    "Participants will gain practical knowledge of LNG facility engineering requirements, applicable codes and standards, and safe handling of cryogenic and flammable materials, including both large-scale and small-scale LNG installations. Quantitative Risk Analysis (QRA) principles are introduced to support performance-based siting and safety decisions."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Production,%20Storage,%20and%20Handling%20of%20Liquefied%20Natural%20Gas%20(LNG).png",
  "tags": [],
  "category": "Petroleum",
  "duration": "5 Days",
  "prerequisite": [
    "Basic understanding of oil and gas processing operations",
    "Familiarity with process flow diagrams (PFDs) and P&IDs",
    "Fundamental knowledge of process safety and HSE principles"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand LNG production, storage, and handling principles across the LNG value chain.",
    "Apply LNG facility design requirements in accordance with international codes and standards.",
    "Design and assess LNG storage, vaporization, and transfer systems safely and efficiently.",
    "Identify and mitigate LNG-specific hazards, including cryogenic and flammable risks.",
    "Evaluate plant siting and layout options using prescriptive and performance-based approaches.",
    "Support safe operation, maintenance, and emergency preparedness of LNG facilities."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: General Requirements",
    "Module 3: Plant Siting",
    "Module 4: Plant Layout",
    "Module 5: Process Equipment",
    "Module 6: Stationary LNG Storage",
    "Module 7: Vaporization Facilities",
    "Module 8: Piping Systems and Components",
    "Module 9: Instrumentation and Electrical Services",
    "Module 10: Plant Facilities Design",
    "Module 11: Impounding Area and Drainage System Design & Capacity",
    "Module 12: Mobile and Temporary LNG Facility",
    "Module 13: Transfer Systems for Hazardous Fluids",
    "Module 14: Fire Protection, Safety, and Security",
    "Module 15: Requirements for Stationary Applications for Small Scale LNG Facilities",
    "Module 16: Operating, Maintenance, and Personnel Training",
    "Module 17: Performance-Based LNG Plant Siting Using Quantitative Risk Analysis (QRA)"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $250",
  "certification": "Certificate of Completion"
},

{
  "id": 71,
  "title": "Guideline for Design Construction and Operations of Oil and Gas Production Facilities",
  "date": "Present",
  "description": [
    "The Guideline for Design, Construction and Operations course provides a comprehensive understanding of the regulatory, technical, operational, and HSE requirements governing oil and gas production facilities. The course is designed to guide participants through the full facility lifecycle, from regulatory approvals and design considerations to construction, installation, and safe operational practices.",
    "Emphasis is placed on compliance with regulatory frameworks, minimum engineering standards, operational readiness, and the integration of health, safety, and environmental (HSE) requirements into facility design and day-to-day operations. The course helps participants align engineering decisions with regulatory expectations, ensuring facilities are safe, reliable, and compliant throughout their operating life."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Guideline%20for%20Design%20Construction%20and%20Operations.png",
  "tags": [],
  "category": "Petroleum",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of oil and gas production facilities",
    "Familiarity with engineering design or plant operations",
    "Understanding of process safety and HSE principles"
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand regulatory expectations governing the design, construction, and operation of oil and gas production facilities.",
    "Navigate approval and consent processes required by regulatory authorities.",
    "Apply minimum engineering and construction standards to ensure safe and compliant facilities.",
    "Implement operational requirements that support safe, reliable, and efficient facility performance.",
    "Integrate HSE principles into facility design and operations, minimizing risk to people, assets, and the environment.",
    "Support compliance and audit readiness throughout the facility lifecycle."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Application Procedure for Regulatory Approvals and Consents for Oil & Gas Production Facilities",
    "Module 3: Minimum Design, Construction, and Installation Considerations and Specifications",
    "Module 4: Minimum Facility Operations Requirement",
    "Module 5: Minimum HSE Requirements for Facility Operations"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 72,
  "title": "Bunkering Of Liquefied Natural Gas Fueled Vessels",
  "date": "Present",
  "description": [
    "The Bunkering of Liquefied Natural Gas (LNG) Fueled Vessels course provides a structured and practical understanding of the design, operation, and safety management of LNG bunkering activities. With the rapid adoption of LNG as a marine fuel to meet environmental regulations, safe and efficient bunkering operations have become critical for ports, terminals, ship operators, and bunker service providers.",
    "This course covers LNG transfer system design requirements, bunkering processes and procedures, quality and management systems, and personnel competency requirements, with emphasis on risk control, regulatory compliance, and operational best practices. The training addresses ship-to-ship, truck-to-ship, and terminal-to-ship LNG bunkering operations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/bunkering%20of%20liquefied%20natural%20gas%20fueled%20vessels%20(2).png",
  "tags": [],
  "category": "Petroleum",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of marine operations and ship systems",
    "Familiarity with LNG properties and cryogenic safety principles",
    "General understanding of process safety, HSE, and maritime regulations"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles and hazards of LNG bunkering operations for LNG-fueled vessels.",
    "Apply transfer system design requirements to ensure safe LNG handling and containment.",
    "Execute LNG bunkering procedures safely and efficiently, including normal and emergency operations.",
    "Implement effective management and quality assurance systems for LNG bunkering activities.",
    "Define training and competency requirements for personnel involved in LNG bunkering operations.",
    "Ensure compliance with international maritime and LNG safety regulations."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Transfer system design requirements",
    "Module 3: LNG bunkering processes and procedures",
    "Module 4: Management system/quality assurance",
    "Module 5: Personnel training"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 73,
  "title": "Design Petroleum Fuel Facilities",
  "date": "Present",
  "description": [
    "The Design of Petroleum Fuel Facilities course provides comprehensive technical and practical guidance on the planning, engineering design, operation, rehabilitation, and closure of petroleum fuel storage and distribution systems. The course covers bulk fuel storage terminals, aviation fueling systems, marine and ground fueling facilities, pipelines, and supporting infrastructure, with strong emphasis on safety, reliability, regulatory compliance, and lifecycle management.",
    "Participants will gain in-depth understanding of POL (Petroleum, Oil & Lubricants) facility design principles, applicable international standards, system configuration, and best practices for both greenfield and brownfield projects. The course integrates design considerations for normal operations, rehabilitation, temporary deactivation, and permanent facility closure, making it ideal for engineers involved in long-term fuel infrastructure development."
  ],
  "image": "https://ik.imagekit.io/mags/courses/DESIGN%20PETROLEUM%20FUEL%20FACILITIES.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "Basic knowledge of petroleum products and fuel properties",
    "Fundamental understanding of process, mechanical, piping, or civil engineering",
    "Familiarity with industrial facilities or oil & gas infrastructure",
    "Basic understanding of P&IDs and engineering drawings"
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand petroleum fuel facility design principles and their application across aviation, marine, ground, and pipeline systems.",
    "Apply international codes and standards to the design of POL storage and distribution facilities.",
    "Design bulk fuel storage and fueling systems with emphasis on safety, operability, and maintainability.",
    "Evaluate piping and tank system requirements, including materials, layouts, and protection systems.",
    "Plan interterminal pipelines and transfer systems for reliable fuel movement.",
    "Develop rehabilitation and upgrade strategies for aging fuel facilities.",
    "Manage temporary deactivation and permanent closure of fueling facilities in compliance with environmental and safety regulations.",
    "Integrate lifecycle thinking into petroleum fuel facility design, from concept to decommissioning."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: General Design Information",
    "Module 3: Bulk Fuel Storage Facilities",
    "Module 4: Aircraft Fueling Facilities",
    "Module 5: Marine Receiving And Dispensing Facilities",
    "Module 6: Interterminal And Installation Pipelines",
    "Module 7: Ground Products Fueling Facilities",
    "Module 8: Atmospheric Storage Tanks",
    "Module 9: Piping Systems",
    "Module 10: Alternate Pol Facilities",
    "Module 11: Support Facilities",
    "Module 12: Major Rehabilitation",
    "Module 13: Fueling Facility Temporary Deactivation",
    "Module 14: Fueling Facility Closure"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 74,
  "title": "Practical Centrifugal Pumps Design, Operation and Maintenance",
  "date": "Present",
  "description": [
    "The Practical Centrifugal Pumps – Design, Operation and Maintenance course provides a comprehensive and hands-on understanding of centrifugal pump systems, focusing on how pumps are designed, selected, operated, installed, and maintained in real industrial environments. The course bridges theory and practice, enabling participants to understand pump hydraulics, internal forces, performance characteristics, and common failure modes.",
    "Emphasis is placed on correct pump specification and selection, proper installation and commissioning practices, performance testing, and preventive maintenance strategies. Participants will learn how to diagnose operational problems, improve reliability, and extend pump service life while maintaining safe and efficient plant operation."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Practical%20Centrifugal%20Pumps%20Design,%20Operation%20and%20Maintenance.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    "Basic understanding of fluid mechanics and process operations",
    "Familiarity with industrial equipment and piping systems",
    "Exposure to maintenance or operations environments is advantageous"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand centrifugal pump design and operating principles.",
    "Apply pump hydraulics concepts to evaluate performance and efficiency.",
    "Select and specify centrifugal pumps correctly for various services.",
    "Interpret pump curves and operating characteristics to avoid off-design operation.",
    "Implement proper installation, commissioning, and testing practices.",
    "Identify and troubleshoot common centrifugal pump problems.",
    "Apply effective maintenance practices to improve reliability and reduce downtime."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Centrifugal pump design and construction",
    "Module 3: Pump hydraulics",
    "Module 4: Forces in centrifugal pumps",
    "Module 5: Centrifugal pump operation and characteristics",
    "Module 6: Pump specification and selection",
    "Module 7: Pump testing and inspection",
    "Module 8: Pump installation and commissioning",
    "Module 9: Centrifugal pump maintenance"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 75,
  "title": "Purging Principles & Practice",
  "date": "Present",
  "description": [
    "The Purging Principles and Practice course provides a comprehensive understanding of the theory, methods, and safe execution of purging operations used in oil & gas, natural gas transmission, LNG, and LPG facilities. Purging is a critical activity during commissioning, start-up, shutdown, maintenance, and decommissioning, where incorrect practices can lead to fires, explosions, or toxic exposure.",
    "This course focuses on controlling purging operations, selection of inert purge media, gas analysis, instrumentation, and application-specific purging practices for pipelines and process facilities. Real-world operational scenarios are used to emphasize safe transition between air, inert gas, and hydrocarbons."
  ],
  "image": "https://ik.imagekit.io/mags/courses/PURGING%20PRINCIPLES%20AND%20PRACTICE.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of process engineering and pipeline systems",
    "Familiarity with hydrocarbon properties"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the principles and safety importance of purging operations in hydrocarbon facilities.",
    "Select appropriate purging methods and inert media for different systems and applications.",
    "Control and monitor purging activities to prevent flammable or explosive atmospheres.",
    "Interpret gas analysis data to verify safe conditions before system handover.",
    "Apply purging practices safely in natural gas pipelines, LNG, and LPG facilities.",
    "Support commissioning, maintenance, and shutdown activities in compliance with industry standards."
  ],
  "outline": [
    "Module 1: General Information",
    "Module 2: Control of Purging",
    "Module 3: Gas Analysis & Instrumentation",
    "Module 4: Inert Purge Media",
    "Module 5: Natural Gas Transmission & Distribution Pipe",
    "Module 6: Liquefied Natural Gas Facilities",
    "Module 7: Liquefied Petroleum Gas Facilities"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 76,
  "title": "Process Safety in Upstream Oil and Gas",
  "date": "Present",
  "description": [
    "The Process Safety in Upstream Oil and Gas course provides a comprehensive understanding of process safety principles and their application across upstream oil and gas operations, including wells, onshore production facilities, offshore installations, and project execution phases. The course is structured around Risk-Based Process Safety (RBPS) concepts, focusing on the prevention and mitigation of major accident hazards such as loss of containment, fires, explosions, and blowouts.",
    "Participants will learn how process safety is applied throughout the upstream asset lifecycle from well design and drilling through production, facility operation, and project execution. The course integrates engineering, operational, and organizational aspects of process safety, emphasizing practical implementation rather than theory alone."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Process%20Safety%20in%20Upstream%20Oil%20and%20Gas.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "prerequisite": [
    "Basic understanding of oil and gas upstream operations",
    "Familiarity with engineering or operational environments",
    "General awareness of health, safety, and environmental (HSE) principles"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand key process safety principles and their importance in upstream oil and gas operations.",
    "Apply the Risk-Based Process Safety (RBPS) framework to identify and manage major accident hazards.",
    "Recognize process safety risks associated with wells, onshore, and offshore production facilities.",
    "Apply barrier and integrity management concepts across the upstream lifecycle.",
    "Integrate process safety into engineering design, construction, and installation activities.",
    "Support safe operations and regulatory compliance through effective process safety practices."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: The Upstream Industry",
    "Module 3: Overview of Risk Based Process Safety (RBPS)",
    "Module 4: Application of Process Safety to Wells",
    "Module 5: Application of Process Safety to Onshore Production",
    "Module 6: Application of Process Safety to Offshore Production",
    "Module 7: Application of Process Safety to Engineering Design, Construction and Installation"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 77,
  "title": "Hydrogen Technologies",
  "date": "Present",
  "description": [
    "The Hydrogen Technologies course provides a comprehensive introduction to hydrogen as an energy carrier, covering its production, storage, handling, fueling infrastructure, and utilization in power and mobility applications. The course emphasizes safety, performance-based design, and regulatory compliance, addressing the unique hazards and engineering challenges associated with hydrogen systems.",
    "Participants will gain practical insights into gaseous and liquefied hydrogen technologies, hydrogen fueling facilities, fuel cell power systems, and hydrogen generation processes. The course integrates fire safety principles, performance-based approaches, and system design considerations, making it highly relevant to professionals involved in hydrogen projects across industrial, transportation, and energy sectors."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Hydrogen%20Technologies.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic understanding of engineering fundamentals (mechanical, process, electrical, or chemical)",
    "Familiarity with industrial safety principles and hazardous materials handling",
    "General knowledge of energy systems or oil & gas facilities"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand hydrogen properties and applications across industrial, mobility, and power sectors.",
    "Apply fire safety and risk management principles specific to hydrogen systems.",
    "Evaluate gaseous and liquefied hydrogen technologies, including storage and fueling infrastructure.",
    "Apply performance-based design concepts to hydrogen facility safety and compliance.",
    "Understand hydrogen generation and fuel cell technologies and their role in energy systems.",
    "Support safe design, operation, and regulatory compliance of hydrogen facilities and projects."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: General Fire Safety Requirement",
    "Module 3: Performance-Based Option",
    "Module 4: General Hydrogen Requirements",
    "Module 5: Gaseous Hydrogen",
    "Module 6: Liquefied Hydrogen",
    "Module 7: GH2 Vehicle Fueling Facilities",
    "Module 8: LH2 Fueling Facilities",
    "Module 9: Hydrogen Fuel Cell Power Systems",
    "Module 10: Hydrogen Generation Systems"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 78,
  "title": "P&ID Reviewing Checklist",
  "date": "Present",
  "description": [
    "The P&ID Reviewing Checklist course provides a structured and systematic approach to reviewing Piping and Instrumentation Diagrams (P&IDs) throughout the project lifecycle. P&IDs are the backbone of process design, construction, commissioning, operation, and safety analysis; errors or omissions can lead to costly rework, safety incidents, and operational inefficiencies.",
    "This course equips participants with practical checklists and review methodologies to ensure P&IDs are complete, consistent, technically correct, and compliant with project specifications and industry standards. Emphasis is placed on format consistency, symbol usage, technical accuracy, and design integrity, enabling participants to identify gaps and risks early in the project."
  ],
  "image": "https://ik.imagekit.io/mags/courses/P&ID%20Checklist.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic understanding of process engineering concepts",
    "Familiarity with P&IDs, PFDs, and engineering drawings",
    "General knowledge of process equipment, piping, and instrumentation"
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Apply a structured checklist approach to reviewing P&IDs.",
    "Verify format and documentation compliance with project and company standards.",
    "Confirm correct application of symbols and drawing conventions.",
    "Identify technical errors, omissions, and inconsistencies in process, piping, and instrumentation details.",
    "Assess design completeness, operability, and safety readiness of P&IDs.",
    "Support effective HAZOP, construction, commissioning, and operations through high-quality P&IDs."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Format Check",
    "Module 3: Demonstration Rules Check",
    "Module 4: Technical Check",
    "Module 5: Design Check"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 79,
  "title": "Process Design of Separation Vessels",
  "date": "Present",
  "description": [
    "The Process Design of Separation Vessels course provides a comprehensive and practical understanding of the process design principles, selection criteria, and sizing methodologies for separation vessels used in oil & gas, petrochemical, and process industries. Separation vessels—such as knockout drums, two-phase and three-phase separators, and reflux drums—are critical for protecting downstream equipment, ensuring product quality, and maintaining safe and reliable plant operation.",
    "This course focuses on process design rather than mechanical design, emphasizing phase separation fundamentals, sizing calculations, operating envelopes, and performance limitations. Through worked examples and real-life case studies, participants will learn how to select the right separator type, determine vessel dimensions, and evaluate design adequacy under varying operating conditions."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Process%20Design%20of%20Separation%20Vessels.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of process engineering fundamentals",
    "Familiarity with phase behavior, vapor–liquid equilibrium, and fluid properties",
    "Understanding of process flow diagrams (PFDs) and P&IDs"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the function and application of different types of separation vessels.",
    "Select appropriate separator configurations based on process and operating requirements.",
    "Apply basic sizing calculations for gas–liquid and liquid–liquid separation.",
    "Design knockout drums, two-phase, and three-phase separators from a process perspective.",
    "Evaluate separator performance limits and identify potential operational issues.",
    "Review and validate separator designs using sound engineering judgment and case-study experience."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Selection of Separator Type",
    "Module 3: Basic Sizing Information",
    "Module 4: Design of Knockout Drums and Vertical Two Phase Separators",
    "Module 5: Design of Horizontal Separators and Reflux Drums",
    "Module 6: Design of High Pressure Vertical Three-phase Separators",
    "Module 7: Package Units",
    "Module 8: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 80,
  "title": "Ammonia Concept and Application",
  "date": "Present",
  "description": [
    "Ammonia (NH₃) is one of the most important industrial chemicals, widely used in fertilizer production, chemicals manufacturing, refrigeration systems, and emerging energy applications such as hydrogen carriers and carbon-free fuels. Modern ammonia plants involve complex chemical reactions, high-pressure synthesis loops, advanced separation technologies, and integrated energy systems.",
    "The Ammonia Concept and Application course provides a comprehensive understanding of ammonia production technology from feedstock preparation to storage and emerging future applications. The course combines process fundamentals, industrial practices, equipment design principles, and operational considerations used in modern ammonia plants.",
    "Participants will gain insights into the complete ammonia process flow, including purification, reforming, shift conversion, CO₂ removal, methanation, synthesis loop operations, refrigeration systems, recovery techniques, and storage infrastructure.",
    "The course also explores future developments in ammonia technology, including green ammonia production, decarbonization strategies, and ammonia’s role in the hydrogen economy. It is designed to bridge the gap between process theory and real industrial applications, making it suitable for engineers, plant operators, and technical professionals involved in ammonia and fertilizer industries."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Ammonia%20Concept%20and%20Application.png",
  "tags": [],
  "category": "PC",
  "duration": "5 Days",
  "prerequisite": [
  `Educational Background:
· Basic knowledge of chemical or process engineering
· Understanding of industrial process operations`,

  `Technical Knowledge:
· Fundamentals of mass and energy balance, thermodynamics, heat transfer, chemical reaction engineering
· Basic familiarity with process flow diagrams (PFDs) and process & instrumentation diagrams (P&IDs)`
],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the complete ammonia production process flow",
    "Explain the chemical reactions and thermodynamics involved in ammonia synthesis",
    "Identify the major equipment used in ammonia plants",
    "Analyze the function of each process unit in ammonia production",
    "Understand steam methane reforming and hydrogen generation",
    "Evaluate CO and CO₂ removal technologies",
    "Explain synthesis loop design and catalyst behavior",
    "Understand ammonia refrigeration systems",
    "Evaluate ammonia recovery and purification techniques",
    "Identify ammonia storage and safety considerations",
    "Recognize process optimization opportunities",
    "Identify operational challenges and troubleshooting strategies",
    "Understand energy integration within ammonia plants",
    "Understand the concept of green ammonia production",
    "Evaluate ammonia as a hydrogen carrier and clean fuel",
    "Discuss the future role of ammonia in the global energy transition"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Purification",
    "Module 3: Steam Reforming",
    "Module 4: Carbon Monoxide Shift Conversion",
    "Module 5: CO₂ Removal",
    "Module 6: Methanation",
    "Module 7: Ammonia Synthesis",
    "Module 8: Refrigeration",
    "Module 9: Ammonia Recovery",
    "Module 10: Ammonia Storage",
    "Module 11: Future of Ammonia"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 81,
  "title": "Caustic Soda",
  "date": "Present",
  "description": [
    "Caustic soda (sodium hydroxide, NaOH) is one of the most widely used industrial chemicals in petroleum refining, petrochemicals, water treatment, pulp and paper, alumina production, and chemical manufacturing. It plays a critical role in neutralization, scrubbing, pH control, mercaptan removal, and various chemical reactions.",
    "Due to its highly corrosive nature, caustic soda requires careful design of handling systems, proper storage practices, and strict safety controls. This course provides a comprehensive understanding of the manufacturing processes, physical forms, transportation, storage, safe handling, dilution, equipment selection, and analytical methods related to caustic soda.",
    "Participants will gain both technical and operational competence, enabling them to safely manage caustic soda across the supply chain, from production to end-use application."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Caustic%20soda.png",
  "tags": [],
  "category": "PC",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of chemical engineering or industrial chemistry
· Familiarity with process equipment and material handling systems
· Understanding of workplace safety and chemical hazard management`,
    `This course is suitable for:
· Process Engineers
· Chemical Engineers
· Operations and Maintenance Personnel
· Safety Officers
· Logistics and Tank Farm Personnel
· Laboratory and Quality Control Staff`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the properties, characteristics, and principal uses of caustic soda.",
    "Identify the different forms of caustic soda (liquid, flakes, beads, anhydrous) and their applications.",
    "Explain the manufacturing process, including chlor-alkali production methods.",
    "Understand safe and compliant methods of shipping and transportation.",
    "Apply best practices for safe handling, including PPE, hazard communication, and emergency response.",
    "Implement correct procedures for unloading and handling liquid caustic soda.",
    "Understand the properties and risks associated with anhydrous caustic soda.",
    "Apply proper procedures for storage and handling of caustic soda beads.",
    "Safely perform dissolution of anhydrous caustic soda, understanding heat generation and dilution hazards.",
    "Select appropriate materials and equipment for caustic soda service (pumps, piping, tanks).",
    "Interpret key technical data, including density, concentration, freezing point, and compatibility.",
    "Perform accurate dilution calculations for process and laboratory applications.",
    "Apply appropriate methods of analysis to determine concentration and purity.",
    "Identify corrosion risks and implement mitigation strategies.",
    "Ensure compliance with safety, environmental, and transportation regulations."
  ],
  "outline": [
    "Module 1: Introduction & Principal Uses",
    "Module 2: Forms of Caustic Soda",
    "Module 3: Manufacturing",
    "Module 4: Methods of Shipping Caustic Soda",
    "Module 5: Safety in Handling Caustic Soda",
    "Module 6: Unloading and Handling Liquid Caustic Soda",
    "Module 7: Anhydrous Caustic Soda",
    "Module 8: Shipments, Handling and Storage of Caustic Soda Beads",
    "Module 9: Dissolving Anhydrous Caustic Soda",
    "Module 10: Equipment for Handling Caustic Soda",
    "Module 11: Technical Data",
    "Module 12: Dilution Calculations",
    "Module 13: Methods of Analysis"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 82,
  "title": "Petrochemical Processes",
  "date": "Present",
  "description": [
    "The Petrochemical Processes Course provides a comprehensive understanding of the transformation of hydrocarbons and alternative feedstocks into value-added chemicals, intermediates, polymers, and specialty products. The course covers feedstock selection and preparation, conversion technologies, product synthesis pathways, and integration of petrochemical complexes.",
    "Participants will explore the production of chemicals derived from paraffins, olefins, aromatics, non-hydrocarbon sources, and synthesis gas processes such as the Fischer–Tropsch process. The course also introduces monomers, polymers, plastics manufacturing, and an overview of petrochemical applications in pharmaceuticals.",
    "This course is ideal for chemical engineers, process engineers, plant operators, project engineers, and technical professionals working in refineries, petrochemical plants, gas processing facilities, and downstream industries."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Petrochemical%20Processes.png",
  "tags": [],
  "category": "PC",
  "duration": "5 Days",
  "prerequisite": [
    "Basic knowledge of organic chemistry",
    "Understanding of chemical reaction engineering fundamentals",
    "Familiarity with refinery and hydrocarbon processing concepts",
    "Basic knowledge of heat transfer and separation processes",
    "Ability to interpret process flow diagrams"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Describe the structure of the petrochemical industry, including upstream integration and downstream product value chains.",
    "Explain feedstock composition and properties, including natural gas, naphtha, LPG, and refinery streams.",
    "Evaluate alternative feedstocks such as coal, oil shale, and biomass and their conversion pathways.",
    "Understand feedstock preparation processes, including separation, purification, and conditioning.",
    "Explain gasification principles and synthesis gas (syngas) production.",
    "Identify major chemicals derived from paraffins, including cracking and reforming products.",
    "Describe production pathways for olefin-based chemicals, including ethylene and propylene derivatives.",
    "Explain aromatic hydrocarbon processing, including benzene, toluene, and xylene derivatives.",
    "Understand production of chemicals from non-hydrocarbon sources, including ammonia and methanol.",
    "Explain the Fischer–Tropsch synthesis route and its role in synthetic fuels and chemical production.",
    "Describe monomer and polymer production processes, including plastics manufacturing technologies.",
    "Recognize the role of petrochemicals in pharmaceutical production and specialty chemical industries."
  ],
  "outline": [
    "Module 1: Petrochemical Industry",
    "Module 2: Feedstock Composition and Properties",
    "Module 3: Other Feedstocks—Coal, Oil Shale, and Biomass",
    "Module 4: Feedstock Preparation",
    "Module 5: Feedstock Preparation by Gasification",
    "Module 6: Chemicals from Paraffin Hydrocarbons",
    "Module 7: Chemicals from Olefin Hydrocarbons",
    "Module 8: Chemicals from Aromatic Hydrocarbons",
    "Module 9: Chemicals from Non-hydrocarbons",
    "Module 10: Chemicals from the Fischer–Tropsch Process",
    "Module 11: Monomers, Polymers, and Plastics",
    "Module 12: Pharmaceuticals"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $250",
  "certification": "Certificate of Completion"
},

{
  "id": 83,
  "title": "Facility Layout & Separation Distances Guidelines",
  "date": "Present",
  "description": [
    "Proper facility layout and adequate separation distances are fundamental to ensuring process safety, asset integrity, regulatory compliance, and operational continuity in oil & gas, petrochemical, LNG, refining, and offshore installations. Poor layout decisions can significantly increase the consequences of fire, explosion, toxic release, and escalation events.",
    "This course provides a systematic, risk-based approach to facility layout development and the determination of safe separation distances. Participants will learn how to apply industry-recognized standards such as American Petroleum Institute (API), National Fire Protection Association (NFPA), Occupational Safety and Health Administration (OSHA), and International Organization for Standardization (ISO) within a structured engineering framework.",
    "The program walks participants through: Scope definition and document hierarchy, Hazard identification and risk assessment integration, Step-by-step facility location selection, Process unit and equipment layout development, Offshore-specific constraints, Brownfield modifications and Management of Change (MOC).",
    "The course emphasizes practical application, enabling engineers to confidently evaluate layout decisions in both greenfield and brownfield projects."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Facility%20Layout%20&%20Separation%20Distances%20Guidelines.png",
  "tags": [],
  "category": "plant drafting",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of process plant design and engineering workflows
· Familiarity with PFDs, P&IDs, and plot plans
· Understanding of process safety fundamentals
· Exposure to HAZID / HAZOP concepts is beneficial
· Engineering background (Process, Mechanical, Safety, Civil, or Project Engineering)`,
    `This course is suitable for:
· Process Engineers
· Safety & Risk Engineers
· Layout / Piping Engineers
· Project Engineers
· EPC and Owner’s Engineers.`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and importance of facility layout and separation distances in risk reduction.",
    "Define the scope and boundaries of facility layout studies.",
    "Interpret key terms, abbreviations, and reference documentation used in layout engineering.",
    "Apply relevant industry codes, standards, and company specifications in layout design.",
    "Understand document precedence hierarchy in multi-standard projects.",
    "Implement proper deviation and concession control processes for layout decisions.",
    "Apply a high-level technical, risk-based approach to facility layout development.",
    "Conduct and interpret hazard identification (HAZID) and risk assessments related to layout.",
    "Select appropriate facility locations considering environmental, safety, and operational constraints.",
    "Develop safe layouts for process units within a facility, considering escalation prevention.",
    "Determine safe spacing for equipment within process units.",
    "Apply layout principles to offshore installations, including space and evacuation constraints.",
    "Address construction challenges and brownfield modifications, integrating Management of Change (MOC) principles.",
    "Critically review plot plans and layout drawings for safety, compliance, and operability."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Scope",
    "Module 3: Defined Terms / Abbreviations / References",
    "Module 4: Reference Documents",
    "Module 5: Documents Precedence",
    "Module 6: Deviation /Concession Control",
    "Module 7: High-Level Technical Approach",
    "Module 8: Hazard Identification (Risk Assessment)",
    "Module 9: Step-1: Select Facility Location",
    "Module 10: Step-2: Layout ‘Process Unit’ (Within Facility)",
    "Module 11: Step-3: Layout ‘Equipment’ (Within Process Units)",
    "Module 12: Offshore Installations",
    "Module 13: Construction & Brownfield Issues (Management Of Change)"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 84,
  "title": "Plot Plan Design Criteria For Process Units",
  "date": "Present",
  "description": [
    "Plot plan design is a critical aspect of process plant engineering that determines the physical arrangement of equipment, piping systems, structures, access routes, and safety facilities within a plant. A well-developed plot plan ensures safe operations, efficient process flow, ease of maintenance, proper access for personnel and emergency services, and compliance with industrial safety standards.",
    "The Plot Plan Design Criteria for Process Units Course provides participants with a comprehensive understanding of the principles and practices used in designing the layout of process units in refineries, petrochemical plants, gas processing facilities, and other industrial installations. The course focuses on how equipment positioning, spacing requirements, piping accessibility, and safety considerations influence overall plant performance and operational safety.",
    "Participants will learn the design criteria used in arranging process equipment such as reactors, columns, heat exchangers, pumps, compressors, and storage vessels within a process unit. The course also addresses important considerations including maintenance access, firefighting requirements, emergency evacuation routes, pipe rack layout, and operational efficiency.",
    "The course incorporates widely recognized industrial guidelines such as API Recommended Practice 752, API Recommended Practice 753, and safety guidance from NFPA for safe plant layout and spacing.",
    "Through engineering examples and practical design considerations, participants will develop the skills required to contribute effectively to plot plan development and process unit layout in industrial projects."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Plot%20Plan%20Design%20Criteria%20For%20Process%20Units.png",
  "tags": [],
  "category": "plant drafting",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of chemical engineering, mechanical engineering, or process engineering
· Familiarity with: Process plant operations, Process Flow Diagrams (PFDs), Process and Instrumentation Diagrams (P&IDs), Basic piping and equipment systems`,
    `This course is suitable for professionals working in:
· Process engineering
· Piping engineering
· Mechanical engineering
· Plant layout and design
· Project engineering
· EPC project development
· Refinery and petrochemical operations`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the importance of plot plan design in process plant safety and efficiency",
    "Identify the key factors influencing process unit layout",
    "Understand criteria used for locating process equipment within a unit",
    "Determine appropriate spacing and positioning for major equipment",
    "Evaluate layout considerations related to fire protection, access roads, and emergency evacuation",
    "Ensure safe separation between hazardous equipment and operational areas",
    "Design layouts that allow easy access for maintenance and operation",
    "Consider lifting, equipment removal, and utility connections",
    "Understand how plot plans integrate with piping design, structural design, and safety systems",
    "Apply best practices in industrial plant layout development"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Plant Layout",
    "Module 3: Process Equipment Layout",
    "Module 4: Miscellaneous"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦80,000 / $60",
  "certification": "Certificate of Completion"
},

{
  "id": 85,
  "title": "Chemical Process Equipment (Selection and Design)",
  "date": "Present",
  "description": [
    "The selection and design of chemical process equipment are fundamental to the successful development of industrial plants in refining, petrochemicals, gas processing, pharmaceuticals, and specialty chemicals. Proper equipment sizing and configuration directly influence plant efficiency, safety, reliability, energy consumption, and capital cost.",
    "This course provides a comprehensive understanding of process equipment selection principles, design methodologies, and performance evaluation across major unit operations. Participants will explore flowsheet development, fluid transport systems, heat transfer equipment, separation technologies, reactors, and process vessels.",
    "The course integrates practical engineering standards and best practices aligned with internationally recognized bodies such as American Society of Mechanical Engineers (ASME), American Petroleum Institute (API), and International Society of Automation (ISA), ensuring real-world applicability in EPC and operating environments.",
    "Participants will gain the competence to select appropriate equipment, perform preliminary sizing calculations, evaluate alternatives, and interpret vendor data within multidisciplinary engineering projects."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Chemical%20Process%20Equipment%20(Selection%20and%20Design).png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    `· Basic knowledge of chemical engineering principles
· Understanding of fluid mechanics, heat transfer, and thermodynamics
· Familiarity with process flow diagrams (PFDs) and P&IDs`,
    `This course is suitable for:
· Process Engineers
· Chemical Engineers
· Mechanical Engineers involved in process design
· EPC Design Engineers
· Graduate Engineers entering process industries
· Technical Professionals seeking deeper equipment knowledge`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of process equipment within chemical plant operations.",
    "Interpret and develop process flowsheets for equipment selection.",
    "Integrate process control requirements into equipment design.",
    "Select appropriate drivers for rotating equipment, including electric motors and turbines.",
    "Design and evaluate systems for transfer of solids.",
    "Analyze and calculate fluid flow parameters in piping systems.",
    "Select and size fluid transport equipment, including pumps and compressors.",
    "Apply principles of heat transfer in the design and selection of heat exchangers.",
    "Understand design considerations for dryers and cooling towers.",
    "Select appropriate equipment for mixing and agitation processes.",
    "Design systems for solid-liquid separation, including filtration and centrifugation.",
    "Apply mass transfer principles in distillation and gas absorption column design.",
    "Evaluate liquid-liquid extraction and leaching processes.",
    "Understand principles of adsorption and ion exchange systems.",
    "Apply crystallization design principles for solution and melt systems.",
    "Select and size chemical reactors, including batch and continuous systems.",
    "Design and evaluate process vessels in accordance with ASME/API standards.",
    "Balance technical performance, safety, and cost in equipment selection decisions.",
    "Review vendor proposals and technical datasheets critically."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Flowsheets",
    "Module 3: Process Control",
    "Module 4: Drivers For Moving Equipment",
    "Module 5: Transfer Of Solids",
    "Module 6: Flow Of Fluids",
    "Module 7: Fluid Transport Equipment",
    "Module 8: Heat Transfer And Heat Exchangers",
    "Module 9: Dryers And Cooling Towers",
    "Module 10: Mixing And Agitation",
    "Module 11: Solid-Liquid Separation",
    "Module 12: Distillation And Gas Absorption",
    "Module 13: Extraction And Leaching",
    "Module 14: Adsorption And Ion Exchange",
    "Module 15: Crystallization From Solutions And Melts",
    "Module 16: Chemical Reactors",
    "Module 17: Process Vessels"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦450,000 / $400",
  "certification": "Certificate of Completion"
},

{
  "id": 86,
  "title": "Compressor Selection Guidelines",
  "date": "Present",
  "description": [
    "Compressors are critical rotating equipment in oil & gas, petrochemical, LNG, power generation, and industrial process plants. Proper compressor selection directly impacts process efficiency, reliability, energy consumption, safety, and lifecycle cost. Incorrect selection can result in vibration issues, seal failures, performance instability, and costly downtime.",
    "This course provides a comprehensive understanding of compressor selection principles, including compressor types, compression theory, performance evaluation, lubrication systems, seal systems, and ancillary equipment requirements. It integrates best practices and international standards such as those from the American Petroleum Institute (API – e.g., API 617, API 618) and the International Organization for Standardization (ISO).",
    "Participants will learn how to evaluate operating conditions, define technical specifications, interpret vendor data, and select compressors that meet both process requirements and reliability targets."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Compressor%20selection%20Guidelines.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of thermodynamics and fluid mechanics
· Understanding of process plant operations
· Familiarity with PFDs, P&IDs, and rotating equipment fundamentals`,
    `This course is suitable for:
· Process Engineers
· Mechanical / Rotating Equipment Engineers
· Reliability Engineers
· Project Engineers
· EPC Design Engineers
· Operations and Maintenance Engineers`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of compressors in industrial process systems.",
    "Identify and interpret relevant codes, standards, and reference documents.",
    "Apply correct nomenclature and terminology used in compressor engineering.",
    "Differentiate between major types of compressors (centrifugal, reciprocating, screw, axial, etc.) and their applications.",
    "Understand the basic thermodynamic principles of gas compression.",
    "Evaluate key selection parameters, including flow rate, pressure ratio, gas composition, and operating envelope.",
    "Assess surge, choke, and operating stability considerations.",
    "Specify appropriate lubrication systems and understand their reliability impact.",
    "Select and evaluate seal systems, including dry gas seals and oil seals.",
    "Identify and specify necessary ancillary equipment, including drivers, coolers, pulsation dampeners, and control systems.",
    "Review and compare vendor proposals technically and commercially.",
    "Balance performance, reliability, maintainability, and lifecycle cost in compressor selection.",
    "Recognize common failure modes and mitigate selection-related risks.",
    "Contribute effectively to compressor specification during FEED and EPC phases."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: References",
    "Module 3: Nomenclature and Definitions",
    "Module 4: Types of Compressors",
    "Module 5: Basic Principles of Compression",
    "Module 6: Selection Considerations",
    "Module 7: Lubrication Systems",
    "Module 8: Seal Systems",
    "Module 9: Ancillary Equipment"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 87,
  "title": "Computer Methods in Chemical Engineering",
  "date": "Present",
  "description": [
    "Modern chemical and process engineering heavily relies on computer-based modeling and simulation tools for design, optimization, troubleshooting, and performance evaluation. From thermodynamic calculations to full plant simulation, digital tools have become essential for engineers working in oil & gas, petrochemical, LNG, refining, and chemical industries.",
    "This course provides a comprehensive understanding of computational methods applied to core chemical engineering operations. Participants will learn how to model thermodynamic systems, fluid flow, heat exchangers, reactors, separation processes, and complete plant simulations using industry-standard software platforms such as Aspen HYSYS, UniSim Design, PRO/II, Aspen Plus, and AVEVA Process Simulation.",
    "The course bridges fundamental engineering principles with practical simulation skills, enabling participants to develop reliable steady-state process models, perform sensitivity studies, evaluate design alternatives, and simulate entire process plants.",
    "This training is ideal for engineers involved in process design, FEED, EPC, operations support, and process optimization."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Computer%20Methods%20in%20Chemical%20Engineering.png",
  "tags": [],
  "category": "process",
  "duration": "8 Days",
  "prerequisite": [
    `· Bachelor’s degree or background in Chemical Engineering or related discipline
· Basic knowledge of:
· Thermodynamics
· Fluid Mechanics
· Heat Transfer
· Mass Transfer
· Reaction Engineering
· Familiarity with process flow diagrams (PFDs) and P&IDs
· Basic computer literacy
· Prior exposure to any simulation software is beneficial but not mandatory.`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Apply thermodynamic models to predict phase equilibrium and fluid properties.",
    "Perform material and energy balance calculations using simulation tools.",
    "Model fluid flow systems, including pipes, pumps, and compressors.",
    "Evaluate pressure drop and hydraulic performance using computational methods.",
    "Design and simulate shell and tube heat exchangers.",
    "Model and analyze chemical reactors (CSTR, PFR, equilibrium reactors).",
    "Simulate distillation columns including tray and packed columns.",
    "Model gas absorption systems.",
    "Perform liquid–liquid extraction simulations.",
    "Conduct sensitivity analysis and optimization studies.",
    "Develop steady-state models in UniSim / HYSYS.",
    "Build and analyze flowsheets in PRO/II.",
    "Perform chemical process modeling using Aspen Plus.",
    "Understand the interface and workflow of AVEVA Process Simulation.",
    "Select appropriate property packages and thermodynamic models.",
    "Troubleshoot convergence issues and model instability.",
    "Simulate an entire process plant from feed to product.",
    "Interpret simulation outputs for engineering decision-making.",
    "Compare different simulation platforms and understand their strengths.",
    "Support FEED and EPC deliverables using simulation results."
  ],
  "outline": [
    "Module 1: Thermodynamic and Fluid Phase Equilibrium",
    "Module 2: Fluid flow in pipes, pumps and compressors",
    "Module 3: Material and Energy Balance",
    "Module 4: Shell and Tube Heat Exchangers",
    "Module 5: Reactor Design",
    "Module 6: Distillation Column",
    "Module 7: Gas Absorption",
    "Module 8: Liquid Liquid Extraction",
    "Module 9: Simulation of Entire Process",
    "Module 10: Introduction to UniSim/Hysys",
    "Module 11: Introduction to PRO/II Simulation",
    "Module 12: Introduction to Aspen Plus",
    "Module 13: Introduction to Aveva Process Simulation"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 88,
  "title": "Depressuring Criteria",
  "date": "Present",
  "description": [
    "Depressuring (blowdown) is a critical safety function in oil & gas, petrochemical, LNG, and offshore facilities. Improper depressuring philosophy can result in catastrophic vessel rupture, escalation during fire exposure, excessive flare loading, or unnecessary CAPEX from overdesign.",
    "This course provides detailed technical guidance on how to determine when a Blowdown Valve (BDV) is required and when it is not, based on internationally recognized standards and major operator philosophies.",
    "Participants will gain in-depth understanding of depressuring criteria from American Petroleum Institute – API 521, TotalEnergies – GS SAF 261, ExxonMobil – Emergency Isolation, Depressuring & Shutdown Practices, Shell plc – DEP 80.45.10.10-Gen, BP – GP 44-80, and NORSOK – Technical Safety Standard S-001.",
    "The course bridges the gap between code requirements, company standards, and engineering judgment, helping engineers avoid both under-design (safety risk) and over-design (unnecessary flare load and cost).",
    "It is highly relevant for engineers involved in FEED and EPC design, Technical Safety & Loss Prevention, Process Engineering, Flare System Design, Brownfield modification studies, and HAZOP, SIL, and QRA reviews."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Depressuring%20Criteria.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of process engineering
· Understanding of pressure vessels and piping systems
· Familiarity with PFDs and P&IDs
· Basic knowledge of relief valves and flare systems
· Exposure to HAZOP or safety studies (beneficial but not mandatory)`,
    `This course is suitable for:
· Process Engineers
· Safety / Loss Prevention Engineers
· Static Equipment Engineers
· Project Engineers
· Operations Engineers
· FEED & EPC Design Engineers`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the purpose of emergency depressuring systems.",
    "Distinguish between pressure relief and depressuring (blowdown).",
    "Identify credible scenarios requiring depressuring (e.g., fire exposure, loss of containment, runaway reaction).",
    "Apply depressuring philosophy.",
    "Determine when fire case depressuring is required.",
    "Calculate target depressuring rates and time criteria.",
    "Understand metal temperature reduction and brittle fracture prevention.",
    "Decide when a BDV is required and when it can be avoided.",
    "Evaluate vessel size, pressure, inventory, and fire exposure area.",
    "Assess flare load impact from depressuring scenarios.",
    "Balance safety, operability, and economic considerations.",
    "Develop depressuring philosophy for FEED projects.",
    "Review and challenge vendor or consultant BDV proposals.",
    "Participate effectively in HAZOP and SIL discussions regarding blowdown systems.",
    "Perform sample depressuring calculations.",
    "Develop a structured checklist for BDV decision-making.",
    "Identify common overdesign and underdesign pitfalls.",
    "Integrate depressuring philosophy into flare system design."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: API-521",
    "Module 3: TOTAL- GS SAF 261",
    "Module 4: Exxon-emergency isolation, Depressuring, and shutdown systems",
    "Module 5: Shell- DEP 80.45.10.10-Gen",
    "Module 6: BP-GP 44-80",
    "Module 7: NORSOK STANDARD-Technical safety-(S-001)"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 89,
  "title": "Depressurizing and Low Temperature Studies",
  "date": "Present",
  "description": [
    "Depressurization during emergency blowdown or operational upsets can result in significant temperature reduction due to gas expansion (Joule–Thomson effect and auto-refrigeration). If not properly assessed, this can lead to brittle fracture, material failure, and catastrophic loss of containment.",
    "Depressurizing and Low Temperature Studies are critical components of process safety and mechanical integrity, particularly in high-pressure gas facilities, LNG plants, offshore platforms, and gas processing units.",
    "This course provides comprehensive guidance on understanding depressurization mechanisms, determining Minimum Design Metal Temperature (MDMT), performing low temperature calculations, establishing study basis and assumptions, and conducting dynamic simulation using Aspen HYSYS.",
    "Participants will learn how to perform structured depressurization studies that align with FEED and EPC deliverables and integrate results into material selection, mechanical design, and blowdown philosophy."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Depressuring%20And%20Low%20Temperature%20Studies.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of thermodynamics
· Understanding of gas laws and phase behavior
· Familiarity with pressure vessels and piping systems
· Basic exposure to flare and blowdown systems`,
    `This course is suitable for:
· Process Engineers
· Static Equipment Engineers
· Mechanical Engineers
· Materials/Corrosion Engineers
· Technical Safety Engineers
· FEED & EPC Engineers
· LNG and Gas Plant Engineers`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the physical phenomena during depressurization (Joule–Thomson cooling, vaporization effects).",
    "Distinguish between steady-state and dynamic depressurization.",
    "Understand why low temperature studies are critical for material integrity.",
    "Define Minimum Design Metal Temperature (MDMT).",
    "Understand brittle fracture mechanisms and material ductility limits.",
    "Identify governing design cases for low temperature conditions.",
    "Interpret relevant codes and mechanical design requirements.",
    "Establish a clear study basis, including: Initial pressure and temperature, Gas composition, Blowdown valve characteristics and Heat transfer assumptions",
    "Perform manual screening calculations for minimum temperature.",
    "Determine limiting metal temperature during blowdown.",
    "Identify the controlling scenario (fire case, blocked outlet, full inventory depressuring).",
    "Develop depressurization models using Aspen HYSYS dynamic mode.",
    "Configure vessel parameters and blowdown valves in simulation.",
    "Select appropriate thermodynamic packages.",
    "Run time-dependent depressurization analysis.",
    "Extract and interpret minimum fluid and metal temperatures.",
    "Troubleshoot common convergence issues in dynamic simulations.",
    "Determine whether material upgrade is required.",
    "Evaluate need for low-temperature carbon steel vs LTCS vs stainless steel.",
    "Integrate results into mechanical datasheets.",
    "Support BDV sizing and flare load analysis.",
    "Prepare a professional depressurization study report for FEED/EPC submission.",
    "Participate effectively in HAZOP and material selection reviews."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Objectives",
    "Module 3: Definition",
    "Module 4: Definition of Minimum Design Metal Temperature",
    "Module 5: Calculation of Minimum Temperature",
    "Module 6: Study Basis",
    "Module 7: Hysys Methodology"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 90,
  "title": "Design of Safe Closed-Circuit Ammonia Refrigeration Systems",
  "date": "Present",
  "description": [
    "Closed-circuit ammonia refrigeration systems are widely used in industrial facilities such as food processing plants, cold storage terminals, petrochemical complexes, and LNG facilities due to ammonia’s excellent thermodynamic properties and energy efficiency. However, ammonia is toxic and mildly flammable, requiring stringent safety-focused design and compliance with international standards such as International Institute of Ammonia Refrigeration (IIAR), American Society of Heating, Refrigerating and Air-Conditioning Engineers (ASHRAE), National Fire Protection Association (NFPA), and Occupational Safety and Health Administration (OSHA).",
    "This course provides a comprehensive and safety-driven approach to the design, layout, protection, and control of closed-circuit ammonia refrigeration systems. It covers machinery room design, equipment location, compressors, pumps, condensers, evaporators, pressure vessels, piping systems, overpressure protection, ammonia detection systems, and absorption refrigeration technologies.",
    "Participants will gain both technical design competence and process safety awareness, enabling them to design, review, and assess ammonia refrigeration systems in compliance with international safety standards."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Design%20of%20Safe%20Closed-Circuit%20Ammonia%20Refrigeration%20Systems.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    `· Basic understanding of thermodynamics and refrigeration principles
· Familiarity with pressure vessels, piping systems, and compressors
· Knowledge of industrial safety and hazard management
· Exposure to process design documentation (PFDs, P&IDs, layout drawings)`,
    `This course is suitable for:
· Mechanical Engineers
· Process Engineers
· Refrigeration Engineers
· Safety & Loss Prevention Engineers
· Facility Design Engineers
· EPC Project Engineers`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the fundamentals of closed-circuit ammonia refrigeration systems.",
    "Identify hazards associated with ammonia and apply risk-based safety design principles.",
    "Determine safe location criteria for ammonia refrigeration equipment.",
    "Apply general system design requirements in accordance with IIAR, ASHRAE, NFPA, and OSHA guidelines.",
    "Design compliant machinery rooms, including ventilation and emergency systems.",
    "Evaluate requirements for refrigeration equipment located outside machinery rooms.",
    "Understand design and operational considerations for compressors, refrigeration pumps, condensers, and evaporators.",
    "Apply safe design principles for pressure vessels, piping, and hoses.",
    "Assess packaged refrigeration systems for safety and compliance.",
    "Design and verify overpressure protection systems, including relief valves and discharge routing.",
    "Integrate instrumentation and control systems to ensure safe operation.",
    "Specify and evaluate ammonia detection and alarm systems.",
    "Understand the fundamentals and safety aspects of absorption refrigeration systems.",
    "Review and interpret engineering documents for ammonia refrigeration system design.",
    "Conduct preliminary hazard assessments and identify mitigation strategies for ammonia systems."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Location of Ammonia Refrigeration Equipment",
    "Module 3: General System Design Requirement",
    "Module 4: Machinery Rooms",
    "Module 5: Refrigeration Equipment located in areas other than Machinery Rooms",
    "Module 6: Compressor",
    "Module 7: Refrigeration Pumps",
    "Module 8: Condensers",
    "Module 9: Evaporators",
    "Module 10: Pressure Vessels",
    "Module 11: Piping and Hoses",
    "Module 12: Packaged System and Equipment",
    "Module 13: Overpressure Protection",
    "Module 14: Instrumentation and Controls",
    "Module 15: Ammonia Detection and Alarms",
    "Module 16: Absorption System"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 91,
  "title": "Flare Details for Petroleum, Petrochemical, and Natural Gas Industries",
  "date": "Present",
  "description": [
    "Flaring systems are critical safety components in petroleum, petrochemical, and natural gas facilities. They provide a controlled and reliable method for disposing of excess hydrocarbons and relieving overpressure during normal operations, startups, shutdowns, and emergency conditions. Proper flare system design is essential to ensure personnel safety, environmental compliance, operational reliability, and regulatory adherence.",
    "This course provides a comprehensive understanding of flare system design principles and mechanical details, with emphasis on both elevated flares and enclosed-flame flares. Participants will learn how to interpret design standards, define system scope, understand terminology, and apply engineering practices to achieve safe and compliant flare installations.",
    "The program incorporates guidance from recognized international standards such as American Petroleum Institute (API), National Fire Protection Association (NFPA), and relevant environmental regulations, ensuring alignment with industry best practices."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Flare%20Details%20for%20Petroleum,%20Petrochemical,%20and%20Natural%20Gas%20Industries.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of process engineering and pressure relief systems
· Familiarity with PFDs, P&IDs, and flare system layouts
· Knowledge of process safety fundamentals
· Exposure to refinery, petrochemical, or gas processing facilities`,
    `This course is suitable for:
· Process Engineers
· Mechanical Engineers
· Piping Engineers
· Safety and Loss Prevention Engineers
· Project and EPC Engineers
· Operations and Commissioning Personnel.`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role and importance of flare systems in petroleum and gas facilities.",
    "Define the scope and boundaries of flare system engineering.",
    "Interpret key terms, abbreviations, and reference standards used in flare design.",
    "Apply fundamental flare system design principles, including relief load handling and combustion performance.",
    "Understand flare radiation, dispersion, and environmental considerations.",
    "Differentiate between elevated flares and enclosed-flame flares and their applications.",
    "Identify and evaluate mechanical components of elevated flares, including stacks, flare tips, seals, pilots, and support structures.",
    "Understand the mechanical design considerations for enclosed-flame flare systems, including combustion chambers and air supply systems.",
    "Assess safety distances and layout considerations related to flare installations.",
    "Review flare system documentation for compliance with API, NFPA, and company specifications.",
    "Evaluate mechanical design challenges related to thermal loads, wind effects, and structural integrity.",
    "Apply best practices to ensure safe, efficient, and environmentally compliant flare operations."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Scope",
    "Module 3: Defined Terms / Abbreviations / References",
    "Module 4: Design",
    "Module 5: Mechanical Details-Elevated Flares",
    "Module 6: Mechanical Details-Enclosed-flame Flares"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 92,
  "title": "Guidelines for Vapor Cloud Explosion, Pressure Vessel Burst, Bleve, and Flash Fire Hazards",
  "date": "Present",
  "description": [
    "The Guidelines for Vapor Cloud Explosion (VCE), Pressure Vessel Burst, BLEVE, and Flash Fire Hazards course provides a comprehensive understanding of major accident hazards associated with hydrocarbon processing, storage, and transportation facilities.",
    "The course focuses on hazard mechanisms, consequence analysis, case histories, prevention strategies, and mitigation measures for high-impact events such as vapor cloud explosions, boiling liquid expanding vapor explosions (BLEVEs), pressure vessel ruptures, and flash fires. It integrates engineering principles with safety management practices to enhance risk awareness and improve facility design and operational safety.",
    "This course is suitable for process engineers, HSE professionals, operations supervisors, project engineers, risk analysts, and plant management personnel working in refineries, LNG plants, petrochemical facilities, storage terminals, and gas processing plants."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Guidelines%20for%20Vapor%20Cloud%20Explosion,%20Pressure%20Vessel%20Burst,%20Bleve,%20and%20Flash%20Fire%20Hazards.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    "Basic knowledge of process plant operations",
    "Understanding of hydrocarbons and flammable materials",
    "Familiarity with pressure vessels and storage systems",
    "Basic understanding of industrial safety principles"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the fundamental mechanisms of flash fires, vapor cloud explosions (VCE), pressure vessel bursts, and BLEVEs.",
    "Identify conditions that lead to major accident hazards, including loss of containment, ignition sources, and confinement effects.",
    "Understand management responsibilities in preventing catastrophic events through safety leadership and process safety systems.",
    "Analyze real industry case histories to identify root causes and lessons learned.",
    "Differentiate between flash fire and explosion phenomena, including overpressure and thermal radiation effects.",
    "Explain vapor cloud formation, dispersion, and explosion behavior in congested or confined areas.",
    "Understand the causes and consequences of pressure vessel rupture, including overpressure and material failure mechanisms.",
    "Describe the basic principles of BLEVEs, including rapid phase change, vessel failure, and fireball formation.",
    "Identify engineering and administrative controls for prevention and mitigation, such as relief systems, spacing, blast walls, and emergency response planning.",
    "Apply hazard awareness principles during design review, operations, and shutdown activities to reduce risk exposure."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Management Overview",
    "Module 3: Case Histories",
    "Module 4: Basic Concepts",
    "Module 5: Flash Fires",
    "Module 6: Vapor Cloud Explosions",
    "Module 7: Pressure Vessel Bursts",
    "Module 8: Basic Principles Of Bleves"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 93,
  "title": "Petroleum, Petrochemical and Natural Gas Industries — Flare Details for General Refinery and Petrochemical services",
  "date": "Present",
  "description": [
    "Flare systems are essential safety and environmental control systems used in petroleum refineries, petrochemical plants, and natural gas processing facilities. They are designed to safely dispose of excess hydrocarbons and other combustible gases during normal operations, start-ups, shutdowns, and emergency situations, preventing the release of hazardous gases into the atmosphere.",
    "The Flare Details for General Refinery and Petrochemical Services Course provides a comprehensive understanding of flare system design principles, operational requirements, and mechanical configurations used in industrial facilities. The course covers the engineering fundamentals of flare systems, including system design considerations, equipment components, combustion principles, and structural/mechanical details.",
    "Participants will learn how flare systems are designed to handle various operating conditions, ensure safe combustion, minimize environmental impact, and comply with international standards such as API Standard 537, which provides guidelines for flare system design, construction, operation, and maintenance.",
    "The course focuses on two common flare configurations used in the industry: elevated flares, which disperse combustion products at high elevation for safety and environmental protection, and enclosed-flame flares, which provide controlled combustion with reduced noise, radiation, and visible flame.",
    "Through technical explanations and engineering examples, participants will develop the knowledge required to understand flare system components, design considerations, and mechanical configurations used in refinery and petrochemical facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Petroleum,%20Petrochemical%20and%20Natural%20Gas%20Industries.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of chemical engineering, mechanical engineering, or process engineering
· Understanding of: Oil and gas processing operations, Pressure relief systems, Fluid flow fundamentals, Process safety systems`,
    `This course is particularly beneficial for professionals working in:
· Process engineering
· Mechanical engineering
· Piping engineering
· Plant design and layout
· Process safety engineering
· Refinery and petrochemical plant operations`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and importance of flare systems in oil and gas facilities",
    "Explain the role of flare systems in overpressure protection and safe hydrocarbon disposal",
    "Identify the key design considerations for flare systems",
    "Understand flare load calculations and system capacity requirements",
    "Evaluate operational factors such as radiation limits, smoke suppression, and noise control",
    "Understand the mechanical design features of elevated flare systems",
    "Identify components such as flare stacks, flare tips, pilots, ignition systems, and knockout drums",
    "Understand the design and mechanical details of enclosed-flame flare systems",
    "Compare enclosed flares with elevated flares in terms of safety, environmental impact, and operational flexibility",
    "Apply flare design concepts to refinery, petrochemical, and natural gas facilities",
    "Understand best practices for flare system reliability and safe operation"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Design",
    "Module 3: Mechanical Details –Elevated Flares",
    "Module 4: Mechanical Details –Enclosed-Flame Flares"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 94,
  "title": "Introduction to Oil and Gas Utilities",
  "date": "Present",
  "description": [
    "Utilities are the backbone of oil and gas facilities. While process units generate revenue, utility systems ensure safe, reliable, and continuous operation. Failures in utilities such as steam, cooling water, fuel gas, or firewater systems can result in complete plant shutdown, safety incidents, or equipment damage.",
    "This course provides a comprehensive introduction to essential utility systems used in refineries, gas processing plants, petrochemical facilities, LNG plants, and terminals. It explains the design principles, operating philosophy, equipment configuration, and safety considerations of major utility systems.",
    "The course integrates practical industry practices aligned with recognized standards such as American Petroleum Institute, National Fire Protection Association, and American Society of Mechanical Engineers.",
    "Participants will gain a holistic understanding of how utility systems interact with process units and how to maintain their reliability and performance.",
    "This course is ideal for graduate engineers, operations personnel, maintenance staff, and non-process engineers transitioning into oil & gas facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/OIL%20AND%20GAS%20UTILITIES.png",
  "tags": [],
  "category": "process",
  "duration": "1 Day",
  "prerequisite": [
    `· Basic engineering knowledge (mechanical, chemical, or electrical preferred)
· Fundamental understanding of industrial processes
· Familiarity with PFDs and P&IDs (beneficial but not mandatory)`,
    `This course is suitable for:
· Graduate Engineers / Trainees
· Process Engineers
· Mechanical Engineers
· Utility Engineers
· Operations & Maintenance Personnel
· Project Engineers
· HSE Personnel`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of utility systems in oil and gas facilities.",
    "Identify interdependencies between process units and utilities.",
    "Understand redundancy, reliability, and backup philosophy.",
    "Describe fuel gas systems and liquid fuel systems.",
    "Understand fuel conditioning and distribution.",
    "Explain steam generation principles and boiler operation.",
    "Identify different steam pressure levels and applications.",
    "Understand condensate recovery systems.",
    "Differentiate between instrument air and plant air.",
    "Explain air compression, drying, and distribution systems.",
    "Identify failure risks in compressed air systems.",
    "Explain cooling tower operation and cooling water circuits.",
    "Identify open vs closed cooling water systems.",
    "Understand hot oil systems and tempered water circuits.",
    "Apply heat tracing and winterization principles.",
    "Describe raw water intake and treatment systems.",
    "Understand potable water and service water distribution.",
    "Explain water storage and pumping systems.",
    "Understand fresh water and caustic systems.",
    "Identify common chemical injection systems and dosing philosophy.",
    "Recognize corrosion and scaling control methods.",
    "Understand firewater storage and distribution systems.",
    "Explain fire pump types (electric, diesel, jockey pumps).",
    "Describe deluge, hydrant, and sprinkler systems.",
    "Understand firewater reliability philosophy and testing requirements.",
    "Identify solids handling equipment used in plants.",
    "Understand industrial dryer fundamentals.",
    "Explain truck, rail, and marine loading systems.",
    "Identify vapor recovery and safety systems.",
    "Understand grounding, bonding, and emergency shutdown systems."
  ],
  "outline": [
    "Module 1: Fuel System",
    "Module 2: Compressed Air System",
    "Module 3: Fresh and Caustic Units & Chemical Injection Systems",
    "Module 4: Steam Boilers",
    "Module 5: Cooling Tower and Cooling Water Circuits",
    "Module 6: Hot oil and Tempered Water Circuits",
    "Module 7: Heat Tracing and Winterizing",
    "Module 8: Water Supply and Distribution System",
    "Module 9: Fire-Fighting Pump and Water System",
    "Module 10: Solids Handling Systems and Dryers",
    "Module 11: Loading and Unloading Facilities"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦50,000 / $50",
  "certification": "Certificate of Completion"
},

{
  "id": 95,
  "title": "Oil and Gas Utilities - Compressed Air System",
  "date": "Present",
  "description": [
    "Compressed air is one of the most critical utility systems in oil and gas facilities. It supports plant instrumentation, control valves, pneumatic tools, maintenance activities, safety systems, and process operations. Failure or contamination of compressed air systems can lead to plant trips, instrumentation malfunction, production losses, and serious safety incidents.",
    "The Oil and Gas Utilities – Compressed Air System Course provides a comprehensive understanding of compressed air generation, treatment, storage, distribution, and application within refinery and gas processing environments. The course integrates engineering design principles, operational best practices, and air quality control requirements, with emphasis on instrument air reliability and dew point management."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Compressed%20Air%20System.png?updatedAt=1774959410556",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of oil & gas process operations
· Fundamental knowledge of:
· Fluid flow and thermodynamics basics
· Pressure and temperature relationships
· Piping systems and valves
· Basic instrumentation and control systems`,
    `Suitable for:
· Process Engineers
· Utility Engineers
· Mechanical Engineers
· Instrumentation & Control Engineers
· Operations Engineers & Technicians
· Commissioning & Maintenance Personnel
· Graduate Engineers entering refinery or gas plant environments`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of compressed air systems in oil and gas facilities.",
    "Select appropriate compressor size, type, and number based on plant demand and redundancy requirements.",
    "Understand compressor location considerations and layout philosophy.",
    "Describe automatic warning, protection, and shutdown systems.",
    "Differentiate between lubricated and non-lubricated air compressors.",
    "Design and evaluate compressed air distribution networks.",
    "Size and select air receivers (buffer vessels).",
    "Understand moisture behavior, dew point concepts, and drying methods.",
    "Evaluate instrument air quality and quantity requirements.",
    "Apply segregation philosophy between plant air and instrument air.",
    "Identify piping components and nominal pipe sizing concepts.",
    "Understand air supply requirements for plant-mounted instruments and control centers.",
    "Recognize the impact of moisture and temperature on compressor performance.",
    "Troubleshoot common compressed air system issues in refinery environments."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Selecting The Size And Number Of Compressors",
    "Module 3: Locating The Compressors",
    "Module 4: Automatic Warning And Shutdown Systems",
    "Module 5: Non-lubricated Air Compressors",
    "Module 6: Compressed Air Distribution System",
    "Module 7: Air Storage (Air Receiver)",
    "Module 8: Inlet And Discharge Piping",
    "Module 9: Refinery Air System",
    "Module 10: Air Dryers",
    "Module 11: Moisture Content Of The Air",
    "Module 12: Effect Of Temperature And Pressure On Dew Point",
    "Module 13: Pressure Dew Point",
    "Module 14: Effect Of Moisture On Air Compressor Intake Capacity",
    "Module 15: Pipe Components Definition Of Nominal Size",
    "Module 16: Instrument Air Quality And Quantity",
    "Module 17: Segregation",
    "Module 18: Tool Air Supply",
    "Module 19: Air Supply Plant",
    "Module 20: Air Compressors",
    "Module 21: Air Drier",
    "Module 22: Buffer Vessel (Air Receiver)",
    "Module 23: Air Supply Piping",
    "Module 24: Air Supply For Plant-Mounted Instruments",
    "Module 25: Air Supply In The Control Center"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 96,
  "title": "Oil and Gas Utilities - Cooling Tower and Cooling Water Circuits",
  "date": "Present",
  "description": [
    "Cooling towers and cooling water circuits are essential utility systems in oil and gas facilities. They remove excess heat from process equipment such as heat exchangers, compressors, condensers, pumps, and intercoolers, ensuring safe, stable, and efficient plant operation.",
    "Improper design, poor water quality control, or inadequate operation of cooling systems can result in fouling and scaling, corrosion and microbiological growth, reduced heat transfer efficiency, equipment overheating and unplanned shutdowns, and environmental compliance issues.",
    "The Oil and Gas Utilities – Cooling Tower and Cooling Water Circuits Course provides a comprehensive understanding of cooling tower types, process design principles, water chemistry control, environmental considerations, and performance guarantees.",
    "This course integrates process engineering fundamentals, mechanical design features, operational best practices, and environmental compliance requirements."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Cooling%20Tower%20and%20Cooling%20Water%20Circuits.png?updatedAt=1774959410984",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of oil & gas process operations
· Fundamental knowledge of:
· Heat transfer principles
· Fluid flow and pumping systems
· Heat exchangers
· Basic water chemistry concepts`,
    `Suitable for:
· Process Engineers
· Utilities Engineers
· Mechanical Engineers
· Water Treatment Engineers
· Operations & Maintenance Personnel
· Commissioning Engineers
· Environmental & HSE Professionals
· Graduate Engineers entering plant utilities`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of cooling towers and cooling water systems in oil and gas facilities.",
    "Differentiate between various types of cooling towers and their applications.",
    "Develop key design inputs for cooling tower and cooling water circuit design.",
    "Understand the impact of water quality on system performance and equipment life.",
    "Identify scaling, corrosion, and biological fouling mechanisms.",
    "Apply cold climate design considerations to prevent freezing and operational failure.",
    "Evaluate siting, spacing, and environmental requirements for cooling towers.",
    "Interpret performance guarantees and acceptance testing requirements.",
    "Design and analyze cooling water circuits including pumps, headers, and heat exchangers.",
    "Understand the design requirements of intercooling and after-cooling systems.",
    "Troubleshoot common cooling system operational problems.",
    "Apply safe and environmentally compliant operating practices."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Types Of Cooling Towers",
    "Module 3: Design Considerations",
    "Module 4: Water Quality",
    "Module 5: Cold Climate Design Considerations",
    "Module 6: Siting, Spacing, And Environmental Considerations",
    "Module 7: Guarantees",
    "Module 8: Process Design Of Cooling Water Circuits",
    "Module 9: design requirements and features for intercooling And after-cooling facilities"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 97,
  "title": "Oil and Gas Utilities - Fire-Fighting Pump and Water System",
  "date": "Present",
  "description": [
    "The Fire-Fighting Pump and Water System course provides comprehensive technical knowledge on the design, selection, operation, and maintenance of firewater systems used in refineries, gas processing plants, LNG facilities, petrochemical complexes, and other high-risk oil and gas installations.",
    "The course covers firewater sources, pumping systems (centrifugal, vertical turbine, horizontal), prime movers (diesel/electric), control and power reliability, ring main distribution networks, storage tanks, foam systems, mobile firefighting equipment, and system performance criteria. It also addresses fire protection philosophies, hazard-based design approaches, and material procurement standards.",
    "International standards and recommended practices such as National Fire Protection Association (NFPA), American Petroleum Institute (API), and FM Global are referenced throughout the course to ensure compliance with globally accepted fire protection design principles.",
    "This course is ideal for engineers, project professionals, fire safety personnel, and operations staff involved in the design, specification, and operation of fire protection systems in hydrocarbon facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Fire-Fighting%20Pump%20and%20Water%20System.png?updatedAt=1774959410419",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· A basic understanding of fluid mechanics and pump fundamentals
· Knowledge of process plant utilities systems
· Familiarity with piping systems and instrumentation basics
· Basic understanding of refinery or oil & gas plant operations
· This course is particularly beneficial for professionals involved in FEED, EPC, commissioning, and plant operations within high-risk facilities.`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the basis for firewater system design in oil and gas facilities",
    "Identify fire risks in hydrocarbon processing plants",
    "Define design scenarios and worst-case fire demand",
    "Differentiate between horizontal and vertical shaft turbine pumps",
    "Understand centrifugal fire pump characteristics",
    "Determine pump capacity, head, and submergence requirements",
    "Evaluate jockey pump and pressure maintenance systems",
    "Select appropriate prime movers (diesel vs electric)",
    "Ensure power supply dependability and redundancy",
    "Design firewater ring main and network systems",
    "Perform hydraulic calculations for ring mains",
    "Size firewater piping and determine pressure losses",
    "Develop firewater pumping facility layouts",
    "Design firewater storage and suction arrangements",
    "Understand steel gravity and suction tank requirements",
    "Design water tanks for fire protection applications",
    "Evaluate water supply reliability and redundancy",
    "Define method of taking water (sea, river, tank, underground storage)",
    "Design water spray systems for fire exposure protection",
    "Understand fire hose reel systems",
    "Determine application density and coverage",
    "Specify valves for firewater service",
    "Design systems for fixed roof tanks containing high-flash liquids",
    "Explain foam system fundamentals",
    "Understand foam trailer units and foam/water monitor systems",
    "Specify premix and dry chemical trailer systems",
    "Evaluate extinguishing dry powder systems",
    "Identify types of fire-fighting trucks and pumps",
    "Understand major foam tender specifications",
    "Evaluate emergency service vehicles and auxiliary units",
    "Understand trailers carrying extinguishing agents",
    "Prepare material procurement specifications",
    "Develop standard specifications for fire-fighting equipment",
    "Define performance guarantees and testing requirements",
    "Prepare fire protection plans and layout drawings",
    "Develop firewater pumping facility arrangements",
    "Integrate firewater systems into overall plant utility infrastructure",
    "Evaluate fire and explosion prevention strategies",
    "Inspect firewater systems for compliance",
    "Identify common operational failures",
    "Define maintenance and testing strategies"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Method Of Taking Water",
    "Module 3: Control System",
    "Module 4: Electrical System",
    "Module 5: Centrifugal Fire Pumps",
    "Module 6: Outdoor Installation",
    "Module 7: Prime Movers",
    "Module 8: Pressure Maintenance (Jockey Or Make-Up) Pumps",
    "Module 9: Horizontal Pumps",
    "Module 10: Vertical Shaft Turbine-Type Pumps",
    "Module 11: Pumps Submergence",
    "Module 12: Pump",
    "Module 13: Power Supply Dependability",
    "Module 14: Electrical Drive For Pumps",
    "Module 15: Trailers Carrying Fire Extinguishing Agents",
    "Module 16: Foam Equipment Mounted On Trailer Unit",
    "Module 17: Premix FLC And Dry Chemical Trailer Unit",
    "Module 18: Foam/Water Monitor Trailer Unit",
    "Module 19: Fire-Fighting Trucks And Pumps",
    "Module 20: Fire-Fighting Systems For Installation On The Fire-Fighting Vehicle",
    "Module 21: Extinguishing Dry Powder Systems",
    "Module 22: Compartment For Miscellaneous Equipment",
    "Module 23: Proposed Standard Specification Of Major Foam Tender And General Purpose Fire Fighting Trucks For Refineries And Other High Risk Areas",
    "Module 24: Specification For Auxiliary Fire-Fighting And Emergency Vehicles",
    "Module 25: Water Tender",
    "Module 26: Emergency Service Vehicles",
    "Module 27: Brief Description And List Of Proposed Types Of Fire-Fighting Trucks",
    "Module 28: Fire Fighting Portable, Trailer, Skid, And Fixed Mounted Pumps",
    "Module 29: Material Procurement Standard",
    "Module 30: Firewater Distribution And Storage Facilities",
    "Module 31: Bases For A Fire-Fighting Water System",
    "Module 32: Firewater Ring Main System",
    "Module 33: Firewater Ring Main/Network Design",
    "Module 34: Firewater Pumping Facilities",
    "Module 35: Plans",
    "Module 36: Water Tanks For Fire Protection",
    "Module 37: Steel Gravity And Suction Tanks",
    "Module 38: Fire Hose Reels (Water) For Fixed Installations",
    "Module 39: Water Spray Fixed Systems For Fire Protection",
    "Module 40: Density And Application",
    "Module 41: Fire And Explosion Prevention",
    "Module 42: Valves",
    "Module 43: Fixed Roof Tanks Containing High-Flash Liquids"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 98,
  "title": "Oil and Gas Utilities - Fresh and Caustic Units & Chemical Injection System",
  "date": "Present",
  "description": [
    "Fresh caustic systems, spent caustic treatment units, and chemical injection systems are essential utility operations in oil and gas facilities. They support hydrocarbon sweetening, contaminant removal, corrosion prevention, scale inhibition, sludge conditioning, and environmental compliance.",
    "Improper design, poor material selection, inaccurate dosing, or inadequate control of these systems can lead to corrosion, fouling, environmental violations, product contamination, and major operational disruptions.",
    "The course integrates process engineering fundamentals, mechanical design considerations, instrumentation requirements, and operational best practices, making it suitable for both engineering and plant personnel."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Fresh%20and%20Caustic%20Units%20&%20Chemical%20Injection%20System.png?updatedAt=1774959408434",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of oil & gas process operations
· Familiarity with:
· Fluid flow principles
· Pumps and piping systems
· P&IDs
· Basic water treatment concepts`,
    `Suitable for:
· Process Engineers
· Utilities Engineers
· Water Treatment Engineers
· Mechanical Engineers
· Instrumentation & Control Engineers
· Operations & Maintenance Personnel
· Commissioning Engineers
· Environmental & HSE Professionals`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of fresh and spent caustic systems in oil and gas processing.",
    "Identify process requirements for caustic storage, handling, and treatment.",
    "Develop basic design inputs for caustic and chemical injection systems.",
    "Describe the configuration and operation of spent caustic treatment units.",
    "Select appropriate equipment for chemical feed and dosing systems.",
    "Apply general design principles for metering pumps in chemical injection systems.",
    "Understand design and construction requirements of chemical dosing units in water treatment systems.",
    "Evaluate package-type chemical injection system design philosophy.",
    "Explain scale formation mechanisms and scale control strategies.",
    "Describe sludge conditioning principles and chemical treatment methods.",
    "Identify safety and environmental risks associated with caustic and chemical systems.",
    "Interpret P&IDs and troubleshoot common operational issues in dosing systems."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Process Requirements Of Fresh And Spent Caustic Units",
    "Module 3: Design Requirements",
    "Module 4: Spent Caustic Treating Unit",
    "Module 5: Chemical Injection Systems",
    "Module 6: Equipment Design And Selection",
    "Module 7: general requirements for design and construction Of chemical dosing units in a water treating system",
    "Module 8: General Design Requirements Of Chemical Feed Equipment",
    "Module 9: General Design Requirements Of Metering Pump In Chemical Injection Systems",
    "Module 10: general design requirements of package type Chemical injection systems",
    "Module 11: Scale Control",
    "Module 12: Sludge Conditioning"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 99,
  "title": "Oil and Gas Utilities - Fuel System",
  "date": "Present",
  "description": [
    "Fuel systems are among the most safety-critical utility systems in oil and gas facilities. They supply energy to fired heaters, boilers, incinerators, gas turbines, and other combustion equipment that sustain plant operations. Poor design, inadequate control, or improper operation of fuel systems can result in fire, explosion, production downtime, and severe asset damage.",
    "The Oil and Gas Utilities – Fuel System Course provides a comprehensive understanding of fuel gas and fuel oil systems used in refineries, petrochemical plants, LNG facilities, and gas processing plants. The course integrates engineering design principles, operational practices, safety systems, and shutdown philosophies.",
    "The program combines theory, real plant scenarios, P&ID interpretation, and safety case discussions, making it suitable for both engineering and operations personnel."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Fuel%20System.png?updatedAt=1774959410487",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of oil and gas process operations
· Fundamental knowledge of:
· Fluid flow and pressure concepts
· Process equipment (pumps, valves, heaters)
· Piping and Instrumentation Diagrams (P&IDs)
· Basic process control principles`,
    `Recommended for:
· Process Engineers
· Utilities Engineers
· Operations Engineers & Technicians
· Instrumentation & Control Engineers
· Commissioning Engineers
· HSE Professionals
· Graduate Engineers entering oil & gas facilities`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role and importance of fuel systems within oil and gas utility networks.",
    "Describe the configuration and components of fuel gas and fuel oil supply systems.",
    "Interpret fuel system P&IDs and identify key control and safety elements.",
    "Identify minimum data requirements for basic design and sizing of fuel systems.",
    "Understand fired heater fuel system arrangements and burner management concepts.",
    "Explain the function and design considerations of atomizing steam and steam tracing.",
    "Describe shut-off philosophies including double block and bleed systems and ESD valves.",
    "Evaluate fuel flexibility options for gas turbines and associated operational challenges.",
    "Explain the function and operation of heat-off and emergency shutdown switches.",
    "Apply safe operating principles to prevent combustion-related hazards."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Fuel Supplying System",
    "Module 3: Fire Heaters Fuel System",
    "Module 4: Minimum Data Required for Basic Design",
    "Module 5: Atomizing Steam and Tracing",
    "Module 6: Shut-off Systems",
    "Module 7: Gas Turbine Fuel Alternatives",
    "Module 8: Operation of Heat-Off and Emergency Shutdown Switches"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 100,
  "title": "Oil and Gas Utilities - Heat Tracing and Winterizing",
  "date": "Present",
  "description": [
    "Heat tracing and winterization are critical utility and asset protection systems in oil and gas facilities, particularly in cold climates and exposed installations. These systems ensure safe, reliable, and uninterrupted operation by preventing freezing, solidification, excessive viscosity, and temperature-related equipment damage.",
    "Failure to properly design or maintain heat tracing and winterization systems can result in frozen process lines and instrument impulse lines, equipment rupture and loss of containment, process shutdowns and production losses, instrument malfunction and false readings, and safety and environmental incidents.",
    "The Oil and Gas Utilities – Heat Tracing and Winterization Course provides a comprehensive understanding of tracing methods, winterization strategies, system design principles, inspection practices, and testing requirements.",
    "Participants will gain practical knowledge applicable to both design and field operations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Heat%20Tracing%20and%20Winterizing.png?updatedAt=1774959410973",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of oil & gas process operations
· Fundamental knowledge of:
· Heat transfer principles
· Fluid properties and phase behavior
· Piping systems`,
    `Suitable for:
· Process Engineers
· Utilities Engineers
· Mechanical Engineers
· Electrical Engineers
· Instrumentation Engineers
· Maintenance Personnel
· Construction & Commissioning Engineers
· Operations Staff working in cold climates`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the purpose and importance of heat tracing and winterization in oil and gas facilities.",
    "Identify different tracing methods and their applications.",
    "Determine conditions that require winterization protection.",
    "Develop design inputs for heat tracing systems.",
    "Select appropriate tracing methods (steam vs electrical) for specific services.",
    "Understand winterization requirements for instruments and equipment.",
    "Apply design standards and installation best practices.",
    "Conduct inspection and testing of heat tracing systems.",
    "Identify common failure modes and troubleshooting techniques.",
    "Evaluate safety considerations related to heat tracing and freeze protection.",
    "Understand the role of heat transfer cement in improving thermal performance.",
    "Integrate winterization requirements into overall plant design."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Application And Methods",
    "Module 3: Methods Of Winterization",
    "Module 4: Conditions Requiring Winterization",
    "Module 5: Requirements",
    "Module 6: Instruments",
    "Module 7: Equipment",
    "Module 8: Miscellaneous Items",
    "Module 9: Design",
    "Module 10: Inspection And Testing",
    "Module 11: Electrical Tracing",
    "Module 12: Use Of Heat Transfer Cement"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 101,
  "title": "Oil and Gas Utilities - Hot oil and Tempered Water Circuits",
  "date": "Present",
  "description": [
    "Hot oil and tempered water systems are specialized heat transfer utility systems used where steam is unsuitable or where precise temperature control is required. These systems are widely applied in crude units, lube oil plants, sulfur recovery units, polymer plants, storage tank heating, and process temperature control loops.",
    "Hot oil systems provide high-temperature heat transfer at relatively low pressure, while tempered water systems offer stable, uniform, and controlled heating or cooling within moderate temperature ranges.",
    "Improper design, fluid degradation, poor circulation, or inadequate control can result in thermal oil cracking and fouling, pump cavitation and circulation failure, fire hazards and leaks, temperature instability affecting product quality, and equipment overheating or underheating.",
    "The Oil and Gas Utilities – Hot Oil and Tempered Water Circuits Course provides a comprehensive understanding of system configuration, process design, operational philosophy, safety considerations, and performance optimization.",
    "The course integrates thermodynamics, heat transfer, mechanical design considerations, and operational best practices."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Hot%20oil%20and%20Tempered%20Water%20Circuits.png?updatedAt=1774959411157",
  "tags": [],
  "category": "process",
  "duration": "2 Days",
  "prerequisite": [
    `· Basic understanding of oil & gas process operations
· Fundamental knowledge of:
· Heat transfer principles
· Fluid flow and pump systems
· Piping systems
· Basic process control`,
    `Suitable for:
· Process Engineers
· Utilities Engineers
· Mechanical Engineers
· Operations Engineers
· Maintenance Engineers
· Commissioning Engineers
· Graduate Engineers entering plant utilities`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of hot oil and tempered water systems in oil and gas facilities.",
    "Identify applications where hot oil systems are preferred over steam systems.",
    "Describe the main components of a hot oil circulation system.",
    "Develop key process design inputs for hot oil systems (flowrate, temperature, heat duty).",
    "Understand thermal fluid selection criteria and degradation mechanisms.",
    "Evaluate advantages and limitations of hot oil systems.",
    "Design expansion, surge, and inerting systems for safe operation.",
    "Explain the process design and control philosophy of tempered water systems.",
    "Analyze heat balance and circulation requirements.",
    "Identify safety risks associated with high-temperature heat transfer fluids.",
    "Troubleshoot common operational problems in hot oil and tempered water circuits.",
    "Apply safe startup and shutdown practices."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Hot Oil Heater Application",
    "Module 3: Process Design Of Hot Oil System",
    "Module 4: Advantages And Disadvantages Of Hot Oils",
    "Module 5: Design",
    "Module 6: Process Design Of Tempered Water System"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 102,
  "title": "Oil and Gas Utilities - Loading and Unloading Facilities",
  "date": "Present",
  "description": [
    "The Loading and Unloading Facilities course provides practical and engineering-focused knowledge on the design, operation, control, and safety of truck loading and unloading systems used in refineries, depots, terminals, petrochemical plants, and bulk storage facilities.",
    "The course covers truck loading systems, unloading operations, process design parameters, control systems, equipment selection, custody transfer considerations, and product handling procedures. Emphasis is placed on operational safety, spill prevention, grounding and bonding, vapor recovery, overfill protection, and compliance with recognized industry standards such as American Petroleum Institute, National Fire Protection Association, and International Organization for Standardization.",
    "This course is ideal for process engineers, terminal engineers, operations supervisors, project engineers, and HSE personnel involved in hydrocarbon product handling and distribution."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Loading%20and%20Unloading%20Facilities.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic understanding of refinery or terminal operations",
    "Knowledge of pumps, piping systems, and storage tanks",
    "Familiarity with basic instrumentation and control concepts",
    "Understanding of industrial safety principles",
    "Ability to interpret PFDs and P&IDs"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the fundamentals of hydrocarbon loading and unloading operations in refineries and terminals.",
    "Describe truck loading system configurations, including bottom and top loading arrangements.",
    "Define key process design parameters such as flow rate, pressure, temperature, and product characteristics.",
    "Understand control and safety systems, including overfill protection, grounding, interlocks, and emergency shutdown systems.",
    "Select appropriate equipment such as pumps, loading arms, meters, hoses, and vapor recovery systems.",
    "Design and evaluate truck unloading systems, including pump-assisted and gravity discharge methods.",
    "Manage product discharge and transfer operations to storage tanks while preventing contamination and spills.",
    "Identify operational and safety risks associated with loading and unloading of flammable and hazardous products.",
    "Apply best practices for environmental protection, vapor control, and loss prevention.",
    "Troubleshoot common operational problems in loading and unloading facilities."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Truck Loading",
    "Module 3: Control System",
    "Module 4: Process Design Parameters",
    "Module 5: Equipment",
    "Module 6: Truck Unloading",
    "Module 7: Discharging Unloaded Products"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 103,
  "title": "Oil and Gas Utilities - Solids Handling Systems and Dryers",
  "date": "Present",
  "description": [
    "The Solids Handling Systems and Dryers course provides in-depth technical knowledge on the design, selection, operation, and troubleshooting of bulk solids handling, separation, and drying systems used in refineries, petrochemical plants, LNG facilities, fertilizer plants, and other industrial process environments.",
    "The course covers bulk material conveying, storage systems, packaging and container handling, solid–liquid separation equipment (centrifuges, hydrocyclones, and filters), industrial drying technologies, polymer dryers, compressed air dryers, and adsorption dryers. It emphasizes reliability, safety, dust control, explosion prevention, and integration with overall plant utility systems.",
    "Industry-referenced standards and good engineering practices from organizations such as American Petroleum Institute, American Society of Mechanical Engineers, and National Fire Protection Association are incorporated where applicable, particularly in dust handling, pressure equipment, and explosion prevention systems.",
    "This course is suitable for process engineers, mechanical engineers, utilities engineers, operations personnel, and project engineers involved in FEED, EPC, commissioning, and plant operations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Solids%20Handling%20Systems%20and%20Dryers.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    "Basic knowledge of fluid mechanics and heat transfer",
    "Understanding of process plant utilities systems",
    "Familiarity with pumps, piping, and basic process equipment",
    "Ability to interpret PFDs and P&IDs"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the fundamentals of bulk solids handling and key material properties affecting flow and processing.",
    "Identify and select appropriate conveying systems for bulk solids, including mechanical and pneumatic methods.",
    "Design basic bulk storage systems such as silos and hoppers while addressing common flow problems.",
    "Understand solid–liquid separation principles and the operation of centrifuges, hydrocyclones, and filtration systems.",
    "Specify suitable filter media based on process and operating conditions.",
    "Explain industrial drying principles and classify different types of dryers used in process plants.",
    "Select appropriate dryers for solids, polymers, and compressed air applications.",
    "Understand adsorption and compressed air drying systems and their integration into plant utilities.",
    "Recognize safety and operational challenges, including dust control, explosion risks, and moisture management.",
    "Troubleshoot common operational problems in solids handling and drying systems."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Most Salient Features",
    "Module 3: Conveying Of Bulk Solids",
    "Module 4: Handling Bulk Materials In Packages And Containers",
    "Module 5: Storage Of Solids In Bulk",
    "Module 6: Solid–Liquid Separators",
    "Module 7: Centrifuges",
    "Module 8: Hydrocyclones",
    "Module 9: Filter Media Specifications",
    "Module 10: Dryers",
    "Module 11: Classification Of Industrial Drying",
    "Module 12: Selection Of Dryer",
    "Module 13: Polymer Dryers",
    "Module 14: Compressed Air Dryer",
    "Module 15: Adsorption Dryers"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 104,
  "title": "Oil and Gas Utilities - Steam Boilers",
  "date": "Present",
  "description": [
    "Steam boilers are among the most critical utility systems in oil and gas facilities. They provide steam for process heating, stripping, tracing, power generation, and mechanical drives. Boiler reliability, efficiency, and safety directly impact plant uptime, energy cost, and operational integrity.",
    "Improper boiler operation or inadequate design can result in tube failure, explosion hazards, efficiency losses, and costly downtime.",
    "The Oil and Gas Utilities – Steam Boilers Course provides a comprehensive understanding of boiler design, operation, performance monitoring, and auxiliary systems. The course integrates thermodynamic fundamentals, mechanical design features, combustion systems, instrumentation, and steam distribution concepts, with emphasis on safe and efficient plant operation.",
    "The program combines engineering fundamentals with operational best practices and real plant scenarios."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Steam%20Boilers.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of oil & gas process operations
· Fundamental knowledge of:
· Heat transfer principles
· Basic thermodynamics
· Fluid flow concepts
· P&IDs and instrumentation basics`,
    `Recommended for:
· Process Engineers
· Utilities Engineers
· Mechanical Engineers
· Boiler Operators
· Instrumentation & Control Engineers
· Maintenance Engineers
· Commissioning Engineers
· Graduate Engineers entering plant utilities`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of steam boilers within oil and gas utility systems.",
    "Differentiate between fire-tube and water-tube boilers and their applications.",
    "Describe the function of major boiler components including furnace, economizer, superheater, and air heater.",
    "Understand special boiler design features that enhance safety and efficiency.",
    "Explain the purpose of insulation and boiler casing systems.",
    "Describe steam temperature control using superheaters and attemperators.",
    "Identify key boiler valves and accessories and explain their functions.",
    "Understand boiler instrumentation and performance monitoring parameters.",
    "Evaluate boiler performance under various operating conditions.",
    "Understand steam trap selection and condensate management principles.",
    "Recognize common boiler operational issues and preventive measures.",
    "Apply safe operating practices to prevent boiler-related hazards."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Special Design Features",
    "Module 3: Insulation And Casings",
    "Module 4: Air Heater",
    "Module 5: Furnace",
    "Module 6: Superheater/Attemperator",
    "Module 7: Valves And Accessories",
    "Module 8: Integral Pipework",
    "Module 9: Economizer",
    "Module 10: Instrumentation",
    "Module 11: Performance Conditions",
    "Module 12: Fire-Tube Packaged Boilers",
    "Module 13: Water-Tube Boilers",
    "Module 14: Process Design Of Steam Traps"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 105,
  "title": "Oil and Gas Utilities - Water Supply and Distribution System",
  "date": "Present",
  "description": [
    "Water supply and distribution systems are fundamental utility networks in oil and gas facilities. They support process operations, cooling systems, boiler feed preparation, potable water supply, firefighting systems, sanitation, and environmental compliance.",
    "Poorly designed or maintained water systems can result in inadequate supply to critical plant units, contamination and health risks, corrosion and scaling in process systems, sewer overflow and environmental violations, and structural damage due to leakage or poor installation.",
    "The Oil and Gas Utilities – Water Supply and Distribution System Course provides a comprehensive understanding of water resource selection, treatment, and storage, distribution, and sewerage systems within industrial facilities.",
    "Participants will gain both engineering design knowledge and practical installation insight, making this course suitable for both design and field personnel."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Utilities%20-%20Water%20Supply%20and%20Distribution%20System.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    `· Basic understanding of oil & gas process operations
· Fundamental knowledge of:
· Fluid mechanics
· Pumping systems
· Piping systems
· Basic water chemistry`,
    `Suitable for:
· Process Engineers
· Utilities Engineers
· Mechanical & Civil Engineers
· Water Treatment Engineers
· Construction Engineers
· Maintenance Personnel
· Environmental & HSE Professionals
· Graduate Engineers entering plant utilities`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of water supply and distribution systems in oil and gas facilities.",
    "Evaluate water quality requirements for various plant applications.",
    "Select appropriate water resources and protection strategies.",
    "Develop design inputs for waterworks and distribution systems.",
    "Design water distribution networks and determine pipe sizing.",
    "Apply standard specifications for potable and demineralized water systems.",
    "Understand cooling water distribution and return systems.",
    "Interpret water analysis reports and assess treatment needs.",
    "Describe sewerage system design and gravity sewer construction principles.",
    "Understand installation practices for water pipes in buildings and plants.",
    "Conduct inspection, testing, and disinfection of water and sewer systems.",
    "Identify ancillary equipment used in water and sewerage works.",
    "Apply best practices in pipeline construction, jointing, and trenchless methods.",
    "Ensure compliance with environmental and public health standards."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Quality Of Water",
    "Module 3: Water Resource Selection And Protection",
    "Module 4: Waterworks System",
    "Module 5: Methods Of Distribution: General",
    "Module 6: Preferred Pipe Distribution System",
    "Module 7: Design Of Waterworks Distribution System",
    "Module 8: Design Criteria",
    "Module 9: Design Procedure",
    "Module 10: Design Of Components",
    "Module 11: Process Design Of Water Systems",
    "Module 12: Raw Water And Plant Water Systems",
    "Module 13: Cooling Water Distribution And Return System",
    "Module 14: Water Analysis",
    "Module 15: Potable Water Standard Specification",
    "Module 16: Standard Specification Of Demineralizing Unit",
    "Module 17: Equipment Design",
    "Module 18: Disinfection",
    "Module 19: Water Supply And Sewerage Systems",
    "Module 20: Installation Of Water Pipes In Buildings",
    "Module 21: Jointing Pipes To Cisterns And Tanks",
    "Module 22: Pipework In Buildings",
    "Module 23: Disinfection Of An Installation",
    "Module 24: Identifying And Recording Piping Locations",
    "Module 25: Construction Of Gravity Sewers",
    "Module 26: Jointing Pipes",
    "Module 27: Ancillary Items",
    "Module 28: Trenchless Construction",
    "Module 29: Testing Of Sewers",
    "Module 30: Inspection Of Pipelines, Services, And Installations",
    "Module 31: Water Distribution Mains",
    "Module 32: Inspection Of Sewerage Works",
    "Module 33: Water Supply And Sewerage Equipment"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 106,
  "title": "Pressure Relief, Emergency Depressuring, Flare And Vent Systems",
  "date": "Present",
  "description": [
    "Pressure relief, emergency Depressuring, flare, and vent systems are critical safety systems in oil & gas, petrochemical, and chemical processing facilities. These systems protect process equipment, pipelines, and storage tanks from excessive pressure that may result from process upsets, equipment failure, fire exposure, blocked outlets, or thermal expansion.",
    "This course provides a comprehensive understanding of the design philosophy, operation, and integration of pressure relief and flare systems used to safely release and dispose of excess hydrocarbons or process gases. Participants will learn how relief valves, Depressuring systems, flare networks, vent systems, and associated equipment such as knock-out drums and flare stacks operate together to ensure plant safety and environmental compliance.",
    "Participants will develop a clear understanding of how emergency Depressuring systems function during critical scenarios and how flare and vent systems safely dispose of relieved gases.",
    "The course also covers essential equipment such as knock-out drums, flare tips, purge systems, pilots, ignition systems, and venting systems for storage tanks, providing a holistic view of plant overpressure protection systems."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Pressure%20Relief,%20Emergency%20Depressuring,%20Flare%20And%20Vent%20Systems.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "prerequisite": [
    `· Basic understanding of process engineering principles
· Familiarity with pressure, temperature, and flow systems
· Basic knowledge of process equipment such as vessels, pipelines, and storage tanks
· Ability to interpret Process Flow Diagrams (PFDs) and Piping and Instrumentation Diagrams (P&IDs) is recommended`,
    `The course is suitable for:
· Process Engineers
· Safety Engineers
· Instrumentation and Control Engineers
· Mechanical Engineers
· Operations Engineers
· Plant Operators and Technicians
· Design and Project Engineers`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the complete architecture of pressure relief and flare systems",
    "Identify and interpret flare systems in PFDs and P&IDs",
    "Support design and safety reviews of overpressure protection systems",
    "Participate in HAZOP, flare load analysis, and relief system studies",
    "Ensure plant operations comply with industry safety standards and environmental requirements",
    "Participants will also gain practical insight into real-world relief and flare system operation, enabling them to contribute effectively to safe plant design and operation in oil, gas, and petrochemical facilities."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Pressure Relief",
    "Module 3: Emergency Depressuring Systems",
    "Module 4: Flare And Vent Systems",
    "Module 5: Knock-Out Drums, Water Seal Vessels And Liquid Disposal Facilities",
    "Module 6: Structures For Flare And Vent Stacks And Liquid Burners",
    "Module 7: Flare And Vent Tips",
    "Module 8: Flare And Vent Purging",
    "Module 9: Vent Snuffing",
    "Module 10: Flare Pilots And Ignition",
    "Module 11: Venting Atmospheric And Low Pressure Storage Tanks"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 107,
  "title": "Bypassing Critical Protections Standard",
  "date": "Present",
  "description": [
    "Critical protection systems are essential safeguards used in industrial facilities to prevent accidents, protect personnel, and ensure the safe operation of equipment and processes. These protections include safety instrumented systems, alarms, interlocks, pressure relief systems, fire and gas detection systems, and other engineered safeguards designed to prevent hazardous events.",
    "In certain operational or maintenance situations, it may become necessary to temporarily bypass or disable these protections. However, bypassing safety-critical systems introduces significant operational and safety risks if not properly managed.",
    "The Bypassing Critical Protections Standard Course provides participants with a comprehensive understanding of the procedures, responsibilities, and control measures required when bypassing critical protection systems in industrial facilities. The course focuses on ensuring that bypass activities are conducted safely, documented properly, and approved according to established operational standards and management of change procedures.",
    "Participants will learn the requirements for safe bypassing practices, the roles and responsibilities of personnel involved, proper documentation procedures, and the importance of maintaining operational integrity during temporary protection bypasses.",
    "The course emphasizes best practices aligned with process safety management principles and internationally recognized safety frameworks such as IEC 61511 and OSHA Process Safety Management Standard."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Bypassing%20Critical%20Protections%20Standard.png",
  "tags": [],
  "category": "PAI",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of process engineering, instrumentation, or industrial operations
· Understanding of: Process plant operations, Instrumentation and control systems, Safety systems and alarms, Basic process safety principles`,
    `This course is particularly beneficial for professionals working in:
· Process operations
· Process safety engineering
· Instrumentation and control engineering
· Maintenance and reliability engineering
· Plant supervision and shift leadership
· Health, safety, and environment (HSE) roles`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the importance of critical protection systems in industrial facilities",
    "Recognize the risks associated with bypassing safety systems",
    "Understand the purpose, scope, and requirements of bypassing critical protection standards",
    "Identify the conditions under which protections may be bypassed",
    "Evaluate risks associated with bypassing safety protections",
    "Apply appropriate risk mitigation measures during bypass operations",
    "Identify the roles and responsibilities of personnel involved in bypass activities",
    "Understand approval and authorization processes",
    "Apply standard instructions and procedures for bypassing protections",
    "Ensure safe operation during temporary bypass conditions",
    "Maintain accurate records of bypass activities",
    "Ensure compliance with internal standards and regulatory requirements"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Purpose, Objectives and Scope",
    "Module 3: Requirements",
    "Module 4: Terms and Definitions",
    "Module 5: Roles, Responsibilities and Training Requirements",
    "Module 6: Standard Instructions",
    "Module 7: Records"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 108,
  "title": "Instrumentation Of Depressuring Systems",
  "date": "Present",
  "description": [
    "Depressuring systems are critical safety features in oil, gas, and petrochemical facilities. They are designed to rapidly reduce pressure in process equipment during emergency situations such as fire exposure, runaway reactions, or major process upsets. Proper instrumentation and control of Depressuring systems are essential to ensure safe plant operation, prevent catastrophic equipment failure, and protect personnel and assets.",
    "This course provides a comprehensive understanding of the instrumentation, control strategies, and design principles used in Depressuring systems. Participants will learn how emergency Depressuring systems operate, how Depressuring valves are sized and controlled, and how instrumentation interfaces with safety systems such as Emergency Shutdown Systems (ESD) and Safety Instrumented Systems (SIS).",
    "Participants will gain practical knowledge of Depressuring instrumentation, including pressure transmitters, control logic, blowdown valves (BDVs), actuators, and system integration with flare systems.",
    "This course is particularly valuable for engineers and operators involved in process safety, plant design, instrumentation, and operations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Instrumentation%20Of%20Depressuring%20Systems.png",
  "tags": [],
  "category": "PAI",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic understanding of process engineering principles
· Familiarity with pressure, temperature, and flow instrumentation
· Basic knowledge of process control systems
· Understanding of Piping and Instrumentation Diagrams (P&IDs) is recommended`,
    `The course is suitable for:
· Instrumentation Engineers
· Process Engineers
· Control System Engineers
· Safety Engineers
· Operations Engineers and Technicians
· Project and Design Engineers`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "After completing this course, participants will be able to:",
    "Understand the instrumentation architecture of Depressuring systems",
    "Interpret Depressuring systems in engineering drawings and control diagrams",
    "Participate in design, commissioning, and troubleshooting of blowdown systems",
    "Support safety studies such as HAZOP, SIL, and Depressuring analysis",
    "Ensure compliance with industry standards and best practices",
    "Participants will also gain practical insights into how instrumentation supports safe depressurization during both emergency conditions and routine operations in oil and gas facilities."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: High-Rate Emergency Depressuring",
    "Module 3: Low-Rate Operational Depressuring",
    "Module 4: Depressuring Valve Calculations",
    "Module 5: Specific Design Requirements"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 109,
  "title": "Override Bypass Control",
  "date": "Present",
  "description": [
    "Override and bypass controls are operational practices used in industrial facilities to temporarily disable or modify safety or control system functions during specific activities such as maintenance, plant start-up, testing, or troubleshooting. While these actions may sometimes be necessary, improper use of overrides or bypasses can significantly increase the risk of accidents, equipment damage, or process upsets.",
    "The Override Bypass Control Course provides a comprehensive understanding of the principles, procedures, and safety requirements associated with managing overrides and bypasses in process control and safety systems. The course focuses on ensuring that such actions are conducted under strict authorization, risk assessment, and monitoring procedures to maintain plant safety and operational integrity.",
    "Participants will learn how override and bypass controls interact with process safety systems, alarms, interlocks, and shutdown systems. The course also introduces systematic approaches for evaluating risks, approving override requests, and ensuring that temporary overrides are properly documented, monitored, and removed when no longer required.",
    "The course aligns with internationally recognized safety frameworks such as IEC 61511 and process safety management practices under OSHA Process Safety Management Standard.",
    "Through practical examples and operational case studies, participants will gain the knowledge required to safely manage override and bypass activities within industrial facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Override%20Bypass%20Control.png",
  "tags": [],
  "category": "PAI",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of engineering, industrial operations, or process control systems
· Understanding of: Process plant operations, Control systems and instrumentation, Safety systems such as alarms and interlocks, Basic process safety principles`,
    `This course is beneficial for professionals working in:
· Process operations
· Instrumentation and control engineering
· Process safety engineering
· Maintenance and reliability engineering
· Plant supervision and operations management
· Health, Safety and Environment (HSE) roles`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and implications of overrides and bypasses in industrial control systems",
    "Identify different types of control overrides and safety bypasses",
    "Recognize the risks associated with disabling safety protections",
    "Conduct safety override risk assessments",
    "Determine when overrides or bypasses are eligible and justified",
    "Apply proper authorization and control procedures",
    "Implement safe procedures for start-up overrides",
    "Manage overrides for isolated or non-operational plant systems",
    "Monitor override conditions to ensure plant safety",
    "Maintain proper documentation and ensure timely removal of overrides"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Basic principles",
    "Module 3: Eligibility for overrides/bypasses",
    "Module 4: Safety Override Risk Assessment",
    "Module 5: Control of overrides/bypasses",
    "Module 6: Start-up overrides",
    "Module 7: Overrides on isolated non-operational plant"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 110,
  "title": "Construction Cost Management",
  "date": "Present",
  "description": [
    "Construction projects involve significant financial investment, complex stakeholder coordination, and strict time constraints. Effective construction cost management is essential to ensure that projects are delivered within budget while maintaining quality, safety, and performance requirements.",
    "The Construction Cost Management Course provides a comprehensive understanding of the principles, tools, and techniques used to plan, estimate, control, and manage construction costs throughout the project lifecycle. The course explores cost management from the early concept stage through procurement, contract administration, project execution, and final completion.",
    "Participants will gain practical insights into cost estimation, tendering processes, contractor selection, value management, risk management, contract administration, and change management. The course also examines internationally recognized contract frameworks such as FIDIC Contracts and NEC Engineering and Construction Contract, which are widely used in global infrastructure and construction projects.",
    "Through real-world examples and case studies—including the delivery of Heathrow Terminal 5—participants will develop the knowledge required to effectively manage construction costs and minimize financial risks in complex projects.",
    "This course is designed to equip professionals with the skills required to control project costs, manage contractual obligations, and optimize financial performance across the entire construction lifecycle."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Construction%20Cost%20Management.png",
  "tags": [],
  "category": "project management",
  "duration": "7 Days",
  "prerequisite": [
    `· Basic knowledge of construction management, engineering, architecture, or project management
· Familiarity with: Construction project lifecycle, Basic project planning and scheduling, Budgeting and financial management concepts`,
    `This course is suitable for professionals working in:
· Construction engineering
· Project management
· Quantity surveying
· Cost engineering
· Contract administration
· Procurement and project controls
· Infrastructure and industrial project development`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles of construction cost management",
    "Develop cost plans and budgets for construction projects",
    "Monitor project costs and control financial performance",
    "Evaluate and select consultants and contractors",
    "Understand contractor estimating and tendering processes",
    "Assess contractor bids and cost proposals",
    "Apply value management techniques to optimize project costs",
    "Identify, analyze, and manage construction project risks",
    "Understand the concept of whole-life costing",
    "Understand the structure and application of international construction contracts",
    "Manage payment systems, cost reporting, and financial documentation",
    "Evaluate contract variations, claims, and change orders",
    "Implement contractor cost control systems",
    "Monitor project performance and manage financial deviations",
    "Apply cost control strategies during project execution",
    "Understand different organizational methods in construction project delivery",
    "Evaluate Public Finance Initiative (PFI) project cost management",
    "Learn from real-world case studies such as Heathrow Terminal 5"
  ],
  "outline": [
    "Module 1: Introduction and overview",
    "Module 2: Reports and recommendations",
    "Module 3: Selecting the consultants and contractors",
    "Module 4: Pre-contract cost management",
    "Module 5: Cost management on PFI projects",
    "Module 6: Contractor’s estimating and tendering",
    "Module 7: Value management",
    "Module 8: Risk management (RM)",
    "Module 9: Whole-life costing",
    "Module 10: Organizational methods (part A)",
    "Module 11: Organizational methods (part B)",
    "Module 12: Payment systems and contract administration",
    "Module 13: Contractors’ cost-control and monitoring procedures",
    "Module 14: Change management – valuing variations",
    "Module 15: Claims management",
    "Module 16: The NEC Engineering and Construction Contract",
    "Module 17: FIDIC standard forms of international construction contract",
    "Module 18: Heathrow Terminal 5"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦400,000 / $350",
  "certification": "Certificate of Completion"
},

{
  "id": 111,
  "title": "Design and manufacture of tanks for the storage of liquids",
  "date": "Present",
  "description": [
    "Site-built welded steel storage tanks are widely used in refineries, petrochemical plants, tank farms, terminals, and production facilities for storing crude oil, refined products, chemicals, and other liquids at ambient or elevated temperatures. The safe design and construction of these tanks are governed by internationally recognized standards such as American Petroleum Institute (API)—particularly API 650—and European Committee for Standardization (EN standards, e.g., EN 14015).",
    "This course provides a comprehensive technical understanding of the design, material selection, fabrication, erection, welding, inspection, and documentation requirements for above-ground welded steel storage tanks. Participants will gain insight into structural integrity, load considerations, roof configurations, welding qualification, quality control, and compliance requirements.",
    "The course bridges engineering design principles with field construction practices, enabling participants to confidently review, specify, construct, or audit atmospheric storage tank projects."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Design%20and%20manufacture%20of%20tanks%20for%20the%20storage%20of%20liquids.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    `· Basic knowledge of mechanical or structural engineering principles
· Familiarity with materials of construction and corrosion concepts
· Understanding of welding fundamentals`,
    `This course is suitable for:
· Mechanical and Tank Design Engineers
· QA/QC and Welding Engineers
· Inspection Engineers
· EPC Project Engineers
· Construction and Erection Supervisors
· Asset Integrity Professionals`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and application of specifications governing welded above-ground storage tanks.",
    "Identify and document required design information and project data.",
    "Interpret and apply general technical requirements in tank specifications.",
    "Select appropriate materials for shells, bottoms, roofs, and structural components.",
    "Evaluate and apply design loads, including hydrostatic, wind, seismic, thermal, and external loads.",
    "Understand structural design principles for tank bottoms, including annular plates and settlement considerations.",
    "Perform and review shell design calculations, including thickness determination and stability checks.",
    "Differentiate between fixed roof and floating roof designs, and understand their applications.",
    "Specify and assess tank mountings, nozzles, manways, and appurtenances.",
    "Apply requirements for thermal insulation systems.",
    "Understand procedures for shop fabrication of tank components.",
    "Evaluate site erection practices and dimensional tolerances.",
    "Review and approve welding procedures (WPS), procedure qualification records (PQR), and welder qualifications.",
    "Understand welding execution requirements and quality control measures.",
    "Apply testing and inspection methods, including NDT and hydrostatic testing.",
    "Ensure proper documentation, certification, and nameplate requirements.",
    "Support compliance with API, EN, and project specifications during tank construction."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Information and requirements to be documented",
    "Module 3: Requirement",
    "Module 4: Materials",
    "Module 5: Design loads",
    "Module 6: Tank bottoms",
    "Module 7: Shell design",
    "Module 8: Fixed roof design",
    "Module 9: Floating roof design",
    "Module 10: Mountings",
    "Module 11: Insulation",
    "Module 12: Shop fabrication of tank components",
    "Module 13: Site erection and tolerances",
    "Module 14: Approval of welding procedures and welders.",
    "Module 15: Welding",
    "Module 16: Testing and inspection",
    "Module 17: Documentation and name-plate"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 112,
  "title": "Inspection of Pressure-relieving Devices",
  "date": "Present",
  "description": [
    "Pressure-relieving devices (PRDs) are critical safety components used in process industries to protect equipment, pipelines, and personnel from overpressure conditions. These devices, including pressure safety valves, relief valves, rupture disks, and pilot-operated relief valves, play a vital role in ensuring the safe operation of pressure systems in industries such as oil & gas, petrochemicals, refineries, power plants, and chemical processing facilities.",
    "The Inspection of Pressure-Relieving Devices Course provides participants with a comprehensive understanding of the design principles, operational behavior, inspection requirements, and performance verification of PRDs. The course emphasizes proper inspection techniques, testing procedures, failure analysis, and documentation practices to ensure the reliability and compliance of pressure relief systems.",
    "Participants will learn how to identify potential causes of improper PRD performance, apply appropriate inspection and testing methods, and maintain accurate records in accordance with industry standards such as API recommended practices and international pressure equipment safety guidelines.",
    "The course combines technical theory, industry best practices, inspection procedures, and practical case studies, enabling participants to enhance plant safety, regulatory compliance, and equipment reliability."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Inspection%20of%20Pressure-relieving%20Devices.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of mechanical, chemical, or process engineering
· Understanding of industrial pressure systems
· Familiarity with: Pressure vessels and piping systems, Basic instrumentation and safety systems, Process plant operations
· Basic understanding of pressure, temperature, and fluid flow principles`,
    `This course is beneficial for professionals working in:
· Mechanical or process engineering
· Plant inspection and integrity management
· Maintenance and reliability engineering
· Process safety engineering
· Operations and plant supervision`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of pressure-relieving devices in process safety",
    "Identify different types of PRDs and their applications",
    "Understand the operating principles of pressure safety valves and rupture disks",
    "Identify common causes of PRD malfunction or improper performance",
    "Understand the effects of corrosion, fouling, improper installation, and operational issues",
    "Perform inspection procedures for PRDs",
    "Apply appropriate testing methods to verify device functionality",
    "Understand bench testing and in-situ testing techniques",
    "Evaluate PRDs for serviceability and maintenance requirements",
    "Ensure compliance with industry codes and inspection standards",
    "Maintain accurate inspection records and testing documentation",
    "Prepare inspection reports and compliance records",
    "Understand the importance of traceability and regulatory documentation"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Pressure-relieving Devices (PRDs)",
    "Module 3: Causes of Improper Performance",
    "Module 4: Inspection and Testing",
    "Module 5: Records and Reports"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 113,
  "title": "Inspection Practices for Atmospheric and Low-pressure Storage Tanks",
  "date": "Present",
  "description": [
    "Atmospheric and low-pressure storage tanks are critical assets in refineries, petrochemical plants, tank farms, terminals, and bulk storage facilities. These tanks store crude oil, refined products, chemicals, and other hazardous fluids, making their structural integrity essential for operational reliability, environmental protection, and personnel safety.",
    "Over time, tanks are subject to corrosion, settlement, mechanical damage, and operational stresses. Effective inspection practices are necessary to detect deterioration early, prevent failures, and ensure compliance with recognized industry standards such as American Petroleum Institute (API)—including API 653, API 650, and related inspection codes.",
    "This course provides a comprehensive understanding of inspection planning, inspection intervals, testing methods, repair verification, and record management for atmospheric and low-pressure storage tanks. It equips participants with practical knowledge to support inspection programs, extend tank life, and ensure regulatory compliance."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Inspection%20Practices%20for%20Atmospheric%20and%20Low-pressure%20Storage%20Tanks.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    `· Basic knowledge of storage tank construction and operation
· Familiarity with corrosion mechanisms and materials of construction
· Understanding of inspection techniques and non-destructive testing (NDT) fundamentals
· Exposure to tank farm or refinery operations is beneficial`,
    `This course is suitable for:
· Inspection Engineers
· Mechanical and Maintenance Engineers
· Corrosion Engineers
· Asset Integrity Engineers
· Tank Farm Supervisors
· Reliability and Operations Personnel`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and importance of tank inspection programs.",
    "Identify and classify different types of atmospheric and low-pressure storage tanks.",
    "Recognize common causes of tank deterioration, including corrosion, settlement, fatigue, and operational damage.",
    "Develop and interpret risk-based inspection (RBI) and inspection plans.",
    "Determine appropriate inspection intervals, frequency, and scope based on service conditions and standards.",
    "Apply internal and external inspection techniques, including visual inspection and NDT methods.",
    "Evaluate tank bottom integrity, including leak testing and settlement assessment.",
    "Assess the integrity of repairs and alterations in accordance with API requirements.",
    "Review and maintain accurate inspection records and documentation.",
    "Support compliance with regulatory and environmental requirements.",
    "Contribute to asset life extension and integrity management strategies.",
    "Identify early warning signs of failure and recommend corrective actions."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Types of Storage Tank",
    "Module 3: Reasons for Inspection and Causes of Deterioration",
    "Module 4: Inspection Plans",
    "Module 5: Interval/Frequency and Extent of Inspection",
    "Module 6: Inspection",
    "Module 7: Leak Testing and Integrity of the Bottom",
    "Module 8: Integrity of Repairs and Alterations",
    "Module 9: Records"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 114,
  "title": "Inspection Maintenance and Repair of Above Ground Flat Bottomed Storage Tanks",
  "date": "Present",
  "description": [
    "Above ground flat-bottomed storage tanks are critical assets in refineries, tank farms, petrochemical plants, terminals, and LNG facilities. Failures in storage tanks can result in major product loss, environmental contamination, fire hazards, and regulatory non-compliance.",
    "This course provides comprehensive technical guidance on the inspection, maintenance, integrity assessment, and repair of atmospheric and low-pressure vertical storage tanks in accordance with internationally recognized standards such as American Petroleum Institute – API 650 (Design), API 653 (Inspection, Repair, Alteration & Reconstruction), API 571 (Damage Mechanisms), NACE International – Corrosion control standards, and American Society for Nondestructive Testing – NDT practices.",
    "Participants will gain practical knowledge on tank degradation mechanisms, corrosion control, inspection methodologies, repair strategies, Hydrotesting, re-siting, probabilistic maintenance approaches, and tank mothballing procedures.",
    "The course bridges mechanical integrity, corrosion engineering, inspection techniques, and maintenance strategy development, making it highly valuable for asset integrity and operations teams."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Inspection%20Maintenance%20and%20Repair%20of%20Above%20Ground%20Flat%20Bottomed%20Storage%20Tanks.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "prerequisite": [
    `· Basic understanding of mechanical equipment and materials
· Familiarity with storage tank operations
· Basic knowledge of corrosion and inspection concepts`,
    `This course is suitable for:
· Mechanical Engineers
· Inspection Engineers (API 653 aspirants)
· Corrosion Engineers
· Maintenance Engineers
· Asset Integrity Engineers
· Tank Farm Supervisors
· Operations & Reliability Personnel`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and application of API 650 and API 653.",
    "Identify tank types and major components.",
    "Interpret tank terminology and material specifications.",
    "Identify common degradation mechanisms (corrosion, settlement, fatigue, cracking).",
    "Understand internal vs external corrosion processes.",
    "Assess soil-side corrosion and underside bottom corrosion.",
    "Recognize microbiologically influenced corrosion (MIC).",
    "Evaluate corrosion under insulation (CUI).",
    "Apply general inspection techniques",
    "Interpret inspection data and determine remaining life.",
    "Establish inspection intervals based on risk and condition.",
    "Evaluate foundation settlement and distortion.",
    "Assess edge settlement and bottom stress impact.",
    "Evaluate bottom corrosion and annular ring integrity.",
    "Determine minimum thickness requirements.",
    "Recommend repair vs replacement strategies.",
    "Assess shell thinning, buckling, and distortion.",
    "Evaluate shell-to-bottom weld integrity.",
    "Differentiate between fixed roofs and floating roofs.",
    "Inspect cone roofs, dome roofs, and roof support structures.",
    "Assess floating roof pontoons, seals, and rim plates.",
    "Tank Appendages",
    "Inspect nozzles, manways, stairways, and wind girders.",
    "Evaluate reinforcement pads and weld details.",
    "Understand tank coating systems and failure modes.",
    "Evaluate coating condition and repair options.",
    "Assess insulation systems and CUI risks.",
    "Review cathodic protection basics.",
    "Develop repair strategies in accordance with API 653.",
    "Understand welding repairs and patch plate installation.",
    "Evaluate Hydrotesting requirements and procedures.",
    "Determine acceptance criteria after repairs.",
    "Understand tank re-rating and re-siting procedures.",
    "Apply Probabilistic Preventive Maintenance (PPM) concepts.",
    "Develop risk-based inspection strategies.",
    "Prepare tanks for mothballing and long-term preservation.",
    "Develop tank integrity management plans."
  ],
  "outline": [
    "Module 1: Introduction and scope",
    "Module 2: Tanks and their components: Terminology and materials of construction",
    "Module 3: Degradation mechanisms and failure modes",
    "Module 4: Corrosion of tanks",
    "Module 5: General inspection techniques and interpretation of inspection data",
    "Module 6: Tank foundations",
    "Module 7: Tank bottoms (with or without annular plates)",
    "Module 8: Tank shells",
    "Module 9: Tank roofs - general",
    "Module 10: Fixed roofs (cone roofs and dome roofs)",
    "Module 11: Floating roofs",
    "Module 12: Tank appendages",
    "Module 13: Tank coatings",
    "Module 14: Tank insulation",
    "Module 15: Hydrotesting",
    "Module 16: Re-siting of vertical tanks",
    "Module 17: Probabilistic Preventive Maintenance (PPM) for tanks",
    "Module 18: Mothballing"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦350,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 115,
  "title": "Safe Welding, Cutting, and Hot Work Practices in the Petroleum",
  "date": "Present",
  "description": [
    "Welding, cutting, and other hot work activities are among the highest-risk operations in petroleum refineries, petrochemical plants, tank farms, and gas processing facilities. When performed improperly, hot work can lead to fires, explosions, toxic releases, and catastrophic asset damage.",
    "This course provides a comprehensive and practical understanding of safe hot work practices, emphasizing hazard identification, risk assessment, permit systems, confined space work, and safeguards implementation. It integrates internationally recognized safety guidance from organizations such as the American Petroleum Institute (API), National Fire Protection Association (NFPA), and Occupational Safety and Health Administration (OSHA).",
    "Participants will learn how to systematically evaluate risks, implement effective controls, and safely execute hot work in various plant environments including vessels, piping systems, confined spaces, and operating units.",
    "This course bridges process safety principles with field-level execution, making it essential for both engineering and operations personnel."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Safe%20Welding,%20Cutting,%20and%20Hot%20Work%20Practices%20in%20the%20Petroleum.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of petroleum or petrochemical plant operations
· Familiarity with welding and cutting processes
· Understanding of process safety fundamentals`,
    `This course is suitable for:
· Maintenance and Mechanical Engineers
· Welding Supervisors and Inspectors
· Operations Personnel
· Safety and Loss Prevention Engineers
· Turnaround and Shutdown Coordinators
· Contractors working in petroleum facilities`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the risks associated with welding, cutting, and hot work in petroleum facilities.",
    "Conduct thorough job safety analysis (JSA) prior to hot work activities.",
    "Perform effective hazard evaluation and risk reduction using structured methodologies.",
    "Implement appropriate engineering and administrative safeguards.",
    "Conduct proper atmospheric testing and gas monitoring before and during hot work.",
    "Apply and manage hot work permit systems in accordance with industry standards.",
    "Safely execute hot work in confined spaces, including rescue preparedness.",
    "Identify precautions required when working inside vessels, exchangers, and tanks.",
    "Apply safety controls for work on the exterior of out-of-service equipment.",
    "Understand additional risks and precautions when performing work on equipment that remains in service.",
    "Implement safe practices for hot work in buildings, pits, and enclosed structures.",
    "Manage risks associated with hot work on piping systems, including isolation and depressurization.",
    "Recognize common failure scenarios and prevent fire and explosion incidents.",
    "Strengthen compliance with API, NFPA, OSHA, and company safety procedures."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Job Analysis",
    "Module 3: Hazard Evaluation And Risk Reduction",
    "Module 4: Implementation of Safeguards.",
    "Module 5: Testing For Hazards",
    "Module 6: Hot Work Permits",
    "Module 7: Hot Work In Confined Spaces",
    "Module 8: Work Inside Vessels, Exchangers, And Tanks",
    "Module 9: Work On The Exterior Of Vessels, Exchangers, And Tanks Not In Service",
    "Module 10: Work On Equipment In Service",
    "Module 11: Work In Buildings And Pits",
    "Module 12: Work On Piping"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 116,
  "title": "Welded Tanks for Oil Storage",
  "date": "Present",
  "description": [
    "Welded steel tanks are widely used for the storage of crude oil, refined petroleum products, and other hydrocarbons in refineries, tank farms, terminals, and production facilities. The safe design, fabrication, erection, and inspection of these tanks are critical to ensuring structural integrity, environmental protection, and long-term operational reliability.",
    "This course provides a comprehensive understanding of welded oil storage tank requirements in accordance with internationally recognized standards such as American Petroleum Institute (API)—particularly API 650—and relevant welding and materials codes.",
    "Participants will gain practical knowledge of materials selection, tank design fundamentals, fabrication processes, erection practices, inspection methods, welding qualification, and marking requirements, enabling them to effectively participate in tank projects from design through construction and commissioning."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Welded%20Tanks%20for%20Oil%20Storage.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "prerequisite": [
    `· Basic knowledge of mechanical engineering or structural design principles
· Familiarity with welding fundamentals
· Understanding of materials and corrosion concepts
· Exposure to oil storage facilities or tank construction projects is beneficial`,
    `This course is suitable for:
· Mechanical Engineers
· Tank Design Engineers
· Welding Engineers and Inspectors
· QA/QC Engineers
· Construction and Erection Supervisors
· Inspection and Asset Integrity Personnel`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose, scope, and application of welded oil storage tanks.",
    "Identify suitable materials of construction for tank shells, bottoms, roofs, and appurtenances.",
    "Apply fundamental design principles for atmospheric welded storage tanks, including load considerations.",
    "Understand fabrication requirements for shell plates, bottoms, roofs, and nozzles.",
    "Describe proper tank erection procedures, including alignment, welding sequence, and field assembly.",
    "Select and apply appropriate methods of examining welded joints, including visual inspection and NDT techniques.",
    "Understand requirements for welding procedures (WPS), procedure qualification records (PQR), and welder qualification.",
    "Interpret marking and identification requirements for traceability and compliance.",
    "Recognize common construction defects and corrective measures.",
    "Support compliance with API standards and project specifications.",
    "Contribute to quality assurance and quality control during tank construction projects.",
    "Evaluate tank construction documentation for technical completeness and code compliance."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Materials",
    "Module 3: Design",
    "Module 4: Fabrication",
    "Module 5: Erection",
    "Module 6: Methods of Examining joints",
    "Module 7: Welding Procedure and Welder Qualification",
    "Module 8: Marking"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 117,
  "title": "Technical safety",
  "date": "Present",
  "description": [
    "Technical safety is a critical discipline in the design, construction, and operation of industrial facilities, particularly in high-risk sectors such as oil and gas, petrochemical plants, offshore platforms, and energy infrastructure. It focuses on the implementation of engineering safeguards and protective systems that prevent accidents, reduce hazards, and protect personnel, equipment, and the environment.",
    "The Technical Safety Course provides a comprehensive understanding of the engineering principles, systems, and practices used to manage technical safety in industrial facilities. The course covers a wide range of safety aspects including facility layout, structural integrity, containment systems, process safety systems, fire and gas detection, and emergency shutdown systems, flare systems, ventilation, firefighting infrastructure, and emergency response arrangements.",
    "Participants will learn how various technical safety systems work together to provide multiple layers of protection against process hazards. The course also introduces the concept of hazard identification, risk mitigation, and safety system integration throughout the facility lifecycle, from design and construction to operation and emergency response.",
    "The course aligns with widely recognized industry frameworks such as IEC 61511, API Recommended Practice 14C, and NFPA fire protection guidelines.",
    "Through practical examples and engineering concepts, participants will gain a strong foundation in technical safety design, operational safety systems, and emergency preparedness in industrial facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Technical%20Safety.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "7 Days",
  "prerequisite": [
    `· Basic knowledge of engineering, industrial safety, or process operations
· Familiarity with: Process plant operations, Industrial safety principles, Basic instrumentation and control systems, Oil and gas production or processing systems`,
    `This course is suitable for professionals working in:
· Process engineering
· Safety and risk engineering
· Mechanical and structural engineering
· Instrumentation and control engineering
· Offshore and marine operations
· Health, Safety and Environment (HSE) roles
· Plant operations and maintenance`
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles and objectives of technical safety in industrial facilities",
    "Identify the major technical safety systems used in oil & gas and petrochemical plants",
    "Understand methods used to prevent loss of containment",
    "Evaluate facility layout and structural integrity considerations for safety",
    "Understand the role of process safety systems and emergency shutdown systems",
    "Identify the function of blowdown systems, flare systems, and venting systems",
    "Understand gas detection and fire detection technologies",
    "Identify appropriate firefighting systems and passive fire protection measures",
    "Understand emergency communication, evacuation, and rescue systems",
    "Identify safety measures used for escape, evacuation, and emergency power systems",
    "Understand how different safety systems integrate to create layers of protection",
    "Apply technical safety concepts to industrial facility design and operation"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Management of technical safety",
    "Module 3: Layout",
    "Module 4: Structural integrity",
    "Module 5: Containment",
    "Module 6: Open drain",
    "Module 7: Process safety",
    "Module 8: Emergency shut down (ESD)",
    "Module 9: Blow down (BD) and flare/vent system",
    "Module 10: Gas detection",
    "Module 11: Fire detection",
    "Module 12: Ignition source control (ISC)",
    "Module 13: Human – machine interface (HMI)",
    "Module 14: Natural ventilation and heating, ventilation and air conditioning (HVAC)",
    "Module 15: Public Emergency power and lighting address (PA), alarm and emergency communication",
    "Module 16: Emergency power and lighting",
    "Module 17: Passive fire protection (PFP)",
    "Module 18: Firefighting systems",
    "Module 19: Escape and evacuation",
    "Module 20: Rescue and safety equipment",
    "Module 21: Marine systems and position keeping",
    "Module 22: Ship collision barrier"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $300",
  "certification": "Certificate of Completion"
},

{
  "id": 118,
  "title": "Process Plant Layout",
  "date": "Present",
  "description": [
    "Process plant layout is a critical phase in the design and development of chemical, petrochemical, and refinery facilities. It involves the systematic arrangement of equipment, piping, utilities, and supporting systems to ensure safe, efficient, operable, and cost-effective plant operations.",
    "This course integrates general layout principles, equipment layout, and detailed mechanical/piping layout, providing a complete understanding of plant layout from concept to detailed engineering",
    "This course also builds on general layout principles and dives deeper into detailed considerations such as storage facilities, utility systems, pollution control, transportation logistics, and in-building arrangements. It emphasizes industry standards, safety guidelines, and real-world best practices used in oil & gas, petrochemical, refinery, and power plants"
  ],
  "image": "https://ik.imagekit.io/mags/courses/Process%20Plant%20Layout.png",
  "tags": [],
  "category": "process",
  "duration": "8 Days",
  "prerequisite": [
    `This course is designed for engineers, designers, and project professionals involved in plant engineering and design. Recommended background includes:
· Basic understanding of process/chemical engineering principles
· Familiarity with PFDs and P&IDs
· Knowledge of plant equipment (pumps, compressors, vessels, heat exchangers, etc.)
· Awareness of safety and regulatory standards (API, ASME, NFPA, OSHA, ISA)
· Exposure to engineering design tools (AutoCAD, AVEVA E3D, SmartPlant, Plant 3D, etc.)`
],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Explain the role of plant layout in EPC project execution",
    "Apply site and plot layout principles",
    "Develop layouts for major process equipment",
    "Design layouts for pumps, compressors, and piping systems",
    "Apply safety and accessibility requirements",
    "Perform basic pipe routing and stress considerations",
    "Integrate instrumentation systems",
    "Conduct hazard assessments",
    "Evaluate and optimize plant layouts",
    "Develop layouts for bulk solid storage considering handling, dust control, and environmental issues.",
    "Plan warehouse storage areas for spare parts, consumables, and maintenance tools.",
    "Integrate pollution control facilities into site layouts in line with regulatory and environmental requirements.",
    "Analyze and design utility systems, including general utilities and specialized services (water, steam, power).",
    "Plan and optimize central services such as control rooms, substations, laboratories, and maintenance shops.",
    "Evaluate constructability aspects and translate them into layout design for efficient construction and installation.",
    "Prepare detailed plot layouts including spacing, safety distances, and accessibility for operations and maintenance.",
    "Develop effective layouts within buildings, ensuring functionality, safety, and compliance with building codes.",
    "Balance safety, operability, and cost considerations in site and plot layout decision-making.",
    "Critically assess detailed layout drawings and propose improvements to optimize plant design."
  ],
  "outline": [
    "Module 1: Introduction to Process Plant Layout",
    "Module 2: Discipline of Plant Layout",
    "Module 3: Site Layout Principles",
    "Module 4: Plot Plan Development",
    "Module 5: Planning and Development of Layout",
    "Module 6: Methods and Layout Techniques",
    "Module 7: Equipment Layout (Detailed)",
    "Module 8: Mechanical Equipment Layout",
    "Module 9: Piping Layout and Routing",
    "Module 10: Pipe Stress and Flexibility",
    "Module 11: Instrumentation and Control Layout",
    "Module 12: Hazard Assessment and Safety",
    "Module 13: Layout Review and Optimization",
    "Module 14:  Transportation",
    "Module 15:  Bulk Fluid Storage",
    "Module 16:   Bulk Solid Storage",
    "Module 17:   Warehouse Storage",
    "Module 18:   Pollution Control",
    "Module 19:  Utilities I: General",
    "Module 20:   Utilities II: Water and Steam",
    "Module 21:  Central Services",
    "Module 22:    Construction and Layout",
    "Module 23:  Details of Plot Layout",
    "Module 24:  Layout Within Buildings"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#300,000 / $350",
  "certification": "Certificate of Completion"
},

{
  "id": 119,
  "title": "Classification of Fires and Fire Hazard Properties",
  "date": "Present",
  "description": "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 1 provides a fundamental understanding of fire science, fire hazard properties, hazard identification, and fire protection principles that form the foundation for hazardous area classification and risk management in industrial facilities. The course introduces participants to the different classifications of fires, fire behavior, fire hazard properties of materials, occupancy and construction hazards, fire resistance requirements, and methods of fire prevention and protection. Participants will also learn the principles of firefighting, extinguishing methods, building fire protection systems, and the application of hazard identification techniques, including Hazard and Operability Studies (HAZOP), to identify and control fire and explosion risks in petroleum, petrochemical, chemical, and process industries. Through practical examples and industry-based case studies, participants will develop the knowledge required to recognize fire hazards, assess risk levels, and support the safe design and operation of industrial facilities.",
  "image": "https://ik.imagekit.io/mags/courses/Classification%20of%20Fires%20and%20Fire%20Hazard%20Properties%20(HAVPC%20Stage%201).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of industrial processes and operations.",
    "Familiarity with petroleum, chemical, or process industry facilities.",
    "Basic knowledge of safety principles and engineering practices.",
    "Suitable for engineers, technicians, operators, HSE professionals, supervisors, facility managers, and project personnel involved in plant safety and risk management."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the fundamentals of fire science and the importance of fire hazard management in petroleum and chemical plants.",
    "Explain the different classifications of fires and their characteristics.",
    "Identify the fire hazard properties of flammable, combustible, and reactive materials.",
    "Classify industrial hazards based on their potential fire and explosion consequences.",
    "Evaluate occupancy hazards and their impact on fire risk assessment.",
    "Understand building construction classifications and their influence on fire behavior and protection requirements.",
    "Assess fire protection requirements for buildings and industrial facilities.",
    "Identify hazards associated with various types of industrial contents and stored materials.",
    "Understand the fire safety considerations associated with ramps, access routes, and emergency evacuation systems.",
    "Explain fire resistance ratings and their application in facility design and safety management.",
    "Apply basic firefighting methods suitable for different classes of fires.",
    "Understand the principles of fire protection, prevention, detection, and mitigation.",
    "Select appropriate extinguishing methods and firefighting agents for various fire scenarios.",
    "Conduct preliminary hazard identification studies to recognize potential fire and explosion risks.",
    "Understand the methodology and application of Hazard and Operability Studies (HAZOP) in fire and process safety management.",
    "Recognize common fire and explosion hazards in petroleum, petrochemical, and chemical processing facilities.",
    "Support compliance with fire safety regulations, industry standards, and risk management requirements.",
    "Contribute to the development of safer facility designs and operational practices through effective hazard assessment and fire protection planning."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Classification of Fires",
    "Module 3: Fire Hazard Properties",
    "Module 4: Classification of Hazards",
    "Module 5: Classification of Occupancy Hazards",
    "Module 6: Classification of Construction",
    "Module 7: Fire Protection in Buildings",
    "Module 8:  Hazard of Contents",
    "Module 9: Ramps",
    "Module 10: Fire Resistance",
    "Module 11: Basic Methods of Firefighting",
    "Module 12:  Principles of Fire Protection",
    "Module 13:   Extinguishing Methods",
    "Module 14: Suggested Hazard Identification",
    "Module 15: Hazard and Operability Studies"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 120,
  "title": "Hazardous Area Classification",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 2 provides an in-depth understanding of the principles, methodologies, and engineering requirements used to classify hazardous locations where flammable gases, vapors, mists, or combustible dusts may be present. The course focuses on the application of international standards and industry best practices for determining hazardous zones, evaluating ventilation effectiveness, selecting appropriate equipment protection levels (EPLs), and implementing explosion protection techniques for electrical equipment operating in potentially explosive atmospheres.",
    "Participants will develop a thorough understanding of the physical principles governing the formation of explosive atmospheres, area classification methodologies, ventilation assessment, gas and dust hazard evaluation, and the differences between Zone and Class-Division classification systems. The course also examines explosion protection concepts, equipment selection requirements, and the practical application of hazardous area classification studies within petroleum, petrochemical, chemical, LNG, offshore, and industrial facilities.",
    "Through practical examples and case studies, participants will gain the knowledge necessary to perform hazardous area classification assessments, support safe facility design, ensure regulatory compliance, and reduce fire and explosion risks associated with hazardous substances."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Classification%20of%20Fires%20and%20Fire%20Hazard%20Properties%20(HAVPC%20Stage%201).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of industrial process operations and petroleum or chemical plant facilities.",
    "Familiarity with process equipment, piping systems, and instrumentation is beneficial.",
    "Basic knowledge of fire and explosion hazards.",
    "Suitable for process engineers, electrical engineers, instrumentation engineers, HSE professionals, project engineers, operations personnel, maintenance personnel, and facility safety specialists."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose, scope, and importance of hazardous area classification in industrial facilities.",
    "Explain the fundamental physical principles associated with flammable gases, vapors, mists, combustible dusts, and explosive atmospheres.",
    "Define key hazardous area classification terminology and concepts used in international standards.",
    "Apply area classification methodologies to identify and classify hazardous locations within petroleum and chemical facilities.",
    "Determine the extent and severity of hazardous zones based on release characteristics and process conditions.",
    "Evaluate the influence of ventilation on the formation and dispersion of explosive atmospheres.",
    "Assess ventilation effectiveness and its impact on hazardous area extent reduction.",
    "Understand Equipment Protection Levels (EPLs) and their relationship to hazardous area zones.",
    "Select suitable electrical and instrumentation equipment for use in classified hazardous locations.",
    "Understand gas explosion protection concepts and the various protection techniques used for electrical equipment.",
    "Explain explosion protection methods such as flameproof, increased safety, intrinsic safety, pressurization, encapsulation, and other recognized protection concepts.",
    "Identify hazards associated with combustible dusts and understand dust area classification requirements.",
    "Apply hazardous area classification principles to facilities handling powders, particulates, and combustible dusts.",
    "Differentiate between the Zone classification system and the Class-Division classification system.",
    "Understand the requirements and applications of Class I, Class II, and Class III hazardous locations.",
    "Interpret hazardous area classification drawings, documentation, and engineering deliverables.",
    "Support the design, operation, maintenance, and inspection of facilities located within hazardous areas.",
    "Apply relevant international standards and industry practices to hazardous area classification studies.",
    "Identify potential fire and explosion risks associated with equipment installation in hazardous locations.",
    "Contribute to safer facility design and risk reduction through effective hazardous area classification and equipment selection practices."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: The Basic Physical Principles and Definitions",
    "Module 3: Area Classification",
    "Module 4: Ventilation",
    "Module 5: Equipment Protection Level",
    "Module 6: Gas Explosion Protection Concepts for Electrical Equipment",
    "Module 7: Combustible Dusts",
    "Module 8: Class-Division Schemes"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 121,
  "title": "Layout and Spacing",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 3 (Layout and Spacing) provides a comprehensive understanding of the principles, standards, and engineering practices used to develop safe and efficient facility layouts for petroleum, petrochemical, chemical, LNG, gas processing, and other industrial plants. The course focuses on the arrangement of process equipment, buildings, storage facilities, utilities, piping systems, and emergency response infrastructure to minimize fire, explosion, toxic release, and operational risks while ensuring safe access, maintainability, operability, and regulatory compliance.",
    "Participants will learn how facility layout influences process safety, emergency response, hazardous area management, and overall plant performance. The course covers spacing requirements for process units, storage tanks, LPG facilities, utility systems, control rooms, substations, off-site facilities, waste treatment systems, emergency shutdown systems, blowdown facilities, and specialized installations. Emphasis is placed on the application of international standards, risk-based approaches, fire protection requirements, and industry best practices for establishing safe separation distances and equipment arrangements.",
    "Through practical examples, engineering calculations, and industry case studies, participants will gain the knowledge required to evaluate plant layouts, determine appropriate spacing requirements, support facility design reviews, and contribute to safer and more efficient industrial facility development."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Layout%20and%20Spacing%20(HAVPC%20Stage%203).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of process engineering, plant operations, and industrial facilities.",
    "Familiarity with process equipment, piping systems, utilities, and instrumentation.",
    "Basic knowledge of fire protection, loss prevention, and risk management principles.",
    "Suitable for process engineers, mechanical engineers, piping engineers, project engineers, HSE professionals, facility planners, operations personnel, maintenance engineers, and plant design personnel."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the importance of plant layout and spacing in managing fire, explosion, toxic release, and operational risks.",
    "Explain the key principles governing facility layout in petroleum, gas, petrochemical, and chemical plants.",
    "Apply fundamental layout considerations related to safety, operability, maintainability, constructability, and future expansion.",
    "Develop safe and efficient plant layouts that comply with industry standards and best practices.",
    "Evaluate the siting and layout requirements of control rooms and electrical substations.",
    "Identify layout requirements necessary to support effective firefighting and emergency response operations.",
    "Assess building location requirements and occupancy considerations within industrial facilities.",
    "Apply layout principles to process units to minimize escalation risks and improve operational efficiency.",
    "Determine minimum separation distances and clearance requirements for storage tanks and tank farms.",
    "Evaluate layout and spacing requirements for LPG storage, handling, and processing facilities.",
    "Establish appropriate equipment spacing requirements to facilitate safe operation, maintenance, and emergency access.",
    "Apply piping layout principles to reduce hazards, improve accessibility, and support plant operability.",
    "Evaluate utility system layout requirements, including steam, cooling water, instrument air, electrical, and firewater systems.",
    "Understand the siting and spacing requirements for off-site facilities such as warehouses, workshops, loading facilities, and administrative buildings.",
    "Assess layout considerations for waste treatment and environmental protection facilities.",
    "Understand the role and location requirements of Emergency Shutdown (ESD) systems in plant safety.",
    "Evaluate the safe siting and spacing requirements of blowdown drums and depressurization facilities.",
    "Apply layout requirements for fire training areas and emergency preparedness facilities.",
    "Understand special layout considerations for hazardous facilities such as tetraethyl lead blending plants and other high-risk operations.",
    "Interpret and apply industry codes, standards, and recommended practices governing plant layout and spacing.",
    "Identify common layout deficiencies that contribute to major industrial accidents and recommend corrective actions.",
    "Participate effectively in layout reviews, HAZOP studies, risk assessments, and facility design verification activities.",
    "Support the development of inherently safer facility designs through proper equipment arrangement and spacing.",
    "Contribute to regulatory compliance, risk reduction, and improved plant safety through effective layout and spacing practices."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Layout in Oil, Gas, and Chemical Facilities",
    "Module 3: Basic Considerations",
    "Module 4: Plant Layout",
    "Module 5: Layout of Control Room and Electrical Substation",
    "Module 6: Firefighting Requirements",
    "Module 7: Building Requirements",
    "Module 8: Layout in Process Units",
    "Module 9: Distances/Clearances Requirements for Storage Tanks",
    "Module 10: Layout of LPG Facilities",
    "Module 11: Equipment Layout and Spacing",
    "Module 12: Layout of Piping",
    "Module 13:  Utility Layout and Spacing",
    "Module 14: Off-Site Facilities",
    "Module 15: Waste Treatment Facilities",
    "Module 16: Emergency Shutdown System",
    "Module 17: Blowdown Drums",
    "Module 18:  Fire Training Areas",
    "Module 19: Tetraethyl Lead Blending Plants"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 122,
  "title": "Fire Alarm Systems and Automatic Detectors",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 4 (Fire and Gas Detection Systems) provides a comprehensive understanding of the principles, design requirements, operation, maintenance, and application of fire and gas detection systems used to protect personnel, facilities, equipment, and the environment in petroleum, petrochemical, chemical, LNG, and industrial plants. The course focuses on the technologies and methodologies used to detect fires, combustible gases, toxic gases, oxygen deficiency, and hazardous atmospheric conditions before they escalate into major incidents.",
    "Participants will learn the fundamentals of fire and gas detection, alarm management, detector technologies, detector selection criteria, system integration, control panels, portable gas detection equipment, and maintenance requirements. The course also examines combustible gas detectors, toxic gas monitoring systems, oxygen monitoring devices, detector tubes, chemical sensing technologies, and the administrative controls necessary to ensure reliable system performance.",
    "Through practical examples, industry case studies, and engineering applications, participants will develop the knowledge required to evaluate, select, operate, maintain, and manage fire and gas detection systems in hazardous industrial environments while supporting regulatory compliance and process safety objectives."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Fire%20Alarm%20Systems%20and%20Automatic%20Detectors%20(HAVPC%20Stage%204).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of fire and explosion hazards in industrial facilities.",
    "Familiarity with process equipment, instrumentation, and plant operations.",
    "Basic knowledge of safety systems and hazardous area concepts is beneficial.",
    "Suitable for process engineers, instrumentation and control engineers, electrical engineers, HSE professionals, operations personnel, maintenance technicians, fire protection engineers, project engineers, and plant safety specialists."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of fire and gas detection systems in process safety and hazardous area risk management.",
    "Explain the basic principles governing fire detection, gas detection, and atmospheric monitoring systems.",
    "Identify the different types of alarms, warning systems, and status indications used in industrial facilities.",
    "Evaluate alarm management requirements for process units and hazardous installations.",
    "Understand the fire detection requirements for buildings, warehouses, control rooms, substations, and industrial facilities.",
    "Describe the components and architecture of fire detection systems, including detectors, control panels, annunciators, and communication networks.",
    "Explain the operating principles of various fire detection technologies, including smoke, heat, flame, and multi-sensor detectors.",
    "Understand the design, application, and operation of fixed gas detection systems.",
    "Identify different gas detection technologies and their suitability for specific industrial applications.",
    "Understand the materials, construction, and environmental considerations associated with gas detectors.",
    "Explain the operation, application, and limitations of gas detector tubes and sampling systems.",
    "Interpret detector markings, certifications, and hazardous area approvals.",
    "Understand manufacturer documentation, instruction manuals, and operational requirements for fire and gas detection equipment.",
    "Explain the principles of operation of combustible gas detectors and their applications in hazardous environments.",
    "Evaluate the use of portable and transportable combustible gas detectors for workplace safety and confined space monitoring.",
    "Apply proper procedures for the use, calibration, bump testing, and verification of portable gas detection equipment.",
    "Develop maintenance routines and administrative control procedures to ensure reliable detector performance.",
    "Understand inspection, testing, calibration, and record-keeping requirements for fire and gas detection systems.",
    "Evaluate combination detectors used for monitoring combustible gases, toxic gases, oxygen deficiency, and oxygen enrichment.",
    "Understand the operation and application of multi-gas portable monitoring devices.",
    "Explain the principles and applications of chemical sensing detectors and detector tube technologies.",
    "Identify common detector limitations, failure modes, and environmental factors affecting detection performance.",
    "Select appropriate fire and gas detection technologies based on process hazards, facility layout, and operational requirements.",
    "Interpret fire and gas detection system drawings, layouts, alarm philosophies, and engineering documentation.",
    "Support compliance with applicable industry standards, regulations, and best practices for fire and gas detection systems.",
    "Contribute to the design, operation, maintenance, and continuous improvement of fire and gas detection systems within hazardous industrial facilities."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Basic Principles",
    "Module 3: Alarms and Status Indication for Plant Units",
    "Module 4: Buildings, Warehouses’ Fire Detection, and Control Panel",
    "Module 5: Fire Detection System",
    "Module 6: Gas Detection System",
    "Module 7: Gas Detectors: Materials",
    "Module 8: Gas Detector Tubes",
    "Module 9: Marking",
    "Module 10: Instruction Manual",
    "Module 11: Principle of Operation, Combustible Gas Detectors",
    "Module 12: Use of Portable and Transportable Combustible",
    "Module 13:   Maintenance Routine Procedures and General Administrative Control",
    "Module 14: Combination Explosive, Toxic, and Oxygen Deficiency or Excess Detectors (Portable and Transportable)",
    "Module 15: Chemical Sensing Detectors and Tubes"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 123,
  "title": "Firefighting Sprinkler Systems",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 5 (Firefighting Sprinkler Systems) provides a comprehensive understanding of the design, operation, application, and maintenance of automatic sprinkler and water-based fire suppression systems used in petroleum, petrochemical, chemical, LNG, power, storage, and industrial facilities. The course focuses on the engineering principles and standards governing sprinkler system selection, occupancy classification, hydraulic design, water supply requirements, and system integration with other fire protection measures.",
    "Participants will learn the various types of sprinkler systems, including wet pipe, dry pipe, alternate, preaction, deluge, recycling, and foam-water sprinkler systems, as well as their applications in different hazard environments. The course also covers hydraulic calculations, design density requirements, water supply characteristics, sprinkler temperature ratings, exposure protection systems, and personnel safety considerations. Emphasis is placed on ensuring compliance with industry standards, improving fire protection effectiveness, and minimizing fire-related risks in hazardous industrial facilities.",
    "Through practical examples, engineering calculations, design exercises, and industry case studies, participants will gain the knowledge required to evaluate, design, operate, inspect, and maintain sprinkler systems that support facility safety, regulatory compliance, and business continuity."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Firefighting%20Sprinkler%20Systems%20(HAVPC%20Stage%205).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of fire science, fire hazard properties, and fire protection principles.",
    "Familiarity with industrial facilities, process equipment, piping systems, and utility services.",
    "Basic knowledge of hydraulics and fluid flow is beneficial.",
    "Suitable for process engineers, mechanical engineers, fire protection engineers, piping engineers, HSE professionals, operations personnel, maintenance personnel, project engineers, facility managers, and safety specialists."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of automatic sprinkler systems in industrial fire protection and risk reduction.",
    "Explain the basic principles governing sprinkler system design and operation.",
    "Understand the interaction between sprinkler systems and other fire protection measures, including fire detection, alarm systems, passive fire protection, and emergency response systems.",
    "Identify buildings, facilities, and process areas requiring sprinkler protection.",
    "Classify occupancies based on fire hazards and determine corresponding sprinkler protection requirements.",
    "Differentiate between the various types of sprinkler systems and their applications.",
    "Understand the design, operation, advantages, and limitations of wet pipe sprinkler installations.",
    "Explain the application of alternate wet and dry pipe sprinkler systems.",
    "Evaluate dry pipe sprinkler systems used in environments subject to freezing conditions.",
    "Understand the operating principles and applications of preaction sprinkler systems for sensitive or high-value facilities.",
    "Explain the design and operation of recycling sprinkler installations.",
    "Understand the purpose and application of tail-end alternate pipe systems and tail-end dry pipe extensions.",
    "Evaluate deluge sprinkler systems used for high-hazard process equipment and exposure protection.",
    "Determine water supply requirements for sprinkler systems and fire protection networks.",
    "Apply design density criteria and assumed maximum area of operation in fully hydraulically calculated sprinkler systems.",
    "Interpret water supply pressure-flow characteristics and evaluate system hydraulic performance.",
    "Assess flow velocity limitations and their impact on sprinkler system design.",
    "Understand sprinkler temperature ratings, classifications, and color-coding requirements.",
    "Select appropriate sprinkler heads based on environmental conditions and fire hazards.",
    "Evaluate hazards to personnel associated with sprinkler system operation and fire suppression activities.",
    "Design and assess outside sprinkler systems used for protection against exposure fires.",
    "Understand the principles and applications of deluge foam-water sprinkler systems and foam-water spray systems.",
    "Evaluate sprinkler protection requirements for petroleum, petrochemical, chemical, LNG, storage, and utility facilities.",
    "Interpret sprinkler system drawings, hydraulic calculations, equipment specifications, and engineering documentation.",
    "Understand inspection, testing, maintenance, and performance verification requirements for sprinkler systems.",
    "Identify common design deficiencies, operational issues, and maintenance challenges affecting sprinkler system reliability.",
    "Apply relevant industry standards, codes, and recommended practices governing sprinkler system design and operation.",
    "Support fire protection studies, hazard assessments, and facility safety reviews involving sprinkler protection systems.",
    "Contribute to safer facility design and operation through the effective application of sprinkler-based fire protection systems.",
    "Improve fire risk management, regulatory compliance, and emergency preparedness within hazardous industrial environments."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Outline Design",
    "Module 3: Interaction with Other Fire Protection Measures",
    "Module 4:    Buildings to Be Sprinkler-Protected",
    "Module 5: Classification of Occupancies",
    "Module 6: Types",
    "Module 7: Wet Pipe Installations",
    "Module 8: Alternate (Wet and Dry Pipe) Installations",
    "Module 9: Dry Pipe Installations",
    "Module 10: Preaction Installations",
    "Module 11: Recycling Installations",
    "Module 12: Tail-End Alternate Pipe and Tail-End Dry Pipe Extensions",
    "Module 13:   Deluge Installations",
    "Module 14:    Water Supplies",
    "Module 15: Design Density and Assumed Maximum Area of Operation for Fully Hydraulically Calculated Installations",
    "Module 16: Water Supply Pressure-Flow Characteristics and Velocity",
    "Module 17: Temperature Ratings, Classifications, and Color Coding",
    "Module 18:   Hazard to Personnel",
    "Module 19:    Outside Sprinklers for Protection against Exposure Fires",
    "Module 20:  Deluge Foam-Water Sprinkler and Foam-Water Spray Systems"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 124,
  "title": "Carbon Dioxide Gas Fire Extinguishing Systems",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 6 (Carbon Dioxide Gas Fire Extinguishing Systems) provides a comprehensive understanding of the design, application, operation, and safety requirements of carbon dioxide (CO₂) fire suppression systems used in petroleum, petrochemical, chemical, LNG, power generation, marine, and industrial facilities. The course focuses on the characteristics of carbon dioxide as a fire extinguishing agent, system design methodologies, equipment selection, discharge requirements, and operational considerations for protecting critical assets against fire hazards.",
    "Participants will learn the principles of total flooding systems, local application systems, and manual hose reel systems, standpipe systems, and mobile supply arrangements. The course also examines carbon dioxide applications for surface fires and deep-seated fires, storage and distribution equipment, discharge nozzles, application rates, system components, and installation requirements. Particular emphasis is placed on safety considerations due to the asphyxiation hazards associated with carbon dioxide systems and the implementation of safeguards that protect personnel while ensuring effective fire suppression.",
    "Through practical examples, engineering applications, and industry case studies, participants will develop the knowledge required to evaluate, design, operate, inspect, and maintain carbon dioxide fire extinguishing systems in hazardous industrial environments while ensuring compliance with industry standards and fire protection requirements."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Carbon%20Dioxide%20Gas%20Fire%20Extinguishing%20Systems(HAVPC%20Stage%206).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of fire science, fire behavior, and fire protection systems.",
    "Familiarity with industrial process facilities, equipment, and utility systems.",
    "Basic knowledge of fluid mechanics and fire protection engineering is beneficial.",
    "Suitable for fire protection engineers, process engineers, mechanical engineers, HSE professionals, operations personnel, maintenance technicians, project engineers, facility managers, and emergency response personnel."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of carbon dioxide fire extinguishing systems in industrial fire protection programs.",
    "Explain the physical and chemical characteristics of carbon dioxide that make it an effective fire suppression agent.",
    "Identify the advantages, applications, and limitations of carbon dioxide fire extinguishing systems.",
    "Understand the fire suppression mechanisms of carbon dioxide, including oxygen displacement and cooling effects.",
    "Evaluate the suitability of carbon dioxide systems for different fire hazards and facility applications.",
    "Identify and explain the functions of major carbon dioxide system components.",
    "Differentiate between the various types of carbon dioxide fire extinguishing systems and their applications.",
    "Understand the design, installation, and operation of packaged carbon dioxide systems and fire suppression kits.",
    "Explain the principles and requirements of total flooding carbon dioxide systems.",
    "Determine the application of carbon dioxide systems for surface fire hazards.",
    "Understand the design considerations for carbon dioxide protection of deep-seated fire hazards.",
    "Calculate and evaluate carbon dioxide application rates required for effective fire suppression.",
    "Understand the design and operation of local application carbon dioxide systems.",
    "Evaluate manual hose reel carbon dioxide systems and their appropriate applications.",
    "Understand standpipe systems and mobile carbon dioxide supply arrangements used in emergency response operations.",
    "Identify storage container types, capacities, and design requirements for carbon dioxide systems.",
    "Understand carbon dioxide storage conditions, pressure considerations, and inventory management requirements.",
    "Evaluate discharge nozzle selection, placement, and performance requirements.",
    "Understand piping network requirements and distribution system design principles.",
    "Apply additional design and installation requirements applicable to all carbon dioxide fire suppression systems.",
    "Assess system reliability, inspection requirements, and maintenance procedures.",
    "Understand system testing, commissioning, and performance verification requirements.",
    "Identify hazards associated with carbon dioxide discharge and confined-space applications.",
    "Understand personnel safety risks associated with oxygen depletion and carbon dioxide exposure.",
    "Apply safety requirements related to alarms, warning systems, evacuation procedures, lockout controls, and emergency shutdowns.",
    "Interpret carbon dioxide system drawings, specifications, hydraulic calculations, and engineering documentation.",
    "Evaluate compliance with applicable fire protection standards, regulations, and industry best practices.",
    "Identify common design deficiencies, operational issues, and maintenance challenges affecting system performance.",
    "Support hazard assessments, fire protection studies, and facility safety reviews involving carbon dioxide fire suppression systems.",
    "Contribute to safer facility design and operation through the proper application of carbon dioxide fire extinguishing technologies."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Characteristics and Uses of Carbon Dioxide",
    "Module 3: Use and Limitations",
    "Module 4: System Components",
    "Module 5: Types of Systems",
    "Module 6: Package Systems (Kits)",
    "Module 7:    Total Flooding Systems",
    "Module 8: Carbon Dioxide for Surface Fires",
    "Module 9: Carbon Dioxide for Deep-Seated Fires",
    "Module 10: Rates of Application",
    "Module 11: Local Application Systems",
    "Module 12: Manual Hose Reel Systems",
    "Module 13:   Standpipe Systems and Mobile Supply",
    "Module 14: Storage Containers",
    "Module 15: Discharge Nozzles",
    "Module 16: Additional Requirements for All Systems",
    "Module 17: Safety Requirements"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 125,
  "title": "Dry Chemical Fire Extinguishing Systems",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 7 (Dry Chemical Fire Extinguishing Systems) provides a comprehensive understanding of the design, operation, application, and maintenance of dry chemical fire suppression systems used in petroleum, petrochemical, chemical, LNG, power generation, marine, aviation, and industrial facilities. The course focuses on the characteristics of dry chemical extinguishing agents, system design principles, equipment selection, discharge mechanisms, and safety considerations for controlling and extinguishing flammable liquid, flammable gas, and electrical fires.",
    "Participants will learn the properties and performance of dry chemical powders, the role of expellant gases, system components, and the engineering principles used in designing fixed and mobile dry chemical fire suppression systems. The course covers total flooding systems, local application systems, monitor systems, hose reel systems, alarm and indication systems, and operational safety requirements. Emphasis is placed on the rapid suppression capabilities of dry chemical systems, their integration with other fire protection measures, and their application in high-risk industrial environments where rapid fire knockdown is critical.",
    "Through practical examples, engineering applications, and industry case studies, participants will develop the knowledge required to evaluate, design, operate, inspect, and maintain dry chemical fire extinguishing systems while ensuring compliance with industry standards and fire protection requirements."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Dry%20Chemical%20Fire%20Extinguishing%20Systems(HAVPC%20Stage%207).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of fire science, fire behavior, and industrial fire protection systems.",
    "Familiarity with petroleum, petrochemical, chemical, LNG, and industrial process facilities.",
    "Basic knowledge of fluid mechanics, pressure systems, and fire suppression technologies is beneficial.",
    "Suitable for fire protection engineers, process engineers, mechanical engineers, HSE professionals, operations personnel, maintenance technicians, project engineers, facility managers, emergency response personnel, and plant safety specialists."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of dry chemical fire extinguishing systems in industrial fire protection programs.",
    "Explain the fire suppression mechanisms of dry chemical extinguishing agents.",
    "Understand the characteristics, composition, and performance of various dry chemical powders.",
    "Differentiate between dry chemical agents used for Class B, Class C, and specialized fire hazards.",
    "Identify the advantages, applications, and limitations of dry chemical fire extinguishing systems.",
    "Understand the general requirements governing dry chemical fire suppression system design and operation.",
    "Evaluate dry chemical agent storage, handling, and environmental considerations.",
    "Explain the function and operation of expellant gas systems used for dry chemical discharge.",
    "Understand dry chemical and expellant gas supply requirements.",
    "Apply general engineering design principles used in dry chemical fire extinguishing systems.",
    "Identify and explain the functions of major dry chemical system components.",
    "Differentiate between the various types of dry chemical fire extinguishing systems and their applications.",
    "Understand the design and operation of total flooding dry chemical systems.",
    "Evaluate the suitability of total flooding systems for specific industrial hazards.",
    "Understand the design and operation of local application dry chemical systems.",
    "Determine the appropriate use of local application systems for equipment and process fire protection.",
    "Evaluate monitor systems used for large-scale fire suppression and exposure protection.",
    "Understand the design and operation of dry chemical hose reel systems for manual firefighting applications.",
    "Assess discharge coverage, application rates, and extinguishing effectiveness for different hazard scenarios.",
    "Understand alarm, indication, and system activation requirements associated with dry chemical fire suppression systems.",
    "Evaluate control and monitoring systems used to support dry chemical fire protection installations.",
    "Understand system integration requirements with fire detection, alarm, emergency shutdown, and other fire protection systems.",
    "Apply safety precautions associated with dry chemical system installation, operation, testing, and maintenance.",
    "Identify personnel hazards associated with dry chemical discharge, visibility reduction, respiratory exposure, and equipment operation.",
    "Understand inspection, testing, maintenance, and performance verification requirements for dry chemical systems.",
    "Interpret dry chemical fire suppression system drawings, specifications, and engineering documentation.",
    "Identify common design deficiencies, operational challenges, and maintenance issues affecting system reliability.",
    "Apply applicable industry standards, regulations, and recommended practices governing dry chemical fire extinguishing systems.",
    "Support hazard assessments, fire protection studies, and facility safety reviews involving dry chemical suppression systems.",
    "Contribute to safer facility design and operation through the effective application of dry chemical fire extinguishing technologies in hazardous industrial environments."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2:    General Information and Requirements.",
    "Module 3: Powder",
    "Module 4: Dry Chemical and Expellant Gas Supply",
    "Module 5: General Design Principles",
    "Module 6: Types of Systems",
    "Module 7: Total Flooding Systems",
    "Module 8: Local Application Systems",
    "Module 9: Monitor and Hose Reel Systems",
    "Module 10: Alarms and Indicators",
    "Module 11: Safety Precautions"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 126,
  "title": "Foam Generating and Proportioning Systems",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 8 (Foam Generating and Proportioning Systems) provides a comprehensive understanding of foam-based fire protection systems used for the prevention, control, and extinguishment of flammable liquid fires in petroleum, petrochemical, chemical, LNG, NGL, storage terminal, refinery, offshore, and industrial facilities. The course focuses on foam generation principles, foam proportioning technologies, system design methodologies, equipment selection, application techniques, and operational requirements for protecting high-risk hydrocarbon processing and storage installations.",
    "Participants will learn the characteristics and performance of different foam concentrates, foam generation methods, proportioning systems, foam application techniques, and the design of fixed and mobile foam fire protection systems. The course covers subsurface, semi-subsurface, foam monitor, foam spray, medium-expansion, high-expansion, and local application foam systems, as well as foam protection for storage tanks, LNG and NGL facilities, pressure storage vessels, dike areas, and process equipment.",
    "Special emphasis is placed on foam quality, environmental considerations, water supply requirements, automatic system operation, fire detection integration, dynamic extinguishment strategies, and practical engineering calculations used to determine foam concentrate requirements. Through practical examples, engineering applications, and industry case studies, participants will gain the knowledge required to evaluate, design, operate, inspect, and maintain foam fire protection systems while ensuring compliance with industry standards and fire protection requirements."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Foam%20Generating%20and%20Proportioning%20Systems%20(HAVPC%20Stage%208).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of fire science, fire behavior, and industrial fire protection systems.",
    "Familiarity with petroleum, petrochemical, LNG, NGL, storage terminal, and industrial process facilities.",
    "Basic knowledge of hydraulics, fluid flow, storage tank operations, and fire suppression technologies is beneficial.",
    "Suitable for fire protection engineers, process engineers, mechanical engineers, HSE professionals, operations personnel, maintenance technicians, project engineers, terminal operators, facility managers, and emergency response personnel."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of foam fire protection systems in controlling and extinguishing flammable liquid fires.",
    "Explain the principles of foam generation, foam expansion, and foam fire suppression mechanisms.",
    "Differentiate between various foam types and their applications for hydrocarbon and polar solvent fires.",
    "Understand the characteristics, composition, and performance of foam concentrates.",
    "Apply engineering principles used in the design of foam generating and proportioning systems.",
    "Evaluate foam system requirements for petroleum, petrochemical, LNG, NGL, and industrial facilities.",
    "Understand the design and operation of subsurface foam injection systems for storage tanks.",
    "Evaluate semi-subsurface foam systems and their appropriate applications.",
    "Assess foam protection requirements for pressure storage facilities containing C4 and lighter hydrocarbons.",
    "Understand foam protection strategies for LNG and NGL atmospheric refrigerated storage tanks.",
    "Evaluate the design and application of foam monitors and foam handline systems.",
    "Understand foam concentrate properties and foam solution preparation requirements.",
    "Assess foam quality characteristics and their impact on extinguishment effectiveness.",
    "Apply foam testing and performance verification procedures.",
    "Design and evaluate foam protection systems for dike areas and containment facilities.",
    "Determine water supply requirements for foam fire protection systems.",
    "Evaluate firewater pumps and foam system pumping requirements.",
    "Understand foam concentrate storage requirements and inventory management practices.",
    "Assess the design, operation, and maintenance of foam concentrate pumps.",
    "Understand hydrant systems and their integration with foam firefighting operations.",
    "Evaluate foam concentrate facilities, storage arrangements, and distribution systems.",
    "Understand the operation and design requirements of automatically operated foam systems.",
    "Evaluate the integration of foam systems with fire detection and alarm equipment.",
    "Understand the principles and applications of foam spray systems.",
    "Differentiate between low-, medium-, and high-expansion foam systems and their applications.",
    "Evaluate medium- and high-expansion foam systems for enclosed spaces and special hazards.",
    "Understand local application foam systems used for process equipment protection.",
    "Identify personnel and operational safety hazards associated with foam system deployment.",
    "Apply safe operating procedures during foam system testing, maintenance, and emergency response operations.",
    "Understand the use and application of wetting agents in fire protection systems.",
    "Evaluate environmental impacts associated with foam usage and disposal.",
    "Apply methods for reducing soil and environmental contamination resulting from foam application.",
    "Understand dynamic extinguishing strategies used in large-scale hydrocarbon fire incidents.",
    "Develop foam deployment strategies for storage terminals, tank farms, process units, and loading facilities.",
    "Perform calculations to determine foam concentrate requirements for depots, terminals, and industrial facilities.",
    "Interpret foam system drawings, specifications, hydraulic calculations, and engineering documentation.",
    "Identify common design deficiencies, operational issues, and maintenance challenges affecting foam system performance.",
    "Apply applicable industry standards, regulations, and recommended practices governing foam fire protection systems.",
    "Support fire protection studies, hazard assessments, emergency response planning, and facility safety reviews involving foam systems.",
    "Contribute to safer facility design and operation through the effective application of foam generating and proportioning technologies."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Foams",
    "Module 3: System Design",
    "Module 4: Subsurface Foam Systems",
    "Module 5: Semi subsurface Systems",
    "Module 6: Pressure Storage of C4 and Lighter Hydrocarbons",
    "Module 7: LNG and NGL Atmospheric Refrigerated Storage Tanks",
    "Module 8:  Foam Monitors and Handlines",
    "Module 9: Foam Concentrate and Solution",
    "Module 10: Foam Quality",
    "Module 11: Dike Area Protection",
    "Module 12: Water Supplies and Pumps",
    "Module 13:   Storage",
    "Module 14: Foam Concentrate Pumps",
    "Module 15: Hydrants",
    "Module 16: Foam Concentrate Facilities",
    "Module 17: Automatically Operated Systems",
    "Module 18: Detection and Alarm Equipment",
    "Module 19: Foam Spray Systems",
    "Module 20:   Medium- and High-Expansion Foam Systems",
    "Module 21: Local Application Systems",
    "Module 22:   Safety Hazards",
    "Module 23: Wetting Agents",
    "Module 24: Reduction of Soil Pollution by Reducing Foam Exploitation",
    "Module 25: The Dynamic Extinguishing Strategy",
    "Module 26: Sample Calculation of Foam Compound Requirement for a Depot/Terminal"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 127,
  "title": "Fire-Fighting and Fire Protection Facilities",
  "date": "Present",
  "description": [
    "Hazardous Area Classification in Petroleum and Chemical Plants – Stage 9 (Fire-Fighting and Fire Protection Facilities) provides a comprehensive understanding of the design, operation, maintenance, and management of fire-fighting and fire protection systems used in petroleum, petrochemical, chemical, LNG, offshore, onshore, storage terminal, and industrial facilities. The course focuses on the integration of active and passive fire protection measures that safeguard personnel, equipment, assets, and the environment from fire and explosion hazards.",
    "Participants will learn the principles of fire prevention, fire-fighting system design, firewater distribution networks, water monitors, deluge systems, sprinkler systems, fire detection and alarm systems, extinguishing systems, and emergency response infrastructure. The course also covers offshore and onshore fire protection requirements, firewater storage and supply systems, gas cylinder storage safety, firewater demand calculations, inspection programs, and testing requirements.",
    "Special emphasis is placed on the engineering principles used to design fire protection facilities, determine firewater requirements, evaluate firefighting capabilities, and ensure compliance with industry standards and regulatory requirements. Through practical examples, engineering calculations, and industry case studies, participants will develop the knowledge required to assess, design, operate, inspect, and maintain fire protection systems in hazardous industrial environments."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Fire-Fighting%20and%20Fire%20Protection%20Facilities%20(HAVPC%20Stage%209).png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of fire science, fire behavior, hazardous area classification, and industrial fire protection principles.",
    "Familiarity with petroleum, petrochemical, LNG, offshore, onshore, and industrial process facilities.",
    "Basic knowledge of fluid flow, pumps, piping systems, and utility services is beneficial.",
    "Suitable for fire protection engineers, process engineers, mechanical engineers, piping engineers, HSE professionals, operations personnel, maintenance technicians, project engineers, emergency response personnel, facility managers, and safety specialists."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of fire-fighting and fire protection facilities in industrial risk management and emergency response.",
    "Explain the principles of fire prevention and fire protection in petroleum, petrochemical, LNG, offshore, and onshore facilities.",
    "Identify common fire hazards and fire prevention practices applicable to offshore installations.",
    "Evaluate fire protection requirements for offshore production, processing, and storage facilities.",
    "Understand the types, applications, and limitations of fire-fighting equipment used in industrial facilities.",
    "Select appropriate fire-fighting equipment based on fire hazard characteristics and operational requirements.",
    "Explain the design, operation, and application of fixed and mobile water monitors.",
    "Evaluate water monitor coverage, performance requirements, and deployment strategies for offshore and onshore facilities.",
    "Understand the function and operation of water deluge pumps and firewater distribution mains.",
    "Evaluate the design and performance requirements of water deluge systems.",
    "Understand the operation and application of automatic sprinkler systems for facility protection.",
    "Explain the integration of fire detection, fire alarm, and suppression systems.",
    "Evaluate pressure water-spraying systems used for cooling, exposure protection, and fire control.",
    "Understand the various types of fire-extinguishing systems and their applications within industrial facilities.",
    "Assess the storage requirements and safety considerations for compressed gas cylinders.",
    "Understand fire protection requirements for onshore processing plants, terminals, storage facilities, and utility systems.",
    "Evaluate water supply requirements for industrial fire protection systems.",
    "Determine the basis of design for fire-fighting water systems.",
    "Understand firewater demand calculations and hydraulic design considerations.",
    "Evaluate firewater distribution networks, piping systems, hydrants, monitors, and associated equipment.",
    "Assess the design, operation, and maintenance requirements of fire protection water tanks.",
    "Determine firewater storage capacity requirements for different facility types.",
    "Perform sample calculations for firewater flow rates required for storage tank fire protection.",
    "Understand emergency response requirements associated with large-scale hydrocarbon fire incidents.",
    "Interpret fire protection system drawings, hydraulic calculations, specifications, and engineering documentation.",
    "Evaluate the interaction between active and passive fire protection systems.",
    "Understand inspection, testing, and maintenance requirements for fire protection systems.",
    "Develop inspection and testing programs to ensure system reliability and operational readiness.",
    "Identify common fire protection system deficiencies and recommend corrective actions.",
    "Apply industry standards, regulations, and recommended practices governing fire-fighting and fire protection facilities.",
    "Support fire risk assessments, hazard studies, emergency response planning, and facility safety reviews.",
    "Contribute to the design and operation of safer industrial facilities through effective fire protection engineering practices.",
    "Improve facility resilience, emergency preparedness, and regulatory compliance through proper management of fire-fighting and fire protection systems."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2:    Fire Prevention Practices in Offshore Facilities",
    "Module 3: Fire-Fighting Equipment",
    "Module 4: Water Monitors (Mobile and Fixed Offshore Installations)",
    "Module 5: Water Deluge Pumps and Water Deluge Main",
    "Module 6: Water Deluge Systems",
    "Module 7:   Automatic Sprinkler, Fire Detection, and Fire Alarm",
    "Module 8: Pressure Water-Spraying Systems",
    "Module 9: Fire-Extinguishing Systems",
    "Module 10: Storage of Gas Cylinders",
    "Module 11: Fire Protection for Onshore Installations",
    "Module 12:  Water Supplies",
    "Module 13:   Bases for a Fire-Fighting Water System",
    "Module 14: Water Tanks for Fire Protection",
    "Module 15: Sample Calculation of Fire Water Flow Rate for Storage Tanks",
    "Module 16: Fire Protection System, Inspection, and Testing"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 128,
  "title": "Control and Mitigation of Fires and Explosions on Offshore Production Installations",
  "date": "Present",
  "description": [
    "Control and Mitigation of Fires and Explosions on Offshore Production Installations is the application of engineering, operational, and safety management practices used to prevent, control, and mitigate fire and explosion hazards in offshore facilities. Offshore production installations contain significant inventories of flammable hydrocarbons, making effective fire and explosion protection essential for safeguarding personnel, assets, the environment, and business continuity. Proper implementation of risk assessment, installation layout, emergency shutdown systems, fire and gas detection, fire protection systems, and explosion mitigation measures helps reduce the likelihood and consequences of major accident events. Failure to effectively manage these hazards can result in catastrophic incidents, loss of life, environmental damage, and substantial financial losses.",
    "The Control and Mitigation of Fires and Explosions on Offshore Production Installations course is designed for engineers, safety professionals, supervisors, operations personnel, and asset integrity specialists involved in offshore oil and gas facilities. This course provides a detailed understanding of fire and explosion hazards, risk management methodologies, emergency shutdown systems, ignition control strategies, spill prevention measures, emergency power systems, fire and gas detection technologies, and fire and explosion protection systems. Participants will learn industry best practices used to evaluate hazards, implement protective measures, and enhance the safety and resilience of offshore production installations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Control%20and%20Mitigation%20of%20Fires%20and%20Explosions%20on%20Offshore%20Production%20Installations.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "6 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Process Safety and Fire Protection Principles.",
    "Familiarity with Offshore Oil and Gas Operations.",
    "Basic Understanding of Hazard Identification and Risk Management.",
    "Engineering and Safety Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of fire and explosion control on offshore production installations.",
    "Learn the applicable standards, normative references, and industry guidelines governing offshore fire and explosion safety.",
    "Understand important terms, definitions, abbreviations, and concepts associated with offshore fire and explosion protection.",
    "Learn the principles of fire and explosion hazard evaluation and risk management in offshore facilities.",
    "Understand how installation layout influences fire and explosion risk and contributes to effective hazard mitigation.",
    "Learn the functions and operational requirements of emergency shutdown and blowdown systems in reducing escalation risks.",
    "Understand methods for controlling ignition sources and preventing the initiation of fires and explosions.",
    "Learn strategies for controlling hydrocarbon spills and minimizing their impact on offshore operations.",
    "Understand the role and importance of emergency power systems in maintaining critical safety functions during emergencies.",
    "Learn the principles, applications, and performance requirements of fire and gas detection systems used on offshore installations.",
    "Understand active and passive fire protection systems and their role in protecting personnel, equipment, and structures.",
    "Learn explosion mitigation and protection measures used to reduce the consequences of explosion events and improve offshore facility safety."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative references",
    "Module 3: Terms and definitions",
    "Module 4: Abbreviated terms",
    "Module 5: Fire and Explosion evaluation and risk management",
    "Module 6: Installation Layout",
    "Module 7: Emergency shutdown systems and blowdown",
    "Module 8: Control of ignition",
    "Module 9: Control of Spills",
    "Module 10: Emergency power systems",
    "Module 11: Fire and gas (F&G) detection systems",
    "Module 12: Active fire protection",
    "Module 13: Passive fire protection",
    "Module 14: Explosion mitigation and protection measures",
    "Module 15: Response to fires and explosions",
    "Module 16: Inspection, testing, and maintenance"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $280",
  "certification": "Certificate of Completion"
},

{
  "id": 129,
  "title": "Fatigue Risk Management Systems for Personnel in Refinery and Petrochemical Industries",
  "date": "Present",
  "description": [
    "Fatigue Risk Management Systems for Personnel in Refinery and Petrochemical Industries is the application of systematic processes, operational controls, and safety management practices to identify, assess, and mitigate fatigue related risks in industrial work environments. Fatigue can significantly affect personnel performance, decision making, reaction time, and situational awareness, increasing the likelihood of accidents, operational errors, and safety incidents within refinery and petrochemical facilities. Proper implementation of a comprehensive Fatigue Risk Management System helps improve personnel wellbeing, operational reliability, workplace safety, and regulatory compliance.",
    "The Fatigue Risk Management Systems for Personnel in Refinery and Petrochemical Industries course is designed for engineers, supervisors, safety professionals, managers, and personnel involved in operations and workforce management within refinery and petrochemical facilities. This course provides a detailed understanding of fatigue related hazards, applicable standards, system requirements, and the components of an effective Fatigue Risk Management System. Participants will learn about fatigue risk assessment, monitoring strategies, reporting systems, work scheduling considerations, operational controls, and continuous improvement processes used to manage fatigue related risks in industrial environments. The course also covers practical industry approaches and best practices aimed at improving safety performance and reducing fatigue related incidents."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Fatigue%20Risk%20Management%20Systems%20for%20Personnel%20in%20Refinery%20and%20Petrochemical%20Industries.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Occupational Health and Safety Principles.",
    "Familiarity with Refinery or Petrochemical Industry Operations.",
    "Basic Understanding of Workplace Risk Management Practices.",
    "Operational and Safety Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of fatigue risk management systems within refinery and petrochemical industries.",
    "Understand important terms and definitions associated with fatigue management and occupational safety.",
    "Learn the principles and components of a comprehensive Fatigue Risk Management System.",
    "Understand the causes and effects of fatigue on personnel performance, decision making, and operational safety.",
    "Learn how to identify, assess, and evaluate fatigue related risks in industrial work environments.",
    "Understand the role of work schedules, shift patterns, workload, and operational demands in fatigue management.",
    "Learn the importance of reporting systems, monitoring processes, and incident investigations related to fatigue risks.",
    "Understand the responsibilities of management, supervisors, and personnel in implementing effective fatigue risk management practices.",
    "Learn mitigation measures and operational controls used to minimize fatigue related hazards and incidents.",
    "Analyze practical case studies and industry examples to understand the application of fatigue risk management principles in refinery and petrochemical operations."
  ],
  "outline": [
    "Module 1:   Scope",
    "Module 2:   Normative Reference",
    "Module 3:   Terms and Definitions",
    "Module 4:   Components of a comprehensive fatigue risk management system (FRMS)"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 130,
  "title": "Guidelines For Engineering Design for Process Safety",
  "date": "Present",
  "description": [
    "Guidelines for Engineering Design for Process Safety is the application of engineering principles, risk management methodologies, and safety focused design practices to identify, evaluate, and control hazards throughout the lifecycle of industrial process facilities. Effective process safety design integrates hazard identification, physical property evaluation, thermal stability assessment, risk analysis techniques, equipment design requirements, and independent protection layers to prevent incidents and mitigate their consequences. Proper incorporation of process safety considerations during the design phase helps protect personnel, assets, the environment, and business operations while ensuring regulatory compliance and operational reliability.",
    "The Guidelines for Engineering Design for Process Safety course is designed for process engineers, design engineers, safety professionals, project personnel, operations staff, and asset integrity specialists involved in the development and management of industrial facilities. This course provides a detailed understanding of process safety concepts, hazard evaluation methods, physical and thermal property considerations, engineering design practices, equipment safety requirements, protection layers, and safety documentation. Participants will learn how to integrate process safety into engineering design decisions, evaluate potential hazards, apply risk reduction measures, and develop documentation that supports safe and reliable plant operations throughout the facility lifecycle."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Guidelines%20For%20Engineering%20Design%20for%20Process%20Safety.png",
  "tags": [],
  "category": "hazop hazid",
  "duration": "10 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Process Engineering and Industrial Operations.",
    "Familiarity with Process Safety Management Principles.",
    "Basic Understanding of Chemical Process Equipment and Systems.",
    "Engineering and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles, objectives, and importance of engineering design for process safety.",
    "Learn the foundational concepts and methodologies used in process safety engineering.",
    "Understand the role of physical properties and thermal stability data in identifying and managing process hazards.",
    "Learn how to evaluate process hazards using recognized risk assessment and analysis techniques.",
    "Understand the application of hazard identification and risk evaluation methods during engineering design activities.",
    "Learn general process design practices that contribute to inherently safer and more reliable operations.",
    "Understand equipment design considerations required to minimize process safety risks and improve system integrity.",
    "Learn the purpose and application of independent protection layers in reducing the likelihood and consequences of hazardous events.",
    "Understand the principles of layered protection and risk reduction strategies used in process industries.",
    "Understand documentation requirements necessary to support process safety management and regulatory compliance."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Foundational concept.",
    "Module 3: Basic physical properties/thermal stability data",
    "Module 4: Analysis Techniques",
    "Module 5: General design",
    "Module 6: Equipment design",
    "Module 7: Protection Layers",
    "Module 8: Documentation to support process safety"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $280",
  "certification": "Certificate of Completion"
},

{
  "id": 131,
  "title": "Above Ground Bulk Storage Tank Emergencies",
  "date": "Present",
  "description": [
    "Above Ground Bulk Storage Tank Emergencies is the application of emergency response, fire protection, and incident management principles to safely manage incidents involving above ground bulk storage tanks. Storage tank emergencies may include fires, explosions, product releases, structural failures, overfills, and other incidents that pose significant risks to personnel, assets, surrounding communities, and the environment. Effective emergency preparedness and response require a thorough understanding of tank design, fire protection systems, firefighting resources, incident command structures, and tactical response strategies. Failure to adequately prepare for and respond to storage tank emergencies can result in catastrophic consequences, including loss of life, environmental damage, and major financial losses.",
    "The Above Ground Bulk Storage Tank Emergencies course is designed for engineers, emergency response personnel, firefighters, operations personnel, supervisors, and safety professionals involved in the management and protection of bulk liquid storage facilities. This course provides a detailed understanding of storage tank emergency scenarios, applicable standards and regulations, tank construction features, incident management principles, firefighting foam systems, water supply requirements, and tactical response procedures. Participants will learn industry best practices for emergency preparedness, hazard assessment, fire protection planning, and emergency response coordination aimed at improving safety and minimizing the impact of storage tank incidents."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Above%20Ground%20Bulk%20Storage%20Tank%20Emergencies.png",
  "tags": [],
  "category": "petroleum",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Fire Safety and Emergency Response Principles.",
    "Familiarity with Oil and Gas Storage Facilities.",
    "Basic Understanding of Storage Tank Operations.",
    "Engineering and Safety Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the nature, causes, and consequences of emergencies involving above ground bulk storage tanks.",
    "Learn the applicable standards, codes, regulations, and industry guidelines governing storage tank emergency response.",
    "Understand storage tank designs, construction features, and their impact on emergency response strategies.",
    "Learn how to identify hazards and evaluate risks associated with storage tank incidents.",
    "Understand incident management principles and response considerations applicable to storage tank emergencies.",
    "Learn the functions, applications, and limitations of firefighting foam systems used in storage tank fire protection.",
    "Understand water supply requirements and fire protection systems necessary for effective emergency response.",
    "Learn how to assess emergency situations and select appropriate response strategies based on incident conditions.",
    "Understand tactical response guidelines for managing tank fires, product releases, and related emergencies.",
    "Learn the importance of coordination between emergency responders, facility personnel, and external agencies during incident response.",
    "Understand emergency preparedness, response planning, and resource management practices for storage tank facilities.",
    "Analyze practical case studies and industry incidents to understand the application of emergency response principles and tactical decision making during above ground bulk storage tank emergencies."
  ],
  "outline": [
    "Module 1: Introduction and overview",
    "Module 2: Standards, Codes, and Regulations",
    "Module 3: Tank designs and Constructions Features",
    "Module 4: Incident Management and response considerations",
    "Module 5: Firefighting Foam, water supply and fire protection requirements",
    "Module 6: Tactical Response Guidelines"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 132,
  "title": "Annular Casing Pressure Management For Offshore",
  "date": "Present",
  "description": [
    "Annular Casing Pressure Management for Offshore Wells is the application of engineering, monitoring, and risk management practices used to identify, evaluate, and control annular casing pressure in offshore oil and gas wells. Annular casing pressure can arise from various operational and reservoir related conditions and may affect well integrity, operational safety, environmental protection, and regulatory compliance if not properly managed. Offshore wells present additional challenges due to their complex well architectures, remote operating environments, subsea systems, and limited intervention opportunities. Effective annular casing pressure management requires continuous monitoring, evaluation, documentation, and risk based decision making to maintain well integrity and ensure safe offshore operations.",
    "The Annular Casing Pressure Management for Offshore Wells course is designed for engineers, well integrity specialists, offshore operations personnel, supervisors, and professionals involved in the management and operation of offshore wells. This course provides a detailed understanding of annular casing pressure sources, pressure types, offshore well system considerations, monitoring techniques, evaluation methods, operating limits, and risk management practices. Participants will learn about pressure management processes, diagnostic thresholds, pressure evaluation techniques, documentation requirements, and industry best practices used to maintain well integrity throughout the offshore well lifecycle. The course also covers practical engineering considerations aimed at minimizing integrity risks and ensuring safe and reliable offshore well operations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Annular%20Casing%20Pressure%20Management%20For%20Offshore.png",
  "tags": [],
  "category": "petroleum",
  "duration": "6 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Well Integrity and Pressure Management Principles.",
    "Familiarity with Offshore Well Operations.",
    "Basic Understanding of Wellhead, Casing, and Subsea Systems.",
    "Engineering and Operational Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of annular casing pressure management for offshore wells.",
    "Learn the applicable standards, normative references, and industry guidelines associated with annular casing pressure management.",
    "Understand important terms, definitions, and concepts related to annular casing pressure and offshore well integrity",
    "Learn the various sources and types of annular casing pressure encountered in offshore wells.",
    "Understand offshore well system components and the operational considerations that influence annular casing pressure management.",
    "Learn the annular casing pressure management process and its role in maintaining offshore well integrity throughout the well lifecycle.",
    "Understand the determination and application of maximum allowable wellhead operating pressure limits for offshore wells.",
    "Learn the purpose and use of upper and lower diagnostic thresholds in pressure monitoring and integrity assessment.",
    "Understand the methods, frequency, and best practices for monitoring annular casing pressure in offshore operations.",
    "Learn how to perform and interpret annular casing pressure evaluations to assess well integrity conditions and operational risks.",
    "Understand documentation requirements and record management practices associated with annular casing pressure monitoring and evaluation activities.",
    "Learn risk management considerations and mitigation strategies used to address annular casing pressure issues and maintain safe and reliable offshore well operations."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative references",
    "Module 3: Terms and definitions",
    "Module 4: Sources and types of annular casing pressure",
    "Module 5: Offshore well system overview and operation considerations",
    "Module 6: Annular casing pressure management process",
    "Module 7: Maximum allowable wellhead Operating pressure",
    "Module 8: Upper and Lower diagnostic thresholds",
    "Module 9: Methods and frequency of monitoring annular casing pressure",
    "Module 10: Annular casing pressure evaluation",
    "Module 11: Documentation",
    "Module 12: Risk Management considerations"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $220",
  "certification": "Certificate of Completion"
},

{
  "id": 133,
  "title": "Annular Casing Pressure Management For Onshore",
  "date": "Present",
  "description": [
    "Annular Casing Pressure Management for Onshore Wells is the application of engineering, monitoring, and risk management practices used to identify, evaluate, and control annular casing pressure in onshore oil and gas wells. Annular casing pressure can result from a variety of sources and, if not properly managed, may compromise well integrity, operational safety, environmental protection, and regulatory compliance. Effective pressure management requires a systematic approach involving pressure monitoring, diagnostic evaluation, risk assessment, documentation, and corrective actions to ensure the continued integrity of well barrier systems throughout the life of the well.",
    "The Annular Casing Pressure Management for Onshore Wells course is designed for engineers, well integrity specialists, production personnel, supervisors, and professionals involved in the operation and management of onshore wells. This course provides a detailed understanding of annular casing pressure sources, monitoring requirements, evaluation methods, operational limits, and risk management practices. Participants will learn about well system components, pressure management processes, diagnostic thresholds, evaluation testing procedures, documentation requirements, and industry best practices used to maintain safe and reliable well operations. The course also covers practical engineering considerations aimed at protecting well integrity and minimizing operational risks associated with annular casing pressure."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Annular%20Casing%20Pressure%20Management%20For%20Onshore.png",
  "tags": [],
  "category": "petroleum",
  "duration": "7 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Well Integrity and Pressure Management Principles.",
    "Familiarity with Onshore Well Operations.",
    "Basic Understanding of Wellhead and Casing Systems.",
    "Engineering and Operational Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of annular casing pressure management for onshore wells.",
    "Learn the applicable standards, references, and industry guidelines associated with annular casing pressure management.",
    "Understand important terms, definitions, and concepts related to annular casing pressure and well integrity.",
    "Learn the various sources and causes of annular casing pressure in onshore wells.",
    "Understand the components and operational functions of onshore well systems relevant to annular pressure management.",
    "Learn the annular casing pressure management process and its role in maintaining well integrity.",
    "Understand the determination and application of maximum allowable wellhead operating pressure limits.",
    "Learn the purpose and use of upper and lower diagnostic thresholds in pressure monitoring and evaluation.",
    "Understand the methods, frequency, and best practices for monitoring annular casing pressure.",
    "Understand documentation requirements and record management practices associated with annular casing pressure monitoring and evaluation.",
    "Learn risk management considerations and mitigation strategies used to address annular casing pressure issues and maintain safe well operations."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative references",
    "Module 3: Definitions",
    "Module 4: Sources of annual casing pressures",
    "Module 5: Onshore Well system overview",
    "Module 6: Annular casing pressure management",
    "Module 7: Maximum allowable wellhead operating pressure",
    "Module 8: Upper and lower diagnostic thresholds",
    "Module 9: Methods and frequency of monitoring annular casing pressure",
    "Module 10: Methods and frequency of monitoring annular casing pressure test",
    "Module 11: Documentation",
    "Module 12: Risk management considerations"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $220",
  "certification": "Certificate of Completion"
},

{
  "id": 134,
  "title": "Drilling and Well Servicing Operations Involving Hydrogen Sulfide",
  "date": "Present",
  "description": [
    "Drilling and Well Servicing Operations Involving Hydrogen Sulfide is the application of safety, engineering, and operational practices required to protect personnel, equipment, and the environment from the hazards associated with hydrogen sulfide (H₂S) during drilling and well servicing activities. Hydrogen sulfide is a highly toxic, flammable, and corrosive gas that presents significant risks to personnel safety and operational integrity. Effective management of H₂S hazards requires proper training, monitoring systems, protective equipment, emergency preparedness, wellsite safety controls, and adherence to industry standards. Failure to adequately manage hydrogen sulfide risks can result in serious injuries, fatalities, equipment damage, environmental incidents, and operational disruptions.",
    "The Drilling and Well Servicing Operations Involving Hydrogen Sulfide course is designed for engineers, drilling personnel, supervisors, safety professionals, well servicing crews, and personnel involved in operations where hydrogen sulfide may be encountered. This course provides a detailed understanding of standards, personnel training requirements, detection equipment, personal protective equipment, emergency response planning, hazardous area classification, wellsite safety practices, and operational requirements associated with H₂S environments. Participants will learn industry best practices for hazard recognition, risk mitigation, emergency preparedness, and safe operational procedures required to work effectively in hydrogen sulfide environments."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Drilling%20and%20Well%20Servicing%20Operations%20Involving%20Hydrogen%20Sulfide.png",
  "tags": [],
  "category": "petroleum",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Drilling and Well Servicing Operations.",
    "Familiarity with Oil and Gas Wellsite Activities.",
    "Basic Understanding of Process Safety and Hazard Management.",
    "Engineering and Operational Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the scope and application of safety requirements for drilling and well servicing operations involving hydrogen sulfide.",
    "Learn the applicable standards, codes, and industry guidelines governing H₂S operations.",
    "Understand important acronyms, abbreviations, and terminology associated with hydrogen sulfide safety and wellsite operations.",
    "Learn the applicability requirements and operational considerations for activities involving hydrogen sulfide.",
    "Understand personnel training requirements and competency expectations necessary for working safely in H₂S environments.",
    "Learn the selection, use, and maintenance requirements of hydrogen sulfide detection equipment and personal protective equipment.",
    "Understand contingency planning principles and emergency response procedures for hydrogen sulfide incidents and releases.",
    "Learn the classification of hazardous locations and the associated safety requirements applicable to H₂S operations.",
    "Understand the requirements for well materials and equipment used in hydrogen sulfide service environments.",
    "Learn wellsite safety practices and hazard control measures used to protect personnel during drilling and well servicing activities.",
    "Understand special operational considerations and challenges associated with drilling and servicing wells containing hydrogen sulfide.",
    "Analyze practical case studies and industry examples to understand the application of safe operating practices in hydrogen sulfide environments."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Standards",
    "Module 3: Acronyms and abbreviated definitions",
    "Module 4: Applicability",
    "Module 5: Personnel Training",
    "Module 6: Detection equipment and personal protection equipment(PPE)",
    "Module 7: Contingency planning, including emergency procedures",
    "Module 8: Classification of locations",
    "Module 9: Well materials and equipment",
    "Module 10: Wellsite safety",
    "Module 11: Special Operations"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 135,
  "title": "Fireproofing Practices in Petroleum and Petrochemical Processing plants",
  "date": "Present",
  "description": [
    "Fireproofing Practices in Petroleum and Petrochemical Processing Plants is the application of engineering, material selection, installation, and maintenance practices used to protect critical equipment and structural components from the effects of fire exposure in industrial facilities. Effective fireproofing helps maintain structural integrity, reduce escalation risks, protect personnel, and provide sufficient time for emergency response and safe shutdown during fire incidents. Proper fireproofing design and implementation are essential for minimizing the consequences of hydrocarbon fires and maintaining operational safety in petroleum and petrochemical processing plants. Inadequate fireproofing can result in structural failure, equipment damage, process escalation, and significant safety and environmental risks.",
    "The Fireproofing Practices in Petroleum and Petrochemical Processing Plants course is designed for engineers, inspectors, maintenance personnel, safety professionals, supervisors, and professionals involved in plant design, construction, operations, and asset integrity management. This course provides a detailed understanding of fireproofing principles, fire scenario considerations, fireproofing materials, testing requirements, installation practices, quality assurance procedures, and inspection and maintenance activities. Participants will learn industry best practices used to evaluate fire hazards, select appropriate fireproofing systems, ensure installation quality, and maintain long term fire protection performance in industrial facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Fireproofing%20Practices%20in%20Petroleum%20and%20Petrochemical%20Processing%20plants.png",
  "tags": [],
  "category": "petroleum",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Fire Protection and Process Safety Principles.",
    "Familiarity with Petroleum and Petrochemical Plant Operations.",
    "Basic Understanding of Industrial Equipment and Structural Systems.",
    "Engineering and Safety Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of fireproofing practices in petroleum and petrochemical processing plants.",
    "Learn the applicable standards, normative references, and industry guidelines associated with industrial fireproofing systems.",
    "Understand important terms, definitions, and concepts related to fireproofing and fire protection engineering.",
    "Understand fire scenario envelope considerations and their impact on fireproofing design and application requirements.",
    "Learn the different types, properties, advantages, and limitations of fireproofing materials used in petroleum and petrochemical plants.",
    "Understand testing methods, fire resistance ratings, and performance evaluation requirements for fireproofing materials.",
    "Learn installation requirements, application techniques, and quality assurance practices necessary for effective fireproofing performance.",
    "Understand inspection and maintenance practices used to assess fireproofing condition and maintain long term protection effectiveness.",
    "Learn how fireproofing systems contribute to structural integrity, escalation prevention, and emergency response during fire incidents.",
    "Analyze practical case studies and industry examples to understand the application of fireproofing engineering principles in petroleum and petrochemical processing facilities."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative reference",
    "Module 3: Terms and definitions",
    "Module 4: General",
    "Module 5: Fire scenario envelope fireproofing considerations",
    "Module 6: Fireproofing materials",
    "Module 7: Testing and Rating fireproofing materials",
    "Module 8: Installation and quality assurance",
    "Module 9: Inspection and Maintenance"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 136,
  "title": "Oil and Gas Producing and Gas Processing Plant Operations Involving Hydrogen Sulfide",
  "date": "Present",
  "description": [
    "Oil and Gas Producing and Gas Processing Plant Operations Involving Hydrogen Sulfide is the application of safety, engineering, and operational practices required to manage the risks associated with hydrogen sulfide (H₂S) during oil and gas production and gas processing activities. Hydrogen sulfide is a highly toxic and corrosive gas that presents significant health, safety, environmental, and operational hazards. Effective management of H₂S risks requires proper personnel training, protective equipment, monitoring systems, emergency preparedness, facility design, and safe operating procedures. Failure to adequately control H₂S hazards can result in serious injuries, fatalities, environmental incidents, equipment damage, and operational disruptions.",
    "The Oil and Gas Producing and Gas Processing Plant Operations Involving Hydrogen Sulfide course is designed for engineers, operators, supervisors, safety professionals, and personnel involved in oil and gas production and gas processing operations. This course provides a detailed understanding of the requirements, practices, and safety measures necessary for working in environments where hydrogen sulfide may be present. Participants will learn about personnel protection, emergency response planning, H₂S monitoring systems, facility design considerations, offshore operations, enclosed space operations, and gas processing plant requirements. The course also covers practical industry practices and operational guidelines aimed at reducing risk and ensuring safe and reliable operations in H₂S environments."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Producing%20and%20Gas%20Processing%20Plant%20Operations%20Involving%20Hydrogen%20Sulfide.png",
  "tags": [],
  "category": "petroleum",
  "duration": "8 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Oil and Gas Production Operations.",
    "Familiarity with Process Safety Principles.",
    "Basic Understanding of Hazardous Gas Risks and Control Measures.",
    "Engineering and Operational Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles and objectives of safety management in oil terminal facilities.",
    "Learn the design and planning considerations required to ensure safe and efficient terminal operations.",
    "Understand the application of industry standards, codes, and regulatory requirements relevant to oil terminals.",
    "Understand the scope and applicability of safety requirements for operations involving hydrogen sulfide.",
    "Learn the relevant references, standards, and industry guidelines applicable to H₂S operations.",
    "Understand important terms, definitions, and concepts associated with hydrogen sulfide hazards and risk management.",
    "Learn the training requirements necessary to ensure personnel competency when working in H₂S environments.",
    "Understand the selection, use, and maintenance requirements of personal protective equipment used for H₂S protection.",
    "Learn contingency planning principles and emergency response procedures for hydrogen sulfide incidents.",
    "L Understand facility design and construction practices used to minimize H₂S related risks.",
    "Learn safe operating practices for oil and gas production and gas processing facilities involving hydrogen sulfide.",
    "Understand the principles and requirements for evaluating and selecting continuous hydrogen sulfide monitoring equipment.",
    "Learn the additional safety considerations and operational requirements associated with offshore operations involving H₂S.",
    "Understand the hazards and control measures associated with operations in enclosed facilities where hydrogen sulfide may be present.",
    "Learn the specific operational requirements and safety practices applicable to gas processing plants handling hydrogen sulfide containing streams."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: References",
    "Module 3: Definitions",
    "Module 4: Sizing Parameters",
    "Module 5: Personnel training",
    "Module 6: Personnel Protective equipment",
    "Module 7: Contingency planning including emergency procedures",
    "Module 8: Design and Construction practices",
    "Module 9: Operating practices",
    "Module 10: Guidelines for evaluation and selection of continuous hydrogen sulfide monitoring equipment",
    "Module 11: Offshore Operation",
    "Module 12: Operations involving enclosed facilities",
    "Module 13: Gas processing plant operations"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 137,
  "title": "Safety Guidelines and Good Industry Practices for Oil terminals",
  "date": "Present",
  "description": [
    "Safety Guidelines and Good Industry Practices for Oil Terminals is the application of engineering, operational, and safety principles to ensure the safe design, construction, operation, maintenance, and decommissioning of oil terminal facilities. Proper implementation of safety guidelines and industry best practices helps prevent accidents, protect personnel and the environment, maintain asset integrity, and ensure compliance with regulatory and operational requirements. Failure to apply appropriate safety measures can result in operational disruptions, environmental incidents, equipment failures, fire and explosion hazards, and significant financial losses.",
    "The Safety Guidelines and Good Industry Practices for Oil Terminals course is designed for engineers, supervisors, operators, safety professionals, and personnel involved in the planning, construction, operation, and management of oil terminal facilities. This course provides a detailed understanding of the principles, standards, and good industry practices required throughout the lifecycle of oil terminals. Participants will learn about terminal design and planning, procurement processes, construction activities, asset integrity management, operational safety requirements, and closure and decommissioning practices. The course also covers practical approaches and industry best practices aimed at ensuring safe, reliable, efficient, and environmentally responsible oil terminal operations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Safety%20Guidelines%20and%20Good%20Industry%20Practices%20for%20Oil%20terminals.png",
  "tags": [],
  "category": "petroleum",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Process Safety and Engineering Principles.",
    "Familiarity with Oil and Gas Terminal Operations.",
    "Basic Understanding of Industrial Safety Practices.",
    "Engineering and Operational Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the principles and objectives of safety management in oil terminal facilities.",
    "Learn the design and planning considerations required to ensure safe and efficient terminal operations.",
    "Understand the application of industry standards, codes, and regulatory requirements relevant to oil terminals.",
    "Learn the role of procurement processes in ensuring quality, safety, and compliance during project execution.",
    "Understand construction safety requirements and best practices applicable to oil terminal projects.",
    "Learn the principles of asset integrity management and its importance in maintaining safe terminal operations.",
    "Understand operational safety requirements associated with storage, transfer, loading, and unloading activities in oil terminals.",
    "Learn hazard identification and risk management techniques applicable to terminal operations and maintenance activities.",
    "Understand emergency response planning and incident prevention strategies within oil terminal facilities.",
    "Learn environmental protection practices and safe handling procedures associated with petroleum products and terminal operations."
  ],
  "outline": [
    "Module 1: Principles",
    "Module 2: Design and Planning",
    "Module 3: Procurement, construction and Asset integrity management",
    "Module 4: Operations",
    "Module 5: Closure and Decommissioning"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 138,
  "title": "Well Control Equipment Systems for Drilling Wells",
  "date": "Present",
  "description": [
    "Well Control Equipment Systems for Drilling Wells is the application of engineering principles, operational practices, and safety requirements to ensure the safe control of formation pressures during drilling operations. Well control equipment systems are designed to prevent uncontrolled flow of formation fluids, protect personnel and equipment, and maintain safe drilling operations in both land and offshore environments. Proper design, operation, and maintenance of well control equipment are essential for minimizing the risks associated with kicks, blowouts, and other well control incidents. Failure of well control systems can result in major safety hazards, environmental damage, operational downtime, and significant financial losses.",
    "The Well Control Equipment Systems for Drilling Wells course is designed for engineers, drilling personnel, supervisors, inspectors, and professionals involved in drilling operations and well integrity management. This course provides a detailed understanding of the scope, standards, terminology, operational requirements, and equipment systems associated with well control during drilling activities. Participants will learn about surface and subsea Blowout Preventer (BOP) systems, well control equipment requirements, applicable standards, and operational considerations for maintaining safe and reliable drilling operations. The course also covers practical engineering considerations and industry best practices required to ensure effective pressure control and operational safety in drilling environments."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Well%20Control%20Equipment%20Systems%20for%20Drilling%20Wells.png",
  "tags": [],
  "category": "petroleum",
  "duration": "4 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Drilling and Well Control Principles.",
    "Familiarity with Oil and Gas Drilling Operations.",
    "Basic Understanding of Pressure Control Systems.",
    "Engineering and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and application of well control equipment systems used in drilling operations.",
    "Learn the relevant codes, standards, and normative references applicable to well control systems and equipment.",
    "Understand important terms, definitions, and abbreviations associated with drilling well control operations.",
    "Learn the general requirements and operational principles of well control equipment systems.",
    "Understand the functions and components of surface Blowout Preventer systems used in land and offshore drilling operations.",
    "Learn the design, operation, and maintenance requirements for surface BOP systems.",
    "Understand the functions and operational requirements of subsea BOP systems used in offshore drilling environments.",
    "Learn pressure control principles and operational procedures used to maintain safe drilling operations.",
    "Understand the importance of equipment testing, inspection, and maintenance in ensuring reliable well control performance.",
    "Learn the operational and safety considerations associated with well control equipment during drilling activities."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative reference",
    "Module 3: Terms, definitions and abbreviation",
    "Module 4: Well control equipment general requirements",
    "Module 5: Surface BOP systems(land and surface offshore)",
    "Module 6: Subsea BOP systems"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 139,
  "title": "Well Integrity in Drilling and Well Operations",
  "date": "Present",
  "description": [
    "Well Integrity in Drilling and Well Operations is the application of engineering principles, operational practices, and risk management processes to ensure that oil and gas wells remain secure, safe, and environmentally protected throughout their lifecycle. Proper well integrity management helps prevent uncontrolled release of formation fluids, maintain pressure containment, protect personnel and the environment, and ensure reliable well performance during drilling, production, intervention, suspension, and abandonment activities. Failure to maintain well integrity can result in safety incidents, environmental damage, equipment failure, production losses, and significant operational risks.",
    "The Well Integrity in Drilling and Well Operations course is designed for engineers, drilling personnel, well operations professionals, supervisors, and integrity management personnel involved in the planning, execution, monitoring, and maintenance of well operations. This course provides a detailed understanding of well integrity principles, standards, terminology, operational requirements, and barrier management practices applicable to drilling and well operations. Participants will learn about drilling, testing, completion, production, intervention, suspension, abandonment, and pumping operations, as well as well barrier systems and acceptance requirements used to maintain safe and reliable well operations. The course also covers practical engineering considerations and industry best practices aimed at improving operational safety and maintaining effective well integrity throughout the well lifecycle."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Well%20Integrity%20in%20Drilling%20and%20Well%20Operations.png",
  "tags": [],
  "category": "petroleum",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Drilling and Well Operations.",
    "Familiarity with Oil and Gas Production Systems.",
    "Basic Understanding of Well Control and Pressure Management.",
    "Engineering and Operational Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of well integrity management in drilling and well operations.",
    "Learn the applicable normative and informative references related to well integrity and operational safety.",
    "Understand important terms, definitions, and abbreviations associated with well integrity operations.",
    "Learn the general principles and requirements of well integrity management throughout the well lifecycle.",
    "Understand well integrity considerations and barrier requirements during drilling activities.",
    "Learn the operational and integrity requirements associated with well testing and completion activities.",
    "Understand well integrity management practices during production operations and routine well activities.",
    "Learn the integrity considerations associated with sidetracks, well suspension, and abandonment operations.",
    "Understand the operational requirements and integrity risks associated with wireline, coiled tubing, and snubbing operations.",
    "Learn the principles and operational considerations associated with underbalanced drilling and completion operations.",
    "Understand integrity management requirements during pumping operations and pressure related activities.",
    "Learn the purpose and application of well barrier element acceptance tables in maintaining effective well integrity and operational safety."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative and informative reference",
    "Module 3: Terms, Definitions and abbreviations",
    "Module 4: General principles",
    "Module 5: Drilling activities",
    "Module 6: Well testing activities",
    "Module 7: Completion activities",
    "Module 8: Production",
    "Module 9: Sidetracks, suspension and abandonment",
    "Module 10: Wireline operations",
    "Module 11: Coiled tubing operations",
    "Module 12: Snubbing Operations",
    "Module 13:  Under balanced drilling and completion operations",
    "Module 14: Pumping operations",
    "Module 15: Well barrier elements acceptance tables"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 140,
  "title": "Cooling Tower Pumping and Piping",
  "date": "Present",
  "description": [
    "Cooling Tower Pumping and Piping is the application of engineering principles and operational practices used to design, operate, and maintain cooling tower circulation systems, pumps, piping networks, and associated utilities in industrial facilities. Proper cooling tower pumping and piping design ensures efficient water circulation, stable system performance, reliable heat rejection, reduced energy consumption, and safe equipment operation. Inadequate pumping and piping practices can result in cavitation, poor flow distribution, excessive energy usage, freezing issues, pump failures, operational instability, and reduced cooling system efficiency.",
    "The Cooling Tower Pumping and Piping course is designed for engineers, operators, maintenance personnel, and professionals involved in the design, operation, and maintenance of cooling water systems and utility facilities. This course provides a detailed understanding of cooling tower pumping systems, pump performance, piping arrangements, filtration systems, freeze protection, head pressure control, makeup water systems, and blowdown arrangements. Participants will learn about pump curve maintenance, Net Positive Suction Head (NPSH), cavitation, bypass systems, multiple load management, equalization lines, and pumping best practices used to maintain efficient and reliable cooling tower operation. The course also covers practical engineering considerations and industry guidelines required to improve system performance, reliability, and operational safety."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Cooling%20Tower%20Pumping%20and%20Piping.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Fluid Flow and Pumping Principles.",
    "Familiarity with Cooling Water Systems and Industrial Utilities.",
    "Basic Understanding of Pumps, Piping, and Heat Transfer Systems.",
    "Engineering and Process Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles and operational requirements of cooling tower pumping and piping systems.",
    "Learn the functions and operational characteristics of cooling tower pumps and associated piping networks.",
    "Understand pump curves, pump performance monitoring, and maintenance requirements for reliable system operation.",
    "Learn the principles of Net Positive Suction Head and cavitation and their impact on pump performance and equipment reliability.",
    "Understand the design and operational considerations of pump suction lines and tower pumping arrangements.",
    "Learn how to predict pump operating points and evaluate system performance under varying operating conditions.",
    "Understand the functions and operational benefits of tower bypass systems in cooling tower applications.",
    "Learn cooling tower filtration methods and their importance in maintaining water quality and system efficiency.",
    "Understand freeze protection methods and free cooling applications used in cooling tower operations.",
    "Learn the operational principles of wet well sumps, vertical turbine pumps, and multiple load management systems.",
    "Understand head pressure control, closed circuit cooling tower systems, and cooling tower makeup water requirements.",
    "Learn industry guidelines, pumping best practices, equalization line requirements, and blowdown arrangements used to maintain safe and efficient cooling tower operation."
  ],
  "outline": [
    "Module 1: Legend",
    "Module 2: Tower Pumping",
    "Module 3: Pump Curve Maintenance",
    "Module 4: NPSH; Cavitation",
    "Module 5: The Tower pump and its suction line",
    "Module 6: Predicting pump operation points",
    "Module 7: Tower Bypass",
    "Module 8: Cooling tower filtration",
    "Module 9: Cooling tower freeze protection",
    "Module 10: Free cooling with cooling towers",
    "Module 11: Well-well sump (vertical turbine pumps)",
    "Module 12: Multiple Loads",
    "Module 13:  Head Pressure control",
    "Module 14: Closed circuit cooling towers",
    "Module 15: Pumping practices",
    "Module 16: Cooling tower makeup water",
    "Module 17: Cooling tower guidelines",
    "Module 18 Equalization lines",
    "Module 19: Blowdown arrangements"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $200",
  "certification": "Certificate of Completion"
},

{
  "id": 141,
  "title": "Elements of a Risk-Based Inspection Program",
  "date": "Present",
  "description": [
    "Elements of a Risk-Based Inspection Program is the application of risk assessment methodologies, inspection planning techniques, and integrity management practices used to optimize inspection activities and improve the reliability of industrial equipment and facilities. Risk-Based Inspection (RBI) programs evaluate the probability and consequences of equipment failure in order to prioritize inspection resources, manage operational risks, and maintain asset integrity. Effective implementation of RBI helps improve safety, reduce unplanned shutdowns, optimize maintenance costs, and support regulatory compliance. Inadequate inspection planning and risk management can result in equipment failures, operational disruptions, environmental incidents, and increased safety risks.",
    "The Elements of a Risk-Based Inspection Program course is designed for engineers, inspectors, maintenance personnel, reliability professionals, supervisors, and integrity management specialists involved in industrial operations and asset management. This course provides a detailed understanding of RBI principles, risk assessment concepts, damage mechanism evaluation, probability and consequence analysis, inspection planning, and risk management strategies. Participants will learn about data collection, failure assessment methodologies, inspection optimization, documentation practices, and updating RBI assessments to support safe and reliable operation of industrial facilities. The course also covers practical engineering considerations and industry best practices required for the successful implementation and management of Risk-Based Inspection programs."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Elements%20of%20a%20Risk-Based%20Inspection%20Program.png",
  "tags": [],
  "category": "mechanical",
  "duration": "7 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Inspection and Integrity Management Principles.",
    "Familiarity with Industrial Process Equipment and Operations.",
    "Basic Understanding of Risk Assessment and Damage Mechanisms.",
    "Engineering and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of Risk-Based Inspection programs in industrial facilities.",
    "Learn the applicable standards, normative references, and industry guidelines associated with RBI implementation.",
    "Understand important terms, definitions, acronyms, and abbreviations related to Risk-Based Inspection and integrity management.",
    "Learn the principles and concepts of risk assessment used in RBI methodologies.",
    "Understand the purpose, benefits, and implementation requirements of Risk-Based Inspection programs.",
    "Learn how to plan and develop an effective RBI program for industrial equipment and systems.",
    "Understand the roles, responsibilities, training requirements, and qualification needs associated with RBI implementation.",
    "Learn data collection and information management practices required for performing RBI assessments.",
    "Understand damage mechanisms affecting industrial equipment and their impact on inspection planning and integrity management.",
    "Learn methodologies used to assess probability of failure and consequence of failure during RBI evaluations.",
    "Understand risk determination, risk assessment management processes, and the integration of inspection activities into risk management strategies.",
    "Learn documentation, recordkeeping, and RBI updating practices required to maintain an effective and reliable Risk-Based Inspection program."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative references",
    "Module 3: Terms, definitions, acronyms, and abbreviation",
    "Module 4: Risk assessment concept",
    "Module 5: Introduction to risk-based inspection",
    "Module 6: Planning the RBI program",
    "Module 7: Roles, responsibilities, training and qualifications",
    "Module 8: Data and information collection for RBI assessment",
    "Module 9: Damage mechanism review",
    "Module 10: Assessing probability of failure(POF)",
    "Module 11: Assessing consequence of failure(COF)",
    "Module 12: Risk determination assessment and management",
    "Module 13: Risk management with infection activities",
    "Module 14: Other risk management methods",
    "Module 15:  Updating the RBI assessment",
    "Module 16: RBI documentation and recordkeeping"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $220",
  "certification": "Certificate of Completion"
},

{
  "id": 142,
  "title": "Gasket-The different Types of Gaskets Use and Selection",
  "date": "Present",
  "description": [
    "Gasket: The Different Types of Gaskets, Use and Selection is the study and application of gasket technologies used to achieve and maintain leak tight seals in piping systems, pressure vessels, heat exchangers, and other industrial equipment. Proper gasket selection and installation are critical to ensuring safe and reliable operation, preventing product loss, minimizing environmental releases, and maintaining equipment integrity. The effectiveness of a gasketed joint depends on factors such as gasket material, flange design, surface finish, operating conditions, and installation practices. Incorrect gasket selection or installation can lead to leakage, equipment damage, safety incidents, and increased maintenance costs.",
    "The Gasket: The Different Types of Gaskets, Use and Selection course is designed for engineers, maintenance personnel, inspectors, supervisors, and professionals involved in the design, operation, maintenance, and reliability of industrial facilities. This course provides a detailed understanding of gasket functions, sealing mechanisms, flange requirements, gasket materials, selection criteria, and installation practices. Participants will learn about nonmetallic, semi metallic, and metallic gasket types, spiral wound and ring type joint gaskets, flange surface requirements, gasket markings, and industry best practices for gasket selection and application. The course also covers practical considerations required to achieve reliable sealing performance and maintain equipment integrity."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Gasket-The%20different%20Types%20of%20Gaskets%20Use%20and%20Selection.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Mechanical Engineering Principles.",
    "Familiarity with Piping and Flanged Joint Systems.",
    "Basic Understanding of Industrial Equipment and Pressure Containment Systems.",
    "Engineering Drawing and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the purpose and importance of gaskets in maintaining leak tight sealing systems.",
    "Learn the principles of sealing and the factors required to achieve an effective gasket seal.",
    "Understand gasket seating requirements and their impact on joint performance and reliability.",
    "Learn the different types of flanges and their influence on gasket selection and sealing effectiveness.",
    "Understand flange surface finish requirements, common terminology, and their relationship to gasket performance.",
    "Learn how operating conditions and material properties influence gasket material selection.",
    "Understand the criteria and methodology used for selecting appropriate gaskets for different industrial applications.",
    "Learn the characteristics, advantages, limitations, and applications of nonmetallic gaskets.",
    "Understand the construction, applications, and selection requirements of semi metallic gaskets, including spiral wound gaskets.",
    "Learn the different styles and marking systems used for standard spiral wound gaskets.",
    "Understand the characteristics, applications, and marking requirements of metallic and ring type joint gaskets.",
    "Learn proper gasket installation practices and industry best practices for achieving safe, reliable, and leak free operation."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Why Gaskets are used in model",
    "Module 3: Effecting a seal",
    "Module 4: Gasket seating",
    "Module 5: Flange Types",
    "Module 6: Flange Finish",
    "Module 7: Material consideration",
    "Module 8: Gasket selection",
    "Module 9: Section-one: non-metallic gaskets",
    "Module 10: Section-two: Semi-metallic",
    "Module 11: Spiral wound gaskets",
    "Module 12:  Markings for standard spiral wound gaskets",
    "Model 13:  Section-three: Metallic gaskets",
    "Module 14: Markings for standard ring type joint gaskets",
    "Module 15: Gasket installation"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 143,
  "title": "Guidelines for Pressure Boundary Bolted Flange Joint Assembly",
  "date": "Present",
  "description": [
    "Guidelines for Pressure Boundary Bolted Flange Joint Assembly is the application of engineering principles, controlled assembly practices, and quality assurance procedures used to achieve safe, reliable, and leak-tight pressure boundary flange connections. Bolted flange joints are critical components in piping systems, pressure vessels, heat exchangers, and process equipment where maintaining pressure containment is essential for operational safety and reliability. Proper joint assembly requires attention to flange condition, gasket installation, bolt tightening procedures, lubrication practices, torque control, testing, and documentation. Failure to follow proper assembly practices can result in leakage, equipment damage, environmental releases, safety incidents, and unplanned operational downtime.",
    "The Guidelines for Pressure Boundary Bolted Flange Joint Assembly course is designed for engineers, maintenance personnel, technicians, supervisors, inspectors, and reliability professionals involved in the assembly, maintenance, and inspection of flanged joints. This course provides a detailed understanding of personnel qualifications, flange preparation, gasket installation, bolt tightening methods, torque determination, pressure testing requirements, and documentation practices. Participants will learn industry best practices used to ensure consistent flange joint performance, minimize leakage risks, improve equipment reliability, and maintain pressure boundary integrity throughout the operational life of process equipment."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Guidelines%20for%20Pressure%20Boundary%20Bolted%20Flange%20Joint%20Assembly.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Mechanical and Piping Engineering Principles.",
    "Familiarity with Flanged Joint and Pressure Containment Systems.",
    "Basic Understanding of Industrial Maintenance and Inspection Practices.",
    "Engineering Drawings and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and objectives of pressure boundary bolted flange joint assembly practices.",
    "Learn the principles of pressure containment and the importance of proper flange joint assembly.",
    "Understand training, qualification, and competency requirements for personnel performing bolted joint assembly activities.",
    "Learn proper cleaning and examination procedures for flange faces, fasteners, and contact surfaces prior to assembly.",
    "Understand flange alignment requirements and their impact on joint integrity and sealing performance.",
    "Learn the correct methods for gasket selection, handling, positioning, and installation.",
    "Understand lubrication requirements for bolts, nuts, and bearing surfaces to achieve accurate bolt loading.",
    "Learn proper bolt installation, bolt numbering practices, and tightening preparation procedures.",
    "Understand torque control principles and methods used to determine target tightening values.",
    "Learn recommended bolt tightening sequences and techniques used to achieve uniform gasket compression.",
    "Learn documentation, record keeping, and joint disassembly practices used to support safe maintenance and long-term flange joint reliability."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Introduction",
    "Module 3: Training and Qualification of Bolted Joint Assembly Personnel",
    "Module 4: Cleaning and Examination of Flange and Fastener contact surfaces",
    "Module 5: Alignment of Flanged joints",
    "Module 6: Installation of Gasket",
    "Module 7: Lubrication of “Working” surfaces",
    "Module 8: Installation of bolts",
    "Module 9: Numbering of bolts",
    "Module 10: Tightening of bolts",
    "Module 11: Tightening sequence",
    "Module 12: Target Torque Determination",
    "Module 13: Joint Pressure and tightness testing",
    "Module 14: Records",
    "Module 15: Joint Disassembly"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 144,
  "title": "Nonmetallic Flat Gaskets for Pipe Flanges",
  "date": "Present",
  "description": [
    "Nonmetallic Flat Gaskets for Pipe Flanges is the study and application of nonmetallic gasket materials used to achieve leak tight sealing in flanged piping systems and pressure containing equipment. Nonmetallic flat gaskets are widely used in industrial facilities due to their flexibility, chemical resistance, and suitability for a wide range of operating conditions. Proper gasket selection, dimensional control, material compatibility, and installation practices are essential to ensure safe and reliable sealing performance. Failure to properly select or apply gasket systems can result in leakage, equipment damage, environmental releases, operational disruptions, and safety risks.",
    "The Nonmetallic Flat Gaskets for Pipe Flanges course is designed for engineers, maintenance personnel, inspectors, supervisors, and professionals involved in piping design, maintenance, and reliability management within industrial facilities. This course provides a detailed understanding of nonmetallic gasket materials, dimensional requirements, tolerances, marking systems, and application practices used in flanged piping systems. Participants will learn about gasket construction, material properties, sizing requirements, industry standards, and identification methods required to ensure effective sealing performance and reliable operation of piping systems. The course also covers practical engineering considerations and industry best practices aimed at improving gasket reliability and maintaining equipment integrity."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Nonmetallic%20Flat%20Gaskets%20for%20Pipe%20Flanges.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Mechanical and Piping Engineering Principles.",
    "Familiarity with Flanged Joint and Piping Systems.",
    "Basic Understanding of Industrial Sealing Applications.",
    "Engineering Drawing and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the scope and applications of nonmetallic flat gaskets used in pipe flange systems.",
    "Learn the general principles and operational requirements of gasket sealing systems in industrial piping applications.",
    "Learn how material selection influences gasket performance, chemical compatibility, temperature resistance, and sealing effectiveness.",
    "Understand dimensional requirements and tolerance specifications applicable to nonmetallic flat gaskets.",
    "Learn the importance of proper gasket sizing and dimensional control in maintaining leak tight flange connections.",
    "Understand gasket marking systems and identification requirements used for standard gasket applications.",
    "Learn industry standards and best practices applicable to nonmetallic gasket selection and application.",
    "Understand the operational limitations and performance considerations associated with nonmetallic gasket materials.",
    "Learn installation and handling practices used to minimize gasket damage and improve sealing reliability.",
    "Understand common gasket failure causes and mitigation measures used to improve joint integrity and operational safety.",
    "Analyze practical case studies and industry examples to understand the application of nonmetallic flat gaskets in industrial piping systems."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: General",
    "Module 3: Materials",
    "Module 4: Dimensions and Tolerances",
    "Module 5: Markings"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 145,
  "title": "Oil and Gas Piping",
  "date": "Present",
  "description": [
    "Oil and Gas Piping is the application of engineering, fabrication, construction, inspection, and commissioning practices used to design, install, test, and maintain piping systems within oil and gas facilities. Piping systems serve as critical components for the safe and efficient transportation of hydrocarbons, utilities, and process fluids throughout production, processing, storage, and distribution operations. Proper material selection, fabrication quality, welding integrity, inspection activities, and commissioning procedures are essential to ensuring system reliability, operational safety, and regulatory compliance. Failure to effectively manage piping system design and construction can result in leaks, equipment damage, environmental incidents, production losses, and significant safety risks.",
    "The Oil and Gas Piping course is designed for engineers, supervisors, inspectors, construction personnel, project managers, and professionals involved in the design, fabrication, installation, commissioning, and maintenance of piping systems in oil and gas facilities. This course provides a detailed understanding of piping materials, fabrication processes, welding requirements, non-destructive testing methods, erection practices, commissioning activities, project management principles, and applicable ISO standards. Participants will learn industry best practices used to ensure piping system integrity, improve construction quality, maintain operational reliability, and support safe plant operation throughout the project lifecycle."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Oil%20and%20Gas%20Piping.png",
  "tags": [],
  "category": "mechanical",
  "duration": "6 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Piping Engineering and Industrial Plant Operations.",
    "Familiarity with Oil and Gas Processing Facilities.",
    "Basic Understanding of Materials, Welding, and Construction Practices.",
    "Engineering Drawings and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles and applications of piping systems in oil and gas facilities.",
    "Understand piping fabrication processes and quality control requirements used during construction.",
    "Learn welding methods, procedures, and quality assurance practices applicable to piping systems.",
    "Understand the role and application of non-destructive testing methods in verifying piping integrity.",
    "Learn piping erection and installation practices required to ensure safe and reliable system performance.",
    "Understand pre-commissioning activities, testing requirements, and system preparation procedures.",
    "Learn commissioning processes and operational readiness requirements for newly installed piping systems.",
    "Understand post-commissioning activities, performance verification, and system optimization practices.",
    "Learn project management principles and their application in piping engineering and construction projects.",
    "Understand the purpose and application of ISO standards relevant to oil and gas piping systems.",
    "Apply industry best practices to ensure piping system integrity, safety, quality, and long-term operational reliability."
  ],
  "outline": [
    "Module 1: Material",
    "Module 2: Fabrication",
    "Module 3: Welding",
    "Module 4: NDT",
    "Module 5: Erection",
    "Module 6: Pre-commissioning",
    "Module 7: Commissioning",
    "Module 8: Post-commissioning",
    "Module 9: Project Management",
    "Module 10: ISO Standards"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦250,000 / $220",
  "certification": "Certificate of Completion"
},

{
  "id": 146,
  "title": "Practical Thermal Design of Shell and Tube Heat Exchangers",
  "date": "Present",
  "description": [
    "Practical Thermal Design of Shell and Tube Heat Exchangers is the process of applying heat transfer principles and engineering methodologies to design, analyze, and optimize shell and tube heat exchangers used in industrial applications. Proper thermal design ensures efficient heat transfer, optimal equipment performance, reduced energy consumption, and reliable operation under varying process conditions. Inadequate thermal design can result in poor heat transfer efficiency, excessive pressure drop, fouling issues, vibration problems, increased operating costs, and equipment failure.",
    "The Practical Thermal Design of Shell and Tube Heat Exchangers course is designed for engineers and professionals involved in the design, operation, maintenance, and optimization of heat exchanger systems in industrial facilities. This course provides a detailed understanding of shell and tube heat exchanger classification, thermal design methods, optimization techniques, fouling considerations, vibration analysis, and enhanced heat transfer technologies. Participants will learn how to perform thermal design calculations for single phase exchangers, condensers and reboilers, evaluate heat transfer performance, allocate shell side and tube side streams, and apply practical design considerations to achieve safe, reliable, and cost effective heat exchanger operation."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Practical%20thermal%20design%20of%20shell%20and%20tube%20heat%20exchnagers.png",
  "tags": [],
  "category": "mechanical",
  "duration": "6 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Heat Transfer Principles.",
    "Familiarity with Process or industrial Plant Operations.",
    "Basic Understanding of Heat Exchanger Systems.",
    "Engineering Calculation and Drawing Interpretation Skills."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the principles and applications of shell and tube heat exchangers in industrial processes",
    "Learn the classification and operational characteristics of different shell and tube heat exchanger types",
    "Understand the methodology for thermal design and optimization of single phase heat exchange.",
    "Learn how to calculate and apply mean temperature difference methods in heat exchanger design.",
    "Understand the criteria for allocating process fluids to the shell side and tube side of heat exchangers.",
    "Learn the methodology and application of multiple shell arrangements in heat exchanger systems.",
    "Understand the thermal design and optimization requirements for condensers and reboilers.",
    "Learn how physical properties and heat release profiles affect heat exchanger thermal performance.",
    "Understand the concept of overdesign and its impact on heat exchanger efficiency and operation.",
    "Learn the causes, consequences, and mitigation methods associated with fouling in heat exchangers.",
    "Understand vibration analysis and its importance in maintaining heat exchanger reliability and mechanical integrity.",
    "Learn the principles and applications of enhanced heat transfer techniques to improve exchanger performance."
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: Classification of Shell-and-Tube Heat Exchangers",
    "Module 3: Thermal Design and Optimization of Single-phase Heat Exchangers",
    "Module 4: Mean Temperature Difference",
    "Module 5: Allocation of Sides: Shell side and Tube side",
    "Module 6: Methodology of the use of Multiple Shells",
    "Module 7: Thermal Design and Optimization of Condensers",
    "Module 8: Thermal Design and Optimization of Reboilers",
    "Module 9: Physical Properties and Heat Release profiles",
    "Module 10: Overdesign",
    "Module 11: Fouling: Its Consequences and Mitigation",
    "Module 12:  Vibration Analysis",
    "Module 13:   Enhanced Heat Transfer"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $250",
  "certification": "Certificate of Completion"
},

{
  "id": 147,
  "title": "Steels for Hydrogen Service at Elevated Temperatures",
  "date": "Present",
  "description": [
    "Steels for Hydrogen Service at Elevated Temperatures is the study and application of material selection, operational practices, and inspection techniques required to ensure the safe use of steels exposed to high temperature hydrogen environments in industrial facilities. Hydrogen service at elevated temperatures can lead to material degradation mechanisms such as decarburization, fissuring, cracking, and High Temperature Hydrogen Attack (HTHA), which may compromise equipment integrity and plant safety. Proper understanding of material behavior, operating conditions, and inspection requirements is essential for preventing equipment failure and ensuring reliable plant operation.",
    "The Steels for Hydrogen Service at Elevated Temperatures course is designed for engineers, inspectors, maintenance personnel, and professionals involved in the design, operation, inspection, and integrity management of process equipment operating in hydrogen service. This course provides a detailed understanding of the operating experience, damage mechanisms, influencing factors, and inspection practices associated with High Temperature Hydrogen Attack. Participants will learn about the forms of HTHA, factors affecting material degradation, inspection methodologies, and industry practices used to evaluate and manage equipment exposed to hydrogen at elevated temperatures. The course also covers practical engineering considerations and integrity management approaches aimed at improving equipment reliability and operational safety."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Steels%20for%20Hydrogen%20Service%20at%20Elevated%20Temperatures.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Metallurgy and Material Engineering Principles.",
    "Familiarity with Oil and Gas or Refinery Operations.",
    "Basic Understanding of Pressure Equipment and Process Systems.",
    "Engineering and Inspection Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the scope and application of steels used in hydrogen service at elevated temperatures.",
    "Learn the relevant codes, standards, and normative references applicable to hydrogen service materials and equipment.",
    "Understand historical operating experience and industry lessons related to High Temperature Hydrogen Attack.",
    "Learn the different forms and characteristics of HTHA affecting steels in hydrogen environments.",
    "Understand the mechanisms of decarburization, fissuring, and cracking associated with elevated temperature hydrogen exposure.",
    "Learn the factors influencing material degradation and damage progression in hydrogen service equipment.",
    "Understand the operational and process conditions that increase the risk of HTHA in industrial facilities.",
    "Learn inspection techniques and methodologies used to detect and assess HTHA damage in process equipment.",
    "Understand integrity management practices aimed at minimizing the risks associated with hydrogen attack.",
    "Learn material selection considerations and mitigation strategies for improving equipment reliability in hydrogen service."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative reference",
    "Module 3: Operating Experience",
    "Module 4: Forms of HTHA",
    "Module 5: Factors influencing decarburization, fissuring, and cracking caused by HTHA",
    "Module 6: Inspection for HTHA"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦200,000 / $180",
  "certification": "Certificate of Completion"
},

{
  "id": 148,
  "title": "Tank Inspection, Repair, Altercation, and Reconstruction",
  "date": "Present",
  "description": [
    "Tank Inspection, Repair, Alteration, and Reconstruction is the application of engineering, inspection, maintenance, and quality assurance practices used to assess the condition of storage tanks and ensure their continued safe and reliable operation. Proper inspection and evaluation help identify deterioration, damage mechanisms, structural deficiencies, and serviceability concerns that may affect tank integrity. Repair, alteration, and reconstruction activities must be carried out in accordance with recognized industry standards to maintain safety, operational reliability, and regulatory compliance. Failure to properly inspect and maintain storage tanks can result in leaks, structural failures, environmental incidents, product losses, and significant safety risks.",
    "The Tank Inspection, Repair, Alteration, and Reconstruction course is designed for engineers, inspectors, maintenance personnel, fabricators, supervisors, and professionals involved in the management and integrity assessment of storage tanks. This course provides a detailed understanding of inspection requirements, suitability for service evaluations, brittle fracture considerations, material selection, reconstruction design requirements, repair methodologies, welding practices, testing requirements, and documentation procedures. Participants will learn industry best practices used to assess tank condition, plan repair and reconstruction activities, ensure compliance with applicable standards, and maintain the long term integrity of storage tank assets."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Tank%20Inspection,%20Repair,%20Altercation,%20and%20Reconstruction.png",
  "tags": [],
  "category": "mechanical",
  "duration": "8 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Storage Tank Engineering Principles.",
    "Familiarity with Oil and Gas or Industrial Storage Facilities.",
    "Basic Understanding of Inspection and Maintenance Practices.",
    "Engineering Drawing and Technical Documentation Interpretation Skills."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the scope and objectives of tank inspection, repair, alteration, and reconstruction activities.",
    "Learn the applicable standards, normative references, and industry requirements governing storage tank integrity management.",
    "Understand important terms, definitions, and concepts associated with storage tank inspection and repair practices.",
    "Learn how to assess tank suitability for continued service and evaluate structural integrity conditions.",
    "Understand brittle fracture mechanisms and the factors influencing brittle fracture susceptibility in storage tanks.",
    "Learn inspection methods, inspection planning requirements, and assessment techniques used to evaluate tank condition.",
    "Understand material selection requirements and considerations applicable to tank repair and reconstruction activities.",
    "Learn the design considerations and engineering requirements for reconstructed storage tanks.",
    "Understand repair and alteration procedures used to restore or modify storage tanks while maintaining compliance with industry standards.",
    "Learn the requirements and best practices associated with tank dismantling, reconstruction, and welding activities.",
    "Understand examination and testing methods used to verify the quality and integrity of repaired or reconstructed tanks.",
    "Learn marking, documentation, and record keeping requirements necessary to support regulatory compliance and long term asset integrity management."
  ],
  "outline": [
    "Module 1: Scope",
    "Module 2: Normative references",
    "Module 3: Terms and definitions",
    "Module 4: Suitability for service",
    "Module 5: Brittle fracture considerations",
    "Module 6: Inspection",
    "Module 7: Materials",
    "Module 8: Design considerations for reconstructed tanks",
    "Module 9: Tank repair and alteration",
    "Module 10: Dismantling and reconstruction",
    "Module 11: Welding",
    "Module 12: Examination and testing",
    "Module 13: Marking and record keeping"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦300,000 / $280",
  "certification": "Certificate of Completion"
},

{
  "id": 149,
  "title": "Process Unit and Offsite Layout",
  "date": "Present",
  "description": [
    "Process Unit and Offsite Layout is the process of arranging process units, utility systems, storage facilities, buildings, access routes, and supporting infrastructure within an industrial plant to achieve safe, efficient, operable, and maintainable facilities. Proper layout design ensures adequate spacing between equipment, safe access for operation and maintenance, efficient piping and utility routing, compliance with industry standards, and minimization of risks associated with fire, explosion, and hazardous releases. Poor plant layout can result in operational inefficiencies, safety hazards, maintenance difficulties, and increased project costs.",
    "The Process Unit and Offsite Layout course is designed for engineers and professionals involved in the design, construction, operation, and maintenance of industrial plants and facilities. This course provides a detailed understanding of the principles, standards, and engineering considerations involved in plant layout development. Participants will learn about site plan development, equipment arrangement, access requirements, piping considerations, roads and paving systems, storage tank layout, cooling tower positioning, and the placement of buildings and electrical/instrumentation facilities. The course also covers practical design considerations and industry best practices to ensure safe, accessible, and cost effective plant layouts."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Process%20Unit%20and%20Offsite%20Layout.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Engineering principles.",
    "Familiarity with industrial or Process Plant Operations.",
    "Basic Understanding of Piping and equipment Systems",
    "Engineering Drawing Interpretations Skills"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the principles and objectives of process unit and offsite layout in industrial facilities",
    "Learn the applicable codes, standards, and references used in the plant layout engineering and design.",
    "Understand the general requirements and considerations involved in developing plant layouts.",
    "Learn how to develop site plans that ensure safety, accessibility, operational efficiency and future expansion requirement",
    "Understand the design requirements for accesways, platforms, ladders, roads, and paving systems within industrial plants",
    "Understand piping layout considerations, including routing, spacing, accessibility, and safety requirements.",
    "Learn the layout and positioning requirements for buildings within process plants and offsite facilities.",
    "Understand the arrangement and placement requirements for electrical and instrumentation equipment within industrial facilities.",
    "Learn how to provide safe and adequate access to equipment and instruments for operation and maintenance activities.",
    "Understand the layout considerations and spacing requirements for cooling towers and storage tanks.",
    "Learn how to apply layout engineering principles to improve safety, operability, maintainability, and cost effectiveness in industrial facilities.",
    "Analyze practical case studies and real plant layout examples to understand the application of layout engineering principles in industrial projects"
  ],
  "outline": [
    "Module 1: Introduction",
    "Module 2: References",
    "Module 3: definitions",
    "Module 4: General",
    "Module 5: site plan development",
    "Module 6: Accessways, platforms, ladders",
    "Module 7: Roads and Paving’s",
    "Module 8: Piping Model",
    "Module 9: Buildings",
    "Module 10: Instrument and Electrical equipment’s",
    "Module 11: Equipment and Instrument Access",
    "Module 12:  Cooling towers Model 14: storage tanks"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦100,000 / $80",
  "certification": "Certificate of Completion"
},

{
  "id": 150,
  "title": "Safety Flare Headers and Blowdown System",
  "date": "Present",
  "description": [
    "Safety Flare Headers and Blowdown System is the process of designing and analyzing flare and depressurization systems used to safely collect, relieve, and dispose of excess hydrocarbons and process fluids during normal operations, emergency conditions, and plant shutdowns. Proper flare and blowdown system design ensures safe pressure relief, controlled disposal of hazardous gases, protection of personnel and equipment, and compliance with industry safety standards. Inadequate flare and blowdown system design can result in excessive backpressure, unsafe operating conditions, equipment damage, environmental concerns, and major safety risks.",
    "The Safety Flare Headers and Blowdown System course is designed for engineers and professionals involved in the design, operation, maintenance, and safety management of industrial process facilities. This course provides a detailed understanding of flare headers, blowdown systems, and flare relief systems used in oil and gas and process industries. Participants will learn about flare system design principles, flare header sizing considerations, blowdown system requirements, relief load handling, pressure relief integration, and flare system operational safety. The course also covers practical engineering considerations and industry best practices required to ensure safe, reliable, and efficient flare and blowdown system performance."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Safety%20Flare%20Headers%20and%20Blowdown%20System.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic Knowledge of Process Safety Principles.",
    "Familiarity with Oil and Gas or Process Plant Operations.",
    "Basic Understanding of Pressure Relief Systems.",
    "Engineering Drawing and Piping Interpretation Skills."
  ],
  "methodology": "Theoretical",
  "objectives": [
    "Understand the principles and functions of safety flare headers and blowdown systems in industrial facilities.",
    "Learn the general design philosophy and operational requirements of flare and depressurization systems.",
    "Understand the purpose, configuration, and components of flare header systems.",
    "Learn the design considerations involved in flare header sizing, routing, and pressure management.",
    "Understand the principles and operational requirements of blowdown systems in process plants.",
    "Learn how to evaluate blowdown loads and depressurization requirements during emergency conditions.",
    "Understand the integration of pressure relief devices with flare and blowdown systems.",
    "Learn the operational and safety considerations associated with flare relief valve systems.",
    "Understand the impact of backpressure, flow dynamics, and system hydraulics on flare system performance.",
    "Learn industry codes, standards, and best practices applicable to flare and blowdown system design."
  ],
  "outline": [
    "Module 1: General",
    "Module 2: Flare headers",
    "Module 3: Blowdown systems",
    "Module 4: Flare system relief valve summary"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "₦180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 151,
  "title": "Instrumentation Drafting",
  "date": "Present",
  "description": [
    "Instrumentation Drafting is a specialized engineering discipline focused on preparing detailed drawings and documentation required for instrumentation and control system implementation. Instrumentation drawings serve as the communication bridge between process, electrical, instrumentation, and construction teams.",
    "This course provides comprehensive training on instrumentation drafting standards, symbols, document development, and engineering deliverables used throughout FEED, EPC, and detailed design projects. Participants will learn how to prepare instrument location plans, hook-up drawings, loop diagrams, cable schedules, instrument indexes, wiring diagrams, and control system architecture drawings."
  ],
  "image": "https://ik.imagekit.io/mags/courses/INSTRUMENTATION%20DRAFTING.png",
  "tags": [],
  "category": "PAI",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of instrumentation and control systems",
    "Familiarity with P&IDs and engineering drawings",
    "Knowledge of industrial processes and instrumentation symbols"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand instrumentation drafting standards and conventions",
    "Interpret instrumentation-related engineering documents",
    "Develop instrument indexes and I/O lists",
    "Prepare instrument location plans",
    "Generate instrument hook-up drawings",
    "Create loop diagrams and wiring diagrams",
    "Develop junction box and marshalling cabinet drawings",
    "Produce cable routing and cable schedules",
    "Develop control room layout drawings",
    "Generate DCS, PLC, and SIS architecture drawings",
    "Prepare construction-ready instrumentation documentation",
    "Review instrumentation drafting case studies"
  ],
  "outline": [
    "Module 1: Introduction to Instrumentation Drafting",
    "Module 2: Instrumentation Symbols and Standards",
    "Module 3: Instrument Index Development",
    "Module 4: Instrument Location Plans",
    "Module 5: Instrument Hook-Up Drawings",
    "Module 6: Instrument Loop Diagrams",
    "Module 7: Wiring Diagrams",
    "Module 8: Cable Routing Drawings",
    "Module 9: Cable Schedules",
    "Module 10: Junction Box Drawings",
    "Module 11: Marshalling Cabinet Drawings",
    "Module 12: Control Panel Drawings",
    "Module 13: PLC Architecture Drawings",
    "Module 14: DCS Architecture Drawings",
    "Module 15: SIS Architecture Drawings",
    "Module 16: Instrument Installation Details",
    "Module 17: As-Built Documentation",
    "Module 18: Quality Control and Checking Procedures",
    "Module 19: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 152,
  "title": "Instrumentation Engineering (Introduction)",
  "date": "Present",
  "description": [
    "Instrumentation Engineering focuses on the measurement, monitoring, control, and automation of industrial processes. Instrumentation engineers design systems that ensure safe, efficient, and reliable plant operation through accurate measurement and control.",
    "This course provides a comprehensive introduction to instrumentation engineering, including field instruments, control systems, safety systems, communication networks, and automation technologies used in modern industrial facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Instrumentation%20Engineering.png",
  "tags": [],
  "category": "PAI",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of engineering and industrial processes",
    "Familiarity with electrical principles",
    "Knowledge of process operations and control systems"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define the role of an instrumentation engineer",
    "Understand industrial measurement principles",
    "Select appropriate field instruments",
    "Interpret instrument datasheets and specifications",
    "Develop instrument index and I/O lists",
    "Design process control loops",
    "Understand PLC, DCS, and SCADA systems",
    "Apply safety instrumented systems concepts",
    "Evaluate communication protocols",
    "Perform instrument sizing and selection",
    "Review control valve applications",
    "Analyze instrumentation case studies"
  ],
  "outline": [
    "Module 1: Introduction to Instrumentation Engineering",
    "Module 2: Instrumentation Engineering Projects",
    "Module 3: Role of Instrumentation Engineer",
    "Module 4: Interface with Other Discipline Engineers",
    "Module 5: Industrial Process Control Systems",
    "Module 6: Project Phases",
    "Module 7: FEED – Instrumentation Engineering Scope",
    "Module 8: EPC Proposal – Instrumentation Engineering Scope",
    "Module 9: Detailed Design – Instrumentation Engineering Scope",
    "Module 10: Measurement Principles",
    "Module 11: Pressure Instrumentation",
    "Module 12: Temperature Instrumentation",
    "Module 13: Flow Measurement Systems",
    "Module 14: Level Measurement Systems",
    "Module 15: Control Valves and Accessories",
    "Module 16: PLC Systems",
    "Module 17: DCS Systems",
    "Module 18: SCADA Systems",
    "Module 19: Safety Instrumented Systems (SIS)",
    "Module 20: Instrumentation Engineering Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 153,
  "title": "Instrumentation Engineering Design Basis",
  "date": "Present",
  "description": [
    "The Instrumentation Engineering Design Basis document defines the philosophies, standards, and technical requirements governing measurement, control, automation, safety systems, communication networks, and instrumentation architecture.",
    "This course provides detailed knowledge of developing Instrumentation Design Basis documents used in industrial facilities. Participants will learn instrument selection philosophies, control system architectures, safety requirements, alarm management philosophies, and automation design criteria."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Instrumentation%20Engineering%20Design%20Basis.png",
  "tags": [],
  "category": "PAI",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of instrumentation and control systems",
    "Familiarity with process operations and P&IDs",
    "Experience in FEED, EPC, automation, or plant engineering projects"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the structure and content of an Instrumentation Design Basis document",
    "Develop instrumentation philosophies and standards",
    "Define measurement and control requirements",
    "Establish control system architecture philosophies",
    "Develop alarm management strategies",
    "Define safety instrumented system requirements",
    "Establish communication and networking philosophies",
    "Apply instrument installation and maintenance considerations",
    "Develop automation and digitalization strategies",
    "Support FEED and EPC instrumentation engineering activities",
    "Analyze instrumentation engineering case studies"
  ],
  "outline": [
    "Module 1: Instrumentation Design Basis Philosophy",
    "Module 2: Instrumentation Codes and Standards",
    "Module 3: Measurement Philosophy",
    "Module 4: Pressure Instrument Design Basis",
    "Module 5: Temperature Instrument Design Basis",
    "Module 6: Flow Measurement Philosophy",
    "Module 7: Level Measurement Philosophy",
    "Module 8: Instrument Selection Philosophy",
    "Module 9: Control Valve Philosophy",
    "Module 10: Instrument Air System Philosophy",
    "Module 11: Control System Architecture (PLC/DCS/SCADA)",
    "Module 12: Alarm Management Philosophy",
    "Module 13: Safety Instrumented System (SIS) Philosophy",
    "Module 14: Cause and Effect Philosophy",
    "Module 15: Instrument Installation Philosophy",
    "Module 16: Instrument Cable Routing Philosophy",
    "Module 17: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 154,
  "title": "Material Engineering (Introduction)",
  "date": "Present",
  "description": [
    "Materials Engineering focuses on the selection, testing, behavior, degradation, and performance of engineering materials under various operating conditions. Proper material selection is critical for safety, reliability, corrosion resistance, and lifecycle performance.",
    "This course provides participants with practical knowledge of metallic and non-metallic materials used in industrial facilities, emphasizing material selection, corrosion control, welding, inspection, and failure prevention."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Material%20Engineering.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of chemistry and physics",
    "Familiarity with engineering materials",
    "Knowledge of industrial equipment and systems"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of materials engineers",
    "Identify engineering materials used in industry",
    "Select materials for specific operating conditions",
    "Evaluate corrosion mechanisms",
    "Apply material selection standards",
    "Understand welding processes and metallurgy",
    "Evaluate material failures",
    "Review inspection and testing methods",
    "Understand asset integrity management",
    "Apply materials engineering principles in industrial projects"
  ],
  "outline": [
    "Module 1: Introduction to Materials Engineering",
    "Module 2: Materials Engineering Projects",
    "Module 3: Role of Materials Engineer",
    "Module 4: Interface with Other Discipline Engineers",
    "Module 5: Industrial Materials Overview",
    "Module 6: Project Phases",
    "Module 7: FEED – Materials Engineering Scope",
    "Module 8: EPC Proposal – Materials Engineering Scope",
    "Module 9: Detailed Design – Materials Engineering Scope",
    "Module 10: Metallic Materials",
    "Module 11: Non-Metallic Materials",
    "Module 12: Material Selection Methodology",
    "Module 13: Corrosion Mechanisms",
    "Module 14: Corrosion Control Methods",
    "Module 15: Welding and Metallurgy",
    "Module 16: Material Testing and Inspection",
    "Module 17: Failure Analysis",
    "Module 18: Asset Integrity Management",
    "Module 19: Materials Standards and Specifications",
    "Module 20: Materials Engineering Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 155,
  "title": "MATERIAL TAKE-OFF (MTO)",
  "date": "Present",
  "description": [
    "Material Take-Off (MTO) is a critical engineering activity used to quantify materials required for procurement, construction, fabrication, and project cost estimation. Accurate MTO development minimizes project cost overruns and material shortages.",
    "This course provides practical knowledge on extracting quantities from engineering drawings, specifications, and 3D models. Participants will learn quantity take-off methodologies for piping, mechanical, structural, electrical, and instrumentation disciplines."
  ],
  "image": "https://ik.imagekit.io/mags/courses/MATERIAL%20TAKE-OFF%20(MTO).png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of engineering drawings",
    "Familiarity with project documentation",
    "Knowledge of engineering materials and specifications"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand MTO principles and methodologies",
    "Extract quantities from engineering drawings",
    "Interpret material specifications",
    "Develop piping MTOs",
    "Develop structural steel MTOs",
    "Develop instrumentation MTOs",
    "Develop electrical MTOs",
    "Prepare bulk material take-offs",
    "Perform quantity verification",
    "Develop procurement material requisitions",
    "Generate material reports and summaries",
    "Review project MTO case studies"
  ],
  "outline": [
    "Module 1: Introduction to Material Take-Off",
    "Module 2: Engineering Documents for MTO",
    "Module 3: Material Coding Systems",
    "Module 4: Piping MTO Development",
    "Module 5: Pipe Support MTO",
    "Module 6: Valve and Specialty Item MTO",
    "Module 7: Mechanical Equipment MTO",
    "Module 8: Structural Steel MTO",
    "Module 9: Civil Material MTO",
    "Module 10: Electrical Material MTO",
    "Module 11: Instrumentation Material MTO",
    "Module 12: Cable Quantity Estimation",
    "Module 13: Bulk Material Estimation",
    "Module 14: Quantity Verification",
    "Module 15: Procurement Interface",
    "Module 16: MTO Reporting",
    "Module 17: Cost Estimation Interface",
    "Module 18: Quality Control and Auditing",
    "Module 19: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 156,
  "title": "Materials Engineering Design Basis",
  "date": "Present",
  "description": [
    "The Materials Engineering Design Basis document establishes the criteria for material selection, corrosion control, metallurgy, welding, inspection, and asset integrity management throughout the facility lifecycle.",
    "This course provides detailed guidance on developing a comprehensive Materials Design Basis document that supports equipment reliability, safety, and lifecycle performance."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Materials%20Engineering%20Design%20Basis.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of engineering materials and metallurgy",
    "Familiarity with industrial equipment and piping systems",
    "Experience in engineering, inspection, or integrity projects"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the structure of a Materials Design Basis document",
    "Develop material selection philosophies",
    "Establish corrosion management strategies",
    "Define welding and metallurgy requirements",
    "Apply inspection and testing criteria",
    "Develop coating and lining philosophies",
    "Define cathodic protection requirements",
    "Apply industry standards and specifications",
    "Establish asset integrity requirements",
    "Evaluate material failures and corrective actions",
    "Review practical materials engineering case studies"
  ],
  "outline": [
    "Module 1: Materials Design Basis Philosophy",
    "Module 2: Materials Engineering Standards and Specifications",
    "Module 3: Metallic Materials Selection Philosophy",
    "Module 4: Non-Metallic Materials Selection Philosophy",
    "Module 5: Corrosion Assessment Methodology",
    "Module 6: Corrosion Allowance Philosophy",
    "Module 7: Corrosion Mitigation Philosophy",
    "Module 8: Material Compatibility Evaluation",
    "Module 9: Welding Philosophy",
    "Module 10: Metallurgical Design Requirements",
    "Module 11: Heat Treatment Philosophy",
    "Module 12: Coating and Painting Philosophy",
    "Module 13: Lining and Cladding Philosophy",
    "Module 14: Cathodic Protection Philosophy",
    "Module 15: Inspection and Testing Philosophy",
    "Module 16: Asset Integrity Management Philosophy",
    "Module 17: Failure Analysis Methodology",
    "Module 18: Life Extension and Fitness-for-Service Philosophy",
    "Module 19: Case Studies."
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 157,
  "title": "Mechanical Engineering (Introduction)",
  "date": "Present",
  "description": [
    "Mechanical Engineering is one of the broadest engineering disciplines, focusing on the design, analysis, manufacturing, operation, and maintenance of mechanical systems and equipment. Mechanical engineers play a vital role in industries such as oil and gas, petrochemicals, power generation, manufacturing, mining, aerospace, marine, and infrastructure development.",
    "This course provides a comprehensive introduction to Mechanical Engineering within industrial projects. Participants will learn the responsibilities of mechanical engineers during FEED, EPC, and detailed design phases. The course covers static and rotating equipment, pressure vessels, heat exchangers, pumps, compressors, turbines, material handling systems, maintenance strategies, and engineering standards. Real-life industrial case studies will be used to bridge theory and practice."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Mechanical%20Engineering%20(Introduction).png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of engineering principles",
    "Familiarity with mechanics, materials, and thermodynamics",
    "Foundational knowledge of mathematics and physics"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Define the scope and responsibilities of a mechanical engineer",
    "Understand mechanical engineering activities across project phases",
    "Identify major static and rotating equipment",
    "Interpret mechanical datasheets and specifications",
    "Perform equipment selection and sizing calculations",
    "Understand pressure vessel and storage tank design principles",
    "Evaluate pump, compressor, and turbine performance",
    "Develop equipment layouts and maintenance strategies",
    "Apply engineering standards and codes",
    "Analyze equipment failures and troubleshooting methods",
    "Collaborate with process, piping, electrical, and instrumentation engineers",
    "Review practical industrial case studies"
  ],
  "outline": [
    "Module 1: Introduction to Mechanical Engineering",
    "Module 2: Mechanical Engineering Projects",
    "Module 3: Role of Mechanical Engineer",
    "Module 4: Interface with Other Discipline Engineers",
    "Module 5: Industrial Facilities and Equipment",
    "Module 6: Phases of Engineering Projects",
    "Module 7: FEED – Mechanical Engineering Scope",
    "Module 8: EPC Proposals – Mechanical Engineering Scope",
    "Module 9: Detailed Design – Mechanical Engineering Scope",
    "Module 10: Engineering Codes and Standards",
    "Module 11: Equipment Specifications and Datasheets",
    "Module 12: Pressure Vessel Design Fundamentals",
    "Module 13: Storage Tank Design Fundamentals",
    "Module 14: Heat Exchangers",
    "Module 15: Pumps and Pump Systems",
    "Module 16: Compressors and Compression Systems",
    "Module 17: Gas Turbines and Steam Turbines",
    "Module 18: Mechanical Package Equipment",
    "Module 19: Material Handling Equipment",
    "Module 20: Reliability and Asset Integrity",
    "Module 21: Mechanical Engineering Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 158,
  "title": "Mechanical Engineering Design Basis",
  "date": "Present",
  "description": [
    "The Mechanical Engineering Design Basis document establishes the technical requirements, design philosophies, standards, and engineering assumptions used for the selection, sizing, specification, installation, operation, and maintenance of mechanical equipment throughout a project lifecycle.",
    "This course provides comprehensive knowledge of the philosophies and criteria governing mechanical engineering design. Participants will learn how to develop Mechanical Design Basis Documents that define requirements for pressure vessels, heat exchangers, storage tanks, pumps, compressors, turbines, package equipment, maintenance philosophy, reliability requirements, and equipment sparing strategies. The course integrates industry standards, engineering best practices, and practical case studies to support successful project execution from FEED through commissioning and operation."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Mechanical%20Engineering%20Design%20Basis.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of mechanical engineering principles and equipment design",
    "Familiarity with industrial facilities and rotating/static equipment",
    "Experience in FEED, EPC, maintenance, or plant engineering projects"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the structure and content of a Mechanical Design Basis document",
    "Define equipment selection philosophies and design criteria",
    "Establish rotating and static equipment design requirements",
    "Develop equipment sparing and reliability philosophies",
    "Apply maintenance and operability considerations during design",
    "Define equipment accessibility and layout requirements",
    "Specify vibration, noise, and mechanical integrity criteria",
    "Establish equipment inspection and testing requirements",
    "Apply international mechanical engineering codes and standards",
    "Develop design philosophies that support safe and reliable operation",
    "Analyze real-life mechanical engineering case studies"
  ],
  "outline": [
    "Module 1: Mechanical Design Basis Philosophy",
    "Module 2: Mechanical Engineering Codes and Standards",
    "Module 3: Rotating Equipment Design Philosophy",
    "Module 4: Static Equipment Design Philosophy",
    "Module 5: Pressure Vessel Design Basis",
    "Module 6: Storage Tank Design Basis",
    "Module 7: Heat Exchanger Design Philosophy",
    "Module 8: Pump Design Philosophy",
    "Module 9: Compressor Design Philosophy",
    "Module 10: Turbine Design Philosophy",
    "Module 11: Package Equipment Design Philosophy",
    "Module 12: Equipment Sparing Philosophy",
    "Module 13: Reliability and Availability Requirements",
    "Module 14: Equipment Accessibility and Maintenance Philosophy",
    "Module 15: Mechanical Integrity Philosophy",
    "Module 16: Vibration Control Philosophy",
    "Module 17: Noise Control Requirements",
    "Module 18: Inspection and Testing Philosophy",
    "Module 19: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 159,
  "title": "PIPE STRESS ANALYSIS",
  "date": "Present",
  "description": [
    "Pipe Stress Analysis is the engineering discipline that evaluates the structural behavior of piping systems under pressure, temperature, weight, wind, seismic, vibration, and operational loads. Proper stress analysis ensures system integrity, safety, operability, and compliance with applicable codes.",
    "This course provides comprehensive training on pipe stress analysis methodologies, code requirements, modeling techniques, flexibility analysis, support design, and stress mitigation strategies using industry-standard software."
  ],
  "image": "https://ik.imagekit.io/mags/courses/PIPE%20STRESS%20ANALYSIS.png",
  "tags": [],
  "category": "mechanical",
  "duration": "8 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of piping engineering",
    "Familiarity with piping layouts and P&IDs",
    "Knowledge of mechanics and structural analysis"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand pipe stress analysis fundamentals",
    "Apply piping code requirements",
    "Evaluate piping loads and load combinations",
    "Develop pipe stress models",
    "Perform flexibility analysis",
    "Analyze thermal expansion effects",
    "Design pipe support systems",
    "Evaluate nozzle loads",
    "Assess vibration and dynamic loads",
    "Perform seismic and wind analysis",
    "Interpret stress analysis reports",
    "Review practical stress analysis case studies"
  ],
  "outline": [
    "Module 1: Introduction to Pipe Stress Analysis",
    "Module 2: Piping Codes and Standards",
    "Module 3: Pipe Stress Fundamentals",
    "Module 4: Pipe Loading Conditions",
    "Module 5: Sustained Stress Analysis",
    "Module 6: Thermal Expansion Analysis",
    "Module 7: Flexibility Analysis",
    "Module 8: Pipe Support Design",
    "Module 9: Spring Support Selection",
    "Module 10: Equipment Nozzle Load Evaluation",
    "Module 11: Occasional Load Analysis",
    "Module 12: Wind Load Analysis",
    "Module 13: Seismic Analysis",
    "Module 14: Dynamic Analysis",
    "Module 15: Vibration Analysis",
    "Module 16: Expansion Joint Analysis",
    "Module 17: Stress Report Interpretation",
    "Module 18: Stress Mitigation Techniques",
    "Module 19: Industrial Case Studies and Software Application"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#250,000 / $220",
  "certification": "Certificate of Completion"
},

{
  "id": 160,
  "title": "PIPING 3D MODELING",
  "date": "Present",
  "description": [
    "Piping 3D Modeling is the process of developing intelligent three-dimensional representations of piping systems and industrial facilities. Modern EPC projects rely heavily on 3D modeling for design visualization, clash detection, quantity extraction, and construction planning.",
    "This course provides practical training in developing piping models using industry-standard software such as AVEVA E3D, PDMS, AutoCAD Plant 3D, and SmartPlant 3D."
  ],
  "image": "https://ik.imagekit.io/mags/courses/PIPING%203D%20MODELING.png",
  "tags": [],
  "category": "mechanical",
  "duration": "8 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of piping engineering",
    "Familiarity with P&IDs and piping layouts",
    "Knowledge of engineering drawing interpretation"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand 3D plant modeling concepts",
    "Create project databases and model structures",
    "Develop equipment models",
    "Create piping models from P&IDs",
    "Route piping systems",
    "Insert valves and specialty items",
    "Generate pipe supports",
    "Perform clash detection",
    "Extract isometric drawings",
    "Generate MTO reports",
    "Produce construction deliverables",
    "Review practical 3D modeling projects"
  ],
  "outline": [
    "Module 1: Introduction to Piping 3D Modeling",
    "Module 2: 3D Modeling Standards",
    "Module 3: Project Setup",
    "Module 4: Equipment Modeling",
    "Module 5: Structural Modeling Interface",
    "Module 6: Piping Specifications",
    "Module 7: Pipe Routing Fundamentals",
    "Module 8: Valve and Specialty Item Modeling",
    "Module 9: Pipe Support Modeling",
    "Module 10: Equipment Connections",
    "Module 11: Nozzle Management",
    "Module 12: Clash Detection",
    "Module 13: Model Review Techniques",
    "Module 14: Isometric Generation",
    "Module 15: Orthographic Drawings",
    "Module 16: MTO Extraction",
    "Module 17: Construction Deliverables",
    "Module 18: Model Quality Assurance",
    "Module 19: Industrial Plant Modeling Project"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#180,000 / $150",
  "certification": "Certificate of Completion"
},

{
  "id": 161,
  "title": "Piping Engineering (Introduction)",
  "date": "Present",
  "description": [
    "Piping Engineering focuses on the design, analysis, layout, construction, and maintenance of piping systems used to transport fluids safely and efficiently. Piping engineers ensure compliance with industry standards while optimizing cost, operability, safety, and maintainability.",
    "This course provides a practical understanding of piping engineering activities from conceptual design through detailed engineering and construction. Participants will learn piping layouts, line sizing, material selection, stress analysis, pipe supports, isometrics, and construction practices."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Piping%20Engineering.png",
  "tags": [],
  "category": "mechanical",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of engineering drawing",
    "Familiarity with fluid flow principles",
    "Knowledge of industrial facilities and piping systems"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of a piping engineer",
    "Interpret PFDs, P&IDs, and piping layouts",
    "Perform piping material selection",
    "Develop piping specifications",
    "Conduct line sizing calculations",
    "Design pipe routing and equipment connections",
    "Understand piping stress analysis principles",
    "Select appropriate pipe supports",
    "Interpret piping isometrics",
    "Apply piping codes and standards",
    "Review construction and commissioning requirements",
    "Evaluate piping failures and lessons learned"
  ],
  "outline": [
    "Module 1: Introduction to Piping Engineering",
    "Module 2: Piping Engineering Projects",
    "Module 3: Role of Piping Engineer",
    "Module 4: Interface with Other Disciplines",
    "Module 5: Oil & Gas Piping Systems",
    "Module 6: Project Phases",
    "Module 7: FEED – Piping Engineering Scope",
    "Module 8: EPC Proposal – Piping Engineering Scope",
    "Module 9: Detailed Design – Piping Engineering Scope",
    "Module 10: Piping Codes and Standards",
    "Module 11: Piping Material Specifications",
    "Module 12: Pipe Sizing",
    "Module 13: Pipe Routing and Layout",
    "Module 14: Plot Plans and Equipment Arrangement",
    "Module 15: Pipe Stress Analysis",
    "Module 16: Pipe Supports and Spring Supports",
    "Module 17: Expansion Loops and Flexibility Analysis",
    "Module 18: Piping Isometrics",
    "Module 19: Special Piping Items",
    "Module 20: Pipe Fabrication and Installation",
    "Module 21: Testing and Commissioning",
    "Module 22: Piping Integrity Management",
    "Module 23: Piping Engineering Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 162,
  "title": "Piping Engineering Design Basis",
  "date": "Present",
  "description": [
    "The Piping Engineering Design Basis document establishes the design philosophies, standards, and technical requirements governing the design, layout, material selection, stress analysis, and construction of piping systems.",
    "This course provides detailed knowledge of piping design philosophies and criteria used in industrial facilities. Participants will learn how to establish piping specifications, routing philosophies, stress design requirements, valve selection criteria, piping flexibility considerations, and maintenance access requirements."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Piping%20Engineering%20Design%20Basis.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of piping engineering and fluid systems",
    "Familiarity with P&IDs, piping layouts, and engineering drawings",
    "Experience in FEED, EPC, or plant design projects"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the structure of a Piping Design Basis document",
    "Develop piping design philosophies and standards",
    "Define piping material selection criteria",
    "Establish line sizing philosophies",
    "Apply piping stress and flexibility requirements",
    "Develop valve selection and isolation philosophies",
    "Define pipe support requirements",
    "Establish piping routing and layout guidelines",
    "Apply maintenance and operability requirements",
    "Develop piping engineering documentation for FEED and EPC projects",
    "Review practical piping engineering case studies"
  ],
  "outline": [
    "Module 1: Piping Design Basis Philosophy",
    "Module 2: Piping Codes and Standards",
    "Module 3: Piping Material Selection Philosophy",
    "Module 4: Pipe Class Development",
    "Module 5: Line Sizing Philosophy",
    "Module 6: Pipe Routing Philosophy",
    "Module 7: Plot Plan and Equipment Layout Interface",
    "Module 8: Pipe Stress and Flexibility Philosophy",
    "Module 9: Pipe Support Philosophy",
    "Module 10: Expansion and Thermal Growth Philosophy",
    "Module 11: Valve Selection Philosophy",
    "Module 12: Isolation and Bypass Philosophy",
    "Module 13: Drain and Vent Philosophy",
    "Module 14: Utility Piping Philosophy",
    "Module 15: Maintenance and Accessibility Requirements",
    "Module 16: Fabrication and Construction Requirements",
    "Module 17: Testing and Commissioning Philosophy",
    "Module 18: Piping Integrity Philosophy",
    "Module 19: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#120,000 / $100",
  "certification": "Certificate of Completion"
},

{
  "id": 163,
  "title": "SCADA DESIGN",
  "date": "Present",
  "description": [
    "Supervisory Control and Data Acquisition (SCADA) systems provide centralized monitoring, control, data acquisition, alarm management, and reporting for industrial facilities. SCADA systems are widely used in oil and gas, water treatment, power generation, manufacturing, and utility networks.",
    "This course provides comprehensive knowledge of SCADA architecture, hardware, software, communication protocols, system design, cybersecurity, and implementation methodologies."
  ],
  "image": "https://ik.imagekit.io/mags/courses/SCADA%20DESIGN.png",
  "tags": [],
  "category": "PAI",
  "duration": "8 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of instrumentation and control systems",
    "Familiarity with industrial automation concepts",
    "Knowledge of PLC and communication systems"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand SCADA system architecture",
    "Design SCADA communication networks",
    "Configure PLC-SCADA interfaces",
    "Develop HMI graphics",
    "Configure alarms and events",
    "Design historical data logging systems",
    "Develop reporting systems",
    "Implement industrial communication protocols",
    "Apply cybersecurity best practices",
    "Design reliable SCADA systems",
    "Troubleshoot SCADA systems",
    "Review real-world SCADA projects"
  ],
  "outline": [
    "Module 1: Introduction to SCADA Systems",
    "Module 2: SCADA Architecture",
    "Module 3: PLC Integration",
    "Module 4: Remote Terminal Units (RTUs)",
    "Module 5: Human Machine Interface (HMI)",
    "Module 6: Alarm Management",
    "Module 7: Historical Data Management",
    "Module 8: Trend Analysis",
    "Module 9: Communication Protocols",
    "Module 10: Modbus Communication",
    "Module 11: OPC Communication",
    "Module 12: Ethernet Networks",
    "Module 13: Fiber Optic Networks",
    "Module 14: SCADA Cybersecurity",
    "Module 15: Redundancy and Reliability",
    "Module 16: SCADA Database Design",
    "Module 17: System Testing and Commissioning",
    "Module 18: Troubleshooting Techniques",
    "• • Module 19: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#300,000 / $250",
  "certification": "Certificate of Completion"
},

{
  "id": 164,
  "title": "Utility Engineering (Introduction)",
  "date": "Present",
  "description": [
    "Utility Engineering focuses on the systems that support industrial operations, including steam generation, cooling water, compressed air, fuel gas, nitrogen, water treatment, power distribution, and firewater systems. These systems are essential for reliable and safe plant operation.",
    "This course provides a comprehensive understanding of utility systems commonly used in oil and gas, petrochemical, refinery, LNG, and manufacturing facilities."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Utility%20Engineering.png",
  "tags": [],
  "category": "process",
  "duration": "3 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of engineering systems",
    "Familiarity with fluid flow and heat transfer",
    "Foundational knowledge of industrial operations"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand utility engineering principles",
    "Identify major utility systems and their functions",
    "Develop utility consumption estimates",
    "Size utility equipment and networks",
    "Design steam and condensate systems",
    "Evaluate cooling water systems",
    "Understand compressed air and nitrogen systems",
    "Review fuel gas systems",
    "Understand firewater systems",
    "Analyze utility optimization opportunities",
    "Evaluate utility reliability and redundancy requirements",
    "Review industrial utility case studies"
  ],
  "outline": [
    "Module 1: Introduction to Utility Engineering",
    "Module 2: Utility Engineering Projects",
    "Module 3: Role of Utility Engineer",
    "Module 4: Interface with Other Discipline Engineers",
    "Module 5: Utility Systems Overview",
    "Module 6: Project Phases",
    "Module 7: FEED – Utility Engineering Scope",
    "Module 8: EPC Proposal – Utility Engineering Scope",
    "Module 9: Detailed Design – Utility Engineering Scope",
    "Module 10: Utility Demand Calculations",
    "Module 11: Steam Generation Systems",
    "Module 12: Steam Distribution Networks",
    "Module 13: Condensate Recovery Systems",
    "Module 14: Cooling Water Systems",
    "Module 15: Chilled Water Systems",
    "Module 16: Instrument Air Systems",
    "Module 17: Plant Air Systems",
    "Module 18: Nitrogen Generation and Distribution",
    "Module 19: Fuel Gas Systems",
    "Module 20: Water Treatment Systems",
    "Module 21: Firewater Systems",
    "Module 22: Utility Optimization and Energy Efficiency",
    "Module 23: Utility Engineering Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 165,
  "title": "Utility Engineering Design Basis",
  "date": "Present",
  "description": [
    "The Utility Engineering Design Basis document defines the technical requirements and design philosophies for utility generation, distribution, storage, redundancy, and reliability within industrial facilities.",
    "This course provides a comprehensive understanding of utility engineering philosophies covering steam, condensate, cooling water, chilled water, compressed air, nitrogen, fuel gas, water treatment, and firewater systems."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Utility%20Engineering%20Design%20Basis.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Basic understanding of utility systems and plant operations",
    "Familiarity with industrial utility networks",
    "Experience in engineering design or plant operation projects"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the structure of a Utility Design Basis document",
    "Define utility demand estimation methodologies",
    "Develop utility system design criteria",
    "Establish utility reliability and redundancy philosophies",
    "Define utility operating conditions and design margins",
    "Develop utility distribution philosophies",
    "Apply utility safety and operability requirements",
    "Optimize utility system performance",
    "Develop utility engineering documentation for projects",
    "Analyze utility engineering case studies"
  ],
  "outline": [
    "Module 1: Utility Design Basis Philosophy",
    "Module 2: Utility Demand Assessment",
    "Module 3: Utility Reliability Philosophy",
    "Module 4: Utility Redundancy and Sparing Philosophy",
    "Module 5: Steam System Design Basis",
    "Module 6: Condensate Recovery Philosophy",
    "Module 7: Cooling Water System Philosophy",
    "Module 8: Chilled Water System Philosophy",
    "Module 9: Instrument Air Design Philosophy",
    "Module 10: Plant Air Design Philosophy",
    "Module 11: Nitrogen System Design Philosophy",
    "Module 12: Fuel Gas System Design Philosophy",
    "Module 13: Potable Water System Philosophy",
    "Module 14: Industrial Water System Philosophy",
    "Module 15: Water Treatment Design Basis",
    "Module 16: Firewater System Design Philosophy",
    "Module 17: Utility Metering Philosophy",
    "Module 18: Energy Efficiency and Optimization Philosophy",
    "Module 19: Case Studies"
  ],
  "assessment": "Online Written Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 166,
  "title": "Materials Standard Deliverable List for FEED Design",
  "date": "Present",
  "description": [
    "Materials Engineering plays a critical role during the Front-End Engineering Design (FEED) phase by ensuring that all facilities, equipment, piping systems, structures, and pipelines are designed using materials that can safely and reliably withstand their intended operating environments throughout the facility lifecycle.",
    "This course provides comprehensive training on the development of Materials Engineering Standard Deliverables required during FEED projects. Participants will learn how to establish materials selection philosophies, corrosion management strategies, coating and insulation specifications, welding requirements, cathodic protection designs, and materials specifications for both facilities and pipelines."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Material%20Deliverable%20List%20for%20FEED%20Design%20Course.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Participants should ideally have:",
    "Basic understanding of materials engineering, corrosion, and metallurgy principles",
    "Familiarity with oil & gas, petrochemical, refinery, LNG, or industrial facility projects",
    "Knowledge of engineering standards, specifications, and FEED deliverables",
    "Understanding of process conditions, material degradation mechanisms, and asset integrity requirements"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of Materials Engineering during FEED projects",
    "Identify the key materials engineering deliverables required during FEED design",
    "Develop comprehensive Materials Selection Philosophies for facilities and pipelines",
    "Evaluate corrosion threats and establish corrosion mitigation strategies",
    "Develop Corrosion Protection Philosophies for onshore and offshore facilities",
    "Prepare coating specifications for pipelines, structures, equipment, and facilities",
    "Develop plant painting specifications and insulation requirements",
    "Establish fabrication and welding specifications for piping, pipelines, vessels, equipment, and structural steel",
    "Select appropriate materials for process equipment, piping systems, storage tanks, pipelines, and facilities",
    "Prepare Materials Specifications and Material Requisition documentation",
    "Perform pipeline cathodic protection design calculations and system selection",
    "Perform facility cathodic protection design calculations for tanks, structures, and buried assets",
    "Develop Materials Selection Reports (MSR) for facilities and pipelines",
    "Prepare Material Selection Diagrams (MSD) used in project execution and asset integrity management",
    "Understand the application of international standards such as NACE, ISO, ASTM, API, ASME, and DNV",
    "Evaluate lifecycle cost considerations during material selection studies",
    "Integrate corrosion control requirements into FEED design deliverables",
    "Develop materials engineering documentation that supports detailed engineering and procurement activities",
    "Review real-life failures associated with improper material selection",
    "Analyze industry case studies involving corrosion, coating failures, welding defects, and cathodic protection performance",
    "Apply best practices for materials engineering in oil & gas, petrochemical, refinery, LNG, offshore, and industrial facilities"
  ],
  "outline": [
    "Module 1: Materials Selection Philosophy",
    "Module 2: Corrosion Protection Philosophy.",
    "Module 3: Coating Specification (Pipelines/ Structures/ Equipment’s)",
    "Module 4: Plant paint specifications and insulation specifications",
    "Module 5:  Fabrication and Welding Specifications (Pipelines/Vessels & Equipment/ Piping/Structural)",
    "Module 6: Materials Specification for Pipeline & Facilities",
    "Module 7: Pipeline Cathodic Protection Design & Calculations",
    "Module 8: Plant Cathodic Protection Design & Calculations",
    "Module 9:   Materials Selection Report/ Pipeline and/or Facilities",
    "Module 10: Material Selection Diagrams",
    "Module 11: Case Studies"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion",
  "additionalSections": [
    {
      "title": "Typical FEED Materials Engineering Deliverables Covered in the Course",
      "items": [
        "Materials Selection Philosophy",
        "Corrosion Management Philosophy",
        "Corrosion Control Philosophy",
        "Coating and Painting Specification",
        "Insulation Specification",
        "Welding Specification (WPS/PQR Philosophy)",
        "Material Requisition Packages",
        "Pipeline Material Specification",
        "Piping Material Specification",
        "Equipment Material Specification",
        "Structural Material Specification",
        "Cathodic Protection Design Report",
        "Cathodic Protection Calculations",
        "Corrosion Monitoring Philosophy",
        "Material Selection Report (MSR)",
        "Material Selection Diagram (MSD)",
        "Corrosion Risk Assessment",
        "Material Compatibility Study",
        "Asset Integrity Philosophy",
        "Materials Engineering Input to FEED Design Package",
        "Materials Engineering Design Basis Document",
        "Materials Engineering Standard Deliverable Register",
        "Materials Engineering Lessons Learned and Case Study Report"
      ]
    }
  ]
},

{
  "id": 167,
  "title": "Mechanical Standard Deliverable List for FEED Design",
  "date": "Present",
  "description": [
    "Mechanical Engineering is a critical discipline during the Front-End Engineering Design (FEED) phase, responsible for defining the technical requirements, specifications, equipment selection criteria, procurement strategies, and engineering deliverables necessary to support successful project execution.",
    "The quality of mechanical engineering deliverables produced during FEED directly impacts equipment reliability, operability, maintainability, safety, project cost, procurement schedules, and overall plant performance throughout the facility lifecycle.",
    "This course provides comprehensive training on the preparation, development, and review of Mechanical Engineering Standard Deliverables commonly generated during FEED projects. Participants will learn how to develop Mechanical Design Basis documents, Equipment Specifications, Project Specifications, Project Procedures, Equipment Lists, Mechanical Data Sheets, Package Specifications, Technical Requisitions, Compressor Selection Studies, Emission Studies, and Technical Bid Evaluations."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Mechanical%20Deliverable%20List%20for%20FEED%20Design%20Course.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Participants should ideally have:",
    "Basic understanding of mechanical engineering principles and industrial equipment",
    "Familiarity with oil & gas, petrochemical, refinery, LNG, power, or industrial facility projects",
    "Knowledge of engineering design standards, specifications, and equipment design fundamentals",
    "Familiarity with process engineering deliverables such as PFDs, P&IDs, equipment lists, and design basis documents"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of Mechanical Engineering during FEED projects",
    "Identify the major mechanical engineering deliverables required during FEED design",
    "Develop comprehensive Mechanical Design Basis documents",
    "Define equipment design philosophies and equipment selection criteria",
    "Establish project-specific mechanical specifications and standards",
    "Prepare mechanical project procedures supporting engineering execution",
    "Develop and maintain Mechanical Equipment Lists",
    "Evaluate rotating and static equipment requirements",
    "Perform equipment selection studies based on project operating conditions",
    "Conduct Compressor and Driver Selection Studies",
    "Understand emission sources associated with mechanical equipment",
    "Develop Mechanical Equipment Datasheets for procurement activities",
    "Prepare Package Equipment Datasheets and technical specifications",
    "Define equipment operating, design, and performance requirements",
    "Develop Technical Requisition Packages for Long Lead Items (LLIs)",
    "Understand vendor inquiry and procurement processes",
    "Evaluate vendor technical proposals",
    "Conduct Technical Bid Evaluations (TBE) for mechanical equipment",
    "Apply industry standards such as API, ASME, ISO, IEC, NEMA, and vendor specifications",
    "Support procurement and vendor management activities during FEED",
    "Understand package equipment integration within facility design",
    "Review equipment reliability, maintainability, availability, and operability requirements",
    "Analyze real-world mechanical engineering case studies",
    "Develop mechanical deliverables that support detailed engineering and project execution"
  ],
  "outline": [
    "Module 1: Basis of Design",
    "Module 2: Equipment Specifications.",
    "Module 3: Project Specifications",
    "Module 4: Project Procedures",
    "Module 5: Equipment List",
    "Module 6: Emission Study",
    "Module 7: Compressor & Driver Selection Study Report",
    "Module 8: Mechanical Equipment Data Sheets",
    "Module 9:   Package Data Sheets",
    "Module 10:  Technical Requisition for LLI's",
    "Module 11: Technical Bid Evaluation"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#120,000 / $100",
  "certification": "Certificate of Completion",
  "additionalSections": [
    {
      "title": "Typical Mechanical FEED Deliverables Covered in the Course",
      "items": [
        "Mechanical Design Basis Document",
        "Mechanical Design Philosophy",
        "Equipment Design Philosophy",
        "Equipment Specifications",
        "Project Mechanical Specifications",
        "Mechanical Engineering Procedures",
        "Mechanical Equipment List",
        "Equipment Register",
        "Equipment Criticality Assessment",
        "Compressor Selection Study Report",
        "Driver Selection Study Report",
        "Emission Study Report",
        "Mechanical Equipment Datasheets",
        "Package Equipment Datasheets",
        "Mechanical Requisition Packages",
        "Technical Bid Evaluation (TBE) Reports",
        "Vendor Technical Clarification Documents",
        "Long Lead Item (LLI) Procurement Packages",
        "Mechanical Engineering Design Criteria",
        "Equipment Reliability Study",
        "Equipment Availability Study",
        "Mechanical Engineering Deliverable Register",
        "Mechanical Engineering Lessons Learned Report",
        "Mechanical Engineering FEED Package",
        "Mechanical Engineering Case Study Report"
      ]
    }
  ]
},

{
  "id": 168,
  "title": "Piping Standard Deliverables for FEED",
  "date": "Present",
  "description": [
    "The Piping Engineering and Layout Deliverable List for FEED Design Course provides a practical and structured understanding of the key engineering documents, layouts, specifications, and deliverables required during the Front-End Engineering Design (FEED) phase of piping systems in oil & gas, petrochemical, refinery, power, and industrial projects.",
    "This course focuses on the development and review of critical FEED deliverables that ensure safe, operable, maintainable, and cost-effective plant design before transitioning into EPC and detailed engineering. Participants will learn how to prepare piping design basis documents, layout design criteria, flexibility analysis specifications, critical line lists, piping and valve material specifications, plot plans, equipment arrangement drawings, tie-in schedules, piping line studies, and material take-offs.",
    "Special emphasis is placed on plant layout optimization, operability, maintainability, accessibility, constructability, safety compliance, and minimizing costly modifications during later project stages. The training also covers how piping deliverables interact with process, mechanical, civil, instrumentation, and construction disciplines to ensure project success.",
    "This course is highly valuable for engineers involved in FEED design, brownfield modifications, revamp projects, and new greenfield developments where strong piping engineering deliverables are critical to execution success."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Piping%20Standard%20Deliverables%20for%20FEED%20Course.png",
  "tags": [],
  "category": "mechanical",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Participants should ideally have:",
    "Basic understanding of piping systems and plant engineering",
    "Familiarity with process flow diagrams (PFDs) and Piping & Instrumentation Diagrams (P&IDs)",
    "Basic knowledge of piping materials, valves, and plant layout concepts",
    "Understanding of FEED, detailed engineering, and EPC project phases",
    "Suitable for Piping Engineers, Mechanical Engineers, Process Engineers, Layout Engineers, Construction Engineers, Project Engineers, and FEED professionals"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the complete piping engineering deliverable list required during FEED design",
    "Develop and review Piping Design Basis documents for plant piping systems",
    "Prepare Layout Design Basis documents considering safety, operability, and maintainability",
    "Understand specifications for piping flexibility and stress analysis requirements",
    "Develop and review Critical Line Lists for high-risk and special service piping",
    "Prepare Piping and Valve Material Specifications based on process conditions and piping class requirements",
    "Develop Overall Field Layouts and optimize plant arrangement for safety and accessibility",
    "Prepare and interpret 2-D Plot Plans for effective equipment and piping integration",
    "Develop Tie-in Schedules for brownfield and revamp projects",
    "Conduct piping line studies and line shoot evaluations for constructability and operability",
    "Prepare Equipment Arrangement Key Plans and detailed Equipment Arrangement Drawings (1:250)",
    "Perform accurate Piping Material Take-Off (MTO) for project estimation and procurement",
    "Develop Valve Material Take-Off (Valve MTO) for engineering and procurement planning",
    "Improve FEED quality to reduce project risks, prevent design clashes, and minimize cost overruns during EPC execution"
  ],
  "outline": [
    "Module 1: Piping Design Basis",
    "Module 2: Layout Design Basis.",
    "Module 3: Specification for Piping Flexibility Analysis",
    "Module 4: Critical Line List",
    "Module 5: Piping & Valve Material Specification",
    "Module 6: Overall Field Layout",
    "Module 7: 2-D Plot Plan",
    "Module 8: Tie-in Schedule",
    "Module 9:   Piping Line Shoot",
    "Module 10: Equip Arrangement Key Plan",
    "Module 11: Equip Arrangement Drawings (1:250)",
    "Module 12: Piping MTO",
    "Module 14: Valve MTO"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#150,000 / $120",
  "certification": "Certificate of Completion"
},

{
  "id": 169,
  "title": "Process Standard Deliverable List for FEED Design",
  "date": "Present",
  "description": [
    "Process Engineering is the cornerstone of Front-End Engineering Design (FEED), responsible for defining the technical basis, operating philosophy, process requirements, equipment sizing criteria, safety philosophies, and overall plant functionality upon which all other engineering disciplines depend.",
    "The quality of process engineering deliverables developed during FEED significantly influences project safety, operability, reliability, environmental compliance, capital expenditure, operating expenditure, and lifecycle performance.",
    "This course provides comprehensive training on the preparation, development, review, and management of Process Engineering Standard Deliverables required during FEED projects. Participants will learn how to develop Process Design Basis documents, Process Flow Diagrams (PFDs), Utility Flow Diagrams (UFDs), Piping & Instrumentation Diagrams (P&IDs), Heat & Mass Balances, Process Simulations, Hydraulic Studies, Flow Assurance Studies, Flare Studies, Process Datasheets, Shutdown Philosophies, and HAZOP Close-Out documentation."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Process%20Deliverable%20List%20for%20FEED%20Design%20Course.png",
  "tags": [],
  "category": "process",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Participants should ideally have:",
    "A foundational understanding of process engineering and plant operations",
    "Familiarity with Process Flow Diagrams (PFDs), Utility Flow Diagrams (UFDs), and Piping & Instrumentation Diagrams (P&IDs)",
    "Basic knowledge of thermodynamics, fluid mechanics, heat transfer, and process simulation",
    "Understanding of oil & gas, petrochemical, refinery, LNG, offshore, or industrial process facilities",
    "Familiarity with engineering project phases including Conceptual Design, FEED, EPC, and Detailed Design"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of Process Engineering during FEED projects",
    "Identify the major process engineering deliverables required during FEED design",
    "Develop comprehensive Process Design Basis documents",
    "Establish Engineering Shutdown (ESD) philosophies and safeguarding requirements",
    "Define process isolation philosophies for normal operation, maintenance, and emergency situations",
    "Develop process control philosophies to ensure safe and reliable operation",
    "Establish relief, venting, drainage, and blowdown philosophies",
    "Develop Process Flow Diagrams (PFDs) and Utility Flow Diagrams (UFDs)",
    "Prepare Main Process Piping & Instrumentation Diagrams (P&IDs)",
    "Develop Utility Lists and Utility Consumption Summaries",
    "Prepare Equipment Lists and Equipment Registers",
    "Develop comprehensive Line Lists and Process Line Design Conditions",
    "Generate Heat & Mass Balance calculations and reports",
    "Develop process simulation models and interpret simulation results",
    "Perform steady-state hydraulic analyses for pipelines and process systems",
    "Conduct flow assurance evaluations for pipelines and production systems",
    "Develop flare system studies and flare network analyses",
    "Prepare Shutdown Cause & Effect Charts",
    "Establish design and operating conditions for equipment and piping systems",
    "Develop isolation, relief, venting, and blowdown requirements",
    "Prepare Process Equipment Datasheets",
    "Prepare Process Instrument Datasheets",
    "Understand process safety integration with HAZOP studies",
    "Develop HAZOP Close-Out documentation and action tracking systems",
    "Apply international standards and engineering best practices",
    "Support procurement, detailed engineering, construction, and commissioning activities",
    "Analyze real-world process engineering case studies and lessons learned"
  ],
  "outline": [
    "Module 1: Process Design Basis",
    "Module 2: ESD Philosophy.",
    "Module 3: Isolation Philosophy",
    "Module 4: Control Philosophy",
    "Module 5: Relief, Venting, Drainage & Blowdown Philosophy",
    "Module 6: PFD's & UFD's",
    "Module 7: Main Process P&ID's",
    "Module 8: Utility List",
    "Module 9:   Equipment list",
    "Module 10: Line List",
    "Module 11: Main Process Heat & Mass Balances",
    "Module 12: Process Simulation/ Report",
    "Module 13: Pipeline Steady State Hydraulic Analysis & Report",
    "Module 14:  Flow Assurance Report",
    "Module 15:  Flare Study Report",
    "Module 16:  Shutdown Cause & Effect Charts",
    "Module 17:  Design & Operating Conditions",
    "Module 18:  Isolation, Relief & Blowdown",
    "Module 19: Process Equipment Data Sheets",
    "Module 20:  Process Instrument Data Sheets",
    "Module 21:  HAZOP Close-Out"
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#200,000 / $180",
  "certification": "Certificate of Completion",
  "additionalSections": [
    {
      "title": "Typical Process Engineering FEED Deliverables Covered in the Course",
      "items": [
        "Process Design Basis Document",
        "Process Design Philosophy",
        "Operating Philosophy",
        "Control Philosophy",
        "Isolation Philosophy",
        "ESD Philosophy",
        "Relief and Blowdown Philosophy",
        "Venting and Drainage Philosophy",
        "Process Flow Diagrams (PFDs)",
        "Utility Flow Diagrams (UFDs)",
        "Main Process P&IDs",
        "Utility List",
        "Equipment List",
        "Equipment Register",
        "Line List",
        "Process Heat & Mass Balance Report",
        "Process Simulation Report",
        "Hydraulic Analysis Report",
        "Flow Assurance Report",
        "Flare Study Report",
        "Shutdown Cause & Effect Charts",
        "Design and Operating Conditions Register",
        "Isolation, Relief & Blowdown Register",
        "Process Equipment Datasheets",
        "Process Instrument Datasheets",
        "Utility Consumption Summary",
        "Process Engineering Calculations",
        "HAZOP Close-Out Report",
        "Process Engineering Deliverable Register",
        "Process Engineering FEED Package",
        "Process Engineering Lessons Learned and Case Study Report"
      ]
    }
  ]
},

{
  "id": 170,
  "title": "Control & Instrumentation Standard Deliverables for FEED",
  "date": "Present",
  "description": [
    "Control and Instrumentation (C&I) Engineering is a critical discipline during the Front-End Engineering Design (FEED) phase, responsible for defining the measurement, control, automation, monitoring, and safety requirements necessary for reliable and safe facility operation.",
    "The quality of instrumentation and control deliverables developed during FEED directly impacts plant operability, process stability, safety performance, regulatory compliance, maintainability, cybersecurity, and lifecycle reliability.",
    "This course provides comprehensive training on the development and management of Control & Instrumentation Standard Deliverables typically generated during FEED projects. Participants will learn how to develop Engineering Design Specifications (EDS), Metering Philosophies, Integrated Control & Safety System (ICSS) Specifications, Instrument Specifications, Instrument Datasheets, Control System Architecture Diagrams, Shutdown Cause & Effect Charts, Instrument Material Take-Offs (MTOs), and Technical Requisition Packages for Long Lead Items (LLIs)."
  ],
  "image": "https://ik.imagekit.io/mags/courses/Control%20&%20Instrumentation%20Standard%20Deliverables%20for%20FEED.png",
  "tags": [],
  "category": "PAI",
  "duration": "5 Days",
  "trainingLanguage": "English",
  "prerequisite": [
    "Participants should ideally have:",
    "Basic understanding of instrumentation and control engineering principles",
    "Familiarity with process engineering documents such as PFDs, P&IDs, Cause & Effect Charts, and Control Narratives",
    "Knowledge of industrial measurement, control systems, safety systems, and automation technologies",
    "Understanding of FEED, EPC, procurement, and project execution processes"
  ],
  "methodology": "Theoretical/Practical",
  "objectives": [
    "Understand the role of Control & Instrumentation Engineering during FEED projects",
    "Identify major Control & Instrumentation FEED deliverables",
    "Develop Engineering Design Specifications (EDS) for instrumentation and control systems",
    "Establish Metering Philosophies for fiscal, custody transfer, allocation, and operational metering systems",
    "Develop Integrated Control & Safety System (ICSS) Specifications",
    "Define control system architecture and system integration requirements",
    "Specify Distributed Control Systems (DCS), Emergency Shutdown Systems (ESD), Fire & Gas Systems (F&G), and SCADA systems",
    "Develop General Instrumentation Specifications in accordance with industry standards",
    "Prepare Instrument Datasheets for field instruments and control devices",
    "Select appropriate instrumentation technologies based on process requirements",
    "Develop Control and Safety System Topology Diagrams",
    "Define communication network architecture and redundancy requirements",
    "Develop Shutdown Cause & Effect Charts for process safety systems",
    "Understand Safety Instrumented System (SIS) functional requirements",
    "Prepare Bulk Instrument Material Take-Offs (MTOs)",
    "Develop Technical Requisition Packages for Long Lead Instrumentation and Control Equipment",
    "Understand procurement strategies for instrumentation systems",
    "Apply international standards",
    "Support vendor engagement and technical clarifications during FEED",
    "Integrate process control and safety requirements into engineering deliverables",
    "Review real-world instrumentation and automation case studies",
    "Develop FEED documentation that supports detailed engineering and project execution"
  ],
  "outline": [
    "Module 1: EDS Philosophy",
    "Module 2: Metering Philosophy.",
    "Module 3: Integrated Control & Safety System (ICSS) Specification",
    "Module 4: General Instrumentation Specification",
    "Module 5: Instrument Data Sheets",
    "Module 6: Control and Safety System Topology Diagram",
    "Module 7: Shutdown Cause & Effect Charts",
    "Module 8: Bulk Instrument MTO",
    "Module 9:   Technical Requisition for LLI's  "
  ],
  "assessment": "Online Written  Exam",
  "cdf": [
    "Classroom-based training",
    "Online courses",
    "In-house workshops",
    "On-the-job training"
  ],
  "cost": "#120,000 / $100",
  "certification": "Certificate of Completion",
  "additionalSections": [
    {
      "title": "Typical Control & Instrumentation FEED Deliverables Covered in the Course",
      "items": [
        "Engineering Design Specification (EDS)",
        "Instrumentation Design Philosophy",
        "Control System Philosophy",
        "Shutdown Philosophy",
        "Metering Philosophy",
        "Alarm Management Philosophy",
        "Integrated Control & Safety System (ICSS) Specification",
        "Distributed Control System (DCS) Specification",
        "Emergency Shutdown System (ESD) Specification",
        "Fire & Gas System (F&G) Specification",
        "SCADA System Specification",
        "General Instrumentation Specification",
        "Instrument Installation Specification",
        "Instrument Datasheets",
        "Control Valve Datasheets",
        "Analyzer Datasheets",
        "Metering System Datasheets",
        "Control and Safety System Topology Diagrams",
        "Network Architecture Diagrams",
        "Communication System Diagrams",
        "Shutdown Cause & Effect Charts",
        "Safety Logic Diagrams",
        "Instrument Index",
        "Instrument I/O List",
        "Bulk Instrument Material Take-Off (MTO)",
        "Instrument Cable Schedule",
        "Instrument Junction Box Schedule",
        "Technical Requisition Packages for Long Lead Items (LLIs)",
        "Vendor Technical Clarification Documents",
        "Instrument Engineering Deliverable Register",
        "Instrumentation FEED Package",
        "Control & Instrumentation Case Study Report"
      ]
    }
  ]
},


];


const courseSlugOverrides = {
  "Oil and Gas Utilities - Heat Tracing and Winterizing": "process-design-of-heat-tracing-and-winterizing",
};

export const courses = projects.map(project => ({
  ...project,
  slug: courseSlugOverrides[project.title] || slugify(project.title)
}));
